// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28134, 182.5, 254%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%285.2, 44, 101.2%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28109.8, 168, 253.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.3.8 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(10.4, 88, 202.4);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-body-font-family);
  font-size: 1rem;
  font-size: var(--bs-body-font-size);
  font-weight: 400;
  font-weight: var(--bs-body-font-weight);
  line-height: 1.5;
  line-height: var(--bs-body-line-height);
  color: #212529;
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: #fff;
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: #212529;
  color: var(--bs-highlight-color);
  background-color: rgb(255, 242.6, 205.4);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(13, 110, 253, 1);
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: #d63384;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: #fff;
  color: var(--bs-body-bg);
  background-color: #212529;
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: rgba(33, 37, 41, 0.75);
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type=search]::-webkit-search-cancel-button {
  cursor: pointer;
  filter: grayscale(1);
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  background-color: var(--bs-body-bg);
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: rgba(33, 37, 41, 0.75);
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color);
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(1px * 2) solid currentcolor;
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 226, 254.6);
  --bs-table-border-color: rgb(165.28, 180.8, 203.68);
  --bs-table-striped-bg: rgb(196.27, 214.7, 241.87);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 203.4, 229.14);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 209.05, 235.505);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-border-color: rgb(180.48, 181.92, 183.2);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(209, 231, 220.8);
  --bs-table-border-color: rgb(167.2, 184.8, 176.64);
  --bs-table-striped-bg: rgb(198.55, 219.45, 209.76);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(188.1, 207.9, 198.72);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(193.325, 213.675, 204.24);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 244.4, 252);
  --bs-table-border-color: rgb(165.28, 195.52, 201.6);
  --bs-table-striped-bg: rgb(196.27, 232.18, 239.4);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 219.96, 226.8);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 226.07, 233.1);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 242.6, 205.4);
  --bs-table-border-color: rgb(204, 194.08, 164.32);
  --bs-table-striped-bg: rgb(242.25, 230.47, 195.13);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 218.34, 184.86);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 224.405, 189.995);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(248, 214.6, 217.8);
  --bs-table-border-color: rgb(198.4, 171.68, 174.24);
  --bs-table-striped-bg: rgb(235.6, 203.87, 206.91);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 193.14, 196.02);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 198.505, 201.465);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: rgb(198.4, 199.2, 200);
  --bs-table-striped-bg: rgb(235.6, 236.55, 237.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 224.1, 225);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 230.325, 231.25);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(77.4, 80.6, 83.8);
  --bs-table-striped-bg: rgb(44.1, 47.9, 51.7);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(55.2, 58.8, 62.4);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(49.65, 53.35, 57.05);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: rgba(33, 37, 41, 0.75);
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  color: var(--bs-body-color);
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #212529;
  color: var(--bs-body-color);
  background-color: #fff;
  background-color: var(--bs-body-bg);
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: rgba(33, 37, 41, 0.75);
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::-webkit-file-upload-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  color: #212529;
  color: var(--bs-body-color);
  background-color: #f8f9fa;
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  color: #212529;
  color: var(--bs-body-color);
  background-color: #f8f9fa;
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::-webkit-file-upload-button {
    -webkit-transition: none;
    transition: none;
  }
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(1px * 2));
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::-webkit-file-upload-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(1px * 2));
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::-webkit-file-upload-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(1px * 2));
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(1px * 2));
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(1px * 2));
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(1px * 2));
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(1px * 2));
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(1px * 2));
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  color: var(--bs-body-color);
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), none;
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #212529;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  -webkit-appearance: none;
          appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  -webkit-appearance: none;
          appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  -webkit-appearance: none;
          appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: rgba(33, 37, 41, 0.75);
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: rgba(33, 37, 41, 0.75);
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(1px * 2));
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(1px * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(33, 37, 41, 0.65);
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.75rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: #fff;
  background-color: var(--bs-body-bg);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}
.form-floating > textarea:disabled ~ label::after {
  background-color: #e9ecef;
  background-color: var(--bs-secondary-bg);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: #f8f9fa;
  background-color: var(--bs-tertiary-bg);
  border: 1px solid #dee2e6;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: 0.5rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: 0.25rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * 1px);
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #198754;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: #198754;
  background-color: var(--bs-success);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #198754;
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #198754;
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #198754;
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #198754;
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #198754;
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #198754;
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #198754;
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: #dc3545;
  background-color: var(--bs-danger);
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #dc3545;
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #dc3545;
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #dc3545;
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #dc3545;
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #dc3545;
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(11.05, 93.5, 215.05);
  --bs-btn-hover-border-color: rgb(10.4, 88, 202.4);
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(10.4, 88, 202.4);
  --bs-btn-active-border-color: rgb(9.75, 82.5, 189.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(91.8, 99.45, 106.25);
  --bs-btn-hover-border-color: rgb(86.4, 93.6, 100);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86.4, 93.6, 100);
  --bs-btn-active-border-color: rgb(81, 87.75, 93.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(21.25, 114.75, 71.4);
  --bs-btn-hover-border-color: rgb(20, 108, 67.2);
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(20, 108, 67.2);
  --bs-btn-active-border-color: rgb(18.75, 101.25, 63);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(49.3, 209.95, 242.25);
  --bs-btn-hover-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(61.4, 212.6, 243);
  --bs-btn-active-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 202.3, 44.2);
  --bs-btn-hover-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 205.4, 56.6);
  --bs-btn-active-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(187, 45.05, 58.65);
  --bs-btn-hover-border-color: rgb(176, 42.4, 55.2);
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(176, 42.4, 55.2);
  --bs-btn-active-border-color: rgb(165, 39.75, 51.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(210.8, 211.65, 212.5);
  --bs-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(198.4, 199.2, 200);
  --bs-btn-active-border-color: rgb(186, 186.75, 187.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(66.3, 69.7, 73.1);
  --bs-btn-hover-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(77.4, 80.6, 83.8);
  --bs-btn-active-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.375rem;
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * 1px);
  margin-left: calc(-1 * var(--bs-border-width));
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * 1px);
  margin-top: calc(-1 * var(--bs-border-width));
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: 1px solid var(--bs-navbar-toggler-border-color);
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: 75vh;
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: #212529;
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: "/" /* rtl: var(--bs-breadcrumb-divider, "/") */;
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * 1px);
  margin-left: calc(-1 * var(--bs-border-width));
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter:  ;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: -webkit-max-content;
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter:  ;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  flex-shrink: 0;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
          mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(13, 110, 253, 1) !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(108, 117, 125, 1) !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(25, 135, 84, 1) !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(13, 202, 240, 1) !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(255, 193, 7, 1) !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(220, 53, 69, 1) !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(248, 249, 250, 1) !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(33, 37, 41, 1) !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(13, 110, 253, 1) !important;
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(13, 110, 253, 1) !important;
          text-decoration-color: RGBA(13, 110, 253, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, 1) !important;
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(10, 88, 202, 1) !important;
          text-decoration-color: RGBA(10, 88, 202, 1) !important;
  -webkit-text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(108, 117, 125, 1) !important;
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(108, 117, 125, 1) !important;
          text-decoration-color: RGBA(108, 117, 125, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, 1) !important;
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(86, 94, 100, 1) !important;
          text-decoration-color: RGBA(86, 94, 100, 1) !important;
  -webkit-text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(25, 135, 84, 1) !important;
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(25, 135, 84, 1) !important;
          text-decoration-color: RGBA(25, 135, 84, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, 1) !important;
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(20, 108, 67, 1) !important;
          text-decoration-color: RGBA(20, 108, 67, 1) !important;
  -webkit-text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(13, 202, 240, 1) !important;
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(13, 202, 240, 1) !important;
          text-decoration-color: RGBA(13, 202, 240, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, 1) !important;
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(61, 213, 243, 1) !important;
          text-decoration-color: RGBA(61, 213, 243, 1) !important;
  -webkit-text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(255, 193, 7, 1) !important;
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(255, 193, 7, 1) !important;
          text-decoration-color: RGBA(255, 193, 7, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, 1) !important;
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(255, 205, 57, 1) !important;
          text-decoration-color: RGBA(255, 205, 57, 1) !important;
  -webkit-text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(220, 53, 69, 1) !important;
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(220, 53, 69, 1) !important;
          text-decoration-color: RGBA(220, 53, 69, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, 1) !important;
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(176, 42, 55, 1) !important;
          text-decoration-color: RGBA(176, 42, 55, 1) !important;
  -webkit-text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(248, 249, 250, 1) !important;
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(248, 249, 250, 1) !important;
          text-decoration-color: RGBA(248, 249, 250, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, 1) !important;
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(249, 250, 251, 1) !important;
          text-decoration-color: RGBA(249, 250, 251, 1) !important;
  -webkit-text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(33, 37, 41, 1) !important;
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(33, 37, 41, 1) !important;
          text-decoration-color: RGBA(33, 37, 41, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, 1) !important;
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(26, 30, 33, 1) !important;
          text-decoration-color: RGBA(26, 30, 33, 1) !important;
  -webkit-text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(0, 0, 0, 1) !important;
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(0, 0, 0, 1) !important;
          text-decoration-color: RGBA(0, 0, 0, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(0, 0, 0, 0.75) !important;
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  -webkit-text-decoration-color: RGBA(0, 0, 0, 0.75) !important;
          text-decoration-color: RGBA(0, 0, 0, 0.75) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
          text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  -webkit-text-decoration-color: rgba(13, 110, 253, 0.5);
          text-decoration-color: rgba(13, 110, 253, 0.5);
  -webkit-text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
          text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: translate3d(0.25em, 0, 0);
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: 1px solid #dee2e6 !important;
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 1px solid #dee2e6 !important;
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 1px solid #dee2e6 !important;
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(13, 110, 253, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(108, 117, 125, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(25, 135, 84, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(13, 202, 240, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(255, 193, 7, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(220, 53, 69, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(248, 249, 250, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(33, 37, 41, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: rgb(158.2, 197, 254.2) !important;
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: rgb(196.2, 199.8, 203) !important;
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: rgb(163, 207, 186.6) !important;
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: rgb(158.2, 233.8, 249) !important;
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: rgb(255, 230.2, 155.8) !important;
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: rgb(241, 174.2, 180.6) !important;
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: #e9ecef !important;
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: #adb5bd !important;
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(13, 110, 253, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(108, 117, 125, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(25, 135, 84, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(13, 202, 240, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(255, 193, 7, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(220, 53, 69, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(248, 249, 250, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, 0.75) !important;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, 0.75) !important;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, 0.5) !important;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: #000 !important;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: rgb(5.2, 44, 101.2) !important;
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: rgb(43.2, 46.8, 50) !important;
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: rgb(10, 54, 33.6) !important;
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: rgb(5.2, 80.8, 96) !important;
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: rgb(102, 77.2, 2.8) !important;
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: rgb(88, 21.2, 27.6) !important;
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: #495057 !important;
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: #495057 !important;
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(13, 110, 253, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(13, 110, 253, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(108, 117, 125, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(108, 117, 125, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(25, 135, 84, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(25, 135, 84, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(13, 202, 240, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(13, 202, 240, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(255, 193, 7, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(255, 193, 7, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(220, 53, 69, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(220, 53, 69, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(248, 249, 250, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(248, 249, 250, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(33, 37, 41, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(33, 37, 41, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(13, 110, 253, 1) !important;
          text-decoration-color: rgba(13, 110, 253, 1) !important;
  -webkit-text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(13, 110, 253, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(108, 117, 125, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(25, 135, 84, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(13, 202, 240, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 193, 7, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 53, 69, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(248, 249, 250, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(33, 37, 41, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(233, 236, 239, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(248, 249, 250, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: rgb(206.6, 226, 254.6) !important;
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: rgb(225.6, 227.4, 229) !important;
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: rgb(209, 231, 220.8) !important;
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: rgb(206.6, 244.4, 252) !important;
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: rgb(255, 242.6, 205.4) !important;
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: rgb(248, 214.6, 217.8) !important;
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: rgb(251.5, 252, 252.5) !important;
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: #ced4da !important;
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0)) !important;
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.375rem !important;
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.25rem !important;
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: 0.375rem !important;
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: 0.5rem !important;
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: 1rem !important;
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: 2rem !important;
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: 0.5rem !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: 0.5rem !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: 0.5rem !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: 0.5rem !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*!
 * Bootstrap Grid v5.3.8 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  box-sizing: border-box;
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

@media (min-width: 576px) {
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
}
@media (min-width: 768px) {
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
}
@media (min-width: 992px) {
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
}
@media (min-width: 1400px) {
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*!
 * Bootstrap Utilities v5.3.8 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(10.4, 88, 202.4);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(13, 110, 253, 1) !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(108, 117, 125, 1) !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(25, 135, 84, 1) !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(13, 202, 240, 1) !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(255, 193, 7, 1) !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(220, 53, 69, 1) !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(248, 249, 250, 1) !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(33, 37, 41, 1) !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(13, 110, 253, 1) !important;
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(13, 110, 253, 1) !important;
          text-decoration-color: RGBA(13, 110, 253, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, 1) !important;
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(10, 88, 202, 1) !important;
          text-decoration-color: RGBA(10, 88, 202, 1) !important;
  -webkit-text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(108, 117, 125, 1) !important;
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(108, 117, 125, 1) !important;
          text-decoration-color: RGBA(108, 117, 125, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, 1) !important;
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(86, 94, 100, 1) !important;
          text-decoration-color: RGBA(86, 94, 100, 1) !important;
  -webkit-text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(25, 135, 84, 1) !important;
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(25, 135, 84, 1) !important;
          text-decoration-color: RGBA(25, 135, 84, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, 1) !important;
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(20, 108, 67, 1) !important;
          text-decoration-color: RGBA(20, 108, 67, 1) !important;
  -webkit-text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(13, 202, 240, 1) !important;
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(13, 202, 240, 1) !important;
          text-decoration-color: RGBA(13, 202, 240, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, 1) !important;
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(61, 213, 243, 1) !important;
          text-decoration-color: RGBA(61, 213, 243, 1) !important;
  -webkit-text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(255, 193, 7, 1) !important;
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(255, 193, 7, 1) !important;
          text-decoration-color: RGBA(255, 193, 7, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, 1) !important;
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(255, 205, 57, 1) !important;
          text-decoration-color: RGBA(255, 205, 57, 1) !important;
  -webkit-text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(220, 53, 69, 1) !important;
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(220, 53, 69, 1) !important;
          text-decoration-color: RGBA(220, 53, 69, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, 1) !important;
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(176, 42, 55, 1) !important;
          text-decoration-color: RGBA(176, 42, 55, 1) !important;
  -webkit-text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(248, 249, 250, 1) !important;
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(248, 249, 250, 1) !important;
          text-decoration-color: RGBA(248, 249, 250, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, 1) !important;
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(249, 250, 251, 1) !important;
          text-decoration-color: RGBA(249, 250, 251, 1) !important;
  -webkit-text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(33, 37, 41, 1) !important;
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(33, 37, 41, 1) !important;
          text-decoration-color: RGBA(33, 37, 41, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, 1) !important;
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(26, 30, 33, 1) !important;
          text-decoration-color: RGBA(26, 30, 33, 1) !important;
  -webkit-text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(0, 0, 0, 1) !important;
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  -webkit-text-decoration-color: RGBA(0, 0, 0, 1) !important;
          text-decoration-color: RGBA(0, 0, 0, 1) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(0, 0, 0, 0.75) !important;
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  -webkit-text-decoration-color: RGBA(0, 0, 0, 0.75) !important;
          text-decoration-color: RGBA(0, 0, 0, 0.75) !important;
  -webkit-text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
          text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  -webkit-text-decoration-color: rgba(13, 110, 253, 0.5);
          text-decoration-color: rgba(13, 110, 253, 0.5);
  -webkit-text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
          text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  -webkit-backface-visibility: hidden;
          backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: translate3d(0.25em, 0, 0);
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: -webkit-sticky;
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: 1px solid #dee2e6 !important;
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: 1px solid #dee2e6 !important;
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: 1px solid #dee2e6 !important;
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(13, 110, 253, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(108, 117, 125, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(25, 135, 84, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(13, 202, 240, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(255, 193, 7, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(220, 53, 69, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(248, 249, 250, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(33, 37, 41, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(0, 0, 0, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--bs-border-opacity)) !important;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: rgb(158.2, 197, 254.2) !important;
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: rgb(196.2, 199.8, 203) !important;
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: rgb(163, 207, 186.6) !important;
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: rgb(158.2, 233.8, 249) !important;
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: rgb(255, 230.2, 155.8) !important;
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: rgb(241, 174.2, 180.6) !important;
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: #e9ecef !important;
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: #adb5bd !important;
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(13, 110, 253, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(108, 117, 125, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(25, 135, 84, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(13, 202, 240, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(255, 193, 7, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(220, 53, 69, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(248, 249, 250, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, var(--bs-text-opacity)) !important;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, 0.75) !important;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, 0.75) !important;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: rgba(33, 37, 41, 0.5) !important;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: #000 !important;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: rgb(5.2, 44, 101.2) !important;
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: rgb(43.2, 46.8, 50) !important;
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: rgb(10, 54, 33.6) !important;
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: rgb(5.2, 80.8, 96) !important;
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: rgb(102, 77.2, 2.8) !important;
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: rgb(88, 21.2, 27.6) !important;
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: #495057 !important;
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: #495057 !important;
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(13, 110, 253, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(13, 110, 253, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(108, 117, 125, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(108, 117, 125, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(25, 135, 84, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(25, 135, 84, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(13, 202, 240, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(13, 202, 240, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(255, 193, 7, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(255, 193, 7, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(220, 53, 69, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(220, 53, 69, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(248, 249, 250, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(248, 249, 250, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(33, 37, 41, var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(33, 37, 41, var(--bs-link-underline-opacity)) !important;
  -webkit-text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
          text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  -webkit-text-decoration-color: rgba(13, 110, 253, 1) !important;
          text-decoration-color: rgba(13, 110, 253, 1) !important;
  -webkit-text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
          text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(13, 110, 253, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(108, 117, 125, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(25, 135, 84, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(13, 202, 240, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 193, 7, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(220, 53, 69, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(248, 249, 250, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(33, 37, 41, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(233, 236, 239, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(248, 249, 250, var(--bs-bg-opacity)) !important;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: rgb(206.6, 226, 254.6) !important;
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: rgb(225.6, 227.4, 229) !important;
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: rgb(209, 231, 220.8) !important;
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: rgb(206.6, 244.4, 252) !important;
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: rgb(255, 242.6, 205.4) !important;
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: rgb(248, 214.6, 217.8) !important;
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: rgb(251.5, 252, 252.5) !important;
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: #ced4da !important;
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0)) !important;
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.375rem !important;
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.25rem !important;
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: 0.375rem !important;
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: 0.5rem !important;
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: 1rem !important;
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: 2rem !important;
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: 0.5rem !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: 0.5rem !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: 0.25rem !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: 0.375rem !important;
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: 0.5rem !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: 1rem !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: 2rem !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: 50rem !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: 0.375rem !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: 0.5rem !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: 1rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: 2rem !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: 50rem !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: 0.25rem !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: 0.25rem !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: 0.375rem !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: 0.375rem !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: 0.5rem !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: 1rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: 1rem !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: 2rem !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: 2rem !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: 50rem !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: 50rem !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
* {
  box-sizing: border-box;
}

:root {
  --color-primary: #3a5443ff;
  --color-primary-translucent: #284f4330;
  --color-secondary: #844c85;
  --color-error: #aa0000;
  --color-error-background: #ffeeee;
  --color-muted: #6c757d;
  --color-gray: #aaaaaa;
  --color-light-gray: #cccccc;
  --color-dark-gray: #999999;
  --color-white: #ffffff;
  --color-black: #555555;
  --color-super-black: #000000;
  --color-background: #ffffff;
  --color-highlight: #eaf2ff;
  --color-disabled-background: #f8f8f8;
  --color-light-line: #e0e0e0;
  --color-control: #333333;
  --color-control-background: #ffffff;
  --color-control-label: #bbbbbb;
  --color-button-label: #ffffff;
  --color-button-background: #284f43;
  --color-cancel-button-label: #284f43;
  --color-cancel-button-background: #ffffff;
  --color-nav-bar-background: #f4f4f4;
  --color-border: #dee2e6;
  --color-red: #dd1111;
  --color-green: #11aa11;
  --width-nav-bar: 200px;
}

[data-theme=dark] {
  --color-primary: #5a8a7c;
  --color-black: #eeeeee;
  --color-white: #444444;
  --color-super-black: #ffffff;
  --color-background: #333333;
  --color-nav-bar-background: #444444;
  --color-light-gray: #cccccc;
  --color-primary-translucent: #268cd333;
  --color-light-line: #666666;
  --color-disabled-button: #999999;
  --color-highlight: #505060;
  --color-control: #ffffff;
  --color-control-background: #333333;
  --color-control-label: #777777;
  --color-button-label: #ffffff;
  --color-button-background: #284f43;
  --color-cancel-button-label: #999999;
  --color-cancel-button-background: #666666;
  --color-menu-background: #555555;
}

* {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

*:not(path):not(svg):not(rect) {
  xcolor: #555555;
  xcolor: var(--color-black);
}

html,
body {
  height: 100%;
  background-color: #ffffff;
  background-color: var(--color-background);
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  color: var(--text-color);
  scroll-behavior: auto;
}

body {
  opacity: 0;
  animation: fadeIn 200ms ease-in forwards;
  animation-delay: 200ms;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.loader {
  width: 50px;
  aspect-ratio: 1;
  display: grid;
  border: 4px solid rgba(0, 0, 0, 0);
  border-radius: 50%;
  border-right-color: #25b09b;
  animation: l15 1s infinite linear;
}

.loader::before,
.loader::after {
  content: "";
  grid-area: 1/1;
  margin: 2px;
  border: inherit;
  border-radius: 50%;
  animation: l15 2s infinite;
}

.loader::after {
  margin: 8px;
  animation-duration: 3s;
}

@keyframes l15 {
  100% {
    transform: rotate(1turn);
  }
}
.hidden {
  display: none;
}

.container {
  margin: 0 auto;
  padding: 0 1rem;
}

.styled-button {
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.2), 0 0 20px 0 rgba(0, 0, 0, 0.1);
  border: none;
  color: #ffffff;
  color: var(--color-white);
  background-color: #3a5443ff;
  background-color: var(--color-primary);
  padding: 1.2em 2.8em;
  text-decoration: none;
  text-align: center;
  text-transform: uppercase;
  font-weight: 700;
  transition: all 0.2s ease-in;
  letter-spacing: 1px;
  cursor: pointer;
  outline: none;
  font-size: 16px;
}
.styled-button:hover {
  background-color: #ffffff;
  background-color: var(--color-white);
  color: #3a5443ff;
  color: var(--color-primary);
}
.styled-button:disabled {
  color: #aaaaaa !important;
  color: var(--color-gray) !important;
  background-color: var(--color-disabled-button);
  box-shadow: none !important;
  cursor: auto;
  cursor: initial;
}
.styled-button.sm {
  padding: 0.4rem 1.6rem;
  font-size: 14px;
}
.styled-button.danger {
  background-color: #dd1111;
  background-color: var(--color-red);
}
.styled-button.danger:hover {
  background-color: #ffffff;
  background-color: var(--color-white);
  color: #dd1111;
  color: var(--color-red);
}

.modal-content-wrapper .modal-footer-content .remove-photo-button {
  margin-right: auto;
}

.input-container {
  position: relative;
  width: 100%;
  display: block;
}
.input-container.column-2 {
  display: inline-block;
  width: calc(50% - 6px);
}
.input-container.column-2-last {
  display: inline-block;
  width: calc(50% - 6px);
  margin-left: 12px !important;
}
.input-container:focus-within label {
  transform: translate(-14px, 2px) scale(0.7);
  color: #3a5443ff;
  color: var(--color-primary);
}
.input-container .filled {
  transform: translate(-14px, 2px) scale(0.7);
}
.input-container label {
  position: absolute;
  pointer-events: none;
  transform: translate(-4px, 18px) scale(1);
  transform-origin: top left;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  color: #bbbbbb;
  color: var(--color-control-label);
  font-size: 20px;
  line-height: 1;
  left: 16px;
  padding: 3px;
  overflow: hidden;
  height: 25px;
  max-height: 25px;
  width: 100%;
}
.input-container input,
.input-container textarea,
.input-container select,
.input-container .link-box {
  height: 64px;
  border: none;
  padding: 12px 16px 2px 16px;
  font-size: 20px;
  line-height: 1;
  outline: none;
  box-shadow: none;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  border-bottom: solid 3px #eeeeee;
  transition: all 200ms ease-in;
  width: 100%;
}
.input-container input:read-only,
.input-container textarea:read-only,
.input-container select:read-only,
.input-container .link-box:read-only {
  background-color: var(--color-background-color);
}
.input-container select {
  padding-right: 20px;
}
.input-container input:focus,
.input-container textarea:focus,
.input-container select:focus {
  border-bottom: solid 3px #3a5443ff;
  border-bottom: solid 3px var(--color-primary);
}
.input-container textarea {
  min-height: 230px;
  padding-top: 25px;
  resize: none;
  line-height: 23px;
}
.input-container.not-valid input,
.input-container.not-valid textarea,
.input-container.not-valid select {
  border-bottom: solid 3px #aa0000;
  background-color: #ffeeee;
}

.form-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 20px;
}
.form-item label {
  font-size: 12px;
  color: #aaaaaa;
  color: var(--color-gray);
  font-weight: 700;
  text-transform: uppercase;
}
.form-item p {
  font-size: 15px;
  color: #555555;
  color: var(--color-black);
  margin: 0;
  position: relative;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.2rem;
  align-items: center;
  height: -webkit-fit-content;
  height: fit-content;
  line-height: normal;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
}
.form-item.nudge-up p {
  top: -3px;
}

.request-password-reset {
  padding-top: 30px;
}

.login-form .request-password-reset {
  padding-top: 0;
  margin-bottom: 1rem;
}
.login-form .login-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1.5rem;
}
.login-form .login-primary-button,
.login-form .login-google-button,
.login-form .login-google-wrap {
  width: 100%;
  margin: 0;
}
.login-form .login-google-wrap {
  position: relative;
}
.login-form .login-google-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  background-color: #ffffff;
  background-color: var(--color-white);
  color: #3a5443ff;
  color: var(--color-primary);
  border: 2px solid #3a5443ff;
  border: 2px solid var(--color-primary);
  box-shadow: none;
}
.login-form .login-google-button:hover:not(:disabled) {
  background-color: #3a5443ff;
  background-color: var(--color-primary);
  color: #ffffff;
  color: var(--color-white);
}
.login-form .login-google-button:disabled {
  border-color: var(--color-disabled-button);
}
.login-form .login-google-mark {
  width: 1.15em;
  height: 1.15em;
  flex-shrink: 0;
}
.login-form .login-google-overlay {
  position: absolute;
  inset: 0;
  opacity: 0.001;
  overflow: hidden;
  cursor: pointer;
}
.login-form .login-google-overlay > div,
.login-form .login-google-overlay iframe {
  width: 100% !important;
  height: 100% !important;
  min-width: 100% !important;
}

.card {
  background: #ffffff;
  background: var(--color-white);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin-bottom: 2rem;
}

.alert {
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}
.alert-error {
  background-color: #ffeeee;
  background-color: var(--color-error-background);
  border: 1px solid #aa0000;
  border: 1px solid var(--color-error);
  color: #aa0000;
  color: var(--color-error);
}

.no-data {
  font-size: 15px;
  opacity: 0;
  animation: fadeIn 0.2s ease-in-out forwards;
  animation-delay: 0.5s;
}

.split-screen-container {
  position: fixed;
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.split-screen-container.content-left {
  flex-direction: row-reverse;
}
.split-screen-container.content-right {
  flex-direction: row;
}
.split-screen-container .split-screen-image {
  width: 50%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
@media (max-width: 992px) {
  .split-screen-container .split-screen-image {
    display: none;
  }
}
.split-screen-container .split-screen-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1));
}
.split-screen-container .split-screen-content {
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #eeeeee !important;
  padding: 40px;
  overflow-y: auto;
}
@media (max-width: 992px) {
  .split-screen-container .split-screen-content {
    width: 100%;
    padding: 20px;
  }
}
.split-screen-container .split-screen-content .content-wrapper {
  width: 100%;
  max-width: 400px;
  color: #555555;
  color: var(--color-black);
}
@media (max-width: 992px) {
  .split-screen-container .split-screen-content .content-wrapper {
    max-width: 100%;
  }
}
.split-screen-container .split-screen-content .content-wrapper img.split-screen-logo {
  width: auto;
  height: 80px;
  margin-bottom: 40px;
  cursor: pointer;
}
@media (max-width: 992px) {
  .split-screen-container .split-screen-content .content-wrapper img.split-screen-logo {
    height: 50px;
    margin-bottom: 15px;
  }
}
.split-screen-container .split-screen-content .content-wrapper h3.display-4 {
  font-weight: 200;
  font-size: 44px;
  color: #555555;
  color: var(--color-black);
  margin-bottom: 20px;
}
@media (max-width: 992px) {
  .split-screen-container .split-screen-content .content-wrapper h3.display-4 {
    font-size: 32px;
    margin-bottom: 15px;
  }
}
.split-screen-container .split-screen-content .content-wrapper p.muted {
  color: #6c757d;
  color: var(--color-muted);
  font-size: 16px;
  margin-bottom: 30px;
}
.split-screen-container .split-screen-content .content-wrapper .error-message {
  color: #aa0000;
  color: var(--color-error);
  margin-top: 30px;
  line-height: 20px;
}
.split-screen-container .split-screen-content .content-wrapper form {
  margin-top: 50px;
  margin-bottom: 30px;
  width: 100%;
}
.split-screen-container .split-screen-content .content-wrapper form .input-container {
  margin-bottom: 20px;
  width: 100%;
}
.split-screen-container .split-screen-content .content-wrapper form .input-container label {
  position: absolute;
  pointer-events: none;
  transform: translate(-4px, 18px) scale(1);
  transform-origin: top left;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  color: #bbbbbb;
  color: var(--color-control-label);
  font-size: 20px;
  line-height: 1;
  left: 16px;
  padding: 3px;
  overflow: hidden;
  height: 25px;
  max-height: 25px;
  width: 100%;
}
.split-screen-container .split-screen-content .content-wrapper form .input-container input,
.split-screen-container .split-screen-content .content-wrapper form .input-container textarea,
.split-screen-container .split-screen-content .content-wrapper form .input-container select {
  height: 64px;
  border: none;
  padding: 12px 16px 2px 16px;
  font-size: 20px;
  line-height: 1;
  outline: none;
  box-shadow: none;
  transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  border-bottom: solid 3px #e0e0e0;
  border-bottom: solid 3px var(--color-light-line);
  width: 100%;
  color: #333333;
  color: var(--color-control);
  background-color: #ffffff;
  background-color: var(--color-control-background);
}
.split-screen-container .split-screen-content .content-wrapper form .input-container input:focus,
.split-screen-container .split-screen-content .content-wrapper form .input-container textarea:focus,
.split-screen-container .split-screen-content .content-wrapper form .input-container select:focus {
  border-bottom: solid 3px #3a5443ff;
  border-bottom: solid 3px var(--color-primary);
}
.split-screen-container .split-screen-content .content-wrapper form .input-container:focus-within label {
  transform: translate(-14px, 2px) scale(0.7);
  color: #3a5443ff;
  color: var(--color-primary);
}
.split-screen-container .split-screen-content .content-wrapper form .input-container .filled {
  transform: translate(-14px, 2px) scale(0.7);
}
.split-screen-container .split-screen-content .content-wrapper form button {
  margin-top: 40px;
  margin-bottom: 30px;
  width: 100%;
}
.split-screen-container .split-screen-content .content-wrapper form .login-actions button {
  margin-top: 0;
  margin-bottom: 0;
}

.reset-password {
  margin-top: 30px;
}

.muted {
  color: #6c757d;
  color: var(--color-muted);
}

.simple-link {
  color: #3a5443ff;
  color: var(--color-primary);
  text-decoration: underline;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.test-style,
.home-page-title.test-style {
  display: none;
}

.split-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
}
.split-screen.reversed {
  flex-direction: row-reverse;
}
.split-screen .image {
  flex: 1 1;
  position: relative;
  overflow: hidden;
}
.split-screen .image .bg-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.split-screen .image .bg-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4));
}
.split-screen .content-side {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  background-color: var(--color-background);
  padding: 2rem;
}
.split-screen .content-side .content {
  max-width: 400px;
  width: 100%;
}

.content-wrapper {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px 30px 10px 30px;
}
.content-wrapper h2 {
  font-weight: 200;
  font-size: 44px;
  color: #555555;
  color: var(--color-black);
}

.map-container {
  font-size: 15px;
}

.map-tab-static {
  width: 100%;
}

.dashboard .dashboard-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.dashboard .dashboard-header h2 {
  margin: 0;
}
.dashboard .dashboard-period-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #cccccc;
  color: var(--color-light-gray);
  text-transform: uppercase;
}
.dashboard .dashboard-period-selector select {
  min-width: 150px;
  padding: 6px 10px;
  border: solid 1px #555555;
  border: solid 1px var(--color-black);
  border-radius: 4px;
  background: #ffffff;
  background: var(--color-white);
  text-transform: none;
  color: #555555;
  color: var(--color-black);
}
.dashboard .dashboard-chart {
  border: solid 1px #555555;
  border: solid 1px var(--color-black);
  border-radius: 4px;
  padding-top: 14px;
  padding-left: 10px;
  height: 250px;
  min-height: 2px;
  pointer-events: none;
  font-family: Inter, Arial, Helvetica, sans-serif;
  font-size: 13px;
  color: #555555;
  color: var(--color-black);
  position: relative;
  margin-bottom: 30px;
}
.dashboard .dashboard-chart .recharts-responsive-container {
  position: relative;
  left: -10px;
  padding-top: 10px;
  padding-right: 20px;
}
.dashboard .dashboard-chart span.header {
  padding-left: 6px;
}
.dashboard .dashboard-top-users {
  border: solid 1px #555555;
  border: solid 1px var(--color-black);
  color: #555555;
  color: var(--color-black);
  border-radius: 4px;
  height: 375px;
  min-height: 375px;
  overflow: hidden;
  position: relative;
  margin-bottom: 30px;
  padding-top: 14px;
  padding-bottom: 25px;
}
.dashboard .dashboard-top-users span.header {
  margin-left: 15px;
}
.dashboard .dashboard-top-users .frame {
  margin: 0 30px 30px 25px;
}
.dashboard .dashboard-map {
  border: solid 1px #555555;
  border: solid 1px var(--color-black);
  border-radius: 4px;
  padding: 10px;
  height: 375px;
  min-height: 375px;
  position: relative;
  margin-bottom: 30px;
}
@media (max-width: 700px) {
  .dashboard .dashboard-map {
    height: auto;
    height: initial;
    min-height: 0;
    min-height: initial;
  }
}
.dashboard .dashboard-map span.header {
  margin-left: 10px;
  position: relative;
  top: 3px;
}
.dashboard .dashboard-map .us-state-map {
  padding-top: 10px;
  padding-bottom: 60px;
  width: 100%;
  height: 100%;
  max-height: 380px;
}
@media (max-width: 700px) {
  .dashboard .dashboard-map .us-state-map {
    padding-bottom: 0;
  }
}
.dashboard span.header {
  font-weight: 600;
  color: #aaaaaa;
  color: var(--color-gray);
  text-transform: uppercase;
  font-size: 13px;
}
.dashboard .aggregates {
  min-height: 130px;
}
.dashboard .aggregates .aggregate {
  height: 130px;
  min-height: 130px;
  max-height: 130px;
  margin-bottom: 30px;
}
.dashboard .aggregates .aggregate > div {
  border: solid 1px #555555;
  border: solid 1px var(--color-black);
  padding: 10px 15px 0 15px;
  border-radius: 4px;
  height: 100%;
  position: relative;
  overflow: hidden;
  transition: box-shadow 120ms ease-in;
}
.dashboard .aggregates .aggregate > div.clickable {
  cursor: pointer;
}
.dashboard .aggregates .aggregate > div.clickable:hover {
  /* Subtle, even gray glow without shifting layout */
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.08);
}
.dashboard .aggregates .aggregate p {
  margin: 0;
  overflow: hidden;
  text-overflow: hidden;
}
.dashboard .aggregates .aggregate p:nth-child(1) {
  color: #cccccc;
  color: var(--color-light-gray);
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 700;
  position: absolute;
  top: 16px;
}
.dashboard .aggregates .aggregate p:nth-child(2) {
  color: #555555;
  color: var(--color-black);
  font-size: 36px;
  font-weight: 600;
  letter-spacing: 1px;
  position: absolute;
  top: 38px;
}
.dashboard .aggregates .aggregate p:nth-child(3) {
  color: #aaaaaa;
  color: var(--color-gray);
  font-size: 14px;
  position: absolute;
  bottom: 10px;
  height: 19px;
  max-height: 19px;
  overflow: hidden;
  word-break: break-all;
}
.dashboard .aggregates .aggregate .icon {
  margin-right: 8px;
}
.dashboard .aggregates .aggregate .icon-ArrowTrendUp,
.dashboard .aggregates .aggregate span.trendUp {
  color: #11aa11;
  color: var(--color-green);
}
.dashboard .aggregates .aggregate .icon-ArrowTrendDown,
.dashboard .aggregates .aggregate span.trendDown {
  color: #dd1111;
  color: var(--color-red);
}

.auth-timeout-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #e0e0e0;
  background-color: var(--color-light-line);
  z-index: 1030;
}
.auth-timeout-bar div {
  height: 100%;
  background-color: #3a5443ff;
  background-color: var(--color-primary);
  transition: width 0.1s linear;
}

.authenticated-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
}
.authenticated-layout .layout-container {
  display: flex;
  flex: 1 1;
}
.authenticated-layout .nav-bar {
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  width: 200px;
  width: var(--width-nav-bar);
  height: 100vh;
  background-color: #f4f4f4 !important;
  background-color: var(--color-nav-bar-background) !important;
  color: #555555;
  color: var(--color-black);
  transition: width 0.3s ease;
  z-index: 100;
  border-right: solid 1px #e0e0e0;
  border-right: solid 1px var(--color-light-line);
  width: var(--width-nav-bar);
  transition: width 0.3s ease;
  background-color: var(--color-nav-bar-background);
  height: 100vh;
  position: fixed;
  z-index: 1000;
}
@media (max-width: 992px) {
  .authenticated-layout .nav-bar {
    width: 48px;
    max-width: 48px;
    height: auto;
    position: relative;
  }
}
.authenticated-layout .nav-bar .top-bar-nav {
  width: 200px;
  width: var(--width-nav-bar);
}
.authenticated-layout .nav-bar .nav-wrapper {
  margin-top: 74px;
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 74px);
}
.authenticated-layout .nav-bar.mobile {
  width: 55px;
  height: auto;
  position: relative;
  background-color: #f4f4f4;
  background-color: var(--color-nav-bar-background);
  border-bottom: 1px solid #e0e0e0;
  border-bottom: 1px solid var(--color-light-line);
}
.authenticated-layout .nav-bar.mobile .top-bar-nav {
  width: 55px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.authenticated-layout .nav-bar.mobile .top-bar-nav .logo img {
  height: 100%;
  width: auto;
}
.authenticated-layout .nav-bar.mobile .nav-wrapper {
  padding: 0;
}
.authenticated-layout .nav-bar.mobile .nav.mobile {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  padding: 10px;
}
.authenticated-layout .nav-bar.mobile .nav.mobile .nav-item {
  margin: 0;
  width: auto;
}
.authenticated-layout .nav-bar.mobile .nav.mobile .nav-item .nav-item-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.authenticated-layout .nav-bar.mobile .nav.mobile .nav-item .nav-item-link.active {
  color: #3a5443ff;
  color: var(--color-primary);
}
.authenticated-layout .nav-bar.mobile .nav.mobile .nav-item .nav-item-link .icon {
  margin: 0 0 4px 0;
  font-size: 1.2em;
}
.authenticated-layout .nav-bar.mobile .nav.mobile .nav-item .nav-item-link .nav-item-label {
  font-size: 0.8em;
  text-align: center;
  white-space: nowrap;
}
.authenticated-layout .nav-bar .collapse-button {
  position: fixed;
  top: 20px;
  left: calc(200px - 30px);
  left: calc(var(--width-nav-bar) - 30px);
  transition: all 0.3s ease;
  display: block;
}
@media (max-width: 992px) {
  .authenticated-layout .nav-bar .collapse-button {
    display: none;
  }
}
.authenticated-layout .nav-bar .toggle-button {
  position: absolute;
  top: 1rem;
  right: 16px;
  background: none;
  border: none;
  color: #555555;
  color: var(--color-black);
  cursor: pointer;
  padding: 0.5rem;
  font-size: 1.1rem;
  z-index: 101;
}
.authenticated-layout .nav-bar .toggle-button:hover {
  opacity: 0.8;
}
.authenticated-layout .nav-bar .light-theme-only {
  display: block;
}
.authenticated-layout .nav-bar .dark-theme-only {
  display: none;
}
.authenticated-layout .nav-bar .logo {
  height: 60px;
  width: 100%;
  padding: 10px 44px 0 20px;
  transition: opacity 0.2s ease;
  transition-delay: 0.1s;
  opacity: 1;
}
@media (max-width: 992px) {
  .authenticated-layout .nav-bar .logo {
    opacity: 0;
  }
}
.authenticated-layout .nav-bar .logo .logo-image,
.authenticated-layout .nav-bar .logo .logo-image-white {
  height: 42px;
  width: auto;
}
.authenticated-layout .nav-bar .position-sticky {
  z-index: 100;
}
.authenticated-layout .nav-bar .position-sticky {
  padding-top: 1px !important;
}
.authenticated-layout .nav-bar .nav-item {
  height: 45px;
  max-height: 45px;
  position: relative;
}
.authenticated-layout .nav-bar .nav-item-link {
  color: #555555;
  color: var(--color-black);
  position: relative;
  display: inline-block;
}
.authenticated-layout .nav-bar .nav-item-link.disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}
.authenticated-layout .nav-bar .nav-item-link {
  width: 208px;
  max-width: 208px;
  min-height: 45px;
  max-height: 45px;
  margin-top: 0;
  margin-left: 10px;
  margin-bottom: 0;
  border-width: 0;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  text-decoration: none;
  padding-left: 32px;
  padding-top: 9px;
  border-left: solid 8px transparent;
  transition: margin-left 0.2s ease;
}
@media (max-width: 992px) {
  .authenticated-layout .nav-bar .nav-item-link {
    margin-left: 5px;
  }
}
.authenticated-layout .nav-bar .nav-item-link .icon {
  display: inline-block;
  text-align: left;
  position: absolute;
  font-size: 16px;
  margin-left: 4px;
  margin-right: 8px;
  margin-top: 10px;
  width: 22px;
  transition: all 0.2s ease;
  top: 0;
  left: -1px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-Users {
  top: 1px;
  left: -1px;
  font-size: 14px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-Heart {
  font-size: 19px;
  top: -2px;
  left: -2px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-Comment {
  font-size: 18px;
  top: -1px;
  left: -2px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-LayerGroup {
  font-size: 16px;
  top: 0;
  left: -1px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-DoorOpen {
  font-size: 16px;
  top: -1px;
  left: -1px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-Building {
  font-size: 16px;
  top: 0px;
  left: 1px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-NetworkWired {
  left: -2px;
  top: 0px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-FileText {
  font-size: 20px;
  left: 1px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-Clipboard {
  font-size: 19px;
  top: -2px;
  left: -1px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-Shop {
  font-size: 15px;
  top: 0px;
  left: -1px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-QuoteRight {
  left: 1px;
  font-size: 16px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-ChessKing {
  font-size: 18px;
  top: -3px;
  left: 0px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-FireFlameCurved {
  font-size: 17px;
  top: -1px;
  left: 1px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-SignOutAlt {
  top: 0px;
  font-size: 16px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-CloudSun {
  top: 1px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-University {
  font-size: 16px;
  left: -1px;
  top: -1px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-NetworkWired {
  font-size: 15px;
  left: -2px;
  top: 0px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-PersonDigging {
  font-size: 16px;
  left: -1px;
  top: 0px;
}
.authenticated-layout .nav-bar .nav-item-link .icon-Map {
  font-size: 15px;
  left: -2px;
  top: 0px;
}
.authenticated-layout .nav-bar .nav-item-link span {
  font-size: 16px;
  position: relative;
  color: #555555;
  color: var(--color-black);
  font-weight: normal;
  transition: color 0.2s;
}
.authenticated-layout .nav-bar .nav-item-link span.nav-item-label {
  font-size: 14px;
  font-weight: 500;
  transition: opacity 0.2s;
  opacity: 1;
}
@media (max-width: 992px) {
  .authenticated-layout .nav-bar .nav-item-link span.nav-item-label {
    opacity: 0;
  }
}
.authenticated-layout .nav-bar .nav-item-link:visited {
  color: #555555;
  color: var(--color-black);
}
.authenticated-layout .nav-bar .nav-item-link:hover span {
  color: #3a5443ff;
  color: var(--color-primary);
  cursor: pointer;
}
.authenticated-layout .nav-bar .nav-item-link.active {
  color: #3a5443ff;
  color: var(--color-primary);
  cursor: default;
}
.authenticated-layout .nav-bar .nav-item-link.active, .authenticated-layout .nav-bar .nav-item-link.active span {
  color: #3a5443ff;
  color: var(--color-primary);
  font-weight: 700;
  cursor: default;
}
.authenticated-layout .top-bar-nav {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  height: 60px;
  border-bottom: 1px solid #e0e0e0;
  border-bottom: 1px solid var(--color-light-line);
}
@media (max-width: 992px) {
  .authenticated-layout .top-bar-nav {
    display: none;
  }
}
.authenticated-layout .account-profile {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: auto;
  justify-content: flex-end;
}
.authenticated-layout .account-profile.mobile .language-chooser {
  width: 35px;
  height: 35px;
}
.authenticated-layout .account-profile.mobile .account-profile-button {
  width: 35px;
  height: 35px;
}
.authenticated-layout .account-profile.mobile .popover-container {
  width: 100%;
  max-width: 300px;
}
.authenticated-layout .account-profile .language-chooser {
  height: 30px;
  width: auto;
  position: relative;
  top: 14px;
  margin-right: 15px;
  cursor: pointer;
}
.authenticated-layout .account-profile .avatar .initials {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 17px;
}
.authenticated-layout.nav-collapsed .nav-bar {
  width: 55px;
}
.authenticated-layout.nav-collapsed .nav-bar .nav-item-label {
  opacity: 0 !important;
}
.authenticated-layout.nav-collapsed .nav-bar .logo {
  opacity: 0 !important;
}
.authenticated-layout.nav-collapsed .nav-bar .collapse-button {
  left: 22px;
  top: 15px;
  transform: rotate(180deg);
}
.authenticated-layout.nav-collapsed .content-area {
  margin-left: 55px;
}
@media (max-width: 992px) {
  .authenticated-layout.nav-collapsed .content-area {
    margin-left: 0;
  }
}
.authenticated-layout .content-area {
  flex: 1 1;
  margin-left: 200px;
  margin-left: var(--width-nav-bar);
  transition: margin-left 0.3s ease;
  overflow-y: auto;
  height: 100vh;
}
@media (max-width: 992px) {
  .authenticated-layout .content-area {
    margin-left: 0;
  }
}
.authenticated-layout .content-container {
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.authenticated-layout .top-bar {
  background-color: #ffffff;
  background-color: var(--color-background);
  border-bottom: 1px solid #e0e0e0;
  border-bottom: 1px solid var(--color-light-line);
  height: 60px;
  min-height: 60px;
}
.authenticated-layout .top-bar .top-bar-content {
  padding: 15px 0 0 35px;
  display: flex;
  align-items: center;
  gap: 10px;
}
@media (max-width: 992px) {
  .authenticated-layout .top-bar .top-bar-content {
    padding: 15px 0 0 20px;
  }
}
.authenticated-layout .top-bar .top-bar-content .global-search {
  position: relative;
  width: calc(100% - 180px);
}
.authenticated-layout .top-bar .top-bar-content .global-search > input {
  border: 0;
  width: 100%;
  padding: 5px 12px;
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-light-line);
  border-radius: 6px;
  background-color: #ffffff;
  background-color: var(--color-background);
  color: #555555;
  color: var(--color-black);
  font-size: 14px;
}
.authenticated-layout .top-bar .top-bar-content .global-search > input:focus {
  outline: none;
  border-color: #3a5443ff;
  border-color: var(--color-primary);
}
.authenticated-layout .top-bar .top-bar-content .global-search > input::placeholder {
  color: #bbbbbb;
  color: var(--color-control-label);
}
.authenticated-layout .global-search-panel {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 1100;
  max-height: 70vh;
  overflow-y: auto;
  background-color: #ffffff;
  background-color: var(--color-background);
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  padding: 6px 0;
}
.authenticated-layout .global-search-panel .global-search-status {
  padding: 14px 16px;
  color: #6c757d;
  color: var(--color-muted);
  font-size: 13px;
}
.authenticated-layout .global-search-panel .global-search-section:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
  border-bottom: 1px solid var(--color-light-line);
}
.authenticated-layout .global-search-panel .global-search-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px 4px;
}
.authenticated-layout .global-search-panel .global-search-section-header .global-search-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6c757d;
  color: var(--color-muted);
}
.authenticated-layout .global-search-panel .global-search-section-header .global-search-section-title .icon {
  color: #3a5443ff;
  color: var(--color-primary);
}
.authenticated-layout .global-search-panel .global-search-section-header .global-search-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background-color: #284f4330;
  background-color: var(--color-primary-translucent);
  color: #3a5443ff;
  color: var(--color-primary);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0;
}
.authenticated-layout .global-search-panel .global-search-section-header .global-search-seeall {
  border: 0;
  background: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #3a5443ff;
  color: var(--color-primary);
  padding: 2px 4px;
}
.authenticated-layout .global-search-panel .global-search-section-header .global-search-seeall:hover {
  text-decoration: underline;
}
.authenticated-layout .global-search-panel .global-search-section-items {
  display: flex;
  flex-direction: column;
  padding-bottom: 4px;
}
.authenticated-layout .global-search-panel .global-search-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 0;
  background: none;
  text-align: left;
  padding: 7px 14px;
  cursor: pointer;
}
.authenticated-layout .global-search-panel .global-search-row.active, .authenticated-layout .global-search-panel .global-search-row:hover {
  background-color: #eaf2ff;
  background-color: var(--color-highlight);
}
.authenticated-layout .global-search-panel .global-search-row .global-search-thumb.avatar {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
}
.authenticated-layout .global-search-panel .global-search-row .global-search-thumb.avatar .initials {
  font-size: 13px;
  line-height: 1;
}
.authenticated-layout .global-search-panel .global-search-row .global-search-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}
.authenticated-layout .global-search-panel .global-search-row .global-search-title {
  font-size: 14px;
  color: #555555;
  color: var(--color-black);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.authenticated-layout .global-search-panel .global-search-row .global-search-subtitle {
  font-size: 12px;
  color: #6c757d;
  color: var(--color-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.authenticated-layout .global-search-panel .global-search-row .global-search-badge {
  flex: 0 0 auto;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 7px;
  border-radius: 10px;
}
.authenticated-layout .global-search-panel .global-search-row .global-search-badge.live {
  background-color: rgba(17, 170, 17, 0.14);
  color: #11aa11;
  color: var(--color-green);
}
.authenticated-layout .global-search-panel .global-search-row .global-search-badge.history {
  background-color: #f8f8f8;
  background-color: var(--color-disabled-background);
  color: #6c757d;
  color: var(--color-muted);
}
.authenticated-layout .content-wrapper {
  flex: 1 1;
  overflow-y: auto;
  background-color: #ffffff;
  background-color: var(--color-background);
}
@media (max-width: 992px) {
  .authenticated-layout .content-wrapper {
    padding: 10px 15px 10px 15px;
  }
}

.avatar {
  width: 51px;
  height: 51px;
  position: relative;
  color: #ffffff;
  color: var(--color-white);
}
.avatar.empty {
  opacity: 0;
}
.avatar.is-venue .image {
  border-radius: 0;
  transform: scale(1.15);
}
.avatar .initials {
  width: 100%;
  height: 100%;
  background-color: #3a5443ff;
  background-color: var(--color-primary);
  color: #ffffff;
  color: var(--color-white);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: 600;
  position: relative;
  border-radius: 51px;
  line-height: 19px;
}
.avatar .image {
  width: 100%;
  height: 100%;
  border-radius: 51px;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 51px;
  object-fit: cover;
}
.avatar.extra-large {
  aspect-ratio: 1/1;
  height: 100%;
  width: 100%;
  margin-top: 5px;
}
.avatar.extra-large .initials {
  border-radius: 100%;
}
.avatar.extra-large .image {
  border-radius: 100%;
}
.avatar.local-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50px;
  top: 0;
}
.avatar.local-avatar .image {
  transform: scale(1.1);
  background-position: center center;
}
.avatar.venue-avatar {
  border-radius: 0;
}

.table {
  width: 100%;
  font-size: 13px;
  position: relative;
  color: #ffffff;
  color: var(--color-background);
  margin-top: 5px;
  margin-bottom: 0;
}
.table table {
  table-layout: fixed;
}
.table table tr:not([progress]):hover .options-container {
  opacity: 1 !important;
}
.table table:hover td .menu-icon {
  opacity: 1 !important;
}
.table table.clickable tr:not([progress]):hover td {
  background-color: #eaf2ff;
  background-color: var(--color-highlight);
}
.table table.clickable tbody tr:not([progress]) {
  cursor: pointer;
}
.table table {
  width: 100%;
}
.table table tr {
  border-bottom: solid 1px #e0e0e0;
  border-bottom: solid 1px var(--color-light-line);
  background-color: #ffffff;
  background-color: var(--color-background);
}
.table table tr:hover td .options-container {
  opacity: 1 !important;
}
.table table tr:hover td .menu-icon {
  opacity: 1 !important;
}
.table table tr:last-child {
  border-bottom: none;
}
.table table tr[progress] td {
  color: #cccccc !important;
  color: var(--color-light-gray) !important;
}
.table table tr[progress] td img {
  filter: grayscale(1) brightness(1.8);
}
.table table tr[progress] td:nth-child(2) {
  max-width: 0;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
.table table tr[progress] td.actions {
  opacity: 0;
}
.table table tr[progress] td div {
  color: #cccccc !important;
  color: var(--color-light-gray) !important;
}
.table table thead tr {
  height: 34px;
}
.table table td {
  height: 56px;
  max-height: 56px;
  font-size: 13px;
  padding-right: 8px;
  padding-top: 0;
  line-height: 19px;
  color: #555555;
  color: var(--color-black);
  vertical-align: middle;
}
.table table td.special-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  padding-right: 20px;
}
.table table td.special-content p {
  overflow: hidden;
  text-overflow: ellipsis;
}
.table table td p {
  margin: 0;
  /* padding-top: 1px; */
  position: relative;
  top: -1px;
}
.table table td .full-name,
.table table td .customer-name-and-code,
.table table td .name-and-address {
  padding-top: 3px;
}
.table table td .full-name div:nth-child(1),
.table table td .customer-name-and-code div:nth-child(1),
.table table td .name-and-address div:nth-child(1) {
  font-weight: 600;
  color: #555555;
  color: var(--color-black);
}
.table table td .full-name div:nth-child(2),
.table table td .customer-name-and-code div:nth-child(2),
.table table td .name-and-address div:nth-child(2) {
  color: #aaaaaa;
  color: var(--color-gray);
}
.table table td .full-name div:nth-child(3),
.table table td .customer-name-and-code div:nth-child(3),
.table table td .name-and-address div:nth-child(3) {
  display: none;
}
.table table td .avatar {
  cursor: pointer;
}
.table table td .coordinates-cell {
  cursor: pointer;
  color: #3a5443ff;
  color: var(--color-primary);
}
.table table td .property-tag {
  left: -2px;
}
.table table td.actions div {
  text-align: center;
  vertical-align: middle;
  opacity: 0;
  transition: opacity 0.2s;
}
.table table td.actions div .icon {
  font-size: 18px;
  outline: none;
  transition: color 0.2s;
}
.table table td.actions div .icon:hover {
  color: #3a5443ff;
  color: var(--color-primary);
}
.table table td .options-container {
  opacity: 0;
  transition: opacity 0.2s ease;
  display: flex;
  justify-content: left;
  padding-left: 3px;
  align-items: center;
  height: 40px;
  width: 100%;
  position: relative;
  max-width: 40px;
}
.table table td .options-container .menu-dropdown {
  position: relative;
  display: inline-block;
}
.table table td .options-container .menu-icon {
  color: #3a5443ff;
  color: var(--color-primary);
  cursor: pointer;
  font-size: 22px;
  display: inline-block !important;
  width: 35px;
  height: 35px;
  padding: 4px;
  border: solid 1px #3a5443ff;
  border: solid 1px var(--color-primary);
  border-radius: 50%;
  text-align: center;
  vertical-align: middle;
  padding-top: 7px;
}
.table table td .options-container .dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 4px;
  background: #ffffff;
  background: var(--color-background);
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-light-line);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 100px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.2s ease;
  padding-top: 8px;
  padding-bottom: 8px;
}
.table table td .options-container .dropdown-menu.show {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.table table td .options-container .dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  color: var(--color-text);
  transition: background-color 0.2s ease;
}
.table table td .options-container .dropdown-item:hover {
  background-color: #e0e0e0;
  background-color: var(--color-light-line);
}
.table table th {
  border-bottom: solid 1px #e0e0e0;
  border-bottom: solid 1px var(--color-light-line);
  font-weight: bold;
  background-color: #ffffff;
  background-color: var(--color-background);
}
.table table th.special-content {
  width: 50%;
}
.table table th div {
  overflow: hidden;
  white-space: nowrap;
}
.table table th span {
  position: relative;
  cursor: pointer;
  padding: 5px 5px 5px 0px;
  color: #555555;
  color: var(--color-black);
  transition: color 0.2s;
}
.table table th span span {
  color: #aaaaaa;
  color: var(--color-gray);
  padding: 0;
}
.table table th span:hover,
.table table th span:hover span {
  color: #3a5443ff;
  color: var(--color-primary);
}
.table table th span.icon {
  position: relative;
  top: 1px;
}
.table table th span.icon.icon-CaretDown {
  top: 1px;
}
.table table th div:hover {
  color: #3a5443ff;
  color: var(--color-primary);
}
.table table th.nameAndAddress-header {
  width: 30%;
}
.table table th.avatar-header, .table table th.userAvatar-header, .table table th.venueAvatar-header, .table table th.venue-header, .table table th.venueIcon-header {
  width: 64px;
}
.table table th.documentType-header {
  width: 51px;
}
.table table th.hidden-header {
  width: 8px;
}
.table table th.options-header {
  width: 50px;
  max-width: 50px;
}
.table table tbody tr:nth-child(even) {
  background-color: #ffffff;
  background-color: var(--color-background);
}
.table table tbody tr.api-progress {
  transition: all 1s;
  background-image: linear-gradient(to right, #eaf2ff 0%, transparent 0%);
  background-image: linear-gradient(to right, var(--color-highlight) 0%, transparent 0%);
}
.table table tbody tr:hover td.actions div {
  opacity: 1;
}
.table table .thumbnail {
  background-position: center;
  background-size: cover;
  width: 100px;
  height: 100px;
}
.table table .thumbnail-icon {
  background-position: center;
  background-size: cover;
  width: 50px;
  height: 50px;
  margin-top: 25px;
  margin-bottom: 25px;
  margin-left: 25px;
}
.table table .document-icon {
  width: 27px;
  height: 27px;
  top: 0px;
  position: relative;
  max-width: 27px;
}

.venue-icon {
  width: 51px;
  height: 51px;
  border-radius: 51px;
  background-color: #3a5443ff;
  background-color: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  xbackground-size: 120% 120%;
  background-position: center center;
  box-shadow: 0 0 1px rgba(128, 128, 128, 0.5), 0 0 2px rgba(128, 128, 128, 0.4), 0 0 3px rgba(128, 128, 128, 0.3), 0 0 4px rgba(128, 128, 128, 0.2), 0 0 5px rgba(128, 128, 128, 0.1);
}

.property-tag {
  border-radius: 5px;
  padding: 2px 7px 2px 7px;
  display: inline-block;
  position: relative;
  left: 0;
  border: solid 1px #cccccc;
  background-color: #f0f0f0;
  color: #333333;
  white-space: nowrap;
}
.property-tag.Active, .property-tag.Resolved, .property-tag.NotFraudulent, .property-tag.Ready, .property-tag.icon-FileExcel, .property-tag.NotInterested, .property-tag.Trans, .property-tag.refund-refunded {
  background-color: #eaf7ed;
  border-color: #c4ddca;
  color: #155724;
}
.property-tag.OnProbation, .property-tag.Investigating, .property-tag.Running, .property-tag.Customer, .property-tag.icon-FileImage, .property-tag.Non-Binary, .property-tag.refund-pending {
  background-color: #fff3cd;
  border-color: #efdeaa;
  color: #856404;
}
.property-tag.Terminated, .property-tag.Tombstoned, .property-tag.Fraudulent, .property-tag.Error, .property-tag.TimedOut, .property-tag.Deleted, .property-tag.Failed, .property-tag.icon-FilePdf, .property-tag.Reported, .property-tag.refund-failed {
  background-color: #f8d7da;
  border-color: #e5b6bb;
  color: #721c24;
}
.property-tag.Orange, .property-tag.Support, .property-tag.Overdue, .property-tag.icon-FileVideo {
  background-color: #ffe5cc;
  border-color: #f3bc89;
  color: #995c00;
}
.property-tag.Adjudicated, .property-tag.Investigator {
  background-color: #e5e3f6;
  border-color: #cabaf2;
  color: #6b20a2;
}
.property-tag.Admin, .property-tag.Male, .property-tag.icon-FileWord, .property-tag.refund-processing {
  background-color: #ddeafb;
  border-color: #b3d4f7;
  color: #0b5394;
}
.property-tag.Female, .property-tag.icon-FilePowerpoint {
  background-color: #fdecef;
  border-color: #f9c6d0;
  color: #721c24;
}
.property-tag.healthy {
  background-color: #eaf7ed;
  border-color: #c4ddca;
  color: #155724;
}
.property-tag.degraded {
  background-color: #fff3cd;
  border-color: #efdeaa;
  color: #856404;
}
.property-tag.unhealthy {
  background-color: #f8d7da;
  border-color: #e5b6bb;
  color: #721c24;
}
.property-tag.not_configured {
  background-color: #f8f8f8;
  background-color: var(--color-disabled-background);
  border-color: #c4c9d1;
  color: #6c757d;
  color: var(--color-muted);
}

.not-found-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  background-color: var(--color-background);
  padding: 3rem 1rem;
}
.not-found-content {
  max-width: 28rem;
  width: 100%;
  text-align: center;
}
.not-found-title {
  font-size: 9rem;
  font-weight: 800;
  color: #3a5443ff;
  color: var(--color-primary);
  line-height: 1;
  margin: 0;
}
.not-found-subtitle {
  font-size: 1.875rem;
  font-weight: 800;
  color: #555555;
  color: var(--color-black);
  margin-top: 1.5rem;
  margin-bottom: 0;
}
.not-found-description {
  font-size: 0.875rem;
  color: #6c757d;
  color: var(--color-muted);
  margin-top: 0.5rem;
}
.not-found-actions {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.not-found-button {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}
.not-found-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px #284f4330;
  box-shadow: 0 0 0 2px var(--color-primary-translucent);
}
.not-found-button-primary {
  background-color: #284f43;
  background-color: var(--color-button-background);
  color: #ffffff;
  color: var(--color-button-label);
  border: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.not-found-button-primary:hover {
  opacity: 0.9;
}
.not-found-button-secondary {
  background-color: #ffffff;
  background-color: var(--color-cancel-button-background);
  color: #284f43;
  color: var(--color-cancel-button-label);
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.not-found-button-secondary:hover {
  background-color: #f8f8f8;
  background-color: var(--color-disabled-background);
}

.account-profile {
  position: absolute;
  top: 0px;
  right: 0;
  z-index: 1000000;
}
.account-profile .popover-container {
  animation: fadein 0.3s;
  overflow: visible !important;
  padding: 15px 20px 15px 20px;
  z-index: 10000000 !important;
  background-color: #ffffff;
  background-color: var(--color-white);
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.2), 0 0 20px 0 rgba(0, 0, 0, 0.1);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.account-profile .popover-container.visible {
  opacity: 1;
}
.account-profile .avatar.account-profile-button {
  display: inline-block;
  cursor: pointer;
  position: relative;
  top: 13px;
  right: 20px;
  width: 35px;
  height: 35px;
}
.account-profile .icon.button {
  background-color: transparent;
  color: #aaaaaa;
  color: var(--color-gray);
  position: relative;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 20px;
  margin-right: 19px;
  top: -11px;
}
.account-profile .icon.button:hover {
  color: #3a5443ff;
  color: var(--color-primary);
}
.account-profile .icon.button .icon-badge {
  position: absolute;
  right: -5px;
  top: -2px;
  width: 13px;
  height: 13px;
  border-radius: 13px;
  background-color: #dd1111;
  background-color: var(--color-red);
  color: #ffffff;
  font-size: 8px;
  font-weight: 600;
  text-align: center;
}

.top-bar .popover-container {
  transform: none !important;
  transform: initial !important;
  animation: fadein 0.3s;
  min-width: 180px;
  position: fixed;
  overflow: visible !important;
  top: 60px !important;
  right: 25px !important;
  left: auto !important;
  left: initial !important;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.top-bar .popover-container.visible {
  opacity: 1;
}
.top-bar .popover-container.language {
  min-width: 144px;
}
.top-bar .popover-container.language .popover-content div {
  display: flex;
  align-items: center;
  padding-left: 4px;
  cursor: pointer;
}
.top-bar .popover-container.language .popover-content div:hover {
  background-color: #eaf2ff;
  background-color: var(--color-highlight);
}
.top-bar .popover-container.language .popover-content div img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
.top-bar .popover-container.language .popover-content div span {
  font-size: 14px;
  color: #555555;
  color: var(--color-black);
}
.top-bar .popover-container .popover-content {
  color: #555555;
  color: var(--color-black);
  background-color: #ffffff;
  background-color: var(--color-white);
  position: relative;
  font-size: 14px;
}
.top-bar .popover-container .popover-content .avatar {
  width: 100%;
  height: 150px;
  text-align: center;
  padding: 5px 5px 0 5px;
  color: #555555;
  color: var(--color-black);
  background-color: #ffffff;
  background-color: var(--color-white);
}
.top-bar .popover-container .popover-content .avatar .initials {
  margin: 0 auto;
  width: 130px;
  height: 130px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 64px;
  border-radius: 130px;
  line-height: 110px;
  color: #ffffff;
  color: var(--color-white);
}
.top-bar .popover-container .popover-content .avatar .image {
  margin: 0 auto;
  width: 130px;
  height: 130px;
  border-radius: 130px;
  cursor: pointer;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
}
.top-bar .popover-container .popover-content .name {
  text-align: center;
  display: block;
  padding-bottom: 4px;
}
.top-bar .popover-container .popover-content .role {
  text-align: center;
  display: block;
}
.top-bar .popover-container .popover-content .role-name {
  display: inline-block;
  text-align: center;
}
.top-bar .popover-container .popover-content div.item {
  line-height: 38px;
  transition: color 0.2s;
  cursor: pointer;
}
.top-bar .popover-container .popover-content div.item .icon {
  margin-right: 12px;
  width: 14px;
  min-width: 14px;
  display: inline-block;
}
.top-bar .popover-container .popover-content div.item .icon.icon-Moon {
  position: relative;
  left: 2px;
}
.top-bar .popover-container .popover-content div.item:hover {
  color: #3a5443ff !important;
  color: var(--color-primary) !important;
}
.top-bar .popover-container .popover-content div.item:hover .icon {
  color: #3a5443ff !important;
  color: var(--color-primary) !important;
}
.top-bar .popover-container .popover-content hr {
  margin: 15px 0 10px;
}

.user-detail-overlay,
.venue-detail-overlay,
.conversation-detail-overlay,
.visit-detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1000;
  outline: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.user-detail-overlay.ReactModal__Overlay--after-open,
.venue-detail-overlay.ReactModal__Overlay--after-open,
.conversation-detail-overlay.ReactModal__Overlay--after-open,
.visit-detail-overlay.ReactModal__Overlay--after-open {
  opacity: 1;
  pointer-events: auto;
}
.user-detail-overlay.ReactModal__Overlay--before-close,
.venue-detail-overlay.ReactModal__Overlay--before-close,
.conversation-detail-overlay.ReactModal__Overlay--before-close,
.visit-detail-overlay.ReactModal__Overlay--before-close {
  opacity: 0;
  pointer-events: none;
}

.venue-detail-popup,
.conversation-detail-popup,
.visit-detail-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  background-color: var(--color-background);
  border-radius: 8px;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.2), 0 0 20px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-height: 90vh;
  overflow: auto;
}

.user-detail-popup,
.venue-detail-popup,
.conversation-detail-popup,
.visit-detail-popup {
  max-width: 950px;
  width: 90%;
  animation: fadein 0.3s;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.user-detail-popup.ReactModal__Content--after-open,
.venue-detail-popup.ReactModal__Content--after-open,
.conversation-detail-popup.ReactModal__Content--after-open,
.visit-detail-popup.ReactModal__Content--after-open {
  opacity: 1;
}
.user-detail-popup.ReactModal__Content--before-close,
.venue-detail-popup.ReactModal__Content--before-close,
.conversation-detail-popup.ReactModal__Content--before-close,
.visit-detail-popup.ReactModal__Content--before-close {
  opacity: 0;
}
.user-detail-popup,
.venue-detail-popup,
.conversation-detail-popup,
.visit-detail-popup {
  z-index: 1001;
  outline: none;
}
.user-detail-popup .link,
.venue-detail-popup .link,
.conversation-detail-popup .link,
.visit-detail-popup .link {
  color: #3a5443ff;
  color: var(--color-primary);
  cursor: pointer;
  text-decoration: none;
}
.user-detail-popup .popup-detail-container,
.venue-detail-popup .popup-detail-container,
.conversation-detail-popup .popup-detail-container,
.visit-detail-popup .popup-detail-container {
  max-width: 100%;
  margin: 0 auto;
  outline: none;
}
.user-detail-popup .popup-detail-container .popup-profile-grid,
.venue-detail-popup .popup-detail-container .popup-profile-grid,
.conversation-detail-popup .popup-detail-container .popup-profile-grid,
.visit-detail-popup .popup-detail-container .popup-profile-grid {
  display: grid;
  grid-template-columns: 270px 1fr;
  grid-gap: 20px;
  gap: 20px;
}
.user-detail-popup .popup-detail-container .popup-image-container,
.venue-detail-popup .popup-detail-container .popup-image-container,
.conversation-detail-popup .popup-detail-container .popup-image-container,
.visit-detail-popup .popup-detail-container .popup-image-container {
  display: flex;
  align-items: flex-start;
  height: 320px;
  width: 260px;
}
.user-detail-popup .popup-detail-container .popup-image-container.generic-icon,
.venue-detail-popup .popup-detail-container .popup-image-container.generic-icon,
.conversation-detail-popup .popup-detail-container .popup-image-container.generic-icon,
.visit-detail-popup .popup-detail-container .popup-image-container.generic-icon {
  height: 260px;
  width: 260px;
  border-radius: 260px;
  border: solid 3px #999999;
}
.user-detail-popup .popup-detail-container .popup-image-container .popup-image,
.venue-detail-popup .popup-detail-container .popup-image-container .popup-image,
.conversation-detail-popup .popup-detail-container .popup-image-container .popup-image,
.visit-detail-popup .popup-detail-container .popup-image-container .popup-image {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.user-detail-popup .popup-detail-container .popup-image-container.generic-icon .popup-image,
.venue-detail-popup .popup-detail-container .popup-image-container.generic-icon .popup-image,
.conversation-detail-popup .popup-detail-container .popup-image-container.generic-icon .popup-image,
.visit-detail-popup .popup-detail-container .popup-image-container.generic-icon .popup-image {
  margin-right: 0px !important;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border-width: 3px;
  margin-right: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.user-detail-popup .popup-detail-container .popup-info,
.venue-detail-popup .popup-detail-container .popup-info,
.conversation-detail-popup .popup-detail-container .popup-info,
.visit-detail-popup .popup-detail-container .popup-info {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.user-detail-popup .popup-detail-container .popup-details-grid,
.venue-detail-popup .popup-detail-container .popup-details-grid,
.conversation-detail-popup .popup-detail-container .popup-details-grid,
.visit-detail-popup .popup-detail-container .popup-details-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
  gap: 15px;
}
.user-detail-popup .popup-detail-container .popup-details-column,
.venue-detail-popup .popup-detail-container .popup-details-column,
.conversation-detail-popup .popup-detail-container .popup-details-column,
.visit-detail-popup .popup-detail-container .popup-details-column {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.user-detail-popup .popup-detail-container .popup-details-column .clickable p,
.venue-detail-popup .popup-detail-container .popup-details-column .clickable p,
.conversation-detail-popup .popup-detail-container .popup-details-column .clickable p,
.visit-detail-popup .popup-detail-container .popup-details-column .clickable p {
  cursor: pointer;
  color: #3a5443ff;
  color: var(--color-primary);
  transition: color 0.2s ease;
}
.user-detail-popup .popup-detail-container .popup-details-column .clickable p:hover,
.venue-detail-popup .popup-detail-container .popup-details-column .clickable p:hover,
.conversation-detail-popup .popup-detail-container .popup-details-column .clickable p:hover,
.visit-detail-popup .popup-detail-container .popup-details-column .clickable p:hover {
  color: var(--color-primary-dark);
}
.user-detail-popup .popup-detail-container h2,
.venue-detail-popup .popup-detail-container h2,
.conversation-detail-popup .popup-detail-container h2,
.visit-detail-popup .popup-detail-container h2 {
  margin: 0;
  font-size: 44px;
  font-weight: 200;
}
.user-detail-popup .popup-detail-container .popup-visits-section,
.venue-detail-popup .popup-detail-container .popup-visits-section,
.conversation-detail-popup .popup-detail-container .popup-visits-section,
.visit-detail-popup .popup-detail-container .popup-visits-section {
  margin-top: 30px;
}
.user-detail-popup .popup-detail-container .popup-map-section,
.venue-detail-popup .popup-detail-container .popup-map-section,
.conversation-detail-popup .popup-detail-container .popup-map-section,
.visit-detail-popup .popup-detail-container .popup-map-section {
  margin-top: 30px;
  background-color: var(--color-background-light);
  border-radius: 8px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
}
.user-detail-popup .popup-detail-container .popup-map-section h3,
.venue-detail-popup .popup-detail-container .popup-map-section h3,
.conversation-detail-popup .popup-detail-container .popup-map-section h3,
.visit-detail-popup .popup-detail-container .popup-map-section h3 {
  margin: 0 0 15px 0;
  font-size: 24px;
  font-weight: 600;
}
.user-detail-popup .popup-detail-container .popup-map-section p,
.venue-detail-popup .popup-detail-container .popup-map-section p,
.conversation-detail-popup .popup-detail-container .popup-map-section p,
.visit-detail-popup .popup-detail-container .popup-map-section p {
  margin: 0;
  color: var(--color-text-secondary);
  font-style: italic;
}
.user-detail-popup .popup-detail-container .popup-messages-section,
.venue-detail-popup .popup-detail-container .popup-messages-section,
.conversation-detail-popup .popup-detail-container .popup-messages-section,
.visit-detail-popup .popup-detail-container .popup-messages-section {
  margin-top: 20px;
}
.user-detail-popup .popup-detail-container .popup-messages-section h3,
.venue-detail-popup .popup-detail-container .popup-messages-section h3,
.conversation-detail-popup .popup-detail-container .popup-messages-section h3,
.visit-detail-popup .popup-detail-container .popup-messages-section h3 {
  margin: 0 0 20px 0;
  font-size: 24px;
  font-weight: 600;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 15px;
  background-color: var(--color-background-light);
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble {
  margin-bottom: 15px;
  padding: 15px;
  border-radius: 8px;
  background-color: #ffffff;
  background-color: var(--color-background);
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  max-width: 75%;
  min-width: 200px;
  width: -webkit-fit-content;
  width: fit-content;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.recipient,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.recipient,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.recipient,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.recipient {
  margin-left: auto;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.sender,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.sender,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.sender,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.sender {
  margin-right: auto;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-layout,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-layout,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-layout,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-layout {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info .avatar,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info .avatar,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info .avatar,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info .avatar {
  flex-shrink: 0;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info .full-name div:first-child,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info .full-name div:first-child,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info .full-name div:first-child,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-sender-info .full-name div:first-child {
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: 14px;
  line-height: 1.3;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-content-wrapper,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-content-wrapper,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-content-wrapper,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-content-wrapper {
  flex: 1 1;
  min-width: 0;
  margin-left: 25px;
  margin-top: 5px;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-content,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-content,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-content,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-content {
  font-size: 14px;
  line-height: 1.4;
  color: var(--color-text-primary);
  margin-bottom: 6px;
  word-wrap: break-word;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-timestamp,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-timestamp,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-timestamp,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble .message-timestamp {
  font-size: 11px;
  color: #999999;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.sender .message-timestamp,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.sender .message-timestamp,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.sender .message-timestamp,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.sender .message-timestamp {
  text-align: left;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.recipient .message-sender-info .full-name,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.recipient .message-sender-info .full-name,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.recipient .message-sender-info .full-name,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .message-bubble.recipient .message-sender-info .full-name {
  text-align: right;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .recipient .message-content-wrapper,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .recipient .message-content-wrapper,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .recipient .message-content-wrapper,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .recipient .message-content-wrapper {
  flex: 1 1;
  min-width: 0;
  margin-left: 10px;
  margin-right: 25px;
}
.user-detail-popup .popup-detail-container .popup-messages-section .messages-container .no-messages,
.venue-detail-popup .popup-detail-container .popup-messages-section .messages-container .no-messages,
.conversation-detail-popup .popup-detail-container .popup-messages-section .messages-container .no-messages,
.visit-detail-popup .popup-detail-container .popup-messages-section .messages-container .no-messages {
  text-align: center;
  color: var(--color-text-secondary);
  font-style: italic;
  padding: 40px 20px;
}

.feedback-thread-popup .styled-button {
  margin: 0;
  padding: 8px 16px;
  font-size: 13px;
  box-shadow: none;
  border: 1px solid #3a5443ff;
  border: 1px solid var(--color-primary);
}
.feedback-thread-popup .styled-button.secondary {
  background-color: #ffffff;
  background-color: var(--color-cancel-button-background);
  color: #284f43;
  color: var(--color-cancel-button-label);
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
}
.feedback-thread-popup .styled-button.secondary:hover {
  background-color: #3a5443ff;
  background-color: var(--color-primary);
  color: #ffffff;
  color: var(--color-white);
}
.feedback-thread-popup .feedback-icon-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
}
.feedback-thread-popup .feedback-icon-label .icon {
  font-size: 12px;
  line-height: 1;
}
.feedback-thread-popup .feedback-back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  padding: 0;
  border: none;
  background: none;
  color: #3a5443ff;
  color: var(--color-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.feedback-thread-popup .feedback-back-link .icon {
  font-size: 11px;
}
.feedback-thread-popup .feedback-back-link:hover {
  text-decoration: underline;
}
.feedback-thread-popup .feedback-thread-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 8px;
}
.feedback-thread-popup .feedback-thread-header h2 {
  max-width: 640px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 28px;
}
.feedback-thread-popup .feedback-thread-title {
  min-width: 0;
}
.feedback-thread-popup .feedback-thread-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
}
.feedback-thread-popup .feedback-thread-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.feedback-thread-popup .feedback-status {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.feedback-thread-popup .feedback-status.is-open {
  color: #2e7d32;
}
.feedback-thread-popup .feedback-status.is-closed {
  color: #888888;
}
.feedback-thread-popup .feedback-status.feedback-type-venue-suggestion {
  color: #1a73e8;
}
.feedback-thread-popup .feedback-status.feedback-type-refund {
  color: #b26a00;
}
.feedback-thread-popup .feedback-venue-suggestion-card {
  margin: 12px 0 16px;
  padding: 16px;
  border-radius: 8px;
  background: rgba(26, 115, 232, 0.08);
  border: 1px solid rgba(26, 115, 232, 0.25);
}
.feedback-thread-popup .feedback-venue-suggestion-name {
  font-size: 16px;
  font-weight: 600;
}
.feedback-thread-popup .feedback-venue-suggestion-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 6px;
  font-size: 13px;
  color: var(--color-text-secondary);
}
.feedback-thread-popup .feedback-venue-suggestion-meta a {
  color: #1a73e8;
}
.feedback-thread-popup .feedback-original-post {
  margin: 12px 0 16px;
  padding: 16px;
  border-radius: 8px;
  background: var(--color-background-light);
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
}
.feedback-thread-popup .feedback-original-label {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-text-secondary);
  margin-bottom: 8px;
}
.feedback-thread-popup .feedback-original-body {
  white-space: pre-wrap;
  line-height: 1.45;
}
.feedback-thread-popup .feedback-original-time {
  margin-top: 6px;
  font-size: 11px;
  color: #6c757d;
  color: var(--color-muted);
}
.feedback-thread-popup .feedback-messages {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 420px;
  overflow-y: auto;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  background-color: #f8f8f8;
  background-color: var(--color-disabled-background);
}
.feedback-thread-popup .feedback-messages-empty {
  padding: 24px 0;
  text-align: center;
  font-size: 13px;
  color: #6c757d;
  color: var(--color-muted);
}
.feedback-thread-popup .feedback-message {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  max-width: 75%;
}
.feedback-thread-popup .feedback-message .avatar {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
}
.feedback-thread-popup .feedback-message .avatar .initials {
  font-size: 13px;
}
.feedback-thread-popup .feedback-message.is-admin {
  flex-direction: row-reverse;
  align-self: flex-end;
}
.feedback-thread-popup .feedback-message.is-admin .feedback-message-meta {
  flex-direction: row-reverse;
}
.feedback-thread-popup .feedback-message.is-admin .feedback-message-bubble {
  background-color: #284f4330;
  background-color: var(--color-primary-translucent);
  border-color: transparent;
}
.feedback-thread-popup .feedback-message-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.feedback-thread-popup .feedback-message-meta {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 11px;
  color: #6c757d;
  color: var(--color-muted);
}
.feedback-thread-popup .feedback-message-author {
  font-size: 13px;
  font-weight: 600;
  color: #333333;
  color: var(--color-control);
}
.feedback-thread-popup .feedback-message-bubble {
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  background-color: #ffffff;
  background-color: var(--color-background);
}
.feedback-thread-popup .feedback-message-bubble .feedback-attachments {
  margin-bottom: 0;
}
.feedback-thread-popup .feedback-message-content {
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  color: #333333;
  color: var(--color-control);
}
.feedback-thread-popup .feedback-attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 8px 0 6px;
}
.feedback-thread-popup .feedback-attachments a {
  display: block;
  line-height: 0;
}
.feedback-thread-popup .feedback-attachments img {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
}
.feedback-thread-popup .feedback-attachment-drafts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 12px 0;
}
.feedback-thread-popup .feedback-attachment-draft {
  position: relative;
}
.feedback-thread-popup .feedback-attachment-draft img {
  width: 72px;
  height: 72px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
}
.feedback-thread-popup .feedback-attachment-draft button {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 11px;
  cursor: pointer;
}
.feedback-thread-popup .feedback-attachment-error {
  margin-top: 8px;
  font-size: 13px;
  color: #aa0000;
  color: var(--color-error);
}
.feedback-thread-popup .feedback-composer {
  margin-top: 16px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  background-color: #ffffff;
  background-color: var(--color-control-background);
  transition: border-color 0.2s;
}
.feedback-thread-popup .feedback-composer:focus-within {
  border-color: #3a5443ff;
  border-color: var(--color-primary);
}
.feedback-thread-popup .feedback-composer textarea {
  display: block;
  width: 100%;
  min-height: 72px;
  padding: 12px;
  border: none;
  outline: none;
  background: transparent;
  color: #333333;
  color: var(--color-control);
  font-size: 14px;
  line-height: 1.45;
  resize: vertical;
}
.feedback-thread-popup .feedback-composer-footer {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 8px 8px 12px;
  border-top: 1px solid #dee2e6;
  border-top: 1px solid var(--color-border);
}
.feedback-thread-popup .feedback-attach-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: none;
  color: #6c757d;
  color: var(--color-muted);
  font-size: 15px;
  cursor: pointer;
}
.feedback-thread-popup .feedback-attach-button:hover:not(:disabled) {
  background-color: #f8f8f8;
  background-color: var(--color-disabled-background);
  color: #3a5443ff;
  color: var(--color-primary);
}
.feedback-thread-popup .feedback-attach-button:disabled {
  opacity: 0.4;
  cursor: default;
}
.feedback-thread-popup .feedback-composer-hint {
  margin-right: auto;
  font-size: 11px;
  color: #6c757d;
  color: var(--color-muted);
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
[data-theme=dark] .light-theme-only {
  display: none !important;
}
[data-theme=dark] .dark-theme-only {
  display: block !important;
}
[data-theme=dark] .user-detail-overlay,
[data-theme=dark] .venue-detail-overlay,
[data-theme=dark] .conversation-detail-overlay,
[data-theme=dark] .visit-detail-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
[data-theme=dark] .property-tag {
  border: solid 1px #cccccc;
  background-color: #e0e0e0;
  color: #333333;
}
[data-theme=dark] .property-tag.Active, [data-theme=dark] .property-tag.Resolved, [data-theme=dark] .property-tag.NotFraudulent, [data-theme=dark] .property-tag.Customer, [data-theme=dark] .property-tag.Ready, [data-theme=dark] .property-tag.NotInterested, [data-theme=dark] .property-tag.icon-FileExcel {
  background-color: #a3e4b8;
  border-color: #7ccf8e;
  color: #0b3d1b;
}
[data-theme=dark] .property-tag.OnProbation, [data-theme=dark] .property-tag.Investigating, [data-theme=dark] .property-tag.Running, [data-theme=dark] .property-tag.icon-FileImage {
  background-color: #ffdd99;
  border-color: #ffcc66;
  color: #664400;
}
[data-theme=dark] .property-tag.Terminated, [data-theme=dark] .property-tag.Tombstoned, [data-theme=dark] .property-tag.Fraudulent, [data-theme=dark] .property-tag.Error, [data-theme=dark] .property-tag.TimedOut, [data-theme=dark] .property-tag.icon-FilePdf, [data-theme=dark] .property-tag.Reported {
  background-color: #d09599;
  border-color: #f08085;
  color: #4a0d12;
}
[data-theme=dark] .property-tag.Orange, [data-theme=dark] .property-tag.Support, [data-theme=dark] .property-tag.icon-FileVideo {
  background-color: #ffb366;
  border-color: #ff9933;
  color: #663300;
}
[data-theme=dark] .property-tag.Adjudicated, [data-theme=dark] .property-tag.Investigator {
  background-color: #b7b1cc;
  border-color: #9966ff;
  color: #330066;
}
[data-theme=dark] .property-tag.Administrator, [data-theme=dark] .property-tag.icon-FileWord {
  background-color: #99ccff;
  border-color: #66b2ff;
  color: #003366;
}

.idle-warning-toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #3a5443ff;
  background-color: var(--color-primary);
  color: #ffffff;
  color: var(--color-button-label);
  padding: 1rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  animation: slideDown 0.3s ease-out;
  opacity: 1;
  transition: opacity 0.3s ease-out;
  text-align: center;
  width: 580px;
  padding-left: 25px;
}
.idle-warning-toast.fading-out {
  opacity: 0;
}
.idle-warning-toast .toast-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-align: center;
}
.idle-warning-toast .toast-content .icon {
  font-size: 1.2rem;
}
.idle-warning-toast .toast-content span {
  color: #ffffff;
  color: var(--color-white);
}

.idle-countdown {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 100px;
  padding: 4px 8px;
  border-radius: 12px;
  background-color: #3a5443ff;
  background-color: var(--color-primary);
  color: #ffffff;
  color: var(--color-button-label);
  font-size: 12px;
  line-height: 1;
  transition: opacity 0.3s ease-out;
}
.idle-countdown.fading-out {
  opacity: 0;
}
.idle-countdown .icon {
  font-size: 12px;
}

@keyframes slideDown {
  from {
    transform: translate(-50%, -100%);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}
.location-view-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  outline: none;
}

.location-view-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  background-color: var(--color-white);
  border-radius: 8px;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.2), 0 0 20px 0 rgba(0, 0, 0, 0.1);
  outline: none;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1002;
  outline: none;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem 0.5rem;
}

.visit-map-popup {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  background-color: var(--color-white);
  border-radius: 8px;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.2), 0 0 20px 0 rgba(0, 0, 0, 0.1);
  z-index: 1003;
  outline: none;
}
.visit-map-popup .visit-map-popup-content {
  padding: 20px;
  width: 80vw;
  height: 80vh;
  display: flex;
  flex-direction: column;
}
.visit-map-popup .visit-map-popup-map-container {
  flex: 1 1;
  border-radius: 8px;
  overflow: hidden;
  min-height: 0;
}
.visit-map-popup .visit-map-popup-map-container > div {
  height: 100% !important;
  border-radius: 8px;
}

.property-bar {
  padding: 23px 40px 20px 40px;
  top: 2px;
  right: 0;
  overflow-y: auto;
  left: auto !important;
  left: initial !important;
  background-color: #f4f4f4 !important;
  background-color: var(--color-nav-bar-background) !important;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.75);
  -webkit-clip-path: inset(0px 0px 0px -12px);
          clip-path: inset(0px 0px 0px -12px);
  width: 500px !important;
  right: -500px;
  color: #555555;
  color: var(--color-black);
  position: fixed;
  transition: 0.3s all;
  height: 100%;
  z-index: 1000000;
}
.property-bar select {
  background-color: #fff !important;
}
.property-bar.opened {
  right: 0;
}
.property-bar .collapse-button {
  position: absolute;
  top: 27px;
  right: 40px;
  cursor: pointer;
  z-index: 999;
  transition: 0.3s;
}
.property-bar.collapsed {
  right: -500px;
  box-shadow: none;
}
.property-bar .input-container {
  margin: 0 0 10px 0;
  overflow: hidden;
}
.property-bar .input-container label {
  font-size: 20px;
}
.property-bar .input-container input,
.property-bar .input-container textarea,
.property-bar .input-container select {
  font-size: 19px;
}
.property-bar .input-container:focus-within label {
  background-color: transparent;
  background-color: initial;
  xtransform: translate(-8px, 7px) scale(0.7);
}
.property-bar .input-container:focus-within label.filled {
  xtransform: translate(-8px, 7px) scale(0.7);
}
.property-bar .input-container:focus-within label input,
.property-bar .input-container:focus-within label select {
  height: 48px;
  padding: 4px 10px 0px 12px;
  font-size: 16px;
}
.property-bar .caption {
  padding: 0;
  font-weight: 300;
  font-size: 27px;
  padding-bottom: 20px;
}
.property-bar .caption .icon {
  font-weight: 400;
  font-size: 20px;
  padding-left: 10px;
  position: relative;
  top: -2px;
  transition: all 0.2s;
  cursor: pointer;
}
.property-bar .caption a .icon,
.property-bar .caption a:visited .icon {
  color: #555555;
  color: var(--color-black);
}
.property-bar .caption a:hover .icon {
  color: #3a5443ff;
  color: var(--color-primary);
}
.property-bar .property-bar-field-group {
  margin: 20px 0 8px;
  padding: 16px 18px 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.55);
}
.property-bar .property-bar-field-group__title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px;
  color: #555555;
  color: var(--color-black);
}
.property-bar .property-bar-field-group__description {
  margin: 0 0 14px;
  font-size: 14px;
  line-height: 1.45;
  color: rgba(0, 0, 0, 0.68);
}
.property-bar .property-bar-field-group .input-container:last-child {
  margin-bottom: 0;
}
.property-bar .property-bar-field-group .admin-central-datetime-field {
  margin-bottom: 16px;
}
.property-bar .property-bar-field-group .admin-central-datetime-field:last-child {
  margin-bottom: 0;
}
.property-bar .venue-special-external-link .styled-button {
  width: auto;
  margin-bottom: 12px;
}
.property-bar .buttons {
  margin-top: 30px;
}
.property-bar .styled-button {
  color: #ffffff;
  color: var(--color-button-label);
  background-color: #284f43;
  background-color: var(--color-button-background);
  padding: 1em 2.4em;
  width: 100%;
}
.property-bar .styled-button:hover {
  background-color: #ffffff;
  color: #3a5443ff;
  color: var(--color-primary);
}
.property-bar .styled-button.cancel {
  background-color: #ffffff;
  background-color: var(--color-cancel-button-background);
  color: #284f43;
  color: var(--color-cancel-button-label);
  padding: 1em 2.4em;
  width: 100%;
}
.property-bar .styled-button.cancel:hover {
  background-color: #3a5443ff;
  background-color: var(--color-primary);
  color: #ffffff;
  color: var(--color-white);
}

.ReactModal__Overlay {
  opacity: 0;
  transition: opacity 300ms ease-in-out;
}

.ReactModal__Overlay--after-open {
  opacity: 1;
}

.ReactModal__Overlay--before-close {
  opacity: 0;
}

.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.header-row .styled-button {
  font-size: 13px;
  padding: 10px 12px;
}

.modal-popup {
  position: relative;
  background: #ffffff;
  background: var(--color-background);
  border-radius: 8px;
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.2), 0 0 20px 0 rgba(0, 0, 0, 0.1);
  z-index: 1200;
  outline: none;
  margin: auto;
}

.modal-content-wrapper {
  display: flex;
  position: relative;
  padding: 24px;
  border-radius: 8px;
  flex-direction: column;
  gap: 1rem;
  overflow: hidden;
}
.modal-content-wrapper h2 {
  margin-top: 0;
  font-weight: 200;
  margin-bottom: 0;
}
.modal-content-wrapper .modal-body-content {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 1rem;
}
.modal-content-wrapper .modal-footer-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
}
.modal-content-wrapper .styled-button {
  margin: 0;
  padding: 8px 16px;
  font-size: 14px;
}
.modal-content-wrapper .loader-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(107, 107, 107, 0.226);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  z-index: 5;
}
.modal-content-wrapper .loader-wrapper .loader {
  width: 10rem;
  height: 10rem;
}

.add-venue-popup,
.blast-popup {
  width: 100%;
  max-width: 500px;
}

.add-venue-popup {
  max-width: min(1100px, 96vw);
  max-height: 92vh;
}

.confirm-popup {
  width: 100%;
  max-width: 500px;
}

.blast-modal-content .form-group .date-group {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.blast-modal-content .form-group .date-group .input-container input,
.blast-modal-content .form-group .date-group .input-container select {
  height: 45px;
}
.blast-modal-content .form-group .date-group .input-container label {
  display: none;
}
.blast-modal-content .form-group .date-group .input-container .time-date {
  flex: 0 0 190px !important;
}

.venue-add-popup-content,
.logo-content-wrapper,
.user-detail-page,
.notifications-page,
.modal-content-wrapper,
.blast-modal-content {
  display: flex;
  flex-direction: column;
}
.venue-add-popup-content .form-group,
.logo-content-wrapper .form-group,
.user-detail-page .form-group,
.notifications-page .form-group,
.modal-content-wrapper .form-group,
.blast-modal-content .form-group {
  display: flex;
  flex-direction: column;
}
.venue-add-popup-content .form-group label,
.logo-content-wrapper .form-group label,
.user-detail-page .form-group label,
.notifications-page .form-group label,
.modal-content-wrapper .form-group label,
.blast-modal-content .form-group label {
  font-weight: 600;
  margin-bottom: 4px;
}
.venue-add-popup-content .form-group textarea,
.venue-add-popup-content .form-group input,
.venue-add-popup-content .form-group select,
.logo-content-wrapper .form-group textarea,
.logo-content-wrapper .form-group input,
.logo-content-wrapper .form-group select,
.user-detail-page .form-group textarea,
.user-detail-page .form-group input,
.user-detail-page .form-group select,
.notifications-page .form-group textarea,
.notifications-page .form-group input,
.notifications-page .form-group select,
.modal-content-wrapper .form-group textarea,
.modal-content-wrapper .form-group input,
.modal-content-wrapper .form-group select,
.blast-modal-content .form-group textarea,
.blast-modal-content .form-group input,
.blast-modal-content .form-group select {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  resize: none;
}
.venue-add-popup-content .form-group textarea:disabled,
.venue-add-popup-content .form-group input:disabled,
.venue-add-popup-content .form-group select:disabled,
.logo-content-wrapper .form-group textarea:disabled,
.logo-content-wrapper .form-group input:disabled,
.logo-content-wrapper .form-group select:disabled,
.user-detail-page .form-group textarea:disabled,
.user-detail-page .form-group input:disabled,
.user-detail-page .form-group select:disabled,
.notifications-page .form-group textarea:disabled,
.notifications-page .form-group input:disabled,
.notifications-page .form-group select:disabled,
.modal-content-wrapper .form-group textarea:disabled,
.modal-content-wrapper .form-group input:disabled,
.modal-content-wrapper .form-group select:disabled,
.blast-modal-content .form-group textarea:disabled,
.blast-modal-content .form-group input:disabled,
.blast-modal-content .form-group select:disabled {
  opacity: 0.7;
  background-color: #cccccc;
  background-color: var(--color-light-gray);
}
.venue-add-popup-content .form-group select,
.logo-content-wrapper .form-group select,
.user-detail-page .form-group select,
.notifications-page .form-group select,
.modal-content-wrapper .form-group select,
.blast-modal-content .form-group select {
  background-color: #ffffff;
  background-color: var(--color-background);
  color: #333333;
  color: var(--color-control);
}
.venue-add-popup-content .form-group input[type=number],
.logo-content-wrapper .form-group input[type=number],
.user-detail-page .form-group input[type=number],
.notifications-page .form-group input[type=number],
.modal-content-wrapper .form-group input[type=number],
.blast-modal-content .form-group input[type=number] {
  -moz-appearance: textfield;
}
.venue-add-popup-content .form-group input[type=number]::-webkit-outer-spin-button,
.venue-add-popup-content .form-group input[type=number]::-webkit-inner-spin-button,
.logo-content-wrapper .form-group input[type=number]::-webkit-outer-spin-button,
.logo-content-wrapper .form-group input[type=number]::-webkit-inner-spin-button,
.user-detail-page .form-group input[type=number]::-webkit-outer-spin-button,
.user-detail-page .form-group input[type=number]::-webkit-inner-spin-button,
.notifications-page .form-group input[type=number]::-webkit-outer-spin-button,
.notifications-page .form-group input[type=number]::-webkit-inner-spin-button,
.modal-content-wrapper .form-group input[type=number]::-webkit-outer-spin-button,
.modal-content-wrapper .form-group input[type=number]::-webkit-inner-spin-button,
.blast-modal-content .form-group input[type=number]::-webkit-outer-spin-button,
.blast-modal-content .form-group input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.venue-add-popup-content .recipient-count,
.logo-content-wrapper .recipient-count,
.user-detail-page .recipient-count,
.notifications-page .recipient-count,
.modal-content-wrapper .recipient-count,
.blast-modal-content .recipient-count {
  position: relative;
  top: 5px;
  font-size: 14px;
  font-weight: 300;
  color: var(--color-text-secondary);
}
.venue-add-popup-content .back-button,
.logo-content-wrapper .back-button,
.user-detail-page .back-button,
.notifications-page .back-button,
.modal-content-wrapper .back-button,
.blast-modal-content .back-button {
  background: none;
  border: none;
  color: #3a5443ff;
  color: var(--color-primary);
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 12px;
  padding: 0;
}
.venue-add-popup-content .styled-button:disabled,
.logo-content-wrapper .styled-button:disabled,
.user-detail-page .styled-button:disabled,
.notifications-page .styled-button:disabled,
.modal-content-wrapper .styled-button:disabled,
.blast-modal-content .styled-button:disabled {
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-light-line);
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  -webkit-user-select: none;
          user-select: none;
  width: -webkit-fit-content;
  width: fit-content;
  position: relative;
}
.toggle .toggle-input {
  position: absolute;
  opacity: 0;
  width: 100%;
  left: 0;
  bottom: 0;
  height: 100%;
  z-index: 2;
  cursor: pointer;
}
.toggle .toggle-slider {
  position: relative;
  width: 48px;
  height: 28px;
  background: #284f4330;
  background: var(--color-primary-translucent);
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-light-line);
  border-radius: 999px;
  transition: background 0.2s ease;
  top: 1px;
}
.toggle .toggle-slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 22px;
  height: 22px;
  background: #ffffff;
  background: var(--color-white);
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-light-line);
  border-radius: 50%;
  transition: transform 0.2s ease;
}
.toggle .toggle-input:checked + .toggle-slider {
  background: #3a5443ff;
  background: var(--color-primary);
  border-color: #3a5443ff;
  border-color: var(--color-primary);
}
.toggle .toggle-input:checked + .toggle-slider::after {
  transform: translateX(20px);
  border-color: #3a5443ff;
  border-color: var(--color-primary);
}
.toggle .toggle-label {
  font-weight: 500;
  color: #555555;
  color: var(--color-black);
}

.datetime-picker .picker-content-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}
.datetime-picker .picker-content-wrapper .date-picker {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
.datetime-picker .picker-content-wrapper .date-picker-icon-wrapper {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.admin-central-datetime-field__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}
.admin-central-datetime-field__label {
  font-size: 15px;
  font-weight: 600;
  color: #555555;
  color: var(--color-black);
}
.admin-central-datetime-field__clear {
  border: none;
  background: transparent;
  color: #3a5443ff;
  color: var(--color-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}
.admin-central-datetime-field__controls {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.admin-central-datetime-field__date {
  width: 100%;
  height: 44px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  padding: 0 12px;
  font-size: 16px;
  background: #fff;
  color: #555555;
  color: var(--color-black);
}
.admin-central-datetime-field__time {
  display: grid;
  grid-template-columns: 1fr auto 1fr 1.1fr;
  grid-gap: 8px;
  gap: 8px;
  align-items: center;
}
.admin-central-datetime-field__select {
  width: 100%;
  height: 44px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  padding: 0 10px;
  font-size: 16px;
  background: #fff;
  color: #555555;
  color: var(--color-black);
}
.admin-central-datetime-field__separator {
  font-size: 18px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.55);
  text-align: center;
}
.admin-central-datetime-field__preview, .admin-central-datetime-field__hint {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.4;
}
.admin-central-datetime-field__preview {
  color: rgba(0, 0, 0, 0.78);
  font-weight: 500;
}
.admin-central-datetime-field__hint {
  color: rgba(0, 0, 0, 0.5);
}

.admin-event-date-ranges-field__notice {
  background: #284f4330;
  background: var(--color-primary-translucent);
  border: 1px solid #3a5443ff;
  border: 1px solid var(--color-primary);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #555555;
  color: var(--color-black);
  margin-bottom: 14px;
}
.admin-event-date-ranges-field__notice strong {
  color: #3a5443ff;
  color: var(--color-primary);
}
.admin-event-date-ranges-field__row {
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 14px;
}
.admin-event-date-ranges-field__row-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}
.admin-event-date-ranges-field__row-title {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #3a5443ff;
  color: var(--color-primary);
}
.admin-event-date-ranges-field__add {
  margin-top: 4px;
}
.admin-event-date-ranges-field__warning {
  background: #ffeeee;
  background: var(--color-error-background);
  border: 1px solid #aa0000;
  border: 1px solid var(--color-error);
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #aa0000;
  color: var(--color-error);
  margin-top: 10px;
}

.admin-date-range-row {
  min-width: 0;
  max-width: 100%;
}
.admin-date-range-row__calendar-header {
  display: flex;
  justify-content: flex-end;
  min-height: 18px;
  margin-bottom: 4px;
}
.admin-date-range-row__clear-link {
  border: none;
  background: transparent;
  color: #3a5443ff;
  color: var(--color-primary);
  font-size: 13px;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
}
.admin-date-range-row__calendar {
  display: flex;
  justify-content: center;
  background: #ffffff;
  background: var(--color-background);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 4px;
  margin-bottom: 12px;
  max-width: 100%;
  overflow-x: auto;
}
.admin-date-range-row__calendar .rdp-root {
  --rdp-accent-color: var(--color-primary);
  --rdp-accent-background-color: var(--color-primary-translucent);
  --rdp-today-color: var(--color-primary);
  --rdp-range_middle-background-color: var(--color-primary-translucent);
  --rdp-range_middle-color: var(--color-black);
  color: #555555;
  color: var(--color-black);
  margin: 0;
}
.admin-date-range-row__times {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}
.admin-date-range-row__time-line {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.admin-date-range-row__time-label {
  flex: 0 0 90px;
  font-size: 14px;
  font-weight: 600;
  color: #555555;
  color: var(--color-black);
}
.admin-date-range-row__time-select {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) minmax(0, 1.1fr);
  grid-gap: 8px;
  gap: 8px;
  align-items: center;
  flex: 1 1;
  min-width: 0;
}
.admin-date-range-row__preview {
  margin: 10px 0 0;
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.78);
}

.venue-detail-event-rsvps__toolbar {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
}
.venue-detail-event-rsvps__toolbar select {
  max-width: 360px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  background: #fff;
}
.venue-detail-event-rsvps__toolbar .styled-button {
  width: auto;
  white-space: nowrap;
}

.event-rsvp-blast-popup .event-rsvp-blast-counter {
  float: right;
  font-weight: 400;
  opacity: 0.6;
}
.event-rsvp-blast-popup .event-rsvp-blast-preview {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 12px 0;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.05);
}
.event-rsvp-blast-popup .event-rsvp-blast-note {
  font-size: 13px;
  opacity: 0.7;
}
.event-rsvp-blast-popup .event-rsvp-blast-warning {
  margin-top: 6px;
  font-size: 13px;
  color: #b45309;
}
.event-rsvp-blast-popup .modal-footer-content {
  gap: 12px;
}

.venue-special-popup {
  width: 100%;
  max-width: 680px;
  max-height: 92vh;
  box-sizing: border-box;
  overflow-x: hidden;
}

.venue-special-popup-content {
  max-height: 92vh;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}
.venue-special-popup-content * {
  min-width: 0;
}
.venue-special-popup-content .modal-body-content {
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}
.venue-special-popup-content h2 {
  margin-bottom: 4px;
}
.venue-special-popup-content .property-bar-field-group {
  margin: 20px 0 8px;
  padding: 16px 18px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.02);
}
.venue-special-popup-content .property-bar-field-group__title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 8px;
  color: #555555;
  color: var(--color-black);
}
.venue-special-popup-content .property-bar-field-group__description {
  margin: 0 0 14px;
  font-size: 14px;
  line-height: 1.45;
  color: rgba(0, 0, 0, 0.68);
}
.venue-special-popup-content .venue-special-external-link .styled-button {
  width: auto;
}
.venue-special-popup-content .eventbrite-import-row {
  display: flex;
  gap: 10px;
  align-items: stretch;
}
.venue-special-popup-content .eventbrite-import-row input {
  flex: 1 1;
  height: 40px;
  padding: 0 12px;
  font-size: 14px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
}
.venue-special-popup-content .eventbrite-import-row input:focus {
  outline: none;
  border-color: #284f43;
  border-color: var(--color-button-background);
}
.venue-special-popup-content .eventbrite-import-row .styled-button {
  width: auto;
  height: 40px;
  padding: 0 20px;
  white-space: nowrap;
}
.venue-special-popup-content .eventbrite-event-picker {
  width: 100%;
  height: 40px;
  margin: 4px 0 10px;
  padding: 0 10px;
  font-size: 14px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
}
.venue-special-popup-content .eventbrite-event-picker:focus {
  outline: none;
  border-color: #284f43;
  border-color: var(--color-button-background);
}
.venue-special-popup-content .eventbrite-event-picker__error {
  margin: -4px 0 10px;
  font-size: 13px;
  color: #c0392b;
}
.venue-special-popup-content .eventbrite-import-summary {
  margin-top: 12px;
  font-size: 14px;
  line-height: 1.45;
}
.venue-special-popup-content .eventbrite-import-summary p {
  margin: 0 0 4px;
}
.venue-special-popup-content .eventbrite-import-summary .styled-button {
  width: auto;
  margin-top: 8px;
}

.pagination-container {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  padding: 0;
}
.pagination-container .pagination-info {
  color: #666;
  font-size: 14px;
  white-space: nowrap;
  margin-right: 10px;
}
.pagination-container .pagination-button {
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.2), 0 0 20px 0 rgba(0, 0, 0, 0.1);
  border: none;
  padding: 8px 16px;
  text-decoration: none;
  text-align: center;
  font-weight: 600;
  transition: all 0.2s ease-in;
  cursor: pointer;
  outline: none;
  font-size: 13px;
  white-space: nowrap;
  width: 90px;
  min-width: 90px;
  color: #ffffff;
  color: var(--color-white);
  background-color: #3a5443ff;
  background-color: var(--color-primary);
}
.pagination-container .pagination-button:hover:not(:disabled) {
  background-color: #ffffff;
  background-color: var(--color-white);
  color: #3a5443ff;
  color: var(--color-primary);
}
.pagination-container .pagination-button.previous {
  color: #3a5443ff;
  color: var(--color-primary);
  background-color: #ffffff;
  background-color: var(--color-white);
}
.pagination-container .pagination-button.previous:hover:not(:disabled) {
  background-color: #3a5443ff;
  background-color: var(--color-primary);
  color: #ffffff;
  color: var(--color-white);
}
.pagination-container .pagination-button:disabled {
  color: #aaaaaa !important;
  color: var(--color-gray) !important;
  background-color: var(--color-disabled-button);
  box-shadow: none !important;
  cursor: not-allowed;
}

.users-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0;
}
.users-header h2 {
  margin: 0;
}

.venues-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.venues-container .venues-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}
.venues-container .venues-header h2 {
  margin: 0;
}
.venues-container .venues-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
}

.feature-flags-page .feature-flag-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.feature-flags-page .feature-flag-row-top {
  align-items: flex-start;
}
.feature-flags-page .app-feature-toggle-row {
  padding: 12px 0;
  border-top: 1px solid #dee2e6;
  border-top: 1px solid var(--color-border);
}
.feature-flags-page .feature-flag-save-sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 16px;
  align-self: flex-start;
  flex-shrink: 0;
  z-index: 2;
}
.feature-flags-page .feature-flag-grow {
  flex: 1 1;
  min-width: 0;
}
.feature-flags-page .feature-flag-title {
  font-weight: 600;
}
.feature-flags-page .feature-flag-subtitle {
  opacity: 0.8;
  font-size: 13px;
}
.feature-flags-page .feature-flag-subtitle-spaced {
  margin-bottom: 8px;
}
.feature-flags-page .feature-flag-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.feature-flags-page .feature-flag-card-spaced {
  margin-top: 12px;
}
.feature-flags-page .feature-flag-textarea {
  width: 100%;
  min-height: 72px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  resize: vertical;
  font-family: inherit;
  font-size: 14px;
}
.feature-flags-page .feature-flag-textarea:disabled {
  opacity: 0.6;
}
.feature-flags-page .feature-flag-checkbox-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  margin-bottom: 8px;
  cursor: pointer;
}
.feature-flags-page .map-filters-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  margin-top: 8px;
}
.feature-flags-page .map-filters-table th,
.feature-flags-page .map-filters-table td {
  padding: 8px 6px;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #e5e5e5;
  border-bottom: 1px solid var(--border-color, #e5e5e5);
}
.feature-flags-page .map-filters-table th {
  font-weight: 600;
  opacity: 0.85;
}
.feature-flags-page .map-filter-input {
  width: 100%;
  min-width: 80px;
  padding: 6px 8px;
  font-size: 13px;
  border: 1px solid #ccc;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 4px;
}
.feature-flags-page .venue-type-emoji-input {
  min-width: 0;
  width: 56px;
  text-align: center;
  font-size: 16px;
}
.feature-flags-page .ticker-setting-label {
  font-size: 13px;
  font-weight: 600;
}
.feature-flags-page .ticker-setting-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 4px 0 16px;
  max-width: 360px;
}
.feature-flags-page .ticker-setting-count-input {
  width: 120px;
}
.feature-flags-page .ticker-setting-error {
  color: #c00;
  color: var(--error-color, #c00);
  margin-top: -8px;
  margin-bottom: 12px;
}
.feature-flags-page .feature-flag-deprecated-notice {
  background: #fff8e6;
  border: 1px solid #f0c96b;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #8a6416;
}
.feature-flags-page .ticker-setting-block {
  margin-top: 4px;
}
.feature-flags-page .ticker-settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 12px 24px;
  gap: 12px 24px;
  margin-bottom: 8px;
}
.feature-flags-page .spotlight-current-venue-settings {
  margin-top: 4px;
}
.feature-flags-page .spotlight-eligibility-editor {
  margin-top: 4px;
}
.feature-flags-page .spotlight-eligibility-table {
  margin-top: 8px;
}
.feature-flags-page .spotlight-eligibility-table input[type=checkbox] {
  width: 16px;
  height: 16px;
}
.feature-flags-page .spotlight-eligibility-min-input {
  width: 88px;
}
.feature-flags-page .spotlight-eligibility-na {
  opacity: 0.5;
}
.feature-flags-page .spotlight-sort-table {
  margin-top: 8px;
}
.feature-flags-page .spotlight-ticker-guide {
  margin: 12px 0 20px;
  padding: 16px;
  border: 1px solid #e5e5e5;
  border: 1px solid var(--border-color, #e5e5e5);
  border-radius: 8px;
  background: #fafafa;
  background: var(--surface-muted, #fafafa);
  font-size: 13px;
}
.feature-flags-page .spotlight-ticker-guide p {
  margin: 0 0 12px;
  line-height: 1.5;
}
.feature-flags-page .spotlight-ticker-guide code {
  font-size: 12px;
}
.feature-flags-page .spotlight-ticker-guide__pipeline {
  margin: 0;
  padding-left: 20px;
  line-height: 1.55;
}
.feature-flags-page .spotlight-ticker-guide__pipeline li + li {
  margin-top: 6px;
}
.feature-flags-page .spotlight-ticker-guide__details {
  margin-top: 16px;
}
.feature-flags-page .spotlight-ticker-guide__details summary {
  cursor: pointer;
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
}
.feature-flags-page .spotlight-ticker-guide__glossary {
  margin: 12px 0 0;
}
.feature-flags-page .spotlight-ticker-guide__glossary dt {
  font-weight: 600;
  margin-top: 12px;
}
.feature-flags-page .spotlight-ticker-guide__glossary dt:first-child {
  margin-top: 0;
}
.feature-flags-page .spotlight-ticker-guide__glossary dd {
  margin: 4px 0 0;
  opacity: 0.85;
  line-height: 1.5;
}
.feature-flags-page .spotlight-ticker-preview {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e5e5e5;
  border-top: 1px solid var(--border-color, #e5e5e5);
}
.feature-flags-page .spotlight-ticker-preview__header {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px 16px;
  margin-bottom: 10px;
}
.feature-flags-page .spotlight-ticker-preview__label {
  font-weight: 600;
}
.feature-flags-page .spotlight-ticker-preview__hint {
  font-size: 12px;
  opacity: 0.7;
}
.feature-flags-page .spotlight-ticker-preview__frame {
  position: relative;
  max-width: 420px;
  border-radius: 20px;
  overflow: hidden;
  border: 2px solid #333;
  background: #e8ece9;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
.feature-flags-page .spotlight-ticker-preview__map {
  height: 120px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.15), transparent), repeating-linear-gradient(45deg, #c5d4c8 0, #c5d4c8 8px, #b8c9bb 8px, #b8c9bb 16px);
}
.feature-flags-page .spotlight-ticker-preview__cards {
  display: flex;
  gap: 10px;
  padding: 10px 12px 14px;
  overflow-x: auto;
  background: rgba(255, 255, 255, 0.55);
}
.feature-flags-page .spotlight-ticker-preview__card {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 168px;
  padding: 8px 10px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
  overflow: visible;
}
.feature-flags-page .spotlight-ticker-preview__card--pinned {
  outline: 2px solid #3a5443ff;
  outline: 2px solid var(--color-primary, #3a5443);
}
.feature-flags-page .spotlight-ticker-preview__card-body {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}
.feature-flags-page .spotlight-ticker-preview__card-name {
  font-weight: 700;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.feature-flags-page .spotlight-ticker-preview__card-subtitle {
  font-size: 11px;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.feature-flags-page .spotlight-ticker-preview__pin-badge {
  position: absolute;
  top: -6px;
  right: 6px;
  padding: 1px 5px;
  border-radius: 4px;
  background: #3a5443ff;
  background: var(--color-primary, #3a5443);
  color: #fff;
  font-size: 9px;
  font-weight: 600;
  white-space: nowrap;
}
.feature-flags-page .spotlight-ticker-preview__caption {
  margin: 10px 0 0;
  font-size: 12px;
  opacity: 0.8;
  line-height: 1.45;
  max-width: 520px;
}
.feature-flags-page .ticker-checkbox-field {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 12px 0;
  font-size: 13px;
  cursor: pointer;
}
.feature-flags-page .ticker-checkbox-field input[type=checkbox] {
  width: 16px;
  height: 16px;
  margin: 2px 0 0;
  flex-shrink: 0;
}
.feature-flags-page .ticker-checkbox-field__text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.feature-flags-page .ticker-checkbox-field__label {
  font-weight: 500;
}
.feature-flags-page .ticker-checkbox-field__help {
  line-height: 1.45;
}
.feature-flags-page .map-filter-drag-header {
  width: 72px;
}
.feature-flags-page .map-filter-drag-cell {
  width: 72px;
  white-space: nowrap;
}
.feature-flags-page .map-filter-drag-handle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  color: inherit;
  cursor: grab;
  touch-action: none;
}
.feature-flags-page .map-filter-drag-handle:hover {
  background: rgba(0, 0, 0, 0.04);
  background: var(--hover-bg, rgba(0, 0, 0, 0.04));
  border-color: #e5e5e5;
  border-color: var(--border-color, #e5e5e5);
}
.feature-flags-page .map-filter-drag-handle:active {
  cursor: grabbing;
}
.feature-flags-page .map-filter-drag-handle:focus-visible {
  outline: 2px solid #2270dd;
  outline: 2px solid var(--focus-color, #2270dd);
  outline-offset: 1px;
}
.feature-flags-page .map-filter-drag-icon {
  opacity: 0.55;
  font-size: 14px;
}
.feature-flags-page .map-filter-position-label {
  min-width: 14px;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  opacity: 0.75;
}
.feature-flags-page .map-filter-row-dragging {
  opacity: 0.35;
}
.feature-flags-page .map-filters-table-overlay {
  width: 100%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  background: #fff;
  background: var(--card-bg, #fff);
  table-layout: fixed;
}
.feature-flags-page .map-filter-row-overlay {
  background: #fff;
  background: var(--card-bg, #fff);
}
.feature-flags-page .map-filter-row-overlay td {
  border-bottom: none;
}
.feature-flags-page .map-filter-hex {
  max-width: 88px;
  margin-left: 6px;
}
.feature-flags-page .map-filter-payload {
  min-width: 120px;
  font-family: monospace;
}
.feature-flags-page .map-filter-color {
  width: 36px;
  height: 32px;
  padding: 0;
  border: none;
  vertical-align: middle;
  cursor: pointer;
}
.feature-flags-page .map-filter-select {
  padding: 6px 8px;
  font-size: 13px;
  border: 1px solid #ccc;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 4px;
}

.user-detail-page,
.venue-detail-page {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.venue-add-popup-content .add-venue-header {
  width: 100%;
}
.venue-add-popup-content .add-venue-header h2 {
  margin-bottom: 0.25rem;
}
.venue-add-popup-content .add-venue-subtitle {
  opacity: 0.75;
  font-size: 0.9rem;
  margin: 0 0 0.5rem;
}
.venue-add-popup-content .add-venue-layout {
  width: 100%;
  display: grid;
  grid-template-columns: 1.15fr 0.85fr;
  grid-gap: 1rem;
  gap: 1rem;
  align-items: start;
  max-height: calc(92vh - 120px);
  overflow: hidden;
}
.venue-add-popup-content .add-venue-search-pane,
.venue-add-popup-content .add-venue-form-pane {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  min-height: 0;
}
.venue-add-popup-content .add-venue-search-pane {
  overflow: hidden;
}
.venue-add-popup-content .add-venue-map {
  width: 100%;
  height: 260px;
  border-radius: 10px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.06);
}
.venue-add-popup-content .add-venue-map-fallback {
  font-size: 0.85rem;
  opacity: 0.75;
}
.venue-add-popup-content .add-venue-search-controls {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.venue-add-popup-content .add-venue-search-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.venue-add-popup-content .add-venue-hint {
  margin: 0;
  font-size: 0.8rem;
  opacity: 0.7;
}
.venue-add-popup-content .add-venue-source-errors,
.venue-add-popup-content .add-venue-error,
.venue-add-popup-content .add-venue-empty {
  font-size: 0.85rem;
  opacity: 0.85;
}
.venue-add-popup-content .add-venue-error {
  color: #f0a0a0;
}
.venue-add-popup-content .add-venue-source-ids {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.75rem;
  opacity: 0.65;
  word-break: break-all;
}
.venue-add-popup-content .add-venue-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.venue-add-popup-content .form-group {
  width: 100%;
}
.venue-add-popup-content .form-group select {
  width: 100%;
  height: 45px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(0, 0, 0, 0.25);
  color: inherit;
  padding: 0 0.75rem;
}
.venue-add-popup-content .modal-body-content {
  flex-grow: 1;
  gap: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.venue-add-popup-content .modal-body-content .search-input {
  width: 100%;
}
.venue-add-popup-content .modal-body-content .location-inputs {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.5rem;
  gap: 0.5rem;
}
.venue-add-popup-content .location-inputs {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.5rem;
  gap: 0.5rem;
}
.venue-add-popup-content .external-venues-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  padding-top: 0.2rem;
  width: 100%;
  max-height: 220px;
  overflow: auto;
}
.venue-add-popup-content .external-venues-list .external-venue-wrapper {
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0.12);
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  gap: 0.2rem;
  padding: 0.4rem;
}
.venue-add-popup-content .external-venues-list .external-venue-wrapper.selected {
  border-color: rgba(90, 138, 124, 0.8);
}
.venue-add-popup-content .external-venues-list .external-venue-wrapper.already-exists {
  opacity: 0.65;
}
.venue-add-popup-content .external-venues-list .external-venue-wrapper .venue-info {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.venue-add-popup-content .external-venues-list .external-venue-wrapper .venue-info .venue-logo {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
  background: rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}
.venue-add-popup-content .external-venues-list .external-venue-wrapper .venue-info .venue-details {
  min-width: 0;
}
.venue-add-popup-content .external-venues-list .external-venue-wrapper .venue-info .venue-details .venue-name {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.venue-add-popup-content .external-venues-list .external-venue-wrapper .venue-info .venue-details .venue-address {
  opacity: 0.8;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.venue-add-popup-content .external-venues-list .external-venue-wrapper .venue-info .venue-details .venue-meta {
  opacity: 0.7;
  font-size: 12px;
}

@media (max-width: 900px) {
  .venue-add-popup-content .add-venue-layout {
    grid-template-columns: 1fr;
    max-height: none;
    overflow: auto;
  }
  .venue-add-popup-content .external-venues-list {
    max-height: 180px;
  }
}
.venue-logo-popup-content .logo-content-wrapper,
.user-photo-popup-content .logo-content-wrapper {
  flex-grow: 1;
  gap: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.venue-logo-popup-content .logo-content-wrapper .dropzone,
.user-photo-popup-content .logo-content-wrapper .dropzone {
  flex-grow: 1;
  width: 100%;
  position: relative;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: rgba(206, 206, 206, 0.103);
  gap: 1.5rem;
  transition: gap cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;
}
.venue-logo-popup-content .logo-content-wrapper .dropzone label,
.user-photo-popup-content .logo-content-wrapper .dropzone label {
  font-size: 1.4rem;
  font-weight: 600;
  opacity: 0.7;
  transition: opacity cubic-bezier(0.165, 0.84, 0.44, 1) 0.2s;
  position: relative;
  pointer-events: none;
}
.venue-logo-popup-content .logo-content-wrapper .dropzone svg,
.user-photo-popup-content .logo-content-wrapper .dropzone svg {
  pointer-events: none;
  font-size: 2.5rem;
  opacity: 0.2;
  transition: opacity cubic-bezier(0.165, 0.84, 0.44, 1) 0.2s;
}
.venue-logo-popup-content .logo-content-wrapper .dropzone:hover,
.venue-logo-popup-content .logo-content-wrapper .dropzone .active,
.user-photo-popup-content .logo-content-wrapper .dropzone:hover,
.user-photo-popup-content .logo-content-wrapper .dropzone .active {
  background-color: rgba(38, 75, 46, 0.103);
  gap: 0.7rem;
}
.venue-logo-popup-content .logo-content-wrapper .dropzone:hover label,
.venue-logo-popup-content .logo-content-wrapper .dropzone .active label,
.user-photo-popup-content .logo-content-wrapper .dropzone:hover label,
.user-photo-popup-content .logo-content-wrapper .dropzone .active label {
  opacity: 1;
}
.venue-logo-popup-content .logo-content-wrapper .dropzone:hover svg,
.venue-logo-popup-content .logo-content-wrapper .dropzone .active svg,
.user-photo-popup-content .logo-content-wrapper .dropzone:hover svg,
.user-photo-popup-content .logo-content-wrapper .dropzone .active svg {
  opacity: 0.7;
}
.venue-logo-popup-content .logo-content-wrapper .editor-tools,
.user-photo-popup-content .logo-content-wrapper .editor-tools {
  width: 40%;
}
.venue-logo-popup-content .logo-content-wrapper .editor-tools .form-item .color-input-row,
.user-photo-popup-content .logo-content-wrapper .editor-tools .form-item .color-input-row {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}
.venue-logo-popup-content .logo-content-wrapper .editor-tools .form-item .color-input-row button,
.user-photo-popup-content .logo-content-wrapper .editor-tools .form-item .color-input-row button {
  flex-grow: 1;
}
.venue-logo-popup-content .logo-content-wrapper .editor-tools .form-item .input-row,
.user-photo-popup-content .logo-content-wrapper .editor-tools .form-item .input-row {
  display: flex;
  gap: 0.5rem;
  width: 100%;
}
.venue-logo-popup-content .logo-content-wrapper .editor-tools .form-item .input-row input[type=range],
.user-photo-popup-content .logo-content-wrapper .editor-tools .form-item .input-row input[type=range] {
  flex-grow: 1;
}
.venue-logo-popup-content .logo-content-wrapper .editor-tools .form-item label,
.user-photo-popup-content .logo-content-wrapper .editor-tools .form-item label {
  color: #777777;
  font-size: 1.1rem;
}
.venue-logo-popup-content .logo-content-wrapper .editor-tools .buttons-group,
.user-photo-popup-content .logo-content-wrapper .editor-tools .buttons-group {
  display: flex;
  flex-direction: column;
}
.venue-logo-popup-content .logo-content-wrapper .editor-wrapper,
.user-photo-popup-content .logo-content-wrapper .editor-wrapper {
  display: flex;
  gap: 2.2rem;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.venue-logo-popup-content .logo-content-wrapper .editor-wrapper .img-outter-wrapper,
.user-photo-popup-content .logo-content-wrapper .editor-wrapper .img-outter-wrapper {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 400px;
  height: 400px;
  max-width: 400px;
  flex-shrink: 0;
  background: linear-gradient(45deg, #e6e6e6 25%, transparent 25%), linear-gradient(-45deg, #e6e6e6 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e6e6e6 75%), linear-gradient(-45deg, transparent 75%, #e6e6e6 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
  background-color: #f5f5f5;
}
.venue-logo-popup-content .logo-content-wrapper .editor-wrapper .img-outter-wrapper .img-wrapper,
.user-photo-popup-content .logo-content-wrapper .editor-wrapper .img-outter-wrapper .img-wrapper {
  position: relative;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.venue-logo-popup-content .logo-content-wrapper .editor-wrapper .img-outter-wrapper .img-wrapper canvas,
.user-photo-popup-content .logo-content-wrapper .editor-wrapper .img-outter-wrapper .img-wrapper canvas {
  display: block;
  position: relative;
  width: 400px !important;
  height: 400px !important;
}
.venue-logo-popup-content .logo-content-wrapper .editor-wrapper .img-outter-wrapper .grid-overlay,
.user-photo-popup-content .logo-content-wrapper .editor-wrapper .img-outter-wrapper .grid-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: linear-gradient(to top, rgba(88, 84, 84, 0.464) 1px, transparent 1px), linear-gradient(to left, rgba(88, 84, 84, 0.464) 1px, transparent 1px), linear-gradient(to right, rgba(88, 84, 84, 0.464) 1px, transparent 1px), linear-gradient(to bottom, rgba(88, 84, 84, 0.464) 1px, transparent 1px);
  background-size: 33.33% 33.33%;
}

.dropzone {
  border: 2px dashed rgba(204, 204, 204, 0.6705882353);
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  cursor: pointer;
  transition: 0.2s ease;
}

.dropzone.active {
  border-color: #4f46e5;
  background: #eef2ff;
}

.dropzone.reject {
  border-color: #dc2626;
  background: #fee2e2;
}

.user-detail-header,
.venue-detail-header {
  display: flex;
  gap: 1rem;
  margin-bottom: 5px;
  align-items: center;
  justify-content: space-between;
}
.user-detail-header .left-info-wrapper,
.venue-detail-header .left-info-wrapper {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  width: -webkit-fit-content;
  width: fit-content;
}
.user-detail-header .left-info-wrapper .avatar-wrapper,
.venue-detail-header .left-info-wrapper .avatar-wrapper {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 70px;
  min-width: 70px;
  border-radius: 50%;
}
.user-detail-header .left-info-wrapper .avatar-wrapper .change-avatar,
.venue-detail-header .left-info-wrapper .avatar-wrapper .change-avatar {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  outline: 0;
  border-radius: 50%;
  opacity: 0;
  background-color: rgba(97, 175, 145, 0.6431372549);
  transition: cubic-bezier(0.165, 0.84, 0.44, 1) opacity 0.2s;
  border: 0.2rem solid #ffffff;
  box-shadow: 0px 0px 3px 3px rgba(185, 185, 185, 0.384);
}
.user-detail-header .left-info-wrapper .avatar-wrapper .change-avatar:hover,
.venue-detail-header .left-info-wrapper .avatar-wrapper .change-avatar:hover {
  opacity: 0.9;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
.user-detail-header .left-info-wrapper .avatar-wrapper .change-avatar svg,
.venue-detail-header .left-info-wrapper .avatar-wrapper .change-avatar svg {
  font-size: 1.8rem;
  color: #ffffff;
}
.user-detail-header .left-info-wrapper .avatar-wrapper .avatar,
.venue-detail-header .left-info-wrapper .avatar-wrapper .avatar {
  height: 70px;
  width: 70px;
  background-color: transparent;
  flex-grow: 1;
  margin-top: 0;
  position: relative;
  display: flex;
}
.user-detail-header .left-info-wrapper h2,
.venue-detail-header .left-info-wrapper h2 {
  margin: 0;
  height: -webkit-fit-content;
  height: fit-content;
  font-size: 2.3rem;
  line-height: 3.1rem;
}
.user-detail-header .hidden,
.venue-detail-header .hidden {
  visibility: hidden;
}

.tab-bar {
  display: flex;
  gap: 24px;
  padding-right: 10px;
  margin-bottom: 26px;
}
.tab-bar .tab {
  position: relative;
  background: none;
  border: none;
  padding: 8px 0;
  color: #aaaaaa;
  color: var(--color-gray);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
}
.tab-bar .tab:hover {
  color: #3a5443ff;
  color: var(--color-primary);
}
.tab-bar .tab.active {
  color: #3a5443ff;
  color: var(--color-primary);
}
.tab-bar .tab.active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 2px;
  height: 2px;
  background: #3a5443ff;
  background: var(--color-primary);
}
.tab-bar .tab.back-tab {
  color: #3a5443ff;
  color: var(--color-primary);
}
.tab-bar .tab.back-tab:hover {
  color: var(--color-primary-dark);
}

.account-status-filter {
  position: relative;
}
.account-status-filter .account-status-filter-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border, #d9d9d9);
  border-radius: 8px;
  background: #fff;
  background: var(--color-surface, #fff);
  color: #1f1f1f;
  color: var(--color-text, #1f1f1f);
  font-size: 14px;
  cursor: pointer;
}
.account-status-filter .account-status-filter-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 20;
  min-width: 180px;
  padding: 8px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border, #d9d9d9);
  border-radius: 8px;
  background: #fff;
  background: var(--color-surface, #fff);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}
.account-status-filter .account-status-filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
}
.account-status-filter .account-status-filter-option:hover {
  background: #f5f5f5;
  background: var(--color-surface-muted, #f5f5f5);
}
.account-status-filter .account-status-filter-option input {
  margin: 0;
}

.user-detail-header .form-group {
  margin-bottom: 0;
  min-width: 200px;
}

.user-detail-content {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 32px;
}
.user-detail-content .user-detail-overview {
  display: flex;
  gap: 32px;
  align-items: flex-start;
  flex: 1 1;
  flex-wrap: wrap;
}
.user-detail-content .user-detail-overview .user-detail-info {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  padding: 26px;
  column-gap: 28px;
  row-gap: 15px;
}
.user-detail-content .user-detail-overview .user-detail-info.grid {
  display: grid;
  grid-column-gap: 0;
  column-gap: 0;
  grid-row-gap: 15px;
  row-gap: 15px;
  grid-template-columns: 1fr 1fr;
}
.user-detail-content .user-detail-overview .user-detail-info .form-item {
  margin-bottom: 0;
}
.user-detail-content .user-detail-overview .user-detail-info .form-item p {
  max-width: 100%;
  position: relative;
}
.user-detail-content .user-detail-overview .user-detail-info .form-item label {
  margin: 0;
}
.user-detail-content .user-detail-overview .user-detail-info .form-item .property-tag,
.user-detail-content .user-detail-overview .user-detail-info .form-item select {
  padding: 0.2rem 0.4rem;
  font-size: 14px;
}
.user-detail-content .user-detail-overview .user-detail-info .form-item .moderation-icon-button {
  width: 24px;
  height: 24px;
  margin-left: 4px;
  flex-shrink: 0;
}
.user-detail-content .user-detail-overview .user-detail-info .form-item .moderation-icon-button .icon {
  font-size: 12px;
}
.user-detail-content .user-detail-overview .user-detail-info .user-name-editor .user-name-editor-row {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.user-detail-content .user-detail-overview .user-detail-info .user-name-editor .user-name-editor-row input {
  flex: 1 1;
  min-width: 0;
  height: 45px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-light-line);
  padding: 0 0.75rem;
  background: #ffffff;
  background: var(--color-white);
  color: inherit;
}
.user-detail-content .user-detail-overview .user-detail-info .user-name-editor .user-name-editor-error {
  margin: 0.35rem 0 0;
  color: #c0392b;
  font-size: 0.85rem;
}

.user-detail-tab-table {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.user-detail-tab-table-toolbar {
  display: flex;
  justify-content: flex-end;
}

.user-photo-verification-status {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}
.user-photo-verification-status__label {
  color: #cccccc;
  color: var(--color-light-gray);
}
.user-photo-verification-status__badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}
.user-photo-verification-status__badge--verified {
  background: #d9f5df;
  color: #14532d;
}
.user-photo-verification-status__badge--unverified {
  background: #f3f4f6;
  color: #6c757d;
  color: var(--color-muted);
}

.breadcrumb-activity-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
}

.breadcrumb-activity-box {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
}
.breadcrumb-activity-box--flagged {
  border-color: #d97706;
  box-shadow: inset 0 0 0 1px rgba(217, 119, 6, 0.15);
}
.breadcrumb-activity-box h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  color: var(--color-control);
}
.breadcrumb-activity-box--breadcrumb {
  background-color: #ffffff;
  background-color: var(--color-control-background);
}
.breadcrumb-activity-box--reply {
  background-color: #f4f4f4;
  background-color: var(--color-nav-bar-background);
}

.breadcrumb-activity-box-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.breadcrumb-activity-box-header h3 {
  flex: 1 1;
  min-width: 0;
}

.moderation-icon-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.moderation-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background-color: #ffffff;
  background-color: var(--color-control-background);
  color: #333333;
  color: var(--color-control);
  cursor: pointer;
}
.moderation-icon-button:hover:not(:disabled) {
  background-color: #f4f4f4;
  background-color: var(--color-nav-bar-background);
}
.moderation-icon-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.moderation-icon-button.is-active {
  border-color: #d97706;
  background-color: rgba(217, 119, 6, 0.12);
  color: #b45309;
}
.moderation-icon-button .icon {
  display: inline-flex;
  font-size: 14px;
}

.breadcrumb-activity-meta {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  grid-gap: 12px;
  gap: 12px;
  padding-top: 12px;
  border-top: 1px solid #dee2e6;
  border-top: 1px solid var(--color-border);
}

.breadcrumb-activity-content {
  white-space: pre-wrap;
  line-height: 1.5;
}

.breadcrumb-activity-reactions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  grid-column: 1/-1;
}

.breadcrumb-activity-reactions-label {
  font-size: 13px;
  font-weight: 600;
  color: #333333;
  color: var(--color-control);
}

.breadcrumb-reactions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.breadcrumb-reaction-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  background-color: #ffffff;
  background-color: var(--color-control-background);
  font-size: 16px;
  line-height: 1;
}

.breadcrumb-reaction-count {
  font-size: 12px;
  font-weight: 600;
  color: #333333;
  color: var(--color-control);
}

.breadcrumb-reactions-empty {
  font-size: 13px;
  color: #333333;
  color: var(--color-control);
  opacity: 0.7;
}

.breadcrumb-detail-popup {
  max-width: 560px;
}

.sticker-detail-popup {
  max-width: 680px;
}
.sticker-detail-popup .photo-verification-detail-layout {
  grid-template-columns: 280px 1fr;
}
.sticker-detail-popup .photo-verification-detail-photo img {
  width: 100%;
  aspect-ratio: auto;
  max-height: 420px;
  object-fit: contain;
  background: #f4f4f4;
  background: var(--color-nav-bar-background);
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  border-radius: 8px;
}
@media (max-width: 700px) {
  .sticker-detail-popup .photo-verification-detail-layout {
    grid-template-columns: 1fr;
  }
}

.breadcrumb-detail-sections {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 4px;
}

.breadcrumb-detail-loading {
  padding: 16px 0;
  color: #333333;
  color: var(--color-control);
  opacity: 0.8;
}

.event-comment-edit-panel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  border: 1px dashed #dee2e6;
  border: 1px dashed var(--color-border);
  background-color: #f4f4f4;
  background-color: var(--color-nav-bar-background);
}
.event-comment-edit-panel .styled-button {
  align-self: flex-start;
  width: auto;
  padding: 0.6em 1.4em;
}

.breadcrumb-replies-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.breadcrumb-replies-heading {
  margin: 4px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  color: var(--color-control);
}

.venue-detail-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.venue-detail-content .form-item p {
  max-width: 100%;
}

.page-loading,
.page-error {
  background-color: #f8f8f8;
  background-color: var(--color-disabled-background);
  border-radius: 8px;
  padding: 16px 20px;
  font-size: 15px;
  color: #333333;
  color: var(--color-control);
}

.page-error {
  background-color: #ffeeee;
  background-color: var(--color-error-background);
  color: #aa0000;
  color: var(--color-error);
}

.venue-detail-overview {
  display: flex;
  gap: 32px;
  align-items: flex-start;
}

.venue-detail-media {
  flex: 0 0 25%;
  max-width: 25%;
  display: grid;
  grid-gap: 24px;
  gap: 24px;
}

.venue-detail-socials,
.venue-detail-info,
.user-detail-info,
.venue-detail-counts {
  border: solid 1px #e0e0e0;
  border: solid 1px var(--color-light-line);
  background-color: #ffffff;
  background-color: var(--color-white);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 26px 26px 10px 26px;
}

.venue-detail-info,
.venue-detail-socials {
  flex: 0 0 50%;
  max-width: 50%;
  display: grid;
  display: flex;
  flex-direction: column;
  min-height: 70px;
}
.venue-detail-info .venue-address-row,
.venue-detail-socials .venue-address-row {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
}
.venue-detail-info .venue-address-row .form-item,
.venue-detail-socials .venue-address-row .form-item {
  flex: 1 1;
  min-width: 0;
}
.venue-detail-info .venue-name-editor .venue-name-editor-row,
.venue-detail-socials .venue-name-editor .venue-name-editor-row {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.venue-detail-info .venue-name-editor .venue-name-editor-row input,
.venue-detail-socials .venue-name-editor .venue-name-editor-row input {
  flex: 1 1;
  min-width: 0;
  height: 45px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-light-line);
  padding: 0 0.75rem;
  background: #ffffff;
  background: var(--color-white);
  color: inherit;
}
.venue-detail-info .venue-name-editor .venue-name-editor-error,
.venue-detail-socials .venue-name-editor .venue-name-editor-error {
  margin: 0.35rem 0 0;
  color: #c0392b;
  font-size: 0.85rem;
}

.venue-detail-counts {
  flex: 0 0 20%;
  max-width: 20%;
  display: grid;
  display: flex;
  flex-direction: column;
  min-height: 70px;
}

@media (max-width: 1024px) {
  .venue-detail-info {
    flex: 0 0 100%;
    width: 100%;
    max-width: 100%;
  }
}
@media (max-width: 1024px) {
  .venue-detail-counts {
    flex: 0 0 100%;
    width: 100%;
    max-width: 100%;
  }
}
.venue-opening-hours-editor {
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
  border-top: 1px solid var(--color-light-line);
  width: 100%;
}
.venue-opening-hours-editor h3 {
  margin: 0 0 8px;
  font-size: 16px;
}
.venue-opening-hours-editor__header {
  margin-bottom: 12px;
}
.venue-opening-hours-editor__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  font-size: 13px;
  color: #666;
  color: var(--color-text-secondary, #666);
}
.venue-opening-hours-editor__effective, .venue-opening-hours-editor__google-ref {
  margin-bottom: 12px;
}
.venue-opening-hours-editor__effective label, .venue-opening-hours-editor__google-ref label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.venue-opening-hours-editor__effective ul, .venue-opening-hours-editor__google-ref ul {
  margin: 0;
  padding-left: 20px;
  font-size: 14px;
}
.venue-opening-hours-editor__google-ref {
  opacity: 0.85;
}
.venue-opening-hours-editor__hint {
  font-size: 13px;
  color: #666;
  color: var(--color-text-secondary, #666);
  margin: 0 0 12px;
  line-height: 1.4;
}
.venue-opening-hours-editor__table-wrap {
  overflow-x: auto;
  margin-bottom: 12px;
}
.venue-opening-hours-editor__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.venue-opening-hours-editor__table th,
.venue-opening-hours-editor__table td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
  border-bottom: 1px solid var(--color-light-line);
}
.venue-opening-hours-editor__table th {
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.venue-opening-hours-editor__table input[type=time] {
  font: inherit;
  padding: 4px 6px;
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-light-line);
  border-radius: 4px;
}
.venue-opening-hours-editor__google-cell {
  white-space: nowrap;
  color: #666;
  color: var(--color-text-secondary, #666);
  font-size: 13px;
}
.venue-opening-hours-editor__error {
  color: #aa0000;
  color: var(--color-error, #c0392b);
  font-size: 13px;
  margin-bottom: 8px;
}
.venue-opening-hours-editor__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.venue-detail-photo {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  position: relative;
  width: 100%;
  height: 360px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.venue-detail-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.detail-item {
  background-color: #f8f8f8;
  background-color: var(--color-disabled-background);
  border-radius: 12px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 70px;
}

.detail-label {
  font-size: 12px;
  color: #aaaaaa;
  color: var(--color-gray);
  font-weight: 700;
  text-transform: uppercase;
}

.detail-value {
  font-size: 15px;
  color: #333333;
  color: var(--color-control);
  line-height: 1.45;
  word-break: break-word;
}

.venue-detail-visits,
.venue-detail-blasts,
.venue-detail-specials {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.venue-detail-map-tab {
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: calc(100vh - 250px);
}

.map-tab-static {
  width: 100%;
  height: calc(100vh - 300px);
  min-height: 400px;
  border-radius: 12px;
  overflow: hidden;
  background-color: #f8f8f8;
  background-color: var(--color-disabled-background);
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.venue-detail-map-inline {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  height: 100%;
}

.inline-location-map {
  width: 100%;
  height: 100%;
}

.map-tab-actions {
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.link-out {
  color: #3a5443ff;
  color: var(--color-primary);
  font-weight: 600;
  text-decoration: none;
}
.link-out:hover {
  color: var(--color-primary-dark);
}

.link-button {
  background: none;
  border: none;
  color: #3a5443ff;
  color: var(--color-primary);
  font-weight: 600;
  cursor: pointer;
  margin-left: 12px;
  padding: 0;
}
.link-button:hover {
  color: var(--color-primary-dark);
  text-decoration: underline;
}

.empty-state {
  padding: 24px;
  border-radius: 12px;
  background-color: #f8f8f8;
  background-color: var(--color-disabled-background);
  color: #6c757d;
  color: var(--color-muted);
}

.empty-state.error {
  background-color: #ffeeee;
  background-color: var(--color-error-background);
  color: #aa0000;
  color: var(--color-error);
}

.venue-detail-map img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  -webkit-mask-clip: content-box;
          mask-clip: content-box;
}

.venue-detail-map-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  color: var(--color-muted);
  font-size: 64px;
  background-color: #f8f8f8;
  background-color: var(--color-disabled-background);
  border-radius: 12px;
}

.venue-detail-stats {
  margin-top: 32px;
  display: grid;
  grid-gap: 16px;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.stat-card {
  background-color: #ffffff;
  background-color: var(--color-white);
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-light-line);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
}

.stat-label {
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6c757d;
  color: var(--color-muted);
}

.stat-value {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  color: var(--color-control);
}

.venue-detail-table {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.venue-detail-table h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  color: var(--color-control);
}

.venue-detail-tabs,
.venue-detail-content {
  width: 100%;
}

@media (max-width: 1024px) {
  .venue-detail-tabs {
    flex-wrap: wrap;
    gap: 16px;
  }
  .venue-detail-overview {
    flex-direction: column;
  }
  .venue-detail-media,
  .venue-detail-info {
    flex: 1 1 100%;
    max-width: 100%;
  }
  .venue-detail-media {
    grid-template-columns: 1fr;
  }
}
.visits-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0;
}
.visits-header h2 {
  margin: 0;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 16px;
}

.table-wrapper {
  position: relative;
}
.table-wrapper.loading {
  pointer-events: none;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.loading-overlay .loading-spinner {
  background: white;
  padding: 20px 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  color: #666;
  font-size: 16px;
}

.users-table-container {
  position: relative;
}

.venues-table-container {
  position: relative;
}

.visits-table-container {
  position: relative;
}

.map-container {
  position: relative;
  top: -30px;
  left: -30px;
  width: calc(100% + 60px);
  height: calc(100vh - 55px);
  margin-top: 20px;
}

.map-container-inner {
  width: 100%;
  height: 100%;
}

.moderation-modal-header {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
.moderation-modal-header h2 {
  margin: 0;
}

.moderation-actions-bar {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 8px;
  margin: 16px 0;
}
.moderation-actions-bar .styled-button {
  flex: 1 1 auto;
  min-width: 5.5rem;
  margin: 0;
}
@media (max-width: 520px) {
  .moderation-actions-bar {
    flex-direction: column;
  }
  .moderation-actions-bar .styled-button {
    width: 100%;
    min-width: 0;
  }
}

/* ===========================================================================
   Live Activity map (/admin/live-map)
   Ported from the mobile map: badge markers, filter card, pulses, bottom cards.
   =========================================================================== */
.live-map {
  position: relative;
  margin: -10px -30px;
  height: calc(100vh - 55px);
}
.live-map__canvas {
  width: 100%;
  height: 100%;
}
.live-map__status {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 6px 14px;
  border-radius: 16px;
  font-size: 13px;
  z-index: 5;
}
.live-map__status--error {
  background: #aa0000;
  background: var(--color-error, #aa0000);
}
.live-map__filter-toggle {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 18px;
  padding: 8px 14px;
  background: #fff;
  color: #1a1a1a;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}
.live-map__locate {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 1px solid #8c1414;
  border-radius: 12px;
  background: #aa0000;
  background: var(--color-error, #aa0000);
  color: #fff;
  font-size: 17px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}
.live-map__locate:hover {
  filter: brightness(1.08);
}

/* Stacked overlay (filter card / toggle + loading indicator), top-left. */
.map-overlay-top-left {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 6;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.map-loading-indicator {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border-radius: 18px;
  background: #fff;
  color: #1a1a1a;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
}
.map-loading-indicator__spinner {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-top-color: #3a5443ff;
  border-top-color: var(--color-primary, #3a5443);
  animation: map-spinner-rotate 0.7s linear infinite;
}

@keyframes map-spinner-rotate {
  to {
    transform: rotate(360deg);
  }
}
/* --- Custom badge marker ------------------------------------------------- */
.live-marker {
  position: relative;
  width: 52px;
  height: 52px;
}
.live-marker__token {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  overflow: hidden;
  background: #ffffff;
  border: 3px solid #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.live-marker__logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.live-marker__initials {
  font-weight: 900;
  font-size: 22px;
  color: #555;
}
.live-marker__badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 22px;
  height: 22px;
  padding: 0 5px;
  border-radius: 11px;
  border: 3.5px solid #ffffff;
  box-sizing: border-box;
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}
.live-marker__badge--pill {
  border-radius: 13px;
}
.live-marker__dots {
  position: absolute;
  left: 50%;
  bottom: -4px;
  transform: translateX(-50%);
  display: flex;
  gap: 3px;
  padding: 3px 4px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  z-index: 3;
}
.live-marker__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.live-marker__ripple {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}
.live-marker__ring {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid #aa0100;
  border: 2px solid var(--ripple-color, #aa0100);
  background: #aa0100;
  background: var(--ripple-color, #aa0100);
  opacity: 0;
  animation: live-marker-ripple 3000ms cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
}

@keyframes live-marker-ripple {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.5;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.75);
    opacity: 0;
  }
}
/* --- Filter card --------------------------------------------------------- */
.map-filter-card {
  width: 220px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);
  padding: 10px 12px;
}
.map-filter-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.map-filter-card__title {
  font-weight: 800;
  font-size: 15px;
}
.map-filter-card__close {
  border: none;
  background: transparent;
  color: #888;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
}
.map-filter-card__list {
  list-style: none;
  margin: 6px 0 0;
  padding: 0;
}

.map-filter-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 4px;
  border-radius: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.map-filter-row:hover {
  background: rgba(0, 0, 0, 0.04);
}
.map-filter-row--locked {
  cursor: default;
}
.map-filter-row--locked:hover {
  background: transparent;
}
.map-filter-row--dimmed {
  opacity: 0.45;
}
.map-filter-row__ring {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.map-filter-row__check {
  color: #ffffff;
  font-size: 10px;
}
.map-filter-row__label {
  flex: 1 1 auto;
  font-size: 14px;
  color: #1a1a1a;
}
.map-filter-row__lock {
  color: #b0b0b0;
  font-size: 12px;
}

/* --- Bottom "recent viewers" cards -------------------------------------- */
.map-bottom-cards {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 16px;
  z-index: 5;
  padding: 0 16px;
  overflow: hidden;
}
.map-bottom-cards__track {
  display: flex;
  width: -webkit-max-content;
  width: max-content;
}
.map-bottom-cards__track--scrolling {
  animation-name: map-ticker-scroll;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.map-bottom-cards:hover .map-bottom-cards__track--scrolling {
  animation-play-state: paused;
}

@keyframes map-ticker-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
.map-venue-card {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 220px;
  margin-right: 12px;
  text-align: left;
  border: none;
  border-radius: 14px;
  padding: 10px 12px;
  background: #ffffff;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.18);
  cursor: pointer;
}
.map-venue-card--active {
  outline: 2px solid #3a5443ff;
  outline: 2px solid var(--color-primary, #3a5443);
}
.map-venue-card__body {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.map-venue-card__name {
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.map-venue-card__flame {
  font-size: 12px;
  color: #666;
}

/* Reused map marker token (logo + count badges) inside ticker cards. */
.venue-token {
  flex: 0 0 auto;
  position: relative;
  display: inline-block;
  width: 46px;
  height: 46px;
}
.venue-token .live-marker {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.88);
}

/* --- Venue detail sheet -------------------------------------------------- */
.venue-detail-sheet {
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 7;
  width: 320px;
  max-width: calc(100% - 32px);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.25);
  padding: 16px;
}
.venue-detail-sheet__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.venue-detail-sheet__logo {
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.venue-detail-sheet__logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.venue-detail-sheet__initials {
  font-weight: 900;
  color: #777;
}
.venue-detail-sheet__identity {
  flex: 1 1 auto;
  min-width: 0;
}
.venue-detail-sheet__name {
  font-weight: 800;
  font-size: 16px;
}
.venue-detail-sheet__address {
  font-size: 12px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.venue-detail-sheet__close {
  border: none;
  background: transparent;
  color: #888;
  cursor: pointer;
  font-size: 16px;
}
.venue-detail-sheet__stats {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
}

.venue-stat-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}
.venue-stat-row__badge {
  flex: 0 0 auto;
  min-width: 28px;
  height: 28px;
  padding: 0 6px;
  border-radius: 14px;
  color: #ffffff;
  font-weight: 800;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.venue-stat-row__text {
  display: flex;
  flex-direction: column;
}
.venue-stat-row__label {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}
.venue-stat-row__subtitle {
  font-size: 12px;
  color: #888;
}

.moderation-flagged .styled-button,
.styled-button.moderation-flagged {
  border-color: #c9a227;
  color: #8a6914;
}

.moderation-flagged-content {
  border-left: 3px solid #c9a227;
  padding-left: 12px;
  background: #fffbeb;
}

.moderation-flag-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  color: #8a6914;
  margin-left: 0;
  padding: 2px 8px;
  border-radius: 4px;
  background: #fff3cd;
  border: 1px solid #c9a227;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.moderation-flag-badge--reply {
  color: #7c4a12;
  background: #f3f4f6;
  border-color: #c4c9d1;
}

.name-and-address-title {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.venue-closed-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  color: #7f1d1d;
  padding: 2px 8px;
  border-radius: 4px;
  background: #fef2f2;
  border: 1px solid #fca5a5;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.venue-closed-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 6px;
  background: #fef2f2;
  border: 1px solid #fca5a5;
  color: #7f1d1d;
}

.venue-status-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
}

.breadcrumb-moderation-flags,
.moderation-modal-header-flags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

tr.moderation-flagged-row td {
  background: #fffbeb;
}

.intention-prompt-cell {
  max-width: 320px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.intention-active-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.intention-active-toggle input {
  margin: 0;
}

.dev-telephones-page .roles-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
}
.dev-telephones-page .dev-otp-card {
  max-width: 280px;
  color: #555555;
  color: var(--color-black);
  font-family: Inter, Arial, Helvetica, sans-serif;
}
.dev-telephones-page .dev-otp-card span.header {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
}
.dev-telephones-page .dev-otp-card .dev-otp-reveal {
  display: block;
  width: 100%;
  min-height: 88px;
  border: solid 1px #ccc;
  border: solid 1px var(--border-color, #ccc);
  border-radius: 4px;
  background: #ffffff;
  background: var(--color-white, #fff);
  padding: 16px 12px;
  cursor: pointer;
  position: relative;
  text-align: center;
  box-sizing: border-box;
}
.dev-telephones-page .dev-otp-card .dev-otp-reveal:focus-visible {
  outline: 2px solid #555555;
  outline: 2px solid var(--color-black);
  outline-offset: 2px;
}
.dev-telephones-page .dev-otp-card .dev-otp-code {
  display: block;
  font-size: 32px;
  font-weight: 600;
  letter-spacing: 0.3em;
  filter: blur(10px);
  -webkit-user-select: none;
          user-select: none;
  transition: filter 0.2s ease;
}
.dev-telephones-page .dev-otp-card .dev-otp-reveal.is-revealed .dev-otp-code {
  filter: blur(0);
  -webkit-user-select: text;
          user-select: text;
}
.dev-telephones-page .dev-otp-card .dev-otp-hint {
  display: block;
  margin-top: 8px;
  min-height: 14px;
  font-size: 11px;
  color: #aaaaaa;
  color: var(--color-gray, #666);
  visibility: visible;
  opacity: 1;
  transition: opacity 0.2s ease;
}
.dev-telephones-page .dev-otp-card .dev-otp-reveal.is-revealed .dev-otp-hint {
  visibility: hidden;
  opacity: 0;
}
.dev-telephones-page .dev-otp-card .dev-otp-expiry {
  margin: 10px 0 0;
  font-size: 11px;
  color: #aaaaaa;
  color: var(--color-gray, #666);
}

.simulation-page .simulation-status {
  margin: 0.75rem 0 0;
  opacity: 0.9;
}
.simulation-page .simulation-presence-panel {
  margin-top: 1.5rem;
}
.simulation-page .simulation-presence-meta,
.simulation-page .simulation-hint {
  margin: 0.5rem 0 1rem;
  font-size: 14px;
  opacity: 0.85;
}
.simulation-page .simulation-spawn-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
  margin-top: 1rem;
}
.simulation-page .simulation-spawn-card {
  padding: 1rem 1.25rem;
  border: 1px solid #ccc;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 4px;
}
.simulation-page .simulation-spawn-card h3 {
  margin: 0 0 0.5rem;
  font-size: 16px;
}
.simulation-page .simulation-spawn-card p {
  margin: 0 0 1rem;
  font-size: 13px;
  line-height: 1.45;
  opacity: 0.85;
}
.simulation-page .simulation-spawn-card .form-group {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-bottom: 0.75rem;
}
.simulation-page .simulation-spawn-card .form-group span {
  font-size: 12px;
  font-weight: 600;
}
.simulation-page .simulation-spawn-card .form-group input,
.simulation-page .simulation-spawn-card .form-group select {
  padding: 0.45rem 0.55rem;
  border: 1px solid #ccc;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 4px;
  font: inherit;
}
.simulation-page .simulation-field-note {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
  opacity: 0.75;
}
.simulation-page .simulation-picker {
  position: relative;
}
.simulation-page .simulation-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-bottom: 0.35rem;
}
.simulation-page .simulation-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid #ccc;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 4px;
  background: transparent;
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}
.simulation-page .simulation-chip span {
  font-weight: 600;
  opacity: 0.7;
}
.simulation-page .simulation-picker-dropdown {
  position: absolute;
  z-index: 5;
  left: 0;
  right: 0;
  top: calc(100% - 0.25rem);
  margin: 0;
  padding: 0.25rem 0;
  list-style: none;
  max-height: 220px;
  overflow: auto;
  border: 1px solid #ccc;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 4px;
  background: #ffffff;
  background: var(--color-white, #fff);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.simulation-page .simulation-picker-dropdown li button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.15rem;
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 0;
  background: transparent;
  text-align: left;
  font: inherit;
  cursor: pointer;
}
.simulation-page .simulation-picker-dropdown li button:hover {
  background: rgba(0, 0, 0, 0.04);
}
.simulation-page .simulation-picker-dropdown li button strong {
  font-size: 13px;
}
.simulation-page .simulation-picker-dropdown li button span,
.simulation-page .simulation-picker-dropdown li button em {
  font-size: 11px;
  opacity: 0.75;
  font-style: normal;
}
.simulation-page .simulation-picker-empty {
  margin: 0;
  padding: 0.5rem 0.75rem;
  font-size: 12px;
  opacity: 0.7;
}
.simulation-page .simulation-person-select-actions {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 0.35rem;
}
.simulation-page .simulation-link-btn {
  border: 0;
  padding: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
  opacity: 0.85;
}
.simulation-page .simulation-link-btn:disabled {
  opacity: 0.4;
  cursor: default;
  text-decoration: none;
}
.simulation-page .simulation-person-list {
  max-height: 220px;
  overflow: auto;
  border: 1px solid #ccc;
  border: 1px solid var(--border-color, #ccc);
  border-radius: 4px;
}
.simulation-page .simulation-person-option {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  grid-gap: 0.5rem;
  gap: 0.5rem;
  margin: 0;
  padding: 0.45rem 0.65rem;
  border-bottom: 1px solid #eee;
  border-bottom: 1px solid var(--border-color, #eee);
  font-size: 13px;
  cursor: pointer;
}
.simulation-page .simulation-person-option:last-child {
  border-bottom: 0;
}
.simulation-page .simulation-person-option.is-selected {
  background: rgba(0, 0, 0, 0.03);
}
.simulation-page .simulation-person-option input {
  margin: 0;
}
.simulation-page .simulation-person-option__name {
  font-weight: 600;
}
.simulation-page .simulation-person-option__meta {
  font-size: 11px;
  opacity: 0.7;
}
.simulation-page .users-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
}
.simulation-page .roles-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
}

.roles-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.roles-container .roles-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
}
.roles-container .roles-header h2 {
  margin: 0;
}
.roles-container .roles-page-intro {
  margin: 0;
  opacity: 0.85;
}
.roles-container .roles-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
}

.notification-presets-page .notification-presets-overview {
  margin-bottom: 1rem;
  padding: 1rem 1.25rem;
}
.notification-presets-page .notification-presets-overview__title {
  margin: 0 0 0.5rem;
  font-size: 18px;
  font-weight: 600;
  color: #555555;
  color: var(--color-black);
}
.notification-presets-page .notification-presets-overview__intro {
  margin: 0 0 1rem;
  font-size: 14px;
  line-height: 1.5;
  opacity: 0.85;
}
.notification-presets-page .notification-presets-overview__list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.notification-presets-page .notification-presets-overview__item {
  font-size: 14px;
  line-height: 1.5;
}
.notification-presets-page .notification-presets-overview__link {
  font-weight: 600;
  color: #3a5443ff;
  color: var(--color-primary);
  text-decoration: none;
}
.notification-presets-page .notification-presets-overview__link:hover {
  text-decoration: underline;
}
.notification-presets-page .notification-presets-overview__description {
  color: #555555;
  color: var(--color-black);
  opacity: 0.85;
}
.notification-presets-page .notification-presets-overview__meta {
  display: block;
  margin-top: 0.2rem;
  font-size: 12px;
  opacity: 0.65;
}
.notification-presets-page .notification-presets-toolbar {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin: 0.75rem 0 1rem;
  padding: 0.75rem 0;
  background: #ffffff;
  background: var(--color-background);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.notification-presets-page .notification-presets-toolbar__secondary {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.notification-presets-page .notification-presets-category {
  margin-top: 1.5rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.45);
  overflow: hidden;
  scroll-margin-top: 4.5rem;
}
.notification-presets-page .notification-presets-category:first-of-type {
  margin-top: 1rem;
}
.notification-presets-page .notification-presets-collapse-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 1rem 1.1rem;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  color: inherit;
}
.notification-presets-page .notification-presets-collapse-header:hover {
  background: rgba(0, 0, 0, 0.03);
}
.notification-presets-page .notification-presets-collapse-header--category {
  background: #284f4330;
  background: var(--color-primary-translucent);
  color: #3a5443ff;
  color: var(--color-primary);
  border-bottom: 1px solid rgba(40, 79, 67, 0.12);
}
.notification-presets-page .notification-presets-collapse-header--category:hover {
  background: rgba(40, 79, 67, 0.18);
}
.notification-presets-page .notification-presets-collapse-header--category .notification-presets-collapse-count {
  color: #3a5443ff;
  color: var(--color-primary);
  opacity: 0.75;
}
.notification-presets-page .notification-presets-collapse-header--trigger {
  padding: 0.85rem 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.notification-presets-page .notification-presets-collapse-icon {
  flex-shrink: 0;
  transition: transform 0.2s ease;
}
.notification-presets-page .notification-presets-collapse-icon.is-collapsed {
  transform: rotate(-90deg);
}
.notification-presets-page .notification-presets-collapse-title {
  flex: 1 1;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
}
.notification-presets-page .notification-presets-collapse-header--trigger .notification-presets-collapse-title {
  font-size: 16px;
  font-weight: 600;
}
.notification-presets-page .notification-presets-collapse-count {
  flex-shrink: 0;
  font-size: 13px;
  opacity: 0.65;
}
.notification-presets-page .notification-presets-trigger-group {
  margin: 0;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 0;
  background: transparent;
}
.notification-presets-page .notification-presets-trigger-group .property-bar-field-group__description {
  margin: 0 1rem 0.75rem;
}
.notification-presets-page .notification-presets-empty {
  margin: 0 1rem 1rem;
  font-style: italic;
}
.notification-presets-page .roles-table-container {
  margin: 0 1rem 1rem;
}

.roles-permissions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-gap: 10px 16px;
  gap: 10px 16px;
  margin-top: 8px;
}

.roles-permission-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  cursor: pointer;
}
.roles-permission-item input {
  margin: 0;
}

.notification-recipient-picker {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.notification-recipient-search,
.notification-recipient-selected {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.notification-recipient-search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}

.notification-recipient-search-table {
  width: 100%;
  border-collapse: collapse;
}
.notification-recipient-search-table th,
.notification-recipient-search-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #e5e5e5;
  vertical-align: middle;
}
.notification-recipient-search-table tr.is-selected {
  opacity: 0.7;
}

.notification-recipient-checkbox-col {
  width: 44px;
}

.notification-recipient-name {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.role-modal .modal-content-wrapper,
.account-access-modal .modal-content-wrapper {
  max-width: 720px;
}

.system-status-page .system-status-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.system-status-page .system-status-header h2 {
  margin: 0 0 6px;
}
.system-status-page .system-status-subtitle {
  margin: 0;
  color: #cccccc;
  color: var(--color-light-gray);
  font-size: 14px;
}
.system-status-page .system-status-error {
  padding: 16px;
  border-radius: 8px;
  background: #999999;
  background: var(--color-dark-gray);
}
.system-status-page .system-status-error {
  margin-bottom: 16px;
  color: #ffb4b4;
}
.system-status-page .system-status-overview-card {
  border: solid 1px #e0e0e0;
  border: solid 1px var(--color-light-line);
  background-color: #ffffff;
  background-color: var(--color-white);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 18px 20px;
  margin-bottom: 16px;
  color: #333333;
  color: var(--color-control);
}
.system-status-page .system-status-overview-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.system-status-page .system-status-overview-card__heading {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
}
.system-status-page .system-status-overview-card__label {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6c757d;
  color: var(--color-muted);
  font-size: 12px;
  line-height: 1.2;
}
.system-status-page .system-status-overview-card__meta {
  color: #6c757d;
  color: var(--color-muted);
  font-size: 13px;
  white-space: nowrap;
}
.system-status-page .system-status-overview-card__description {
  font-size: 14px;
}
.system-status-page .system-status-overview-card__status-text {
  font-weight: 700;
  line-height: 1.2;
}
.system-status-page .system-status-overview-card__hint {
  color: #6c757d;
  color: var(--color-muted);
}
.system-status-page .system-status-overview-card--healthy .system-status-overview-card__status-text {
  color: #11aa11;
  color: var(--color-green);
}
.system-status-page .system-status-overview-card--degraded .system-status-overview-card__status-text {
  color: #856404;
}
.system-status-page .system-status-overview-card--unhealthy .system-status-overview-card__status-text {
  color: #aa0000;
  color: var(--color-error);
}
.system-status-page .system-status-overview-card--not_configured .system-status-overview-card__status-text {
  color: #6c757d;
  color: var(--color-muted);
}
.system-status-page th.system-health-priority-col,
.system-status-page td.system-health-priority-col {
  display: none;
}
.system-status-page .tile-migration-progress {
  height: 10px;
  overflow: hidden;
  margin-bottom: 8px;
  border-radius: 999px;
  background: #e0e0e0;
  background: var(--color-light-line);
}
.system-status-page .tile-migration-progress__bar {
  height: 100%;
  border-radius: inherit;
  background: #11aa11;
  background: var(--color-green);
  transition: width 200ms ease;
}
.system-status-page .tile-migration-progress__label {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  color: #6c757d;
  color: var(--color-muted);
  font-size: 13px;
}
.system-status-page .tile-migration-progress__label strong {
  color: #333333;
  color: var(--color-control);
}
.system-status-page .osm-queue-status {
  margin-top: 28px;
}
.system-status-page .osm-queue-status__header {
  margin-bottom: 14px;
}
.system-status-page .osm-queue-status__header h3 {
  margin: 0 0 6px;
}
.system-status-page .osm-queue-status__header p {
  margin: 0;
  color: #cccccc;
  color: var(--color-light-gray);
  font-size: 14px;
}
.system-status-page .osm-queue-status__stats {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  grid-gap: 12px;
  gap: 12px;
  margin-bottom: 16px;
}
.system-status-page .osm-queue-status__stats > div {
  border: solid 1px #e0e0e0;
  border: solid 1px var(--color-light-line);
  border-radius: 10px;
  background: #ffffff;
  background: var(--color-white);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.system-status-page .osm-queue-status__stats > div span {
  color: #6c757d;
  color: var(--color-muted);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.system-status-page .osm-queue-status__stats > div strong {
  font-size: 15px;
  color: #333333;
  color: var(--color-control);
  font-weight: 600;
}

.photo-verification-page .photo-verification-header {
  margin-bottom: 20px;
}
.photo-verification-page .photo-verification-header h2 {
  margin: 0 0 6px;
}
.photo-verification-page .photo-verification-subtitle {
  margin: 0;
  color: #cccccc;
  color: var(--color-light-gray);
  font-size: 14px;
}
.photo-verification-page .photo-verification-error {
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #fff1f1;
  color: #9b1c1c;
}

.photo-verification-modal .photo-verification-detail-layout {
  display: grid;
  grid-template-columns: 180px 1fr;
  grid-gap: 20px;
  gap: 20px;
  margin-top: 16px;
}
.photo-verification-modal .photo-verification-detail-photo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.photo-verification-modal .photo-verification-detail-photo img {
  width: 100%;
  border-radius: 8px;
  object-fit: cover;
  aspect-ratio: 1;
}
.photo-verification-modal .photo-verification-detail-photo-avatar {
  width: 100%;
  aspect-ratio: 1;
}
.photo-verification-modal .photo-verification-detail-photo-avatar .avatar {
  width: 100%;
  height: 100%;
  margin-top: 0;
}
.photo-verification-modal .photo-verification-detail-photo-avatar .avatar .initials,
.photo-verification-modal .photo-verification-detail-photo-avatar .avatar .image {
  border-radius: 8px;
}
.photo-verification-modal .photo-verification-detail-photo-caption {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #cccccc;
  color: var(--color-light-gray);
  text-align: center;
}
.photo-verification-modal .photo-verification-detail-stats dl {
  margin: 0;
  display: grid;
  grid-gap: 10px;
  gap: 10px;
}
.photo-verification-modal .photo-verification-detail-stats div {
  display: grid;
  grid-template-columns: 160px 1fr;
  grid-gap: 8px;
  gap: 8px;
}
.photo-verification-modal .photo-verification-detail-stats dt {
  margin: 0;
  color: #cccccc;
  color: var(--color-light-gray);
  font-size: 13px;
}
.photo-verification-modal .photo-verification-detail-stats dd {
  margin: 0;
  font-size: 14px;
}
.photo-verification-modal .photo-verification-error {
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #fff1f1;
  color: #9b1c1c;
}
.photo-verification-modal .photo-verification-user-profile-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: auto;
}
.photo-verification-modal .photo-verification-user-profile-link .icon {
  font-size: 13px;
  line-height: 1;
}
@media (max-width: 700px) {
  .photo-verification-modal .photo-verification-detail-layout {
    grid-template-columns: 1fr;
  }
}

.venue-suggestion-modal {
  width: min(640px, 92vw);
}
.venue-suggestion-modal .venue-suggestion-detail-layout {
  display: grid;
  grid-gap: 16px;
  gap: 16px;
  margin-top: 16px;
}
.venue-suggestion-modal .venue-suggestion-detail-map-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  border-radius: 8px;
  background: var(--color-background-light);
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  color: #cccccc;
  color: var(--color-light-gray);
  font-size: 13px;
}
.venue-suggestion-modal .venue-suggestion-detail-stats dl {
  margin: 0;
  display: grid;
  grid-gap: 10px;
  gap: 10px;
}
.venue-suggestion-modal .venue-suggestion-detail-stats div {
  display: grid;
  grid-template-columns: 140px 1fr;
  grid-gap: 8px;
  gap: 8px;
}
.venue-suggestion-modal .venue-suggestion-detail-stats dt {
  margin: 0;
  color: #cccccc;
  color: var(--color-light-gray);
  font-size: 13px;
}
.venue-suggestion-modal .venue-suggestion-detail-stats dd {
  margin: 0;
  font-size: 14px;
}
.venue-suggestion-modal .venue-suggestion-feedback-link {
  margin-right: auto;
}

.refund-request-modal {
  width: min(680px, 92vw);
}
.refund-request-modal .refund-request-header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.refund-request-modal .refund-request-header h3 {
  margin: 0;
}
.refund-request-modal .refund-request-section {
  margin-top: 20px;
}
.refund-request-modal .refund-request-section h4 {
  margin: 0 0 10px;
  font-size: 14px;
}
.refund-request-modal .refund-request-section dl {
  margin: 0;
  display: grid;
  grid-gap: 10px;
  gap: 10px;
}
.refund-request-modal .refund-request-section dl > div {
  display: grid;
  grid-template-columns: 140px 1fr;
  grid-gap: 8px;
  gap: 8px;
}
.refund-request-modal .refund-request-section dt {
  margin: 0;
  color: #cccccc;
  color: var(--color-light-gray);
  font-size: 13px;
}
.refund-request-modal .refund-request-section dd {
  margin: 0;
  font-size: 14px;
}
.refund-request-modal .refund-request-reason {
  white-space: pre-wrap;
}
.refund-request-modal .refund-request-hint {
  margin: 0 0 8px;
  font-size: 13px;
  color: #cccccc;
  color: var(--color-light-gray);
}
.refund-request-modal .refund-request-failure {
  color: #aa0000;
  color: var(--color-error);
}
.refund-request-modal .refund-request-action-error {
  margin-top: 16px;
}
.refund-request-modal .refund-request-feedback-link {
  margin-right: auto;
}

.partnered-hotspot-modal__selected {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.partnered-hotspot-modal__label {
  font-size: 15px;
  font-weight: 600;
}
.partnered-hotspot-modal__muted {
  opacity: 0.7;
  font-size: 12px;
}
.partnered-hotspot-modal__results {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  max-height: 220px;
  overflow: auto;
}
.partnered-hotspot-modal__result {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 0.4rem 0.6rem;
  border: 1px solid #e0e0e0;
  border: 1px solid var(--color-light-line);
  border-radius: 10px;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}
.partnered-hotspot-modal__result.selected {
  border-color: rgba(90, 138, 124, 0.8);
}
.partnered-hotspot-modal__result-name {
  font-weight: 600;
}

.event-journey-modal {
  width: min(680px, 92vw);
}
.event-journey-modal h3 {
  margin: 0;
}
.event-journey-modal__link {
  margin-right: auto;
  text-decoration: none;
}

.event-journey-section {
  margin-top: 20px;
}
.event-journey-section h4 {
  margin: 0 0 10px;
  font-size: 14px;
}
.event-journey-section dl {
  margin: 0;
  display: grid;
  grid-gap: 10px;
  gap: 10px;
}
.event-journey-section dl > div {
  display: grid;
  grid-template-columns: 140px 1fr;
  grid-gap: 8px;
  gap: 8px;
}
.event-journey-section dt {
  margin: 0;
  color: #cccccc;
  color: var(--color-light-gray);
  font-size: 13px;
}
.event-journey-section dd {
  margin: 0;
  font-size: 14px;
}

.event-journey-empty {
  color: #cccccc;
  color: var(--color-light-gray);
  font-size: 13px;
}

.event-journey-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-gap: 6px;
  gap: 6px;
}
.event-journey-timeline li {
  display: grid;
  grid-template-columns: 170px 1fr auto;
  grid-gap: 12px;
  gap: 12px;
  align-items: baseline;
  padding: 6px 10px;
  border-left: 2px solid #cccccc;
  border-left: 2px solid var(--color-light-gray);
  font-size: 13px;
}
.event-journey-timeline li.is-conversion {
  border-left-color: #3a5443ff;
  border-left-color: var(--color-primary);
  font-weight: 600;
}
.event-journey-timeline__time, .event-journey-timeline__source {
  color: #cccccc;
  color: var(--color-light-gray);
}
@media (max-width: 640px) {
  .event-journey-timeline li {
    grid-template-columns: 1fr;
    gap: 2px;
  }
}

.event-journey-page__venue {
  font-weight: 400;
  color: #cccccc;
  color: var(--color-light-gray);
}
.event-journey-page__heading {
  margin: 24px 0 12px;
  font-size: 16px;
}

.event-journey-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  grid-gap: 12px;
  gap: 12px;
  margin-top: 16px;
}

.event-journey-tile {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  border-radius: 10px;
}
.event-journey-tile__label {
  font-size: 13px;
  color: #cccccc;
  color: var(--color-light-gray);
}
.event-journey-tile__value {
  font-size: 24px;
  font-weight: 600;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}
.event-journey-tile__sub {
  font-size: 12px;
  color: #cccccc;
  color: var(--color-light-gray);
}

.event-journey-users-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.event-journey-users-header .tab-bar {
  display: flex;
  gap: 24px;
}

.event-journey-users {
  display: grid;
  grid-gap: 12px;
  gap: 12px;
  margin-top: 12px;
}

.event-journey-user {
  padding: 12px 16px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  border-radius: 10px;
}
.event-journey-user__header {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px 16px;
  margin-bottom: 10px;
}
.event-journey-user__name {
  font-weight: 600;
}
.event-journey-user__meta {
  font-size: 13px;
  color: #cccccc;
  color: var(--color-light-gray);
}

.event-name-cell {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.event-ticketed-badge {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 600;
  line-height: 1.4;
  color: #14532d;
  padding: 1px 6px;
  border-radius: 4px;
  background: #f0fdf4;
  border: 1px solid #86efac;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

.event-journey-sources {
  width: 100%;
  margin-top: 16px;
  border-collapse: collapse;
  font-size: 13px;
}
.event-journey-sources th,
.event-journey-sources td {
  padding: 8px 10px;
  text-align: right;
  border-bottom: 1px solid #e0e0e0;
  border-bottom: 1px solid var(--color-light-line);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}
.event-journey-sources th:first-child,
.event-journey-sources td:first-child {
  text-align: left;
}
.event-journey-sources th {
  font-weight: 600;
  color: #cccccc;
  color: var(--color-light-gray);
}

.event-detail-modal {
  width: min(760px, 94vw);
}
.event-detail-modal__header {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.event-detail-modal__flyer {
  width: 96px;
  height: 128px;
  flex-shrink: 0;
  border-radius: 8px;
  background-size: cover;
  background-position: center;
  background-color: #e0e0e0;
  background-color: var(--color-light-line);
}
.event-detail-modal__title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.event-detail-modal__title h3 {
  margin: 0;
}
.event-detail-modal__subtitle {
  margin: 4px 0 0;
  font-size: 13px;
  color: #cccccc;
  color: var(--color-light-gray);
}
.event-detail-modal__content {
  white-space: pre-wrap;
}
.event-detail-modal__link {
  margin-right: auto;
  text-decoration: none;
}

.feature-flag-unsaved {
  margin-left: 10px;
  padding: 2px 8px;
  border-radius: 10px;
  background: #fff3d6;
  color: #8a6416;
  font-size: 11px;
  font-weight: 600;
  vertical-align: middle;
}

.map-action-icon {
  display: block;
  flex-shrink: 0;
}
.map-action-icon--muted {
  filter: brightness(0) invert(0.773);
}
.map-action-icon--white {
  filter: brightness(0) invert(1);
}

.map-action-tile {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #1c1c1c;
}
.map-action-tile--lg {
  width: 56px;
  height: 56px;
}
.map-action-tile.is-disabled {
  opacity: 0.35;
}

.map-action-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  background: #1c1c1c;
  color: #f2f2f2;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
}
.map-action-pill--icon {
  background: #2b2b2b;
  color: #fff;
}
.map-action-pill__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.map-action-marker-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.map-action-state--active {
  --state-color: #11aa11;
}

.map-action-state--disabled {
  --state-color: #c88a00;
}

.map-action-state--hidden {
  --state-color: #888888;
}

.map-actions-editor {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 220px;
  grid-gap: 20px;
  gap: 20px;
  align-items: start;
  margin-top: 8px;
}
@media (max-width: 900px) {
  .map-actions-editor {
    grid-template-columns: minmax(0, 1fr);
  }
}

.map-action-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.map-action-row {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto auto auto;
  align-items: center;
  grid-gap: 12px;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  border-left: 4px solid #dee2e6;
  border-left: 4px solid var(--state-color, var(--color-border));
  border-radius: 8px;
  background: #ffffff;
  background: var(--color-background);
}
.map-action-row--active {
  --state-color: #11aa11;
}
.map-action-row--disabled {
  --state-color: #c88a00;
}
.map-action-row--hidden {
  --state-color: #888888;
}
.map-action-row--hidden .map-action-tile,
.map-action-row--hidden .map-action-row__main,
.map-action-row--hidden .map-action-row__pill {
  opacity: 0.45;
}
.map-action-row--overlay {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}
@media (max-width: 700px) {
  .map-action-row {
    grid-template-columns: auto auto minmax(0, 1fr);
  }
  .map-action-row .map-action-row__pill {
    display: none;
  }
}
.map-action-row__main {
  min-width: 0;
}
.map-action-row__title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
}
.map-action-row__title code {
  font-weight: 400;
  font-size: 12px;
  opacity: 0.6;
}
.map-action-row__tag {
  padding: 1px 6px;
  border-radius: 4px;
  background: #eaf2ff;
  background: var(--color-highlight);
  font-size: 11px;
  font-weight: 500;
}
.map-action-row__description {
  margin-top: 2px;
  font-size: 12px;
  opacity: 0.7;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.map-action-row__edit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  border-radius: 6px;
  background: transparent;
  color: inherit;
  font-size: 13px;
  cursor: pointer;
}
.map-action-row__edit:hover:not(:disabled) {
  background: #eaf2ff;
  background: var(--color-highlight);
}

.map-action-state-select {
  border-color: var(--state-color) !important;
  color: var(--state-color);
  font-weight: 600;
  background: transparent;
}

.map-actions-error {
  margin-top: 8px;
}

.map-actions-phone {
  position: -webkit-sticky;
  position: sticky;
  top: 16px;
}
.map-actions-phone__label {
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  opacity: 0.7;
}
.map-actions-phone__screen {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  min-height: 420px;
  padding: 16px;
  border: 6px solid #1c1c1c;
  border-radius: 28px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.5) 25%, transparent 25%) 0 0/28px 28px, #e6ece7;
}
.map-actions-phone__sidebar {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 64px;
  padding: 12px;
  border-radius: 55px;
  background: #1c1c1c;
  box-shadow: 0 8px 10px -8px rgba(0, 0, 0, 0.3);
}
.map-actions-phone__action {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: none;
  border-radius: 29px;
  background: transparent;
  cursor: pointer;
}
.map-actions-phone__action.is-selected {
  background: #3a3a3a;
}
.map-actions-phone__action.is-disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.map-actions-phone__empty {
  color: #c5c5c5;
  font-size: 10px;
  text-align: center;
}
.map-actions-phone__pill-slot {
  align-self: center;
  min-height: 32px;
  display: flex;
  align-items: center;
}
.map-actions-phone__hint {
  font-size: 11px;
  color: #555;
  text-align: center;
}

.map-action-modal {
  width: 100%;
  max-width: 600px;
  max-height: 92vh;
  overflow-y: auto;
}
.map-action-modal .modal-content-wrapper {
  overflow: visible;
}
.map-action-modal .styled-button.cancel {
  background: transparent;
  color: inherit;
  box-shadow: none;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
}
.map-action-modal .styled-button.cancel:hover {
  background: #eaf2ff;
  background: var(--color-highlight);
}
.map-action-modal__header {
  display: flex;
  align-items: center;
  gap: 12px;
}
.map-action-modal__header code {
  font-size: 12px;
  opacity: 0.6;
}
.map-action-modal__description {
  font-size: 13px;
  opacity: 0.8;
  line-height: 1.45;
}
.map-action-modal__body {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.map-action-modal__section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.map-action-modal__section-title {
  font-size: 13px;
  font-weight: 600;
}
.map-action-modal__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px 16px;
  gap: 12px 16px;
}
@media (max-width: 560px) {
  .map-action-modal__grid {
    grid-template-columns: 1fr;
  }
}
.map-action-modal__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.map-action-modal__field--spaced {
  margin-top: 8px;
}
.map-action-modal__icon-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}
.map-action-modal__icon-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.map-action-modal__buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.map-action-modal__color-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.map-action-modal__color-row .map-filter-hex {
  margin-left: 0;
  font-family: monospace;
}
.map-action-modal__swatches {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-left: 4px;
}
.map-action-modal__preview {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #e6ece7;
}
.map-action-modal__preview .feature-flag-subtitle {
  color: #333;
}
.map-action-modal__error {
  color: #aa0000;
  color: var(--color-error);
  font-size: 12px;
}
.map-action-modal__reset {
  margin-right: auto !important;
}

.map-action-swatch {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #dee2e6;
  box-shadow: 0 0 0 1px var(--color-border);
  cursor: pointer;
}
.map-action-swatch.is-selected {
  border-color: #ffffff;
  border-color: var(--color-background);
  box-shadow: 0 0 0 2px #000000;
  box-shadow: 0 0 0 2px var(--color-super-black);
}

.map-action-state-segmented {
  display: inline-flex;
  align-self: flex-start;
  border: 1px solid #dee2e6;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  overflow: hidden;
}
.map-action-state-segmented__option {
  padding: 7px 16px;
  border: none;
  border-right: 1px solid #dee2e6;
  border-right: 1px solid var(--color-border);
  background: transparent;
  color: inherit;
  font-size: 13px;
  cursor: pointer;
}
.map-action-state-segmented__option:last-child {
  border-right: none;
}
.map-action-state-segmented__option.is-selected {
  background: var(--state-color);
  color: #fff;
  font-weight: 600;
}

.map-action-modal__icon-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.map-action-icon-search {
  max-width: 200px;
  font-weight: 400;
}

.map-action-icon-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));
  grid-gap: 6px;
  gap: 6px;
  max-height: 228px;
  overflow-y: auto;
  padding: 2px;
}

.map-action-icon-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 4px 6px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  cursor: pointer;
}
.map-action-icon-option:hover {
  background: #eaf2ff;
  background: var(--color-highlight);
}
.map-action-icon-option.is-selected {
  border-color: #3a5443ff;
  border-color: var(--color-primary);
  background: #284f4330;
  background: var(--color-primary-translucent);
}
.map-action-icon-option--static {
  cursor: default;
  flex-shrink: 0;
}
.map-action-icon-option__label {
  font-size: 11px;
  line-height: 1.2;
  text-align: center;
}

.map-ui-status-tag {
  margin-left: 10px;
  padding: 2px 8px;
  border-radius: 10px;
  background: #eaf2ff;
  background: var(--color-highlight);
  font-size: 11px;
  font-weight: 600;
  vertical-align: middle;
  opacity: 0.85;
}
.map-ui-status-tag.is-live {
  background: #dcf5dc;
  color: #1f7a1f;
  opacity: 1;
}

.table th.select-header,
.table td.select-cell {
  width: 36px;
  text-align: center;
}
.table th.select-header input[type=checkbox],
.table td.select-cell input[type=checkbox] {
  cursor: pointer;
  width: 16px;
  height: 16px;
}

.stickers-admin .stickers-admin-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.stickers-admin .stickers-admin-tabs {
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.06);
}
.stickers-admin .stickers-admin-tab {
  border: none;
  background: transparent;
  padding: 6px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 500;
}
.stickers-admin .stickers-admin-tab.active {
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
}
.stickers-admin .stickers-admin-tab-count {
  display: inline-block;
  min-width: 18px;
  margin-left: 6px;
  padding: 0 6px;
  border-radius: 9px;
  background: #c92f2f;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 18px;
  text-align: center;
}
.stickers-admin .stickers-admin-bulk {
  display: flex;
  align-items: center;
  gap: 8px;
}
.stickers-admin .stickers-admin-bulk span {
  margin-right: 4px;
  opacity: 0.7;
}
.stickers-admin .stickers-admin-reports {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 1100px;
}
.stickers-admin .stickers-admin-report {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  transition: box-shadow 0.15s ease;
}
.stickers-admin .stickers-admin-report:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}
.stickers-admin .stickers-admin-report.resolved {
  opacity: 0.55;
  background: rgba(0, 0, 0, 0.02);
}
.stickers-admin .stickers-admin-report .thumbnail,
.stickers-admin .stickers-admin-report .stickers-admin-report-kind {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
}
.stickers-admin .stickers-admin-report .stickers-admin-report-kind {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.45);
  font-size: 18px;
}
.stickers-admin .stickers-admin-report .stickers-admin-report-kind span {
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
@media (max-width: 760px) {
  .stickers-admin .stickers-admin-report {
    flex-wrap: wrap;
  }
  .stickers-admin .stickers-admin-report .stickers-admin-report-actions {
    width: 100%;
    padding-left: 66px;
  }
}
.stickers-admin .stickers-admin-report-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.stickers-admin .stickers-admin-report-text {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.stickers-admin .stickers-admin-report-text .muted {
  opacity: 0.55;
  font-style: italic;
}
.stickers-admin .stickers-admin-report-type {
  display: inline-block;
  margin-right: 8px;
  padding: 1px 7px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.06);
  font-size: 11px;
  font-weight: 600;
  vertical-align: 1px;
}
.stickers-admin .stickers-admin-report-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 14px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.stickers-admin .stickers-admin-report-meta .icon {
  margin-right: 3px;
  opacity: 0.7;
}
.stickers-admin .stickers-admin-report-reason {
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(201, 47, 47, 0.1);
  color: #a82626;
  font-weight: 500;
}
.stickers-admin .stickers-admin-report-reason .icon {
  opacity: 1;
}
.stickers-admin .stickers-admin-report-status {
  padding: 3px 10px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.06);
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}
.stickers-admin .stickers-admin-report-actions {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}
.stickers-admin .stickers-admin-report-actions .report-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: #fff;
  color: #1c1c1c;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.stickers-admin .stickers-admin-report-actions .report-action:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.04);
}
.stickers-admin .stickers-admin-report-actions .report-action.keep:hover:not(:disabled) {
  border-color: #2e7d4f;
  color: #2e7d4f;
  background: rgba(46, 125, 79, 0.06);
}
.stickers-admin .stickers-admin-report-actions .report-action.remove {
  color: #c92f2f;
  border-color: rgba(201, 47, 47, 0.35);
}
.stickers-admin .stickers-admin-report-actions .report-action.remove:hover:not(:disabled) {
  background: rgba(201, 47, 47, 0.08);
  border-color: #c92f2f;
}
.stickers-admin .stickers-admin-report-actions .report-action:disabled {
  opacity: 0.5;
  cursor: default;
}

.moderation-flag-badge.pinned {
  background: #43f099;
  color: #1c1c1c;
}

.stickers-admin-settings {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 560px;
}
.stickers-admin-settings .stickers-admin-setting {
  display: grid;
  grid-template-columns: 1fr 120px;
  grid-gap: 4px 16px;
  gap: 4px 16px;
  align-items: center;
}
.stickers-admin-settings .stickers-admin-setting input {
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  font-size: 14px;
}
.stickers-admin-settings .stickers-admin-setting-label {
  font-weight: 600;
}
.stickers-admin-settings .stickers-admin-setting input[type=checkbox] {
  justify-self: start;
  width: 18px;
  height: 18px;
  padding: 0;
}
.stickers-admin-settings .stickers-admin-setting-hint {
  grid-column: 1/-1;
  font-size: 12px;
  opacity: 0.7;
}
.stickers-admin-settings .stickers-admin-setting-message {
  font-size: 13px;
}
.stickers-admin-settings .stickers-admin-setting-actions {
  display: flex;
  gap: 8px;
}

.eventbrite-events-tab {
  padding: 4px 0 24px;
}

.eventbrite-page__title,
.eventbrite-import-title {
  display: flex;
  align-items: center;
  gap: 12px;
}
.eventbrite-page__title img,
.eventbrite-import-title img {
  width: 36px;
  height: 36px;
}

.eventbrite-import-title {
  gap: 8px;
}
.eventbrite-import-title img {
  width: 20px;
  height: 20px;
}

.eb-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  padding: 0 14px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  background: #ffffff;
  background: var(--color-white);
  color: rgba(0, 0, 0, 0.8);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.eb-button:hover:not(:disabled) {
  background: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.3);
}
.eb-button:disabled {
  opacity: 0.45;
  cursor: default;
}
.eb-button--primary {
  border-color: #3a5443ff;
  border-color: var(--color-primary);
  background: #3a5443ff;
  background: var(--color-primary);
  color: #ffffff;
  color: var(--color-white);
}
.eb-button--primary:hover:not(:disabled) {
  background: #3a5443ff;
  background: var(--color-primary);
  border-color: #3a5443ff;
  border-color: var(--color-primary);
  filter: brightness(1.12);
}
.eb-button--danger {
  border-color: rgba(192, 57, 43, 0.35);
  color: #c0392b;
}
.eb-button--danger:hover:not(:disabled) {
  background: rgba(192, 57, 43, 0.06);
  border-color: #c0392b;
}

.eventbrite-events-table__no-venue {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}
.eventbrite-events-table__no-venue .eventbrite-events-tab__error {
  margin-top: 0;
}

.eventbrite-events-table__eb-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.eventbrite-events-table__eb-link img {
  width: 12px;
  height: 12px;
}

.eventbrite-events-tab__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}
.eventbrite-events-tab__toolbar .eventbrite-events-tab__note {
  flex: 1 1 320px;
  margin: 0;
}
.eventbrite-events-tab__toolbar label {
  display: flex;
  align-items: center;
  gap: 8px;
}
.eventbrite-events-tab__toolbar .styled-button {
  width: auto;
  padding: 0 18px;
  white-space: nowrap;
}

.eventbrite-events-tab__note {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.eventbrite-events-tab__error {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  color: #c0392b;
}

.eventbrite-events-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.eventbrite-events-table th,
.eventbrite-events-table td {
  padding: 10px 12px;
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.eventbrite-events-table th {
  font-weight: 600;
  white-space: nowrap;
}
.eventbrite-events-table select {
  max-width: 260px;
  height: 34px;
}
.eventbrite-events-table .styled-button {
  width: auto;
  padding: 0 16px;
  white-space: nowrap;
}

.eventbrite-events-table__tags,
.eventbrite-events-table__sub {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
}

.eventbrite-events-table__link {
  display: block;
  padding: 0;
  border: 0;
  background: none;
  color: #284f43;
  color: var(--color-button-background);
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  text-decoration: underline;
}

.eventbrite-events-table__check {
  width: 32px;
}
.eventbrite-events-table__check input[type=checkbox] {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.eventbrite-events-table__name {
  font-weight: 600;
}

.eventbrite-events-table__row--linked td {
  color: rgba(0, 0, 0, 0.55);
}

.eventbrite-events-table__badge {
  display: inline-block;
  margin-left: 8px;
  padding: 1px 8px;
  border-radius: 10px;
  background: rgba(46, 125, 50, 0.12);
  color: #2e7d32;
  font-size: 12px;
  font-weight: 600;
  vertical-align: middle;
}

.eventbrite-events-table__linked {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.eventbrite-events-table__linked + .eventbrite-events-table__linked {
  margin-top: 6px;
}
.eventbrite-events-table__linked .styled-button {
  width: auto;
  padding: 0 14px;
}

.eventbrite-events-table__edit-row td {
  background: rgba(0, 0, 0, 0.03);
}

.eventbrite-quick-edit {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 16px;
  gap: 16px;
}
.eventbrite-quick-edit label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  position: relative;
}
.eventbrite-quick-edit input[type=text],
.eventbrite-quick-edit select {
  height: 36px;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
  max-width: none;
}

.eventbrite-quick-edit__results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 5;
  margin: 4px 0 0;
  padding: 4px 0;
  list-style: none;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
}
.eventbrite-quick-edit__results button {
  display: block;
  width: 100%;
  padding: 6px 10px;
  border: 0;
  background: none;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  cursor: pointer;
}
.eventbrite-quick-edit__results button:hover {
  background: rgba(0, 0, 0, 0.05);
}
.eventbrite-quick-edit__results button span {
  display: block;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,2CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFFF;;AI9GI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;AFFJ;;AKtKA;;;EAGE,sBAAA;ALyKF;;AK1JI;EANJ;IAOM,uBAAA;EL8JJ;AACF;;AKjJA;EACE,SAAA;EACA,4MAAA;EAAA,uCAAA;EF6OI,eALI;EAKJ,mCALI;EEtOR,gBAAA;EAAA,uCAAA;EACA,gBAAA;EAAA,uCAAA;EACA,cAAA;EAAA,2BAAA;EACA,qCAAA;EACA,sBAAA;EAAA,mCAAA;EACA,8BAAA;EACA,6CAAA;ALoJF;;AK3IA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,qBAAA;EAAA,wCAAA;EACA,aCynB4B;AN3e9B;;AKpIA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,cAAA;EAAA,8BAAA;ALqIF;;AKlIA;EFuMQ,iCAAA;AHjER;AG3FI;EE3CJ;IF8MQ,iBAAA;EHpEN;AACF;;AKtIA;EFkMQ,iCAAA;AHxDR;AGpGI;EEtCJ;IFyMQ,eAAA;EH3DN;AACF;;AK1IA;EF6LQ,+BAAA;AH/CR;AG7GI;EEjCJ;IFoMQ,kBAAA;EHlDN;AACF;;AK9IA;EFwLQ,iCAAA;AHtCR;AGtHI;EE5BJ;IF+LQ,iBAAA;EHzCN;AACF;;AKlJA;EF+KM,kBALI;AHpBV;;AKjJA;EF0KM,eALI;AHhBV;;AK1IA;EACE,aAAA;EACA,mBCwV0B;AN3M5B;;AKnIA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,sCAAA;UAAA,8BAAA;ALsIF;;AKhIA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALmIF;;AK7HA;;EAEE,kBAAA;ALgIF;;AK7HA;;;EAGE,aAAA;EACA,mBAAA;ALgIF;;AK7HA;;;;EAIE,gBAAA;ALgIF;;AK7HA;EACE,gBC6b4B;AN7T9B;;AK3HA;EACE,qBAAA;EACA,cAAA;AL8HF;;AKxHA;EACE,gBAAA;AL2HF;;AKnHA;;EAEE,mBCsa4B;ANhT9B;;AK9GA;EF6EM,kBALI;AH0CV;;AK3GA;EACE,iBCqf4B;EDpf5B,cAAA;EAAA,gCAAA;EACA,wCAAA;EAAA,wCAAA;AL8GF;;AKrGA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ALwGF;;AKrGA;EAAM,eAAA;ALyGN;;AKxGA;EAAM,WAAA;AL4GN;;AKvGA;EACE,4BAAA;EAAA,gEAAA;EACA,0BCgNwC;ANtG1C;AKxGE;EACE,mDAAA;AL0GJ;;AK/FE;EAEE,cAAA;EACA,qBAAA;ALiGJ;;AK1FA;;;;EAIE,iGCgV4B;EDhV5B,qCCgV4B;EHlUxB,cALI;AHqFV;;AKtFA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AH6FV;AKrFE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ALuFJ;;AKnFA;EFVM,kBALI;EEiBR,cAAA;EAAA,2BAAA;EACA,qBAAA;ALsFF;AKnFE;EACE,cAAA;ALqFJ;;AKjFA;EACE,2BAAA;EFtBI,kBALI;EE6BR,WC25CkC;ED35ClC,wBC25CkC;ED15ClC,yBC25CkC;ED35ClC,sCC25CkC;EChsDhC,sBAAA;AP0XJ;AKlFE;EACE,UAAA;EF7BE,cALI;AHuHV;;AK1EA;EACE,gBAAA;AL6EF;;AKvEA;;EAEE,sBAAA;AL0EF;;AKlEA;EACE,oBAAA;EACA,yBAAA;ALqEF;;AKlEA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,6BC4Z4B;ED5Z5B,gCC4Z4B;ED3Z5B,gBAAA;ALqEF;;AK9DA;EAEE,mBAAA;EACA,gCAAA;ALgEF;;AK7DA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ALgEF;;AKxDA;EACE,qBAAA;AL2DF;;AKrDA;EAEE,gBAAA;ALuDF;;AK/CA;EACE,UAAA;ALkDF;;AK7CA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ALgDF;;AK5CA;;EAEE,oBAAA;AL+CF;;AK1CA;EACE,eAAA;AL6CF;;AK1CA;EAGE,iBAAA;AL2CF;AKxCE;EACE,UAAA;AL0CJ;;AKnCA;EACE,wBAAA;ALsCF;;AK9BA;;;;EAIE,0BAAA;ALiCF;AK9BI;;;;EACE,eAAA;ALmCN;;AK5BA;EACE,UAAA;EACA,kBAAA;AL+BF;;AK1BA;EACE,gBAAA;AL6BF;;AKnBA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALsBF;;AKdA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EDjN5B,oBAAA;EFnNM,iCAAA;AHoOR;AGhYI;EEyWJ;IFtMQ,iBAAA;EHiON;AACF;AKnBE;EACE,WAAA;ALqBJ;;AKdA;;;;;;;EAOE,UAAA;ALiBF;;AKdA;EACE,YAAA;ALiBF;;AKRA;EACE,6BAAA;EACA,oBAAA;ALWF;AKRE;EACE,eAAA;EACA,oBAAA;ALUJ;;AKDA;;;;;;;CAAA;AAWA;EACE,wBAAA;ALCF;;AKIA;EACE,UAAA;ALDF;;AKQA;EACE,aAAA;EACA,0BAAA;ALLF;;AKGA;EACE,aAAA;EACA,0BAAA;ALLF;;AKUA;EACE,qBAAA;ALPF;;AKYA;EACE,SAAA;ALTF;;AKgBA;EACE,kBAAA;EACA,eAAA;ALbF;;AKqBA;EACE,wBAAA;ALlBF;;AK0BA;EACE,wBAAA;ALvBF;;AQpjBA;ELmQM,kBALI;EK5PR,gBFwoB4B;ANjF9B;;AQljBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHwTR;AGpdI;EKpGF;ILuQM,eAAA;EHqTN;AACF;;AQ7jBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHmUR;AG/dI;EKpGF;ILuQM,iBAAA;EHgUN;AACF;;AQxkBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AH8UR;AG1eI;EKpGF;ILuQM,eAAA;EH2UN;AACF;;AQnlBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHyVR;AGrfI;EKpGF;ILuQM,iBAAA;EHsVN;AACF;;AQ9lBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHoWR;AGhgBI;EKpGF;ILuQM,eAAA;EHiWN;AACF;;AQzmBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AH+WR;AG3gBI;EKpGF;ILuQM,iBAAA;EH4WN;AACF;;AQ5lBA;ECvDE,eAAA;EACA,gBAAA;ATupBF;;AQ5lBA;EC5DE,eAAA;EACA,gBAAA;AT4pBF;;AQ9lBA;EACE,qBAAA;ARimBF;AQ/lBE;EACE,oBFsoB0B;ANrC9B;;AQvlBA;EL8MM,kBALI;EKvMR,yBAAA;AR0lBF;;AQtlBA;EACE,mBFiUO;EH1HH,kBALI;AHwZV;AQvlBE;EACE,gBAAA;ARylBJ;;AQrlBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;AN8qBX;AQtlBE;EACE,aAAA;ARwlBJ;;AUxrBA;ECIE,eAAA;EAGA,YAAA;AXsrBF;;AUvrBA;EACE,gBJ+jDkC;EI9jDlC,sBJ+jDkC;EI/jDlC,mCJ+jDkC;EI9jDlC,yBAAA;EAAA,2DAAA;EHGE,uBAAA;EAAA,sCAAA;EIRF,eAAA;EAGA,YAAA;AX+rBF;;AUjrBA;EAEE,qBAAA;AVmrBF;;AUhrBA;EACE,qBAAA;EACA,cAAA;AVmrBF;;AUhrBA;EPyPM,kBALI;EOlPR,6BJkjDkC;EIljDlC,gCJkjDkC;AN/3BpC;;AYrtBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AbkuBF;;Ac5qBI;EF5CE;IACE,gBNkee;EN0PrB;AACF;AclrBI;EF5CE;IACE,gBNkee;EN+PrB;AACF;AcvrBI;EF5CE;IACE,gBNkee;ENoQrB;AACF;Ac5rBI;EF5CE;IACE,iBNkee;ENyQrB;AACF;AcjsBI;EF5CE;IACE,iBNkee;EN8QrB;AACF;AejwBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AfuwBJ;;AelwBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhB2wBF;AezwBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhBqwBF;;AgBttBM;EACE,SAAA;AhBytBR;;AgBttBM;EApCJ,cAAA;EACA,WAAA;AhB8vBF;;AgBhvBE;EACE,cAAA;EACA,WAAA;AhBmvBJ;;AgBrvBE;EACE,cAAA;EACA,UAAA;AhBwvBJ;;AgB1vBE;EACE,cAAA;EACA,mBAAA;AhB6vBJ;;AgB/vBE;EACE,cAAA;EACA,UAAA;AhBkwBJ;;AgBpwBE;EACE,cAAA;EACA,UAAA;AhBuwBJ;;AgBzwBE;EACE,cAAA;EACA,mBAAA;AhB4wBJ;;AgB7uBM;EAhDJ,cAAA;EACA,WAAA;AhBiyBF;;AgB5uBU;EAhEN,cAAA;EACA,kBAAA;AhBgzBJ;;AgBjvBU;EAhEN,cAAA;EACA,mBAAA;AhBqzBJ;;AgBtvBU;EAhEN,cAAA;EACA,UAAA;AhB0zBJ;;AgB3vBU;EAhEN,cAAA;EACA,mBAAA;AhB+zBJ;;AgBhwBU;EAhEN,cAAA;EACA,mBAAA;AhBo0BJ;;AgBrwBU;EAhEN,cAAA;EACA,UAAA;AhBy0BJ;;AgB1wBU;EAhEN,cAAA;EACA,mBAAA;AhB80BJ;;AgB/wBU;EAhEN,cAAA;EACA,mBAAA;AhBm1BJ;;AgBpxBU;EAhEN,cAAA;EACA,UAAA;AhBw1BJ;;AgBzxBU;EAhEN,cAAA;EACA,mBAAA;AhB61BJ;;AgB9xBU;EAhEN,cAAA;EACA,mBAAA;AhBk2BJ;;AgBnyBU;EAhEN,cAAA;EACA,WAAA;AhBu2BJ;;AgBhyBY;EAxDV,wBAAA;AhB41BF;;AgBpyBY;EAxDV,yBAAA;AhBg2BF;;AgBxyBY;EAxDV,gBAAA;AhBo2BF;;AgB5yBY;EAxDV,yBAAA;AhBw2BF;;AgBhzBY;EAxDV,yBAAA;AhB42BF;;AgBpzBY;EAxDV,gBAAA;AhBg3BF;;AgBxzBY;EAxDV,yBAAA;AhBo3BF;;AgB5zBY;EAxDV,yBAAA;AhBw3BF;;AgBh0BY;EAxDV,gBAAA;AhB43BF;;AgBp0BY;EAxDV,yBAAA;AhBg4BF;;AgBx0BY;EAxDV,yBAAA;AhBo4BF;;AgBj0BQ;;EAEE,gBAAA;AhBo0BV;;AgBj0BQ;;EAEE,gBAAA;AhBo0BV;;AgB30BQ;;EAEE,sBAAA;AhB80BV;;AgB30BQ;;EAEE,sBAAA;AhB80BV;;AgBr1BQ;;EAEE,qBAAA;AhBw1BV;;AgBr1BQ;;EAEE,qBAAA;AhBw1BV;;AgB/1BQ;;EAEE,mBAAA;AhBk2BV;;AgB/1BQ;;EAEE,mBAAA;AhBk2BV;;AgBz2BQ;;EAEE,qBAAA;AhB42BV;;AgBz2BQ;;EAEE,qBAAA;AhB42BV;;AgBn3BQ;;EAEE,mBAAA;AhBs3BV;;AgBn3BQ;;EAEE,mBAAA;AhBs3BV;;Ach7BI;EEUE;IACE,SAAA;EhB06BN;EgBv6BI;IApCJ,cAAA;IACA,WAAA;EhB88BA;EgBh8BA;IACE,cAAA;IACA,WAAA;EhBk8BF;EgBp8BA;IACE,cAAA;IACA,UAAA;EhBs8BF;EgBx8BA;IACE,cAAA;IACA,mBAAA;EhB08BF;EgB58BA;IACE,cAAA;IACA,UAAA;EhB88BF;EgBh9BA;IACE,cAAA;IACA,UAAA;EhBk9BF;EgBp9BA;IACE,cAAA;IACA,mBAAA;EhBs9BF;EgBv7BI;IAhDJ,cAAA;IACA,WAAA;EhB0+BA;EgBr7BQ;IAhEN,cAAA;IACA,kBAAA;EhBw/BF;EgBz7BQ;IAhEN,cAAA;IACA,mBAAA;EhB4/BF;EgB77BQ;IAhEN,cAAA;IACA,UAAA;EhBggCF;EgBj8BQ;IAhEN,cAAA;IACA,mBAAA;EhBogCF;EgBr8BQ;IAhEN,cAAA;IACA,mBAAA;EhBwgCF;EgBz8BQ;IAhEN,cAAA;IACA,UAAA;EhB4gCF;EgB78BQ;IAhEN,cAAA;IACA,mBAAA;EhBghCF;EgBj9BQ;IAhEN,cAAA;IACA,mBAAA;EhBohCF;EgBr9BQ;IAhEN,cAAA;IACA,UAAA;EhBwhCF;EgBz9BQ;IAhEN,cAAA;IACA,mBAAA;EhB4hCF;EgB79BQ;IAhEN,cAAA;IACA,mBAAA;EhBgiCF;EgBj+BQ;IAhEN,cAAA;IACA,WAAA;EhBoiCF;EgB79BU;IAxDV,cAAA;EhBwhCA;EgBh+BU;IAxDV,wBAAA;EhB2hCA;EgBn+BU;IAxDV,yBAAA;EhB8hCA;EgBt+BU;IAxDV,gBAAA;EhBiiCA;EgBz+BU;IAxDV,yBAAA;EhBoiCA;EgB5+BU;IAxDV,yBAAA;EhBuiCA;EgB/+BU;IAxDV,gBAAA;EhB0iCA;EgBl/BU;IAxDV,yBAAA;EhB6iCA;EgBr/BU;IAxDV,yBAAA;EhBgjCA;EgBx/BU;IAxDV,gBAAA;EhBmjCA;EgB3/BU;IAxDV,yBAAA;EhBsjCA;EgB9/BU;IAxDV,yBAAA;EhByjCA;EgBt/BM;;IAEE,gBAAA;EhBw/BR;EgBr/BM;;IAEE,gBAAA;EhBu/BR;EgB9/BM;;IAEE,sBAAA;EhBggCR;EgB7/BM;;IAEE,sBAAA;EhB+/BR;EgBtgCM;;IAEE,qBAAA;EhBwgCR;EgBrgCM;;IAEE,qBAAA;EhBugCR;EgB9gCM;;IAEE,mBAAA;EhBghCR;EgB7gCM;;IAEE,mBAAA;EhB+gCR;EgBthCM;;IAEE,qBAAA;EhBwhCR;EgBrhCM;;IAEE,qBAAA;EhBuhCR;EgB9hCM;;IAEE,mBAAA;EhBgiCR;EgB7hCM;;IAEE,mBAAA;EhB+hCR;AACF;Ac1lCI;EEUE;IACE,SAAA;EhBmlCN;EgBhlCI;IApCJ,cAAA;IACA,WAAA;EhBunCA;EgBzmCA;IACE,cAAA;IACA,WAAA;EhB2mCF;EgB7mCA;IACE,cAAA;IACA,UAAA;EhB+mCF;EgBjnCA;IACE,cAAA;IACA,mBAAA;EhBmnCF;EgBrnCA;IACE,cAAA;IACA,UAAA;EhBunCF;EgBznCA;IACE,cAAA;IACA,UAAA;EhB2nCF;EgB7nCA;IACE,cAAA;IACA,mBAAA;EhB+nCF;EgBhmCI;IAhDJ,cAAA;IACA,WAAA;EhBmpCA;EgB9lCQ;IAhEN,cAAA;IACA,kBAAA;EhBiqCF;EgBlmCQ;IAhEN,cAAA;IACA,mBAAA;EhBqqCF;EgBtmCQ;IAhEN,cAAA;IACA,UAAA;EhByqCF;EgB1mCQ;IAhEN,cAAA;IACA,mBAAA;EhB6qCF;EgB9mCQ;IAhEN,cAAA;IACA,mBAAA;EhBirCF;EgBlnCQ;IAhEN,cAAA;IACA,UAAA;EhBqrCF;EgBtnCQ;IAhEN,cAAA;IACA,mBAAA;EhByrCF;EgB1nCQ;IAhEN,cAAA;IACA,mBAAA;EhB6rCF;EgB9nCQ;IAhEN,cAAA;IACA,UAAA;EhBisCF;EgBloCQ;IAhEN,cAAA;IACA,mBAAA;EhBqsCF;EgBtoCQ;IAhEN,cAAA;IACA,mBAAA;EhBysCF;EgB1oCQ;IAhEN,cAAA;IACA,WAAA;EhB6sCF;EgBtoCU;IAxDV,cAAA;EhBisCA;EgBzoCU;IAxDV,wBAAA;EhBosCA;EgB5oCU;IAxDV,yBAAA;EhBusCA;EgB/oCU;IAxDV,gBAAA;EhB0sCA;EgBlpCU;IAxDV,yBAAA;EhB6sCA;EgBrpCU;IAxDV,yBAAA;EhBgtCA;EgBxpCU;IAxDV,gBAAA;EhBmtCA;EgB3pCU;IAxDV,yBAAA;EhBstCA;EgB9pCU;IAxDV,yBAAA;EhBytCA;EgBjqCU;IAxDV,gBAAA;EhB4tCA;EgBpqCU;IAxDV,yBAAA;EhB+tCA;EgBvqCU;IAxDV,yBAAA;EhBkuCA;EgB/pCM;;IAEE,gBAAA;EhBiqCR;EgB9pCM;;IAEE,gBAAA;EhBgqCR;EgBvqCM;;IAEE,sBAAA;EhByqCR;EgBtqCM;;IAEE,sBAAA;EhBwqCR;EgB/qCM;;IAEE,qBAAA;EhBirCR;EgB9qCM;;IAEE,qBAAA;EhBgrCR;EgBvrCM;;IAEE,mBAAA;EhByrCR;EgBtrCM;;IAEE,mBAAA;EhBwrCR;EgB/rCM;;IAEE,qBAAA;EhBisCR;EgB9rCM;;IAEE,qBAAA;EhBgsCR;EgBvsCM;;IAEE,mBAAA;EhBysCR;EgBtsCM;;IAEE,mBAAA;EhBwsCR;AACF;AcnwCI;EEUE;IACE,SAAA;EhB4vCN;EgBzvCI;IApCJ,cAAA;IACA,WAAA;EhBgyCA;EgBlxCA;IACE,cAAA;IACA,WAAA;EhBoxCF;EgBtxCA;IACE,cAAA;IACA,UAAA;EhBwxCF;EgB1xCA;IACE,cAAA;IACA,mBAAA;EhB4xCF;EgB9xCA;IACE,cAAA;IACA,UAAA;EhBgyCF;EgBlyCA;IACE,cAAA;IACA,UAAA;EhBoyCF;EgBtyCA;IACE,cAAA;IACA,mBAAA;EhBwyCF;EgBzwCI;IAhDJ,cAAA;IACA,WAAA;EhB4zCA;EgBvwCQ;IAhEN,cAAA;IACA,kBAAA;EhB00CF;EgB3wCQ;IAhEN,cAAA;IACA,mBAAA;EhB80CF;EgB/wCQ;IAhEN,cAAA;IACA,UAAA;EhBk1CF;EgBnxCQ;IAhEN,cAAA;IACA,mBAAA;EhBs1CF;EgBvxCQ;IAhEN,cAAA;IACA,mBAAA;EhB01CF;EgB3xCQ;IAhEN,cAAA;IACA,UAAA;EhB81CF;EgB/xCQ;IAhEN,cAAA;IACA,mBAAA;EhBk2CF;EgBnyCQ;IAhEN,cAAA;IACA,mBAAA;EhBs2CF;EgBvyCQ;IAhEN,cAAA;IACA,UAAA;EhB02CF;EgB3yCQ;IAhEN,cAAA;IACA,mBAAA;EhB82CF;EgB/yCQ;IAhEN,cAAA;IACA,mBAAA;EhBk3CF;EgBnzCQ;IAhEN,cAAA;IACA,WAAA;EhBs3CF;EgB/yCU;IAxDV,cAAA;EhB02CA;EgBlzCU;IAxDV,wBAAA;EhB62CA;EgBrzCU;IAxDV,yBAAA;EhBg3CA;EgBxzCU;IAxDV,gBAAA;EhBm3CA;EgB3zCU;IAxDV,yBAAA;EhBs3CA;EgB9zCU;IAxDV,yBAAA;EhBy3CA;EgBj0CU;IAxDV,gBAAA;EhB43CA;EgBp0CU;IAxDV,yBAAA;EhB+3CA;EgBv0CU;IAxDV,yBAAA;EhBk4CA;EgB10CU;IAxDV,gBAAA;EhBq4CA;EgB70CU;IAxDV,yBAAA;EhBw4CA;EgBh1CU;IAxDV,yBAAA;EhB24CA;EgBx0CM;;IAEE,gBAAA;EhB00CR;EgBv0CM;;IAEE,gBAAA;EhBy0CR;EgBh1CM;;IAEE,sBAAA;EhBk1CR;EgB/0CM;;IAEE,sBAAA;EhBi1CR;EgBx1CM;;IAEE,qBAAA;EhB01CR;EgBv1CM;;IAEE,qBAAA;EhBy1CR;EgBh2CM;;IAEE,mBAAA;EhBk2CR;EgB/1CM;;IAEE,mBAAA;EhBi2CR;EgBx2CM;;IAEE,qBAAA;EhB02CR;EgBv2CM;;IAEE,qBAAA;EhBy2CR;EgBh3CM;;IAEE,mBAAA;EhBk3CR;EgB/2CM;;IAEE,mBAAA;EhBi3CR;AACF;Ac56CI;EEUE;IACE,SAAA;EhBq6CN;EgBl6CI;IApCJ,cAAA;IACA,WAAA;EhBy8CA;EgB37CA;IACE,cAAA;IACA,WAAA;EhB67CF;EgB/7CA;IACE,cAAA;IACA,UAAA;EhBi8CF;EgBn8CA;IACE,cAAA;IACA,mBAAA;EhBq8CF;EgBv8CA;IACE,cAAA;IACA,UAAA;EhBy8CF;EgB38CA;IACE,cAAA;IACA,UAAA;EhB68CF;EgB/8CA;IACE,cAAA;IACA,mBAAA;EhBi9CF;EgBl7CI;IAhDJ,cAAA;IACA,WAAA;EhBq+CA;EgBh7CQ;IAhEN,cAAA;IACA,kBAAA;EhBm/CF;EgBp7CQ;IAhEN,cAAA;IACA,mBAAA;EhBu/CF;EgBx7CQ;IAhEN,cAAA;IACA,UAAA;EhB2/CF;EgB57CQ;IAhEN,cAAA;IACA,mBAAA;EhB+/CF;EgBh8CQ;IAhEN,cAAA;IACA,mBAAA;EhBmgDF;EgBp8CQ;IAhEN,cAAA;IACA,UAAA;EhBugDF;EgBx8CQ;IAhEN,cAAA;IACA,mBAAA;EhB2gDF;EgB58CQ;IAhEN,cAAA;IACA,mBAAA;EhB+gDF;EgBh9CQ;IAhEN,cAAA;IACA,UAAA;EhBmhDF;EgBp9CQ;IAhEN,cAAA;IACA,mBAAA;EhBuhDF;EgBx9CQ;IAhEN,cAAA;IACA,mBAAA;EhB2hDF;EgB59CQ;IAhEN,cAAA;IACA,WAAA;EhB+hDF;EgBx9CU;IAxDV,cAAA;EhBmhDA;EgB39CU;IAxDV,wBAAA;EhBshDA;EgB99CU;IAxDV,yBAAA;EhByhDA;EgBj+CU;IAxDV,gBAAA;EhB4hDA;EgBp+CU;IAxDV,yBAAA;EhB+hDA;EgBv+CU;IAxDV,yBAAA;EhBkiDA;EgB1+CU;IAxDV,gBAAA;EhBqiDA;EgB7+CU;IAxDV,yBAAA;EhBwiDA;EgBh/CU;IAxDV,yBAAA;EhB2iDA;EgBn/CU;IAxDV,gBAAA;EhB8iDA;EgBt/CU;IAxDV,yBAAA;EhBijDA;EgBz/CU;IAxDV,yBAAA;EhBojDA;EgBj/CM;;IAEE,gBAAA;EhBm/CR;EgBh/CM;;IAEE,gBAAA;EhBk/CR;EgBz/CM;;IAEE,sBAAA;EhB2/CR;EgBx/CM;;IAEE,sBAAA;EhB0/CR;EgBjgDM;;IAEE,qBAAA;EhBmgDR;EgBhgDM;;IAEE,qBAAA;EhBkgDR;EgBzgDM;;IAEE,mBAAA;EhB2gDR;EgBxgDM;;IAEE,mBAAA;EhB0gDR;EgBjhDM;;IAEE,qBAAA;EhBmhDR;EgBhhDM;;IAEE,qBAAA;EhBkhDR;EgBzhDM;;IAEE,mBAAA;EhB2hDR;EgBxhDM;;IAEE,mBAAA;EhB0hDR;AACF;AcrlDI;EEUE;IACE,SAAA;EhB8kDN;EgB3kDI;IApCJ,cAAA;IACA,WAAA;EhBknDA;EgBpmDA;IACE,cAAA;IACA,WAAA;EhBsmDF;EgBxmDA;IACE,cAAA;IACA,UAAA;EhB0mDF;EgB5mDA;IACE,cAAA;IACA,mBAAA;EhB8mDF;EgBhnDA;IACE,cAAA;IACA,UAAA;EhBknDF;EgBpnDA;IACE,cAAA;IACA,UAAA;EhBsnDF;EgBxnDA;IACE,cAAA;IACA,mBAAA;EhB0nDF;EgB3lDI;IAhDJ,cAAA;IACA,WAAA;EhB8oDA;EgBzlDQ;IAhEN,cAAA;IACA,kBAAA;EhB4pDF;EgB7lDQ;IAhEN,cAAA;IACA,mBAAA;EhBgqDF;EgBjmDQ;IAhEN,cAAA;IACA,UAAA;EhBoqDF;EgBrmDQ;IAhEN,cAAA;IACA,mBAAA;EhBwqDF;EgBzmDQ;IAhEN,cAAA;IACA,mBAAA;EhB4qDF;EgB7mDQ;IAhEN,cAAA;IACA,UAAA;EhBgrDF;EgBjnDQ;IAhEN,cAAA;IACA,mBAAA;EhBorDF;EgBrnDQ;IAhEN,cAAA;IACA,mBAAA;EhBwrDF;EgBznDQ;IAhEN,cAAA;IACA,UAAA;EhB4rDF;EgB7nDQ;IAhEN,cAAA;IACA,mBAAA;EhBgsDF;EgBjoDQ;IAhEN,cAAA;IACA,mBAAA;EhBosDF;EgBroDQ;IAhEN,cAAA;IACA,WAAA;EhBwsDF;EgBjoDU;IAxDV,cAAA;EhB4rDA;EgBpoDU;IAxDV,wBAAA;EhB+rDA;EgBvoDU;IAxDV,yBAAA;EhBksDA;EgB1oDU;IAxDV,gBAAA;EhBqsDA;EgB7oDU;IAxDV,yBAAA;EhBwsDA;EgBhpDU;IAxDV,yBAAA;EhB2sDA;EgBnpDU;IAxDV,gBAAA;EhB8sDA;EgBtpDU;IAxDV,yBAAA;EhBitDA;EgBzpDU;IAxDV,yBAAA;EhBotDA;EgB5pDU;IAxDV,gBAAA;EhButDA;EgB/pDU;IAxDV,yBAAA;EhB0tDA;EgBlqDU;IAxDV,yBAAA;EhB6tDA;EgB1pDM;;IAEE,gBAAA;EhB4pDR;EgBzpDM;;IAEE,gBAAA;EhB2pDR;EgBlqDM;;IAEE,sBAAA;EhBoqDR;EgBjqDM;;IAEE,sBAAA;EhBmqDR;EgB1qDM;;IAEE,qBAAA;EhB4qDR;EgBzqDM;;IAEE,qBAAA;EhB2qDR;EgBlrDM;;IAEE,mBAAA;EhBorDR;EgBjrDM;;IAEE,mBAAA;EhBmrDR;EgB1rDM;;IAEE,qBAAA;EhB4rDR;EgBzrDM;;IAEE,qBAAA;EhB2rDR;EgBlsDM;;IAEE,mBAAA;EhBosDR;EgBjsDM;;IAEE,mBAAA;EhBmsDR;AACF;AiBzzDA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AjBwzDF;AiBjzDE;EACE,sBAAA;EAEA,4BAAA;EAAA,qFAAA;EACA,oCAAA;EACA,wBX+sB0B;EW/sB1B,2CX+sB0B;EW9sB1B,wDAAA;EAAA,2GAAA;AjBkzDJ;AiB/yDE;EACE,uBAAA;AjBizDJ;AiB9yDE;EACE,sBAAA;AjBgzDJ;;AiB5yDA;EACE,4CAAA;EAAA,+DAAA;AjB+yDF;;AiBxyDA;EACE,iBAAA;AjB2yDF;;AiBjyDE;EACE,wBAAA;AjBoyDJ;;AiBrxDE;EACE,mBAAA;EAAA,sCAAA;AjBwxDJ;AiBrxDI;EACE,mBAAA;EAAA,sCAAA;AjBuxDN;;AiBhxDE;EACE,sBAAA;AjBmxDJ;AiBhxDE;EACE,mBAAA;AjBkxDJ;;AiBxwDE;EACE,oDAAA;EACA,8CAAA;AjB2wDJ;;AiBrwDE;EACE,oDAAA;EACA,8CAAA;AjBwwDJ;;AiBhwDA;EACE,oDAAA;EACA,8CAAA;AjBmwDF;;AiB3vDE;EACE,mDAAA;EACA,6CAAA;AjB8vDJ;;AkB14DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBs4DJ;;AkBx5DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBo5DJ;;AkBt6DE;EAOE,sBAAA;EACA,mCAAA;EACA,kDAAA;EACA,kDAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBk6DJ;;AkBp7DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBg7DJ;;AkBl8DE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,mDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB87DJ;;AkBh9DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB48DJ;;AkB99DE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;EACA,4CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB09DJ;;AkB5+DE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,4CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,6CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBw+DJ;;AiBv1DI;EACE,gBAAA;EACA,iCAAA;AjB01DN;;Acr7DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBg2DJ;AACF;Ac57DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBs2DJ;AACF;Acl8DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB42DJ;AACF;Acx8DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBk3DJ;AACF;Ac98DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBw3DJ;AACF;AmB5hEA;EACE,qBbu2BsC;ANurCxC;;AmBrhEA;EACE,iCAAA;EAAA,oDAAA;EACA,oCAAA;EAAA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;ANu7C9B;;AmBlhEA;EACE,+BAAA;EAAA,kDAAA;EACA,kCAAA;EAAA,qDAAA;EhBoQI,kBALI;AHuxDV;;AmBlhEA;EACE,gCAAA;EAAA,mDAAA;EACA,mCAAA;EAAA,sDAAA;EhB8PI,mBALI;AH6xDV;;AoBnjEA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,6Bd+1BsC;Ec/1BtC,gCd+1BsC;ANqtCxC;;AqBzjEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,cf43BsC;Ee53BtC,2Bf43BsC;Ee33BtC,wBAAA;UAAA,gBAAA;EACA,sBfq3BsC;Eer3BtC,mCfq3BsC;Eep3BtC,4BAAA;EACA,yBAAA;EAAA,2DAAA;EdGE,uBAAA;EAAA,sCAAA;EeHE,wEDMJ;ArBujEF;AsBzjEM;EDhBN;ICiBQ,gBAAA;EtB4jEN;AACF;AqB1jEE;EACE,gBAAA;ArB4jEJ;AqB1jEI;EACE,eAAA;ArB4jEN;AqBvjEE;EACE,cfs2BoC;Eet2BpC,2Bfs2BoC;Eer2BpC,sBfg2BoC;Eeh2BpC,mCfg2BoC;Ee/1BpC,kCf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;ANmiDxB;AqBjjEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArBqiEJ;AqBhiEE;EACE,cAAA;EACA,UAAA;ArBkiEJ;AqB9hEE;EACE,6Bf40BoC;Ee50BpC,gCf40BoC;Ee10BpC,UAAA;ArB+hEJ;AqBvhEE;EAEE,yBf8yBoC;Ee9yBpC,wCf8yBoC;Ee3yBpC,UAAA;ArBshEJ;AqBlhEE;EACE,yBAAA;EACA,0BAAA;EACA,2BforB0B;UeprB1B,0BforB0B;EenrB1B,cfsyBoC;EetyBpC,2BfsyBoC;EiBp4BtC,yBjBqiCgC;EiBriChC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BfgsB0B;EehsB1B,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,6ID0FF;EC1FE,qID0FF;ArBohEJ;AqBhiEE;EACE,yBAAA;EACA,0BAAA;EACA,2BforB0B;UeprB1B,0BforB0B;EenrB1B,cfsyBoC;EetyBpC,2BfsyBoC;EiBp4BtC,yBjBqiCgC;EiBriChC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BfgsB0B;EehsB1B,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;ArBohEJ;AsB1mEM;ED0EJ;ICzEM,wBAAA;IAAA,gBAAA;EtB6mEN;EqBpiEA;ICzEM,gBAAA;EtB6mEN;AACF;AqBthEE;EACE,yBf47B8B;Ee57B9B,wCf47B8B;AN4lClC;AqBzhEE;EACE,yBf47B8B;Ee57B9B,wCf47B8B;AN4lClC;;AqB/gEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,cf2xBsC;Ee3xBtC,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,mBAAA;EAAA,sCAAA;ArBkhEF;AqBhhEE;EACE,UAAA;ArBkhEJ;AqB/gEE;EAEE,gBAAA;EACA,eAAA;ArBghEJ;;AqBrgEA;EACE,gDf4wBsC;Ee5wBtC,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,sBAAA;EAAA,yCAAA;AP6oEJ;AqBtgEE;EACE,uBAAA;EACA,wBAAA;EACA,0BfooB0B;UepoB1B,yBfooB0B;ANo4C9B;AqB3gEE;EACE,uBAAA;EACA,wBAAA;EACA,0BfooB0B;UepoB1B,yBfooB0B;ANo4C9B;;AqBpgEA;EACE,8CfgwBsC;EehwBtC,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,qBAAA;EAAA,yCAAA;APypEJ;AqBrgEE;EACE,oBAAA;EACA,qBAAA;EACA,wBf2nB0B;Ue3nB1B,uBf2nB0B;AN44C9B;AqB1gEE;EACE,oBAAA;EACA,qBAAA;EACA,wBf2nB0B;Ue3nB1B,uBf2nB0B;AN44C9B;;AqB//DE;EACE,iDf6uBoC;Ee7uBpC,oEf6uBoC;ANqxCxC;AqB//DE;EACE,gDf0uBoC;Ee1uBpC,mEf0uBoC;ANuxCxC;AqB9/DE;EACE,8CfuuBoC;EevuBpC,iEfuuBoC;ANyxCxC;;AqB3/DA;EACE,WfquBsC;EepuBtC,6Cf8tBsC;Ee9tBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;AN66C9B;AqB5/DE;EACE,eAAA;ArB8/DJ;AqB3/DE;EACE,oBAAA;EdvLA,uBAAA;EAAA,sCAAA;APqrEJ;AqB1/DE;EACE,oBAAA;Ed5LA,uBAAA;EAAA,sCAAA;APyrEJ;AqBz/DE;EAAoB,4Cf8sBkB;Ee9sBlB,+Df8sBkB;AN8yCxC;AqB3/DE;EAAoB,0Cf8sBkB;Ee9sBlB,6Df8sBkB;ANgzCxC;;AwB7sEA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,clBy3BsC;EkBz3BtC,2BlBy3BsC;EkBx3BtC,wBAAA;UAAA,gBAAA;EACA,sBlBk3BsC;EkBl3BtC,mClBk3BsC;EkBj3BtC,oDAAA;EAAA,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,yBAAA;EAAA,2DAAA;EjBHE,uBAAA;EAAA,sCAAA;EeHE,wEESJ;AxB6sEF;AsBltEM;EEfN;IFgBQ,gBAAA;EtBqtEN;AACF;AwBhtEE;EACE,kClBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;AN6uClC;AwB1sEE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;AxB2sEJ;AwBxsEE;EAEE,yBlBu1BoC;EkBv1BpC,wClBu1BoC;ANk3CxC;AwBpsEE;EACE,kBAAA;EACA,0BAAA;EAAA,uCAAA;AxBssEJ;;AwBlsEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,sBAAA;EAAA,yCAAA;APgvEJ;;AwBlsEA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,kBALI;EIvQN,qBAAA;EAAA,yCAAA;APwvEJ;;AwBhsEI;EACE,gEAAA;AxBmsEN;;AyB3wEA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;ANy2C1C;AyB5wEE;EACE,WAAA;EACA,mBAAA;AzB8wEJ;;AyB1wEA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AzB6wEF;AyB3wEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AzB6wEJ;;AyBzwEA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,wBAAA;UAAA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,yBnB24BwC;EmB34BxC,2DnB24BwC;EmB14BxC,iCAAA;UAAA,yBAAA;AzB2wEF;AyBxwEE;ElB3BE,qBAAA;APsyEJ;AyBvwEE;EAEE,kBnBm4BsC;ANq4C1C;AyBrwEE;EACE,uBnB03BsC;AN64C1C;AyBpwEE;EACE,kCnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;ANwwDxB;AyBnwEE;EACE,yBnB5BM;EmB6BN,qBnB7BM;ANkyEV;AyBnwEI;EAII,iEAAA;AzBkwER;AyB9vEI;EAII,iEAAA;AzB6vER;AyBxvEE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,iEAAA;AzBsvEN;AyBlvEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;ANk5C3C;AyB7uEI;EACE,eAAA;EACA,YnBy1BqC;ANs5C3C;;AyBjuEA;EACE,mBnBo1BgC;ANg5ClC;AyBluEE;EACE,4DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AzBmuEJ;AsBr1EM;EG0GJ;IHzGM,gBAAA;EtBw1EN;AACF;AyBtuEI;EACE,4DAAA;AzBwuEN;AyBruEI;EACE,iCnB60B4B;EmBx0B1B,4DAAA;AzBmuER;AyB9tEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AzBguEJ;AyB9tEI;EACE,oBAAA;EACA,cAAA;AzBguEN;;AyB3tEA;EACE,qBAAA;EACA,kBnBsyBgC;ANw7ClC;;AyB3tEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzB8tEF;AyB1tEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;ANskD9B;;AyBrtEI;EACE,4DAAA;AzBwtEN;;A0B34EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,wBAAA;UAAA,gBAAA;EACA,6BAAA;A1B84EF;A0B54EE;EACE,UAAA;A1B84EJ;A0B14EI;EAA0B,kEpB8gCa;AN+3C3C;A0B54EI;EAA0B,kEpB6gCa;ANk4C3C;A0B54EE;EACE,SAAA;A1B84EJ;A0B34EE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,wBAAA;UAAA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A1B44EJ;AsB35EM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EtB85EN;AACF;A0B/4EI;EHjCF,0CjB8hCyC;ANq5C3C;A0B74EE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,yBpBu+B8B;EoBv+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;AP66EJ;A0B34EE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A1B44EJ;AsBr7EM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EtBw7EN;AACF;A0B/4EI;EH3DF,0CjB8hCyC;AN+6C3C;A0B74EE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,yBpB68B8B;EoB78B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;APu8EJ;A0B34EE;EACE,oBAAA;A1B64EJ;A0B34EI;EACE,wCpBg9BqC;EoBh9BrC,2CpBg9BqC;AN67C3C;A0B14EI;EACE,wCpB48BqC;EoB58BrC,2CpB48BqC;ANg8C3C;;A2Bn+EA;EACE,kBAAA;A3Bs+EF;A2Bp+EE;;;EAGE,oCrBwiCoC;EqBxiCpC,uDrBwiCoC;EqBviCpC,wCrBuiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;AN+7CxC;A2Bn+EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,6BAAA;EAAA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EAAA,gDAAA;EACA,qBAAA;ELVE,gEKWF;A3Bq+EJ;AsB5+EM;EKTJ;ILUM,gBAAA;EtB++EN;AACF;A2Bv+EE;;EAEE,qBAAA;A3By+EJ;A2Bv+EI;;EACE,kBAAA;A3B0+EN;A2Bv+EI;;;EAEE,qBrB0gCkC;EqBzgClC,wBrB0gCkC;ANg+CxC;A2Bv+EI;;EACE,qBrBqgCkC;EqBpgClC,wBrBqgCkC;ANq+CxC;A2Bt+EE;EACE,qBrB+/BoC;EqB9/BpC,wBrB+/BoC;EqB9/BpC,qBrBguB0B;ANwwD9B;A2Bj+EI;;;;EACE,8DrBy/BkC;AN6+CxC;A2Bj+EI;EACE,8DrBm/BkC;ANg/CxC;A2B99EI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBw+BkC;EqBv+BlC,WAAA;EACA,sBrBqzBkC;EqBrzBlC,mCrBqzBkC;ECh3BpC,uBAAA;EAAA,sCAAA;AP6hFJ;A2B99EE;EACE,yBrBkzBoC;EqBlzBpC,wCrBkzBoC;AN8qDxC;A2B59EI;EACE,mBAAA;EAAA,sCAAA;A3B89EN;A2B19EE;;EAEE,crBhFO;AN4iFX;;A4BtjFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5ByjFF;A4BvjFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5ByjFJ;A4BrjFE;;;EAGE,UAAA;A5BujFJ;A4BjjFE;EACE,kBAAA;EACA,UAAA;A5BmjFJ;A4BjjFI;EACE,UAAA;A5BmjFN;;A4BxiFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,ctBm1BsC;EsBn1BtC,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,yBtB06BsC;EsB16BtC,uCtB06BsC;EsBz6BtC,yBAAA;EAAA,2DAAA;ErBtCE,uBAAA;EAAA,sCAAA;APklFJ;;A4BliFA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,qBAAA;EAAA,yCAAA;AP2lFJ;;A4BliFA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,sBAAA;EAAA,yCAAA;APomFJ;;A4BliFA;;EAEE,mBAAA;A5BqiFF;;A4BxhFI;;;;ErBjEA,0BAAA;EACA,6BAAA;APgmFJ;A4BvhFI;;;;ErB1EA,0BAAA;EACA,6BAAA;APumFJ;A4BjhFE;EACE,2BAAA;EAAA,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;AP8lFJ;A4BjhFE;;ErB9EE,yBAAA;EACA,4BAAA;APmmFJ;;A6B3nFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,cvBkjCqB;EuBljCrB,iCvBkjCqB;AN2kDzB;;A6B1nFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,yBvBoiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,uBAAA;EAAA,sCAAA;APwpFJ;;A6BxnFI;;;;EAEE,cAAA;A7B6nFN;;A6B5qFI;EAqDE,qBvBuhCmB;EuBvhCnB,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7BynFR;A6BtnFM;EACE,qBvB4gCiB;EuB5gCjB,+CvB4gCiB;EuBvgCf,iDvBugCe;EuBvgCf,2DvBugCe;AN6mDzB;;A6BzrFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7B8mFR;;A6B9rFI;EAuFE,qBvBq/BmB;EuBr/BnB,+CvBq/BmB;ANsnDzB;A6BxmFQ;EAEE,iEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7BymFV;A6BrmFM;EACE,qBvBw+BiB;EuBx+BjB,+CvBw+BiB;EuBn+Bf,iDvBm+Be;EuBn+Bf,2DvBm+Be;ANgoDzB;;A6B5sFI;EAkHI,yCAAA;A7B8lFR;;A6BhtFI;EAyHE,qBvBm9BmB;EuBn9BnB,+CvBm9BmB;ANwoDzB;A6BzlFM;EACE,yBvBg9BiB;EuBh9BjB,4CvBg9BiB;AN2oDzB;A6BxlFM;EACE,iDvB48BiB;EuB58BjB,2DvB48BiB;AN8oDzB;A6BvlFM;EACE,cvBw8BiB;EuBx8BjB,iCvBw8BiB;ANipDzB;;A6BplFI;EACE,kBAAA;A7BulFN;;A6BjuFI;;;;;EAoJM,UAAA;A7BqlFV;;A6BrtFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,cvBkjCqB;EuBljCrB,mCvBkjCqB;ANqqDzB;;A6BptFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,yBvBoiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,uBAAA;EAAA,sCAAA;APkvFJ;;A6BltFI;;;;EAEE,cAAA;A7ButFN;;A6BtwFI;EAqDE,qBvBuhCmB;EuBvhCnB,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7BmtFR;A6BhtFM;EACE,qBvB4gCiB;EuB5gCjB,iDvB4gCiB;EuBvgCf,iDvBugCe;EuBvgCf,0DvBugCe;ANusDzB;;A6BnxFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7BwsFR;;A6BxxFI;EAuFE,qBvBq/BmB;EuBr/BnB,iDvBq/BmB;ANgtDzB;A6BlsFQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7BmsFV;A6B/rFM;EACE,qBvBw+BiB;EuBx+BjB,iDvBw+BiB;EuBn+Bf,iDvBm+Be;EuBn+Bf,0DvBm+Be;AN0tDzB;;A6BtyFI;EAkHI,yCAAA;A7BwrFR;;A6B1yFI;EAyHE,qBvBm9BmB;EuBn9BnB,iDvBm9BmB;ANkuDzB;A6BnrFM;EACE,yBvBg9BiB;EuBh9BjB,8CvBg9BiB;ANquDzB;A6BlrFM;EACE,iDvB48BiB;EuB58BjB,0DvB48BiB;ANwuDzB;A6BjrFM;EACE,cvBw8BiB;EuBx8BjB,mCvBw8BiB;AN2uDzB;;A6B9qFI;EACE,kBAAA;A7BirFN;;A6B3zFI;;;;;EAsJM,UAAA;A7B6qFV;;A8Br0FA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A9Bm0FF;AsBv1FM;EQhBN;IRiBQ,gBAAA;EtB01FN;AACF;A8Bt0FE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A9Bu0FJ;A8Bp0FE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A9Bq0FJ;A8Bl0FE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A9Bg0FN;A8B5zFE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A9B0zFN;A8BtzFE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A9BkzFJ;A8B/yFI;EAKI,0CAAA;A9B6yFR;A8BxyFE;EAKI,0CAAA;A9BsyFN;A8BlyFE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A9BiyFJ;;A8BrxFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/Bw4FF;;A8BtyFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/By5FF;;A8BvzFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,+CAAA;EACA,uCAAA;EACA,2BAAA;EACA,sCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B06FF;;A8Bx0FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B27FF;;A8Bz1FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B48FF;;A8B12FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,sCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B69FF;;A8B33FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B8+FF;;A8B54FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B+/FF;;A8Bn4FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/Bu/FF;;A8Bp5FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BwgGF;;A8Br6FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/ByhGF;;A8Bt7FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B0iGF;;A8Bv8FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B2jGF;;A8Bx9FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B4kGF;;A8Bz+FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B6lGF;;A8B1/FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B8mGF;;A8B//FA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;ANmvF1C;A8Bv/FE;EACE,0BAAA;A9By/FJ;A8Bt/FE;EACE,gCAAA;A9Bw/FJ;;A8B7+FA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;A/BkoGF;;A8Bh/FA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A/ByoGF;;AgC5sGA;EVgBM,gCUfJ;AhC+sGF;AsB5rGM;EUpBN;IVqBQ,gBAAA;EtB+rGN;AACF;AgCltGE;EACE,UAAA;AhCotGJ;;AgC9sGE;EACE,aAAA;AhCitGJ;;AgC7sGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhCgtGF;AsB9sGM;EULN;IVMQ,gBAAA;EtBitGN;AACF;AgCntGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhCqtGJ;AsBxtGM;EUAJ;IVCM,gBAAA;EtB2tGN;AACF;;AiChvGA;;;;;;EAME,kBAAA;AjCmvGF;;AiChvGA;EACE,mBAAA;AjCmvGF;AkC3tGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AlCmwGF;AkCzsGI;EACE,cAAA;AlC2sGN;;AiCzvGA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;APmyGJ;AiCtvGE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AjCwvGJ;;AiChuGI;EACE,oBAAA;AjCmuGN;AiCjuGM;EACE,WAAA;EACA,OAAA;AjCmuGR;;AiC/tGI;EACE,kBAAA;AjCkuGN;AiChuGM;EACE,QAAA;EACA,UAAA;AjCkuGR;;Ac5wGI;EmB4BA;IACE,oBAAA;EjCovGJ;EiClvGI;IACE,WAAA;IACA,OAAA;EjCovGN;EiChvGE;IACE,kBAAA;EjCkvGJ;EiChvGI;IACE,QAAA;IACA,UAAA;EjCkvGN;AACF;Ac7xGI;EmB4BA;IACE,oBAAA;EjCowGJ;EiClwGI;IACE,WAAA;IACA,OAAA;EjCowGN;EiChwGE;IACE,kBAAA;EjCkwGJ;EiChwGI;IACE,QAAA;IACA,UAAA;EjCkwGN;AACF;Ac7yGI;EmB4BA;IACE,oBAAA;EjCoxGJ;EiClxGI;IACE,WAAA;IACA,OAAA;EjCoxGN;EiChxGE;IACE,kBAAA;EjCkxGJ;EiChxGI;IACE,QAAA;IACA,UAAA;EjCkxGN;AACF;Ac7zGI;EmB4BA;IACE,oBAAA;EjCoyGJ;EiClyGI;IACE,WAAA;IACA,OAAA;EjCoyGN;EiChyGE;IACE,kBAAA;EjCkyGJ;EiChyGI;IACE,QAAA;IACA,UAAA;EjCkyGN;AACF;Ac70GI;EmB4BA;IACE,oBAAA;EjCozGJ;EiClzGI;IACE,WAAA;IACA,OAAA;EjCozGN;EiChzGE;IACE,kBAAA;EjCkzGJ;EiChzGI;IACE,QAAA;IACA,UAAA;EjCkzGN;AACF;AiCzyGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AjC2yGJ;AkC/3GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AlCg6GF;AkC72GI;EACE,cAAA;AlC+2GN;;AiC/yGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AjCkzGJ;AkCp5GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AlC86GF;AkCl4GI;EACE,cAAA;AlCo4GN;AiC1zGI;EACE,iBAAA;AjC4zGN;;AiCtzGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AjCyzGJ;AkC56GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AlC86GN;AkCn6GM;EACE,aAAA;AlCq6GR;AkCl6GM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AlCw8GF;AkCl6GI;EACE,cAAA;AlCo6GN;AiCz0GI;EACE,iBAAA;AjC20GN;;AiCp0GA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AjCu0GF;;AiCj0GA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,gBAAA;EAAA,uDAAA;AP2+GJ;AiCl0GE;EAEE,0CAAA;EV1LF,kDU4LuB;AjCk0GzB;AiC/zGE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AjCg0GzB;AiC7zGE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AjC8zGJ;;AiCxzGA;EACE,cAAA;AjC2zGF;;AiCvzGA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AjC0zGF;;AiCtzGA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AjCyzGF;;AiCrzGA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AjCuzGF;;AmC7iHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnCgjHF;AmC9iHE;;EACE,kBAAA;EACA,cAAA;AnCijHJ;AmC5iHE;;;;;;;;;;;;EAME,UAAA;AnCojHJ;;AmC/iHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnCkjHF;AmChjHE;EACE,WAAA;AnCkjHJ;;AmC9iHA;E5BhBI,uBAAA;EAAA,sCAAA;APkkHJ;AmC9iHE;;EAEE,2BAAA;EAAA,8CAAA;AnCgjHJ;AmC5iHE;;;E5BVE,0BAAA;EACA,6BAAA;AP2jHJ;AmCxiHE;;;E5BNE,yBAAA;EACA,4BAAA;APmjHJ;;AmC3hHA;EACE,wBAAA;EACA,uBAAA;AnC8hHF;AmC5hHE;EAGE,cAAA;AnC4hHJ;AmCzhHE;EACE,eAAA;AnC2hHJ;;AmCvhHA;EACE,uBAAA;EACA,sBAAA;AnC0hHF;;AmCvhHA;EACE,sBAAA;EACA,qBAAA;AnC0hHF;;AmCtgHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnCygHF;AmCvgHE;;EAEE,WAAA;AnCygHJ;AmCtgHE;;EAEE,0BAAA;EAAA,6CAAA;AnCwgHJ;AmCpgHE;;E5B1FE,6BAAA;EACA,4BAAA;APkmHJ;AmChgHE;;;E5BjHE,yBAAA;EACA,0BAAA;APsnHJ;;AoC9oHA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApC6oHF;;AoC1oHA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ApC6oHF;AsBzpHM;EcGN;IdFQ,gBAAA;EtB4pHN;AACF;AoChpHE;EAEE,qCAAA;ApCipHJ;AoC7oHE;EACE,UAAA;EACA,kD9BkhBoB;AN6nGxB;AoC3oHE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ApC4oHJ;;AoCpoHA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ApCooHF;AoCloHE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;APkrHJ;AoCnoHI;EAGE,kBAAA;EACA,wDAAA;ApCmoHN;AoC/nHE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ApCioHJ;AoC9nHE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;APisHJ;;AoCtnHA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ApCwnHF;AoCrnHE;E7B5FE,gDAAA;APotHJ;AoCpnHE;;EAEE,4CAAA;EbjHF,oDakHuB;ApCsnHzB;;AoC7mHA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ApC6mHF;AoC3mHE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ApC6mHJ;AoC3mHI;EAEE,iCAAA;ApC4mHN;AoCxmHE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ApC0mHJ;;AoChmHE;;EAEE,cAAA;EACA,kBAAA;ApCmmHJ;;AoC9lHE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;ApCimHJ;;AoC3lHE;;EACE,WAAA;ApC+lHJ;;AoCrlHE;EACE,aAAA;ApCwlHJ;AoCtlHE;EACE,cAAA;ApCwlHJ;;AqCrxHA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ArCqxHF;AqC/wHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArCuxHJ;AqCnwHA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;ArCqwHF;AqCnwHE;EAEE,yCAAA;ArCowHJ;;AqC1vHA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArCyvHF;AqCtvHI;EAEE,oCAAA;ArCuvHN;AqCnvHE;EACE,gBAAA;ArCqvHJ;;AqC5uHA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;ArC+uHF;AqC7uHE;;;EAGE,oCAAA;ArC+uHJ;;AqCluHA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;ArCmuHF;;AqC/tHA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,uDAAA;EAAA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;ArCkuHF;AsB32HM;EeiIN;IfhIQ,gBAAA;EtB82HN;AACF;AqCruHE;EACE,qBAAA;ArCuuHJ;AqCpuHE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ArCsuHJ;;AqChuHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArCmuHF;;AqChuHA;EACE,gBAAA;EAAA,yCAAA;EACA,gBAAA;ArCmuHF;;Ac71HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErC0tHN;EqCxtHM;IACE,mBAAA;ErC0tHR;EqCxtHQ;IACE,kBAAA;ErC0tHV;EqCvtHQ;IACE,kDAAA;IACA,iDAAA;ErCytHV;EqCrtHM;IACE,iBAAA;ErCutHR;EqCptHM;IACE,wBAAA;IACA,gBAAA;ErCstHR;EqCntHM;IACE,aAAA;ErCqtHR;EqCltHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCktHR;EqC/sHQ;IACE,aAAA;ErCitHV;EqC9sHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCgtHV;AACF;Ac74HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCywHN;EqCvwHM;IACE,mBAAA;ErCywHR;EqCvwHQ;IACE,kBAAA;ErCywHV;EqCtwHQ;IACE,kDAAA;IACA,iDAAA;ErCwwHV;EqCpwHM;IACE,iBAAA;ErCswHR;EqCnwHM;IACE,wBAAA;IACA,gBAAA;ErCqwHR;EqClwHM;IACE,aAAA;ErCowHR;EqCjwHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCiwHR;EqC9vHQ;IACE,aAAA;ErCgwHV;EqC7vHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC+vHV;AACF;Ac57HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCwzHN;EqCtzHM;IACE,mBAAA;ErCwzHR;EqCtzHQ;IACE,kBAAA;ErCwzHV;EqCrzHQ;IACE,kDAAA;IACA,iDAAA;ErCuzHV;EqCnzHM;IACE,iBAAA;ErCqzHR;EqClzHM;IACE,wBAAA;IACA,gBAAA;ErCozHR;EqCjzHM;IACE,aAAA;ErCmzHR;EqChzHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCgzHR;EqC7yHQ;IACE,aAAA;ErC+yHV;EqC5yHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC8yHV;AACF;Ac3+HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCu2HN;EqCr2HM;IACE,mBAAA;ErCu2HR;EqCr2HQ;IACE,kBAAA;ErCu2HV;EqCp2HQ;IACE,kDAAA;IACA,iDAAA;ErCs2HV;EqCl2HM;IACE,iBAAA;ErCo2HR;EqCj2HM;IACE,wBAAA;IACA,gBAAA;ErCm2HR;EqCh2HM;IACE,aAAA;ErCk2HR;EqC/1HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC+1HR;EqC51HQ;IACE,aAAA;ErC81HV;EqC31HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC61HV;AACF;Ac1hII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCs5HN;EqCp5HM;IACE,mBAAA;ErCs5HR;EqCp5HQ;IACE,kBAAA;ErCs5HV;EqCn5HQ;IACE,kDAAA;IACA,iDAAA;ErCq5HV;EqCj5HM;IACE,iBAAA;ErCm5HR;EqCh5HM;IACE,wBAAA;IACA,gBAAA;ErCk5HR;EqC/4HM;IACE,aAAA;ErCi5HR;EqC94HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC84HR;EqC34HQ;IACE,aAAA;ErC64HV;EqC14HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC44HV;AACF;AqCn8HI;EAEI,iBAAA;EACA,2BAAA;ArCo8HR;AqCl8HQ;EACE,mBAAA;ArCo8HV;AqCl8HU;EACE,kBAAA;ArCo8HZ;AqCj8HU;EACE,kDAAA;EACA,iDAAA;ArCm8HZ;AqC/7HQ;EACE,iBAAA;ArCi8HV;AqC97HQ;EACE,wBAAA;EACA,gBAAA;ArCg8HV;AqC77HQ;EACE,aAAA;ArC+7HV;AqC57HQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;ArC47HV;AqCz7HU;EACE,aAAA;ArC27HZ;AqCx7HU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArC07HZ;;AqCz6HA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ArC26HF;;AqCr6HI;EACE,qEAAA;ArCw6HN;;AsCjsIA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EAAA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;APmtIJ;AsC9rIE;EACE,eAAA;EACA,cAAA;AtCgsIJ;AsC7rIE;EACE,mBAAA;EACA,sBAAA;AtC+rIJ;AsC7rII;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;APstIJ;AsC7rII;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AP6sIJ;AsC1rIE;;EAEE,aAAA;AtC4rIJ;;AsCxrIA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AtCyrIF;;AsCtrIA;EACE,4CAAA;EACA,iCAAA;AtCyrIF;;AsCtrIA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AtCyrIF;;AsCtrIA;EACE,gBAAA;AtCyrIF;;AsCjrIE;EACE,oCAAA;AtCorIJ;;AsC5qIA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AtC+qIF;AsC7qIE;E/B7FE,wFAAA;AP6wIJ;;AsC3qIA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AtC8qIF;AsC5qIE;E/BxGE,wFAAA;APuxIJ;;AsCrqIA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AtCwqIF;AsCtqIE;EACE,mCAAA;EACA,sCAAA;AtCwqIJ;;AsCpqIA;EACE,uDAAA;EACA,sDAAA;AtCuqIF;;AsCnqIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;APizIJ;;AsCnqIA;;;EAGE,WAAA;AtCsqIF;;AsCnqIA;;E/B3II,0DAAA;EACA,2DAAA;APmzIJ;;AsCpqIA;;E/BlII,8DAAA;EACA,6DAAA;AP2yIJ;;AsC7pIE;EACE,0CAAA;AtCgqIJ;Ac3xII;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EtCgqIF;EsC7pIE;IACE,SAAA;IACA,gBAAA;EtC+pIJ;EsC7pII;IACE,cAAA;IACA,cAAA;EtC+pIN;EsC1pIM;I/B1KJ,0BAAA;IACA,6BAAA;EPu0IF;EsC3pIQ;;IAGE,0BAAA;EtC4pIV;EsC1pIQ;;IAGE,6BAAA;EtC2pIV;EsCvpIM;I/B3KJ,yBAAA;IACA,4BAAA;EPq0IF;EsCxpIQ;;IAGE,yBAAA;EtCypIV;EsCvpIQ;;IAGE,4BAAA;EtCwpIV;AACF;;AuC53IA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AvC83IF;;AuC13IA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AvC63IF;AsBp5IM;EiBUN;IjBTQ,gBAAA;EtBu5IN;AACF;AuCh4IE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AvCk4IJ;AuCh4II;EACE,qDAAA;EACA,iDAAA;AvCk4IN;AuC73IE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AvC+3IJ;AsB76IM;EiBqCJ;IjBpCM,gBAAA;EtBg7IN;AACF;AuCj4IE;EACE,UAAA;AvCm4IJ;AuCh4IE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AvCk4IJ;;AuC93IA;EACE,gBAAA;AvCi4IF;;AuC93IA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AvCi4IF;AuC/3IE;EhC7DE,yDAAA;EACA,0DAAA;AP+7IJ;AuCh4II;EhChEA,+DAAA;EACA,gEAAA;APm8IJ;AuC/3IE;EACE,aAAA;AvCi4IJ;AuC73IE;EhC5DE,6DAAA;EACA,4DAAA;AP47IJ;AuC73IM;EhChEF,mEAAA;EACA,kEAAA;APg8IJ;AuC53II;EhCrEA,6DAAA;EACA,4DAAA;APo8IJ;;AuC13IA;EACE,8EAAA;AvC63IF;;AuCp3IE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;APs+IJ;AuCr3II;EAAgB,aAAA;AvCw3IpB;AuCv3II;EAAe,gBAAA;AvC03InB;AuCv3II;;;EhCrHA,gBAAA;APi/IJ;;AuCj3II;EACE,iEAAA;EACA,wEAAA;AvCo3IN;;AwCzgJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;APygJJ;;AwCngJE;EACE,iDAAA;AxCsgJJ;AwCpgJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,yDAAA;EAAA,uFAAA;AxCsgJN;AwClgJE;EACE,6CAAA;AxCogJJ;;AyCziJA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AT8jJF;;AyCviJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AzC0iJF;AsB3jJM;EmBQN;InBPQ,gBAAA;EtB8jJN;AACF;AyC7iJE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AzC8iJJ;AyC3iJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AzC6iJJ;AyC1iJE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AzC2iJJ;AyCxiJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AzCyiJJ;;AyCpiJE;EACE,2BnC8sCgC;EmC9sChC,8CnC8sCgC;ANy1GpC;AyCliJM;ElC9BF,0DAAA;EACA,6DAAA;APmkJJ;AyChiJM;ElClDF,2DAAA;EACA,8DAAA;APqlJJ;;AyCnhJA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;A1CynJF;;AyCthJA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A1CgoJF;;A2CloJA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;APuoJJ;A2C9nJE;EACE,aAAA;A3CgoJJ;;A2C3nJA;EACE,kBAAA;EACA,SAAA;A3C8nJF;;A4C9pJA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;APkqJJ;;A4C1pJA;EAEE,cAAA;A5C4pJF;;A4CxpJA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A5C2pJF;;A4CnpJA;EACE,mBtCs+C8B;ANgrGhC;A4CnpJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A5CqpJJ;;A4C7oJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5CgpJJ;;A4CppJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5CupJJ;;A4C3pJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C8pJJ;;A4ClqJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5CqqJJ;;A4CzqJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C4qJJ;;A4ChrJE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A5CmrJJ;;A4CvrJE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A5C0rJJ;;A4C9rJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5CisJJ;;A6C7vJE;EACE;IAAK,gDAAA;E7CiwJP;AACF;A6C7vJA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;APqwJJ;;A6CxvJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A7C2vJF;AsBhxJM;EuBYN;IvBXQ,gBAAA;EtBmxJN;AACF;;A6C7vJA;EtBAE,qMAAA;EsBEA,oEAAA;A7CgwJF;;A6C7vJA;EACE,iBAAA;A7CgwJF;;A6C7vJA;EACE,WAAA;A7CgwJF;;A6C5vJE;EACE,kDAAA;A7C+vJJ;A6C5vJM;EAJJ;IAKM,eAAA;E7C+vJN;AACF;;A8C3zJA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;APq0JJ;;A8CtzJA;EACE,qBAAA;EACA,sBAAA;A9CyzJF;A8CvzJE;EAEE,oCAAA;EACA,0BAAA;A9CwzJJ;;A8ChzJA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A9CmzJF;A8CjzJE;EvC9BE,+BAAA;EACA,gCAAA;APk1JJ;A8CjzJE;EvCpBE,mCAAA;EACA,kCAAA;APw0JJ;A8CjzJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9CkzJJ;A8C9yJE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9CgzJJ;A8C5yJE;EACE,mBAAA;A9C8yJJ;A8C5yJI;EACE,wDAAA;EACA,mDAAA;A9C8yJN;;A8CpyJA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9CuyJF;A8CnyJI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9CoyJN;A8CjyJI;EACE,+CAAA;EACA,uDAAA;A9CmyJN;;A8CtxJI;EACE,mBAAA;A9CyxJN;A8CtxJQ;EvCzDJ,6DAAA;EAZA,0BAAA;AP+1JJ;A8CrxJQ;EvC1EJ,2DAAA;EAYA,4BAAA;APu1JJ;A8CpxJQ;EACE,aAAA;A9CsxJV;A8CnxJQ;EACE,mDAAA;EACA,oBAAA;A9CqxJV;A8CnxJU;EACE,yDAAA;EACA,oDAAA;A9CqxJZ;;Ac72JI;EgCgEA;IACE,mBAAA;E9CizJJ;E8C9yJM;IvCzDJ,6DAAA;IAZA,0BAAA;EPu3JF;E8C7yJM;IvC1EJ,2DAAA;IAYA,4BAAA;EP+2JF;E8C5yJM;IACE,aAAA;E9C8yJR;E8C3yJM;IACE,mDAAA;IACA,oBAAA;E9C6yJR;E8C3yJQ;IACE,yDAAA;IACA,oDAAA;E9C6yJV;AACF;Act4JI;EgCgEA;IACE,mBAAA;E9Cy0JJ;E8Ct0JM;IvCzDJ,6DAAA;IAZA,0BAAA;EP+4JF;E8Cr0JM;IvC1EJ,2DAAA;IAYA,4BAAA;EPu4JF;E8Cp0JM;IACE,aAAA;E9Cs0JR;E8Cn0JM;IACE,mDAAA;IACA,oBAAA;E9Cq0JR;E8Cn0JQ;IACE,yDAAA;IACA,oDAAA;E9Cq0JV;AACF;Ac95JI;EgCgEA;IACE,mBAAA;E9Ci2JJ;E8C91JM;IvCzDJ,6DAAA;IAZA,0BAAA;EPu6JF;E8C71JM;IvC1EJ,2DAAA;IAYA,4BAAA;EP+5JF;E8C51JM;IACE,aAAA;E9C81JR;E8C31JM;IACE,mDAAA;IACA,oBAAA;E9C61JR;E8C31JQ;IACE,yDAAA;IACA,oDAAA;E9C61JV;AACF;Act7JI;EgCgEA;IACE,mBAAA;E9Cy3JJ;E8Ct3JM;IvCzDJ,6DAAA;IAZA,0BAAA;EP+7JF;E8Cr3JM;IvC1EJ,2DAAA;IAYA,4BAAA;EPu7JF;E8Cp3JM;IACE,aAAA;E9Cs3JR;E8Cn3JM;IACE,mDAAA;IACA,oBAAA;E9Cq3JR;E8Cn3JQ;IACE,yDAAA;IACA,oDAAA;E9Cq3JV;AACF;Ac98JI;EgCgEA;IACE,mBAAA;E9Ci5JJ;E8C94JM;IvCzDJ,6DAAA;IAZA,0BAAA;EPu9JF;E8C74JM;IvC1EJ,2DAAA;IAYA,4BAAA;EP+8JF;E8C54JM;IACE,aAAA;E9C84JR;E8C34JM;IACE,mDAAA;IACA,oBAAA;E9C64JR;E8C34JQ;IACE,yDAAA;IACA,oDAAA;E9C64JV;AACF;A8Ch4JA;EvClJI,gBAAA;APqhKJ;A8Ch4JE;EACE,mDAAA;A9Ck4JJ;A8Ch4JI;EACE,sBAAA;A9Ck4JN;;A8Cr3JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9Cw3JJ;;A8Cl4JE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9Cq4JJ;;A8C/4JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9Ck5JJ;;A8C55JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9C+5JJ;;A8Cz6JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9C46JJ;;A8Ct7JE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A9Cy7JJ;;A8Cn8JE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A9Cs8JJ;;A8Ch9JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9Cm9JJ;;A+CjpKA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCupD2B;EyCtpD3B,WzCspD2B;EyCrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;EAAA,kCAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A/CipKF;A+C9oKE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A/CgpKJ;A+C7oKE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A/C+oKJ;A+C5oKE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;A/C6oKJ;;A+CroKA;EAHE,iEAAA;A/C4oKF;;A+CroKA;;EAEE,uBAAA;A/CwoKF;;AInrKI;E2CkCF,iEAAA;A/CqpKF;;AgDtsKA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;AP+sKJ;AgDpsKE;EACE,UAAA;AhDssKJ;AgDnsKE;EACE,aAAA;AhDqsKJ;;AgDjsKA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,0BAAA;EAAA,kBAAA;EACA,eAAA;EACA,oBAAA;AhDmsKF;AgDjsKE;EACE,sCAAA;AhDmsKJ;;AgD/rKA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;APmuKJ;AgDjsKE;EACE,oDAAA;EACA,sCAAA;AhDmsKJ;;AgD/rKA;EACE,kCAAA;EACA,qBAAA;AhDksKF;;AiDhwKA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AjD8vKF;;AiDvvKA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AjDyvKF;AiDtvKE;EACE,8B3Cm8CgC;EgBh/C9B,mC2B8CF;AjDwvKJ;AsBlyKM;E2BwCJ;I3BvCM,gBAAA;EtBqyKN;AACF;AiD3vKE;EACE,e3Cg8CgC;AN6zHpC;AiDzvKE;EACE,sB3C67CgC;AN8zHpC;;AiDvvKA;EACE,+CAAA;AjD0vKF;AiDxvKE;EACE,gBAAA;EACA,gBAAA;AjD0vKJ;AiDvvKE;EACE,gBAAA;AjDyvKJ;;AiDrvKA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AjDwvKF;;AiDpvKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AjDovKF;;AiDhvKA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AjDsvK9D;AkDl2KE;EAAS,UAAA;AlDq2KX;AkDp2KE;EAAS,mCD2GiF;AjD4vK5F;;AiDvvKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;APg2KJ;AiDzvKE;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;AjD0vKJ;;AiDrvKA;EACE,gBAAA;EACA,8CAAA;AjDwvKF;;AiDnvKA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AjDovKF;;AiDhvKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;APi3KJ;AiD/uKE;EACE,8CAAA;AjDivKJ;;Ach2KI;EmCqHF;IACE,0BAAA;IACA,2CAAA;EjD+uKF;EiD3uKA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EjD6uKF;EiD1uKA;IACE,uBAAA;EjD4uKF;AACF;Ac/2KI;EmCuIF;;IAEE,uBAAA;EjD2uKF;AACF;Acr3KI;EmC8IF;IACE,wBAAA;EjD0uKF;AACF;AiDjuKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjDmuKN;AiDjuKM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;APi7KJ;AiDhuKM;;E1CjNF,gBAAA;APq7KJ;AiD/tKM;EACE,gBAAA;AjDiuKR;;Ac/3KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDuvKJ;EiDrvKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPq8KF;EiDpvKI;;I1CjNF,gBAAA;EPy8KF;EiDnvKI;IACE,gBAAA;EjDqvKN;AACF;Acp5KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD2wKJ;EiDzwKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPy9KF;EiDxwKI;;I1CjNF,gBAAA;EP69KF;EiDvwKI;IACE,gBAAA;EjDywKN;AACF;Acx6KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD+xKJ;EiD7xKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EP6+KF;EiD5xKI;;I1CjNF,gBAAA;EPi/KF;EiD3xKI;IACE,gBAAA;EjD6xKN;AACF;Ac57KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDmzKJ;EiDjzKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPigLF;EiDhzKI;;I1CjNF,gBAAA;EPqgLF;EiD/yKI;IACE,gBAAA;EjDizKN;AACF;Ach9KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDu0KJ;EiDr0KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPqhLF;EiDp0KI;;I1CjNF,gBAAA;EPyhLF;EiDn0KI;IACE,gBAAA;EjDq0KN;AACF;AmD/iLA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,4M9C+lB4B;E8C/lB5B,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AnDujLF;AmDrjLE;EAAS,kCAAA;AnDwjLX;AmDtjLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnDwjLJ;AmDtjLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDwjLN;;AmDnjLA;EACE,iDAAA;AnDsjLF;AmDpjLE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnDsjLJ;;AmDljLA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AnDqjLF;AmDnjLE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnDqjLJ;;AmDjjLA,mBAAA;AAEA;EACE,8CAAA;AnDmjLF;AmDjjLE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnDmjLJ;;AmD/iLA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AnDkjLF;AmDhjLE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnDkjLJ;;AmD9iLA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;APkoLJ;;AqDrpLA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,4M9C+lB4B;E8C/lB5B,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;APgrLJ;AqD5pLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArD8pLJ;AqD5pLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArD6pLN;;AqDvpLE;EACE,oFAAA;ArD0pLJ;AqDxpLI;EAEE,wFAAA;ArDypLN;AqDtpLI;EACE,SAAA;EACA,gDAAA;ArDwpLN;AqDrpLI;EACE,sCAAA;EACA,sCAAA;ArDupLN;;AqDlpLA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArDopLJ;AqDlpLI;EAEE,kIAAA;ArDmpLN;AqDhpLI;EACE,OAAA;EACA,kDAAA;ArDkpLN;AqD/oLI;EACE,oCAAA;EACA,wCAAA;ArDipLN;;AqD5oLA,mBAAA;AAGE;EACE,iFAAA;ArD6oLJ;AqD3oLI;EAEE,wFAAA;ArD4oLN;AqDzoLI;EACE,MAAA;EACA,mDAAA;ArD2oLN;AqDxoLI;EACE,mCAAA;EACA,yCAAA;ArD0oLN;AqDroLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArDuoLJ;;AqDnoLA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArDqoLJ;AqDnoLI;EAEE,kIAAA;ArDooLN;AqDjoLI;EACE,QAAA;EACA,iDAAA;ArDmoLN;AqDhoLI;EACE,qCAAA;EACA,uCAAA;ArDkoLN;;AqD7nLA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AP4wLJ;AqD9mLE;EACE,aAAA;ArDgnLJ;;AqD5mLA;EACE,0EAAA;EACA,mCAAA;ArD+mLF;;AsDpyLA;EACE,kBAAA;AtDuyLF;;AsDpyLA;EACE,mBAAA;AtDuyLF;;AsDpyLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtDuyLF;AuD7zLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD+zLJ;;AsDxyLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;UAAA,2BAAA;EhClBI,sCgCmBJ;AtD2yLF;AsB1zLM;EgCQN;IhCPQ,gBAAA;EtB6zLN;AACF;;AsD7yLA;;;EAGE,cAAA;AtDgzLF;;AsD7yLA;;EAEE,2BAAA;AtDgzLF;;AsD7yLA;;EAEE,4BAAA;AtDgzLF;;AsDvyLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtD0yLJ;AsDvyLE;;;EAGE,UAAA;EACA,UAAA;AtDyyLJ;AsDtyLE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AtDwyLJ;AsBj2LM;EgCqDJ;;IhCpDM,gBAAA;EtBq2LN;AACF;;AsDryLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,SAAA;EAAA,8CAAA;EACA,SAAA;EACA,YhD4gDmC;EgBnmD/B,8BgCwFJ;AtDuyLF;AsB33LM;EgCkEN;;IhCjEQ,gBAAA;EtB+3LN;AACF;AsD1yLE;;;EAEE,WhDrGO;EgDsGP,qBAAA;EACA,UAAA;EACA,YhDogDiC;ANyyIrC;;AsD1yLA;EACE,OAAA;AtD6yLF;;AsD1yLA;EACE,QAAA;AtD6yLF;;AsDxyLA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtD2yLF;;AsDxyLA;EACE,0TAAA;AtD2yLF;;AsDzyLA;EACE,yTAAA;AtD4yLF;;AsDpyLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDq9CmC;EgDp9CnC,mBAAA;EACA,gBhDm9CmC;ANm1IrC;AsDpyLE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,sBAAA;EAAA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB5mD/B,6BgCkKF;AtDqyLJ;AsBn8LM;EgC6IJ;IhC5IM,gBAAA;EtBs8LN;AACF;AsDvyLE;EACE,UhDw8CiC;ANi2IrC;;AsDhyLA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,WAAA;EAAA,uCAAA;EACA,kBAAA;AtDmyLF;;AsDxxLA;EALE,uCAAA;EACA,iCAAA;EACA,2DAAA;AtDiyLF;;AsD1xLA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;AtD6xLF;;AIx+LI;EkD8LF,uCAAA;EACA,iCAAA;EACA,2DAAA;AtD8yLF;;AwDz/LA;;EAEE,qBAAA;EACA,cAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxD2/LF;;AwDv/LA;EACE;IAAK,0CAAA;ExD2/LL;AACF;AwDx/LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxDu/LF;;AwDp/LA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxDs/LF;;AwD7+LA;EACE;IACE,mBAAA;ExDg/LF;EwD9+LA;IACE,UAAA;IACA,eAAA;ExDg/LF;AACF;AwD5+LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxD2+LF;;AwDx+LA;EACE,wBAAA;EACA,yBAAA;AxD2+LF;;AwDv+LE;EACE;;IAEE,kCAAA;ExD0+LJ;AACF;AyD3jMA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzD4jMF;;Ac//LI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD6iMJ;AACF;AsBxkMM;EmCYJ;InCXM,gBAAA;EtB2kMN;AACF;AcrhMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDojMN;EyDjjMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDmjMN;EyDhjMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDkjMN;EyD/iMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDijMN;EyD9iMI;IAEE,eAAA;EzD+iMN;EyD5iMI;IAGE,mBAAA;EzD4iMN;AACF;AczkMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD2iMN;EyDziMM;IACE,aAAA;EzD2iMR;EyDxiMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDyiMR;AACF;;Ac7kMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD2nMJ;AACF;AsBtpMM;EmCYJ;InCXM,gBAAA;EtBypMN;AACF;AcnmMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDkoMN;EyD/nMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDioMN;EyD9nMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDgoMN;EyD7nMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD+nMN;EyD5nMI;IAEE,eAAA;EzD6nMN;EyD1nMI;IAGE,mBAAA;EzD0nMN;AACF;AcvpMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDynMN;EyDvnMM;IACE,aAAA;EzDynMR;EyDtnMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDunMR;AACF;;Ac3pMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDysMJ;AACF;AsBpuMM;EmCYJ;InCXM,gBAAA;EtBuuMN;AACF;AcjrMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDgtMN;EyD7sMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD+sMN;EyD5sMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD8sMN;EyD3sMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD6sMN;EyD1sMI;IAEE,eAAA;EzD2sMN;EyDxsMI;IAGE,mBAAA;EzDwsMN;AACF;AcruMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDusMN;EyDrsMM;IACE,aAAA;EzDusMR;EyDpsMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDqsMR;AACF;;AczuMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDuxMJ;AACF;AsBlzMM;EmCYJ;InCXM,gBAAA;EtBqzMN;AACF;Ac/vMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD8xMN;EyD3xMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD6xMN;EyD1xMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD4xMN;EyDzxMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD2xMN;EyDxxMI;IAEE,eAAA;EzDyxMN;EyDtxMI;IAGE,mBAAA;EzDsxMN;AACF;AcnzMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDqxMN;EyDnxMM;IACE,aAAA;EzDqxMR;EyDlxMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDmxMR;AACF;;AcvzMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDq2MJ;AACF;AsBh4MM;EmCYJ;InCXM,gBAAA;EtBm4MN;AACF;Ac70MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD42MN;EyDz2MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD22MN;EyDx2MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD02MN;EyDv2MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDy2MN;EyDt2MI;IAEE,eAAA;EzDu2MN;EyDp2MI;IAGE,mBAAA;EzDo2MN;AACF;Acj4MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDm2MN;EyDj2MM;IACE,aAAA;EzDm2MR;EyDh2MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDi2MR;AACF;;AyDj7ME;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AzDk7MN;AsB58MM;EmCYJ;InCXM,gBAAA;EtB+8MN;AACF;AyDr7MM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzDu7MR;AyDp7MM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzDs7MR;AyDn7MM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzDq7MR;AyDl7MM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzDo7MR;AyDj7MM;EAEE,eAAA;AzDk7MR;AyD/6MM;EAGE,mBAAA;AzD+6MR;;AyDp5MA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sB5CUS;ANkgNX;AkDzgNE;EAAS,UAAA;AlD4gNX;AkD3gNE;EAAS,Y5Cm+CyB;AN2iKpC;;AyDh6MA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AzDm6MF;AyDj6ME;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;AzDk6MJ;;AyD95MA;EACE,gBAAA;EACA,kDAAA;AzDi6MF;;AyD95MA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzDi6MF;;A0DljNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;ANqwKpC;A0DnjNE;EACE,qBAAA;EACA,WAAA;A1DqjNJ;;A0DhjNA;EACE,iBAAA;A1DmjNF;;A0DhjNA;EACE,iBAAA;A1DmjNF;;A0DhjNA;EACE,iBAAA;A1DmjNF;;A0D9iNE;EACE,mDAAA;A1DijNJ;;A0D7iNA;EACE;IACE,YpDmxCgC;EN6xKlC;AACF;A0D7iNA;EACE,uFAAA;UAAA,+EAAA;EACA,4BAAA;UAAA,oBAAA;EACA,8CAAA;A1D+iNF;;A0D5iNA;EACE;IACE,+BAAA;YAAA,uBAAA;E1D+iNF;AACF;AuD9lNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDgmNJ;;A2DnmNE;EACE,sBAAA;EACA,kDAAA;EAAA,iFAAA;A3DsmNJ;;A2DxmNE;EACE,sBAAA;EACA,mDAAA;EAAA,mFAAA;A3D2mNJ;;A2D7mNE;EACE,sBAAA;EACA,iDAAA;EAAA,iFAAA;A3DgnNJ;;A2DlnNE;EACE,sBAAA;EACA,kDAAA;EAAA,8EAAA;A3DqnNJ;;A2DvnNE;EACE,sBAAA;EACA,iDAAA;EAAA,iFAAA;A3D0nNJ;;A2D5nNE;EACE,sBAAA;EACA,iDAAA;EAAA,gFAAA;A3D+nNJ;;A2DjoNE;EACE,sBAAA;EACA,mDAAA;EAAA,+EAAA;A3DooNJ;;A2DtoNE;EACE,sBAAA;EACA,gDAAA;EAAA,8EAAA;A3DyoNJ;;A4D3oNE;EACE,uCAAA;EAAA,wEAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,0GAAA;UAAA,kGAAA;A5D8oNJ;A4D3oNM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5D2oNR;;A4DppNE;EACE,wCAAA;EAAA,0EAAA;EACA,gEAAA;UAAA,wDAAA;EAAA,4GAAA;UAAA,oGAAA;A5DupNJ;A4DppNM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5DopNR;;A4D7pNE;EACE,sCAAA;EAAA,wEAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,0GAAA;UAAA,kGAAA;A5DgqNJ;A4D7pNM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5D6pNR;;A4DtqNE;EACE,uCAAA;EAAA,qEAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,uGAAA;UAAA,+FAAA;A5DyqNJ;A4DtqNM;EAGE,uCAAA;EAAA,+DAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,iGAAA;UAAA,yFAAA;A5DsqNR;;A4D/qNE;EACE,sCAAA;EAAA,wEAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,0GAAA;UAAA,kGAAA;A5DkrNJ;A4D/qNM;EAGE,uCAAA;EAAA,+DAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,iGAAA;UAAA,yFAAA;A5D+qNR;;A4DxrNE;EACE,sCAAA;EAAA,uEAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,yGAAA;UAAA,iGAAA;A5D2rNJ;A4DxrNM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5DwrNR;;A4DjsNE;EACE,wCAAA;EAAA,sEAAA;EACA,gEAAA;UAAA,wDAAA;EAAA,wGAAA;UAAA,gGAAA;A5DosNJ;A4DjsNM;EAGE,wCAAA;EAAA,gEAAA;EACA,gEAAA;UAAA,wDAAA;EAAA,kGAAA;UAAA,0FAAA;A5DisNR;;A4D1sNE;EACE,qCAAA;EAAA,qEAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,uGAAA;UAAA,+FAAA;A5D6sNJ;A4D1sNM;EAGE,qCAAA;EAAA,6DAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,+FAAA;UAAA,uFAAA;A5D0sNR;;A4DnsNA;EACE,kCAAA;EAAA,+EAAA;EACA,0DAAA;UAAA,kDAAA;EAAA,iHAAA;UAAA,yGAAA;A5DssNF;A4DnsNI;EAEE,qCAAA;EAAA,kFAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,oHAAA;UAAA,4GAAA;A5DosNN;;A6D9tNA;EACE,UAAA;EAEA,kDAAA;EAAA,kJAAA;A7DguNF;;A8DnuNA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,sDAAA;UAAA,8CAAA;EAAA,0FAAA;UAAA,kFAAA;EACA,6BxD2c4B;EwD1c5B,mCAAA;UAAA,2BAAA;A9DsuNF;A8DpuNE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A9DsuNJ;AsB/tNM;EwCZJ;IxCaM,gBAAA;EtBkuNN;AACF;;A8DpuNI;EACE,oCAAA;EAAA,mEAAA;A9DuuNN;;A+D1vNA;EACE,kBAAA;EACA,WAAA;A/D6vNF;A+D3vNE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A/D6vNJ;A+D1vNE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/D4vNJ;;A+DvvNE;EACE,uBAAA;A/D0vNJ;;A+D3vNE;EACE,sBAAA;A/D8vNJ;;A+D/vNE;EACE,yBAAA;A/DkwNJ;;A+DnwNE;EACE,iCAAA;A/DswNJ;;AgE3xNA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;ANurLpC;;AgE3xNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;AN+rLpC;;AgEtxNI;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,a1DmlC8B;ANssLpC;;AgEtxNI;EACE,wBAAA;EAAA,gBAAA;EACA,SAAA;EACA,a1D6kC8B;AN4sLpC;;Ac1vNI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENmtLlC;EgEnyNE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENwtLlC;AACF;AcvwNI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN+tLlC;EgE/yNE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENouLlC;AACF;AcnxNI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN2uLlC;EgE3zNE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENgvLlC;AACF;Ac/xNI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENuvLlC;EgEv0NE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN4vLlC;AACF;Ac3yNI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENmwLlC;EgEn1NE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENwwLlC;AACF;AiEr3NA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjEu3NF;;AiEp3NA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjEu3NF;;AkE/3NA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnEg4NF;AmE73NE;;EACE,6BAAA;AnEg4NJ;AmE53NE;;EACE,2BAAA;AnE+3NJ;;AoEl5NE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ApEq5NJ;;AqE75NA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtEi6NF;;AuEv6NA;EACE,qBAAA;EACA,mBAAA;EACA,UjEisB4B;EiEjsB5B,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;AN+uM9B;;AwE92NQ;EAOI,mCAAA;AxE22NZ;;AwEl3NQ;EAOI,8BAAA;AxE+2NZ;;AwEt3NQ;EAOI,iCAAA;AxEm3NZ;;AwE13NQ;EAOI,iCAAA;AxEu3NZ;;AwE93NQ;EAOI,sCAAA;AxE23NZ;;AwEl4NQ;EAOI,mCAAA;AxE+3NZ;;AwEt4NQ;EAOI,sBAAA;AxEm4NZ;;AwE14NQ;EAOI,uBAAA;AxEu4NZ;;AwE94NQ;EAOI,sBAAA;AxE24NZ;;AwEl5NQ;EAOI,8BAAA;AxE+4NZ;;AwEt5NQ;EAOI,4BAAA;AxEm5NZ;;AwE15NQ;EAOI,2BAAA;AxEu5NZ;;AwE95NQ;EAOI,iCAAA;AxE25NZ;;AwEl6NQ;EAOI,2BAAA;AxE+5NZ;;AwEt6NQ;EAOI,qBAAA;AxEm6NZ;;AwE16NQ;EAOI,wBAAA;AxEu6NZ;;AwE96NQ;EAOI,uBAAA;AxE26NZ;;AwEl7NQ;EAOI,wBAAA;AxE+6NZ;;AwEt7NQ;EAOI,qBAAA;AxEm7NZ;;AwE17NQ;EAOI,yBAAA;AxEu7NZ;;AwE97NQ;EAOI,2BAAA;AxE27NZ;;AwEl8NQ;EAOI,4BAAA;AxE+7NZ;;AwEt8NQ;EAOI,2BAAA;AxEm8NZ;;AwE18NQ;EAOI,2BAAA;AxEu8NZ;;AwE98NQ;EAOI,6BAAA;AxE28NZ;;AwEl9NQ;EAOI,8BAAA;AxE+8NZ;;AwEt9NQ;EAOI,6BAAA;AxEm9NZ;;AwE19NQ;EAOI,2BAAA;AxEu9NZ;;AwE99NQ;EAOI,6BAAA;AxE29NZ;;AwEl+NQ;EAOI,8BAAA;AxE+9NZ;;AwEt+NQ;EAOI,6BAAA;AxEm+NZ;;AwE1+NQ;EAOI,0BAAA;AxEu+NZ;;AwE9+NQ;EAOI,gCAAA;AxE2+NZ;;AwEl/NQ;EAOI,yBAAA;AxE++NZ;;AwEt/NQ;EAOI,wBAAA;AxEm/NZ;;AwE1/NQ;EAOI,+BAAA;AxEu/NZ;;AwE9/NQ;EAOI,yBAAA;AxE2/NZ;;AwElgOQ;EAOI,6BAAA;AxE+/NZ;;AwEtgOQ;EAOI,8BAAA;AxEmgOZ;;AwE1gOQ;EAOI,wBAAA;AxEugOZ;;AwE9gOQ;EAOI,+BAAA;AxE2gOZ;;AwElhOQ;EAOI,wBAAA;AxE+gOZ;;AwEthOQ;EAOI,wDAAA;EAAA,2CAAA;AxEmhOZ;;AwE1hOQ;EAOI,8DAAA;EAAA,8CAAA;AxEuhOZ;;AwE9hOQ;EAOI,uDAAA;EAAA,8CAAA;AxE2hOZ;;AwEliOQ;EAOI,2BAAA;AxE+hOZ;;AwEhjOQ;EACE,gFAAA;AxEmjOV;;AwEpjOQ;EACE,kFAAA;AxEujOV;;AwExjOQ;EACE,gFAAA;AxE2jOV;;AwE5jOQ;EACE,6EAAA;AxE+jOV;;AwEhkOQ;EACE,gFAAA;AxEmkOV;;AwEpkOQ;EACE,+EAAA;AxEukOV;;AwExkOQ;EACE,8EAAA;AxE2kOV;;AwE5kOQ;EACE,6EAAA;AxE+kOV;;AwEtkOQ;EAOI,2BAAA;AxEmkOZ;;AwE1kOQ;EAOI,6BAAA;AxEukOZ;;AwE9kOQ;EAOI,6BAAA;AxE2kOZ;;AwEllOQ;EAOI,0BAAA;AxE+kOZ;;AwEtlOQ;EAOI,mCAAA;EAAA,2BAAA;AxEmlOZ;;AwE1lOQ;EAOI,iBAAA;AxEulOZ;;AwE9lOQ;EAOI,mBAAA;AxE2lOZ;;AwElmOQ;EAOI,oBAAA;AxE+lOZ;;AwEtmOQ;EAOI,oBAAA;AxEmmOZ;;AwE1mOQ;EAOI,sBAAA;AxEumOZ;;AwE9mOQ;EAOI,uBAAA;AxE2mOZ;;AwElnOQ;EAOI,kBAAA;AxE+mOZ;;AwEtnOQ;EAOI,oBAAA;AxEmnOZ;;AwE1nOQ;EAOI,qBAAA;AxEunOZ;;AwE9nOQ;EAOI,mBAAA;AxE2nOZ;;AwEloOQ;EAOI,qBAAA;AxE+nOZ;;AwEtoOQ;EAOI,sBAAA;AxEmoOZ;;AwE1oOQ;EAOI,2CAAA;AxEuoOZ;;AwE9oOQ;EAOI,sCAAA;AxE2oOZ;;AwElpOQ;EAOI,sCAAA;AxE+oOZ;;AwEtpOQ;EAOI,oCAAA;EAAA,uFAAA;AxEmpOZ;;AwE1pOQ;EAOI,oBAAA;AxEupOZ;;AwE9pOQ;EAOI,wCAAA;EAAA,2FAAA;AxE2pOZ;;AwElqOQ;EAOI,wBAAA;AxE+pOZ;;AwEtqOQ;EAOI,0CAAA;EAAA,6FAAA;AxEmqOZ;;AwE1qOQ;EAOI,0BAAA;AxEuqOZ;;AwE9qOQ;EAOI,2CAAA;EAAA,8FAAA;AxE2qOZ;;AwElrOQ;EAOI,2BAAA;AxE+qOZ;;AwEtrOQ;EAOI,yCAAA;EAAA,4FAAA;AxEmrOZ;;AwE1rOQ;EAOI,yBAAA;AxEurOZ;;AwE9rOQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,8EAAA;AxE4rOZ;;AwEnsOQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,gFAAA;AxEisOZ;;AwExsOQ;EAIQ,sBAAA;EAGJ,oEAAA;EAAA,8EAAA;AxEssOZ;;AwE7sOQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,2EAAA;AxE2sOZ;;AwEltOQ;EAIQ,sBAAA;EAGJ,oEAAA;EAAA,8EAAA;AxEgtOZ;;AwEvtOQ;EAIQ,sBAAA;EAGJ,oEAAA;EAAA,6EAAA;AxEqtOZ;;AwE5tOQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxE0tOZ;;AwEjuOQ;EAIQ,sBAAA;EAGJ,mEAAA;EAAA,2EAAA;AxE+tOZ;;AwEtuOQ;EAIQ,sBAAA;EAGJ,gEAAA;EAAA,4EAAA;AxEouOZ;;AwE3uOQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxEyuOZ;;AwEhvOQ;EAOI,+CAAA;EAAA,wDAAA;AxE6uOZ;;AwEpvOQ;EAOI,+CAAA;EAAA,0DAAA;AxEivOZ;;AwExvOQ;EAOI,6CAAA;EAAA,wDAAA;AxEqvOZ;;AwE5vOQ;EAOI,+CAAA;EAAA,qDAAA;AxEyvOZ;;AwEhwOQ;EAOI,+CAAA;EAAA,wDAAA;AxE6vOZ;;AwEpwOQ;EAOI,+CAAA;EAAA,uDAAA;AxEiwOZ;;AwExwOQ;EAOI,gCAAA;EAAA,sDAAA;AxEqwOZ;;AwE5wOQ;EAOI,gCAAA;EAAA,qDAAA;AxEywOZ;;AwEhxOQ;EAOI,4BAAA;AxE6wOZ;;AwEpxOQ;EAOI,4BAAA;AxEixOZ;;AwExxOQ;EAOI,4BAAA;AxEqxOZ;;AwE5xOQ;EAOI,4BAAA;AxEyxOZ;;AwEhyOQ;EAOI,4BAAA;AxE6xOZ;;AwE9yOQ;EACE,wBAAA;AxEizOV;;AwElzOQ;EACE,yBAAA;AxEqzOV;;AwEtzOQ;EACE,wBAAA;AxEyzOV;;AwE1zOQ;EACE,yBAAA;AxE6zOV;;AwE9zOQ;EACE,sBAAA;AxEi0OV;;AwExzOQ;EAOI,qBAAA;AxEqzOZ;;AwE5zOQ;EAOI,qBAAA;AxEyzOZ;;AwEh0OQ;EAOI,qBAAA;AxE6zOZ;;AwEp0OQ;EAOI,sBAAA;AxEi0OZ;;AwEx0OQ;EAOI,sBAAA;AxEq0OZ;;AwE50OQ;EAOI,0BAAA;AxEy0OZ;;AwEh1OQ;EAOI,uBAAA;AxE60OZ;;AwEp1OQ;EAOI,2BAAA;AxEi1OZ;;AwEx1OQ;EAOI,sBAAA;AxEq1OZ;;AwE51OQ;EAOI,sBAAA;AxEy1OZ;;AwEh2OQ;EAOI,sBAAA;AxE61OZ;;AwEp2OQ;EAOI,uBAAA;AxEi2OZ;;AwEx2OQ;EAOI,uBAAA;AxEq2OZ;;AwE52OQ;EAOI,2BAAA;AxEy2OZ;;AwEh3OQ;EAOI,wBAAA;AxE62OZ;;AwEp3OQ;EAOI,4BAAA;AxEi3OZ;;AwEx3OQ;EAOI,yBAAA;AxEq3OZ;;AwE53OQ;EAOI,8BAAA;AxEy3OZ;;AwEh4OQ;EAOI,iCAAA;AxE63OZ;;AwEp4OQ;EAOI,sCAAA;AxEi4OZ;;AwEx4OQ;EAOI,yCAAA;AxEq4OZ;;AwE54OQ;EAOI,uBAAA;AxEy4OZ;;AwEh5OQ;EAOI,uBAAA;AxE64OZ;;AwEp5OQ;EAOI,yBAAA;AxEi5OZ;;AwEx5OQ;EAOI,yBAAA;AxEq5OZ;;AwE55OQ;EAOI,0BAAA;AxEy5OZ;;AwEh6OQ;EAOI,4BAAA;AxE65OZ;;AwEp6OQ;EAOI,kCAAA;AxEi6OZ;;AwEx6OQ;EAOI,sCAAA;AxEq6OZ;;AwE56OQ;EAOI,oCAAA;AxEy6OZ;;AwEh7OQ;EAOI,kCAAA;AxE66OZ;;AwEp7OQ;EAOI,yCAAA;AxEi7OZ;;AwEx7OQ;EAOI,wCAAA;AxEq7OZ;;AwE57OQ;EAOI,wCAAA;AxEy7OZ;;AwEh8OQ;EAOI,kCAAA;AxE67OZ;;AwEp8OQ;EAOI,gCAAA;AxEi8OZ;;AwEx8OQ;EAOI,8BAAA;AxEq8OZ;;AwE58OQ;EAOI,gCAAA;AxEy8OZ;;AwEh9OQ;EAOI,+BAAA;AxE68OZ;;AwEp9OQ;EAOI,oCAAA;AxEi9OZ;;AwEx9OQ;EAOI,kCAAA;AxEq9OZ;;AwE59OQ;EAOI,gCAAA;AxEy9OZ;;AwEh+OQ;EAOI,uCAAA;AxE69OZ;;AwEp+OQ;EAOI,sCAAA;AxEi+OZ;;AwEx+OQ;EAOI,iCAAA;AxEq+OZ;;AwE5+OQ;EAOI,2BAAA;AxEy+OZ;;AwEh/OQ;EAOI,iCAAA;AxE6+OZ;;AwEp/OQ;EAOI,+BAAA;AxEi/OZ;;AwEx/OQ;EAOI,6BAAA;AxEq/OZ;;AwE5/OQ;EAOI,+BAAA;AxEy/OZ;;AwEhgPQ;EAOI,8BAAA;AxE6/OZ;;AwEpgPQ;EAOI,oBAAA;AxEigPZ;;AwExgPQ;EAOI,mBAAA;AxEqgPZ;;AwE5gPQ;EAOI,mBAAA;AxEygPZ;;AwEhhPQ;EAOI,mBAAA;AxE6gPZ;;AwEphPQ;EAOI,mBAAA;AxEihPZ;;AwExhPQ;EAOI,mBAAA;AxEqhPZ;;AwE5hPQ;EAOI,mBAAA;AxEyhPZ;;AwEhiPQ;EAOI,mBAAA;AxE6hPZ;;AwEpiPQ;EAOI,oBAAA;AxEiiPZ;;AwExiPQ;EAOI,0BAAA;AxEqiPZ;;AwE5iPQ;EAOI,yBAAA;AxEyiPZ;;AwEhjPQ;EAOI,uBAAA;AxE6iPZ;;AwEpjPQ;EAOI,yBAAA;AxEijPZ;;AwExjPQ;EAOI,uBAAA;AxEqjPZ;;AwE5jPQ;EAOI,uBAAA;AxEyjPZ;;AwEhkPQ;EAOI,0BAAA;EAAA,yBAAA;AxE8jPZ;;AwErkPQ;EAOI,gCAAA;EAAA,+BAAA;AxEmkPZ;;AwE1kPQ;EAOI,+BAAA;EAAA,8BAAA;AxEwkPZ;;AwE/kPQ;EAOI,6BAAA;EAAA,4BAAA;AxE6kPZ;;AwEplPQ;EAOI,+BAAA;EAAA,8BAAA;AxEklPZ;;AwEzlPQ;EAOI,6BAAA;EAAA,4BAAA;AxEulPZ;;AwE9lPQ;EAOI,6BAAA;EAAA,4BAAA;AxE4lPZ;;AwEnmPQ;EAOI,wBAAA;EAAA,2BAAA;AxEimPZ;;AwExmPQ;EAOI,8BAAA;EAAA,iCAAA;AxEsmPZ;;AwE7mPQ;EAOI,6BAAA;EAAA,gCAAA;AxE2mPZ;;AwElnPQ;EAOI,2BAAA;EAAA,8BAAA;AxEgnPZ;;AwEvnPQ;EAOI,6BAAA;EAAA,gCAAA;AxEqnPZ;;AwE5nPQ;EAOI,2BAAA;EAAA,8BAAA;AxE0nPZ;;AwEjoPQ;EAOI,2BAAA;EAAA,8BAAA;AxE+nPZ;;AwEtoPQ;EAOI,wBAAA;AxEmoPZ;;AwE1oPQ;EAOI,8BAAA;AxEuoPZ;;AwE9oPQ;EAOI,6BAAA;AxE2oPZ;;AwElpPQ;EAOI,2BAAA;AxE+oPZ;;AwEtpPQ;EAOI,6BAAA;AxEmpPZ;;AwE1pPQ;EAOI,2BAAA;AxEupPZ;;AwE9pPQ;EAOI,2BAAA;AxE2pPZ;;AwElqPQ;EAOI,0BAAA;AxE+pPZ;;AwEtqPQ;EAOI,gCAAA;AxEmqPZ;;AwE1qPQ;EAOI,+BAAA;AxEuqPZ;;AwE9qPQ;EAOI,6BAAA;AxE2qPZ;;AwElrPQ;EAOI,+BAAA;AxE+qPZ;;AwEtrPQ;EAOI,6BAAA;AxEmrPZ;;AwE1rPQ;EAOI,6BAAA;AxEurPZ;;AwE9rPQ;EAOI,2BAAA;AxE2rPZ;;AwElsPQ;EAOI,iCAAA;AxE+rPZ;;AwEtsPQ;EAOI,gCAAA;AxEmsPZ;;AwE1sPQ;EAOI,8BAAA;AxEusPZ;;AwE9sPQ;EAOI,gCAAA;AxE2sPZ;;AwEltPQ;EAOI,8BAAA;AxE+sPZ;;AwEttPQ;EAOI,8BAAA;AxEmtPZ;;AwE1tPQ;EAOI,yBAAA;AxEutPZ;;AwE9tPQ;EAOI,+BAAA;AxE2tPZ;;AwEluPQ;EAOI,8BAAA;AxE+tPZ;;AwEtuPQ;EAOI,4BAAA;AxEmuPZ;;AwE1uPQ;EAOI,8BAAA;AxEuuPZ;;AwE9uPQ;EAOI,4BAAA;AxE2uPZ;;AwElvPQ;EAOI,4BAAA;AxE+uPZ;;AwEtvPQ;EAOI,qBAAA;AxEmvPZ;;AwE1vPQ;EAOI,2BAAA;AxEuvPZ;;AwE9vPQ;EAOI,0BAAA;AxE2vPZ;;AwElwPQ;EAOI,wBAAA;AxE+vPZ;;AwEtwPQ;EAOI,0BAAA;AxEmwPZ;;AwE1wPQ;EAOI,wBAAA;AxEuwPZ;;AwE9wPQ;EAOI,2BAAA;EAAA,0BAAA;AxE4wPZ;;AwEnxPQ;EAOI,iCAAA;EAAA,gCAAA;AxEixPZ;;AwExxPQ;EAOI,gCAAA;EAAA,+BAAA;AxEsxPZ;;AwE7xPQ;EAOI,8BAAA;EAAA,6BAAA;AxE2xPZ;;AwElyPQ;EAOI,gCAAA;EAAA,+BAAA;AxEgyPZ;;AwEvyPQ;EAOI,8BAAA;EAAA,6BAAA;AxEqyPZ;;AwE5yPQ;EAOI,yBAAA;EAAA,4BAAA;AxE0yPZ;;AwEjzPQ;EAOI,+BAAA;EAAA,kCAAA;AxE+yPZ;;AwEtzPQ;EAOI,8BAAA;EAAA,iCAAA;AxEozPZ;;AwE3zPQ;EAOI,4BAAA;EAAA,+BAAA;AxEyzPZ;;AwEh0PQ;EAOI,8BAAA;EAAA,iCAAA;AxE8zPZ;;AwEr0PQ;EAOI,4BAAA;EAAA,+BAAA;AxEm0PZ;;AwE10PQ;EAOI,yBAAA;AxEu0PZ;;AwE90PQ;EAOI,+BAAA;AxE20PZ;;AwEl1PQ;EAOI,8BAAA;AxE+0PZ;;AwEt1PQ;EAOI,4BAAA;AxEm1PZ;;AwE11PQ;EAOI,8BAAA;AxEu1PZ;;AwE91PQ;EAOI,4BAAA;AxE21PZ;;AwEl2PQ;EAOI,2BAAA;AxE+1PZ;;AwEt2PQ;EAOI,iCAAA;AxEm2PZ;;AwE12PQ;EAOI,gCAAA;AxEu2PZ;;AwE92PQ;EAOI,8BAAA;AxE22PZ;;AwEl3PQ;EAOI,gCAAA;AxE+2PZ;;AwEt3PQ;EAOI,8BAAA;AxEm3PZ;;AwE13PQ;EAOI,4BAAA;AxEu3PZ;;AwE93PQ;EAOI,kCAAA;AxE23PZ;;AwEl4PQ;EAOI,iCAAA;AxE+3PZ;;AwEt4PQ;EAOI,+BAAA;AxEm4PZ;;AwE14PQ;EAOI,iCAAA;AxEu4PZ;;AwE94PQ;EAOI,+BAAA;AxE24PZ;;AwEl5PQ;EAOI,0BAAA;AxE+4PZ;;AwEt5PQ;EAOI,gCAAA;AxEm5PZ;;AwE15PQ;EAOI,+BAAA;AxEu5PZ;;AwE95PQ;EAOI,6BAAA;AxE25PZ;;AwEl6PQ;EAOI,+BAAA;AxE+5PZ;;AwEt6PQ;EAOI,6BAAA;AxEm6PZ;;AwE16PQ;EAOI,iBAAA;AxEu6PZ;;AwE96PQ;EAOI,uBAAA;AxE26PZ;;AwEl7PQ;EAOI,sBAAA;AxE+6PZ;;AwEt7PQ;EAOI,oBAAA;AxEm7PZ;;AwE17PQ;EAOI,sBAAA;AxEu7PZ;;AwE97PQ;EAOI,oBAAA;AxE27PZ;;AwEl8PQ;EAOI,qBAAA;AxE+7PZ;;AwEt8PQ;EAOI,2BAAA;AxEm8PZ;;AwE18PQ;EAOI,0BAAA;AxEu8PZ;;AwE98PQ;EAOI,wBAAA;AxE28PZ;;AwEl9PQ;EAOI,0BAAA;AxE+8PZ;;AwEt9PQ;EAOI,wBAAA;AxEm9PZ;;AwE19PQ;EAOI,wBAAA;AxEu9PZ;;AwE99PQ;EAOI,8BAAA;AxE29PZ;;AwEl+PQ;EAOI,6BAAA;AxE+9PZ;;AwEt+PQ;EAOI,2BAAA;AxEm+PZ;;AwE1+PQ;EAOI,6BAAA;AxEu+PZ;;AwE9+PQ;EAOI,2BAAA;AxE2+PZ;;AwEl/PQ;EAOI,4GAAA;EAAA,gDAAA;AxE++PZ;;AwEt/PQ;EAOI,4CAAA;AxEm/PZ;;AwE1/PQ;EAOI,4CAAA;AxEu/PZ;;AwE9/PQ;EAOI,0CAAA;AxE2/PZ;;AwElgQQ;EAOI,4CAAA;AxE+/PZ;;AwEtgQQ;EAOI,6BAAA;AxEmgQZ;;AwE1gQQ;EAOI,0BAAA;AxEugQZ;;AwE9gQQ;EAOI,6BAAA;AxE2gQZ;;AwElhQQ;EAOI,6BAAA;AxE+gQZ;;AwEthQQ;EAOI,+BAAA;AxEmhQZ;;AwE1hQQ;EAOI,2BAAA;AxEuhQZ;;AwE9hQQ;EAOI,2BAAA;AxE2hQZ;;AwEliQQ;EAOI,2BAAA;AxE+hQZ;;AwEtiQQ;EAOI,2BAAA;AxEmiQZ;;AwE1iQQ;EAOI,2BAAA;AxEuiQZ;;AwE9iQQ;EAOI,8BAAA;AxE2iQZ;;AwEljQQ;EAOI,yBAAA;AxE+iQZ;;AwEtjQQ;EAOI,4BAAA;AxEmjQZ;;AwE1jQQ;EAOI,2BAAA;AxEujQZ;;AwE9jQQ;EAOI,yBAAA;AxE2jQZ;;AwElkQQ;EAOI,2BAAA;AxE+jQZ;;AwEtkQQ;EAOI,4BAAA;AxEmkQZ;;AwE1kQQ;EAOI,6BAAA;AxEukQZ;;AwE9kQQ;EAOI,gCAAA;AxE2kQZ;;AwEllQQ;EAOI,qCAAA;AxE+kQZ;;AwEtlQQ;EAOI,wCAAA;AxEmlQZ;;AwE1lQQ;EAOI,oCAAA;AxEulQZ;;AwE9lQQ;EAOI,oCAAA;AxE2lQZ;;AwElmQQ;EAOI,qCAAA;AxE+lQZ;;AwEtmQQ;EAOI,8BAAA;AxEmmQZ;;AwE1mQQ;EAOI,8BAAA;AxEumQZ;;AwE5nQQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AxE6mQZ;;AwE1lQQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,qEAAA;AxEmnQZ;;AwE1nQQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,uEAAA;AxEwnQZ;;AwE/nQQ;EAIQ,oBAAA;EAGJ,2DAAA;EAAA,qEAAA;AxE6nQZ;;AwEpoQQ;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,kEAAA;AxEkoQZ;;AwEzoQQ;EAIQ,oBAAA;EAGJ,2DAAA;EAAA,qEAAA;AxEuoQZ;;AwE9oQQ;EAIQ,oBAAA;EAGJ,2DAAA;EAAA,oEAAA;AxE4oQZ;;AwEnpQQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,mEAAA;AxEipQZ;;AwExpQQ;EAIQ,oBAAA;EAGJ,0DAAA;EAAA,kEAAA;AxEspQZ;;AwE7pQQ;EAIQ,oBAAA;EAGJ,uDAAA;EAAA,mEAAA;AxE2pQZ;;AwElqQQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,mEAAA;AxEgqQZ;;AwEvqQQ;EAIQ,oBAAA;EAGJ,0DAAA;EAAA,wEAAA;AxEqqQZ;;AwE5qQQ;EAIQ,oBAAA;EAGJ,wCAAA;EAAA,2CAAA;AxE0qQZ;;AwEjrQQ;EAIQ,oBAAA;EAGJ,oCAAA;AxE+qQZ;;AwEtrQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEorQZ;;AwE3rQQ;EAIQ,oBAAA;EAGJ,wCAAA;EAAA,2CAAA;AxEyrQZ;;AwEhsQQ;EAIQ,oBAAA;EAGJ,uCAAA;EAAA,0CAAA;AxE8rQZ;;AwErsQQ;EAIQ,oBAAA;EAGJ,sBAAA;EAAA,0CAAA;AxEmsQZ;;AwE1sQQ;EAIQ,oBAAA;EAGJ,yBAAA;AxEwsQZ;;AwEztQQ;EACE,uBAAA;AxE4tQV;;AwE7tQQ;EACE,sBAAA;AxEguQV;;AwEjuQQ;EACE,uBAAA;AxEouQV;;AwEruQQ;EACE,oBAAA;AxEwuQV;;AwE/tQQ;EAOI,qCAAA;EAAA,iDAAA;AxE4tQZ;;AwEnuQQ;EAOI,qCAAA;EAAA,mDAAA;AxEguQZ;;AwEvuQQ;EAOI,mCAAA;EAAA,iDAAA;AxEouQZ;;AwE3uQQ;EAOI,oCAAA;EAAA,8CAAA;AxEwuQZ;;AwE/uQQ;EAOI,qCAAA;EAAA,iDAAA;AxE4uQZ;;AwEnvQQ;EAOI,qCAAA;EAAA,gDAAA;AxEgvQZ;;AwEvvQQ;EAOI,yBAAA;EAAA,+CAAA;AxEovQZ;;AwE3vQQ;EAOI,yBAAA;EAAA,8CAAA;AxEwvQZ;;AwEzwQQ;EACE,sBAAA;AxE4wQV;;AwExwQU;EACE,sBAAA;AxE2wQZ;;AwEjxQQ;EACE,uBAAA;AxEoxQV;;AwEhxQU;EACE,uBAAA;AxEmxQZ;;AwEzxQQ;EACE,sBAAA;AxE4xQV;;AwExxQU;EACE,sBAAA;AxE2xQZ;;AwEjyQQ;EACE,uBAAA;AxEoyQV;;AwEhyQU;EACE,uBAAA;AxEmyQZ;;AwEzyQQ;EACE,oBAAA;AxE4yQV;;AwExyQU;EACE,oBAAA;AxE2yQZ;;AwEvyQQ;EAOI,yCAAA;AxEoyQZ;;AwE/xQU;EAOI,yCAAA;AxE4xQd;;AwE/yQQ;EAOI,wCAAA;AxE4yQZ;;AwEvyQU;EAOI,wCAAA;AxEoyQd;;AwEvzQQ;EAOI,yCAAA;AxEozQZ;;AwE/yQU;EAOI,yCAAA;AxE4yQd;;AwE/zQQ;EAIQ,8BAAA;EAGJ,8FAAA;UAAA,sFAAA;EAAA,uGAAA;UAAA,+FAAA;AxE6zQZ;;AwEp0QQ;EAIQ,8BAAA;EAGJ,+FAAA;UAAA,uFAAA;EAAA,yGAAA;UAAA,iGAAA;AxEk0QZ;;AwEz0QQ;EAIQ,8BAAA;EAGJ,6FAAA;UAAA,qFAAA;EAAA,uGAAA;UAAA,+FAAA;AxEu0QZ;;AwE90QQ;EAIQ,8BAAA;EAGJ,8FAAA;UAAA,sFAAA;EAAA,oGAAA;UAAA,4FAAA;AxE40QZ;;AwEn1QQ;EAIQ,8BAAA;EAGJ,6FAAA;UAAA,qFAAA;EAAA,uGAAA;UAAA,+FAAA;AxEi1QZ;;AwEx1QQ;EAIQ,8BAAA;EAGJ,6FAAA;UAAA,qFAAA;EAAA,sGAAA;UAAA,8FAAA;AxEs1QZ;;AwE71QQ;EAIQ,8BAAA;EAGJ,+FAAA;UAAA,uFAAA;EAAA,qGAAA;UAAA,6FAAA;AxE21QZ;;AwEl2QQ;EAIQ,8BAAA;EAGJ,4FAAA;UAAA,oFAAA;EAAA,oGAAA;UAAA,4FAAA;AxEg2QZ;;AwEv2QQ;EAIQ,8BAAA;EAGJ,+DAAA;UAAA,uDAAA;EAAA,6GAAA;UAAA,qGAAA;AxEq2QZ;;AwEt3QQ;EACE,8BAAA;AxEy3QV;;AwEr3QU;EACE,8BAAA;AxEw3QZ;;AwE93QQ;EACE,gCAAA;AxEi4QV;;AwE73QU;EACE,gCAAA;AxEg4QZ;;AwEt4QQ;EACE,iCAAA;AxEy4QV;;AwEr4QU;EACE,iCAAA;AxEw4QZ;;AwE94QQ;EACE,gCAAA;AxEi5QV;;AwE74QU;EACE,gCAAA;AxEg5QZ;;AwEt5QQ;EACE,iCAAA;AxEy5QV;;AwEr5QU;EACE,iCAAA;AxEw5QZ;;AwE95QQ;EACE,8BAAA;AxEi6QV;;AwE75QU;EACE,8BAAA;AxEg6QZ;;AwE55QQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,8EAAA;AxE05QZ;;AwEj6QQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,gFAAA;AxE+5QZ;;AwEt6QQ;EAIQ,kBAAA;EAGJ,oEAAA;EAAA,8EAAA;AxEo6QZ;;AwE36QQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,2EAAA;AxEy6QZ;;AwEh7QQ;EAIQ,kBAAA;EAGJ,oEAAA;EAAA,8EAAA;AxE86QZ;;AwEr7QQ;EAIQ,kBAAA;EAGJ,oEAAA;EAAA,6EAAA;AxEm7QZ;;AwE17QQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxEw7QZ;;AwE/7QQ;EAIQ,kBAAA;EAGJ,mEAAA;EAAA,2EAAA;AxE67QZ;;AwEp8QQ;EAIQ,kBAAA;EAGJ,gEAAA;EAAA,4EAAA;AxEk8QZ;;AwEz8QQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxEu8QZ;;AwE98QQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,8EAAA;AxE48QZ;;AwEn9QQ;EAIQ,kBAAA;EAGJ,wCAAA;AxEi9QZ;;AwEx9QQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,mFAAA;AxEs9QZ;;AwE79QQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,kFAAA;AxE29QZ;;AwE5+QQ;EACE,oBAAA;AxE++QV;;AwEh/QQ;EACE,qBAAA;AxEm/QV;;AwEp/QQ;EACE,oBAAA;AxEu/QV;;AwEx/QQ;EACE,qBAAA;AxE2/QV;;AwE5/QQ;EACE,kBAAA;AxE+/QV;;AwEt/QQ;EAOI,mDAAA;EAAA,wDAAA;AxEm/QZ;;AwE1/QQ;EAOI,mDAAA;EAAA,0DAAA;AxEu/QZ;;AwE9/QQ;EAOI,iDAAA;EAAA,wDAAA;AxE2/QZ;;AwElgRQ;EAOI,mDAAA;EAAA,qDAAA;AxE+/QZ;;AwEtgRQ;EAOI,mDAAA;EAAA,wDAAA;AxEmgRZ;;AwE1gRQ;EAOI,mDAAA;EAAA,uDAAA;AxEugRZ;;AwE9gRQ;EAOI,mDAAA;EAAA,sDAAA;AxE2gRZ;;AwElhRQ;EAOI,oCAAA;EAAA,qDAAA;AxE+gRZ;;AwEthRQ;EAOI,uGAAA;EAAA,+CAAA;AxEmhRZ;;AwE1hRQ;EAOI,mCAAA;UAAA,2BAAA;AxEuhRZ;;AwE9hRQ;EAOI,oCAAA;UAAA,4BAAA;AxE2hRZ;;AwEliRQ;EAOI,oCAAA;UAAA,4BAAA;AxE+hRZ;;AwEtiRQ;EAOI,+BAAA;AxEmiRZ;;AwE1iRQ;EAOI,+BAAA;AxEuiRZ;;AwE9iRQ;EAOI,kCAAA;EAAA,iDAAA;AxE2iRZ;;AwEljRQ;EAOI,2BAAA;AxE+iRZ;;AwEtjRQ;EAOI,iCAAA;EAAA,oDAAA;AxEmjRZ;;AwE1jRQ;EAOI,kCAAA;EAAA,iDAAA;AxEujRZ;;AwE9jRQ;EAOI,gCAAA;EAAA,oDAAA;AxE2jRZ;;AwElkRQ;EAOI,8BAAA;EAAA,oDAAA;AxE+jRZ;;AwEtkRQ;EAOI,8BAAA;EAAA,qDAAA;AxEmkRZ;;AwE1kRQ;EAOI,6BAAA;AxEukRZ;;AwE9kRQ;EAOI,+BAAA;EAAA,sDAAA;AxE2kRZ;;AwEllRQ;EAOI,2CAAA;EAAA,0DAAA;EAAA,4CAAA;EAAA,2DAAA;AxEglRZ;;AwEvlRQ;EAOI,oCAAA;EAAA,qCAAA;AxEqlRZ;;AwE5lRQ;EAOI,0CAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,8DAAA;AxE0lRZ;;AwEjmRQ;EAOI,2CAAA;EAAA,0DAAA;EAAA,4CAAA;EAAA,2DAAA;AxE+lRZ;;AwEtmRQ;EAOI,yCAAA;EAAA,6DAAA;EAAA,0CAAA;EAAA,8DAAA;AxEomRZ;;AwE3mRQ;EAOI,uCAAA;EAAA,6DAAA;EAAA,wCAAA;EAAA,8DAAA;AxEymRZ;;AwEhnRQ;EAOI,uCAAA;EAAA,8DAAA;EAAA,wCAAA;EAAA,+DAAA;AxE8mRZ;;AwErnRQ;EAOI,sCAAA;EAAA,uCAAA;AxEmnRZ;;AwE1nRQ;EAOI,wCAAA;EAAA,+DAAA;EAAA,yCAAA;EAAA,gEAAA;AxEwnRZ;;AwE/nRQ;EAOI,4CAAA;EAAA,2DAAA;EAAA,+CAAA;EAAA,8DAAA;AxE6nRZ;;AwEpoRQ;EAOI,qCAAA;EAAA,wCAAA;AxEkoRZ;;AwEzoRQ;EAOI,2CAAA;EAAA,8DAAA;EAAA,8CAAA;EAAA,iEAAA;AxEuoRZ;;AwE9oRQ;EAOI,4CAAA;EAAA,2DAAA;EAAA,+CAAA;EAAA,8DAAA;AxE4oRZ;;AwEnpRQ;EAOI,0CAAA;EAAA,8DAAA;EAAA,6CAAA;EAAA,iEAAA;AxEipRZ;;AwExpRQ;EAOI,wCAAA;EAAA,8DAAA;EAAA,2CAAA;EAAA,iEAAA;AxEspRZ;;AwE7pRQ;EAOI,wCAAA;EAAA,+DAAA;EAAA,2CAAA;EAAA,kEAAA;AxE2pRZ;;AwElqRQ;EAOI,uCAAA;EAAA,0CAAA;AxEgqRZ;;AwEvqRQ;EAOI,yCAAA;EAAA,gEAAA;EAAA,4CAAA;EAAA,mEAAA;AxEqqRZ;;AwE5qRQ;EAOI,+CAAA;EAAA,8DAAA;EAAA,8CAAA;EAAA,6DAAA;AxE0qRZ;;AwEjrRQ;EAOI,wCAAA;EAAA,uCAAA;AxE+qRZ;;AwEtrRQ;EAOI,8CAAA;EAAA,iEAAA;EAAA,6CAAA;EAAA,gEAAA;AxEorRZ;;AwE3rRQ;EAOI,+CAAA;EAAA,8DAAA;EAAA,8CAAA;EAAA,6DAAA;AxEyrRZ;;AwEhsRQ;EAOI,6CAAA;EAAA,iEAAA;EAAA,4CAAA;EAAA,gEAAA;AxE8rRZ;;AwErsRQ;EAOI,2CAAA;EAAA,iEAAA;EAAA,0CAAA;EAAA,gEAAA;AxEmsRZ;;AwE1sRQ;EAOI,2CAAA;EAAA,kEAAA;EAAA,0CAAA;EAAA,iEAAA;AxEwsRZ;;AwE/sRQ;EAOI,0CAAA;EAAA,yCAAA;AxE6sRZ;;AwEptRQ;EAOI,4CAAA;EAAA,mEAAA;EAAA,2CAAA;EAAA,kEAAA;AxEktRZ;;AwEztRQ;EAOI,8CAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,0DAAA;AxEutRZ;;AwE9tRQ;EAOI,uCAAA;EAAA,oCAAA;AxE4tRZ;;AwEnuRQ;EAOI,6CAAA;EAAA,gEAAA;EAAA,0CAAA;EAAA,6DAAA;AxEiuRZ;;AwExuRQ;EAOI,8CAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,0DAAA;AxEsuRZ;;AwE7uRQ;EAOI,4CAAA;EAAA,gEAAA;EAAA,yCAAA;EAAA,6DAAA;AxE2uRZ;;AwElvRQ;EAOI,0CAAA;EAAA,gEAAA;EAAA,uCAAA;EAAA,6DAAA;AxEgvRZ;;AwEvvRQ;EAOI,0CAAA;EAAA,iEAAA;EAAA,uCAAA;EAAA,8DAAA;AxEqvRZ;;AwE5vRQ;EAOI,yCAAA;EAAA,sCAAA;AxE0vRZ;;AwEjwRQ;EAOI,2CAAA;EAAA,kEAAA;EAAA,wCAAA;EAAA,+DAAA;AxE+vRZ;;AwEtwRQ;EAOI,8BAAA;AxEmwRZ;;AwE1wRQ;EAOI,6BAAA;AxEuwRZ;;AwE9wRQ;EAOI,sBAAA;AxE2wRZ;;AwElxRQ;EAOI,qBAAA;AxE+wRZ;;AwEtxRQ;EAOI,qBAAA;AxEmxRZ;;AwE1xRQ;EAOI,qBAAA;AxEuxRZ;;AwE9xRQ;EAOI,qBAAA;AxE2xRZ;;AcryRI;E0DGI;IAOI,sBAAA;ExEgyRV;EwEvyRM;IAOI,uBAAA;ExEmyRV;EwE1yRM;IAOI,sBAAA;ExEsyRV;EwE7yRM;IAOI,8BAAA;ExEyyRV;EwEhzRM;IAOI,4BAAA;ExE4yRV;EwEnzRM;IAOI,2BAAA;ExE+yRV;EwEtzRM;IAOI,iCAAA;ExEkzRV;EwEzzRM;IAOI,2BAAA;ExEqzRV;EwE5zRM;IAOI,0BAAA;ExEwzRV;EwE/zRM;IAOI,gCAAA;ExE2zRV;EwEl0RM;IAOI,yBAAA;ExE8zRV;EwEr0RM;IAOI,wBAAA;ExEi0RV;EwEx0RM;IAOI,+BAAA;ExEo0RV;EwE30RM;IAOI,yBAAA;ExEu0RV;EwE90RM;IAOI,6BAAA;ExE00RV;EwEj1RM;IAOI,8BAAA;ExE60RV;EwEp1RM;IAOI,wBAAA;ExEg1RV;EwEv1RM;IAOI,+BAAA;ExEm1RV;EwE11RM;IAOI,wBAAA;ExEs1RV;EwE71RM;IAOI,yBAAA;ExEy1RV;EwEh2RM;IAOI,8BAAA;ExE41RV;EwEn2RM;IAOI,iCAAA;ExE+1RV;EwEt2RM;IAOI,sCAAA;ExEk2RV;EwEz2RM;IAOI,yCAAA;ExEq2RV;EwE52RM;IAOI,uBAAA;ExEw2RV;EwE/2RM;IAOI,uBAAA;ExE22RV;EwEl3RM;IAOI,yBAAA;ExE82RV;EwEr3RM;IAOI,yBAAA;ExEi3RV;EwEx3RM;IAOI,0BAAA;ExEo3RV;EwE33RM;IAOI,4BAAA;ExEu3RV;EwE93RM;IAOI,kCAAA;ExE03RV;EwEj4RM;IAOI,sCAAA;ExE63RV;EwEp4RM;IAOI,oCAAA;ExEg4RV;EwEv4RM;IAOI,kCAAA;ExEm4RV;EwE14RM;IAOI,yCAAA;ExEs4RV;EwE74RM;IAOI,wCAAA;ExEy4RV;EwEh5RM;IAOI,wCAAA;ExE44RV;EwEn5RM;IAOI,kCAAA;ExE+4RV;EwEt5RM;IAOI,gCAAA;ExEk5RV;EwEz5RM;IAOI,8BAAA;ExEq5RV;EwE55RM;IAOI,gCAAA;ExEw5RV;EwE/5RM;IAOI,+BAAA;ExE25RV;EwEl6RM;IAOI,oCAAA;ExE85RV;EwEr6RM;IAOI,kCAAA;ExEi6RV;EwEx6RM;IAOI,gCAAA;ExEo6RV;EwE36RM;IAOI,uCAAA;ExEu6RV;EwE96RM;IAOI,sCAAA;ExE06RV;EwEj7RM;IAOI,iCAAA;ExE66RV;EwEp7RM;IAOI,2BAAA;ExEg7RV;EwEv7RM;IAOI,iCAAA;ExEm7RV;EwE17RM;IAOI,+BAAA;ExEs7RV;EwE77RM;IAOI,6BAAA;ExEy7RV;EwEh8RM;IAOI,+BAAA;ExE47RV;EwEn8RM;IAOI,8BAAA;ExE+7RV;EwEt8RM;IAOI,oBAAA;ExEk8RV;EwEz8RM;IAOI,mBAAA;ExEq8RV;EwE58RM;IAOI,mBAAA;ExEw8RV;EwE/8RM;IAOI,mBAAA;ExE28RV;EwEl9RM;IAOI,mBAAA;ExE88RV;EwEr9RM;IAOI,mBAAA;ExEi9RV;EwEx9RM;IAOI,mBAAA;ExEo9RV;EwE39RM;IAOI,mBAAA;ExEu9RV;EwE99RM;IAOI,oBAAA;ExE09RV;EwEj+RM;IAOI,0BAAA;ExE69RV;EwEp+RM;IAOI,yBAAA;ExEg+RV;EwEv+RM;IAOI,uBAAA;ExEm+RV;EwE1+RM;IAOI,yBAAA;ExEs+RV;EwE7+RM;IAOI,uBAAA;ExEy+RV;EwEh/RM;IAOI,uBAAA;ExE4+RV;EwEn/RM;IAOI,0BAAA;IAAA,yBAAA;ExEg/RV;EwEv/RM;IAOI,gCAAA;IAAA,+BAAA;ExEo/RV;EwE3/RM;IAOI,+BAAA;IAAA,8BAAA;ExEw/RV;EwE//RM;IAOI,6BAAA;IAAA,4BAAA;ExE4/RV;EwEngSM;IAOI,+BAAA;IAAA,8BAAA;ExEggSV;EwEvgSM;IAOI,6BAAA;IAAA,4BAAA;ExEogSV;EwE3gSM;IAOI,6BAAA;IAAA,4BAAA;ExEwgSV;EwE/gSM;IAOI,wBAAA;IAAA,2BAAA;ExE4gSV;EwEnhSM;IAOI,8BAAA;IAAA,iCAAA;ExEghSV;EwEvhSM;IAOI,6BAAA;IAAA,gCAAA;ExEohSV;EwE3hSM;IAOI,2BAAA;IAAA,8BAAA;ExEwhSV;EwE/hSM;IAOI,6BAAA;IAAA,gCAAA;ExE4hSV;EwEniSM;IAOI,2BAAA;IAAA,8BAAA;ExEgiSV;EwEviSM;IAOI,2BAAA;IAAA,8BAAA;ExEoiSV;EwE3iSM;IAOI,wBAAA;ExEuiSV;EwE9iSM;IAOI,8BAAA;ExE0iSV;EwEjjSM;IAOI,6BAAA;ExE6iSV;EwEpjSM;IAOI,2BAAA;ExEgjSV;EwEvjSM;IAOI,6BAAA;ExEmjSV;EwE1jSM;IAOI,2BAAA;ExEsjSV;EwE7jSM;IAOI,2BAAA;ExEyjSV;EwEhkSM;IAOI,0BAAA;ExE4jSV;EwEnkSM;IAOI,gCAAA;ExE+jSV;EwEtkSM;IAOI,+BAAA;ExEkkSV;EwEzkSM;IAOI,6BAAA;ExEqkSV;EwE5kSM;IAOI,+BAAA;ExEwkSV;EwE/kSM;IAOI,6BAAA;ExE2kSV;EwEllSM;IAOI,6BAAA;ExE8kSV;EwErlSM;IAOI,2BAAA;ExEilSV;EwExlSM;IAOI,iCAAA;ExEolSV;EwE3lSM;IAOI,gCAAA;ExEulSV;EwE9lSM;IAOI,8BAAA;ExE0lSV;EwEjmSM;IAOI,gCAAA;ExE6lSV;EwEpmSM;IAOI,8BAAA;ExEgmSV;EwEvmSM;IAOI,8BAAA;ExEmmSV;EwE1mSM;IAOI,yBAAA;ExEsmSV;EwE7mSM;IAOI,+BAAA;ExEymSV;EwEhnSM;IAOI,8BAAA;ExE4mSV;EwEnnSM;IAOI,4BAAA;ExE+mSV;EwEtnSM;IAOI,8BAAA;ExEknSV;EwEznSM;IAOI,4BAAA;ExEqnSV;EwE5nSM;IAOI,4BAAA;ExEwnSV;EwE/nSM;IAOI,qBAAA;ExE2nSV;EwEloSM;IAOI,2BAAA;ExE8nSV;EwEroSM;IAOI,0BAAA;ExEioSV;EwExoSM;IAOI,wBAAA;ExEooSV;EwE3oSM;IAOI,0BAAA;ExEuoSV;EwE9oSM;IAOI,wBAAA;ExE0oSV;EwEjpSM;IAOI,2BAAA;IAAA,0BAAA;ExE8oSV;EwErpSM;IAOI,iCAAA;IAAA,gCAAA;ExEkpSV;EwEzpSM;IAOI,gCAAA;IAAA,+BAAA;ExEspSV;EwE7pSM;IAOI,8BAAA;IAAA,6BAAA;ExE0pSV;EwEjqSM;IAOI,gCAAA;IAAA,+BAAA;ExE8pSV;EwErqSM;IAOI,8BAAA;IAAA,6BAAA;ExEkqSV;EwEzqSM;IAOI,yBAAA;IAAA,4BAAA;ExEsqSV;EwE7qSM;IAOI,+BAAA;IAAA,kCAAA;ExE0qSV;EwEjrSM;IAOI,8BAAA;IAAA,iCAAA;ExE8qSV;EwErrSM;IAOI,4BAAA;IAAA,+BAAA;ExEkrSV;EwEzrSM;IAOI,8BAAA;IAAA,iCAAA;ExEsrSV;EwE7rSM;IAOI,4BAAA;IAAA,+BAAA;ExE0rSV;EwEjsSM;IAOI,yBAAA;ExE6rSV;EwEpsSM;IAOI,+BAAA;ExEgsSV;EwEvsSM;IAOI,8BAAA;ExEmsSV;EwE1sSM;IAOI,4BAAA;ExEssSV;EwE7sSM;IAOI,8BAAA;ExEysSV;EwEhtSM;IAOI,4BAAA;ExE4sSV;EwEntSM;IAOI,2BAAA;ExE+sSV;EwEttSM;IAOI,iCAAA;ExEktSV;EwEztSM;IAOI,gCAAA;ExEqtSV;EwE5tSM;IAOI,8BAAA;ExEwtSV;EwE/tSM;IAOI,gCAAA;ExE2tSV;EwEluSM;IAOI,8BAAA;ExE8tSV;EwEruSM;IAOI,4BAAA;ExEiuSV;EwExuSM;IAOI,kCAAA;ExEouSV;EwE3uSM;IAOI,iCAAA;ExEuuSV;EwE9uSM;IAOI,+BAAA;ExE0uSV;EwEjvSM;IAOI,iCAAA;ExE6uSV;EwEpvSM;IAOI,+BAAA;ExEgvSV;EwEvvSM;IAOI,0BAAA;ExEmvSV;EwE1vSM;IAOI,gCAAA;ExEsvSV;EwE7vSM;IAOI,+BAAA;ExEyvSV;EwEhwSM;IAOI,6BAAA;ExE4vSV;EwEnwSM;IAOI,+BAAA;ExE+vSV;EwEtwSM;IAOI,6BAAA;ExEkwSV;EwEzwSM;IAOI,iBAAA;ExEqwSV;EwE5wSM;IAOI,uBAAA;ExEwwSV;EwE/wSM;IAOI,sBAAA;ExE2wSV;EwElxSM;IAOI,oBAAA;ExE8wSV;EwErxSM;IAOI,sBAAA;ExEixSV;EwExxSM;IAOI,oBAAA;ExEoxSV;EwE3xSM;IAOI,qBAAA;ExEuxSV;EwE9xSM;IAOI,2BAAA;ExE0xSV;EwEjySM;IAOI,0BAAA;ExE6xSV;EwEpySM;IAOI,wBAAA;ExEgySV;EwEvySM;IAOI,0BAAA;ExEmySV;EwE1ySM;IAOI,wBAAA;ExEsySV;EwE7ySM;IAOI,wBAAA;ExEyySV;EwEhzSM;IAOI,8BAAA;ExE4ySV;EwEnzSM;IAOI,6BAAA;ExE+ySV;EwEtzSM;IAOI,2BAAA;ExEkzSV;EwEzzSM;IAOI,6BAAA;ExEqzSV;EwE5zSM;IAOI,2BAAA;ExEwzSV;EwE/zSM;IAOI,2BAAA;ExE2zSV;EwEl0SM;IAOI,4BAAA;ExE8zSV;EwEr0SM;IAOI,6BAAA;ExEi0SV;AACF;Ac50SI;E0DGI;IAOI,sBAAA;ExEs0SV;EwE70SM;IAOI,uBAAA;ExEy0SV;EwEh1SM;IAOI,sBAAA;ExE40SV;EwEn1SM;IAOI,8BAAA;ExE+0SV;EwEt1SM;IAOI,4BAAA;ExEk1SV;EwEz1SM;IAOI,2BAAA;ExEq1SV;EwE51SM;IAOI,iCAAA;ExEw1SV;EwE/1SM;IAOI,2BAAA;ExE21SV;EwEl2SM;IAOI,0BAAA;ExE81SV;EwEr2SM;IAOI,gCAAA;ExEi2SV;EwEx2SM;IAOI,yBAAA;ExEo2SV;EwE32SM;IAOI,wBAAA;ExEu2SV;EwE92SM;IAOI,+BAAA;ExE02SV;EwEj3SM;IAOI,yBAAA;ExE62SV;EwEp3SM;IAOI,6BAAA;ExEg3SV;EwEv3SM;IAOI,8BAAA;ExEm3SV;EwE13SM;IAOI,wBAAA;ExEs3SV;EwE73SM;IAOI,+BAAA;ExEy3SV;EwEh4SM;IAOI,wBAAA;ExE43SV;EwEn4SM;IAOI,yBAAA;ExE+3SV;EwEt4SM;IAOI,8BAAA;ExEk4SV;EwEz4SM;IAOI,iCAAA;ExEq4SV;EwE54SM;IAOI,sCAAA;ExEw4SV;EwE/4SM;IAOI,yCAAA;ExE24SV;EwEl5SM;IAOI,uBAAA;ExE84SV;EwEr5SM;IAOI,uBAAA;ExEi5SV;EwEx5SM;IAOI,yBAAA;ExEo5SV;EwE35SM;IAOI,yBAAA;ExEu5SV;EwE95SM;IAOI,0BAAA;ExE05SV;EwEj6SM;IAOI,4BAAA;ExE65SV;EwEp6SM;IAOI,kCAAA;ExEg6SV;EwEv6SM;IAOI,sCAAA;ExEm6SV;EwE16SM;IAOI,oCAAA;ExEs6SV;EwE76SM;IAOI,kCAAA;ExEy6SV;EwEh7SM;IAOI,yCAAA;ExE46SV;EwEn7SM;IAOI,wCAAA;ExE+6SV;EwEt7SM;IAOI,wCAAA;ExEk7SV;EwEz7SM;IAOI,kCAAA;ExEq7SV;EwE57SM;IAOI,gCAAA;ExEw7SV;EwE/7SM;IAOI,8BAAA;ExE27SV;EwEl8SM;IAOI,gCAAA;ExE87SV;EwEr8SM;IAOI,+BAAA;ExEi8SV;EwEx8SM;IAOI,oCAAA;ExEo8SV;EwE38SM;IAOI,kCAAA;ExEu8SV;EwE98SM;IAOI,gCAAA;ExE08SV;EwEj9SM;IAOI,uCAAA;ExE68SV;EwEp9SM;IAOI,sCAAA;ExEg9SV;EwEv9SM;IAOI,iCAAA;ExEm9SV;EwE19SM;IAOI,2BAAA;ExEs9SV;EwE79SM;IAOI,iCAAA;ExEy9SV;EwEh+SM;IAOI,+BAAA;ExE49SV;EwEn+SM;IAOI,6BAAA;ExE+9SV;EwEt+SM;IAOI,+BAAA;ExEk+SV;EwEz+SM;IAOI,8BAAA;ExEq+SV;EwE5+SM;IAOI,oBAAA;ExEw+SV;EwE/+SM;IAOI,mBAAA;ExE2+SV;EwEl/SM;IAOI,mBAAA;ExE8+SV;EwEr/SM;IAOI,mBAAA;ExEi/SV;EwEx/SM;IAOI,mBAAA;ExEo/SV;EwE3/SM;IAOI,mBAAA;ExEu/SV;EwE9/SM;IAOI,mBAAA;ExE0/SV;EwEjgTM;IAOI,mBAAA;ExE6/SV;EwEpgTM;IAOI,oBAAA;ExEggTV;EwEvgTM;IAOI,0BAAA;ExEmgTV;EwE1gTM;IAOI,yBAAA;ExEsgTV;EwE7gTM;IAOI,uBAAA;ExEygTV;EwEhhTM;IAOI,yBAAA;ExE4gTV;EwEnhTM;IAOI,uBAAA;ExE+gTV;EwEthTM;IAOI,uBAAA;ExEkhTV;EwEzhTM;IAOI,0BAAA;IAAA,yBAAA;ExEshTV;EwE7hTM;IAOI,gCAAA;IAAA,+BAAA;ExE0hTV;EwEjiTM;IAOI,+BAAA;IAAA,8BAAA;ExE8hTV;EwEriTM;IAOI,6BAAA;IAAA,4BAAA;ExEkiTV;EwEziTM;IAOI,+BAAA;IAAA,8BAAA;ExEsiTV;EwE7iTM;IAOI,6BAAA;IAAA,4BAAA;ExE0iTV;EwEjjTM;IAOI,6BAAA;IAAA,4BAAA;ExE8iTV;EwErjTM;IAOI,wBAAA;IAAA,2BAAA;ExEkjTV;EwEzjTM;IAOI,8BAAA;IAAA,iCAAA;ExEsjTV;EwE7jTM;IAOI,6BAAA;IAAA,gCAAA;ExE0jTV;EwEjkTM;IAOI,2BAAA;IAAA,8BAAA;ExE8jTV;EwErkTM;IAOI,6BAAA;IAAA,gCAAA;ExEkkTV;EwEzkTM;IAOI,2BAAA;IAAA,8BAAA;ExEskTV;EwE7kTM;IAOI,2BAAA;IAAA,8BAAA;ExE0kTV;EwEjlTM;IAOI,wBAAA;ExE6kTV;EwEplTM;IAOI,8BAAA;ExEglTV;EwEvlTM;IAOI,6BAAA;ExEmlTV;EwE1lTM;IAOI,2BAAA;ExEslTV;EwE7lTM;IAOI,6BAAA;ExEylTV;EwEhmTM;IAOI,2BAAA;ExE4lTV;EwEnmTM;IAOI,2BAAA;ExE+lTV;EwEtmTM;IAOI,0BAAA;ExEkmTV;EwEzmTM;IAOI,gCAAA;ExEqmTV;EwE5mTM;IAOI,+BAAA;ExEwmTV;EwE/mTM;IAOI,6BAAA;ExE2mTV;EwElnTM;IAOI,+BAAA;ExE8mTV;EwErnTM;IAOI,6BAAA;ExEinTV;EwExnTM;IAOI,6BAAA;ExEonTV;EwE3nTM;IAOI,2BAAA;ExEunTV;EwE9nTM;IAOI,iCAAA;ExE0nTV;EwEjoTM;IAOI,gCAAA;ExE6nTV;EwEpoTM;IAOI,8BAAA;ExEgoTV;EwEvoTM;IAOI,gCAAA;ExEmoTV;EwE1oTM;IAOI,8BAAA;ExEsoTV;EwE7oTM;IAOI,8BAAA;ExEyoTV;EwEhpTM;IAOI,yBAAA;ExE4oTV;EwEnpTM;IAOI,+BAAA;ExE+oTV;EwEtpTM;IAOI,8BAAA;ExEkpTV;EwEzpTM;IAOI,4BAAA;ExEqpTV;EwE5pTM;IAOI,8BAAA;ExEwpTV;EwE/pTM;IAOI,4BAAA;ExE2pTV;EwElqTM;IAOI,4BAAA;ExE8pTV;EwErqTM;IAOI,qBAAA;ExEiqTV;EwExqTM;IAOI,2BAAA;ExEoqTV;EwE3qTM;IAOI,0BAAA;ExEuqTV;EwE9qTM;IAOI,wBAAA;ExE0qTV;EwEjrTM;IAOI,0BAAA;ExE6qTV;EwEprTM;IAOI,wBAAA;ExEgrTV;EwEvrTM;IAOI,2BAAA;IAAA,0BAAA;ExEorTV;EwE3rTM;IAOI,iCAAA;IAAA,gCAAA;ExEwrTV;EwE/rTM;IAOI,gCAAA;IAAA,+BAAA;ExE4rTV;EwEnsTM;IAOI,8BAAA;IAAA,6BAAA;ExEgsTV;EwEvsTM;IAOI,gCAAA;IAAA,+BAAA;ExEosTV;EwE3sTM;IAOI,8BAAA;IAAA,6BAAA;ExEwsTV;EwE/sTM;IAOI,yBAAA;IAAA,4BAAA;ExE4sTV;EwEntTM;IAOI,+BAAA;IAAA,kCAAA;ExEgtTV;EwEvtTM;IAOI,8BAAA;IAAA,iCAAA;ExEotTV;EwE3tTM;IAOI,4BAAA;IAAA,+BAAA;ExEwtTV;EwE/tTM;IAOI,8BAAA;IAAA,iCAAA;ExE4tTV;EwEnuTM;IAOI,4BAAA;IAAA,+BAAA;ExEguTV;EwEvuTM;IAOI,yBAAA;ExEmuTV;EwE1uTM;IAOI,+BAAA;ExEsuTV;EwE7uTM;IAOI,8BAAA;ExEyuTV;EwEhvTM;IAOI,4BAAA;ExE4uTV;EwEnvTM;IAOI,8BAAA;ExE+uTV;EwEtvTM;IAOI,4BAAA;ExEkvTV;EwEzvTM;IAOI,2BAAA;ExEqvTV;EwE5vTM;IAOI,iCAAA;ExEwvTV;EwE/vTM;IAOI,gCAAA;ExE2vTV;EwElwTM;IAOI,8BAAA;ExE8vTV;EwErwTM;IAOI,gCAAA;ExEiwTV;EwExwTM;IAOI,8BAAA;ExEowTV;EwE3wTM;IAOI,4BAAA;ExEuwTV;EwE9wTM;IAOI,kCAAA;ExE0wTV;EwEjxTM;IAOI,iCAAA;ExE6wTV;EwEpxTM;IAOI,+BAAA;ExEgxTV;EwEvxTM;IAOI,iCAAA;ExEmxTV;EwE1xTM;IAOI,+BAAA;ExEsxTV;EwE7xTM;IAOI,0BAAA;ExEyxTV;EwEhyTM;IAOI,gCAAA;ExE4xTV;EwEnyTM;IAOI,+BAAA;ExE+xTV;EwEtyTM;IAOI,6BAAA;ExEkyTV;EwEzyTM;IAOI,+BAAA;ExEqyTV;EwE5yTM;IAOI,6BAAA;ExEwyTV;EwE/yTM;IAOI,iBAAA;ExE2yTV;EwElzTM;IAOI,uBAAA;ExE8yTV;EwErzTM;IAOI,sBAAA;ExEizTV;EwExzTM;IAOI,oBAAA;ExEozTV;EwE3zTM;IAOI,sBAAA;ExEuzTV;EwE9zTM;IAOI,oBAAA;ExE0zTV;EwEj0TM;IAOI,qBAAA;ExE6zTV;EwEp0TM;IAOI,2BAAA;ExEg0TV;EwEv0TM;IAOI,0BAAA;ExEm0TV;EwE10TM;IAOI,wBAAA;ExEs0TV;EwE70TM;IAOI,0BAAA;ExEy0TV;EwEh1TM;IAOI,wBAAA;ExE40TV;EwEn1TM;IAOI,wBAAA;ExE+0TV;EwEt1TM;IAOI,8BAAA;ExEk1TV;EwEz1TM;IAOI,6BAAA;ExEq1TV;EwE51TM;IAOI,2BAAA;ExEw1TV;EwE/1TM;IAOI,6BAAA;ExE21TV;EwEl2TM;IAOI,2BAAA;ExE81TV;EwEr2TM;IAOI,2BAAA;ExEi2TV;EwEx2TM;IAOI,4BAAA;ExEo2TV;EwE32TM;IAOI,6BAAA;ExEu2TV;AACF;Acl3TI;E0DGI;IAOI,sBAAA;ExE42TV;EwEn3TM;IAOI,uBAAA;ExE+2TV;EwEt3TM;IAOI,sBAAA;ExEk3TV;EwEz3TM;IAOI,8BAAA;ExEq3TV;EwE53TM;IAOI,4BAAA;ExEw3TV;EwE/3TM;IAOI,2BAAA;ExE23TV;EwEl4TM;IAOI,iCAAA;ExE83TV;EwEr4TM;IAOI,2BAAA;ExEi4TV;EwEx4TM;IAOI,0BAAA;ExEo4TV;EwE34TM;IAOI,gCAAA;ExEu4TV;EwE94TM;IAOI,yBAAA;ExE04TV;EwEj5TM;IAOI,wBAAA;ExE64TV;EwEp5TM;IAOI,+BAAA;ExEg5TV;EwEv5TM;IAOI,yBAAA;ExEm5TV;EwE15TM;IAOI,6BAAA;ExEs5TV;EwE75TM;IAOI,8BAAA;ExEy5TV;EwEh6TM;IAOI,wBAAA;ExE45TV;EwEn6TM;IAOI,+BAAA;ExE+5TV;EwEt6TM;IAOI,wBAAA;ExEk6TV;EwEz6TM;IAOI,yBAAA;ExEq6TV;EwE56TM;IAOI,8BAAA;ExEw6TV;EwE/6TM;IAOI,iCAAA;ExE26TV;EwEl7TM;IAOI,sCAAA;ExE86TV;EwEr7TM;IAOI,yCAAA;ExEi7TV;EwEx7TM;IAOI,uBAAA;ExEo7TV;EwE37TM;IAOI,uBAAA;ExEu7TV;EwE97TM;IAOI,yBAAA;ExE07TV;EwEj8TM;IAOI,yBAAA;ExE67TV;EwEp8TM;IAOI,0BAAA;ExEg8TV;EwEv8TM;IAOI,4BAAA;ExEm8TV;EwE18TM;IAOI,kCAAA;ExEs8TV;EwE78TM;IAOI,sCAAA;ExEy8TV;EwEh9TM;IAOI,oCAAA;ExE48TV;EwEn9TM;IAOI,kCAAA;ExE+8TV;EwEt9TM;IAOI,yCAAA;ExEk9TV;EwEz9TM;IAOI,wCAAA;ExEq9TV;EwE59TM;IAOI,wCAAA;ExEw9TV;EwE/9TM;IAOI,kCAAA;ExE29TV;EwEl+TM;IAOI,gCAAA;ExE89TV;EwEr+TM;IAOI,8BAAA;ExEi+TV;EwEx+TM;IAOI,gCAAA;ExEo+TV;EwE3+TM;IAOI,+BAAA;ExEu+TV;EwE9+TM;IAOI,oCAAA;ExE0+TV;EwEj/TM;IAOI,kCAAA;ExE6+TV;EwEp/TM;IAOI,gCAAA;ExEg/TV;EwEv/TM;IAOI,uCAAA;ExEm/TV;EwE1/TM;IAOI,sCAAA;ExEs/TV;EwE7/TM;IAOI,iCAAA;ExEy/TV;EwEhgUM;IAOI,2BAAA;ExE4/TV;EwEngUM;IAOI,iCAAA;ExE+/TV;EwEtgUM;IAOI,+BAAA;ExEkgUV;EwEzgUM;IAOI,6BAAA;ExEqgUV;EwE5gUM;IAOI,+BAAA;ExEwgUV;EwE/gUM;IAOI,8BAAA;ExE2gUV;EwElhUM;IAOI,oBAAA;ExE8gUV;EwErhUM;IAOI,mBAAA;ExEihUV;EwExhUM;IAOI,mBAAA;ExEohUV;EwE3hUM;IAOI,mBAAA;ExEuhUV;EwE9hUM;IAOI,mBAAA;ExE0hUV;EwEjiUM;IAOI,mBAAA;ExE6hUV;EwEpiUM;IAOI,mBAAA;ExEgiUV;EwEviUM;IAOI,mBAAA;ExEmiUV;EwE1iUM;IAOI,oBAAA;ExEsiUV;EwE7iUM;IAOI,0BAAA;ExEyiUV;EwEhjUM;IAOI,yBAAA;ExE4iUV;EwEnjUM;IAOI,uBAAA;ExE+iUV;EwEtjUM;IAOI,yBAAA;ExEkjUV;EwEzjUM;IAOI,uBAAA;ExEqjUV;EwE5jUM;IAOI,uBAAA;ExEwjUV;EwE/jUM;IAOI,0BAAA;IAAA,yBAAA;ExE4jUV;EwEnkUM;IAOI,gCAAA;IAAA,+BAAA;ExEgkUV;EwEvkUM;IAOI,+BAAA;IAAA,8BAAA;ExEokUV;EwE3kUM;IAOI,6BAAA;IAAA,4BAAA;ExEwkUV;EwE/kUM;IAOI,+BAAA;IAAA,8BAAA;ExE4kUV;EwEnlUM;IAOI,6BAAA;IAAA,4BAAA;ExEglUV;EwEvlUM;IAOI,6BAAA;IAAA,4BAAA;ExEolUV;EwE3lUM;IAOI,wBAAA;IAAA,2BAAA;ExEwlUV;EwE/lUM;IAOI,8BAAA;IAAA,iCAAA;ExE4lUV;EwEnmUM;IAOI,6BAAA;IAAA,gCAAA;ExEgmUV;EwEvmUM;IAOI,2BAAA;IAAA,8BAAA;ExEomUV;EwE3mUM;IAOI,6BAAA;IAAA,gCAAA;ExEwmUV;EwE/mUM;IAOI,2BAAA;IAAA,8BAAA;ExE4mUV;EwEnnUM;IAOI,2BAAA;IAAA,8BAAA;ExEgnUV;EwEvnUM;IAOI,wBAAA;ExEmnUV;EwE1nUM;IAOI,8BAAA;ExEsnUV;EwE7nUM;IAOI,6BAAA;ExEynUV;EwEhoUM;IAOI,2BAAA;ExE4nUV;EwEnoUM;IAOI,6BAAA;ExE+nUV;EwEtoUM;IAOI,2BAAA;ExEkoUV;EwEzoUM;IAOI,2BAAA;ExEqoUV;EwE5oUM;IAOI,0BAAA;ExEwoUV;EwE/oUM;IAOI,gCAAA;ExE2oUV;EwElpUM;IAOI,+BAAA;ExE8oUV;EwErpUM;IAOI,6BAAA;ExEipUV;EwExpUM;IAOI,+BAAA;ExEopUV;EwE3pUM;IAOI,6BAAA;ExEupUV;EwE9pUM;IAOI,6BAAA;ExE0pUV;EwEjqUM;IAOI,2BAAA;ExE6pUV;EwEpqUM;IAOI,iCAAA;ExEgqUV;EwEvqUM;IAOI,gCAAA;ExEmqUV;EwE1qUM;IAOI,8BAAA;ExEsqUV;EwE7qUM;IAOI,gCAAA;ExEyqUV;EwEhrUM;IAOI,8BAAA;ExE4qUV;EwEnrUM;IAOI,8BAAA;ExE+qUV;EwEtrUM;IAOI,yBAAA;ExEkrUV;EwEzrUM;IAOI,+BAAA;ExEqrUV;EwE5rUM;IAOI,8BAAA;ExEwrUV;EwE/rUM;IAOI,4BAAA;ExE2rUV;EwElsUM;IAOI,8BAAA;ExE8rUV;EwErsUM;IAOI,4BAAA;ExEisUV;EwExsUM;IAOI,4BAAA;ExEosUV;EwE3sUM;IAOI,qBAAA;ExEusUV;EwE9sUM;IAOI,2BAAA;ExE0sUV;EwEjtUM;IAOI,0BAAA;ExE6sUV;EwEptUM;IAOI,wBAAA;ExEgtUV;EwEvtUM;IAOI,0BAAA;ExEmtUV;EwE1tUM;IAOI,wBAAA;ExEstUV;EwE7tUM;IAOI,2BAAA;IAAA,0BAAA;ExE0tUV;EwEjuUM;IAOI,iCAAA;IAAA,gCAAA;ExE8tUV;EwEruUM;IAOI,gCAAA;IAAA,+BAAA;ExEkuUV;EwEzuUM;IAOI,8BAAA;IAAA,6BAAA;ExEsuUV;EwE7uUM;IAOI,gCAAA;IAAA,+BAAA;ExE0uUV;EwEjvUM;IAOI,8BAAA;IAAA,6BAAA;ExE8uUV;EwErvUM;IAOI,yBAAA;IAAA,4BAAA;ExEkvUV;EwEzvUM;IAOI,+BAAA;IAAA,kCAAA;ExEsvUV;EwE7vUM;IAOI,8BAAA;IAAA,iCAAA;ExE0vUV;EwEjwUM;IAOI,4BAAA;IAAA,+BAAA;ExE8vUV;EwErwUM;IAOI,8BAAA;IAAA,iCAAA;ExEkwUV;EwEzwUM;IAOI,4BAAA;IAAA,+BAAA;ExEswUV;EwE7wUM;IAOI,yBAAA;ExEywUV;EwEhxUM;IAOI,+BAAA;ExE4wUV;EwEnxUM;IAOI,8BAAA;ExE+wUV;EwEtxUM;IAOI,4BAAA;ExEkxUV;EwEzxUM;IAOI,8BAAA;ExEqxUV;EwE5xUM;IAOI,4BAAA;ExEwxUV;EwE/xUM;IAOI,2BAAA;ExE2xUV;EwElyUM;IAOI,iCAAA;ExE8xUV;EwEryUM;IAOI,gCAAA;ExEiyUV;EwExyUM;IAOI,8BAAA;ExEoyUV;EwE3yUM;IAOI,gCAAA;ExEuyUV;EwE9yUM;IAOI,8BAAA;ExE0yUV;EwEjzUM;IAOI,4BAAA;ExE6yUV;EwEpzUM;IAOI,kCAAA;ExEgzUV;EwEvzUM;IAOI,iCAAA;ExEmzUV;EwE1zUM;IAOI,+BAAA;ExEszUV;EwE7zUM;IAOI,iCAAA;ExEyzUV;EwEh0UM;IAOI,+BAAA;ExE4zUV;EwEn0UM;IAOI,0BAAA;ExE+zUV;EwEt0UM;IAOI,gCAAA;ExEk0UV;EwEz0UM;IAOI,+BAAA;ExEq0UV;EwE50UM;IAOI,6BAAA;ExEw0UV;EwE/0UM;IAOI,+BAAA;ExE20UV;EwEl1UM;IAOI,6BAAA;ExE80UV;EwEr1UM;IAOI,iBAAA;ExEi1UV;EwEx1UM;IAOI,uBAAA;ExEo1UV;EwE31UM;IAOI,sBAAA;ExEu1UV;EwE91UM;IAOI,oBAAA;ExE01UV;EwEj2UM;IAOI,sBAAA;ExE61UV;EwEp2UM;IAOI,oBAAA;ExEg2UV;EwEv2UM;IAOI,qBAAA;ExEm2UV;EwE12UM;IAOI,2BAAA;ExEs2UV;EwE72UM;IAOI,0BAAA;ExEy2UV;EwEh3UM;IAOI,wBAAA;ExE42UV;EwEn3UM;IAOI,0BAAA;ExE+2UV;EwEt3UM;IAOI,wBAAA;ExEk3UV;EwEz3UM;IAOI,wBAAA;ExEq3UV;EwE53UM;IAOI,8BAAA;ExEw3UV;EwE/3UM;IAOI,6BAAA;ExE23UV;EwEl4UM;IAOI,2BAAA;ExE83UV;EwEr4UM;IAOI,6BAAA;ExEi4UV;EwEx4UM;IAOI,2BAAA;ExEo4UV;EwE34UM;IAOI,2BAAA;ExEu4UV;EwE94UM;IAOI,4BAAA;ExE04UV;EwEj5UM;IAOI,6BAAA;ExE64UV;AACF;Acx5UI;E0DGI;IAOI,sBAAA;ExEk5UV;EwEz5UM;IAOI,uBAAA;ExEq5UV;EwE55UM;IAOI,sBAAA;ExEw5UV;EwE/5UM;IAOI,8BAAA;ExE25UV;EwEl6UM;IAOI,4BAAA;ExE85UV;EwEr6UM;IAOI,2BAAA;ExEi6UV;EwEx6UM;IAOI,iCAAA;ExEo6UV;EwE36UM;IAOI,2BAAA;ExEu6UV;EwE96UM;IAOI,0BAAA;ExE06UV;EwEj7UM;IAOI,gCAAA;ExE66UV;EwEp7UM;IAOI,yBAAA;ExEg7UV;EwEv7UM;IAOI,wBAAA;ExEm7UV;EwE17UM;IAOI,+BAAA;ExEs7UV;EwE77UM;IAOI,yBAAA;ExEy7UV;EwEh8UM;IAOI,6BAAA;ExE47UV;EwEn8UM;IAOI,8BAAA;ExE+7UV;EwEt8UM;IAOI,wBAAA;ExEk8UV;EwEz8UM;IAOI,+BAAA;ExEq8UV;EwE58UM;IAOI,wBAAA;ExEw8UV;EwE/8UM;IAOI,yBAAA;ExE28UV;EwEl9UM;IAOI,8BAAA;ExE88UV;EwEr9UM;IAOI,iCAAA;ExEi9UV;EwEx9UM;IAOI,sCAAA;ExEo9UV;EwE39UM;IAOI,yCAAA;ExEu9UV;EwE99UM;IAOI,uBAAA;ExE09UV;EwEj+UM;IAOI,uBAAA;ExE69UV;EwEp+UM;IAOI,yBAAA;ExEg+UV;EwEv+UM;IAOI,yBAAA;ExEm+UV;EwE1+UM;IAOI,0BAAA;ExEs+UV;EwE7+UM;IAOI,4BAAA;ExEy+UV;EwEh/UM;IAOI,kCAAA;ExE4+UV;EwEn/UM;IAOI,sCAAA;ExE++UV;EwEt/UM;IAOI,oCAAA;ExEk/UV;EwEz/UM;IAOI,kCAAA;ExEq/UV;EwE5/UM;IAOI,yCAAA;ExEw/UV;EwE//UM;IAOI,wCAAA;ExE2/UV;EwElgVM;IAOI,wCAAA;ExE8/UV;EwErgVM;IAOI,kCAAA;ExEigVV;EwExgVM;IAOI,gCAAA;ExEogVV;EwE3gVM;IAOI,8BAAA;ExEugVV;EwE9gVM;IAOI,gCAAA;ExE0gVV;EwEjhVM;IAOI,+BAAA;ExE6gVV;EwEphVM;IAOI,oCAAA;ExEghVV;EwEvhVM;IAOI,kCAAA;ExEmhVV;EwE1hVM;IAOI,gCAAA;ExEshVV;EwE7hVM;IAOI,uCAAA;ExEyhVV;EwEhiVM;IAOI,sCAAA;ExE4hVV;EwEniVM;IAOI,iCAAA;ExE+hVV;EwEtiVM;IAOI,2BAAA;ExEkiVV;EwEziVM;IAOI,iCAAA;ExEqiVV;EwE5iVM;IAOI,+BAAA;ExEwiVV;EwE/iVM;IAOI,6BAAA;ExE2iVV;EwEljVM;IAOI,+BAAA;ExE8iVV;EwErjVM;IAOI,8BAAA;ExEijVV;EwExjVM;IAOI,oBAAA;ExEojVV;EwE3jVM;IAOI,mBAAA;ExEujVV;EwE9jVM;IAOI,mBAAA;ExE0jVV;EwEjkVM;IAOI,mBAAA;ExE6jVV;EwEpkVM;IAOI,mBAAA;ExEgkVV;EwEvkVM;IAOI,mBAAA;ExEmkVV;EwE1kVM;IAOI,mBAAA;ExEskVV;EwE7kVM;IAOI,mBAAA;ExEykVV;EwEhlVM;IAOI,oBAAA;ExE4kVV;EwEnlVM;IAOI,0BAAA;ExE+kVV;EwEtlVM;IAOI,yBAAA;ExEklVV;EwEzlVM;IAOI,uBAAA;ExEqlVV;EwE5lVM;IAOI,yBAAA;ExEwlVV;EwE/lVM;IAOI,uBAAA;ExE2lVV;EwElmVM;IAOI,uBAAA;ExE8lVV;EwErmVM;IAOI,0BAAA;IAAA,yBAAA;ExEkmVV;EwEzmVM;IAOI,gCAAA;IAAA,+BAAA;ExEsmVV;EwE7mVM;IAOI,+BAAA;IAAA,8BAAA;ExE0mVV;EwEjnVM;IAOI,6BAAA;IAAA,4BAAA;ExE8mVV;EwErnVM;IAOI,+BAAA;IAAA,8BAAA;ExEknVV;EwEznVM;IAOI,6BAAA;IAAA,4BAAA;ExEsnVV;EwE7nVM;IAOI,6BAAA;IAAA,4BAAA;ExE0nVV;EwEjoVM;IAOI,wBAAA;IAAA,2BAAA;ExE8nVV;EwEroVM;IAOI,8BAAA;IAAA,iCAAA;ExEkoVV;EwEzoVM;IAOI,6BAAA;IAAA,gCAAA;ExEsoVV;EwE7oVM;IAOI,2BAAA;IAAA,8BAAA;ExE0oVV;EwEjpVM;IAOI,6BAAA;IAAA,gCAAA;ExE8oVV;EwErpVM;IAOI,2BAAA;IAAA,8BAAA;ExEkpVV;EwEzpVM;IAOI,2BAAA;IAAA,8BAAA;ExEspVV;EwE7pVM;IAOI,wBAAA;ExEypVV;EwEhqVM;IAOI,8BAAA;ExE4pVV;EwEnqVM;IAOI,6BAAA;ExE+pVV;EwEtqVM;IAOI,2BAAA;ExEkqVV;EwEzqVM;IAOI,6BAAA;ExEqqVV;EwE5qVM;IAOI,2BAAA;ExEwqVV;EwE/qVM;IAOI,2BAAA;ExE2qVV;EwElrVM;IAOI,0BAAA;ExE8qVV;EwErrVM;IAOI,gCAAA;ExEirVV;EwExrVM;IAOI,+BAAA;ExEorVV;EwE3rVM;IAOI,6BAAA;ExEurVV;EwE9rVM;IAOI,+BAAA;ExE0rVV;EwEjsVM;IAOI,6BAAA;ExE6rVV;EwEpsVM;IAOI,6BAAA;ExEgsVV;EwEvsVM;IAOI,2BAAA;ExEmsVV;EwE1sVM;IAOI,iCAAA;ExEssVV;EwE7sVM;IAOI,gCAAA;ExEysVV;EwEhtVM;IAOI,8BAAA;ExE4sVV;EwEntVM;IAOI,gCAAA;ExE+sVV;EwEttVM;IAOI,8BAAA;ExEktVV;EwEztVM;IAOI,8BAAA;ExEqtVV;EwE5tVM;IAOI,yBAAA;ExEwtVV;EwE/tVM;IAOI,+BAAA;ExE2tVV;EwEluVM;IAOI,8BAAA;ExE8tVV;EwEruVM;IAOI,4BAAA;ExEiuVV;EwExuVM;IAOI,8BAAA;ExEouVV;EwE3uVM;IAOI,4BAAA;ExEuuVV;EwE9uVM;IAOI,4BAAA;ExE0uVV;EwEjvVM;IAOI,qBAAA;ExE6uVV;EwEpvVM;IAOI,2BAAA;ExEgvVV;EwEvvVM;IAOI,0BAAA;ExEmvVV;EwE1vVM;IAOI,wBAAA;ExEsvVV;EwE7vVM;IAOI,0BAAA;ExEyvVV;EwEhwVM;IAOI,wBAAA;ExE4vVV;EwEnwVM;IAOI,2BAAA;IAAA,0BAAA;ExEgwVV;EwEvwVM;IAOI,iCAAA;IAAA,gCAAA;ExEowVV;EwE3wVM;IAOI,gCAAA;IAAA,+BAAA;ExEwwVV;EwE/wVM;IAOI,8BAAA;IAAA,6BAAA;ExE4wVV;EwEnxVM;IAOI,gCAAA;IAAA,+BAAA;ExEgxVV;EwEvxVM;IAOI,8BAAA;IAAA,6BAAA;ExEoxVV;EwE3xVM;IAOI,yBAAA;IAAA,4BAAA;ExEwxVV;EwE/xVM;IAOI,+BAAA;IAAA,kCAAA;ExE4xVV;EwEnyVM;IAOI,8BAAA;IAAA,iCAAA;ExEgyVV;EwEvyVM;IAOI,4BAAA;IAAA,+BAAA;ExEoyVV;EwE3yVM;IAOI,8BAAA;IAAA,iCAAA;ExEwyVV;EwE/yVM;IAOI,4BAAA;IAAA,+BAAA;ExE4yVV;EwEnzVM;IAOI,yBAAA;ExE+yVV;EwEtzVM;IAOI,+BAAA;ExEkzVV;EwEzzVM;IAOI,8BAAA;ExEqzVV;EwE5zVM;IAOI,4BAAA;ExEwzVV;EwE/zVM;IAOI,8BAAA;ExE2zVV;EwEl0VM;IAOI,4BAAA;ExE8zVV;EwEr0VM;IAOI,2BAAA;ExEi0VV;EwEx0VM;IAOI,iCAAA;ExEo0VV;EwE30VM;IAOI,gCAAA;ExEu0VV;EwE90VM;IAOI,8BAAA;ExE00VV;EwEj1VM;IAOI,gCAAA;ExE60VV;EwEp1VM;IAOI,8BAAA;ExEg1VV;EwEv1VM;IAOI,4BAAA;ExEm1VV;EwE11VM;IAOI,kCAAA;ExEs1VV;EwE71VM;IAOI,iCAAA;ExEy1VV;EwEh2VM;IAOI,+BAAA;ExE41VV;EwEn2VM;IAOI,iCAAA;ExE+1VV;EwEt2VM;IAOI,+BAAA;ExEk2VV;EwEz2VM;IAOI,0BAAA;ExEq2VV;EwE52VM;IAOI,gCAAA;ExEw2VV;EwE/2VM;IAOI,+BAAA;ExE22VV;EwEl3VM;IAOI,6BAAA;ExE82VV;EwEr3VM;IAOI,+BAAA;ExEi3VV;EwEx3VM;IAOI,6BAAA;ExEo3VV;EwE33VM;IAOI,iBAAA;ExEu3VV;EwE93VM;IAOI,uBAAA;ExE03VV;EwEj4VM;IAOI,sBAAA;ExE63VV;EwEp4VM;IAOI,oBAAA;ExEg4VV;EwEv4VM;IAOI,sBAAA;ExEm4VV;EwE14VM;IAOI,oBAAA;ExEs4VV;EwE74VM;IAOI,qBAAA;ExEy4VV;EwEh5VM;IAOI,2BAAA;ExE44VV;EwEn5VM;IAOI,0BAAA;ExE+4VV;EwEt5VM;IAOI,wBAAA;ExEk5VV;EwEz5VM;IAOI,0BAAA;ExEq5VV;EwE55VM;IAOI,wBAAA;ExEw5VV;EwE/5VM;IAOI,wBAAA;ExE25VV;EwEl6VM;IAOI,8BAAA;ExE85VV;EwEr6VM;IAOI,6BAAA;ExEi6VV;EwEx6VM;IAOI,2BAAA;ExEo6VV;EwE36VM;IAOI,6BAAA;ExEu6VV;EwE96VM;IAOI,2BAAA;ExE06VV;EwEj7VM;IAOI,2BAAA;ExE66VV;EwEp7VM;IAOI,4BAAA;ExEg7VV;EwEv7VM;IAOI,6BAAA;ExEm7VV;AACF;Ac97VI;E0DGI;IAOI,sBAAA;ExEw7VV;EwE/7VM;IAOI,uBAAA;ExE27VV;EwEl8VM;IAOI,sBAAA;ExE87VV;EwEr8VM;IAOI,8BAAA;ExEi8VV;EwEx8VM;IAOI,4BAAA;ExEo8VV;EwE38VM;IAOI,2BAAA;ExEu8VV;EwE98VM;IAOI,iCAAA;ExE08VV;EwEj9VM;IAOI,2BAAA;ExE68VV;EwEp9VM;IAOI,0BAAA;ExEg9VV;EwEv9VM;IAOI,gCAAA;ExEm9VV;EwE19VM;IAOI,yBAAA;ExEs9VV;EwE79VM;IAOI,wBAAA;ExEy9VV;EwEh+VM;IAOI,+BAAA;ExE49VV;EwEn+VM;IAOI,yBAAA;ExE+9VV;EwEt+VM;IAOI,6BAAA;ExEk+VV;EwEz+VM;IAOI,8BAAA;ExEq+VV;EwE5+VM;IAOI,wBAAA;ExEw+VV;EwE/+VM;IAOI,+BAAA;ExE2+VV;EwEl/VM;IAOI,wBAAA;ExE8+VV;EwEr/VM;IAOI,yBAAA;ExEi/VV;EwEx/VM;IAOI,8BAAA;ExEo/VV;EwE3/VM;IAOI,iCAAA;ExEu/VV;EwE9/VM;IAOI,sCAAA;ExE0/VV;EwEjgWM;IAOI,yCAAA;ExE6/VV;EwEpgWM;IAOI,uBAAA;ExEggWV;EwEvgWM;IAOI,uBAAA;ExEmgWV;EwE1gWM;IAOI,yBAAA;ExEsgWV;EwE7gWM;IAOI,yBAAA;ExEygWV;EwEhhWM;IAOI,0BAAA;ExE4gWV;EwEnhWM;IAOI,4BAAA;ExE+gWV;EwEthWM;IAOI,kCAAA;ExEkhWV;EwEzhWM;IAOI,sCAAA;ExEqhWV;EwE5hWM;IAOI,oCAAA;ExEwhWV;EwE/hWM;IAOI,kCAAA;ExE2hWV;EwEliWM;IAOI,yCAAA;ExE8hWV;EwEriWM;IAOI,wCAAA;ExEiiWV;EwExiWM;IAOI,wCAAA;ExEoiWV;EwE3iWM;IAOI,kCAAA;ExEuiWV;EwE9iWM;IAOI,gCAAA;ExE0iWV;EwEjjWM;IAOI,8BAAA;ExE6iWV;EwEpjWM;IAOI,gCAAA;ExEgjWV;EwEvjWM;IAOI,+BAAA;ExEmjWV;EwE1jWM;IAOI,oCAAA;ExEsjWV;EwE7jWM;IAOI,kCAAA;ExEyjWV;EwEhkWM;IAOI,gCAAA;ExE4jWV;EwEnkWM;IAOI,uCAAA;ExE+jWV;EwEtkWM;IAOI,sCAAA;ExEkkWV;EwEzkWM;IAOI,iCAAA;ExEqkWV;EwE5kWM;IAOI,2BAAA;ExEwkWV;EwE/kWM;IAOI,iCAAA;ExE2kWV;EwEllWM;IAOI,+BAAA;ExE8kWV;EwErlWM;IAOI,6BAAA;ExEilWV;EwExlWM;IAOI,+BAAA;ExEolWV;EwE3lWM;IAOI,8BAAA;ExEulWV;EwE9lWM;IAOI,oBAAA;ExE0lWV;EwEjmWM;IAOI,mBAAA;ExE6lWV;EwEpmWM;IAOI,mBAAA;ExEgmWV;EwEvmWM;IAOI,mBAAA;ExEmmWV;EwE1mWM;IAOI,mBAAA;ExEsmWV;EwE7mWM;IAOI,mBAAA;ExEymWV;EwEhnWM;IAOI,mBAAA;ExE4mWV;EwEnnWM;IAOI,mBAAA;ExE+mWV;EwEtnWM;IAOI,oBAAA;ExEknWV;EwEznWM;IAOI,0BAAA;ExEqnWV;EwE5nWM;IAOI,yBAAA;ExEwnWV;EwE/nWM;IAOI,uBAAA;ExE2nWV;EwEloWM;IAOI,yBAAA;ExE8nWV;EwEroWM;IAOI,uBAAA;ExEioWV;EwExoWM;IAOI,uBAAA;ExEooWV;EwE3oWM;IAOI,0BAAA;IAAA,yBAAA;ExEwoWV;EwE/oWM;IAOI,gCAAA;IAAA,+BAAA;ExE4oWV;EwEnpWM;IAOI,+BAAA;IAAA,8BAAA;ExEgpWV;EwEvpWM;IAOI,6BAAA;IAAA,4BAAA;ExEopWV;EwE3pWM;IAOI,+BAAA;IAAA,8BAAA;ExEwpWV;EwE/pWM;IAOI,6BAAA;IAAA,4BAAA;ExE4pWV;EwEnqWM;IAOI,6BAAA;IAAA,4BAAA;ExEgqWV;EwEvqWM;IAOI,wBAAA;IAAA,2BAAA;ExEoqWV;EwE3qWM;IAOI,8BAAA;IAAA,iCAAA;ExEwqWV;EwE/qWM;IAOI,6BAAA;IAAA,gCAAA;ExE4qWV;EwEnrWM;IAOI,2BAAA;IAAA,8BAAA;ExEgrWV;EwEvrWM;IAOI,6BAAA;IAAA,gCAAA;ExEorWV;EwE3rWM;IAOI,2BAAA;IAAA,8BAAA;ExEwrWV;EwE/rWM;IAOI,2BAAA;IAAA,8BAAA;ExE4rWV;EwEnsWM;IAOI,wBAAA;ExE+rWV;EwEtsWM;IAOI,8BAAA;ExEksWV;EwEzsWM;IAOI,6BAAA;ExEqsWV;EwE5sWM;IAOI,2BAAA;ExEwsWV;EwE/sWM;IAOI,6BAAA;ExE2sWV;EwEltWM;IAOI,2BAAA;ExE8sWV;EwErtWM;IAOI,2BAAA;ExEitWV;EwExtWM;IAOI,0BAAA;ExEotWV;EwE3tWM;IAOI,gCAAA;ExEutWV;EwE9tWM;IAOI,+BAAA;ExE0tWV;EwEjuWM;IAOI,6BAAA;ExE6tWV;EwEpuWM;IAOI,+BAAA;ExEguWV;EwEvuWM;IAOI,6BAAA;ExEmuWV;EwE1uWM;IAOI,6BAAA;ExEsuWV;EwE7uWM;IAOI,2BAAA;ExEyuWV;EwEhvWM;IAOI,iCAAA;ExE4uWV;EwEnvWM;IAOI,gCAAA;ExE+uWV;EwEtvWM;IAOI,8BAAA;ExEkvWV;EwEzvWM;IAOI,gCAAA;ExEqvWV;EwE5vWM;IAOI,8BAAA;ExEwvWV;EwE/vWM;IAOI,8BAAA;ExE2vWV;EwElwWM;IAOI,yBAAA;ExE8vWV;EwErwWM;IAOI,+BAAA;ExEiwWV;EwExwWM;IAOI,8BAAA;ExEowWV;EwE3wWM;IAOI,4BAAA;ExEuwWV;EwE9wWM;IAOI,8BAAA;ExE0wWV;EwEjxWM;IAOI,4BAAA;ExE6wWV;EwEpxWM;IAOI,4BAAA;ExEgxWV;EwEvxWM;IAOI,qBAAA;ExEmxWV;EwE1xWM;IAOI,2BAAA;ExEsxWV;EwE7xWM;IAOI,0BAAA;ExEyxWV;EwEhyWM;IAOI,wBAAA;ExE4xWV;EwEnyWM;IAOI,0BAAA;ExE+xWV;EwEtyWM;IAOI,wBAAA;ExEkyWV;EwEzyWM;IAOI,2BAAA;IAAA,0BAAA;ExEsyWV;EwE7yWM;IAOI,iCAAA;IAAA,gCAAA;ExE0yWV;EwEjzWM;IAOI,gCAAA;IAAA,+BAAA;ExE8yWV;EwErzWM;IAOI,8BAAA;IAAA,6BAAA;ExEkzWV;EwEzzWM;IAOI,gCAAA;IAAA,+BAAA;ExEszWV;EwE7zWM;IAOI,8BAAA;IAAA,6BAAA;ExE0zWV;EwEj0WM;IAOI,yBAAA;IAAA,4BAAA;ExE8zWV;EwEr0WM;IAOI,+BAAA;IAAA,kCAAA;ExEk0WV;EwEz0WM;IAOI,8BAAA;IAAA,iCAAA;ExEs0WV;EwE70WM;IAOI,4BAAA;IAAA,+BAAA;ExE00WV;EwEj1WM;IAOI,8BAAA;IAAA,iCAAA;ExE80WV;EwEr1WM;IAOI,4BAAA;IAAA,+BAAA;ExEk1WV;EwEz1WM;IAOI,yBAAA;ExEq1WV;EwE51WM;IAOI,+BAAA;ExEw1WV;EwE/1WM;IAOI,8BAAA;ExE21WV;EwEl2WM;IAOI,4BAAA;ExE81WV;EwEr2WM;IAOI,8BAAA;ExEi2WV;EwEx2WM;IAOI,4BAAA;ExEo2WV;EwE32WM;IAOI,2BAAA;ExEu2WV;EwE92WM;IAOI,iCAAA;ExE02WV;EwEj3WM;IAOI,gCAAA;ExE62WV;EwEp3WM;IAOI,8BAAA;ExEg3WV;EwEv3WM;IAOI,gCAAA;ExEm3WV;EwE13WM;IAOI,8BAAA;ExEs3WV;EwE73WM;IAOI,4BAAA;ExEy3WV;EwEh4WM;IAOI,kCAAA;ExE43WV;EwEn4WM;IAOI,iCAAA;ExE+3WV;EwEt4WM;IAOI,+BAAA;ExEk4WV;EwEz4WM;IAOI,iCAAA;ExEq4WV;EwE54WM;IAOI,+BAAA;ExEw4WV;EwE/4WM;IAOI,0BAAA;ExE24WV;EwEl5WM;IAOI,gCAAA;ExE84WV;EwEr5WM;IAOI,+BAAA;ExEi5WV;EwEx5WM;IAOI,6BAAA;ExEo5WV;EwE35WM;IAOI,+BAAA;ExEu5WV;EwE95WM;IAOI,6BAAA;ExE05WV;EwEj6WM;IAOI,iBAAA;ExE65WV;EwEp6WM;IAOI,uBAAA;ExEg6WV;EwEv6WM;IAOI,sBAAA;ExEm6WV;EwE16WM;IAOI,oBAAA;ExEs6WV;EwE76WM;IAOI,sBAAA;ExEy6WV;EwEh7WM;IAOI,oBAAA;ExE46WV;EwEn7WM;IAOI,qBAAA;ExE+6WV;EwEt7WM;IAOI,2BAAA;ExEk7WV;EwEz7WM;IAOI,0BAAA;ExEq7WV;EwE57WM;IAOI,wBAAA;ExEw7WV;EwE/7WM;IAOI,0BAAA;ExE27WV;EwEl8WM;IAOI,wBAAA;ExE87WV;EwEr8WM;IAOI,wBAAA;ExEi8WV;EwEx8WM;IAOI,8BAAA;ExEo8WV;EwE38WM;IAOI,6BAAA;ExEu8WV;EwE98WM;IAOI,2BAAA;ExE08WV;EwEj9WM;IAOI,6BAAA;ExE68WV;EwEp9WM;IAOI,2BAAA;ExEg9WV;EwEv9WM;IAOI,2BAAA;ExEm9WV;EwE19WM;IAOI,4BAAA;ExEs9WV;EwE79WM;IAOI,6BAAA;ExEy9WV;AACF;AyEhhXA;ED+CQ;IAOI,4BAAA;ExE89WV;EwEr+WM;IAOI,0BAAA;ExEi+WV;EwEx+WM;IAOI,6BAAA;ExEo+WV;EwE3+WM;IAOI,4BAAA;ExEu+WV;AACF;AyE3gXA;ED4BQ;IAOI,0BAAA;ExE4+WV;EwEn/WM;IAOI,gCAAA;ExE++WV;EwEt/WM;IAOI,yBAAA;ExEk/WV;EwEz/WM;IAOI,wBAAA;ExEq/WV;EwE5/WM;IAOI,+BAAA;ExEw/WV;EwE//WM;IAOI,yBAAA;ExE2/WV;EwElgXM;IAOI,6BAAA;ExE8/WV;EwErgXM;IAOI,8BAAA;ExEigXV;EwExgXM;IAOI,wBAAA;ExEogXV;EwE3gXM;IAOI,+BAAA;ExEugXV;EwE9gXM;IAOI,wBAAA;ExE0gXV;AACF;ACnlXE;;;;EAAA;AWKA;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Ab+lXF;;AcziXI;EF5CE;IACE,gBNkee;ENunWrB;AACF;Ac/iXI;EF5CE;IACE,gBNkee;EN4nWrB;AACF;AcpjXI;EF5CE;IACE,gBNkee;ENioWrB;AACF;AczjXI;EF5CE;IACE,iBNkee;ENsoWrB;AACF;Ac9jXI;EF5CE;IACE,iBNkee;EN2oWrB;AACF;Ae9nXA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AfooXJ;;Ae/nXE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhBwoXF;AetoXI;ECGF,sBAAA;EAIA,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhBmoXF;;AgBplXM;EACE,SAAA;AhBulXR;;AgBplXM;EApCJ,cAAA;EACA,WAAA;AhB4nXF;;AgB9mXE;EACE,cAAA;EACA,WAAA;AhBinXJ;;AgBnnXE;EACE,cAAA;EACA,UAAA;AhBsnXJ;;AgBxnXE;EACE,cAAA;EACA,mBAAA;AhB2nXJ;;AgB7nXE;EACE,cAAA;EACA,UAAA;AhBgoXJ;;AgBloXE;EACE,cAAA;EACA,UAAA;AhBqoXJ;;AgBvoXE;EACE,cAAA;EACA,mBAAA;AhB0oXJ;;AgB3mXM;EAhDJ,cAAA;EACA,WAAA;AhB+pXF;;AgB1mXU;EAhEN,cAAA;EACA,kBAAA;AhB8qXJ;;AgB/mXU;EAhEN,cAAA;EACA,mBAAA;AhBmrXJ;;AgBpnXU;EAhEN,cAAA;EACA,UAAA;AhBwrXJ;;AgBznXU;EAhEN,cAAA;EACA,mBAAA;AhB6rXJ;;AgB9nXU;EAhEN,cAAA;EACA,mBAAA;AhBksXJ;;AgBnoXU;EAhEN,cAAA;EACA,UAAA;AhBusXJ;;AgBxoXU;EAhEN,cAAA;EACA,mBAAA;AhB4sXJ;;AgB7oXU;EAhEN,cAAA;EACA,mBAAA;AhBitXJ;;AgBlpXU;EAhEN,cAAA;EACA,UAAA;AhBstXJ;;AgBvpXU;EAhEN,cAAA;EACA,mBAAA;AhB2tXJ;;AgB5pXU;EAhEN,cAAA;EACA,mBAAA;AhBguXJ;;AgBjqXU;EAhEN,cAAA;EACA,WAAA;AhBquXJ;;AgB9pXY;EAxDV,wBAAA;AhB0tXF;;AgBlqXY;EAxDV,yBAAA;AhB8tXF;;AgBtqXY;EAxDV,gBAAA;AhBkuXF;;AgB1qXY;EAxDV,yBAAA;AhBsuXF;;AgB9qXY;EAxDV,yBAAA;AhB0uXF;;AgBlrXY;EAxDV,gBAAA;AhB8uXF;;AgBtrXY;EAxDV,yBAAA;AhBkvXF;;AgB1rXY;EAxDV,yBAAA;AhBsvXF;;AgB9rXY;EAxDV,gBAAA;AhB0vXF;;AgBlsXY;EAxDV,yBAAA;AhB8vXF;;AgBtsXY;EAxDV,yBAAA;AhBkwXF;;AgB/rXQ;;EAEE,gBAAA;AhBksXV;;AgB/rXQ;;EAEE,gBAAA;AhBksXV;;AgBzsXQ;;EAEE,sBAAA;AhB4sXV;;AgBzsXQ;;EAEE,sBAAA;AhB4sXV;;AgBntXQ;;EAEE,qBAAA;AhBstXV;;AgBntXQ;;EAEE,qBAAA;AhBstXV;;AgB7tXQ;;EAEE,mBAAA;AhBguXV;;AgB7tXQ;;EAEE,mBAAA;AhBguXV;;AgBvuXQ;;EAEE,qBAAA;AhB0uXV;;AgBvuXQ;;EAEE,qBAAA;AhB0uXV;;AgBjvXQ;;EAEE,mBAAA;AhBovXV;;AgBjvXQ;;EAEE,mBAAA;AhBovXV;;Ac9yXI;EEUE;IACE,SAAA;EhBwyXN;EgBryXI;IApCJ,cAAA;IACA,WAAA;EhB40XA;EgB9zXA;IACE,cAAA;IACA,WAAA;EhBg0XF;EgBl0XA;IACE,cAAA;IACA,UAAA;EhBo0XF;EgBt0XA;IACE,cAAA;IACA,mBAAA;EhBw0XF;EgB10XA;IACE,cAAA;IACA,UAAA;EhB40XF;EgB90XA;IACE,cAAA;IACA,UAAA;EhBg1XF;EgBl1XA;IACE,cAAA;IACA,mBAAA;EhBo1XF;EgBrzXI;IAhDJ,cAAA;IACA,WAAA;EhBw2XA;EgBnzXQ;IAhEN,cAAA;IACA,kBAAA;EhBs3XF;EgBvzXQ;IAhEN,cAAA;IACA,mBAAA;EhB03XF;EgB3zXQ;IAhEN,cAAA;IACA,UAAA;EhB83XF;EgB/zXQ;IAhEN,cAAA;IACA,mBAAA;EhBk4XF;EgBn0XQ;IAhEN,cAAA;IACA,mBAAA;EhBs4XF;EgBv0XQ;IAhEN,cAAA;IACA,UAAA;EhB04XF;EgB30XQ;IAhEN,cAAA;IACA,mBAAA;EhB84XF;EgB/0XQ;IAhEN,cAAA;IACA,mBAAA;EhBk5XF;EgBn1XQ;IAhEN,cAAA;IACA,UAAA;EhBs5XF;EgBv1XQ;IAhEN,cAAA;IACA,mBAAA;EhB05XF;EgB31XQ;IAhEN,cAAA;IACA,mBAAA;EhB85XF;EgB/1XQ;IAhEN,cAAA;IACA,WAAA;EhBk6XF;EgB31XU;IAxDV,cAAA;EhBs5XA;EgB91XU;IAxDV,wBAAA;EhBy5XA;EgBj2XU;IAxDV,yBAAA;EhB45XA;EgBp2XU;IAxDV,gBAAA;EhB+5XA;EgBv2XU;IAxDV,yBAAA;EhBk6XA;EgB12XU;IAxDV,yBAAA;EhBq6XA;EgB72XU;IAxDV,gBAAA;EhBw6XA;EgBh3XU;IAxDV,yBAAA;EhB26XA;EgBn3XU;IAxDV,yBAAA;EhB86XA;EgBt3XU;IAxDV,gBAAA;EhBi7XA;EgBz3XU;IAxDV,yBAAA;EhBo7XA;EgB53XU;IAxDV,yBAAA;EhBu7XA;EgBp3XM;;IAEE,gBAAA;EhBs3XR;EgBn3XM;;IAEE,gBAAA;EhBq3XR;EgB53XM;;IAEE,sBAAA;EhB83XR;EgB33XM;;IAEE,sBAAA;EhB63XR;EgBp4XM;;IAEE,qBAAA;EhBs4XR;EgBn4XM;;IAEE,qBAAA;EhBq4XR;EgB54XM;;IAEE,mBAAA;EhB84XR;EgB34XM;;IAEE,mBAAA;EhB64XR;EgBp5XM;;IAEE,qBAAA;EhBs5XR;EgBn5XM;;IAEE,qBAAA;EhBq5XR;EgB55XM;;IAEE,mBAAA;EhB85XR;EgB35XM;;IAEE,mBAAA;EhB65XR;AACF;Acx9XI;EEUE;IACE,SAAA;EhBi9XN;EgB98XI;IApCJ,cAAA;IACA,WAAA;EhBq/XA;EgBv+XA;IACE,cAAA;IACA,WAAA;EhBy+XF;EgB3+XA;IACE,cAAA;IACA,UAAA;EhB6+XF;EgB/+XA;IACE,cAAA;IACA,mBAAA;EhBi/XF;EgBn/XA;IACE,cAAA;IACA,UAAA;EhBq/XF;EgBv/XA;IACE,cAAA;IACA,UAAA;EhBy/XF;EgB3/XA;IACE,cAAA;IACA,mBAAA;EhB6/XF;EgB99XI;IAhDJ,cAAA;IACA,WAAA;EhBihYA;EgB59XQ;IAhEN,cAAA;IACA,kBAAA;EhB+hYF;EgBh+XQ;IAhEN,cAAA;IACA,mBAAA;EhBmiYF;EgBp+XQ;IAhEN,cAAA;IACA,UAAA;EhBuiYF;EgBx+XQ;IAhEN,cAAA;IACA,mBAAA;EhB2iYF;EgB5+XQ;IAhEN,cAAA;IACA,mBAAA;EhB+iYF;EgBh/XQ;IAhEN,cAAA;IACA,UAAA;EhBmjYF;EgBp/XQ;IAhEN,cAAA;IACA,mBAAA;EhBujYF;EgBx/XQ;IAhEN,cAAA;IACA,mBAAA;EhB2jYF;EgB5/XQ;IAhEN,cAAA;IACA,UAAA;EhB+jYF;EgBhgYQ;IAhEN,cAAA;IACA,mBAAA;EhBmkYF;EgBpgYQ;IAhEN,cAAA;IACA,mBAAA;EhBukYF;EgBxgYQ;IAhEN,cAAA;IACA,WAAA;EhB2kYF;EgBpgYU;IAxDV,cAAA;EhB+jYA;EgBvgYU;IAxDV,wBAAA;EhBkkYA;EgB1gYU;IAxDV,yBAAA;EhBqkYA;EgB7gYU;IAxDV,gBAAA;EhBwkYA;EgBhhYU;IAxDV,yBAAA;EhB2kYA;EgBnhYU;IAxDV,yBAAA;EhB8kYA;EgBthYU;IAxDV,gBAAA;EhBilYA;EgBzhYU;IAxDV,yBAAA;EhBolYA;EgB5hYU;IAxDV,yBAAA;EhBulYA;EgB/hYU;IAxDV,gBAAA;EhB0lYA;EgBliYU;IAxDV,yBAAA;EhB6lYA;EgBriYU;IAxDV,yBAAA;EhBgmYA;EgB7hYM;;IAEE,gBAAA;EhB+hYR;EgB5hYM;;IAEE,gBAAA;EhB8hYR;EgBriYM;;IAEE,sBAAA;EhBuiYR;EgBpiYM;;IAEE,sBAAA;EhBsiYR;EgB7iYM;;IAEE,qBAAA;EhB+iYR;EgB5iYM;;IAEE,qBAAA;EhB8iYR;EgBrjYM;;IAEE,mBAAA;EhBujYR;EgBpjYM;;IAEE,mBAAA;EhBsjYR;EgB7jYM;;IAEE,qBAAA;EhB+jYR;EgB5jYM;;IAEE,qBAAA;EhB8jYR;EgBrkYM;;IAEE,mBAAA;EhBukYR;EgBpkYM;;IAEE,mBAAA;EhBskYR;AACF;AcjoYI;EEUE;IACE,SAAA;EhB0nYN;EgBvnYI;IApCJ,cAAA;IACA,WAAA;EhB8pYA;EgBhpYA;IACE,cAAA;IACA,WAAA;EhBkpYF;EgBppYA;IACE,cAAA;IACA,UAAA;EhBspYF;EgBxpYA;IACE,cAAA;IACA,mBAAA;EhB0pYF;EgB5pYA;IACE,cAAA;IACA,UAAA;EhB8pYF;EgBhqYA;IACE,cAAA;IACA,UAAA;EhBkqYF;EgBpqYA;IACE,cAAA;IACA,mBAAA;EhBsqYF;EgBvoYI;IAhDJ,cAAA;IACA,WAAA;EhB0rYA;EgBroYQ;IAhEN,cAAA;IACA,kBAAA;EhBwsYF;EgBzoYQ;IAhEN,cAAA;IACA,mBAAA;EhB4sYF;EgB7oYQ;IAhEN,cAAA;IACA,UAAA;EhBgtYF;EgBjpYQ;IAhEN,cAAA;IACA,mBAAA;EhBotYF;EgBrpYQ;IAhEN,cAAA;IACA,mBAAA;EhBwtYF;EgBzpYQ;IAhEN,cAAA;IACA,UAAA;EhB4tYF;EgB7pYQ;IAhEN,cAAA;IACA,mBAAA;EhBguYF;EgBjqYQ;IAhEN,cAAA;IACA,mBAAA;EhBouYF;EgBrqYQ;IAhEN,cAAA;IACA,UAAA;EhBwuYF;EgBzqYQ;IAhEN,cAAA;IACA,mBAAA;EhB4uYF;EgB7qYQ;IAhEN,cAAA;IACA,mBAAA;EhBgvYF;EgBjrYQ;IAhEN,cAAA;IACA,WAAA;EhBovYF;EgB7qYU;IAxDV,cAAA;EhBwuYA;EgBhrYU;IAxDV,wBAAA;EhB2uYA;EgBnrYU;IAxDV,yBAAA;EhB8uYA;EgBtrYU;IAxDV,gBAAA;EhBivYA;EgBzrYU;IAxDV,yBAAA;EhBovYA;EgB5rYU;IAxDV,yBAAA;EhBuvYA;EgB/rYU;IAxDV,gBAAA;EhB0vYA;EgBlsYU;IAxDV,yBAAA;EhB6vYA;EgBrsYU;IAxDV,yBAAA;EhBgwYA;EgBxsYU;IAxDV,gBAAA;EhBmwYA;EgB3sYU;IAxDV,yBAAA;EhBswYA;EgB9sYU;IAxDV,yBAAA;EhBywYA;EgBtsYM;;IAEE,gBAAA;EhBwsYR;EgBrsYM;;IAEE,gBAAA;EhBusYR;EgB9sYM;;IAEE,sBAAA;EhBgtYR;EgB7sYM;;IAEE,sBAAA;EhB+sYR;EgBttYM;;IAEE,qBAAA;EhBwtYR;EgBrtYM;;IAEE,qBAAA;EhButYR;EgB9tYM;;IAEE,mBAAA;EhBguYR;EgB7tYM;;IAEE,mBAAA;EhB+tYR;EgBtuYM;;IAEE,qBAAA;EhBwuYR;EgBruYM;;IAEE,qBAAA;EhBuuYR;EgB9uYM;;IAEE,mBAAA;EhBgvYR;EgB7uYM;;IAEE,mBAAA;EhB+uYR;AACF;Ac1yYI;EEUE;IACE,SAAA;EhBmyYN;EgBhyYI;IApCJ,cAAA;IACA,WAAA;EhBu0YA;EgBzzYA;IACE,cAAA;IACA,WAAA;EhB2zYF;EgB7zYA;IACE,cAAA;IACA,UAAA;EhB+zYF;EgBj0YA;IACE,cAAA;IACA,mBAAA;EhBm0YF;EgBr0YA;IACE,cAAA;IACA,UAAA;EhBu0YF;EgBz0YA;IACE,cAAA;IACA,UAAA;EhB20YF;EgB70YA;IACE,cAAA;IACA,mBAAA;EhB+0YF;EgBhzYI;IAhDJ,cAAA;IACA,WAAA;EhBm2YA;EgB9yYQ;IAhEN,cAAA;IACA,kBAAA;EhBi3YF;EgBlzYQ;IAhEN,cAAA;IACA,mBAAA;EhBq3YF;EgBtzYQ;IAhEN,cAAA;IACA,UAAA;EhBy3YF;EgB1zYQ;IAhEN,cAAA;IACA,mBAAA;EhB63YF;EgB9zYQ;IAhEN,cAAA;IACA,mBAAA;EhBi4YF;EgBl0YQ;IAhEN,cAAA;IACA,UAAA;EhBq4YF;EgBt0YQ;IAhEN,cAAA;IACA,mBAAA;EhBy4YF;EgB10YQ;IAhEN,cAAA;IACA,mBAAA;EhB64YF;EgB90YQ;IAhEN,cAAA;IACA,UAAA;EhBi5YF;EgBl1YQ;IAhEN,cAAA;IACA,mBAAA;EhBq5YF;EgBt1YQ;IAhEN,cAAA;IACA,mBAAA;EhBy5YF;EgB11YQ;IAhEN,cAAA;IACA,WAAA;EhB65YF;EgBt1YU;IAxDV,cAAA;EhBi5YA;EgBz1YU;IAxDV,wBAAA;EhBo5YA;EgB51YU;IAxDV,yBAAA;EhBu5YA;EgB/1YU;IAxDV,gBAAA;EhB05YA;EgBl2YU;IAxDV,yBAAA;EhB65YA;EgBr2YU;IAxDV,yBAAA;EhBg6YA;EgBx2YU;IAxDV,gBAAA;EhBm6YA;EgB32YU;IAxDV,yBAAA;EhBs6YA;EgB92YU;IAxDV,yBAAA;EhBy6YA;EgBj3YU;IAxDV,gBAAA;EhB46YA;EgBp3YU;IAxDV,yBAAA;EhB+6YA;EgBv3YU;IAxDV,yBAAA;EhBk7YA;EgB/2YM;;IAEE,gBAAA;EhBi3YR;EgB92YM;;IAEE,gBAAA;EhBg3YR;EgBv3YM;;IAEE,sBAAA;EhBy3YR;EgBt3YM;;IAEE,sBAAA;EhBw3YR;EgB/3YM;;IAEE,qBAAA;EhBi4YR;EgB93YM;;IAEE,qBAAA;EhBg4YR;EgBv4YM;;IAEE,mBAAA;EhBy4YR;EgBt4YM;;IAEE,mBAAA;EhBw4YR;EgB/4YM;;IAEE,qBAAA;EhBi5YR;EgB94YM;;IAEE,qBAAA;EhBg5YR;EgBv5YM;;IAEE,mBAAA;EhBy5YR;EgBt5YM;;IAEE,mBAAA;EhBw5YR;AACF;Acn9YI;EEUE;IACE,SAAA;EhB48YN;EgBz8YI;IApCJ,cAAA;IACA,WAAA;EhBg/YA;EgBl+YA;IACE,cAAA;IACA,WAAA;EhBo+YF;EgBt+YA;IACE,cAAA;IACA,UAAA;EhBw+YF;EgB1+YA;IACE,cAAA;IACA,mBAAA;EhB4+YF;EgB9+YA;IACE,cAAA;IACA,UAAA;EhBg/YF;EgBl/YA;IACE,cAAA;IACA,UAAA;EhBo/YF;EgBt/YA;IACE,cAAA;IACA,mBAAA;EhBw/YF;EgBz9YI;IAhDJ,cAAA;IACA,WAAA;EhB4gZA;EgBv9YQ;IAhEN,cAAA;IACA,kBAAA;EhB0hZF;EgB39YQ;IAhEN,cAAA;IACA,mBAAA;EhB8hZF;EgB/9YQ;IAhEN,cAAA;IACA,UAAA;EhBkiZF;EgBn+YQ;IAhEN,cAAA;IACA,mBAAA;EhBsiZF;EgBv+YQ;IAhEN,cAAA;IACA,mBAAA;EhB0iZF;EgB3+YQ;IAhEN,cAAA;IACA,UAAA;EhB8iZF;EgB/+YQ;IAhEN,cAAA;IACA,mBAAA;EhBkjZF;EgBn/YQ;IAhEN,cAAA;IACA,mBAAA;EhBsjZF;EgBv/YQ;IAhEN,cAAA;IACA,UAAA;EhB0jZF;EgB3/YQ;IAhEN,cAAA;IACA,mBAAA;EhB8jZF;EgB//YQ;IAhEN,cAAA;IACA,mBAAA;EhBkkZF;EgBngZQ;IAhEN,cAAA;IACA,WAAA;EhBskZF;EgB//YU;IAxDV,cAAA;EhB0jZA;EgBlgZU;IAxDV,wBAAA;EhB6jZA;EgBrgZU;IAxDV,yBAAA;EhBgkZA;EgBxgZU;IAxDV,gBAAA;EhBmkZA;EgB3gZU;IAxDV,yBAAA;EhBskZA;EgB9gZU;IAxDV,yBAAA;EhBykZA;EgBjhZU;IAxDV,gBAAA;EhB4kZA;EgBphZU;IAxDV,yBAAA;EhB+kZA;EgBvhZU;IAxDV,yBAAA;EhBklZA;EgB1hZU;IAxDV,gBAAA;EhBqlZA;EgB7hZU;IAxDV,yBAAA;EhBwlZA;EgBhiZU;IAxDV,yBAAA;EhB2lZA;EgBxhZM;;IAEE,gBAAA;EhB0hZR;EgBvhZM;;IAEE,gBAAA;EhByhZR;EgBhiZM;;IAEE,sBAAA;EhBkiZR;EgB/hZM;;IAEE,sBAAA;EhBiiZR;EgBxiZM;;IAEE,qBAAA;EhB0iZR;EgBviZM;;IAEE,qBAAA;EhByiZR;EgBhjZM;;IAEE,mBAAA;EhBkjZR;EgB/iZM;;IAEE,mBAAA;EhBijZR;EgBxjZM;;IAEE,qBAAA;EhB0jZR;EgBvjZM;;IAEE,qBAAA;EhByjZR;EgBhkZM;;IAEE,mBAAA;EhBkkZR;EgB/jZM;;IAEE,mBAAA;EhBikZR;AACF;AwEznZQ;EAOI,0BAAA;AxEqnZZ;;AwE5nZQ;EAOI,gCAAA;AxEynZZ;;AwEhoZQ;EAOI,yBAAA;AxE6nZZ;;AwEpoZQ;EAOI,wBAAA;AxEioZZ;;AwExoZQ;EAOI,+BAAA;AxEqoZZ;;AwE5oZQ;EAOI,yBAAA;AxEyoZZ;;AwEhpZQ;EAOI,6BAAA;AxE6oZZ;;AwEppZQ;EAOI,8BAAA;AxEipZZ;;AwExpZQ;EAOI,wBAAA;AxEqpZZ;;AwE5pZQ;EAOI,+BAAA;AxEypZZ;;AwEhqZQ;EAOI,wBAAA;AxE6pZZ;;AwEpqZQ;EAOI,yBAAA;AxEiqZZ;;AwExqZQ;EAOI,8BAAA;AxEqqZZ;;AwE5qZQ;EAOI,iCAAA;AxEyqZZ;;AwEhrZQ;EAOI,sCAAA;AxE6qZZ;;AwEprZQ;EAOI,yCAAA;AxEirZZ;;AwExrZQ;EAOI,uBAAA;AxEqrZZ;;AwE5rZQ;EAOI,uBAAA;AxEyrZZ;;AwEhsZQ;EAOI,yBAAA;AxE6rZZ;;AwEpsZQ;EAOI,yBAAA;AxEisZZ;;AwExsZQ;EAOI,0BAAA;AxEqsZZ;;AwE5sZQ;EAOI,4BAAA;AxEysZZ;;AwEhtZQ;EAOI,kCAAA;AxE6sZZ;;AwEptZQ;EAOI,sCAAA;AxEitZZ;;AwExtZQ;EAOI,oCAAA;AxEqtZZ;;AwE5tZQ;EAOI,kCAAA;AxEytZZ;;AwEhuZQ;EAOI,yCAAA;AxE6tZZ;;AwEpuZQ;EAOI,wCAAA;AxEiuZZ;;AwExuZQ;EAOI,wCAAA;AxEquZZ;;AwE5uZQ;EAOI,kCAAA;AxEyuZZ;;AwEhvZQ;EAOI,gCAAA;AxE6uZZ;;AwEpvZQ;EAOI,8BAAA;AxEivZZ;;AwExvZQ;EAOI,gCAAA;AxEqvZZ;;AwE5vZQ;EAOI,+BAAA;AxEyvZZ;;AwEhwZQ;EAOI,oCAAA;AxE6vZZ;;AwEpwZQ;EAOI,kCAAA;AxEiwZZ;;AwExwZQ;EAOI,gCAAA;AxEqwZZ;;AwE5wZQ;EAOI,uCAAA;AxEywZZ;;AwEhxZQ;EAOI,sCAAA;AxE6wZZ;;AwEpxZQ;EAOI,iCAAA;AxEixZZ;;AwExxZQ;EAOI,2BAAA;AxEqxZZ;;AwE5xZQ;EAOI,iCAAA;AxEyxZZ;;AwEhyZQ;EAOI,+BAAA;AxE6xZZ;;AwEpyZQ;EAOI,6BAAA;AxEiyZZ;;AwExyZQ;EAOI,+BAAA;AxEqyZZ;;AwE5yZQ;EAOI,8BAAA;AxEyyZZ;;AwEhzZQ;EAOI,oBAAA;AxE6yZZ;;AwEpzZQ;EAOI,mBAAA;AxEizZZ;;AwExzZQ;EAOI,mBAAA;AxEqzZZ;;AwE5zZQ;EAOI,mBAAA;AxEyzZZ;;AwEh0ZQ;EAOI,mBAAA;AxE6zZZ;;AwEp0ZQ;EAOI,mBAAA;AxEi0ZZ;;AwEx0ZQ;EAOI,mBAAA;AxEq0ZZ;;AwE50ZQ;EAOI,mBAAA;AxEy0ZZ;;AwEh1ZQ;EAOI,oBAAA;AxE60ZZ;;AwEp1ZQ;EAOI,0BAAA;AxEi1ZZ;;AwEx1ZQ;EAOI,yBAAA;AxEq1ZZ;;AwE51ZQ;EAOI,uBAAA;AxEy1ZZ;;AwEh2ZQ;EAOI,yBAAA;AxE61ZZ;;AwEp2ZQ;EAOI,uBAAA;AxEi2ZZ;;AwEx2ZQ;EAOI,uBAAA;AxEq2ZZ;;AwE52ZQ;EAOI,0BAAA;EAAA,yBAAA;AxE02ZZ;;AwEj3ZQ;EAOI,gCAAA;EAAA,+BAAA;AxE+2ZZ;;AwEt3ZQ;EAOI,+BAAA;EAAA,8BAAA;AxEo3ZZ;;AwE33ZQ;EAOI,6BAAA;EAAA,4BAAA;AxEy3ZZ;;AwEh4ZQ;EAOI,+BAAA;EAAA,8BAAA;AxE83ZZ;;AwEr4ZQ;EAOI,6BAAA;EAAA,4BAAA;AxEm4ZZ;;AwE14ZQ;EAOI,6BAAA;EAAA,4BAAA;AxEw4ZZ;;AwE/4ZQ;EAOI,wBAAA;EAAA,2BAAA;AxE64ZZ;;AwEp5ZQ;EAOI,8BAAA;EAAA,iCAAA;AxEk5ZZ;;AwEz5ZQ;EAOI,6BAAA;EAAA,gCAAA;AxEu5ZZ;;AwE95ZQ;EAOI,2BAAA;EAAA,8BAAA;AxE45ZZ;;AwEn6ZQ;EAOI,6BAAA;EAAA,gCAAA;AxEi6ZZ;;AwEx6ZQ;EAOI,2BAAA;EAAA,8BAAA;AxEs6ZZ;;AwE76ZQ;EAOI,2BAAA;EAAA,8BAAA;AxE26ZZ;;AwEl7ZQ;EAOI,wBAAA;AxE+6ZZ;;AwEt7ZQ;EAOI,8BAAA;AxEm7ZZ;;AwE17ZQ;EAOI,6BAAA;AxEu7ZZ;;AwE97ZQ;EAOI,2BAAA;AxE27ZZ;;AwEl8ZQ;EAOI,6BAAA;AxE+7ZZ;;AwEt8ZQ;EAOI,2BAAA;AxEm8ZZ;;AwE18ZQ;EAOI,2BAAA;AxEu8ZZ;;AwE98ZQ;EAOI,0BAAA;AxE28ZZ;;AwEl9ZQ;EAOI,gCAAA;AxE+8ZZ;;AwEt9ZQ;EAOI,+BAAA;AxEm9ZZ;;AwE19ZQ;EAOI,6BAAA;AxEu9ZZ;;AwE99ZQ;EAOI,+BAAA;AxE29ZZ;;AwEl+ZQ;EAOI,6BAAA;AxE+9ZZ;;AwEt+ZQ;EAOI,6BAAA;AxEm+ZZ;;AwE1+ZQ;EAOI,2BAAA;AxEu+ZZ;;AwE9+ZQ;EAOI,iCAAA;AxE2+ZZ;;AwEl/ZQ;EAOI,gCAAA;AxE++ZZ;;AwEt/ZQ;EAOI,8BAAA;AxEm/ZZ;;AwE1/ZQ;EAOI,gCAAA;AxEu/ZZ;;AwE9/ZQ;EAOI,8BAAA;AxE2/ZZ;;AwElgaQ;EAOI,8BAAA;AxE+/ZZ;;AwEtgaQ;EAOI,yBAAA;AxEmgaZ;;AwE1gaQ;EAOI,+BAAA;AxEugaZ;;AwE9gaQ;EAOI,8BAAA;AxE2gaZ;;AwElhaQ;EAOI,4BAAA;AxE+gaZ;;AwEthaQ;EAOI,8BAAA;AxEmhaZ;;AwE1haQ;EAOI,4BAAA;AxEuhaZ;;AwE9haQ;EAOI,4BAAA;AxE2haZ;;AwEliaQ;EAOI,qBAAA;AxE+haZ;;AwEtiaQ;EAOI,2BAAA;AxEmiaZ;;AwE1iaQ;EAOI,0BAAA;AxEuiaZ;;AwE9iaQ;EAOI,wBAAA;AxE2iaZ;;AwEljaQ;EAOI,0BAAA;AxE+iaZ;;AwEtjaQ;EAOI,wBAAA;AxEmjaZ;;AwE1jaQ;EAOI,2BAAA;EAAA,0BAAA;AxEwjaZ;;AwE/jaQ;EAOI,iCAAA;EAAA,gCAAA;AxE6jaZ;;AwEpkaQ;EAOI,gCAAA;EAAA,+BAAA;AxEkkaZ;;AwEzkaQ;EAOI,8BAAA;EAAA,6BAAA;AxEukaZ;;AwE9kaQ;EAOI,gCAAA;EAAA,+BAAA;AxE4kaZ;;AwEnlaQ;EAOI,8BAAA;EAAA,6BAAA;AxEilaZ;;AwExlaQ;EAOI,yBAAA;EAAA,4BAAA;AxEslaZ;;AwE7laQ;EAOI,+BAAA;EAAA,kCAAA;AxE2laZ;;AwElmaQ;EAOI,8BAAA;EAAA,iCAAA;AxEgmaZ;;AwEvmaQ;EAOI,4BAAA;EAAA,+BAAA;AxEqmaZ;;AwE5maQ;EAOI,8BAAA;EAAA,iCAAA;AxE0maZ;;AwEjnaQ;EAOI,4BAAA;EAAA,+BAAA;AxE+maZ;;AwEtnaQ;EAOI,yBAAA;AxEmnaZ;;AwE1naQ;EAOI,+BAAA;AxEunaZ;;AwE9naQ;EAOI,8BAAA;AxE2naZ;;AwEloaQ;EAOI,4BAAA;AxE+naZ;;AwEtoaQ;EAOI,8BAAA;AxEmoaZ;;AwE1oaQ;EAOI,4BAAA;AxEuoaZ;;AwE9oaQ;EAOI,2BAAA;AxE2oaZ;;AwElpaQ;EAOI,iCAAA;AxE+oaZ;;AwEtpaQ;EAOI,gCAAA;AxEmpaZ;;AwE1paQ;EAOI,8BAAA;AxEupaZ;;AwE9paQ;EAOI,gCAAA;AxE2paZ;;AwElqaQ;EAOI,8BAAA;AxE+paZ;;AwEtqaQ;EAOI,4BAAA;AxEmqaZ;;AwE1qaQ;EAOI,kCAAA;AxEuqaZ;;AwE9qaQ;EAOI,iCAAA;AxE2qaZ;;AwElraQ;EAOI,+BAAA;AxE+qaZ;;AwEtraQ;EAOI,iCAAA;AxEmraZ;;AwE1raQ;EAOI,+BAAA;AxEuraZ;;AwE9raQ;EAOI,0BAAA;AxE2raZ;;AwElsaQ;EAOI,gCAAA;AxE+raZ;;AwEtsaQ;EAOI,+BAAA;AxEmsaZ;;AwE1saQ;EAOI,6BAAA;AxEusaZ;;AwE9saQ;EAOI,+BAAA;AxE2saZ;;AwEltaQ;EAOI,6BAAA;AxE+saZ;;AcztaI;E0DGI;IAOI,0BAAA;ExEotaV;EwE3taM;IAOI,gCAAA;ExEutaV;EwE9taM;IAOI,yBAAA;ExE0taV;EwEjuaM;IAOI,wBAAA;ExE6taV;EwEpuaM;IAOI,+BAAA;ExEguaV;EwEvuaM;IAOI,yBAAA;ExEmuaV;EwE1uaM;IAOI,6BAAA;ExEsuaV;EwE7uaM;IAOI,8BAAA;ExEyuaV;EwEhvaM;IAOI,wBAAA;ExE4uaV;EwEnvaM;IAOI,+BAAA;ExE+uaV;EwEtvaM;IAOI,wBAAA;ExEkvaV;EwEzvaM;IAOI,yBAAA;ExEqvaV;EwE5vaM;IAOI,8BAAA;ExEwvaV;EwE/vaM;IAOI,iCAAA;ExE2vaV;EwElwaM;IAOI,sCAAA;ExE8vaV;EwErwaM;IAOI,yCAAA;ExEiwaV;EwExwaM;IAOI,uBAAA;ExEowaV;EwE3waM;IAOI,uBAAA;ExEuwaV;EwE9waM;IAOI,yBAAA;ExE0waV;EwEjxaM;IAOI,yBAAA;ExE6waV;EwEpxaM;IAOI,0BAAA;ExEgxaV;EwEvxaM;IAOI,4BAAA;ExEmxaV;EwE1xaM;IAOI,kCAAA;ExEsxaV;EwE7xaM;IAOI,sCAAA;ExEyxaV;EwEhyaM;IAOI,oCAAA;ExE4xaV;EwEnyaM;IAOI,kCAAA;ExE+xaV;EwEtyaM;IAOI,yCAAA;ExEkyaV;EwEzyaM;IAOI,wCAAA;ExEqyaV;EwE5yaM;IAOI,wCAAA;ExEwyaV;EwE/yaM;IAOI,kCAAA;ExE2yaV;EwElzaM;IAOI,gCAAA;ExE8yaV;EwErzaM;IAOI,8BAAA;ExEizaV;EwExzaM;IAOI,gCAAA;ExEozaV;EwE3zaM;IAOI,+BAAA;ExEuzaV;EwE9zaM;IAOI,oCAAA;ExE0zaV;EwEj0aM;IAOI,kCAAA;ExE6zaV;EwEp0aM;IAOI,gCAAA;ExEg0aV;EwEv0aM;IAOI,uCAAA;ExEm0aV;EwE10aM;IAOI,sCAAA;ExEs0aV;EwE70aM;IAOI,iCAAA;ExEy0aV;EwEh1aM;IAOI,2BAAA;ExE40aV;EwEn1aM;IAOI,iCAAA;ExE+0aV;EwEt1aM;IAOI,+BAAA;ExEk1aV;EwEz1aM;IAOI,6BAAA;ExEq1aV;EwE51aM;IAOI,+BAAA;ExEw1aV;EwE/1aM;IAOI,8BAAA;ExE21aV;EwEl2aM;IAOI,oBAAA;ExE81aV;EwEr2aM;IAOI,mBAAA;ExEi2aV;EwEx2aM;IAOI,mBAAA;ExEo2aV;EwE32aM;IAOI,mBAAA;ExEu2aV;EwE92aM;IAOI,mBAAA;ExE02aV;EwEj3aM;IAOI,mBAAA;ExE62aV;EwEp3aM;IAOI,mBAAA;ExEg3aV;EwEv3aM;IAOI,mBAAA;ExEm3aV;EwE13aM;IAOI,oBAAA;ExEs3aV;EwE73aM;IAOI,0BAAA;ExEy3aV;EwEh4aM;IAOI,yBAAA;ExE43aV;EwEn4aM;IAOI,uBAAA;ExE+3aV;EwEt4aM;IAOI,yBAAA;ExEk4aV;EwEz4aM;IAOI,uBAAA;ExEq4aV;EwE54aM;IAOI,uBAAA;ExEw4aV;EwE/4aM;IAOI,0BAAA;IAAA,yBAAA;ExE44aV;EwEn5aM;IAOI,gCAAA;IAAA,+BAAA;ExEg5aV;EwEv5aM;IAOI,+BAAA;IAAA,8BAAA;ExEo5aV;EwE35aM;IAOI,6BAAA;IAAA,4BAAA;ExEw5aV;EwE/5aM;IAOI,+BAAA;IAAA,8BAAA;ExE45aV;EwEn6aM;IAOI,6BAAA;IAAA,4BAAA;ExEg6aV;EwEv6aM;IAOI,6BAAA;IAAA,4BAAA;ExEo6aV;EwE36aM;IAOI,wBAAA;IAAA,2BAAA;ExEw6aV;EwE/6aM;IAOI,8BAAA;IAAA,iCAAA;ExE46aV;EwEn7aM;IAOI,6BAAA;IAAA,gCAAA;ExEg7aV;EwEv7aM;IAOI,2BAAA;IAAA,8BAAA;ExEo7aV;EwE37aM;IAOI,6BAAA;IAAA,gCAAA;ExEw7aV;EwE/7aM;IAOI,2BAAA;IAAA,8BAAA;ExE47aV;EwEn8aM;IAOI,2BAAA;IAAA,8BAAA;ExEg8aV;EwEv8aM;IAOI,wBAAA;ExEm8aV;EwE18aM;IAOI,8BAAA;ExEs8aV;EwE78aM;IAOI,6BAAA;ExEy8aV;EwEh9aM;IAOI,2BAAA;ExE48aV;EwEn9aM;IAOI,6BAAA;ExE+8aV;EwEt9aM;IAOI,2BAAA;ExEk9aV;EwEz9aM;IAOI,2BAAA;ExEq9aV;EwE59aM;IAOI,0BAAA;ExEw9aV;EwE/9aM;IAOI,gCAAA;ExE29aV;EwEl+aM;IAOI,+BAAA;ExE89aV;EwEr+aM;IAOI,6BAAA;ExEi+aV;EwEx+aM;IAOI,+BAAA;ExEo+aV;EwE3+aM;IAOI,6BAAA;ExEu+aV;EwE9+aM;IAOI,6BAAA;ExE0+aV;EwEj/aM;IAOI,2BAAA;ExE6+aV;EwEp/aM;IAOI,iCAAA;ExEg/aV;EwEv/aM;IAOI,gCAAA;ExEm/aV;EwE1/aM;IAOI,8BAAA;ExEs/aV;EwE7/aM;IAOI,gCAAA;ExEy/aV;EwEhgbM;IAOI,8BAAA;ExE4/aV;EwEngbM;IAOI,8BAAA;ExE+/aV;EwEtgbM;IAOI,yBAAA;ExEkgbV;EwEzgbM;IAOI,+BAAA;ExEqgbV;EwE5gbM;IAOI,8BAAA;ExEwgbV;EwE/gbM;IAOI,4BAAA;ExE2gbV;EwElhbM;IAOI,8BAAA;ExE8gbV;EwErhbM;IAOI,4BAAA;ExEihbV;EwExhbM;IAOI,4BAAA;ExEohbV;EwE3hbM;IAOI,qBAAA;ExEuhbV;EwE9hbM;IAOI,2BAAA;ExE0hbV;EwEjibM;IAOI,0BAAA;ExE6hbV;EwEpibM;IAOI,wBAAA;ExEgibV;EwEvibM;IAOI,0BAAA;ExEmibV;EwE1ibM;IAOI,wBAAA;ExEsibV;EwE7ibM;IAOI,2BAAA;IAAA,0BAAA;ExE0ibV;EwEjjbM;IAOI,iCAAA;IAAA,gCAAA;ExE8ibV;EwErjbM;IAOI,gCAAA;IAAA,+BAAA;ExEkjbV;EwEzjbM;IAOI,8BAAA;IAAA,6BAAA;ExEsjbV;EwE7jbM;IAOI,gCAAA;IAAA,+BAAA;ExE0jbV;EwEjkbM;IAOI,8BAAA;IAAA,6BAAA;ExE8jbV;EwErkbM;IAOI,yBAAA;IAAA,4BAAA;ExEkkbV;EwEzkbM;IAOI,+BAAA;IAAA,kCAAA;ExEskbV;EwE7kbM;IAOI,8BAAA;IAAA,iCAAA;ExE0kbV;EwEjlbM;IAOI,4BAAA;IAAA,+BAAA;ExE8kbV;EwErlbM;IAOI,8BAAA;IAAA,iCAAA;ExEklbV;EwEzlbM;IAOI,4BAAA;IAAA,+BAAA;ExEslbV;EwE7lbM;IAOI,yBAAA;ExEylbV;EwEhmbM;IAOI,+BAAA;ExE4lbV;EwEnmbM;IAOI,8BAAA;ExE+lbV;EwEtmbM;IAOI,4BAAA;ExEkmbV;EwEzmbM;IAOI,8BAAA;ExEqmbV;EwE5mbM;IAOI,4BAAA;ExEwmbV;EwE/mbM;IAOI,2BAAA;ExE2mbV;EwElnbM;IAOI,iCAAA;ExE8mbV;EwErnbM;IAOI,gCAAA;ExEinbV;EwExnbM;IAOI,8BAAA;ExEonbV;EwE3nbM;IAOI,gCAAA;ExEunbV;EwE9nbM;IAOI,8BAAA;ExE0nbV;EwEjobM;IAOI,4BAAA;ExE6nbV;EwEpobM;IAOI,kCAAA;ExEgobV;EwEvobM;IAOI,iCAAA;ExEmobV;EwE1obM;IAOI,+BAAA;ExEsobV;EwE7obM;IAOI,iCAAA;ExEyobV;EwEhpbM;IAOI,+BAAA;ExE4obV;EwEnpbM;IAOI,0BAAA;ExE+obV;EwEtpbM;IAOI,gCAAA;ExEkpbV;EwEzpbM;IAOI,+BAAA;ExEqpbV;EwE5pbM;IAOI,6BAAA;ExEwpbV;EwE/pbM;IAOI,+BAAA;ExE2pbV;EwElqbM;IAOI,6BAAA;ExE8pbV;AACF;AczqbI;E0DGI;IAOI,0BAAA;ExEmqbV;EwE1qbM;IAOI,gCAAA;ExEsqbV;EwE7qbM;IAOI,yBAAA;ExEyqbV;EwEhrbM;IAOI,wBAAA;ExE4qbV;EwEnrbM;IAOI,+BAAA;ExE+qbV;EwEtrbM;IAOI,yBAAA;ExEkrbV;EwEzrbM;IAOI,6BAAA;ExEqrbV;EwE5rbM;IAOI,8BAAA;ExEwrbV;EwE/rbM;IAOI,wBAAA;ExE2rbV;EwElsbM;IAOI,+BAAA;ExE8rbV;EwErsbM;IAOI,wBAAA;ExEisbV;EwExsbM;IAOI,yBAAA;ExEosbV;EwE3sbM;IAOI,8BAAA;ExEusbV;EwE9sbM;IAOI,iCAAA;ExE0sbV;EwEjtbM;IAOI,sCAAA;ExE6sbV;EwEptbM;IAOI,yCAAA;ExEgtbV;EwEvtbM;IAOI,uBAAA;ExEmtbV;EwE1tbM;IAOI,uBAAA;ExEstbV;EwE7tbM;IAOI,yBAAA;ExEytbV;EwEhubM;IAOI,yBAAA;ExE4tbV;EwEnubM;IAOI,0BAAA;ExE+tbV;EwEtubM;IAOI,4BAAA;ExEkubV;EwEzubM;IAOI,kCAAA;ExEqubV;EwE5ubM;IAOI,sCAAA;ExEwubV;EwE/ubM;IAOI,oCAAA;ExE2ubV;EwElvbM;IAOI,kCAAA;ExE8ubV;EwErvbM;IAOI,yCAAA;ExEivbV;EwExvbM;IAOI,wCAAA;ExEovbV;EwE3vbM;IAOI,wCAAA;ExEuvbV;EwE9vbM;IAOI,kCAAA;ExE0vbV;EwEjwbM;IAOI,gCAAA;ExE6vbV;EwEpwbM;IAOI,8BAAA;ExEgwbV;EwEvwbM;IAOI,gCAAA;ExEmwbV;EwE1wbM;IAOI,+BAAA;ExEswbV;EwE7wbM;IAOI,oCAAA;ExEywbV;EwEhxbM;IAOI,kCAAA;ExE4wbV;EwEnxbM;IAOI,gCAAA;ExE+wbV;EwEtxbM;IAOI,uCAAA;ExEkxbV;EwEzxbM;IAOI,sCAAA;ExEqxbV;EwE5xbM;IAOI,iCAAA;ExEwxbV;EwE/xbM;IAOI,2BAAA;ExE2xbV;EwElybM;IAOI,iCAAA;ExE8xbV;EwErybM;IAOI,+BAAA;ExEiybV;EwExybM;IAOI,6BAAA;ExEoybV;EwE3ybM;IAOI,+BAAA;ExEuybV;EwE9ybM;IAOI,8BAAA;ExE0ybV;EwEjzbM;IAOI,oBAAA;ExE6ybV;EwEpzbM;IAOI,mBAAA;ExEgzbV;EwEvzbM;IAOI,mBAAA;ExEmzbV;EwE1zbM;IAOI,mBAAA;ExEszbV;EwE7zbM;IAOI,mBAAA;ExEyzbV;EwEh0bM;IAOI,mBAAA;ExE4zbV;EwEn0bM;IAOI,mBAAA;ExE+zbV;EwEt0bM;IAOI,mBAAA;ExEk0bV;EwEz0bM;IAOI,oBAAA;ExEq0bV;EwE50bM;IAOI,0BAAA;ExEw0bV;EwE/0bM;IAOI,yBAAA;ExE20bV;EwEl1bM;IAOI,uBAAA;ExE80bV;EwEr1bM;IAOI,yBAAA;ExEi1bV;EwEx1bM;IAOI,uBAAA;ExEo1bV;EwE31bM;IAOI,uBAAA;ExEu1bV;EwE91bM;IAOI,0BAAA;IAAA,yBAAA;ExE21bV;EwEl2bM;IAOI,gCAAA;IAAA,+BAAA;ExE+1bV;EwEt2bM;IAOI,+BAAA;IAAA,8BAAA;ExEm2bV;EwE12bM;IAOI,6BAAA;IAAA,4BAAA;ExEu2bV;EwE92bM;IAOI,+BAAA;IAAA,8BAAA;ExE22bV;EwEl3bM;IAOI,6BAAA;IAAA,4BAAA;ExE+2bV;EwEt3bM;IAOI,6BAAA;IAAA,4BAAA;ExEm3bV;EwE13bM;IAOI,wBAAA;IAAA,2BAAA;ExEu3bV;EwE93bM;IAOI,8BAAA;IAAA,iCAAA;ExE23bV;EwEl4bM;IAOI,6BAAA;IAAA,gCAAA;ExE+3bV;EwEt4bM;IAOI,2BAAA;IAAA,8BAAA;ExEm4bV;EwE14bM;IAOI,6BAAA;IAAA,gCAAA;ExEu4bV;EwE94bM;IAOI,2BAAA;IAAA,8BAAA;ExE24bV;EwEl5bM;IAOI,2BAAA;IAAA,8BAAA;ExE+4bV;EwEt5bM;IAOI,wBAAA;ExEk5bV;EwEz5bM;IAOI,8BAAA;ExEq5bV;EwE55bM;IAOI,6BAAA;ExEw5bV;EwE/5bM;IAOI,2BAAA;ExE25bV;EwEl6bM;IAOI,6BAAA;ExE85bV;EwEr6bM;IAOI,2BAAA;ExEi6bV;EwEx6bM;IAOI,2BAAA;ExEo6bV;EwE36bM;IAOI,0BAAA;ExEu6bV;EwE96bM;IAOI,gCAAA;ExE06bV;EwEj7bM;IAOI,+BAAA;ExE66bV;EwEp7bM;IAOI,6BAAA;ExEg7bV;EwEv7bM;IAOI,+BAAA;ExEm7bV;EwE17bM;IAOI,6BAAA;ExEs7bV;EwE77bM;IAOI,6BAAA;ExEy7bV;EwEh8bM;IAOI,2BAAA;ExE47bV;EwEn8bM;IAOI,iCAAA;ExE+7bV;EwEt8bM;IAOI,gCAAA;ExEk8bV;EwEz8bM;IAOI,8BAAA;ExEq8bV;EwE58bM;IAOI,gCAAA;ExEw8bV;EwE/8bM;IAOI,8BAAA;ExE28bV;EwEl9bM;IAOI,8BAAA;ExE88bV;EwEr9bM;IAOI,yBAAA;ExEi9bV;EwEx9bM;IAOI,+BAAA;ExEo9bV;EwE39bM;IAOI,8BAAA;ExEu9bV;EwE99bM;IAOI,4BAAA;ExE09bV;EwEj+bM;IAOI,8BAAA;ExE69bV;EwEp+bM;IAOI,4BAAA;ExEg+bV;EwEv+bM;IAOI,4BAAA;ExEm+bV;EwE1+bM;IAOI,qBAAA;ExEs+bV;EwE7+bM;IAOI,2BAAA;ExEy+bV;EwEh/bM;IAOI,0BAAA;ExE4+bV;EwEn/bM;IAOI,wBAAA;ExE++bV;EwEt/bM;IAOI,0BAAA;ExEk/bV;EwEz/bM;IAOI,wBAAA;ExEq/bV;EwE5/bM;IAOI,2BAAA;IAAA,0BAAA;ExEy/bV;EwEhgcM;IAOI,iCAAA;IAAA,gCAAA;ExE6/bV;EwEpgcM;IAOI,gCAAA;IAAA,+BAAA;ExEigcV;EwExgcM;IAOI,8BAAA;IAAA,6BAAA;ExEqgcV;EwE5gcM;IAOI,gCAAA;IAAA,+BAAA;ExEygcV;EwEhhcM;IAOI,8BAAA;IAAA,6BAAA;ExE6gcV;EwEphcM;IAOI,yBAAA;IAAA,4BAAA;ExEihcV;EwExhcM;IAOI,+BAAA;IAAA,kCAAA;ExEqhcV;EwE5hcM;IAOI,8BAAA;IAAA,iCAAA;ExEyhcV;EwEhicM;IAOI,4BAAA;IAAA,+BAAA;ExE6hcV;EwEpicM;IAOI,8BAAA;IAAA,iCAAA;ExEiicV;EwExicM;IAOI,4BAAA;IAAA,+BAAA;ExEqicV;EwE5icM;IAOI,yBAAA;ExEwicV;EwE/icM;IAOI,+BAAA;ExE2icV;EwEljcM;IAOI,8BAAA;ExE8icV;EwErjcM;IAOI,4BAAA;ExEijcV;EwExjcM;IAOI,8BAAA;ExEojcV;EwE3jcM;IAOI,4BAAA;ExEujcV;EwE9jcM;IAOI,2BAAA;ExE0jcV;EwEjkcM;IAOI,iCAAA;ExE6jcV;EwEpkcM;IAOI,gCAAA;ExEgkcV;EwEvkcM;IAOI,8BAAA;ExEmkcV;EwE1kcM;IAOI,gCAAA;ExEskcV;EwE7kcM;IAOI,8BAAA;ExEykcV;EwEhlcM;IAOI,4BAAA;ExE4kcV;EwEnlcM;IAOI,kCAAA;ExE+kcV;EwEtlcM;IAOI,iCAAA;ExEklcV;EwEzlcM;IAOI,+BAAA;ExEqlcV;EwE5lcM;IAOI,iCAAA;ExEwlcV;EwE/lcM;IAOI,+BAAA;ExE2lcV;EwElmcM;IAOI,0BAAA;ExE8lcV;EwErmcM;IAOI,gCAAA;ExEimcV;EwExmcM;IAOI,+BAAA;ExEomcV;EwE3mcM;IAOI,6BAAA;ExEumcV;EwE9mcM;IAOI,+BAAA;ExE0mcV;EwEjncM;IAOI,6BAAA;ExE6mcV;AACF;AcxncI;E0DGI;IAOI,0BAAA;ExEkncV;EwEzncM;IAOI,gCAAA;ExEqncV;EwE5ncM;IAOI,yBAAA;ExEwncV;EwE/ncM;IAOI,wBAAA;ExE2ncV;EwElocM;IAOI,+BAAA;ExE8ncV;EwErocM;IAOI,yBAAA;ExEiocV;EwExocM;IAOI,6BAAA;ExEoocV;EwE3ocM;IAOI,8BAAA;ExEuocV;EwE9ocM;IAOI,wBAAA;ExE0ocV;EwEjpcM;IAOI,+BAAA;ExE6ocV;EwEppcM;IAOI,wBAAA;ExEgpcV;EwEvpcM;IAOI,yBAAA;ExEmpcV;EwE1pcM;IAOI,8BAAA;ExEspcV;EwE7pcM;IAOI,iCAAA;ExEypcV;EwEhqcM;IAOI,sCAAA;ExE4pcV;EwEnqcM;IAOI,yCAAA;ExE+pcV;EwEtqcM;IAOI,uBAAA;ExEkqcV;EwEzqcM;IAOI,uBAAA;ExEqqcV;EwE5qcM;IAOI,yBAAA;ExEwqcV;EwE/qcM;IAOI,yBAAA;ExE2qcV;EwElrcM;IAOI,0BAAA;ExE8qcV;EwErrcM;IAOI,4BAAA;ExEircV;EwExrcM;IAOI,kCAAA;ExEorcV;EwE3rcM;IAOI,sCAAA;ExEurcV;EwE9rcM;IAOI,oCAAA;ExE0rcV;EwEjscM;IAOI,kCAAA;ExE6rcV;EwEpscM;IAOI,yCAAA;ExEgscV;EwEvscM;IAOI,wCAAA;ExEmscV;EwE1scM;IAOI,wCAAA;ExEsscV;EwE7scM;IAOI,kCAAA;ExEyscV;EwEhtcM;IAOI,gCAAA;ExE4scV;EwEntcM;IAOI,8BAAA;ExE+scV;EwEttcM;IAOI,gCAAA;ExEktcV;EwEztcM;IAOI,+BAAA;ExEqtcV;EwE5tcM;IAOI,oCAAA;ExEwtcV;EwE/tcM;IAOI,kCAAA;ExE2tcV;EwElucM;IAOI,gCAAA;ExE8tcV;EwErucM;IAOI,uCAAA;ExEiucV;EwExucM;IAOI,sCAAA;ExEoucV;EwE3ucM;IAOI,iCAAA;ExEuucV;EwE9ucM;IAOI,2BAAA;ExE0ucV;EwEjvcM;IAOI,iCAAA;ExE6ucV;EwEpvcM;IAOI,+BAAA;ExEgvcV;EwEvvcM;IAOI,6BAAA;ExEmvcV;EwE1vcM;IAOI,+BAAA;ExEsvcV;EwE7vcM;IAOI,8BAAA;ExEyvcV;EwEhwcM;IAOI,oBAAA;ExE4vcV;EwEnwcM;IAOI,mBAAA;ExE+vcV;EwEtwcM;IAOI,mBAAA;ExEkwcV;EwEzwcM;IAOI,mBAAA;ExEqwcV;EwE5wcM;IAOI,mBAAA;ExEwwcV;EwE/wcM;IAOI,mBAAA;ExE2wcV;EwElxcM;IAOI,mBAAA;ExE8wcV;EwErxcM;IAOI,mBAAA;ExEixcV;EwExxcM;IAOI,oBAAA;ExEoxcV;EwE3xcM;IAOI,0BAAA;ExEuxcV;EwE9xcM;IAOI,yBAAA;ExE0xcV;EwEjycM;IAOI,uBAAA;ExE6xcV;EwEpycM;IAOI,yBAAA;ExEgycV;EwEvycM;IAOI,uBAAA;ExEmycV;EwE1ycM;IAOI,uBAAA;ExEsycV;EwE7ycM;IAOI,0BAAA;IAAA,yBAAA;ExE0ycV;EwEjzcM;IAOI,gCAAA;IAAA,+BAAA;ExE8ycV;EwErzcM;IAOI,+BAAA;IAAA,8BAAA;ExEkzcV;EwEzzcM;IAOI,6BAAA;IAAA,4BAAA;ExEszcV;EwE7zcM;IAOI,+BAAA;IAAA,8BAAA;ExE0zcV;EwEj0cM;IAOI,6BAAA;IAAA,4BAAA;ExE8zcV;EwEr0cM;IAOI,6BAAA;IAAA,4BAAA;ExEk0cV;EwEz0cM;IAOI,wBAAA;IAAA,2BAAA;ExEs0cV;EwE70cM;IAOI,8BAAA;IAAA,iCAAA;ExE00cV;EwEj1cM;IAOI,6BAAA;IAAA,gCAAA;ExE80cV;EwEr1cM;IAOI,2BAAA;IAAA,8BAAA;ExEk1cV;EwEz1cM;IAOI,6BAAA;IAAA,gCAAA;ExEs1cV;EwE71cM;IAOI,2BAAA;IAAA,8BAAA;ExE01cV;EwEj2cM;IAOI,2BAAA;IAAA,8BAAA;ExE81cV;EwEr2cM;IAOI,wBAAA;ExEi2cV;EwEx2cM;IAOI,8BAAA;ExEo2cV;EwE32cM;IAOI,6BAAA;ExEu2cV;EwE92cM;IAOI,2BAAA;ExE02cV;EwEj3cM;IAOI,6BAAA;ExE62cV;EwEp3cM;IAOI,2BAAA;ExEg3cV;EwEv3cM;IAOI,2BAAA;ExEm3cV;EwE13cM;IAOI,0BAAA;ExEs3cV;EwE73cM;IAOI,gCAAA;ExEy3cV;EwEh4cM;IAOI,+BAAA;ExE43cV;EwEn4cM;IAOI,6BAAA;ExE+3cV;EwEt4cM;IAOI,+BAAA;ExEk4cV;EwEz4cM;IAOI,6BAAA;ExEq4cV;EwE54cM;IAOI,6BAAA;ExEw4cV;EwE/4cM;IAOI,2BAAA;ExE24cV;EwEl5cM;IAOI,iCAAA;ExE84cV;EwEr5cM;IAOI,gCAAA;ExEi5cV;EwEx5cM;IAOI,8BAAA;ExEo5cV;EwE35cM;IAOI,gCAAA;ExEu5cV;EwE95cM;IAOI,8BAAA;ExE05cV;EwEj6cM;IAOI,8BAAA;ExE65cV;EwEp6cM;IAOI,yBAAA;ExEg6cV;EwEv6cM;IAOI,+BAAA;ExEm6cV;EwE16cM;IAOI,8BAAA;ExEs6cV;EwE76cM;IAOI,4BAAA;ExEy6cV;EwEh7cM;IAOI,8BAAA;ExE46cV;EwEn7cM;IAOI,4BAAA;ExE+6cV;EwEt7cM;IAOI,4BAAA;ExEk7cV;EwEz7cM;IAOI,qBAAA;ExEq7cV;EwE57cM;IAOI,2BAAA;ExEw7cV;EwE/7cM;IAOI,0BAAA;ExE27cV;EwEl8cM;IAOI,wBAAA;ExE87cV;EwEr8cM;IAOI,0BAAA;ExEi8cV;EwEx8cM;IAOI,wBAAA;ExEo8cV;EwE38cM;IAOI,2BAAA;IAAA,0BAAA;ExEw8cV;EwE/8cM;IAOI,iCAAA;IAAA,gCAAA;ExE48cV;EwEn9cM;IAOI,gCAAA;IAAA,+BAAA;ExEg9cV;EwEv9cM;IAOI,8BAAA;IAAA,6BAAA;ExEo9cV;EwE39cM;IAOI,gCAAA;IAAA,+BAAA;ExEw9cV;EwE/9cM;IAOI,8BAAA;IAAA,6BAAA;ExE49cV;EwEn+cM;IAOI,yBAAA;IAAA,4BAAA;ExEg+cV;EwEv+cM;IAOI,+BAAA;IAAA,kCAAA;ExEo+cV;EwE3+cM;IAOI,8BAAA;IAAA,iCAAA;ExEw+cV;EwE/+cM;IAOI,4BAAA;IAAA,+BAAA;ExE4+cV;EwEn/cM;IAOI,8BAAA;IAAA,iCAAA;ExEg/cV;EwEv/cM;IAOI,4BAAA;IAAA,+BAAA;ExEo/cV;EwE3/cM;IAOI,yBAAA;ExEu/cV;EwE9/cM;IAOI,+BAAA;ExE0/cV;EwEjgdM;IAOI,8BAAA;ExE6/cV;EwEpgdM;IAOI,4BAAA;ExEggdV;EwEvgdM;IAOI,8BAAA;ExEmgdV;EwE1gdM;IAOI,4BAAA;ExEsgdV;EwE7gdM;IAOI,2BAAA;ExEygdV;EwEhhdM;IAOI,iCAAA;ExE4gdV;EwEnhdM;IAOI,gCAAA;ExE+gdV;EwEthdM;IAOI,8BAAA;ExEkhdV;EwEzhdM;IAOI,gCAAA;ExEqhdV;EwE5hdM;IAOI,8BAAA;ExEwhdV;EwE/hdM;IAOI,4BAAA;ExE2hdV;EwElidM;IAOI,kCAAA;ExE8hdV;EwEridM;IAOI,iCAAA;ExEiidV;EwExidM;IAOI,+BAAA;ExEoidV;EwE3idM;IAOI,iCAAA;ExEuidV;EwE9idM;IAOI,+BAAA;ExE0idV;EwEjjdM;IAOI,0BAAA;ExE6idV;EwEpjdM;IAOI,gCAAA;ExEgjdV;EwEvjdM;IAOI,+BAAA;ExEmjdV;EwE1jdM;IAOI,6BAAA;ExEsjdV;EwE7jdM;IAOI,+BAAA;ExEyjdV;EwEhkdM;IAOI,6BAAA;ExE4jdV;AACF;AcvkdI;E0DGI;IAOI,0BAAA;ExEikdV;EwExkdM;IAOI,gCAAA;ExEokdV;EwE3kdM;IAOI,yBAAA;ExEukdV;EwE9kdM;IAOI,wBAAA;ExE0kdV;EwEjldM;IAOI,+BAAA;ExE6kdV;EwEpldM;IAOI,yBAAA;ExEgldV;EwEvldM;IAOI,6BAAA;ExEmldV;EwE1ldM;IAOI,8BAAA;ExEsldV;EwE7ldM;IAOI,wBAAA;ExEyldV;EwEhmdM;IAOI,+BAAA;ExE4ldV;EwEnmdM;IAOI,wBAAA;ExE+ldV;EwEtmdM;IAOI,yBAAA;ExEkmdV;EwEzmdM;IAOI,8BAAA;ExEqmdV;EwE5mdM;IAOI,iCAAA;ExEwmdV;EwE/mdM;IAOI,sCAAA;ExE2mdV;EwElndM;IAOI,yCAAA;ExE8mdV;EwErndM;IAOI,uBAAA;ExEindV;EwExndM;IAOI,uBAAA;ExEondV;EwE3ndM;IAOI,yBAAA;ExEundV;EwE9ndM;IAOI,yBAAA;ExE0ndV;EwEjodM;IAOI,0BAAA;ExE6ndV;EwEpodM;IAOI,4BAAA;ExEgodV;EwEvodM;IAOI,kCAAA;ExEmodV;EwE1odM;IAOI,sCAAA;ExEsodV;EwE7odM;IAOI,oCAAA;ExEyodV;EwEhpdM;IAOI,kCAAA;ExE4odV;EwEnpdM;IAOI,yCAAA;ExE+odV;EwEtpdM;IAOI,wCAAA;ExEkpdV;EwEzpdM;IAOI,wCAAA;ExEqpdV;EwE5pdM;IAOI,kCAAA;ExEwpdV;EwE/pdM;IAOI,gCAAA;ExE2pdV;EwElqdM;IAOI,8BAAA;ExE8pdV;EwErqdM;IAOI,gCAAA;ExEiqdV;EwExqdM;IAOI,+BAAA;ExEoqdV;EwE3qdM;IAOI,oCAAA;ExEuqdV;EwE9qdM;IAOI,kCAAA;ExE0qdV;EwEjrdM;IAOI,gCAAA;ExE6qdV;EwEprdM;IAOI,uCAAA;ExEgrdV;EwEvrdM;IAOI,sCAAA;ExEmrdV;EwE1rdM;IAOI,iCAAA;ExEsrdV;EwE7rdM;IAOI,2BAAA;ExEyrdV;EwEhsdM;IAOI,iCAAA;ExE4rdV;EwEnsdM;IAOI,+BAAA;ExE+rdV;EwEtsdM;IAOI,6BAAA;ExEksdV;EwEzsdM;IAOI,+BAAA;ExEqsdV;EwE5sdM;IAOI,8BAAA;ExEwsdV;EwE/sdM;IAOI,oBAAA;ExE2sdV;EwEltdM;IAOI,mBAAA;ExE8sdV;EwErtdM;IAOI,mBAAA;ExEitdV;EwExtdM;IAOI,mBAAA;ExEotdV;EwE3tdM;IAOI,mBAAA;ExEutdV;EwE9tdM;IAOI,mBAAA;ExE0tdV;EwEjudM;IAOI,mBAAA;ExE6tdV;EwEpudM;IAOI,mBAAA;ExEgudV;EwEvudM;IAOI,oBAAA;ExEmudV;EwE1udM;IAOI,0BAAA;ExEsudV;EwE7udM;IAOI,yBAAA;ExEyudV;EwEhvdM;IAOI,uBAAA;ExE4udV;EwEnvdM;IAOI,yBAAA;ExE+udV;EwEtvdM;IAOI,uBAAA;ExEkvdV;EwEzvdM;IAOI,uBAAA;ExEqvdV;EwE5vdM;IAOI,0BAAA;IAAA,yBAAA;ExEyvdV;EwEhwdM;IAOI,gCAAA;IAAA,+BAAA;ExE6vdV;EwEpwdM;IAOI,+BAAA;IAAA,8BAAA;ExEiwdV;EwExwdM;IAOI,6BAAA;IAAA,4BAAA;ExEqwdV;EwE5wdM;IAOI,+BAAA;IAAA,8BAAA;ExEywdV;EwEhxdM;IAOI,6BAAA;IAAA,4BAAA;ExE6wdV;EwEpxdM;IAOI,6BAAA;IAAA,4BAAA;ExEixdV;EwExxdM;IAOI,wBAAA;IAAA,2BAAA;ExEqxdV;EwE5xdM;IAOI,8BAAA;IAAA,iCAAA;ExEyxdV;EwEhydM;IAOI,6BAAA;IAAA,gCAAA;ExE6xdV;EwEpydM;IAOI,2BAAA;IAAA,8BAAA;ExEiydV;EwExydM;IAOI,6BAAA;IAAA,gCAAA;ExEqydV;EwE5ydM;IAOI,2BAAA;IAAA,8BAAA;ExEyydV;EwEhzdM;IAOI,2BAAA;IAAA,8BAAA;ExE6ydV;EwEpzdM;IAOI,wBAAA;ExEgzdV;EwEvzdM;IAOI,8BAAA;ExEmzdV;EwE1zdM;IAOI,6BAAA;ExEszdV;EwE7zdM;IAOI,2BAAA;ExEyzdV;EwEh0dM;IAOI,6BAAA;ExE4zdV;EwEn0dM;IAOI,2BAAA;ExE+zdV;EwEt0dM;IAOI,2BAAA;ExEk0dV;EwEz0dM;IAOI,0BAAA;ExEq0dV;EwE50dM;IAOI,gCAAA;ExEw0dV;EwE/0dM;IAOI,+BAAA;ExE20dV;EwEl1dM;IAOI,6BAAA;ExE80dV;EwEr1dM;IAOI,+BAAA;ExEi1dV;EwEx1dM;IAOI,6BAAA;ExEo1dV;EwE31dM;IAOI,6BAAA;ExEu1dV;EwE91dM;IAOI,2BAAA;ExE01dV;EwEj2dM;IAOI,iCAAA;ExE61dV;EwEp2dM;IAOI,gCAAA;ExEg2dV;EwEv2dM;IAOI,8BAAA;ExEm2dV;EwE12dM;IAOI,gCAAA;ExEs2dV;EwE72dM;IAOI,8BAAA;ExEy2dV;EwEh3dM;IAOI,8BAAA;ExE42dV;EwEn3dM;IAOI,yBAAA;ExE+2dV;EwEt3dM;IAOI,+BAAA;ExEk3dV;EwEz3dM;IAOI,8BAAA;ExEq3dV;EwE53dM;IAOI,4BAAA;ExEw3dV;EwE/3dM;IAOI,8BAAA;ExE23dV;EwEl4dM;IAOI,4BAAA;ExE83dV;EwEr4dM;IAOI,4BAAA;ExEi4dV;EwEx4dM;IAOI,qBAAA;ExEo4dV;EwE34dM;IAOI,2BAAA;ExEu4dV;EwE94dM;IAOI,0BAAA;ExE04dV;EwEj5dM;IAOI,wBAAA;ExE64dV;EwEp5dM;IAOI,0BAAA;ExEg5dV;EwEv5dM;IAOI,wBAAA;ExEm5dV;EwE15dM;IAOI,2BAAA;IAAA,0BAAA;ExEu5dV;EwE95dM;IAOI,iCAAA;IAAA,gCAAA;ExE25dV;EwEl6dM;IAOI,gCAAA;IAAA,+BAAA;ExE+5dV;EwEt6dM;IAOI,8BAAA;IAAA,6BAAA;ExEm6dV;EwE16dM;IAOI,gCAAA;IAAA,+BAAA;ExEu6dV;EwE96dM;IAOI,8BAAA;IAAA,6BAAA;ExE26dV;EwEl7dM;IAOI,yBAAA;IAAA,4BAAA;ExE+6dV;EwEt7dM;IAOI,+BAAA;IAAA,kCAAA;ExEm7dV;EwE17dM;IAOI,8BAAA;IAAA,iCAAA;ExEu7dV;EwE97dM;IAOI,4BAAA;IAAA,+BAAA;ExE27dV;EwEl8dM;IAOI,8BAAA;IAAA,iCAAA;ExE+7dV;EwEt8dM;IAOI,4BAAA;IAAA,+BAAA;ExEm8dV;EwE18dM;IAOI,yBAAA;ExEs8dV;EwE78dM;IAOI,+BAAA;ExEy8dV;EwEh9dM;IAOI,8BAAA;ExE48dV;EwEn9dM;IAOI,4BAAA;ExE+8dV;EwEt9dM;IAOI,8BAAA;ExEk9dV;EwEz9dM;IAOI,4BAAA;ExEq9dV;EwE59dM;IAOI,2BAAA;ExEw9dV;EwE/9dM;IAOI,iCAAA;ExE29dV;EwEl+dM;IAOI,gCAAA;ExE89dV;EwEr+dM;IAOI,8BAAA;ExEi+dV;EwEx+dM;IAOI,gCAAA;ExEo+dV;EwE3+dM;IAOI,8BAAA;ExEu+dV;EwE9+dM;IAOI,4BAAA;ExE0+dV;EwEj/dM;IAOI,kCAAA;ExE6+dV;EwEp/dM;IAOI,iCAAA;ExEg/dV;EwEv/dM;IAOI,+BAAA;ExEm/dV;EwE1/dM;IAOI,iCAAA;ExEs/dV;EwE7/dM;IAOI,+BAAA;ExEy/dV;EwEhgeM;IAOI,0BAAA;ExE4/dV;EwEngeM;IAOI,gCAAA;ExE+/dV;EwEtgeM;IAOI,+BAAA;ExEkgeV;EwEzgeM;IAOI,6BAAA;ExEqgeV;EwE5geM;IAOI,+BAAA;ExEwgeV;EwE/geM;IAOI,6BAAA;ExE2geV;AACF;ActheI;E0DGI;IAOI,0BAAA;ExEgheV;EwEvheM;IAOI,gCAAA;ExEmheV;EwE1heM;IAOI,yBAAA;ExEsheV;EwE7heM;IAOI,wBAAA;ExEyheV;EwEhieM;IAOI,+BAAA;ExE4heV;EwEnieM;IAOI,yBAAA;ExE+heV;EwEtieM;IAOI,6BAAA;ExEkieV;EwEzieM;IAOI,8BAAA;ExEqieV;EwE5ieM;IAOI,wBAAA;ExEwieV;EwE/ieM;IAOI,+BAAA;ExE2ieV;EwEljeM;IAOI,wBAAA;ExE8ieV;EwErjeM;IAOI,yBAAA;ExEijeV;EwExjeM;IAOI,8BAAA;ExEojeV;EwE3jeM;IAOI,iCAAA;ExEujeV;EwE9jeM;IAOI,sCAAA;ExE0jeV;EwEjkeM;IAOI,yCAAA;ExE6jeV;EwEpkeM;IAOI,uBAAA;ExEgkeV;EwEvkeM;IAOI,uBAAA;ExEmkeV;EwE1keM;IAOI,yBAAA;ExEskeV;EwE7keM;IAOI,yBAAA;ExEykeV;EwEhleM;IAOI,0BAAA;ExE4keV;EwEnleM;IAOI,4BAAA;ExE+keV;EwEtleM;IAOI,kCAAA;ExEkleV;EwEzleM;IAOI,sCAAA;ExEqleV;EwE5leM;IAOI,oCAAA;ExEwleV;EwE/leM;IAOI,kCAAA;ExE2leV;EwElmeM;IAOI,yCAAA;ExE8leV;EwErmeM;IAOI,wCAAA;ExEimeV;EwExmeM;IAOI,wCAAA;ExEomeV;EwE3meM;IAOI,kCAAA;ExEumeV;EwE9meM;IAOI,gCAAA;ExE0meV;EwEjneM;IAOI,8BAAA;ExE6meV;EwEpneM;IAOI,gCAAA;ExEgneV;EwEvneM;IAOI,+BAAA;ExEmneV;EwE1neM;IAOI,oCAAA;ExEsneV;EwE7neM;IAOI,kCAAA;ExEyneV;EwEhoeM;IAOI,gCAAA;ExE4neV;EwEnoeM;IAOI,uCAAA;ExE+neV;EwEtoeM;IAOI,sCAAA;ExEkoeV;EwEzoeM;IAOI,iCAAA;ExEqoeV;EwE5oeM;IAOI,2BAAA;ExEwoeV;EwE/oeM;IAOI,iCAAA;ExE2oeV;EwElpeM;IAOI,+BAAA;ExE8oeV;EwErpeM;IAOI,6BAAA;ExEipeV;EwExpeM;IAOI,+BAAA;ExEopeV;EwE3peM;IAOI,8BAAA;ExEupeV;EwE9peM;IAOI,oBAAA;ExE0peV;EwEjqeM;IAOI,mBAAA;ExE6peV;EwEpqeM;IAOI,mBAAA;ExEgqeV;EwEvqeM;IAOI,mBAAA;ExEmqeV;EwE1qeM;IAOI,mBAAA;ExEsqeV;EwE7qeM;IAOI,mBAAA;ExEyqeV;EwEhreM;IAOI,mBAAA;ExE4qeV;EwEnreM;IAOI,mBAAA;ExE+qeV;EwEtreM;IAOI,oBAAA;ExEkreV;EwEzreM;IAOI,0BAAA;ExEqreV;EwE5reM;IAOI,yBAAA;ExEwreV;EwE/reM;IAOI,uBAAA;ExE2reV;EwElseM;IAOI,yBAAA;ExE8reV;EwErseM;IAOI,uBAAA;ExEiseV;EwExseM;IAOI,uBAAA;ExEoseV;EwE3seM;IAOI,0BAAA;IAAA,yBAAA;ExEwseV;EwE/seM;IAOI,gCAAA;IAAA,+BAAA;ExE4seV;EwEnteM;IAOI,+BAAA;IAAA,8BAAA;ExEgteV;EwEvteM;IAOI,6BAAA;IAAA,4BAAA;ExEoteV;EwE3teM;IAOI,+BAAA;IAAA,8BAAA;ExEwteV;EwE/teM;IAOI,6BAAA;IAAA,4BAAA;ExE4teV;EwEnueM;IAOI,6BAAA;IAAA,4BAAA;ExEgueV;EwEvueM;IAOI,wBAAA;IAAA,2BAAA;ExEoueV;EwE3ueM;IAOI,8BAAA;IAAA,iCAAA;ExEwueV;EwE/ueM;IAOI,6BAAA;IAAA,gCAAA;ExE4ueV;EwEnveM;IAOI,2BAAA;IAAA,8BAAA;ExEgveV;EwEvveM;IAOI,6BAAA;IAAA,gCAAA;ExEoveV;EwE3veM;IAOI,2BAAA;IAAA,8BAAA;ExEwveV;EwE/veM;IAOI,2BAAA;IAAA,8BAAA;ExE4veV;EwEnweM;IAOI,wBAAA;ExE+veV;EwEtweM;IAOI,8BAAA;ExEkweV;EwEzweM;IAOI,6BAAA;ExEqweV;EwE5weM;IAOI,2BAAA;ExEwweV;EwE/weM;IAOI,6BAAA;ExE2weV;EwElxeM;IAOI,2BAAA;ExE8weV;EwErxeM;IAOI,2BAAA;ExEixeV;EwExxeM;IAOI,0BAAA;ExEoxeV;EwE3xeM;IAOI,gCAAA;ExEuxeV;EwE9xeM;IAOI,+BAAA;ExE0xeV;EwEjyeM;IAOI,6BAAA;ExE6xeV;EwEpyeM;IAOI,+BAAA;ExEgyeV;EwEvyeM;IAOI,6BAAA;ExEmyeV;EwE1yeM;IAOI,6BAAA;ExEsyeV;EwE7yeM;IAOI,2BAAA;ExEyyeV;EwEhzeM;IAOI,iCAAA;ExE4yeV;EwEnzeM;IAOI,gCAAA;ExE+yeV;EwEtzeM;IAOI,8BAAA;ExEkzeV;EwEzzeM;IAOI,gCAAA;ExEqzeV;EwE5zeM;IAOI,8BAAA;ExEwzeV;EwE/zeM;IAOI,8BAAA;ExE2zeV;EwEl0eM;IAOI,yBAAA;ExE8zeV;EwEr0eM;IAOI,+BAAA;ExEi0eV;EwEx0eM;IAOI,8BAAA;ExEo0eV;EwE30eM;IAOI,4BAAA;ExEu0eV;EwE90eM;IAOI,8BAAA;ExE00eV;EwEj1eM;IAOI,4BAAA;ExE60eV;EwEp1eM;IAOI,4BAAA;ExEg1eV;EwEv1eM;IAOI,qBAAA;ExEm1eV;EwE11eM;IAOI,2BAAA;ExEs1eV;EwE71eM;IAOI,0BAAA;ExEy1eV;EwEh2eM;IAOI,wBAAA;ExE41eV;EwEn2eM;IAOI,0BAAA;ExE+1eV;EwEt2eM;IAOI,wBAAA;ExEk2eV;EwEz2eM;IAOI,2BAAA;IAAA,0BAAA;ExEs2eV;EwE72eM;IAOI,iCAAA;IAAA,gCAAA;ExE02eV;EwEj3eM;IAOI,gCAAA;IAAA,+BAAA;ExE82eV;EwEr3eM;IAOI,8BAAA;IAAA,6BAAA;ExEk3eV;EwEz3eM;IAOI,gCAAA;IAAA,+BAAA;ExEs3eV;EwE73eM;IAOI,8BAAA;IAAA,6BAAA;ExE03eV;EwEj4eM;IAOI,yBAAA;IAAA,4BAAA;ExE83eV;EwEr4eM;IAOI,+BAAA;IAAA,kCAAA;ExEk4eV;EwEz4eM;IAOI,8BAAA;IAAA,iCAAA;ExEs4eV;EwE74eM;IAOI,4BAAA;IAAA,+BAAA;ExE04eV;EwEj5eM;IAOI,8BAAA;IAAA,iCAAA;ExE84eV;EwEr5eM;IAOI,4BAAA;IAAA,+BAAA;ExEk5eV;EwEz5eM;IAOI,yBAAA;ExEq5eV;EwE55eM;IAOI,+BAAA;ExEw5eV;EwE/5eM;IAOI,8BAAA;ExE25eV;EwEl6eM;IAOI,4BAAA;ExE85eV;EwEr6eM;IAOI,8BAAA;ExEi6eV;EwEx6eM;IAOI,4BAAA;ExEo6eV;EwE36eM;IAOI,2BAAA;ExEu6eV;EwE96eM;IAOI,iCAAA;ExE06eV;EwEj7eM;IAOI,gCAAA;ExE66eV;EwEp7eM;IAOI,8BAAA;ExEg7eV;EwEv7eM;IAOI,gCAAA;ExEm7eV;EwE17eM;IAOI,8BAAA;ExEs7eV;EwE77eM;IAOI,4BAAA;ExEy7eV;EwEh8eM;IAOI,kCAAA;ExE47eV;EwEn8eM;IAOI,iCAAA;ExE+7eV;EwEt8eM;IAOI,+BAAA;ExEk8eV;EwEz8eM;IAOI,iCAAA;ExEq8eV;EwE58eM;IAOI,+BAAA;ExEw8eV;EwE/8eM;IAOI,0BAAA;ExE28eV;EwEl9eM;IAOI,gCAAA;ExE88eV;EwEr9eM;IAOI,+BAAA;ExEi9eV;EwEx9eM;IAOI,6BAAA;ExEo9eV;EwE39eM;IAOI,+BAAA;ExEu9eV;EwE99eM;IAOI,6BAAA;ExE09eV;AACF;AyE9/eA;ED4BQ;IAOI,0BAAA;ExE+9eV;EwEt+eM;IAOI,gCAAA;ExEk+eV;EwEz+eM;IAOI,yBAAA;ExEq+eV;EwE5+eM;IAOI,wBAAA;ExEw+eV;EwE/+eM;IAOI,+BAAA;ExE2+eV;EwEl/eM;IAOI,yBAAA;ExE8+eV;EwEr/eM;IAOI,6BAAA;ExEi/eV;EwEx/eM;IAOI,8BAAA;ExEo/eV;EwE3/eM;IAOI,wBAAA;ExEu/eV;EwE9/eM;IAOI,+BAAA;ExE0/eV;EwEjgfM;IAOI,wBAAA;ExE6/eV;AACF;ACtkfE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,2CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFqkfF;;AIrrfI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;AFqkfJ;;AuD1vfE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvD6vfJ;;A2DhwfE;EACE,sBAAA;EACA,kDAAA;EAAA,iFAAA;A3DmwfJ;;A2DrwfE;EACE,sBAAA;EACA,mDAAA;EAAA,mFAAA;A3DwwfJ;;A2D1wfE;EACE,sBAAA;EACA,iDAAA;EAAA,iFAAA;A3D6wfJ;;A2D/wfE;EACE,sBAAA;EACA,kDAAA;EAAA,8EAAA;A3DkxfJ;;A2DpxfE;EACE,sBAAA;EACA,iDAAA;EAAA,iFAAA;A3DuxfJ;;A2DzxfE;EACE,sBAAA;EACA,iDAAA;EAAA,gFAAA;A3D4xfJ;;A2D9xfE;EACE,sBAAA;EACA,mDAAA;EAAA,+EAAA;A3DiyfJ;;A2DnyfE;EACE,sBAAA;EACA,gDAAA;EAAA,8EAAA;A3DsyfJ;;A4DxyfE;EACE,uCAAA;EAAA,wEAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,0GAAA;UAAA,kGAAA;A5D2yfJ;A4DxyfM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5DwyfR;;A4DjzfE;EACE,wCAAA;EAAA,0EAAA;EACA,gEAAA;UAAA,wDAAA;EAAA,4GAAA;UAAA,oGAAA;A5DozfJ;A4DjzfM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5DizfR;;A4D1zfE;EACE,sCAAA;EAAA,wEAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,0GAAA;UAAA,kGAAA;A5D6zfJ;A4D1zfM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5D0zfR;;A4Dn0fE;EACE,uCAAA;EAAA,qEAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,uGAAA;UAAA,+FAAA;A5Ds0fJ;A4Dn0fM;EAGE,uCAAA;EAAA,+DAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,iGAAA;UAAA,yFAAA;A5Dm0fR;;A4D50fE;EACE,sCAAA;EAAA,wEAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,0GAAA;UAAA,kGAAA;A5D+0fJ;A4D50fM;EAGE,uCAAA;EAAA,+DAAA;EACA,+DAAA;UAAA,uDAAA;EAAA,iGAAA;UAAA,yFAAA;A5D40fR;;A4Dr1fE;EACE,sCAAA;EAAA,uEAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,yGAAA;UAAA,iGAAA;A5Dw1fJ;A4Dr1fM;EAGE,sCAAA;EAAA,8DAAA;EACA,8DAAA;UAAA,sDAAA;EAAA,gGAAA;UAAA,wFAAA;A5Dq1fR;;A4D91fE;EACE,wCAAA;EAAA,sEAAA;EACA,gEAAA;UAAA,wDAAA;EAAA,wGAAA;UAAA,gGAAA;A5Di2fJ;A4D91fM;EAGE,wCAAA;EAAA,gEAAA;EACA,gEAAA;UAAA,wDAAA;EAAA,kGAAA;UAAA,0FAAA;A5D81fR;;A4Dv2fE;EACE,qCAAA;EAAA,qEAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,uGAAA;UAAA,+FAAA;A5D02fJ;A4Dv2fM;EAGE,qCAAA;EAAA,6DAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,+FAAA;UAAA,uFAAA;A5Du2fR;;A4Dh2fA;EACE,kCAAA;EAAA,+EAAA;EACA,0DAAA;UAAA,kDAAA;EAAA,iHAAA;UAAA,yGAAA;A5Dm2fF;A4Dh2fI;EAEE,qCAAA;EAAA,kFAAA;EACA,6DAAA;UAAA,qDAAA;EAAA,oHAAA;UAAA,4GAAA;A5Di2fN;;A6D33fA;EACE,UAAA;EAEA,kDAAA;EAAA,kJAAA;A7D63fF;;A8Dh4fA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,sDAAA;UAAA,8CAAA;EAAA,0FAAA;UAAA,kFAAA;EACA,6BxD2c4B;EwD1c5B,mCAAA;UAAA,2BAAA;A9Dm4fF;A8Dj4fE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A9Dm4fJ;AsB53fM;EwCZJ;IxCaM,gBAAA;EtB+3fN;AACF;;A8Dj4fI;EACE,oCAAA;EAAA,mEAAA;A9Do4fN;;A+Dv5fA;EACE,kBAAA;EACA,WAAA;A/D05fF;A+Dx5fE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A/D05fJ;A+Dv5fE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/Dy5fJ;;A+Dp5fE;EACE,uBAAA;A/Du5fJ;;A+Dx5fE;EACE,sBAAA;A/D25fJ;;A+D55fE;EACE,yBAAA;A/D+5fJ;;A+Dh6fE;EACE,iCAAA;A/Dm6fJ;;AgEx7fA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;ANo1dpC;;AgEx7fA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;AN41dpC;;AgEn7fI;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,a1DmlC8B;ANm2dpC;;AgEn7fI;EACE,wBAAA;EAAA,gBAAA;EACA,SAAA;EACA,a1D6kC8B;ANy2dpC;;Acv5fI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENg3dlC;EgEh8fE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENq3dlC;AACF;Acp6fI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN43dlC;EgE58fE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENi4dlC;AACF;Ach7fI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENw4dlC;EgEx9fE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN64dlC;AACF;Ac57fI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENo5dlC;EgEp+fE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENy5dlC;AACF;Acx8fI;EkDxCA;IACE,wBAAA;IAAA,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENg6dlC;EgEh/fE;IACE,wBAAA;IAAA,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENq6dlC;AACF;AiElhgBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjEohgBF;;AiEjhgBA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjEohgBF;;AkE5hgBA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnE6hgBF;AmE1hgBE;;EACE,6BAAA;AnE6hgBJ;AmEzhgBE;;EACE,2BAAA;AnE4hgBJ;;AoE/igBE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ApEkjgBJ;;AqE1jgBA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtE8jgBF;;AuEpkgBA;EACE,qBAAA;EACA,mBAAA;EACA,UjEisB4B;EiEjsB5B,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;AN44e9B;;AwE3ggBQ;EAOI,mCAAA;AxEwggBZ;;AwE/ggBQ;EAOI,8BAAA;AxE4ggBZ;;AwEnhgBQ;EAOI,iCAAA;AxEghgBZ;;AwEvhgBQ;EAOI,iCAAA;AxEohgBZ;;AwE3hgBQ;EAOI,sCAAA;AxEwhgBZ;;AwE/hgBQ;EAOI,mCAAA;AxE4hgBZ;;AwEnigBQ;EAOI,sBAAA;AxEgigBZ;;AwEvigBQ;EAOI,uBAAA;AxEoigBZ;;AwE3igBQ;EAOI,sBAAA;AxEwigBZ;;AwE/igBQ;EAOI,8BAAA;AxE4igBZ;;AwEnjgBQ;EAOI,4BAAA;AxEgjgBZ;;AwEvjgBQ;EAOI,2BAAA;AxEojgBZ;;AwE3jgBQ;EAOI,iCAAA;AxEwjgBZ;;AwE/jgBQ;EAOI,2BAAA;AxE4jgBZ;;AwEnkgBQ;EAOI,qBAAA;AxEgkgBZ;;AwEvkgBQ;EAOI,wBAAA;AxEokgBZ;;AwE3kgBQ;EAOI,uBAAA;AxEwkgBZ;;AwE/kgBQ;EAOI,wBAAA;AxE4kgBZ;;AwEnlgBQ;EAOI,qBAAA;AxEglgBZ;;AwEvlgBQ;EAOI,yBAAA;AxEolgBZ;;AwE3lgBQ;EAOI,2BAAA;AxEwlgBZ;;AwE/lgBQ;EAOI,4BAAA;AxE4lgBZ;;AwEnmgBQ;EAOI,2BAAA;AxEgmgBZ;;AwEvmgBQ;EAOI,2BAAA;AxEomgBZ;;AwE3mgBQ;EAOI,6BAAA;AxEwmgBZ;;AwE/mgBQ;EAOI,8BAAA;AxE4mgBZ;;AwEnngBQ;EAOI,6BAAA;AxEgngBZ;;AwEvngBQ;EAOI,2BAAA;AxEongBZ;;AwE3ngBQ;EAOI,6BAAA;AxEwngBZ;;AwE/ngBQ;EAOI,8BAAA;AxE4ngBZ;;AwEnogBQ;EAOI,6BAAA;AxEgogBZ;;AwEvogBQ;EAOI,0BAAA;AxEoogBZ;;AwE3ogBQ;EAOI,gCAAA;AxEwogBZ;;AwE/ogBQ;EAOI,yBAAA;AxE4ogBZ;;AwEnpgBQ;EAOI,wBAAA;AxEgpgBZ;;AwEvpgBQ;EAOI,+BAAA;AxEopgBZ;;AwE3pgBQ;EAOI,yBAAA;AxEwpgBZ;;AwE/pgBQ;EAOI,6BAAA;AxE4pgBZ;;AwEnqgBQ;EAOI,8BAAA;AxEgqgBZ;;AwEvqgBQ;EAOI,wBAAA;AxEoqgBZ;;AwE3qgBQ;EAOI,+BAAA;AxEwqgBZ;;AwE/qgBQ;EAOI,wBAAA;AxE4qgBZ;;AwEnrgBQ;EAOI,wDAAA;EAAA,2CAAA;AxEgrgBZ;;AwEvrgBQ;EAOI,8DAAA;EAAA,8CAAA;AxEorgBZ;;AwE3rgBQ;EAOI,uDAAA;EAAA,8CAAA;AxEwrgBZ;;AwE/rgBQ;EAOI,2BAAA;AxE4rgBZ;;AwE7sgBQ;EACE,gFAAA;AxEgtgBV;;AwEjtgBQ;EACE,kFAAA;AxEotgBV;;AwErtgBQ;EACE,gFAAA;AxEwtgBV;;AwEztgBQ;EACE,6EAAA;AxE4tgBV;;AwE7tgBQ;EACE,gFAAA;AxEgugBV;;AwEjugBQ;EACE,+EAAA;AxEougBV;;AwErugBQ;EACE,8EAAA;AxEwugBV;;AwEzugBQ;EACE,6EAAA;AxE4ugBV;;AwEnugBQ;EAOI,2BAAA;AxEgugBZ;;AwEvugBQ;EAOI,6BAAA;AxEougBZ;;AwE3ugBQ;EAOI,6BAAA;AxEwugBZ;;AwE/ugBQ;EAOI,0BAAA;AxE4ugBZ;;AwEnvgBQ;EAOI,mCAAA;EAAA,2BAAA;AxEgvgBZ;;AwEvvgBQ;EAOI,iBAAA;AxEovgBZ;;AwE3vgBQ;EAOI,mBAAA;AxEwvgBZ;;AwE/vgBQ;EAOI,oBAAA;AxE4vgBZ;;AwEnwgBQ;EAOI,oBAAA;AxEgwgBZ;;AwEvwgBQ;EAOI,sBAAA;AxEowgBZ;;AwE3wgBQ;EAOI,uBAAA;AxEwwgBZ;;AwE/wgBQ;EAOI,kBAAA;AxE4wgBZ;;AwEnxgBQ;EAOI,oBAAA;AxEgxgBZ;;AwEvxgBQ;EAOI,qBAAA;AxEoxgBZ;;AwE3xgBQ;EAOI,mBAAA;AxEwxgBZ;;AwE/xgBQ;EAOI,qBAAA;AxE4xgBZ;;AwEnygBQ;EAOI,sBAAA;AxEgygBZ;;AwEvygBQ;EAOI,2CAAA;AxEoygBZ;;AwE3ygBQ;EAOI,sCAAA;AxEwygBZ;;AwE/ygBQ;EAOI,sCAAA;AxE4ygBZ;;AwEnzgBQ;EAOI,oCAAA;EAAA,uFAAA;AxEgzgBZ;;AwEvzgBQ;EAOI,oBAAA;AxEozgBZ;;AwE3zgBQ;EAOI,wCAAA;EAAA,2FAAA;AxEwzgBZ;;AwE/zgBQ;EAOI,wBAAA;AxE4zgBZ;;AwEn0gBQ;EAOI,0CAAA;EAAA,6FAAA;AxEg0gBZ;;AwEv0gBQ;EAOI,0BAAA;AxEo0gBZ;;AwE30gBQ;EAOI,2CAAA;EAAA,8FAAA;AxEw0gBZ;;AwE/0gBQ;EAOI,2BAAA;AxE40gBZ;;AwEn1gBQ;EAOI,yCAAA;EAAA,4FAAA;AxEg1gBZ;;AwEv1gBQ;EAOI,yBAAA;AxEo1gBZ;;AwE31gBQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,8EAAA;AxEy1gBZ;;AwEh2gBQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,gFAAA;AxE81gBZ;;AwEr2gBQ;EAIQ,sBAAA;EAGJ,oEAAA;EAAA,8EAAA;AxEm2gBZ;;AwE12gBQ;EAIQ,sBAAA;EAGJ,qEAAA;EAAA,2EAAA;AxEw2gBZ;;AwE/2gBQ;EAIQ,sBAAA;EAGJ,oEAAA;EAAA,8EAAA;AxE62gBZ;;AwEp3gBQ;EAIQ,sBAAA;EAGJ,oEAAA;EAAA,6EAAA;AxEk3gBZ;;AwEz3gBQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxEu3gBZ;;AwE93gBQ;EAIQ,sBAAA;EAGJ,mEAAA;EAAA,2EAAA;AxE43gBZ;;AwEn4gBQ;EAIQ,sBAAA;EAGJ,gEAAA;EAAA,4EAAA;AxEi4gBZ;;AwEx4gBQ;EAIQ,sBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxEs4gBZ;;AwE74gBQ;EAOI,+CAAA;EAAA,wDAAA;AxE04gBZ;;AwEj5gBQ;EAOI,+CAAA;EAAA,0DAAA;AxE84gBZ;;AwEr5gBQ;EAOI,6CAAA;EAAA,wDAAA;AxEk5gBZ;;AwEz5gBQ;EAOI,+CAAA;EAAA,qDAAA;AxEs5gBZ;;AwE75gBQ;EAOI,+CAAA;EAAA,wDAAA;AxE05gBZ;;AwEj6gBQ;EAOI,+CAAA;EAAA,uDAAA;AxE85gBZ;;AwEr6gBQ;EAOI,gCAAA;EAAA,sDAAA;AxEk6gBZ;;AwEz6gBQ;EAOI,gCAAA;EAAA,qDAAA;AxEs6gBZ;;AwE76gBQ;EAOI,4BAAA;AxE06gBZ;;AwEj7gBQ;EAOI,4BAAA;AxE86gBZ;;AwEr7gBQ;EAOI,4BAAA;AxEk7gBZ;;AwEz7gBQ;EAOI,4BAAA;AxEs7gBZ;;AwE77gBQ;EAOI,4BAAA;AxE07gBZ;;AwE38gBQ;EACE,wBAAA;AxE88gBV;;AwE/8gBQ;EACE,yBAAA;AxEk9gBV;;AwEn9gBQ;EACE,wBAAA;AxEs9gBV;;AwEv9gBQ;EACE,yBAAA;AxE09gBV;;AwE39gBQ;EACE,sBAAA;AxE89gBV;;AwEr9gBQ;EAOI,qBAAA;AxEk9gBZ;;AwEz9gBQ;EAOI,qBAAA;AxEs9gBZ;;AwE79gBQ;EAOI,qBAAA;AxE09gBZ;;AwEj+gBQ;EAOI,sBAAA;AxE89gBZ;;AwEr+gBQ;EAOI,sBAAA;AxEk+gBZ;;AwEz+gBQ;EAOI,0BAAA;AxEs+gBZ;;AwE7+gBQ;EAOI,uBAAA;AxE0+gBZ;;AwEj/gBQ;EAOI,2BAAA;AxE8+gBZ;;AwEr/gBQ;EAOI,sBAAA;AxEk/gBZ;;AwEz/gBQ;EAOI,sBAAA;AxEs/gBZ;;AwE7/gBQ;EAOI,sBAAA;AxE0/gBZ;;AwEjghBQ;EAOI,uBAAA;AxE8/gBZ;;AwErghBQ;EAOI,uBAAA;AxEkghBZ;;AwEzghBQ;EAOI,2BAAA;AxEsghBZ;;AwE7ghBQ;EAOI,wBAAA;AxE0ghBZ;;AwEjhhBQ;EAOI,4BAAA;AxE8ghBZ;;AwErhhBQ;EAOI,yBAAA;AxEkhhBZ;;AwEzhhBQ;EAOI,8BAAA;AxEshhBZ;;AwE7hhBQ;EAOI,iCAAA;AxE0hhBZ;;AwEjihBQ;EAOI,sCAAA;AxE8hhBZ;;AwErihBQ;EAOI,yCAAA;AxEkihBZ;;AwEzihBQ;EAOI,uBAAA;AxEsihBZ;;AwE7ihBQ;EAOI,uBAAA;AxE0ihBZ;;AwEjjhBQ;EAOI,yBAAA;AxE8ihBZ;;AwErjhBQ;EAOI,yBAAA;AxEkjhBZ;;AwEzjhBQ;EAOI,0BAAA;AxEsjhBZ;;AwE7jhBQ;EAOI,4BAAA;AxE0jhBZ;;AwEjkhBQ;EAOI,kCAAA;AxE8jhBZ;;AwErkhBQ;EAOI,sCAAA;AxEkkhBZ;;AwEzkhBQ;EAOI,oCAAA;AxEskhBZ;;AwE7khBQ;EAOI,kCAAA;AxE0khBZ;;AwEjlhBQ;EAOI,yCAAA;AxE8khBZ;;AwErlhBQ;EAOI,wCAAA;AxEklhBZ;;AwEzlhBQ;EAOI,wCAAA;AxEslhBZ;;AwE7lhBQ;EAOI,kCAAA;AxE0lhBZ;;AwEjmhBQ;EAOI,gCAAA;AxE8lhBZ;;AwErmhBQ;EAOI,8BAAA;AxEkmhBZ;;AwEzmhBQ;EAOI,gCAAA;AxEsmhBZ;;AwE7mhBQ;EAOI,+BAAA;AxE0mhBZ;;AwEjnhBQ;EAOI,oCAAA;AxE8mhBZ;;AwErnhBQ;EAOI,kCAAA;AxEknhBZ;;AwEznhBQ;EAOI,gCAAA;AxEsnhBZ;;AwE7nhBQ;EAOI,uCAAA;AxE0nhBZ;;AwEjohBQ;EAOI,sCAAA;AxE8nhBZ;;AwErohBQ;EAOI,iCAAA;AxEkohBZ;;AwEzohBQ;EAOI,2BAAA;AxEsohBZ;;AwE7ohBQ;EAOI,iCAAA;AxE0ohBZ;;AwEjphBQ;EAOI,+BAAA;AxE8ohBZ;;AwErphBQ;EAOI,6BAAA;AxEkphBZ;;AwEzphBQ;EAOI,+BAAA;AxEsphBZ;;AwE7phBQ;EAOI,8BAAA;AxE0phBZ;;AwEjqhBQ;EAOI,oBAAA;AxE8phBZ;;AwErqhBQ;EAOI,mBAAA;AxEkqhBZ;;AwEzqhBQ;EAOI,mBAAA;AxEsqhBZ;;AwE7qhBQ;EAOI,mBAAA;AxE0qhBZ;;AwEjrhBQ;EAOI,mBAAA;AxE8qhBZ;;AwErrhBQ;EAOI,mBAAA;AxEkrhBZ;;AwEzrhBQ;EAOI,mBAAA;AxEsrhBZ;;AwE7rhBQ;EAOI,mBAAA;AxE0rhBZ;;AwEjshBQ;EAOI,oBAAA;AxE8rhBZ;;AwErshBQ;EAOI,0BAAA;AxEkshBZ;;AwEzshBQ;EAOI,yBAAA;AxEsshBZ;;AwE7shBQ;EAOI,uBAAA;AxE0shBZ;;AwEjthBQ;EAOI,yBAAA;AxE8shBZ;;AwErthBQ;EAOI,uBAAA;AxEkthBZ;;AwEzthBQ;EAOI,uBAAA;AxEsthBZ;;AwE7thBQ;EAOI,0BAAA;EAAA,yBAAA;AxE2thBZ;;AwEluhBQ;EAOI,gCAAA;EAAA,+BAAA;AxEguhBZ;;AwEvuhBQ;EAOI,+BAAA;EAAA,8BAAA;AxEquhBZ;;AwE5uhBQ;EAOI,6BAAA;EAAA,4BAAA;AxE0uhBZ;;AwEjvhBQ;EAOI,+BAAA;EAAA,8BAAA;AxE+uhBZ;;AwEtvhBQ;EAOI,6BAAA;EAAA,4BAAA;AxEovhBZ;;AwE3vhBQ;EAOI,6BAAA;EAAA,4BAAA;AxEyvhBZ;;AwEhwhBQ;EAOI,wBAAA;EAAA,2BAAA;AxE8vhBZ;;AwErwhBQ;EAOI,8BAAA;EAAA,iCAAA;AxEmwhBZ;;AwE1whBQ;EAOI,6BAAA;EAAA,gCAAA;AxEwwhBZ;;AwE/whBQ;EAOI,2BAAA;EAAA,8BAAA;AxE6whBZ;;AwEpxhBQ;EAOI,6BAAA;EAAA,gCAAA;AxEkxhBZ;;AwEzxhBQ;EAOI,2BAAA;EAAA,8BAAA;AxEuxhBZ;;AwE9xhBQ;EAOI,2BAAA;EAAA,8BAAA;AxE4xhBZ;;AwEnyhBQ;EAOI,wBAAA;AxEgyhBZ;;AwEvyhBQ;EAOI,8BAAA;AxEoyhBZ;;AwE3yhBQ;EAOI,6BAAA;AxEwyhBZ;;AwE/yhBQ;EAOI,2BAAA;AxE4yhBZ;;AwEnzhBQ;EAOI,6BAAA;AxEgzhBZ;;AwEvzhBQ;EAOI,2BAAA;AxEozhBZ;;AwE3zhBQ;EAOI,2BAAA;AxEwzhBZ;;AwE/zhBQ;EAOI,0BAAA;AxE4zhBZ;;AwEn0hBQ;EAOI,gCAAA;AxEg0hBZ;;AwEv0hBQ;EAOI,+BAAA;AxEo0hBZ;;AwE30hBQ;EAOI,6BAAA;AxEw0hBZ;;AwE/0hBQ;EAOI,+BAAA;AxE40hBZ;;AwEn1hBQ;EAOI,6BAAA;AxEg1hBZ;;AwEv1hBQ;EAOI,6BAAA;AxEo1hBZ;;AwE31hBQ;EAOI,2BAAA;AxEw1hBZ;;AwE/1hBQ;EAOI,iCAAA;AxE41hBZ;;AwEn2hBQ;EAOI,gCAAA;AxEg2hBZ;;AwEv2hBQ;EAOI,8BAAA;AxEo2hBZ;;AwE32hBQ;EAOI,gCAAA;AxEw2hBZ;;AwE/2hBQ;EAOI,8BAAA;AxE42hBZ;;AwEn3hBQ;EAOI,8BAAA;AxEg3hBZ;;AwEv3hBQ;EAOI,yBAAA;AxEo3hBZ;;AwE33hBQ;EAOI,+BAAA;AxEw3hBZ;;AwE/3hBQ;EAOI,8BAAA;AxE43hBZ;;AwEn4hBQ;EAOI,4BAAA;AxEg4hBZ;;AwEv4hBQ;EAOI,8BAAA;AxEo4hBZ;;AwE34hBQ;EAOI,4BAAA;AxEw4hBZ;;AwE/4hBQ;EAOI,4BAAA;AxE44hBZ;;AwEn5hBQ;EAOI,qBAAA;AxEg5hBZ;;AwEv5hBQ;EAOI,2BAAA;AxEo5hBZ;;AwE35hBQ;EAOI,0BAAA;AxEw5hBZ;;AwE/5hBQ;EAOI,wBAAA;AxE45hBZ;;AwEn6hBQ;EAOI,0BAAA;AxEg6hBZ;;AwEv6hBQ;EAOI,wBAAA;AxEo6hBZ;;AwE36hBQ;EAOI,2BAAA;EAAA,0BAAA;AxEy6hBZ;;AwEh7hBQ;EAOI,iCAAA;EAAA,gCAAA;AxE86hBZ;;AwEr7hBQ;EAOI,gCAAA;EAAA,+BAAA;AxEm7hBZ;;AwE17hBQ;EAOI,8BAAA;EAAA,6BAAA;AxEw7hBZ;;AwE/7hBQ;EAOI,gCAAA;EAAA,+BAAA;AxE67hBZ;;AwEp8hBQ;EAOI,8BAAA;EAAA,6BAAA;AxEk8hBZ;;AwEz8hBQ;EAOI,yBAAA;EAAA,4BAAA;AxEu8hBZ;;AwE98hBQ;EAOI,+BAAA;EAAA,kCAAA;AxE48hBZ;;AwEn9hBQ;EAOI,8BAAA;EAAA,iCAAA;AxEi9hBZ;;AwEx9hBQ;EAOI,4BAAA;EAAA,+BAAA;AxEs9hBZ;;AwE79hBQ;EAOI,8BAAA;EAAA,iCAAA;AxE29hBZ;;AwEl+hBQ;EAOI,4BAAA;EAAA,+BAAA;AxEg+hBZ;;AwEv+hBQ;EAOI,yBAAA;AxEo+hBZ;;AwE3+hBQ;EAOI,+BAAA;AxEw+hBZ;;AwE/+hBQ;EAOI,8BAAA;AxE4+hBZ;;AwEn/hBQ;EAOI,4BAAA;AxEg/hBZ;;AwEv/hBQ;EAOI,8BAAA;AxEo/hBZ;;AwE3/hBQ;EAOI,4BAAA;AxEw/hBZ;;AwE//hBQ;EAOI,2BAAA;AxE4/hBZ;;AwEngiBQ;EAOI,iCAAA;AxEggiBZ;;AwEvgiBQ;EAOI,gCAAA;AxEogiBZ;;AwE3giBQ;EAOI,8BAAA;AxEwgiBZ;;AwE/giBQ;EAOI,gCAAA;AxE4giBZ;;AwEnhiBQ;EAOI,8BAAA;AxEghiBZ;;AwEvhiBQ;EAOI,4BAAA;AxEohiBZ;;AwE3hiBQ;EAOI,kCAAA;AxEwhiBZ;;AwE/hiBQ;EAOI,iCAAA;AxE4hiBZ;;AwEniiBQ;EAOI,+BAAA;AxEgiiBZ;;AwEviiBQ;EAOI,iCAAA;AxEoiiBZ;;AwE3iiBQ;EAOI,+BAAA;AxEwiiBZ;;AwE/iiBQ;EAOI,0BAAA;AxE4iiBZ;;AwEnjiBQ;EAOI,gCAAA;AxEgjiBZ;;AwEvjiBQ;EAOI,+BAAA;AxEojiBZ;;AwE3jiBQ;EAOI,6BAAA;AxEwjiBZ;;AwE/jiBQ;EAOI,+BAAA;AxE4jiBZ;;AwEnkiBQ;EAOI,6BAAA;AxEgkiBZ;;AwEvkiBQ;EAOI,iBAAA;AxEokiBZ;;AwE3kiBQ;EAOI,uBAAA;AxEwkiBZ;;AwE/kiBQ;EAOI,sBAAA;AxE4kiBZ;;AwEnliBQ;EAOI,oBAAA;AxEgliBZ;;AwEvliBQ;EAOI,sBAAA;AxEoliBZ;;AwE3liBQ;EAOI,oBAAA;AxEwliBZ;;AwE/liBQ;EAOI,qBAAA;AxE4liBZ;;AwEnmiBQ;EAOI,2BAAA;AxEgmiBZ;;AwEvmiBQ;EAOI,0BAAA;AxEomiBZ;;AwE3miBQ;EAOI,wBAAA;AxEwmiBZ;;AwE/miBQ;EAOI,0BAAA;AxE4miBZ;;AwEnniBQ;EAOI,wBAAA;AxEgniBZ;;AwEvniBQ;EAOI,wBAAA;AxEoniBZ;;AwE3niBQ;EAOI,8BAAA;AxEwniBZ;;AwE/niBQ;EAOI,6BAAA;AxE4niBZ;;AwEnoiBQ;EAOI,2BAAA;AxEgoiBZ;;AwEvoiBQ;EAOI,6BAAA;AxEooiBZ;;AwE3oiBQ;EAOI,2BAAA;AxEwoiBZ;;AwE/oiBQ;EAOI,4GAAA;EAAA,gDAAA;AxE4oiBZ;;AwEnpiBQ;EAOI,4CAAA;AxEgpiBZ;;AwEvpiBQ;EAOI,4CAAA;AxEopiBZ;;AwE3piBQ;EAOI,0CAAA;AxEwpiBZ;;AwE/piBQ;EAOI,4CAAA;AxE4piBZ;;AwEnqiBQ;EAOI,6BAAA;AxEgqiBZ;;AwEvqiBQ;EAOI,0BAAA;AxEoqiBZ;;AwE3qiBQ;EAOI,6BAAA;AxEwqiBZ;;AwE/qiBQ;EAOI,6BAAA;AxE4qiBZ;;AwEnriBQ;EAOI,+BAAA;AxEgriBZ;;AwEvriBQ;EAOI,2BAAA;AxEoriBZ;;AwE3riBQ;EAOI,2BAAA;AxEwriBZ;;AwE/riBQ;EAOI,2BAAA;AxE4riBZ;;AwEnsiBQ;EAOI,2BAAA;AxEgsiBZ;;AwEvsiBQ;EAOI,2BAAA;AxEosiBZ;;AwE3siBQ;EAOI,8BAAA;AxEwsiBZ;;AwE/siBQ;EAOI,yBAAA;AxE4siBZ;;AwEntiBQ;EAOI,4BAAA;AxEgtiBZ;;AwEvtiBQ;EAOI,2BAAA;AxEotiBZ;;AwE3tiBQ;EAOI,yBAAA;AxEwtiBZ;;AwE/tiBQ;EAOI,2BAAA;AxE4tiBZ;;AwEnuiBQ;EAOI,4BAAA;AxEguiBZ;;AwEvuiBQ;EAOI,6BAAA;AxEouiBZ;;AwE3uiBQ;EAOI,gCAAA;AxEwuiBZ;;AwE/uiBQ;EAOI,qCAAA;AxE4uiBZ;;AwEnviBQ;EAOI,wCAAA;AxEgviBZ;;AwEvviBQ;EAOI,oCAAA;AxEoviBZ;;AwE3viBQ;EAOI,oCAAA;AxEwviBZ;;AwE/viBQ;EAOI,qCAAA;AxE4viBZ;;AwEnwiBQ;EAOI,8BAAA;AxEgwiBZ;;AwEvwiBQ;EAOI,8BAAA;AxEowiBZ;;AwEzxiBQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AxE0wiBZ;;AwEvviBQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,qEAAA;AxEgxiBZ;;AwEvxiBQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,uEAAA;AxEqxiBZ;;AwE5xiBQ;EAIQ,oBAAA;EAGJ,2DAAA;EAAA,qEAAA;AxE0xiBZ;;AwEjyiBQ;EAIQ,oBAAA;EAGJ,4DAAA;EAAA,kEAAA;AxE+xiBZ;;AwEtyiBQ;EAIQ,oBAAA;EAGJ,2DAAA;EAAA,qEAAA;AxEoyiBZ;;AwE3yiBQ;EAIQ,oBAAA;EAGJ,2DAAA;EAAA,oEAAA;AxEyyiBZ;;AwEhziBQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,mEAAA;AxE8yiBZ;;AwErziBQ;EAIQ,oBAAA;EAGJ,0DAAA;EAAA,kEAAA;AxEmziBZ;;AwE1ziBQ;EAIQ,oBAAA;EAGJ,uDAAA;EAAA,mEAAA;AxEwziBZ;;AwE/ziBQ;EAIQ,oBAAA;EAGJ,6DAAA;EAAA,mEAAA;AxE6ziBZ;;AwEp0iBQ;EAIQ,oBAAA;EAGJ,0DAAA;EAAA,wEAAA;AxEk0iBZ;;AwEz0iBQ;EAIQ,oBAAA;EAGJ,wCAAA;EAAA,2CAAA;AxEu0iBZ;;AwE90iBQ;EAIQ,oBAAA;EAGJ,oCAAA;AxE40iBZ;;AwEn1iBQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEi1iBZ;;AwEx1iBQ;EAIQ,oBAAA;EAGJ,wCAAA;EAAA,2CAAA;AxEs1iBZ;;AwE71iBQ;EAIQ,oBAAA;EAGJ,uCAAA;EAAA,0CAAA;AxE21iBZ;;AwEl2iBQ;EAIQ,oBAAA;EAGJ,sBAAA;EAAA,0CAAA;AxEg2iBZ;;AwEv2iBQ;EAIQ,oBAAA;EAGJ,yBAAA;AxEq2iBZ;;AwEt3iBQ;EACE,uBAAA;AxEy3iBV;;AwE13iBQ;EACE,sBAAA;AxE63iBV;;AwE93iBQ;EACE,uBAAA;AxEi4iBV;;AwEl4iBQ;EACE,oBAAA;AxEq4iBV;;AwE53iBQ;EAOI,qCAAA;EAAA,iDAAA;AxEy3iBZ;;AwEh4iBQ;EAOI,qCAAA;EAAA,mDAAA;AxE63iBZ;;AwEp4iBQ;EAOI,mCAAA;EAAA,iDAAA;AxEi4iBZ;;AwEx4iBQ;EAOI,oCAAA;EAAA,8CAAA;AxEq4iBZ;;AwE54iBQ;EAOI,qCAAA;EAAA,iDAAA;AxEy4iBZ;;AwEh5iBQ;EAOI,qCAAA;EAAA,gDAAA;AxE64iBZ;;AwEp5iBQ;EAOI,yBAAA;EAAA,+CAAA;AxEi5iBZ;;AwEx5iBQ;EAOI,yBAAA;EAAA,8CAAA;AxEq5iBZ;;AwEt6iBQ;EACE,sBAAA;AxEy6iBV;;AwEr6iBU;EACE,sBAAA;AxEw6iBZ;;AwE96iBQ;EACE,uBAAA;AxEi7iBV;;AwE76iBU;EACE,uBAAA;AxEg7iBZ;;AwEt7iBQ;EACE,sBAAA;AxEy7iBV;;AwEr7iBU;EACE,sBAAA;AxEw7iBZ;;AwE97iBQ;EACE,uBAAA;AxEi8iBV;;AwE77iBU;EACE,uBAAA;AxEg8iBZ;;AwEt8iBQ;EACE,oBAAA;AxEy8iBV;;AwEr8iBU;EACE,oBAAA;AxEw8iBZ;;AwEp8iBQ;EAOI,yCAAA;AxEi8iBZ;;AwE57iBU;EAOI,yCAAA;AxEy7iBd;;AwE58iBQ;EAOI,wCAAA;AxEy8iBZ;;AwEp8iBU;EAOI,wCAAA;AxEi8iBd;;AwEp9iBQ;EAOI,yCAAA;AxEi9iBZ;;AwE58iBU;EAOI,yCAAA;AxEy8iBd;;AwE59iBQ;EAIQ,8BAAA;EAGJ,8FAAA;UAAA,sFAAA;EAAA,uGAAA;UAAA,+FAAA;AxE09iBZ;;AwEj+iBQ;EAIQ,8BAAA;EAGJ,+FAAA;UAAA,uFAAA;EAAA,yGAAA;UAAA,iGAAA;AxE+9iBZ;;AwEt+iBQ;EAIQ,8BAAA;EAGJ,6FAAA;UAAA,qFAAA;EAAA,uGAAA;UAAA,+FAAA;AxEo+iBZ;;AwE3+iBQ;EAIQ,8BAAA;EAGJ,8FAAA;UAAA,sFAAA;EAAA,oGAAA;UAAA,4FAAA;AxEy+iBZ;;AwEh/iBQ;EAIQ,8BAAA;EAGJ,6FAAA;UAAA,qFAAA;EAAA,uGAAA;UAAA,+FAAA;AxE8+iBZ;;AwEr/iBQ;EAIQ,8BAAA;EAGJ,6FAAA;UAAA,qFAAA;EAAA,sGAAA;UAAA,8FAAA;AxEm/iBZ;;AwE1/iBQ;EAIQ,8BAAA;EAGJ,+FAAA;UAAA,uFAAA;EAAA,qGAAA;UAAA,6FAAA;AxEw/iBZ;;AwE//iBQ;EAIQ,8BAAA;EAGJ,4FAAA;UAAA,oFAAA;EAAA,oGAAA;UAAA,4FAAA;AxE6/iBZ;;AwEpgjBQ;EAIQ,8BAAA;EAGJ,+DAAA;UAAA,uDAAA;EAAA,6GAAA;UAAA,qGAAA;AxEkgjBZ;;AwEnhjBQ;EACE,8BAAA;AxEshjBV;;AwElhjBU;EACE,8BAAA;AxEqhjBZ;;AwE3hjBQ;EACE,gCAAA;AxE8hjBV;;AwE1hjBU;EACE,gCAAA;AxE6hjBZ;;AwEnijBQ;EACE,iCAAA;AxEsijBV;;AwElijBU;EACE,iCAAA;AxEqijBZ;;AwE3ijBQ;EACE,gCAAA;AxE8ijBV;;AwE1ijBU;EACE,gCAAA;AxE6ijBZ;;AwEnjjBQ;EACE,iCAAA;AxEsjjBV;;AwEljjBU;EACE,iCAAA;AxEqjjBZ;;AwE3jjBQ;EACE,8BAAA;AxE8jjBV;;AwE1jjBU;EACE,8BAAA;AxE6jjBZ;;AwEzjjBQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,8EAAA;AxEujjBZ;;AwE9jjBQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,gFAAA;AxE4jjBZ;;AwEnkjBQ;EAIQ,kBAAA;EAGJ,oEAAA;EAAA,8EAAA;AxEikjBZ;;AwExkjBQ;EAIQ,kBAAA;EAGJ,qEAAA;EAAA,2EAAA;AxEskjBZ;;AwE7kjBQ;EAIQ,kBAAA;EAGJ,oEAAA;EAAA,8EAAA;AxE2kjBZ;;AwElljBQ;EAIQ,kBAAA;EAGJ,oEAAA;EAAA,6EAAA;AxEgljBZ;;AwEvljBQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxEqljBZ;;AwE5ljBQ;EAIQ,kBAAA;EAGJ,mEAAA;EAAA,2EAAA;AxE0ljBZ;;AwEjmjBQ;EAIQ,kBAAA;EAGJ,gEAAA;EAAA,4EAAA;AxE+ljBZ;;AwEtmjBQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,4EAAA;AxEomjBZ;;AwE3mjBQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,8EAAA;AxEymjBZ;;AwEhnjBQ;EAIQ,kBAAA;EAGJ,wCAAA;AxE8mjBZ;;AwErnjBQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,mFAAA;AxEmnjBZ;;AwE1njBQ;EAIQ,kBAAA;EAGJ,sEAAA;EAAA,kFAAA;AxEwnjBZ;;AwEzojBQ;EACE,oBAAA;AxE4ojBV;;AwE7ojBQ;EACE,qBAAA;AxEgpjBV;;AwEjpjBQ;EACE,oBAAA;AxEopjBV;;AwErpjBQ;EACE,qBAAA;AxEwpjBV;;AwEzpjBQ;EACE,kBAAA;AxE4pjBV;;AwEnpjBQ;EAOI,mDAAA;EAAA,wDAAA;AxEgpjBZ;;AwEvpjBQ;EAOI,mDAAA;EAAA,0DAAA;AxEopjBZ;;AwE3pjBQ;EAOI,iDAAA;EAAA,wDAAA;AxEwpjBZ;;AwE/pjBQ;EAOI,mDAAA;EAAA,qDAAA;AxE4pjBZ;;AwEnqjBQ;EAOI,mDAAA;EAAA,wDAAA;AxEgqjBZ;;AwEvqjBQ;EAOI,mDAAA;EAAA,uDAAA;AxEoqjBZ;;AwE3qjBQ;EAOI,mDAAA;EAAA,sDAAA;AxEwqjBZ;;AwE/qjBQ;EAOI,oCAAA;EAAA,qDAAA;AxE4qjBZ;;AwEnrjBQ;EAOI,uGAAA;EAAA,+CAAA;AxEgrjBZ;;AwEvrjBQ;EAOI,mCAAA;UAAA,2BAAA;AxEorjBZ;;AwE3rjBQ;EAOI,oCAAA;UAAA,4BAAA;AxEwrjBZ;;AwE/rjBQ;EAOI,oCAAA;UAAA,4BAAA;AxE4rjBZ;;AwEnsjBQ;EAOI,+BAAA;AxEgsjBZ;;AwEvsjBQ;EAOI,+BAAA;AxEosjBZ;;AwE3sjBQ;EAOI,kCAAA;EAAA,iDAAA;AxEwsjBZ;;AwE/sjBQ;EAOI,2BAAA;AxE4sjBZ;;AwEntjBQ;EAOI,iCAAA;EAAA,oDAAA;AxEgtjBZ;;AwEvtjBQ;EAOI,kCAAA;EAAA,iDAAA;AxEotjBZ;;AwE3tjBQ;EAOI,gCAAA;EAAA,oDAAA;AxEwtjBZ;;AwE/tjBQ;EAOI,8BAAA;EAAA,oDAAA;AxE4tjBZ;;AwEnujBQ;EAOI,8BAAA;EAAA,qDAAA;AxEgujBZ;;AwEvujBQ;EAOI,6BAAA;AxEoujBZ;;AwE3ujBQ;EAOI,+BAAA;EAAA,sDAAA;AxEwujBZ;;AwE/ujBQ;EAOI,2CAAA;EAAA,0DAAA;EAAA,4CAAA;EAAA,2DAAA;AxE6ujBZ;;AwEpvjBQ;EAOI,oCAAA;EAAA,qCAAA;AxEkvjBZ;;AwEzvjBQ;EAOI,0CAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,8DAAA;AxEuvjBZ;;AwE9vjBQ;EAOI,2CAAA;EAAA,0DAAA;EAAA,4CAAA;EAAA,2DAAA;AxE4vjBZ;;AwEnwjBQ;EAOI,yCAAA;EAAA,6DAAA;EAAA,0CAAA;EAAA,8DAAA;AxEiwjBZ;;AwExwjBQ;EAOI,uCAAA;EAAA,6DAAA;EAAA,wCAAA;EAAA,8DAAA;AxEswjBZ;;AwE7wjBQ;EAOI,uCAAA;EAAA,8DAAA;EAAA,wCAAA;EAAA,+DAAA;AxE2wjBZ;;AwElxjBQ;EAOI,sCAAA;EAAA,uCAAA;AxEgxjBZ;;AwEvxjBQ;EAOI,wCAAA;EAAA,+DAAA;EAAA,yCAAA;EAAA,gEAAA;AxEqxjBZ;;AwE5xjBQ;EAOI,4CAAA;EAAA,2DAAA;EAAA,+CAAA;EAAA,8DAAA;AxE0xjBZ;;AwEjyjBQ;EAOI,qCAAA;EAAA,wCAAA;AxE+xjBZ;;AwEtyjBQ;EAOI,2CAAA;EAAA,8DAAA;EAAA,8CAAA;EAAA,iEAAA;AxEoyjBZ;;AwE3yjBQ;EAOI,4CAAA;EAAA,2DAAA;EAAA,+CAAA;EAAA,8DAAA;AxEyyjBZ;;AwEhzjBQ;EAOI,0CAAA;EAAA,8DAAA;EAAA,6CAAA;EAAA,iEAAA;AxE8yjBZ;;AwErzjBQ;EAOI,wCAAA;EAAA,8DAAA;EAAA,2CAAA;EAAA,iEAAA;AxEmzjBZ;;AwE1zjBQ;EAOI,wCAAA;EAAA,+DAAA;EAAA,2CAAA;EAAA,kEAAA;AxEwzjBZ;;AwE/zjBQ;EAOI,uCAAA;EAAA,0CAAA;AxE6zjBZ;;AwEp0jBQ;EAOI,yCAAA;EAAA,gEAAA;EAAA,4CAAA;EAAA,mEAAA;AxEk0jBZ;;AwEz0jBQ;EAOI,+CAAA;EAAA,8DAAA;EAAA,8CAAA;EAAA,6DAAA;AxEu0jBZ;;AwE90jBQ;EAOI,wCAAA;EAAA,uCAAA;AxE40jBZ;;AwEn1jBQ;EAOI,8CAAA;EAAA,iEAAA;EAAA,6CAAA;EAAA,gEAAA;AxEi1jBZ;;AwEx1jBQ;EAOI,+CAAA;EAAA,8DAAA;EAAA,8CAAA;EAAA,6DAAA;AxEs1jBZ;;AwE71jBQ;EAOI,6CAAA;EAAA,iEAAA;EAAA,4CAAA;EAAA,gEAAA;AxE21jBZ;;AwEl2jBQ;EAOI,2CAAA;EAAA,iEAAA;EAAA,0CAAA;EAAA,gEAAA;AxEg2jBZ;;AwEv2jBQ;EAOI,2CAAA;EAAA,kEAAA;EAAA,0CAAA;EAAA,iEAAA;AxEq2jBZ;;AwE52jBQ;EAOI,0CAAA;EAAA,yCAAA;AxE02jBZ;;AwEj3jBQ;EAOI,4CAAA;EAAA,mEAAA;EAAA,2CAAA;EAAA,kEAAA;AxE+2jBZ;;AwEt3jBQ;EAOI,8CAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,0DAAA;AxEo3jBZ;;AwE33jBQ;EAOI,uCAAA;EAAA,oCAAA;AxEy3jBZ;;AwEh4jBQ;EAOI,6CAAA;EAAA,gEAAA;EAAA,0CAAA;EAAA,6DAAA;AxE83jBZ;;AwEr4jBQ;EAOI,8CAAA;EAAA,6DAAA;EAAA,2CAAA;EAAA,0DAAA;AxEm4jBZ;;AwE14jBQ;EAOI,4CAAA;EAAA,gEAAA;EAAA,yCAAA;EAAA,6DAAA;AxEw4jBZ;;AwE/4jBQ;EAOI,0CAAA;EAAA,gEAAA;EAAA,uCAAA;EAAA,6DAAA;AxE64jBZ;;AwEp5jBQ;EAOI,0CAAA;EAAA,iEAAA;EAAA,uCAAA;EAAA,8DAAA;AxEk5jBZ;;AwEz5jBQ;EAOI,yCAAA;EAAA,sCAAA;AxEu5jBZ;;AwE95jBQ;EAOI,2CAAA;EAAA,kEAAA;EAAA,wCAAA;EAAA,+DAAA;AxE45jBZ;;AwEn6jBQ;EAOI,8BAAA;AxEg6jBZ;;AwEv6jBQ;EAOI,6BAAA;AxEo6jBZ;;AwE36jBQ;EAOI,sBAAA;AxEw6jBZ;;AwE/6jBQ;EAOI,qBAAA;AxE46jBZ;;AwEn7jBQ;EAOI,qBAAA;AxEg7jBZ;;AwEv7jBQ;EAOI,qBAAA;AxEo7jBZ;;AwE37jBQ;EAOI,qBAAA;AxEw7jBZ;;Acl8jBI;E0DGI;IAOI,sBAAA;ExE67jBV;EwEp8jBM;IAOI,uBAAA;ExEg8jBV;EwEv8jBM;IAOI,sBAAA;ExEm8jBV;EwE18jBM;IAOI,8BAAA;ExEs8jBV;EwE78jBM;IAOI,4BAAA;ExEy8jBV;EwEh9jBM;IAOI,2BAAA;ExE48jBV;EwEn9jBM;IAOI,iCAAA;ExE+8jBV;EwEt9jBM;IAOI,2BAAA;ExEk9jBV;EwEz9jBM;IAOI,0BAAA;ExEq9jBV;EwE59jBM;IAOI,gCAAA;ExEw9jBV;EwE/9jBM;IAOI,yBAAA;ExE29jBV;EwEl+jBM;IAOI,wBAAA;ExE89jBV;EwEr+jBM;IAOI,+BAAA;ExEi+jBV;EwEx+jBM;IAOI,yBAAA;ExEo+jBV;EwE3+jBM;IAOI,6BAAA;ExEu+jBV;EwE9+jBM;IAOI,8BAAA;ExE0+jBV;EwEj/jBM;IAOI,wBAAA;ExE6+jBV;EwEp/jBM;IAOI,+BAAA;ExEg/jBV;EwEv/jBM;IAOI,wBAAA;ExEm/jBV;EwE1/jBM;IAOI,yBAAA;ExEs/jBV;EwE7/jBM;IAOI,8BAAA;ExEy/jBV;EwEhgkBM;IAOI,iCAAA;ExE4/jBV;EwEngkBM;IAOI,sCAAA;ExE+/jBV;EwEtgkBM;IAOI,yCAAA;ExEkgkBV;EwEzgkBM;IAOI,uBAAA;ExEqgkBV;EwE5gkBM;IAOI,uBAAA;ExEwgkBV;EwE/gkBM;IAOI,yBAAA;ExE2gkBV;EwElhkBM;IAOI,yBAAA;ExE8gkBV;EwErhkBM;IAOI,0BAAA;ExEihkBV;EwExhkBM;IAOI,4BAAA;ExEohkBV;EwE3hkBM;IAOI,kCAAA;ExEuhkBV;EwE9hkBM;IAOI,sCAAA;ExE0hkBV;EwEjikBM;IAOI,oCAAA;ExE6hkBV;EwEpikBM;IAOI,kCAAA;ExEgikBV;EwEvikBM;IAOI,yCAAA;ExEmikBV;EwE1ikBM;IAOI,wCAAA;ExEsikBV;EwE7ikBM;IAOI,wCAAA;ExEyikBV;EwEhjkBM;IAOI,kCAAA;ExE4ikBV;EwEnjkBM;IAOI,gCAAA;ExE+ikBV;EwEtjkBM;IAOI,8BAAA;ExEkjkBV;EwEzjkBM;IAOI,gCAAA;ExEqjkBV;EwE5jkBM;IAOI,+BAAA;ExEwjkBV;EwE/jkBM;IAOI,oCAAA;ExE2jkBV;EwElkkBM;IAOI,kCAAA;ExE8jkBV;EwErkkBM;IAOI,gCAAA;ExEikkBV;EwExkkBM;IAOI,uCAAA;ExEokkBV;EwE3kkBM;IAOI,sCAAA;ExEukkBV;EwE9kkBM;IAOI,iCAAA;ExE0kkBV;EwEjlkBM;IAOI,2BAAA;ExE6kkBV;EwEplkBM;IAOI,iCAAA;ExEglkBV;EwEvlkBM;IAOI,+BAAA;ExEmlkBV;EwE1lkBM;IAOI,6BAAA;ExEslkBV;EwE7lkBM;IAOI,+BAAA;ExEylkBV;EwEhmkBM;IAOI,8BAAA;ExE4lkBV;EwEnmkBM;IAOI,oBAAA;ExE+lkBV;EwEtmkBM;IAOI,mBAAA;ExEkmkBV;EwEzmkBM;IAOI,mBAAA;ExEqmkBV;EwE5mkBM;IAOI,mBAAA;ExEwmkBV;EwE/mkBM;IAOI,mBAAA;ExE2mkBV;EwElnkBM;IAOI,mBAAA;ExE8mkBV;EwErnkBM;IAOI,mBAAA;ExEinkBV;EwExnkBM;IAOI,mBAAA;ExEonkBV;EwE3nkBM;IAOI,oBAAA;ExEunkBV;EwE9nkBM;IAOI,0BAAA;ExE0nkBV;EwEjokBM;IAOI,yBAAA;ExE6nkBV;EwEpokBM;IAOI,uBAAA;ExEgokBV;EwEvokBM;IAOI,yBAAA;ExEmokBV;EwE1okBM;IAOI,uBAAA;ExEsokBV;EwE7okBM;IAOI,uBAAA;ExEyokBV;EwEhpkBM;IAOI,0BAAA;IAAA,yBAAA;ExE6okBV;EwEppkBM;IAOI,gCAAA;IAAA,+BAAA;ExEipkBV;EwExpkBM;IAOI,+BAAA;IAAA,8BAAA;ExEqpkBV;EwE5pkBM;IAOI,6BAAA;IAAA,4BAAA;ExEypkBV;EwEhqkBM;IAOI,+BAAA;IAAA,8BAAA;ExE6pkBV;EwEpqkBM;IAOI,6BAAA;IAAA,4BAAA;ExEiqkBV;EwExqkBM;IAOI,6BAAA;IAAA,4BAAA;ExEqqkBV;EwE5qkBM;IAOI,wBAAA;IAAA,2BAAA;ExEyqkBV;EwEhrkBM;IAOI,8BAAA;IAAA,iCAAA;ExE6qkBV;EwEprkBM;IAOI,6BAAA;IAAA,gCAAA;ExEirkBV;EwExrkBM;IAOI,2BAAA;IAAA,8BAAA;ExEqrkBV;EwE5rkBM;IAOI,6BAAA;IAAA,gCAAA;ExEyrkBV;EwEhskBM;IAOI,2BAAA;IAAA,8BAAA;ExE6rkBV;EwEpskBM;IAOI,2BAAA;IAAA,8BAAA;ExEiskBV;EwExskBM;IAOI,wBAAA;ExEoskBV;EwE3skBM;IAOI,8BAAA;ExEuskBV;EwE9skBM;IAOI,6BAAA;ExE0skBV;EwEjtkBM;IAOI,2BAAA;ExE6skBV;EwEptkBM;IAOI,6BAAA;ExEgtkBV;EwEvtkBM;IAOI,2BAAA;ExEmtkBV;EwE1tkBM;IAOI,2BAAA;ExEstkBV;EwE7tkBM;IAOI,0BAAA;ExEytkBV;EwEhukBM;IAOI,gCAAA;ExE4tkBV;EwEnukBM;IAOI,+BAAA;ExE+tkBV;EwEtukBM;IAOI,6BAAA;ExEkukBV;EwEzukBM;IAOI,+BAAA;ExEqukBV;EwE5ukBM;IAOI,6BAAA;ExEwukBV;EwE/ukBM;IAOI,6BAAA;ExE2ukBV;EwElvkBM;IAOI,2BAAA;ExE8ukBV;EwErvkBM;IAOI,iCAAA;ExEivkBV;EwExvkBM;IAOI,gCAAA;ExEovkBV;EwE3vkBM;IAOI,8BAAA;ExEuvkBV;EwE9vkBM;IAOI,gCAAA;ExE0vkBV;EwEjwkBM;IAOI,8BAAA;ExE6vkBV;EwEpwkBM;IAOI,8BAAA;ExEgwkBV;EwEvwkBM;IAOI,yBAAA;ExEmwkBV;EwE1wkBM;IAOI,+BAAA;ExEswkBV;EwE7wkBM;IAOI,8BAAA;ExEywkBV;EwEhxkBM;IAOI,4BAAA;ExE4wkBV;EwEnxkBM;IAOI,8BAAA;ExE+wkBV;EwEtxkBM;IAOI,4BAAA;ExEkxkBV;EwEzxkBM;IAOI,4BAAA;ExEqxkBV;EwE5xkBM;IAOI,qBAAA;ExEwxkBV;EwE/xkBM;IAOI,2BAAA;ExE2xkBV;EwElykBM;IAOI,0BAAA;ExE8xkBV;EwErykBM;IAOI,wBAAA;ExEiykBV;EwExykBM;IAOI,0BAAA;ExEoykBV;EwE3ykBM;IAOI,wBAAA;ExEuykBV;EwE9ykBM;IAOI,2BAAA;IAAA,0BAAA;ExE2ykBV;EwElzkBM;IAOI,iCAAA;IAAA,gCAAA;ExE+ykBV;EwEtzkBM;IAOI,gCAAA;IAAA,+BAAA;ExEmzkBV;EwE1zkBM;IAOI,8BAAA;IAAA,6BAAA;ExEuzkBV;EwE9zkBM;IAOI,gCAAA;IAAA,+BAAA;ExE2zkBV;EwEl0kBM;IAOI,8BAAA;IAAA,6BAAA;ExE+zkBV;EwEt0kBM;IAOI,yBAAA;IAAA,4BAAA;ExEm0kBV;EwE10kBM;IAOI,+BAAA;IAAA,kCAAA;ExEu0kBV;EwE90kBM;IAOI,8BAAA;IAAA,iCAAA;ExE20kBV;EwEl1kBM;IAOI,4BAAA;IAAA,+BAAA;ExE+0kBV;EwEt1kBM;IAOI,8BAAA;IAAA,iCAAA;ExEm1kBV;EwE11kBM;IAOI,4BAAA;IAAA,+BAAA;ExEu1kBV;EwE91kBM;IAOI,yBAAA;ExE01kBV;EwEj2kBM;IAOI,+BAAA;ExE61kBV;EwEp2kBM;IAOI,8BAAA;ExEg2kBV;EwEv2kBM;IAOI,4BAAA;ExEm2kBV;EwE12kBM;IAOI,8BAAA;ExEs2kBV;EwE72kBM;IAOI,4BAAA;ExEy2kBV;EwEh3kBM;IAOI,2BAAA;ExE42kBV;EwEn3kBM;IAOI,iCAAA;ExE+2kBV;EwEt3kBM;IAOI,gCAAA;ExEk3kBV;EwEz3kBM;IAOI,8BAAA;ExEq3kBV;EwE53kBM;IAOI,gCAAA;ExEw3kBV;EwE/3kBM;IAOI,8BAAA;ExE23kBV;EwEl4kBM;IAOI,4BAAA;ExE83kBV;EwEr4kBM;IAOI,kCAAA;ExEi4kBV;EwEx4kBM;IAOI,iCAAA;ExEo4kBV;EwE34kBM;IAOI,+BAAA;ExEu4kBV;EwE94kBM;IAOI,iCAAA;ExE04kBV;EwEj5kBM;IAOI,+BAAA;ExE64kBV;EwEp5kBM;IAOI,0BAAA;ExEg5kBV;EwEv5kBM;IAOI,gCAAA;ExEm5kBV;EwE15kBM;IAOI,+BAAA;ExEs5kBV;EwE75kBM;IAOI,6BAAA;ExEy5kBV;EwEh6kBM;IAOI,+BAAA;ExE45kBV;EwEn6kBM;IAOI,6BAAA;ExE+5kBV;EwEt6kBM;IAOI,iBAAA;ExEk6kBV;EwEz6kBM;IAOI,uBAAA;ExEq6kBV;EwE56kBM;IAOI,sBAAA;ExEw6kBV;EwE/6kBM;IAOI,oBAAA;ExE26kBV;EwEl7kBM;IAOI,sBAAA;ExE86kBV;EwEr7kBM;IAOI,oBAAA;ExEi7kBV;EwEx7kBM;IAOI,qBAAA;ExEo7kBV;EwE37kBM;IAOI,2BAAA;ExEu7kBV;EwE97kBM;IAOI,0BAAA;ExE07kBV;EwEj8kBM;IAOI,wBAAA;ExE67kBV;EwEp8kBM;IAOI,0BAAA;ExEg8kBV;EwEv8kBM;IAOI,wBAAA;ExEm8kBV;EwE18kBM;IAOI,wBAAA;ExEs8kBV;EwE78kBM;IAOI,8BAAA;ExEy8kBV;EwEh9kBM;IAOI,6BAAA;ExE48kBV;EwEn9kBM;IAOI,2BAAA;ExE+8kBV;EwEt9kBM;IAOI,6BAAA;ExEk9kBV;EwEz9kBM;IAOI,2BAAA;ExEq9kBV;EwE59kBM;IAOI,2BAAA;ExEw9kBV;EwE/9kBM;IAOI,4BAAA;ExE29kBV;EwEl+kBM;IAOI,6BAAA;ExE89kBV;AACF;Acz+kBI;E0DGI;IAOI,sBAAA;ExEm+kBV;EwE1+kBM;IAOI,uBAAA;ExEs+kBV;EwE7+kBM;IAOI,sBAAA;ExEy+kBV;EwEh/kBM;IAOI,8BAAA;ExE4+kBV;EwEn/kBM;IAOI,4BAAA;ExE++kBV;EwEt/kBM;IAOI,2BAAA;ExEk/kBV;EwEz/kBM;IAOI,iCAAA;ExEq/kBV;EwE5/kBM;IAOI,2BAAA;ExEw/kBV;EwE//kBM;IAOI,0BAAA;ExE2/kBV;EwElglBM;IAOI,gCAAA;ExE8/kBV;EwErglBM;IAOI,yBAAA;ExEiglBV;EwExglBM;IAOI,wBAAA;ExEoglBV;EwE3glBM;IAOI,+BAAA;ExEuglBV;EwE9glBM;IAOI,yBAAA;ExE0glBV;EwEjhlBM;IAOI,6BAAA;ExE6glBV;EwEphlBM;IAOI,8BAAA;ExEghlBV;EwEvhlBM;IAOI,wBAAA;ExEmhlBV;EwE1hlBM;IAOI,+BAAA;ExEshlBV;EwE7hlBM;IAOI,wBAAA;ExEyhlBV;EwEhilBM;IAOI,yBAAA;ExE4hlBV;EwEnilBM;IAOI,8BAAA;ExE+hlBV;EwEtilBM;IAOI,iCAAA;ExEkilBV;EwEzilBM;IAOI,sCAAA;ExEqilBV;EwE5ilBM;IAOI,yCAAA;ExEwilBV;EwE/ilBM;IAOI,uBAAA;ExE2ilBV;EwEljlBM;IAOI,uBAAA;ExE8ilBV;EwErjlBM;IAOI,yBAAA;ExEijlBV;EwExjlBM;IAOI,yBAAA;ExEojlBV;EwE3jlBM;IAOI,0BAAA;ExEujlBV;EwE9jlBM;IAOI,4BAAA;ExE0jlBV;EwEjklBM;IAOI,kCAAA;ExE6jlBV;EwEpklBM;IAOI,sCAAA;ExEgklBV;EwEvklBM;IAOI,oCAAA;ExEmklBV;EwE1klBM;IAOI,kCAAA;ExEsklBV;EwE7klBM;IAOI,yCAAA;ExEyklBV;EwEhllBM;IAOI,wCAAA;ExE4klBV;EwEnllBM;IAOI,wCAAA;ExE+klBV;EwEtllBM;IAOI,kCAAA;ExEkllBV;EwEzllBM;IAOI,gCAAA;ExEqllBV;EwE5llBM;IAOI,8BAAA;ExEwllBV;EwE/llBM;IAOI,gCAAA;ExE2llBV;EwElmlBM;IAOI,+BAAA;ExE8llBV;EwErmlBM;IAOI,oCAAA;ExEimlBV;EwExmlBM;IAOI,kCAAA;ExEomlBV;EwE3mlBM;IAOI,gCAAA;ExEumlBV;EwE9mlBM;IAOI,uCAAA;ExE0mlBV;EwEjnlBM;IAOI,sCAAA;ExE6mlBV;EwEpnlBM;IAOI,iCAAA;ExEgnlBV;EwEvnlBM;IAOI,2BAAA;ExEmnlBV;EwE1nlBM;IAOI,iCAAA;ExEsnlBV;EwE7nlBM;IAOI,+BAAA;ExEynlBV;EwEholBM;IAOI,6BAAA;ExE4nlBV;EwEnolBM;IAOI,+BAAA;ExE+nlBV;EwEtolBM;IAOI,8BAAA;ExEkolBV;EwEzolBM;IAOI,oBAAA;ExEqolBV;EwE5olBM;IAOI,mBAAA;ExEwolBV;EwE/olBM;IAOI,mBAAA;ExE2olBV;EwElplBM;IAOI,mBAAA;ExE8olBV;EwErplBM;IAOI,mBAAA;ExEiplBV;EwExplBM;IAOI,mBAAA;ExEoplBV;EwE3plBM;IAOI,mBAAA;ExEuplBV;EwE9plBM;IAOI,mBAAA;ExE0plBV;EwEjqlBM;IAOI,oBAAA;ExE6plBV;EwEpqlBM;IAOI,0BAAA;ExEgqlBV;EwEvqlBM;IAOI,yBAAA;ExEmqlBV;EwE1qlBM;IAOI,uBAAA;ExEsqlBV;EwE7qlBM;IAOI,yBAAA;ExEyqlBV;EwEhrlBM;IAOI,uBAAA;ExE4qlBV;EwEnrlBM;IAOI,uBAAA;ExE+qlBV;EwEtrlBM;IAOI,0BAAA;IAAA,yBAAA;ExEmrlBV;EwE1rlBM;IAOI,gCAAA;IAAA,+BAAA;ExEurlBV;EwE9rlBM;IAOI,+BAAA;IAAA,8BAAA;ExE2rlBV;EwElslBM;IAOI,6BAAA;IAAA,4BAAA;ExE+rlBV;EwEtslBM;IAOI,+BAAA;IAAA,8BAAA;ExEmslBV;EwE1slBM;IAOI,6BAAA;IAAA,4BAAA;ExEuslBV;EwE9slBM;IAOI,6BAAA;IAAA,4BAAA;ExE2slBV;EwEltlBM;IAOI,wBAAA;IAAA,2BAAA;ExE+slBV;EwEttlBM;IAOI,8BAAA;IAAA,iCAAA;ExEmtlBV;EwE1tlBM;IAOI,6BAAA;IAAA,gCAAA;ExEutlBV;EwE9tlBM;IAOI,2BAAA;IAAA,8BAAA;ExE2tlBV;EwElulBM;IAOI,6BAAA;IAAA,gCAAA;ExE+tlBV;EwEtulBM;IAOI,2BAAA;IAAA,8BAAA;ExEmulBV;EwE1ulBM;IAOI,2BAAA;IAAA,8BAAA;ExEuulBV;EwE9ulBM;IAOI,wBAAA;ExE0ulBV;EwEjvlBM;IAOI,8BAAA;ExE6ulBV;EwEpvlBM;IAOI,6BAAA;ExEgvlBV;EwEvvlBM;IAOI,2BAAA;ExEmvlBV;EwE1vlBM;IAOI,6BAAA;ExEsvlBV;EwE7vlBM;IAOI,2BAAA;ExEyvlBV;EwEhwlBM;IAOI,2BAAA;ExE4vlBV;EwEnwlBM;IAOI,0BAAA;ExE+vlBV;EwEtwlBM;IAOI,gCAAA;ExEkwlBV;EwEzwlBM;IAOI,+BAAA;ExEqwlBV;EwE5wlBM;IAOI,6BAAA;ExEwwlBV;EwE/wlBM;IAOI,+BAAA;ExE2wlBV;EwElxlBM;IAOI,6BAAA;ExE8wlBV;EwErxlBM;IAOI,6BAAA;ExEixlBV;EwExxlBM;IAOI,2BAAA;ExEoxlBV;EwE3xlBM;IAOI,iCAAA;ExEuxlBV;EwE9xlBM;IAOI,gCAAA;ExE0xlBV;EwEjylBM;IAOI,8BAAA;ExE6xlBV;EwEpylBM;IAOI,gCAAA;ExEgylBV;EwEvylBM;IAOI,8BAAA;ExEmylBV;EwE1ylBM;IAOI,8BAAA;ExEsylBV;EwE7ylBM;IAOI,yBAAA;ExEyylBV;EwEhzlBM;IAOI,+BAAA;ExE4ylBV;EwEnzlBM;IAOI,8BAAA;ExE+ylBV;EwEtzlBM;IAOI,4BAAA;ExEkzlBV;EwEzzlBM;IAOI,8BAAA;ExEqzlBV;EwE5zlBM;IAOI,4BAAA;ExEwzlBV;EwE/zlBM;IAOI,4BAAA;ExE2zlBV;EwEl0lBM;IAOI,qBAAA;ExE8zlBV;EwEr0lBM;IAOI,2BAAA;ExEi0lBV;EwEx0lBM;IAOI,0BAAA;ExEo0lBV;EwE30lBM;IAOI,wBAAA;ExEu0lBV;EwE90lBM;IAOI,0BAAA;ExE00lBV;EwEj1lBM;IAOI,wBAAA;ExE60lBV;EwEp1lBM;IAOI,2BAAA;IAAA,0BAAA;ExEi1lBV;EwEx1lBM;IAOI,iCAAA;IAAA,gCAAA;ExEq1lBV;EwE51lBM;IAOI,gCAAA;IAAA,+BAAA;ExEy1lBV;EwEh2lBM;IAOI,8BAAA;IAAA,6BAAA;ExE61lBV;EwEp2lBM;IAOI,gCAAA;IAAA,+BAAA;ExEi2lBV;EwEx2lBM;IAOI,8BAAA;IAAA,6BAAA;ExEq2lBV;EwE52lBM;IAOI,yBAAA;IAAA,4BAAA;ExEy2lBV;EwEh3lBM;IAOI,+BAAA;IAAA,kCAAA;ExE62lBV;EwEp3lBM;IAOI,8BAAA;IAAA,iCAAA;ExEi3lBV;EwEx3lBM;IAOI,4BAAA;IAAA,+BAAA;ExEq3lBV;EwE53lBM;IAOI,8BAAA;IAAA,iCAAA;ExEy3lBV;EwEh4lBM;IAOI,4BAAA;IAAA,+BAAA;ExE63lBV;EwEp4lBM;IAOI,yBAAA;ExEg4lBV;EwEv4lBM;IAOI,+BAAA;ExEm4lBV;EwE14lBM;IAOI,8BAAA;ExEs4lBV;EwE74lBM;IAOI,4BAAA;ExEy4lBV;EwEh5lBM;IAOI,8BAAA;ExE44lBV;EwEn5lBM;IAOI,4BAAA;ExE+4lBV;EwEt5lBM;IAOI,2BAAA;ExEk5lBV;EwEz5lBM;IAOI,iCAAA;ExEq5lBV;EwE55lBM;IAOI,gCAAA;ExEw5lBV;EwE/5lBM;IAOI,8BAAA;ExE25lBV;EwEl6lBM;IAOI,gCAAA;ExE85lBV;EwEr6lBM;IAOI,8BAAA;ExEi6lBV;EwEx6lBM;IAOI,4BAAA;ExEo6lBV;EwE36lBM;IAOI,kCAAA;ExEu6lBV;EwE96lBM;IAOI,iCAAA;ExE06lBV;EwEj7lBM;IAOI,+BAAA;ExE66lBV;EwEp7lBM;IAOI,iCAAA;ExEg7lBV;EwEv7lBM;IAOI,+BAAA;ExEm7lBV;EwE17lBM;IAOI,0BAAA;ExEs7lBV;EwE77lBM;IAOI,gCAAA;ExEy7lBV;EwEh8lBM;IAOI,+BAAA;ExE47lBV;EwEn8lBM;IAOI,6BAAA;ExE+7lBV;EwEt8lBM;IAOI,+BAAA;ExEk8lBV;EwEz8lBM;IAOI,6BAAA;ExEq8lBV;EwE58lBM;IAOI,iBAAA;ExEw8lBV;EwE/8lBM;IAOI,uBAAA;ExE28lBV;EwEl9lBM;IAOI,sBAAA;ExE88lBV;EwEr9lBM;IAOI,oBAAA;ExEi9lBV;EwEx9lBM;IAOI,sBAAA;ExEo9lBV;EwE39lBM;IAOI,oBAAA;ExEu9lBV;EwE99lBM;IAOI,qBAAA;ExE09lBV;EwEj+lBM;IAOI,2BAAA;ExE69lBV;EwEp+lBM;IAOI,0BAAA;ExEg+lBV;EwEv+lBM;IAOI,wBAAA;ExEm+lBV;EwE1+lBM;IAOI,0BAAA;ExEs+lBV;EwE7+lBM;IAOI,wBAAA;ExEy+lBV;EwEh/lBM;IAOI,wBAAA;ExE4+lBV;EwEn/lBM;IAOI,8BAAA;ExE++lBV;EwEt/lBM;IAOI,6BAAA;ExEk/lBV;EwEz/lBM;IAOI,2BAAA;ExEq/lBV;EwE5/lBM;IAOI,6BAAA;ExEw/lBV;EwE//lBM;IAOI,2BAAA;ExE2/lBV;EwElgmBM;IAOI,2BAAA;ExE8/lBV;EwErgmBM;IAOI,4BAAA;ExEigmBV;EwExgmBM;IAOI,6BAAA;ExEogmBV;AACF;Ac/gmBI;E0DGI;IAOI,sBAAA;ExEygmBV;EwEhhmBM;IAOI,uBAAA;ExE4gmBV;EwEnhmBM;IAOI,sBAAA;ExE+gmBV;EwEthmBM;IAOI,8BAAA;ExEkhmBV;EwEzhmBM;IAOI,4BAAA;ExEqhmBV;EwE5hmBM;IAOI,2BAAA;ExEwhmBV;EwE/hmBM;IAOI,iCAAA;ExE2hmBV;EwElimBM;IAOI,2BAAA;ExE8hmBV;EwErimBM;IAOI,0BAAA;ExEiimBV;EwEximBM;IAOI,gCAAA;ExEoimBV;EwE3imBM;IAOI,yBAAA;ExEuimBV;EwE9imBM;IAOI,wBAAA;ExE0imBV;EwEjjmBM;IAOI,+BAAA;ExE6imBV;EwEpjmBM;IAOI,yBAAA;ExEgjmBV;EwEvjmBM;IAOI,6BAAA;ExEmjmBV;EwE1jmBM;IAOI,8BAAA;ExEsjmBV;EwE7jmBM;IAOI,wBAAA;ExEyjmBV;EwEhkmBM;IAOI,+BAAA;ExE4jmBV;EwEnkmBM;IAOI,wBAAA;ExE+jmBV;EwEtkmBM;IAOI,yBAAA;ExEkkmBV;EwEzkmBM;IAOI,8BAAA;ExEqkmBV;EwE5kmBM;IAOI,iCAAA;ExEwkmBV;EwE/kmBM;IAOI,sCAAA;ExE2kmBV;EwEllmBM;IAOI,yCAAA;ExE8kmBV;EwErlmBM;IAOI,uBAAA;ExEilmBV;EwExlmBM;IAOI,uBAAA;ExEolmBV;EwE3lmBM;IAOI,yBAAA;ExEulmBV;EwE9lmBM;IAOI,yBAAA;ExE0lmBV;EwEjmmBM;IAOI,0BAAA;ExE6lmBV;EwEpmmBM;IAOI,4BAAA;ExEgmmBV;EwEvmmBM;IAOI,kCAAA;ExEmmmBV;EwE1mmBM;IAOI,sCAAA;ExEsmmBV;EwE7mmBM;IAOI,oCAAA;ExEymmBV;EwEhnmBM;IAOI,kCAAA;ExE4mmBV;EwEnnmBM;IAOI,yCAAA;ExE+mmBV;EwEtnmBM;IAOI,wCAAA;ExEknmBV;EwEznmBM;IAOI,wCAAA;ExEqnmBV;EwE5nmBM;IAOI,kCAAA;ExEwnmBV;EwE/nmBM;IAOI,gCAAA;ExE2nmBV;EwElomBM;IAOI,8BAAA;ExE8nmBV;EwEromBM;IAOI,gCAAA;ExEiomBV;EwExomBM;IAOI,+BAAA;ExEoomBV;EwE3omBM;IAOI,oCAAA;ExEuomBV;EwE9omBM;IAOI,kCAAA;ExE0omBV;EwEjpmBM;IAOI,gCAAA;ExE6omBV;EwEppmBM;IAOI,uCAAA;ExEgpmBV;EwEvpmBM;IAOI,sCAAA;ExEmpmBV;EwE1pmBM;IAOI,iCAAA;ExEspmBV;EwE7pmBM;IAOI,2BAAA;ExEypmBV;EwEhqmBM;IAOI,iCAAA;ExE4pmBV;EwEnqmBM;IAOI,+BAAA;ExE+pmBV;EwEtqmBM;IAOI,6BAAA;ExEkqmBV;EwEzqmBM;IAOI,+BAAA;ExEqqmBV;EwE5qmBM;IAOI,8BAAA;ExEwqmBV;EwE/qmBM;IAOI,oBAAA;ExE2qmBV;EwElrmBM;IAOI,mBAAA;ExE8qmBV;EwErrmBM;IAOI,mBAAA;ExEirmBV;EwExrmBM;IAOI,mBAAA;ExEormBV;EwE3rmBM;IAOI,mBAAA;ExEurmBV;EwE9rmBM;IAOI,mBAAA;ExE0rmBV;EwEjsmBM;IAOI,mBAAA;ExE6rmBV;EwEpsmBM;IAOI,mBAAA;ExEgsmBV;EwEvsmBM;IAOI,oBAAA;ExEmsmBV;EwE1smBM;IAOI,0BAAA;ExEssmBV;EwE7smBM;IAOI,yBAAA;ExEysmBV;EwEhtmBM;IAOI,uBAAA;ExE4smBV;EwEntmBM;IAOI,yBAAA;ExE+smBV;EwEttmBM;IAOI,uBAAA;ExEktmBV;EwEztmBM;IAOI,uBAAA;ExEqtmBV;EwE5tmBM;IAOI,0BAAA;IAAA,yBAAA;ExEytmBV;EwEhumBM;IAOI,gCAAA;IAAA,+BAAA;ExE6tmBV;EwEpumBM;IAOI,+BAAA;IAAA,8BAAA;ExEiumBV;EwExumBM;IAOI,6BAAA;IAAA,4BAAA;ExEqumBV;EwE5umBM;IAOI,+BAAA;IAAA,8BAAA;ExEyumBV;EwEhvmBM;IAOI,6BAAA;IAAA,4BAAA;ExE6umBV;EwEpvmBM;IAOI,6BAAA;IAAA,4BAAA;ExEivmBV;EwExvmBM;IAOI,wBAAA;IAAA,2BAAA;ExEqvmBV;EwE5vmBM;IAOI,8BAAA;IAAA,iCAAA;ExEyvmBV;EwEhwmBM;IAOI,6BAAA;IAAA,gCAAA;ExE6vmBV;EwEpwmBM;IAOI,2BAAA;IAAA,8BAAA;ExEiwmBV;EwExwmBM;IAOI,6BAAA;IAAA,gCAAA;ExEqwmBV;EwE5wmBM;IAOI,2BAAA;IAAA,8BAAA;ExEywmBV;EwEhxmBM;IAOI,2BAAA;IAAA,8BAAA;ExE6wmBV;EwEpxmBM;IAOI,wBAAA;ExEgxmBV;EwEvxmBM;IAOI,8BAAA;ExEmxmBV;EwE1xmBM;IAOI,6BAAA;ExEsxmBV;EwE7xmBM;IAOI,2BAAA;ExEyxmBV;EwEhymBM;IAOI,6BAAA;ExE4xmBV;EwEnymBM;IAOI,2BAAA;ExE+xmBV;EwEtymBM;IAOI,2BAAA;ExEkymBV;EwEzymBM;IAOI,0BAAA;ExEqymBV;EwE5ymBM;IAOI,gCAAA;ExEwymBV;EwE/ymBM;IAOI,+BAAA;ExE2ymBV;EwElzmBM;IAOI,6BAAA;ExE8ymBV;EwErzmBM;IAOI,+BAAA;ExEizmBV;EwExzmBM;IAOI,6BAAA;ExEozmBV;EwE3zmBM;IAOI,6BAAA;ExEuzmBV;EwE9zmBM;IAOI,2BAAA;ExE0zmBV;EwEj0mBM;IAOI,iCAAA;ExE6zmBV;EwEp0mBM;IAOI,gCAAA;ExEg0mBV;EwEv0mBM;IAOI,8BAAA;ExEm0mBV;EwE10mBM;IAOI,gCAAA;ExEs0mBV;EwE70mBM;IAOI,8BAAA;ExEy0mBV;EwEh1mBM;IAOI,8BAAA;ExE40mBV;EwEn1mBM;IAOI,yBAAA;ExE+0mBV;EwEt1mBM;IAOI,+BAAA;ExEk1mBV;EwEz1mBM;IAOI,8BAAA;ExEq1mBV;EwE51mBM;IAOI,4BAAA;ExEw1mBV;EwE/1mBM;IAOI,8BAAA;ExE21mBV;EwEl2mBM;IAOI,4BAAA;ExE81mBV;EwEr2mBM;IAOI,4BAAA;ExEi2mBV;EwEx2mBM;IAOI,qBAAA;ExEo2mBV;EwE32mBM;IAOI,2BAAA;ExEu2mBV;EwE92mBM;IAOI,0BAAA;ExE02mBV;EwEj3mBM;IAOI,wBAAA;ExE62mBV;EwEp3mBM;IAOI,0BAAA;ExEg3mBV;EwEv3mBM;IAOI,wBAAA;ExEm3mBV;EwE13mBM;IAOI,2BAAA;IAAA,0BAAA;ExEu3mBV;EwE93mBM;IAOI,iCAAA;IAAA,gCAAA;ExE23mBV;EwEl4mBM;IAOI,gCAAA;IAAA,+BAAA;ExE+3mBV;EwEt4mBM;IAOI,8BAAA;IAAA,6BAAA;ExEm4mBV;EwE14mBM;IAOI,gCAAA;IAAA,+BAAA;ExEu4mBV;EwE94mBM;IAOI,8BAAA;IAAA,6BAAA;ExE24mBV;EwEl5mBM;IAOI,yBAAA;IAAA,4BAAA;ExE+4mBV;EwEt5mBM;IAOI,+BAAA;IAAA,kCAAA;ExEm5mBV;EwE15mBM;IAOI,8BAAA;IAAA,iCAAA;ExEu5mBV;EwE95mBM;IAOI,4BAAA;IAAA,+BAAA;ExE25mBV;EwEl6mBM;IAOI,8BAAA;IAAA,iCAAA;ExE+5mBV;EwEt6mBM;IAOI,4BAAA;IAAA,+BAAA;ExEm6mBV;EwE16mBM;IAOI,yBAAA;ExEs6mBV;EwE76mBM;IAOI,+BAAA;ExEy6mBV;EwEh7mBM;IAOI,8BAAA;ExE46mBV;EwEn7mBM;IAOI,4BAAA;ExE+6mBV;EwEt7mBM;IAOI,8BAAA;ExEk7mBV;EwEz7mBM;IAOI,4BAAA;ExEq7mBV;EwE57mBM;IAOI,2BAAA;ExEw7mBV;EwE/7mBM;IAOI,iCAAA;ExE27mBV;EwEl8mBM;IAOI,gCAAA;ExE87mBV;EwEr8mBM;IAOI,8BAAA;ExEi8mBV;EwEx8mBM;IAOI,gCAAA;ExEo8mBV;EwE38mBM;IAOI,8BAAA;ExEu8mBV;EwE98mBM;IAOI,4BAAA;ExE08mBV;EwEj9mBM;IAOI,kCAAA;ExE68mBV;EwEp9mBM;IAOI,iCAAA;ExEg9mBV;EwEv9mBM;IAOI,+BAAA;ExEm9mBV;EwE19mBM;IAOI,iCAAA;ExEs9mBV;EwE79mBM;IAOI,+BAAA;ExEy9mBV;EwEh+mBM;IAOI,0BAAA;ExE49mBV;EwEn+mBM;IAOI,gCAAA;ExE+9mBV;EwEt+mBM;IAOI,+BAAA;ExEk+mBV;EwEz+mBM;IAOI,6BAAA;ExEq+mBV;EwE5+mBM;IAOI,+BAAA;ExEw+mBV;EwE/+mBM;IAOI,6BAAA;ExE2+mBV;EwEl/mBM;IAOI,iBAAA;ExE8+mBV;EwEr/mBM;IAOI,uBAAA;ExEi/mBV;EwEx/mBM;IAOI,sBAAA;ExEo/mBV;EwE3/mBM;IAOI,oBAAA;ExEu/mBV;EwE9/mBM;IAOI,sBAAA;ExE0/mBV;EwEjgnBM;IAOI,oBAAA;ExE6/mBV;EwEpgnBM;IAOI,qBAAA;ExEggnBV;EwEvgnBM;IAOI,2BAAA;ExEmgnBV;EwE1gnBM;IAOI,0BAAA;ExEsgnBV;EwE7gnBM;IAOI,wBAAA;ExEygnBV;EwEhhnBM;IAOI,0BAAA;ExE4gnBV;EwEnhnBM;IAOI,wBAAA;ExE+gnBV;EwEthnBM;IAOI,wBAAA;ExEkhnBV;EwEzhnBM;IAOI,8BAAA;ExEqhnBV;EwE5hnBM;IAOI,6BAAA;ExEwhnBV;EwE/hnBM;IAOI,2BAAA;ExE2hnBV;EwElinBM;IAOI,6BAAA;ExE8hnBV;EwErinBM;IAOI,2BAAA;ExEiinBV;EwExinBM;IAOI,2BAAA;ExEoinBV;EwE3inBM;IAOI,4BAAA;ExEuinBV;EwE9inBM;IAOI,6BAAA;ExE0inBV;AACF;AcrjnBI;E0DGI;IAOI,sBAAA;ExE+inBV;EwEtjnBM;IAOI,uBAAA;ExEkjnBV;EwEzjnBM;IAOI,sBAAA;ExEqjnBV;EwE5jnBM;IAOI,8BAAA;ExEwjnBV;EwE/jnBM;IAOI,4BAAA;ExE2jnBV;EwElknBM;IAOI,2BAAA;ExE8jnBV;EwErknBM;IAOI,iCAAA;ExEiknBV;EwExknBM;IAOI,2BAAA;ExEoknBV;EwE3knBM;IAOI,0BAAA;ExEuknBV;EwE9knBM;IAOI,gCAAA;ExE0knBV;EwEjlnBM;IAOI,yBAAA;ExE6knBV;EwEplnBM;IAOI,wBAAA;ExEglnBV;EwEvlnBM;IAOI,+BAAA;ExEmlnBV;EwE1lnBM;IAOI,yBAAA;ExEslnBV;EwE7lnBM;IAOI,6BAAA;ExEylnBV;EwEhmnBM;IAOI,8BAAA;ExE4lnBV;EwEnmnBM;IAOI,wBAAA;ExE+lnBV;EwEtmnBM;IAOI,+BAAA;ExEkmnBV;EwEzmnBM;IAOI,wBAAA;ExEqmnBV;EwE5mnBM;IAOI,yBAAA;ExEwmnBV;EwE/mnBM;IAOI,8BAAA;ExE2mnBV;EwElnnBM;IAOI,iCAAA;ExE8mnBV;EwErnnBM;IAOI,sCAAA;ExEinnBV;EwExnnBM;IAOI,yCAAA;ExEonnBV;EwE3nnBM;IAOI,uBAAA;ExEunnBV;EwE9nnBM;IAOI,uBAAA;ExE0nnBV;EwEjonBM;IAOI,yBAAA;ExE6nnBV;EwEponBM;IAOI,yBAAA;ExEgonBV;EwEvonBM;IAOI,0BAAA;ExEmonBV;EwE1onBM;IAOI,4BAAA;ExEsonBV;EwE7onBM;IAOI,kCAAA;ExEyonBV;EwEhpnBM;IAOI,sCAAA;ExE4onBV;EwEnpnBM;IAOI,oCAAA;ExE+onBV;EwEtpnBM;IAOI,kCAAA;ExEkpnBV;EwEzpnBM;IAOI,yCAAA;ExEqpnBV;EwE5pnBM;IAOI,wCAAA;ExEwpnBV;EwE/pnBM;IAOI,wCAAA;ExE2pnBV;EwElqnBM;IAOI,kCAAA;ExE8pnBV;EwErqnBM;IAOI,gCAAA;ExEiqnBV;EwExqnBM;IAOI,8BAAA;ExEoqnBV;EwE3qnBM;IAOI,gCAAA;ExEuqnBV;EwE9qnBM;IAOI,+BAAA;ExE0qnBV;EwEjrnBM;IAOI,oCAAA;ExE6qnBV;EwEprnBM;IAOI,kCAAA;ExEgrnBV;EwEvrnBM;IAOI,gCAAA;ExEmrnBV;EwE1rnBM;IAOI,uCAAA;ExEsrnBV;EwE7rnBM;IAOI,sCAAA;ExEyrnBV;EwEhsnBM;IAOI,iCAAA;ExE4rnBV;EwEnsnBM;IAOI,2BAAA;ExE+rnBV;EwEtsnBM;IAOI,iCAAA;ExEksnBV;EwEzsnBM;IAOI,+BAAA;ExEqsnBV;EwE5snBM;IAOI,6BAAA;ExEwsnBV;EwE/snBM;IAOI,+BAAA;ExE2snBV;EwEltnBM;IAOI,8BAAA;ExE8snBV;EwErtnBM;IAOI,oBAAA;ExEitnBV;EwExtnBM;IAOI,mBAAA;ExEotnBV;EwE3tnBM;IAOI,mBAAA;ExEutnBV;EwE9tnBM;IAOI,mBAAA;ExE0tnBV;EwEjunBM;IAOI,mBAAA;ExE6tnBV;EwEpunBM;IAOI,mBAAA;ExEgunBV;EwEvunBM;IAOI,mBAAA;ExEmunBV;EwE1unBM;IAOI,mBAAA;ExEsunBV;EwE7unBM;IAOI,oBAAA;ExEyunBV;EwEhvnBM;IAOI,0BAAA;ExE4unBV;EwEnvnBM;IAOI,yBAAA;ExE+unBV;EwEtvnBM;IAOI,uBAAA;ExEkvnBV;EwEzvnBM;IAOI,yBAAA;ExEqvnBV;EwE5vnBM;IAOI,uBAAA;ExEwvnBV;EwE/vnBM;IAOI,uBAAA;ExE2vnBV;EwElwnBM;IAOI,0BAAA;IAAA,yBAAA;ExE+vnBV;EwEtwnBM;IAOI,gCAAA;IAAA,+BAAA;ExEmwnBV;EwE1wnBM;IAOI,+BAAA;IAAA,8BAAA;ExEuwnBV;EwE9wnBM;IAOI,6BAAA;IAAA,4BAAA;ExE2wnBV;EwElxnBM;IAOI,+BAAA;IAAA,8BAAA;ExE+wnBV;EwEtxnBM;IAOI,6BAAA;IAAA,4BAAA;ExEmxnBV;EwE1xnBM;IAOI,6BAAA;IAAA,4BAAA;ExEuxnBV;EwE9xnBM;IAOI,wBAAA;IAAA,2BAAA;ExE2xnBV;EwElynBM;IAOI,8BAAA;IAAA,iCAAA;ExE+xnBV;EwEtynBM;IAOI,6BAAA;IAAA,gCAAA;ExEmynBV;EwE1ynBM;IAOI,2BAAA;IAAA,8BAAA;ExEuynBV;EwE9ynBM;IAOI,6BAAA;IAAA,gCAAA;ExE2ynBV;EwElznBM;IAOI,2BAAA;IAAA,8BAAA;ExE+ynBV;EwEtznBM;IAOI,2BAAA;IAAA,8BAAA;ExEmznBV;EwE1znBM;IAOI,wBAAA;ExEsznBV;EwE7znBM;IAOI,8BAAA;ExEyznBV;EwEh0nBM;IAOI,6BAAA;ExE4znBV;EwEn0nBM;IAOI,2BAAA;ExE+znBV;EwEt0nBM;IAOI,6BAAA;ExEk0nBV;EwEz0nBM;IAOI,2BAAA;ExEq0nBV;EwE50nBM;IAOI,2BAAA;ExEw0nBV;EwE/0nBM;IAOI,0BAAA;ExE20nBV;EwEl1nBM;IAOI,gCAAA;ExE80nBV;EwEr1nBM;IAOI,+BAAA;ExEi1nBV;EwEx1nBM;IAOI,6BAAA;ExEo1nBV;EwE31nBM;IAOI,+BAAA;ExEu1nBV;EwE91nBM;IAOI,6BAAA;ExE01nBV;EwEj2nBM;IAOI,6BAAA;ExE61nBV;EwEp2nBM;IAOI,2BAAA;ExEg2nBV;EwEv2nBM;IAOI,iCAAA;ExEm2nBV;EwE12nBM;IAOI,gCAAA;ExEs2nBV;EwE72nBM;IAOI,8BAAA;ExEy2nBV;EwEh3nBM;IAOI,gCAAA;ExE42nBV;EwEn3nBM;IAOI,8BAAA;ExE+2nBV;EwEt3nBM;IAOI,8BAAA;ExEk3nBV;EwEz3nBM;IAOI,yBAAA;ExEq3nBV;EwE53nBM;IAOI,+BAAA;ExEw3nBV;EwE/3nBM;IAOI,8BAAA;ExE23nBV;EwEl4nBM;IAOI,4BAAA;ExE83nBV;EwEr4nBM;IAOI,8BAAA;ExEi4nBV;EwEx4nBM;IAOI,4BAAA;ExEo4nBV;EwE34nBM;IAOI,4BAAA;ExEu4nBV;EwE94nBM;IAOI,qBAAA;ExE04nBV;EwEj5nBM;IAOI,2BAAA;ExE64nBV;EwEp5nBM;IAOI,0BAAA;ExEg5nBV;EwEv5nBM;IAOI,wBAAA;ExEm5nBV;EwE15nBM;IAOI,0BAAA;ExEs5nBV;EwE75nBM;IAOI,wBAAA;ExEy5nBV;EwEh6nBM;IAOI,2BAAA;IAAA,0BAAA;ExE65nBV;EwEp6nBM;IAOI,iCAAA;IAAA,gCAAA;ExEi6nBV;EwEx6nBM;IAOI,gCAAA;IAAA,+BAAA;ExEq6nBV;EwE56nBM;IAOI,8BAAA;IAAA,6BAAA;ExEy6nBV;EwEh7nBM;IAOI,gCAAA;IAAA,+BAAA;ExE66nBV;EwEp7nBM;IAOI,8BAAA;IAAA,6BAAA;ExEi7nBV;EwEx7nBM;IAOI,yBAAA;IAAA,4BAAA;ExEq7nBV;EwE57nBM;IAOI,+BAAA;IAAA,kCAAA;ExEy7nBV;EwEh8nBM;IAOI,8BAAA;IAAA,iCAAA;ExE67nBV;EwEp8nBM;IAOI,4BAAA;IAAA,+BAAA;ExEi8nBV;EwEx8nBM;IAOI,8BAAA;IAAA,iCAAA;ExEq8nBV;EwE58nBM;IAOI,4BAAA;IAAA,+BAAA;ExEy8nBV;EwEh9nBM;IAOI,yBAAA;ExE48nBV;EwEn9nBM;IAOI,+BAAA;ExE+8nBV;EwEt9nBM;IAOI,8BAAA;ExEk9nBV;EwEz9nBM;IAOI,4BAAA;ExEq9nBV;EwE59nBM;IAOI,8BAAA;ExEw9nBV;EwE/9nBM;IAOI,4BAAA;ExE29nBV;EwEl+nBM;IAOI,2BAAA;ExE89nBV;EwEr+nBM;IAOI,iCAAA;ExEi+nBV;EwEx+nBM;IAOI,gCAAA;ExEo+nBV;EwE3+nBM;IAOI,8BAAA;ExEu+nBV;EwE9+nBM;IAOI,gCAAA;ExE0+nBV;EwEj/nBM;IAOI,8BAAA;ExE6+nBV;EwEp/nBM;IAOI,4BAAA;ExEg/nBV;EwEv/nBM;IAOI,kCAAA;ExEm/nBV;EwE1/nBM;IAOI,iCAAA;ExEs/nBV;EwE7/nBM;IAOI,+BAAA;ExEy/nBV;EwEhgoBM;IAOI,iCAAA;ExE4/nBV;EwEngoBM;IAOI,+BAAA;ExE+/nBV;EwEtgoBM;IAOI,0BAAA;ExEkgoBV;EwEzgoBM;IAOI,gCAAA;ExEqgoBV;EwE5goBM;IAOI,+BAAA;ExEwgoBV;EwE/goBM;IAOI,6BAAA;ExE2goBV;EwElhoBM;IAOI,+BAAA;ExE8goBV;EwErhoBM;IAOI,6BAAA;ExEihoBV;EwExhoBM;IAOI,iBAAA;ExEohoBV;EwE3hoBM;IAOI,uBAAA;ExEuhoBV;EwE9hoBM;IAOI,sBAAA;ExE0hoBV;EwEjioBM;IAOI,oBAAA;ExE6hoBV;EwEpioBM;IAOI,sBAAA;ExEgioBV;EwEvioBM;IAOI,oBAAA;ExEmioBV;EwE1ioBM;IAOI,qBAAA;ExEsioBV;EwE7ioBM;IAOI,2BAAA;ExEyioBV;EwEhjoBM;IAOI,0BAAA;ExE4ioBV;EwEnjoBM;IAOI,wBAAA;ExE+ioBV;EwEtjoBM;IAOI,0BAAA;ExEkjoBV;EwEzjoBM;IAOI,wBAAA;ExEqjoBV;EwE5joBM;IAOI,wBAAA;ExEwjoBV;EwE/joBM;IAOI,8BAAA;ExE2joBV;EwElkoBM;IAOI,6BAAA;ExE8joBV;EwErkoBM;IAOI,2BAAA;ExEikoBV;EwExkoBM;IAOI,6BAAA;ExEokoBV;EwE3koBM;IAOI,2BAAA;ExEukoBV;EwE9koBM;IAOI,2BAAA;ExE0koBV;EwEjloBM;IAOI,4BAAA;ExE6koBV;EwEploBM;IAOI,6BAAA;ExEgloBV;AACF;Ac3loBI;E0DGI;IAOI,sBAAA;ExEqloBV;EwE5loBM;IAOI,uBAAA;ExEwloBV;EwE/loBM;IAOI,sBAAA;ExE2loBV;EwElmoBM;IAOI,8BAAA;ExE8loBV;EwErmoBM;IAOI,4BAAA;ExEimoBV;EwExmoBM;IAOI,2BAAA;ExEomoBV;EwE3moBM;IAOI,iCAAA;ExEumoBV;EwE9moBM;IAOI,2BAAA;ExE0moBV;EwEjnoBM;IAOI,0BAAA;ExE6moBV;EwEpnoBM;IAOI,gCAAA;ExEgnoBV;EwEvnoBM;IAOI,yBAAA;ExEmnoBV;EwE1noBM;IAOI,wBAAA;ExEsnoBV;EwE7noBM;IAOI,+BAAA;ExEynoBV;EwEhooBM;IAOI,yBAAA;ExE4noBV;EwEnooBM;IAOI,6BAAA;ExE+noBV;EwEtooBM;IAOI,8BAAA;ExEkooBV;EwEzooBM;IAOI,wBAAA;ExEqooBV;EwE5ooBM;IAOI,+BAAA;ExEwooBV;EwE/ooBM;IAOI,wBAAA;ExE2ooBV;EwElpoBM;IAOI,yBAAA;ExE8ooBV;EwErpoBM;IAOI,8BAAA;ExEipoBV;EwExpoBM;IAOI,iCAAA;ExEopoBV;EwE3poBM;IAOI,sCAAA;ExEupoBV;EwE9poBM;IAOI,yCAAA;ExE0poBV;EwEjqoBM;IAOI,uBAAA;ExE6poBV;EwEpqoBM;IAOI,uBAAA;ExEgqoBV;EwEvqoBM;IAOI,yBAAA;ExEmqoBV;EwE1qoBM;IAOI,yBAAA;ExEsqoBV;EwE7qoBM;IAOI,0BAAA;ExEyqoBV;EwEhroBM;IAOI,4BAAA;ExE4qoBV;EwEnroBM;IAOI,kCAAA;ExE+qoBV;EwEtroBM;IAOI,sCAAA;ExEkroBV;EwEzroBM;IAOI,oCAAA;ExEqroBV;EwE5roBM;IAOI,kCAAA;ExEwroBV;EwE/roBM;IAOI,yCAAA;ExE2roBV;EwElsoBM;IAOI,wCAAA;ExE8roBV;EwErsoBM;IAOI,wCAAA;ExEisoBV;EwExsoBM;IAOI,kCAAA;ExEosoBV;EwE3soBM;IAOI,gCAAA;ExEusoBV;EwE9soBM;IAOI,8BAAA;ExE0soBV;EwEjtoBM;IAOI,gCAAA;ExE6soBV;EwEptoBM;IAOI,+BAAA;ExEgtoBV;EwEvtoBM;IAOI,oCAAA;ExEmtoBV;EwE1toBM;IAOI,kCAAA;ExEstoBV;EwE7toBM;IAOI,gCAAA;ExEytoBV;EwEhuoBM;IAOI,uCAAA;ExE4toBV;EwEnuoBM;IAOI,sCAAA;ExE+toBV;EwEtuoBM;IAOI,iCAAA;ExEkuoBV;EwEzuoBM;IAOI,2BAAA;ExEquoBV;EwE5uoBM;IAOI,iCAAA;ExEwuoBV;EwE/uoBM;IAOI,+BAAA;ExE2uoBV;EwElvoBM;IAOI,6BAAA;ExE8uoBV;EwErvoBM;IAOI,+BAAA;ExEivoBV;EwExvoBM;IAOI,8BAAA;ExEovoBV;EwE3voBM;IAOI,oBAAA;ExEuvoBV;EwE9voBM;IAOI,mBAAA;ExE0voBV;EwEjwoBM;IAOI,mBAAA;ExE6voBV;EwEpwoBM;IAOI,mBAAA;ExEgwoBV;EwEvwoBM;IAOI,mBAAA;ExEmwoBV;EwE1woBM;IAOI,mBAAA;ExEswoBV;EwE7woBM;IAOI,mBAAA;ExEywoBV;EwEhxoBM;IAOI,mBAAA;ExE4woBV;EwEnxoBM;IAOI,oBAAA;ExE+woBV;EwEtxoBM;IAOI,0BAAA;ExEkxoBV;EwEzxoBM;IAOI,yBAAA;ExEqxoBV;EwE5xoBM;IAOI,uBAAA;ExEwxoBV;EwE/xoBM;IAOI,yBAAA;ExE2xoBV;EwElyoBM;IAOI,uBAAA;ExE8xoBV;EwEryoBM;IAOI,uBAAA;ExEiyoBV;EwExyoBM;IAOI,0BAAA;IAAA,yBAAA;ExEqyoBV;EwE5yoBM;IAOI,gCAAA;IAAA,+BAAA;ExEyyoBV;EwEhzoBM;IAOI,+BAAA;IAAA,8BAAA;ExE6yoBV;EwEpzoBM;IAOI,6BAAA;IAAA,4BAAA;ExEizoBV;EwExzoBM;IAOI,+BAAA;IAAA,8BAAA;ExEqzoBV;EwE5zoBM;IAOI,6BAAA;IAAA,4BAAA;ExEyzoBV;EwEh0oBM;IAOI,6BAAA;IAAA,4BAAA;ExE6zoBV;EwEp0oBM;IAOI,wBAAA;IAAA,2BAAA;ExEi0oBV;EwEx0oBM;IAOI,8BAAA;IAAA,iCAAA;ExEq0oBV;EwE50oBM;IAOI,6BAAA;IAAA,gCAAA;ExEy0oBV;EwEh1oBM;IAOI,2BAAA;IAAA,8BAAA;ExE60oBV;EwEp1oBM;IAOI,6BAAA;IAAA,gCAAA;ExEi1oBV;EwEx1oBM;IAOI,2BAAA;IAAA,8BAAA;ExEq1oBV;EwE51oBM;IAOI,2BAAA;IAAA,8BAAA;ExEy1oBV;EwEh2oBM;IAOI,wBAAA;ExE41oBV;EwEn2oBM;IAOI,8BAAA;ExE+1oBV;EwEt2oBM;IAOI,6BAAA;ExEk2oBV;EwEz2oBM;IAOI,2BAAA;ExEq2oBV;EwE52oBM;IAOI,6BAAA;ExEw2oBV;EwE/2oBM;IAOI,2BAAA;ExE22oBV;EwEl3oBM;IAOI,2BAAA;ExE82oBV;EwEr3oBM;IAOI,0BAAA;ExEi3oBV;EwEx3oBM;IAOI,gCAAA;ExEo3oBV;EwE33oBM;IAOI,+BAAA;ExEu3oBV;EwE93oBM;IAOI,6BAAA;ExE03oBV;EwEj4oBM;IAOI,+BAAA;ExE63oBV;EwEp4oBM;IAOI,6BAAA;ExEg4oBV;EwEv4oBM;IAOI,6BAAA;ExEm4oBV;EwE14oBM;IAOI,2BAAA;ExEs4oBV;EwE74oBM;IAOI,iCAAA;ExEy4oBV;EwEh5oBM;IAOI,gCAAA;ExE44oBV;EwEn5oBM;IAOI,8BAAA;ExE+4oBV;EwEt5oBM;IAOI,gCAAA;ExEk5oBV;EwEz5oBM;IAOI,8BAAA;ExEq5oBV;EwE55oBM;IAOI,8BAAA;ExEw5oBV;EwE/5oBM;IAOI,yBAAA;ExE25oBV;EwEl6oBM;IAOI,+BAAA;ExE85oBV;EwEr6oBM;IAOI,8BAAA;ExEi6oBV;EwEx6oBM;IAOI,4BAAA;ExEo6oBV;EwE36oBM;IAOI,8BAAA;ExEu6oBV;EwE96oBM;IAOI,4BAAA;ExE06oBV;EwEj7oBM;IAOI,4BAAA;ExE66oBV;EwEp7oBM;IAOI,qBAAA;ExEg7oBV;EwEv7oBM;IAOI,2BAAA;ExEm7oBV;EwE17oBM;IAOI,0BAAA;ExEs7oBV;EwE77oBM;IAOI,wBAAA;ExEy7oBV;EwEh8oBM;IAOI,0BAAA;ExE47oBV;EwEn8oBM;IAOI,wBAAA;ExE+7oBV;EwEt8oBM;IAOI,2BAAA;IAAA,0BAAA;ExEm8oBV;EwE18oBM;IAOI,iCAAA;IAAA,gCAAA;ExEu8oBV;EwE98oBM;IAOI,gCAAA;IAAA,+BAAA;ExE28oBV;EwEl9oBM;IAOI,8BAAA;IAAA,6BAAA;ExE+8oBV;EwEt9oBM;IAOI,gCAAA;IAAA,+BAAA;ExEm9oBV;EwE19oBM;IAOI,8BAAA;IAAA,6BAAA;ExEu9oBV;EwE99oBM;IAOI,yBAAA;IAAA,4BAAA;ExE29oBV;EwEl+oBM;IAOI,+BAAA;IAAA,kCAAA;ExE+9oBV;EwEt+oBM;IAOI,8BAAA;IAAA,iCAAA;ExEm+oBV;EwE1+oBM;IAOI,4BAAA;IAAA,+BAAA;ExEu+oBV;EwE9+oBM;IAOI,8BAAA;IAAA,iCAAA;ExE2+oBV;EwEl/oBM;IAOI,4BAAA;IAAA,+BAAA;ExE++oBV;EwEt/oBM;IAOI,yBAAA;ExEk/oBV;EwEz/oBM;IAOI,+BAAA;ExEq/oBV;EwE5/oBM;IAOI,8BAAA;ExEw/oBV;EwE//oBM;IAOI,4BAAA;ExE2/oBV;EwElgpBM;IAOI,8BAAA;ExE8/oBV;EwErgpBM;IAOI,4BAAA;ExEigpBV;EwExgpBM;IAOI,2BAAA;ExEogpBV;EwE3gpBM;IAOI,iCAAA;ExEugpBV;EwE9gpBM;IAOI,gCAAA;ExE0gpBV;EwEjhpBM;IAOI,8BAAA;ExE6gpBV;EwEphpBM;IAOI,gCAAA;ExEghpBV;EwEvhpBM;IAOI,8BAAA;ExEmhpBV;EwE1hpBM;IAOI,4BAAA;ExEshpBV;EwE7hpBM;IAOI,kCAAA;ExEyhpBV;EwEhipBM;IAOI,iCAAA;ExE4hpBV;EwEnipBM;IAOI,+BAAA;ExE+hpBV;EwEtipBM;IAOI,iCAAA;ExEkipBV;EwEzipBM;IAOI,+BAAA;ExEqipBV;EwE5ipBM;IAOI,0BAAA;ExEwipBV;EwE/ipBM;IAOI,gCAAA;ExE2ipBV;EwEljpBM;IAOI,+BAAA;ExE8ipBV;EwErjpBM;IAOI,6BAAA;ExEijpBV;EwExjpBM;IAOI,+BAAA;ExEojpBV;EwE3jpBM;IAOI,6BAAA;ExEujpBV;EwE9jpBM;IAOI,iBAAA;ExE0jpBV;EwEjkpBM;IAOI,uBAAA;ExE6jpBV;EwEpkpBM;IAOI,sBAAA;ExEgkpBV;EwEvkpBM;IAOI,oBAAA;ExEmkpBV;EwE1kpBM;IAOI,sBAAA;ExEskpBV;EwE7kpBM;IAOI,oBAAA;ExEykpBV;EwEhlpBM;IAOI,qBAAA;ExE4kpBV;EwEnlpBM;IAOI,2BAAA;ExE+kpBV;EwEtlpBM;IAOI,0BAAA;ExEklpBV;EwEzlpBM;IAOI,wBAAA;ExEqlpBV;EwE5lpBM;IAOI,0BAAA;ExEwlpBV;EwE/lpBM;IAOI,wBAAA;ExE2lpBV;EwElmpBM;IAOI,wBAAA;ExE8lpBV;EwErmpBM;IAOI,8BAAA;ExEimpBV;EwExmpBM;IAOI,6BAAA;ExEompBV;EwE3mpBM;IAOI,2BAAA;ExEumpBV;EwE9mpBM;IAOI,6BAAA;ExE0mpBV;EwEjnpBM;IAOI,2BAAA;ExE6mpBV;EwEpnpBM;IAOI,2BAAA;ExEgnpBV;EwEvnpBM;IAOI,4BAAA;ExEmnpBV;EwE1npBM;IAOI,6BAAA;ExEsnpBV;AACF;AyE7qpBA;ED+CQ;IAOI,4BAAA;ExE2npBV;EwElopBM;IAOI,0BAAA;ExE8npBV;EwEropBM;IAOI,6BAAA;ExEiopBV;EwExopBM;IAOI,4BAAA;ExEoopBV;AACF;AyExqpBA;ED4BQ;IAOI,0BAAA;ExEyopBV;EwEhppBM;IAOI,gCAAA;ExE4opBV;EwEnppBM;IAOI,yBAAA;ExE+opBV;EwEtppBM;IAOI,wBAAA;ExEkppBV;EwEzppBM;IAOI,+BAAA;ExEqppBV;EwE5ppBM;IAOI,yBAAA;ExEwppBV;EwE/ppBM;IAOI,6BAAA;ExE2ppBV;EwElqpBM;IAOI,8BAAA;ExE8ppBV;EwErqpBM;IAOI,wBAAA;ExEiqpBV;EwExqpBM;IAOI,+BAAA;ExEoqpBV;EwE3qpBM;IAOI,wBAAA;ExEuqpBV;AACF;AA7upBA;EACE,sBAAA;AA+upBF;;AA5upBA;EACE,0BAAA;EACA,sCAAA;EACA,0BAAA;EACA,sBAAA;EACA,iCAAA;EACA,sBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0BAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;EACA,oCAAA;EACA,2BAAA;EACA,wBAAA;EACA,mCAAA;EACA,8BAAA;EACA,6BAAA;EACA,kCAAA;EACA,oCAAA;EACA,yCAAA;EACA,mCAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EAEA,sBAAA;AA8upBF;;AA1upBA;EACE,wBAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,mCAAA;EACA,2BAAA;EACA,sCAAA;EACA,2BAAA;EACA,gCAAA;EACA,0BAAA;EACA,wBAAA;EACA,mCAAA;EACA,8BAAA;EACA,6BAAA;EACA,kCAAA;EACA,oCAAA;EACA,yCAAA;EACA,gCAAA;AA6upBF;;AAzupBA;EACE,iJACE;EAWF,SAAA;EACA,UAAA;EACA,sBAAA;AAiupBF;;AA9tpBA;EACE,eAAA;EAAA,0BAAA;AAiupBF;;AA9tpBA;;EAEE,YAAA;EACA,yBAAA;EAAA,yCAAA;EACA,SAAA;EACA,UAAA;EACA,uGAAA;EACA,wBAAA;EACA,qBAAA;AAiupBF;;AA9tpBA;EACE,UAAA;EACA,wCAAA;EACA,sBAAA;AAiupBF;;AA9tpBA;EACE;IACE,UAAA;EAiupBF;EA/tpBA;IACE,UAAA;EAiupBF;AACF;AA9tpBA;EACE,WAAA;EACA,eAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,2BAAA;EACA,iCAAA;AAgupBF;;AA9tpBA;;EAEE,WAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AAiupBF;;AA/tpBA;EACE,WAAA;EACA,sBAAA;AAkupBF;;AAhupBA;EACE;IACE,wBAAA;EAmupBF;AACF;AAhupBA;EACE,aAAA;AAkupBF;;AA9tpBA;EACE,cAAA;EACA,eAAA;AAiupBF;;AA5tpBA;EACE,wEACE;EAEF,YAAA;EACA,cAAA;EAAA,yBAAA;EACA,2BAAA;EAAA,sCAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AA6tpBF;AA3tpBE;EACE,yBAAA;EAAA,oCAAA;EACA,gBAAA;EAAA,2BAAA;AA6tpBJ;AA1tpBE;EACE,yBAAA;EAAA,mCAAA;EACA,8CAAA;EACA,2BAAA;EACA,YAAA;EAAA,eAAA;AA4tpBJ;AA1tpBE;EACE,sBAAA;EACA,eAAA;AA4tpBJ;AAxtpBE;EACE,yBAAA;EAAA,kCAAA;AA0tpBJ;AAxtpBI;EACE,yBAAA;EAAA,oCAAA;EACA,cAAA;EAAA,uBAAA;AA0tpBN;;AAptpBA;EACE,kBAAA;AAutpBF;;AAptpBA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AAutpBF;AArtpBE;EACE,qBAAA;EACA,sBAAA;AAutpBJ;AAptpBE;EACE,qBAAA;EACA,sBAAA;EACA,4BAAA;AAstpBJ;AAntpBE;EACE,2CAAA;EACA,gBAAA;EAAA,2BAAA;AAqtpBJ;AAltpBE;EACE,2CAAA;AAotpBJ;AAjtpBE;EACE,kBAAA;EACA,oBAAA;EACA,yCAAA;EACA,0BAAA;EACA,gDAAA;EACA,cAAA;EAAA,iCAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAmtpBJ;AAhtpBE;;;;EAIE,YAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gDAAA;EACA,gCAAA;EACA,6BAAA;EACA,WAAA;AAktpBJ;AAhtpBI;;;;EACE,+CAAA;AAqtpBN;AAjtpBE;EACE,mBAAA;AAmtpBJ;AAhtpBE;;;EAGE,kCAAA;EAAA,6CAAA;AAktpBJ;AA/spBE;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AAitpBJ;AA7spBI;;;EAGE,gCAAA;EACA,yBAAA;AA+spBN;;AA1spBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AA6spBF;AA3spBE;EACE,eAAA;EACA,cAAA;EAAA,wBAAA;EACA,gBAAA;EACA,yBAAA;AA6spBJ;AA1spBE;EACE,eAAA;EACA,cAAA;EAAA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EAAA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AA4spBJ;AAzspBE;EACE,SAAA;AA2spBJ;;AAvspBA;EACE,iBAAA;AA0spBF;;AAtspBE;EACE,cAAA;EACA,mBAAA;AAyspBJ;AAtspBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAwspBJ;AArspBE;;;EAGE,WAAA;EACA,SAAA;AAuspBJ;AApspBE;EACE,kBAAA;AAsspBJ;AAnspBE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,yBAAA;EAAA,oCAAA;EACA,gBAAA;EAAA,2BAAA;EACA,2BAAA;EAAA,sCAAA;EACA,gBAAA;AAqspBJ;AAnspBI;EACE,2BAAA;EAAA,sCAAA;EACA,cAAA;EAAA,yBAAA;AAqspBN;AAlspBI;EACE,0CAAA;AAospBN;AAhspBE;EACE,aAAA;EACA,cAAA;EACA,cAAA;AAkspBJ;AA/rpBE;EACE,kBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAispBJ;AA/rpBI;;EAEE,sBAAA;EACA,uBAAA;EACA,0BAAA;AAispBN;;AA3rpBA;EACE,mBAAA;EAAA,8BAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;AA8rpBF;;AA1rpBA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;AA6rpBF;AA3rpBE;EACE,yBAAA;EAAA,+CAAA;EACA,yBAAA;EAAA,oCAAA;EACA,cAAA;EAAA,yBAAA;AA6rpBJ;;AAzrpBA;EACE,eAAA;EACA,UAAA;EACA,2CAAA;EACA,qBAAA;AA4rpBF;;AAzrpBA;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AA4rpBF;AA1rpBE;EACE,2BAAA;AA4rpBJ;AAzrpBE;EACE,mBAAA;AA2rpBJ;AAxrpBE;EACE,UAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;AA0rpBJ;AAxrpBI;EARF;IASI,aAAA;EA2rpBJ;AACF;AAzrpBI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,6EAAA;AA2rpBN;AAvrpBE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,aAAA;EACA,gBAAA;AAyrpBJ;AAvrpBI;EAVF;IAWI,WAAA;IACA,aAAA;EA0rpBJ;AACF;AAxrpBI;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EAAA,yBAAA;AA0rpBN;AAxrpBM;EALF;IAMI,eAAA;EA2rpBN;AACF;AAzrpBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AA2rpBR;AAzrpBQ;EANF;IAOI,YAAA;IACA,mBAAA;EA4rpBR;AACF;AAzrpBM;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;EACA,mBAAA;AA2rpBR;AAzrpBQ;EANF;IAOI,eAAA;IACA,mBAAA;EA4rpBR;AACF;AAzrpBM;EACE,cAAA;EAAA,yBAAA;EACA,eAAA;EACA,mBAAA;AA2rpBR;AAxrpBM;EACE,cAAA;EAAA,yBAAA;EACA,gBAAA;EACA,iBAAA;AA0rpBR;AAvrpBM;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;AAyrpBR;AAvrpBQ;EACE,mBAAA;EACA,WAAA;AAyrpBV;AAvrpBU;EACE,kBAAA;EACA,oBAAA;EACA,yCAAA;EACA,0BAAA;EACA,gDAAA;EACA,cAAA;EAAA,iCAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAyrpBZ;AAtrpBU;;;EAGE,YAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gDAAA;EACA,gCAAA;EAAA,gDAAA;EACA,WAAA;EACA,cAAA;EAAA,2BAAA;EACA,yBAAA;EAAA,iDAAA;AAwrpBZ;AAtrpBY;;;EACE,kCAAA;EAAA,6CAAA;AA0rpBd;AAtrpBU;EACE,2CAAA;EACA,gBAAA;EAAA,2BAAA;AAwrpBZ;AArrpBU;EACE,2CAAA;AAurpBZ;AAnrpBQ;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;AAqrpBV;AAjrpBU;EACE,aAAA;EACA,gBAAA;AAmrpBZ;;AA3qpBA;EACE,gBAAA;AA8qpBF;;AA3qpBA;EACE,cAAA;EAAA,yBAAA;AA8qpBF;;AA3qpBA;EACE,gBAAA;EAAA,2BAAA;EACA,0BAAA;AA8qpBF;;AA1qpBA;EACE;IACE,UAAA;EA6qpBF;EA3qpBA;IACE,UAAA;EA6qpBF;AACF;AA1qpBA;EACE;IACE,UAAA;EA4qpBF;EA1qpBA;IACE,UAAA;EA4qpBF;AACF;AAzqpBA;;EAEE,aAAA;AA2qpBF;;AAxqpBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AA2qpBF;AAzqpBE;EACE,2BAAA;AA2qpBJ;AAxqpBE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AA0qpBJ;AAxqpBI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AA0qpBN;AAxqpBM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8EAAA;AA0qpBR;AArqpBE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EAAA,yCAAA;EACA,aAAA;AAuqpBJ;AArqpBI;EACE,gBAAA;EACA,WAAA;AAuqpBN;;AAlqpBA;EACE,SAAA;EACA,gBAAA;EACA,4BAAA;AAqqpBF;AAnqpBE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;AAqqpBJ;;AAjqpBA;EACE,eAAA;AAoqpBF;;AAjqpBA;EACE,WAAA;AAoqpBF;;AAhqpBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAmqpBJ;AAjqpBI;EACE,SAAA;AAmqpBN;AA/ppBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EAAA,8BAAA;EACA,yBAAA;AAiqpBJ;AA/ppBI;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;EAAA,oCAAA;EACA,kBAAA;EACA,mBAAA;EAAA,8BAAA;EACA,oBAAA;EACA,cAAA;EAAA,yBAAA;AAiqpBN;AA7ppBE;EACE,yBAAA;EAAA,oCAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,gDAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;EACA,kBAAA;EACA,mBAAA;AA+ppBJ;AA7ppBI;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AA+ppBN;AA5ppBI;EACE,iBAAA;AA8ppBN;AA1ppBE;EACE,yBAAA;EAAA,oCAAA;EACA,cAAA;EAAA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;AA4ppBJ;AA1ppBI;EACE,iBAAA;AA4ppBN;AAzppBI;EACE,wBAAA;AA2ppBN;AAvppBE;EACE,yBAAA;EAAA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAyppBJ;AAvppBI;EATF;IAUI,YAAA;IAAA,eAAA;IACA,aAAA;IAAA,mBAAA;EA0ppBJ;AACF;AAxppBI;EACE,iBAAA;EACA,kBAAA;EACA,QAAA;AA0ppBN;AAvppBI;EACE,iBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAyppBN;AAvppBM;EAPF;IAQI,iBAAA;EA0ppBN;AACF;AAtppBE;EACE,gBAAA;EACA,cAAA;EAAA,wBAAA;EACA,yBAAA;EACA,eAAA;AAwppBJ;AArppBE;EACE,iBAAA;AAuppBJ;AArppBI;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AAuppBN;AArppBM;EACE,yBAAA;EAAA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;AAuppBR;AApppBM;EACE,eAAA;AAsppBR;AAnppBM;EACE,mDAAA;EACA,4CAAA;AAqppBR;AAlppBM;EACE,SAAA;EACA,gBAAA;EACA,qBAAA;AAoppBR;AAjppBM;EACE,cAAA;EAAA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AAmppBR;AAhppBM;EACE,cAAA;EAAA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAkppBR;AA/opBM;EACE,cAAA;EAAA,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAippBR;AA9opBM;EACE,iBAAA;AAgppBR;AA7opBM;;EAEE,cAAA;EAAA,yBAAA;AA+opBR;AA5opBM;;EAEE,cAAA;EAAA,uBAAA;AA8opBR;;AAvopBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EAAA,yCAAA;EACA,aAAA;AA0opBF;AAxopBE;EACE,YAAA;EACA,2BAAA;EAAA,sCAAA;EACA,6BAAA;AA0opBJ;;AAtopBA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;AAyopBF;AAvopBE;EACE,aAAA;EACA,SAAA;AAyopBJ;AAtopBE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EAAA,2BAAA;EACA,aAAA;EACA,oCAAA;EAAA,4DAAA;EACA,cAAA;EAAA,yBAAA;EACA,2BAAA;EACA,YAAA;EACA,+BAAA;EAAA,+CAAA;EACA,2BAAA;EACA,2BAAA;EACA,iDAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;AAwopBJ;AAtopBI;EApBF;IAqBI,WAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;EAyopBJ;AACF;AAvopBI;EACE,YAAA;EAAA,2BAAA;AAyopBN;AAtopBI;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,8BAAA;AAwopBN;AAropBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAAA,iDAAA;EACA,gCAAA;EAAA,gDAAA;AAuopBN;AAropBM;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAuopBR;AApopBU;EACE,YAAA;EACA,WAAA;AAsopBZ;AAjopBM;EACE,UAAA;AAmopBR;AAhopBM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;AAkopBR;AAhopBQ;EACE,SAAA;EACA,WAAA;AAkopBV;AAhopBU;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAkopBZ;AAhopBY;EACE,gBAAA;EAAA,2BAAA;AAkopBd;AA/npBY;EACE,iBAAA;EACA,gBAAA;AAiopBd;AA9npBY;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;AAgopBd;AAznpBI;EACE,eAAA;EACA,SAAA;EACA,wBAAA;EAAA,uCAAA;EACA,yBAAA;EACA,cAAA;AA2npBN;AAznpBM;EAPF;IAQI,aAAA;EA4npBN;AACF;AAznpBI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EAAA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AA2npBN;AAznpBM;EACE,YAAA;AA2npBR;AAvnpBI;EACE,cAAA;AAynpBN;AAtnpBI;EACE,aAAA;AAwnpBN;AArnpBI;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,6BAAA;EACA,sBAAA;EACA,UAAA;AAunpBN;AArnpBM;EARF;IASI,UAAA;EAwnpBN;AACF;AAtnpBM;;EAEE,YAAA;EACA,WAAA;AAwnpBR;AApnpBI;EACE,YAAA;AAsnpBN;AAnnpBI;EACE,2BAAA;AAqnpBN;AAlnpBI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AAonpBN;AAjnpBI;EACE,cAAA;EAAA,yBAAA;EACA,kBAAA;EACA,qBAAA;AAmnpBN;AAjnpBM;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AAmnpBR;AA3npBI;EAUE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,+BAAA;EACA,2BAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCAAA;EACA,iCAAA;AAonpBN;AAlnpBM;EA5BF;IA6BI,gBAAA;EAqnpBN;AACF;AAnnpBM;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,MAAA;EACA,UAAA;AAqnpBR;AAlnpBM;EACE,QAAA;EACA,UAAA;EACA,eAAA;AAonpBR;AAjnpBM;EACE,eAAA;EACA,SAAA;EACA,UAAA;AAmnpBR;AAhnpBM;EACE,eAAA;EACA,SAAA;EACA,UAAA;AAknpBR;AA/mpBM;EACE,eAAA;EACA,MAAA;EACA,UAAA;AAinpBR;AA9mpBM;EACE,eAAA;EACA,SAAA;EACA,UAAA;AAgnpBR;AA7mpBM;EACE,eAAA;EACA,QAAA;EACA,SAAA;AA+mpBR;AA5mpBM;EACE,UAAA;EACA,QAAA;AA8mpBR;AA3mpBM;EACE,eAAA;EACA,SAAA;AA6mpBR;AA1mpBM;EACE,eAAA;EACA,SAAA;EACA,UAAA;AA4mpBR;AAzmpBM;EACE,eAAA;EACA,QAAA;EACA,UAAA;AA2mpBR;AAxmpBM;EACE,SAAA;EACA,eAAA;AA0mpBR;AAvmpBM;EACE,eAAA;EACA,SAAA;EACA,SAAA;AAympBR;AAtmpBM;EACE,eAAA;EACA,SAAA;EACA,SAAA;AAwmpBR;AArmpBM;EACE,QAAA;EACA,eAAA;AAumpBR;AApmpBM;EACE,QAAA;AAsmpBR;AAnmpBM;EACE,eAAA;EACA,UAAA;EACA,SAAA;AAqmpBR;AAlmpBM;EACE,eAAA;EACA,UAAA;EACA,QAAA;AAompBR;AAjmpBM;EACE,eAAA;EACA,UAAA;EACA,QAAA;AAmmpBR;AAhmpBM;EACE,eAAA;EACA,UAAA;EACA,QAAA;AAkmpBR;AA/lpBM;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EAAA,yBAAA;EACA,mBAAA;EACA,sBAAA;AAimpBR;AA/lpBQ;EACE,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,UAAA;AAimpBV;AA/lpBU;EANF;IAOI,UAAA;EAkmpBV;AACF;AA9lpBM;EACE,cAAA;EAAA,yBAAA;AAgmpBR;AA7lpBM;EACE,gBAAA;EAAA,2BAAA;EACA,eAAA;AA+lpBR;AA5lpBM;EACE,gBAAA;EAAA,2BAAA;EACA,eAAA;AA8lpBR;AA3lpBM;EAEE,gBAAA;EAAA,2BAAA;EACA,gBAAA;EACA,eAAA;AA4lpBR;AAvlpBE;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,gCAAA;EAAA,gDAAA;AAylpBJ;AAvlpBI;EARF;IASI,aAAA;EA0lpBJ;AACF;AAvlpBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,yBAAA;AAylpBJ;AAtlpBM;EACE,WAAA;EACA,YAAA;AAwlpBR;AArlpBM;EACE,WAAA;EACA,YAAA;AAulpBR;AAplpBM;EACE,WAAA;EACA,gBAAA;AAslpBR;AAllpBI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;AAolpBN;AAjlpBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAmlpBN;AA9kpBI;EACE,WAAA;AAglpBN;AA9kpBM;EACE,qBAAA;AAglpBR;AA7kpBM;EACE,qBAAA;AA+kpBR;AA5kpBM;EACE,UAAA;EACA,SAAA;EACA,yBAAA;AA8kpBR;AA1kpBI;EACE,iBAAA;AA4kpBN;AA1kpBM;EAHF;IAII,cAAA;EA6kpBN;AACF;AAzkpBE;EACE,SAAA;EACA,kBAAA;EAAA,iCAAA;EACA,iCAAA;EACA,gBAAA;EACA,aAAA;AA2kpBJ;AAzkpBI;EAPF;IAQI,cAAA;EA4kpBJ;AACF;AAzkpBE;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AA2kpBJ;AAxkpBE;EACE,yBAAA;EAAA,yCAAA;EACA,gCAAA;EAAA,gDAAA;EACA,YAAA;EACA,gBAAA;AA0kpBJ;AAxkpBI;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AA0kpBN;AAxkpBM;EANF;IAOI,sBAAA;EA2kpBN;AACF;AA1kpBM;EACE,kBAAA;EACA,yBAAA;AA4kpBR;AA1kpBQ;EACE,SAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EAAA,yCAAA;EACA,kBAAA;EACA,yBAAA;EAAA,yCAAA;EACA,cAAA;EAAA,yBAAA;EACA,eAAA;AA4kpBV;AA3kpBU;EACE,aAAA;EACA,uBAAA;EAAA,kCAAA;AA6kpBZ;AA3kpBU;EACE,cAAA;EAAA,iCAAA;AA6kpBZ;AAtkpBE;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EAAA,yCAAA;EACA,yBAAA;EAAA,qCAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;AAwkpBJ;AAtkpBI;EACE,kBAAA;EACA,cAAA;EAAA,yBAAA;EACA,eAAA;AAwkpBN;AApkpBM;EACE,gCAAA;EAAA,gDAAA;AAskpBR;AAlkpBI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AAokpBN;AAlkpBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EAAA,yBAAA;AAokpBR;AAlkpBQ;EACE,gBAAA;EAAA,2BAAA;AAokpBV;AAhkpBM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,2BAAA;EAAA,kDAAA;EACA,gBAAA;EAAA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAkkpBR;AA/jpBM;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EAAA,2BAAA;EACA,gBAAA;AAikpBR;AAhkpBQ;EACE,0BAAA;AAkkpBV;AA7jpBI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AA+jpBN;AA5jpBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AA8jpBN;AA5jpBM;EAEE,yBAAA;EAAA,wCAAA;AA6jpBR;AA1jpBM;EACE,WAAA;EACA,YAAA;EACA,cAAA;AA4jpBR;AA1jpBQ;EACE,eAAA;EACA,cAAA;AA4jpBV;AAxjpBM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AA0jpBR;AAvjpBM;EACE,eAAA;EACA,cAAA;EAAA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAyjpBR;AAtjpBM;EACE,eAAA;EACA,cAAA;EAAA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAwjpBR;AArjpBM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAujpBR;AArjpBQ;EACE,yCAAA;EACA,cAAA;EAAA,yBAAA;AAujpBV;AArjpBQ;EACE,yBAAA;EAAA,kDAAA;EACA,cAAA;EAAA,yBAAA;AAujpBV;AAjjpBE;EACE,SAAA;EACA,gBAAA;EACA,yBAAA;EAAA,yCAAA;AAmjpBJ;AAjjpBI;EALF;IAMI,4BAAA;EAojpBJ;AACF;;AAhjpBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EAEA,cAAA;EAAA,yBAAA;AAkjpBF;AAhjpBE;EACE,UAAA;AAkjpBJ;AA/ipBE;EACE,gBAAA;EACA,sBAAA;AAijpBJ;AA9ipBE;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EAAA,sCAAA;EACA,cAAA;EAAA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAgjpBJ;AA7ipBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kCAAA;EACA,sBAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AA+ipBJ;AA5ipBE;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AA8ipBJ;AA5ipBI;EACE,mBAAA;AA8ipBN;AA3ipBI;EACE,mBAAA;AA6ipBN;AAzipBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,MAAA;AA2ipBJ;AAxipBE;EACE,qBAAA;EACA,kCAAA;AA0ipBJ;AAvipBE;EACE,gBAAA;AAyipBJ;;AAripBA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EAAA,8BAAA;EACA,eAAA;EACA,gBAAA;AAwipBF;AAtipBE;EACE,mBAAA;AAwipBJ;AAtipBI;EACE,qBAAA;AAwipBN;AAripBI;EACE,qBAAA;AAuipBN;AAnipBM;EACE,yBAAA;EAAA,wCAAA;AAqipBR;AAlipBM;EACE,eAAA;AAoipBR;AArjpBE;EAqBE,WAAA;AAmipBJ;AAjipBI;EACE,gCAAA;EAAA,gDAAA;EACA,yBAAA;EAAA,yCAAA;AAmipBN;AAjipBM;EACE,qBAAA;AAmipBR;AAhipBM;EACE,qBAAA;AAkipBR;AA/hpBM;EACE,mBAAA;AAiipBR;AA9hpBM;EACE,yBAAA;EAAA,yCAAA;AAgipBR;AA9hpBQ;EACE,oCAAA;AAgipBV;AA7hpBQ;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AA+hpBV;AA5hpBQ;EACE,UAAA;AA8hpBV;AA3hpBQ;EACE,yBAAA;EAAA,yCAAA;AA6hpBV;AAxhpBI;EACE,YAAA;AA0hpBN;AAvhpBI;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EAAA,yBAAA;EACA,sBAAA;AAyhpBN;AAvhpBM;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAyhpBR;AAvhpBQ;EACE,gBAAA;EACA,uBAAA;AAyhpBV;AArhpBM;EACE,SAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AAuhpBR;AAphpBM;;;EAGE,gBAAA;AAshpBR;AArhpBQ;;;EACE,gBAAA;EACA,cAAA;EAAA,yBAAA;AAyhpBV;AAvhpBQ;;;EACE,cAAA;EAAA,wBAAA;AA2hpBV;AAzhpBQ;;;EACE,aAAA;AA6hpBV;AAzhpBM;EACE,eAAA;AA2hpBR;AAxhpBM;EACE,eAAA;EACA,gBAAA;EAAA,2BAAA;AA0hpBR;AAvhpBM;EACE,UAAA;AAyhpBR;AArhpBQ;EACE,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,wBAAA;AAuhpBV;AArhpBU;EACE,eAAA;EACA,aAAA;EACA,sBAAA;AAuhpBZ;AArhpBY;EACE,gBAAA;EAAA,2BAAA;AAuhpBd;AAjhpBM;EACE,UAAA;EACA,6BAAA;EACA,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAmhpBR;AAjhpBQ;EACE,kBAAA;EACA,qBAAA;AAmhpBV;AAhhpBQ;EACE,gBAAA;EAAA,2BAAA;EACA,eAAA;EACA,eAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;EAAA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AAkhpBV;AA/gpBQ;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EAAA,mCAAA;EACA,yBAAA;EAAA,yCAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAihpBV;AA/gpBU;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AAihpBZ;AA7gpBQ;EACE,iBAAA;EACA,eAAA;EACA,eAAA;EACA,wBAAA;EACA,sCAAA;AA+gpBV;AA7gpBU;EACE,yBAAA;EAAA,yCAAA;AA+gpBZ;AAzgpBI;EACE,gCAAA;EAAA,gDAAA;EACA,iBAAA;EACA,yBAAA;EAAA,yCAAA;AA2gpBN;AAzgpBM;EACE,UAAA;AA2gpBR;AAxgpBM;EACE,gBAAA;EACA,mBAAA;AA0gpBR;AAvgpBM;EACE,kBAAA;EACA,eAAA;EACA,wBAAA;EACA,cAAA;EAAA,yBAAA;EACA,sBAAA;AAygpBR;AAvgpBQ;EACE,cAAA;EAAA,wBAAA;EACA,UAAA;AAygpBV;AArgpBM;;EAEE,gBAAA;EAAA,2BAAA;AAugpBR;AApgpBM;EACE,kBAAA;EACA,QAAA;AAsgpBR;AAngpBM;EACE,QAAA;AAqgpBR;AAlgpBM;EACE,gBAAA;EAAA,2BAAA;AAogpBR;AAjgpBM;EACE,UAAA;AAmgpBR;AAhgpBM;EAKE,WAAA;AA8/oBR;AA5/oBM;EACE,WAAA;AA8/oBR;AA5/oBM;EACE,UAAA;AA8/oBR;AA5/oBM;EACE,WAAA;EACA,eAAA;AA8/oBR;AA1/oBI;EACE,yBAAA;EAAA,yCAAA;AA4/oBN;AAz/oBI;EACE,kBAAA;EACA,uEAAA;EAAA,sFAAA;AA2/oBN;AAv/oBM;EACE,UAAA;AAy/oBR;AAr/oBI;EACE,2BAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AAu/oBN;AAp/oBI;EACE,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAs/oBN;AAn/oBI;EACE,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AAq/oBN;;AAh/oBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,oLACE;AAk/oBJ;;AA3+oBA;EACE,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AA8+oBF;AA5+oBE;EAQE,yBAAA;EACA,qBAAA;EACA,cAAA;AAu+oBJ;AAp+oBE;EAOE,yBAAA;EACA,qBAAA;EACA,cAAA;AAg+oBJ;AA79oBE;EAUE,yBAAA;EACA,qBAAA;EACA,cAAA;AAs9oBJ;AAn9oBE;EAIE,yBAAA;EACA,qBAAA;EACA,cAAA;AAk9oBJ;AA/8oBE;EAEE,yBAAA;EACA,qBAAA;EACA,cAAA;AAg9oBJ;AA78oBE;EAIE,yBAAA;EACA,qBAAA;EACA,cAAA;AA48oBJ;AAz8oBE;EAEE,yBAAA;EACA,qBAAA;EACA,cAAA;AA08oBJ;AAv8oBE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAy8oBJ;AAt8oBE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAw8oBJ;AAr8oBE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;AAu8oBJ;AAp8oBE;EACE,yBAAA;EAAA,kDAAA;EACA,qBAAA;EACA,cAAA;EAAA,yBAAA;AAs8oBJ;;AAh8oBE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EAAA,yCAAA;EACA,kBAAA;AAm8oBJ;AAh8oBE;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;AAk8oBJ;AA/7oBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EAAA,2BAAA;EACA,cAAA;EACA,SAAA;AAi8oBJ;AA97oBE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EAAA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAg8oBJ;AA77oBE;EACE,mBAAA;EACA,cAAA;EAAA,yBAAA;EACA,kBAAA;AA+7oBJ;AA57oBE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA87oBJ;AA37oBE;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AA67oBJ;AA37oBI;EACE,aAAA;EACA,+BAAA;EAAA,sDAAA;AA67oBN;AA17oBI;EACE,yBAAA;EAAA,gDAAA;EACA,cAAA;EAAA,gCAAA;EACA,YAAA;EACA,2CAAA;AA47oBN;AA17oBM;EACE,YAAA;AA47oBR;AAx7oBI;EACE,yBAAA;EAAA,uDAAA;EACA,cAAA;EAAA,uCAAA;EACA,yBAAA;EAAA,qCAAA;EACA,2CAAA;AA07oBN;AAx7oBM;EACE,yBAAA;EAAA,kDAAA;AA07oBR;;AAp7oBA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,gBAAA;AAu7oBF;AAr7oBE;EACE,sBAAA;EACA,4BAAA;EACA,4BAAA;EACA,4BAAA;EACA,yBAAA;EAAA,oCAAA;EACA,wEACE;EAEF,UAAA;EACA,6BAAA;AAq7oBJ;AAn7oBI;EACE,UAAA;AAq7oBN;AAj7oBE;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAm7oBJ;AAh7oBE;EACE,6BAAA;EACA,cAAA;EAAA,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAk7oBJ;AAh7oBI;EACE,gBAAA;EAAA,2BAAA;AAk7oBN;AA/6oBI;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EAAA,kCAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAi7oBN;;AA56oBA;EACE,0BAAA;EAAA,6BAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EAAA,wBAAA;EACA,UAAA;EACA,6BAAA;AA+6oBF;AA76oBE;EACE,UAAA;AA+6oBJ;AA56oBE;EACE,gBAAA;AA86oBJ;AA36oBM;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AA66oBR;AA36oBQ;EACE,yBAAA;EAAA,wCAAA;AA66oBV;AA16oBQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA46oBV;AAz6oBQ;EACE,eAAA;EACA,cAAA;EAAA,yBAAA;AA26oBV;AAr6oBE;EACE,cAAA;EAAA,yBAAA;EACA,yBAAA;EAAA,oCAAA;EACA,kBAAA;EACA,eAAA;AAu6oBJ;AAr6oBI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EAAA,yBAAA;EACA,yBAAA;EAAA,oCAAA;AAu6oBN;AAr6oBM;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EAAA,yBAAA;AAu6oBR;AAp6oBM;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,eAAA;EACA,kCAAA;EACA,sBAAA;EACA,4BAAA;AAs6oBR;AAl6oBI;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;AAo6oBN;AAj6oBI;EACE,kBAAA;EACA,cAAA;AAm6oBN;AAh6oBI;EACE,qBAAA;EACA,kBAAA;AAk6oBN;AA/5oBI;EACE,iBAAA;EACA,sBAAA;EACA,eAAA;AAi6oBN;AA/5oBM;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AAi6oBR;AA/5oBQ;EACE,kBAAA;EACA,SAAA;AAi6oBV;AA75oBM;EACE,2BAAA;EAAA,sCAAA;AA+5oBR;AA75oBQ;EACE,2BAAA;EAAA,sCAAA;AA+5oBV;AA15oBI;EACE,mBAAA;AA45oBN;;AAv5oBA;;;;EAIE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EAEA,UAAA;EACA,6BAAA;AAy5oBF;AAx5oBE;;;;EACE,UAAA;EACA,oBAAA;AA65oBJ;AA35oBE;;;;EACE,UAAA;EACA,oBAAA;AAg6oBJ;;AA55oBA;;;EAGE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EAAA,yCAAA;EACA,kBAAA;EACA,wEACE;EAEF,aAAA;EACA,gBAAA;EACA,cAAA;AA65oBF;;AA15oBA;;;;EAIE,gBAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;EACA,6BAAA;AA65oBF;AA55oBE;;;;EACE,UAAA;AAi6oBJ;AA/5oBE;;;;EACE,UAAA;AAo6oBJ;AAj7oBA;;;;EAeE,aAAA;EACA,aAAA;AAw6oBF;AAt6oBE;;;;EACE,gBAAA;EAAA,2BAAA;EACA,eAAA;EACA,qBAAA;AA26oBJ;AAx6oBE;;;;EACE,eAAA;EACA,cAAA;EACA,aAAA;AA66oBJ;AA36oBI;;;;EACE,aAAA;EACA,gCAAA;EACA,cAAA;EAAA,SAAA;AAg7oBN;AA76oBI;;;;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AAk7oBN;AAh7oBM;;;;EACE,aAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;AAq7oBR;AAl7oBM;;;;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAu7oBR;AAn7oBQ;;;;EACE,4BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAw7oBV;AAn7oBI;;;;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAw7oBN;AAr7oBI;;;;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EAAA,SAAA;AA07oBN;AAv7oBI;;;;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA47oBN;AA17oBM;;;;EACE,eAAA;EACA,gBAAA;EAAA,2BAAA;EACA,2BAAA;AA+7oBR;AA77oBQ;;;;EACE,gCAAA;AAk8oBV;AA77oBI;;;;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAk8oBN;AA/7oBI;;;;EACE,gBAAA;AAo8oBN;AAj8oBI;;;;EACE,gBAAA;EACA,+CAAA;EACA,kBAAA;EACA,yBAAA;EAAA,qCAAA;AAs8oBN;AAp8oBM;;;;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAy8oBR;AAt8oBM;;;;EACE,SAAA;EACA,kCAAA;EACA,kBAAA;AA28oBR;AAt8oBI;;;;EACE,gBAAA;AA28oBN;AAz8oBM;;;;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AA88oBR;AA38oBM;;;;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,+CAAA;AAg9oBR;AA98oBQ;;;;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EAAA,yCAAA;EACA,yBAAA;EAAA,qCAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;EAAA,kBAAA;AAm9oBV;AAj9oBU;;;;EACE,iBAAA;AAs9oBZ;AAn9oBU;;;;EACE,kBAAA;AAw9oBZ;AAr9oBU;;;;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AA09oBZ;AAv9oBU;;;;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AA49oBZ;AA19oBY;;;;EACE,cAAA;AA+9oBd;AA39oBc;;;;EACE,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AAg+oBhB;AA39oBU;;;;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAg+oBZ;AA79oBU;;;;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;AAk+oBZ;AA/9oBU;;;;EACE,eAAA;EACA,cAAA;AAo+oBZ;AAh+oBY;;;;EACE,gBAAA;AAq+oBd;AA/9oBc;;;;EACE,iBAAA;AAo+oBhB;AA99oBQ;;;;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAm+oBV;AAh+oBQ;;;;EACE,kBAAA;EACA,kCAAA;EACA,kBAAA;EACA,kBAAA;AAq+oBV;;AA59oBE;EACE,SAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EAAA,sCAAA;AA+9oBJ;AA79oBI;EACE,yBAAA;EAAA,uDAAA;EACA,cAAA;EAAA,uCAAA;EACA,yBAAA;EAAA,qCAAA;AA+9oBN;AA79oBM;EACE,2BAAA;EAAA,sCAAA;EACA,cAAA;EAAA,yBAAA;AA+9oBR;AA19oBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;AA49oBJ;AA19oBI;EACE,eAAA;EACA,cAAA;AA49oBN;AAx9oBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EAAA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA09oBJ;AAx9oBI;EACE,eAAA;AA09oBN;AAv9oBI;EACE,0BAAA;AAy9oBN;AAr9oBE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAu9oBJ;AAr9oBI;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAu9oBN;AAn9oBE;EACE,YAAA;AAq9oBJ;AAl9oBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAo9oBJ;AAj9oBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAm9oBJ;AAh9oBE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAk9oBJ;AAh9oBI;EACE,cAAA;AAk9oBN;AA/8oBI;EACE,cAAA;AAi9oBN;AA98oBI;EACE,cAAA;AAg9oBN;AA78oBI;EACE,cAAA;AA+8oBN;AA38oBE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,0CAAA;AA68oBJ;AA18oBE;EACE,eAAA;EACA,gBAAA;AA48oBJ;AAz8oBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;EACA,kCAAA;AA28oBJ;AAz8oBI;EACE,cAAA;AA28oBN;AAv8oBE;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;EACA,yBAAA;EAAA,qCAAA;AAy8oBJ;AAt8oBE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kCAAA;EACA,kBAAA;AAw8oBJ;AAr8oBE;EACE,qBAAA;EACA,iBAAA;AAu8oBJ;AAp8oBE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;AAs8oBJ;AAn8oBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EAAA,qCAAA;EACA,yBAAA;EAAA,kDAAA;AAq8oBJ;AAl8oBE;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;AAo8oBJ;AAj8oBE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AAm8oBJ;AAj8oBI;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAm8oBN;AAj8oBM;EACE,eAAA;AAm8oBR;AA/7oBI;EACE,2BAAA;EACA,oBAAA;AAi8oBN;AA/7oBM;EACE,2BAAA;AAi8oBR;AA97oBM;EACE,2BAAA;EAAA,kDAAA;EACA,yBAAA;AAg8oBR;AA37oBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AA67oBJ;AA17oBE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;AA47oBJ;AAz7oBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,2BAAA;AA27oBJ;AAx7oBE;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EAAA,qCAAA;EACA,yBAAA;EAAA,yCAAA;AA07oBJ;AAx7oBI;EACE,gBAAA;AA07oBN;AAt7oBE;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;EAAA,2BAAA;AAw7oBJ;AAr7oBE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;AAu7oBJ;AAr7oBI;EACE,cAAA;EACA,cAAA;AAu7oBN;AAp7oBI;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EAAA,qCAAA;AAs7oBN;AAl7oBE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,oBAAA;AAo7oBJ;AAj7oBE;EACE,kBAAA;AAm7oBJ;AAj7oBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EAAA,qCAAA;AAm7oBN;AAh7oBI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAk7oBN;AA96oBE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;AAg7oBJ;AA76oBE;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EAAA,qCAAA;EACA,yBAAA;EAAA,iDAAA;EACA,6BAAA;AA+6oBJ;AA76oBI;EACE,uBAAA;EAAA,kCAAA;AA+6oBN;AA56oBI;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;EAAA,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA86oBN;AA16oBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,6BAAA;EAAA,yCAAA;AA46oBJ;AAz6oBE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EAAA,yBAAA;EACA,eAAA;EACA,eAAA;AA26oBJ;AAz6oBI;EACE,yBAAA;EAAA,kDAAA;EACA,gBAAA;EAAA,2BAAA;AA26oBN;AAx6oBI;EACE,YAAA;EACA,eAAA;AA06oBN;AAt6oBE;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;AAw6oBJ;;AAp6oBA;EACE;IACE,UAAA;EAu6oBF;EAr6oBA;IACE,UAAA;EAu6oBF;AACF;AAn6oBE;EACE,wBAAA;AAq6oBJ;AAl6oBE;EACE,yBAAA;AAo6oBJ;AAj6oBE;;;;EAIE,oCAAA;AAm6oBJ;AAh6oBE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AAk6oBJ;AAh6oBI;EAOE,yBAAA;EACA,qBAAA;EACA,cAAA;AA45oBN;AAz5oBI;EAIE,yBAAA;EACA,qBAAA;EACA,cAAA;AAw5oBN;AAr5oBI;EAOE,yBAAA;EACA,qBAAA;EACA,cAAA;AAi5oBN;AA94oBI;EAGE,yBAAA;EACA,qBAAA;EACA,cAAA;AA84oBN;AA34oBI;EAEE,yBAAA;EACA,qBAAA;EACA,cAAA;AA44oBN;AAz4oBI;EAEE,yBAAA;EACA,qBAAA;EACA,cAAA;AA04oBN;;AAr4oBA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,2BAAA;EAAA,sCAAA;EACA,cAAA;EAAA,gCAAA;EACA,aAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,kCAAA;EACA,UAAA;EACA,iCAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AAw4oBF;AAt4oBE;EACE,UAAA;AAw4oBJ;AAr4oBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAu4oBJ;AAr4oBI;EACE,iBAAA;AAu4oBN;AAp4oBI;EACE,cAAA;EAAA,yBAAA;AAs4oBN;;AAh4oBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EAAA,sCAAA;EACA,cAAA;EAAA,gCAAA;EACA,eAAA;EACA,cAAA;EACA,iCAAA;AAm4oBF;AAj4oBE;EACE,UAAA;AAm4oBJ;AAh4oBE;EACE,eAAA;AAk4oBJ;;AA93oBA;EACE;IACE,iCAAA;IACA,UAAA;EAi4oBF;EA/3oBA;IACE,6BAAA;IACA,UAAA;EAi4oBF;AACF;AA93oBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;AAg4oBF;;AA73oBA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EAAA,oCAAA;EACA,kBAAA;EACA,wEACE;EAEF,aAAA;AA83oBF;;AA33oBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA83oBF;;AA33oBA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EAAA,oCAAA;EACA,kBAAA;EACA,wEACE;EAEF,aAAA;EACA,aAAA;AA43oBF;AA13oBE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AA43oBJ;AAz3oBE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AA23oBJ;AAz3oBI;EACE,uBAAA;EACA,kBAAA;AA23oBN;;AAt3oBA;EACE,4BAAA;EACA,QAAA;EACA,QAAA;EACA,gBAAA;EACA,qBAAA;EAAA,wBAAA;EACA,oCAAA;EAAA,4DAAA;EACA,wCAAA;EACA,2CAAA;UAAA,mCAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EAAA,yBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;AAy3oBF;AAv3oBE;EACE,iCAAA;AAy3oBJ;AAt3oBE;EACE,QAAA;AAw3oBJ;AAr3oBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAu3oBJ;AAp3oBE;EACE,aAAA;EACA,gBAAA;AAs3oBJ;AAn3oBE;EACE,kBAAA;EACA,gBAAA;AAq3oBJ;AAn3oBI;EACE,eAAA;AAq3oBN;AAl3oBI;;;EAGE,eAAA;AAo3oBN;AAj3oBI;EACE,6BAAA;EAAA,yBAAA;EACA,2CAAA;AAm3oBN;AAj3oBM;EACE,2CAAA;AAm3oBR;AAh3oBM;;EAEE,YAAA;EACA,0BAAA;EACA,eAAA;AAk3oBR;AA72oBE;EACE,UAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AA+2oBJ;AA72oBI;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;AA+2oBN;AA52oBI;;EAEE,cAAA;EAAA,yBAAA;AA82oBN;AA32oBI;EACE,gBAAA;EAAA,2BAAA;AA62oBN;AAz2oBE;EACE,kBAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,qCAAA;AA22oBJ;AAz2oBI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;AA22oBN;AAx2oBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AA02oBN;AAv2oBI;EACE,gBAAA;AAy2oBN;AAt2oBI;EACE,mBAAA;AAw2oBN;AAt2oBM;EACE,gBAAA;AAw2oBR;AAl2oBI;EACE,WAAA;EACA,mBAAA;AAo2oBN;AAh2oBE;EACE,gBAAA;AAk2oBJ;AA/1oBE;EACE,cAAA;EAAA,gCAAA;EACA,yBAAA;EAAA,gDAAA;EACA,kBAAA;EACA,WAAA;AAi2oBJ;AA/1oBI;EACE,yBAAA;EACA,gBAAA;EAAA,2BAAA;AAi2oBN;AA91oBI;EACE,yBAAA;EAAA,uDAAA;EACA,cAAA;EAAA,uCAAA;EACA,kBAAA;EACA,WAAA;AAg2oBN;AA71oBI;EACE,2BAAA;EAAA,sCAAA;EACA,cAAA;EAAA,yBAAA;AA+1oBN;;AA11oBA;EACE,UAAA;EACA,qCAAA;AA61oBF;;AA11oBA;EACE,UAAA;AA61oBF;;AA11oBA;EACE,UAAA;AA61oBF;;AA11oBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA61oBF;;AA11oBA;EACE,eAAA;EACA,kBAAA;AA61oBF;;AA11oBA;EACE,kBAAA;EACA,mBAAA;EAAA,mCAAA;EACA,kBAAA;EACA,wEACE;EAEF,aAAA;EACA,aAAA;EACA,YAAA;AA21oBF;;AAx1oBA;EACE,aAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AA21oBF;AAz1oBE;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;AA21oBJ;AAx1oBE;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;AA01oBJ;AAv1oBE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAy1oBJ;AAt1oBE;EACE,SAAA;EACA,iBAAA;EACA,eAAA;AAw1oBJ;AAr1oBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,4CAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCAAA;UAAA,0BAAA;EACA,UAAA;AAu1oBJ;AAt1oBI;EACE,YAAA;EACA,aAAA;AAw1oBN;;AAn1oBA;;EAEE,WAAA;EACA,gBAAA;AAs1oBF;;AAn1oBA;EACE,4BAAA;EACA,gBAAA;AAs1oBF;;AAn1oBA;EACE,WAAA;EACA,gBAAA;AAs1oBF;;AAj1oBI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAo1oBN;AAl1oBQ;;EAEE,YAAA;AAo1oBV;AAl1oBQ;EACE,aAAA;AAo1oBV;AAl1oBQ;EACE,0BAAA;AAo1oBV;;AA70oBA;;;;;;EAME,aAAA;EACA,sBAAA;AAg1oBF;AA90oBE;;;;;;EACE,aAAA;EACA,sBAAA;AAq1oBJ;AAn1oBI;;;;;;EACE,gBAAA;EACA,kBAAA;AA01oBN;AAv1oBI;;;;;;;;;;;;;;;;;;EAGE,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AAw2oBN;AAv2oBM;;;;;;;;;;;;;;;;;;EACE,YAAA;EACA,yBAAA;EAAA,yCAAA;AA03oBR;AAt3oBI;;;;;;EACE,yBAAA;EAAA,yCAAA;EACA,cAAA;EAAA,2BAAA;AA63oBN;AA13oBI;;;;;;EACE,0BAAA;AAi4oBN;AA93oBI;;;;;;;;;;;;EAEE,wBAAA;EACA,SAAA;AA04oBN;AAt4oBE;;;;;;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;AA64oBJ;AA14oBE;;;;;;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EAAA,2BAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;AAi5oBJ;AA94oBE;;;;;;EACE,yBAAA;EAAA,yCAAA;AAq5oBJ;;AAj5oBA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0BAAA;EAAA,kBAAA;EACA,kBAAA;AAo5oBF;AAl5oBE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAo5oBJ;AAj5oBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EAAA,4CAAA;EACA,yBAAA;EAAA,yCAAA;EACA,oBAAA;EACA,gCAAA;EACA,QAAA;AAm5oBJ;AAj5oBI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EAAA,8BAAA;EACA,yBAAA;EAAA,yCAAA;EACA,kBAAA;EACA,+BAAA;AAm5oBN;AA/4oBE;EACE,qBAAA;EAAA,gCAAA;EACA,uBAAA;EAAA,kCAAA;AAi5oBJ;AA94oBE;EACE,2BAAA;EACA,uBAAA;EAAA,kCAAA;AAg5oBJ;AA74oBE;EACE,gBAAA;EACA,cAAA;EAAA,yBAAA;AA+4oBJ;;AA34oBE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AA84oBJ;AA74oBI;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;AA+4oBN;AA94oBM;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AAg5oBR;;AAz4oBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AA44oBJ;AAz4oBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,yBAAA;AA24oBJ;AAx4oBE;EACE,YAAA;EACA,uBAAA;EACA,gBAAA;EAAA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AA04oBJ;AAv4oBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAy4oBJ;AAt4oBE;EACE,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,yBAAA;AAw4oBJ;AAr4oBE;EACE,aAAA;EACA,yCAAA;EACA,aAAA;EAAA,QAAA;EACA,mBAAA;AAu4oBJ;AAp4oBE;EACE,WAAA;EACA,YAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,yBAAA;AAs4oBJ;AAn4oBE;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAq4oBJ;AAl4oBE;EAEE,eAAA;EACA,eAAA;EACA,gBAAA;AAm4oBJ;AAh4oBE;EACE,0BAAA;EACA,gBAAA;AAk4oBJ;AA/3oBE;EACE,yBAAA;AAi4oBJ;;AA53oBE;EACE,qBAAA;EAAA,4CAAA;EACA,2BAAA;EAAA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;EACA,mBAAA;AA+3oBJ;AA73oBI;EACE,gBAAA;EAAA,2BAAA;AA+3oBN;AA33oBE;EACE,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA63oBJ;AA13oBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AA43oBJ;AAz3oBE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EAAA,2BAAA;AA23oBJ;AAx3oBE;EACE,eAAA;AA03oBJ;AAv3oBE;EACE,mBAAA;EAAA,yCAAA;EACA,yBAAA;EAAA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;EACA,gBAAA;AAy3oBJ;;AAr3oBA;EACE,YAAA;EACA,eAAA;AAw3oBF;AAt3oBE;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAw3oBJ;AAr3oBE;EACE,YAAA;EACA,uBAAA;EACA,gBAAA;EAAA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,eAAA;EACA,UAAA;AAu3oBJ;AAp3oBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAAA,mCAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAs3oBJ;AAp3oBI;EACE,wCAAA;EACA,+DAAA;EACA,uCAAA;EACA,qEAAA;EACA,4CAAA;EACA,cAAA;EAAA,yBAAA;EACA,SAAA;AAs3oBN;AAl3oBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAo3oBJ;AAj3oBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAm3oBJ;AAh3oBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,yBAAA;AAk3oBJ;AA/2oBE;EACE,aAAA;EACA,0EAAA;EACA,aAAA;EAAA,QAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AAi3oBJ;AA92oBE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAg3oBJ;;AA52oBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AA+2oBF;AA72oBE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AA+2oBJ;AA52oBE;EACE,WAAA;EACA,mBAAA;AA82oBJ;;AAz2oBE;EACE,YAAA;EACA,gBAAA;EACA,YAAA;AA42oBJ;AAz2oBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,+BAAA;AA22oBJ;AAx2oBE;EACE,eAAA;EACA,YAAA;AA02oBJ;AAv2oBE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAy2oBJ;AAt2oBE;EACE,SAAA;AAw2oBJ;;AAp2oBA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAu2oBF;;AAp2oBA;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAu2oBF;AAr2oBE;EACE,YAAA;AAu2oBJ;AAp2oBE;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;AAs2oBJ;AAn2oBE;EACE,kBAAA;AAq2oBJ;AAl2oBE;EACE,kBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,+BAAA;AAo2oBJ;AAl2oBI;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EAAA,yBAAA;AAo2oBN;AAj2oBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;AAm2oBN;AA/1oBE;EACE,WAAA;AAi2oBJ;AA91oBE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AAg2oBJ;AA91oBI;EACE,SAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAg2oBN;AA91oBM;EACE,aAAA;EACA,qBAAA;EAAA,4CAAA;AAg2oBR;AA51oBI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AA81oBN;AA11oBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AA41oBJ;AA11oBI;EACE,aAAA;EACA,qBAAA;EAAA,4CAAA;AA41oBN;AAx1oBE;EACE,mBAAA;EACA,eAAA;EACA,cAAA;AA01oBJ;AAv1oBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAy1oBJ;AAv1oBI;EACE,eAAA;AAy1oBN;AAt1oBI;EACE,WAAA;EACA,eAAA;AAw1oBN;;AAl1oBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;AAq1oBF;AAn1oBE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AAq1oBJ;AAl1oBE;EACE,wEACE;EAEF,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EAGA,cAAA;EAAA,yBAAA;EACA,2BAAA;EAAA,sCAAA;AAg1oBJ;AA90oBI;EACE,yBAAA;EAAA,oCAAA;EACA,gBAAA;EAAA,2BAAA;AAg1oBN;AA50oBI;EACE,gBAAA;EAAA,2BAAA;EACA,yBAAA;EAAA,oCAAA;AA80oBN;AA50oBM;EACE,2BAAA;EAAA,sCAAA;EACA,cAAA;EAAA,yBAAA;AA80oBR;AA10oBI;EACE,yBAAA;EAAA,mCAAA;EACA,8CAAA;EACA,2BAAA;EACA,mBAAA;AA40oBN;;AAt0oBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;AAy0oBF;AAv0oBE;EACE,SAAA;AAy0oBJ;;AAr0oBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAw0oBF;AAv0oBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;AAy0oBJ;AAv0oBI;EACE,SAAA;AAy0oBN;AAt0oBE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAw0oBJ;;AAn0oBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAs0oBJ;AAn0oBE;EACE,uBAAA;AAq0oBJ;AAl0oBE;EACE,eAAA;EACA,6BAAA;EAAA,yCAAA;AAo0oBJ;AAj0oBE;EACE,wBAAA;EAAA,gBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;AAm0oBJ;AAh0oBE;EACE,SAAA;EACA,YAAA;AAk0oBJ;AA/zoBE;EACE,gBAAA;AAi0oBJ;AA9zoBE;EACE,YAAA;EACA,eAAA;AAg0oBJ;AA7zoBE;EACE,kBAAA;AA+zoBJ;AA5zoBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA8zoBJ;AA3zoBE;EACE,gBAAA;AA6zoBJ;AA1zoBE;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EAAA,qCAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AA4zoBJ;AA1zoBI;EACE,YAAA;AA4zoBN;AAxzoBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AA0zoBJ;AAvzoBE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AAyzoBJ;AAvzoBI;;EAEE,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gCAAA;EAAA,qDAAA;AAyzoBN;AAtzoBI;EACE,gBAAA;EACA,aAAA;AAwzoBN;AApzoBE;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EAAA,2CAAA;EACA,kBAAA;AAszoBJ;AAnzoBE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAqzoBJ;AAlzoBE;EACE,eAAA;EACA,gBAAA;AAozoBJ;AAjzoBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;AAmzoBJ;AAhzoBE;EACE,YAAA;AAkzoBJ;AA/yoBE;EACE,WAAA;EAAA,+BAAA;EACA,gBAAA;EACA,mBAAA;AAizoBJ;AA9yoBE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAgzoBJ;AA7yoBE;EACE,eAAA;AA+yoBJ;AA5yoBE;EACE,aAAA;EACA,2DAAA;EACA,mBAAA;EAAA,cAAA;EACA,kBAAA;AA8yoBJ;AA3yoBE;EACE,eAAA;AA6yoBJ;AA1yoBE;EACE,eAAA;AA4yoBJ;AAzyoBE;EACE,eAAA;AA2yoBJ;AAzyoBI;EACE,WAAA;EACA,YAAA;AA2yoBN;AAvyoBE;EACE,WAAA;AAyyoBJ;AAtyoBE;EACE,YAAA;AAwyoBJ;AAryoBE;EACE,eAAA;AAuyoBJ;AApyoBE;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EAAA,8CAAA;EACA,kBAAA;EACA,mBAAA;EAAA,yCAAA;EACA,eAAA;AAsyoBJ;AApyoBI;EACE,gBAAA;EACA,gBAAA;AAsyoBN;AAnyoBI;EACE,eAAA;AAqyoBN;AAjyoBE;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;AAmyoBJ;AAjyoBI;EACE,eAAA;AAmyoBN;AA/xoBE;EACE,gBAAA;AAiyoBJ;AA/xoBI;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AAiyoBN;AA7xoBE;EACE,gBAAA;AA+xoBJ;AA7xoBI;EACE,gBAAA;EACA,gBAAA;AA+xoBN;AA7xoBM;EACE,aAAA;AA+xoBR;AA3xoBI;EACE,eAAA;EACA,aAAA;EACA,gBAAA;AA6xoBN;AAzxoBE;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EAAA,kDAAA;AA2xoBJ;AAxxoBE;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AA0xoBJ;AAvxoBE;EACE,gBAAA;AAyxoBJ;AAtxoBE;EACE,eAAA;EACA,YAAA;AAwxoBJ;AArxoBE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,0CAAA;AAuxoBJ;AApxoBE;EACE,aAAA;EACA,gKACE;AAqxoBN;AA3woBE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,qCAAA;AA6woBJ;AA1woBE;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,iBAAA;AA4woBJ;AA1woBI;EACE,4BAAA;EAAA,gDAAA;AA4woBN;AAxwoBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AA0woBJ;AAvwoBE;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAywoBJ;AAtwoBE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAwwoBJ;AArwoBE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EAAA,yCAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAuwoBJ;AApwoBE;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAswoBJ;AAnwoBE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAqwoBJ;AAnwoBI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAqwoBN;AAlwoBI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAowoBN;AAjwoBI;EACE,gBAAA;AAmwoBN;AAhwoBI;EACE,iBAAA;AAkwoBN;AA9voBE;EACE,WAAA;AAgwoBJ;AA7voBE;EACE,WAAA;EACA,mBAAA;AA+voBJ;AA5voBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AA8voBJ;AA5voBI;EACE,+BAAA;EAAA,gDAAA;EACA,qBAAA;EAAA,0CAAA;AA8voBN;AA3voBI;EACE,gBAAA;AA6voBN;AA1voBI;EACE,0BAAA;EAAA,8CAAA;EACA,mBAAA;AA4voBN;AAxvoBE;EACE,aAAA;EACA,eAAA;AA0voBJ;AAvvoBE;EACE,eAAA;EACA,6BAAA;EAAA,kCAAA;EACA,gBAAA;EACA,aAAA;AAyvoBJ;AAtvoBE;EACE,aAAA;AAwvoBJ;AArvoBE;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EAAA,gCAAA;EACA,mBAAA;AAuvoBJ;AApvoBE;EACE,gBAAA;EAAA,gCAAA;AAsvoBJ;AApvoBI;EACE,mBAAA;AAsvoBN;AAlvoBE;EACE,eAAA;EACA,gBAAA;AAovoBJ;AAjvoBE;EACE,gBAAA;EACA,sBAAA;AAmvoBJ;AAhvoBE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;AAkvoBJ;AA/uoBE;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;EAAA,2CAAA;EACA,kBAAA;AAivoBJ;;AA7uoBA;;EAEE,aAAA;EACA,sBAAA;EACA,MAAA;AAgvoBF;;AA5uoBE;EACE,WAAA;AA+uoBJ;AA9uoBI;EACE,sBAAA;AAgvoBN;AA5uoBE;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;AA8uoBJ;AA3uoBE;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,cAAA;EAAA,SAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;AA6uoBJ;AA1uoBE;;EAEE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AA4uoBJ;AAzuoBE;EACE,gBAAA;AA2uoBJ;AAxuoBE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,qCAAA;AA0uoBJ;AAvuoBE;EACE,kBAAA;EACA,aAAA;AAyuoBJ;AAtuoBE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAwuoBJ;AAruoBE;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAuuoBJ;AApuoBE;EACE,SAAA;EACA,iBAAA;EACA,YAAA;AAsuoBJ;AAnuoBE;;;EAGE,kBAAA;EACA,aAAA;AAquoBJ;AAluoBE;EACE,cAAA;AAouoBJ;AAjuoBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AAmuoBJ;AAhuoBE;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AAkuoBJ;AA/toBE;EACE,WAAA;AAiuoBJ;AA/toBI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,+BAAA;EACA,cAAA;EACA,kBAAA;AAiuoBN;AA7toBE;EACE,YAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AA+toBJ;AA9toBI;EACE,WAAA;AAguoBN;AA9toBI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EAAA,WAAA;AAguoBN;AA5toBE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EAAA,WAAA;AA8toBJ;AA3toBE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AA6toBJ;AA5toBI;EACE,aAAA;EACA,2CAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AA8toBN;AA5toBM;EACE,qCAAA;AA8toBR;AA3toBM;EACE,aAAA;AA6toBR;AA1toBM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AA4toBR;AA1toBQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,qCAAA;EACA,cAAA;AA4toBV;AAztoBQ;EACE,YAAA;AA2toBV;AAztoBU;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA2toBZ;AAxtoBU;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA0toBZ;AAvtoBU;EACE,YAAA;EACA,eAAA;AAytoBZ;;AAjtoBA;EAEI;IACE,0BAAA;IACA,gBAAA;IACA,cAAA;EAmtoBJ;EAhtoBE;IACE,iBAAA;EAktoBJ;AACF;AA5soBE;;EACE,YAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AA+soBJ;AA9soBI;;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EACA,WAAA;EACA,uDAAA;AAitoBN;AAhtoBM;;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,2DAAA;EACA,kBAAA;EACA,oBAAA;AAmtoBR;AAjtoBM;;EACE,oBAAA;EACA,iBAAA;EACA,YAAA;EACA,2DAAA;AAotoBR;AAltoBM;;;;EAEE,yCAAA;EACA,WAAA;AAstoBR;AArtoBQ;;;;EACE,UAAA;AA0toBV;AAxtoBQ;;;;EACE,YAAA;AA6toBV;AAztoBI;;EACE,UAAA;AA4toBN;AA1toBQ;;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AA6toBV;AA5toBU;;EACE,YAAA;AA+toBZ;AA5toBQ;;EACE,aAAA;EACA,WAAA;EACA,WAAA;AA+toBV;AA9toBU;;EACE,YAAA;AAiuoBZ;AA9toBQ;;EACE,cAAA;EACA,iBAAA;AAiuoBV;AA9toBM;;EACE,aAAA;EACA,sBAAA;AAiuoBR;AA9toBI;;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAiuoBN;AAhuoBM;;EACE,aAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,oOACE;EAEF,0BAAA;EACA,uDACE;EAIF,yBAAA;AA6toBR;AA5toBQ;;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AA+toBV;AA9toBU;;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;AAiuoBZ;AA9toBQ;;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,kTACE;EAEF,8BAAA;AA+toBV;;AAxtoBA;EACE,oDAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AA2toBF;;AAxtoBA;EACE,qBAAA;EACA,mBAAA;AA2toBF;;AAxtoBA;EACE,qBAAA;EACA,mBAAA;AA2toBF;;AAxtoBA;;EAEE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AA2toBF;AAztoBE;;EACE,aAAA;EACA,WAAA;EACA,mBAAA;EACA,0BAAA;EAAA,kBAAA;AA4toBJ;AA3toBI;;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA8toBN;AA7toBM;;EACE,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EACA,kDAAA;EACA,2DAAA;EACA,4BAAA;EACA,sDAAA;AAguoBR;AA9toBQ;;EACE,YAAA;EACA,mCAAA;UAAA,2BAAA;AAiuoBV;AA/toBQ;;EACE,iBAAA;EACA,cAAA;AAkuoBV;AA/toBM;;EACE,YAAA;EACA,WAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;AAkuoBR;AA/toBI;;EACE,SAAA;EACA,2BAAA;EAAA,mBAAA;EACA,iBAAA;EACA,mBAAA;AAkuoBN;AA9toBE;;EACE,kBAAA;AAiuoBJ;;AA7toBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AAguoBF;AA9toBE;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EAAA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kCAAA;AAguoBJ;AA9toBI;EACE,gBAAA;EAAA,2BAAA;AAguoBN;AA7toBI;EACE,gBAAA;EAAA,2BAAA;AA+toBN;AA7toBM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;EAAA,gCAAA;AA+toBR;AA3toBI;EACE,gBAAA;EAAA,2BAAA;AA6toBN;AA3toBM;EACE,gCAAA;AA6toBR;;AAvtoBA;EACE,kBAAA;AA0toBF;AAxtoBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EAAA,8CAAA;EACA,kBAAA;EACA,gBAAA;EAAA,sCAAA;EACA,cAAA;EAAA,iCAAA;EACA,eAAA;EACA,eAAA;AA0toBJ;AAvtoBE;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EAAA,8CAAA;EACA,kBAAA;EACA,gBAAA;EAAA,sCAAA;EACA,0CAAA;AAytoBJ;AAttoBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAwtoBJ;AAttoBI;EACE,mBAAA;EAAA,+CAAA;AAwtoBN;AArtoBI;EACE,SAAA;AAutoBN;;AAjtoBE;EACE,gBAAA;EACA,gBAAA;AAotoBJ;;AAhtoBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;AAmtoBF;AAjtoBE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;AAmtoBJ;AAltoBI;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;AAotoBN;AAltoBM;EACE,aAAA;EACA,kBAAA;EAAA,aAAA;EACA,kBAAA;EAAA,aAAA;EACA,8BAAA;AAotoBR;AAjtoBM;EACE,gBAAA;AAmtoBR;AAltoBQ;EACE,eAAA;EACA,kBAAA;AAotoBV;AAltoBQ;EACE,SAAA;AAotoBV;AAltoBQ;;EAEE,sBAAA;EACA,eAAA;AAotoBV;AAjtoBQ;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AAmtoBV;AAjtoBU;EACE,eAAA;AAmtoBZ;AA7soBQ;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AA+soBV;AA7soBU;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAAA,yCAAA;EACA,kBAAA;EACA,mBAAA;EAAA,8BAAA;EACA,cAAA;AA+soBZ;AA3soBQ;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;AA6soBV;;AAtsoBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAysoBF;;AAtsoBA;EACE,aAAA;EACA,yBAAA;AAysoBF;;AAtsoBA;EACE,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAysoBF;AAvsoBE;EACE,cAAA;EAAA,8BAAA;AAysoBJ;AAtsoBE;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAwsoBJ;AAtsoBI;EACE,mBAAA;EACA,cAAA;AAwsoBN;AArsoBI;EACE,mBAAA;EACA,cAAA;EAAA,yBAAA;AAusoBN;;AAlsoBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AAqsoBF;;AAlsoBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EAAA,qCAAA;AAqsoBF;AAnsoBE;EACE,qBAAA;EACA,mDAAA;AAqsoBJ;AAlsoBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,2BAAA;AAosoBJ;AAjsoBE;EACE,yBAAA;EAAA,iDAAA;AAmsoBJ;AAhsoBE;EACE,yBAAA;EAAA,iDAAA;AAksoBJ;;AA9roBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAisoBF;AA/roBE;EACE,SAAA;EACA,YAAA;AAisoBJ;;AA7roBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAgsoBF;;AA7roBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;EAAA,qCAAA;EACA,kBAAA;EACA,yBAAA;EAAA,iDAAA;EACA,cAAA;EAAA,2BAAA;EACA,eAAA;AAgsoBF;AA9roBE;EACE,yBAAA;EAAA,iDAAA;AAgsoBJ;AA7roBE;EACE,YAAA;EACA,mBAAA;AA+roBJ;AA5roBE;EACE,qBAAA;EACA,yCAAA;EACA,cAAA;AA8roBJ;AA3roBE;EACE,oBAAA;EACA,eAAA;AA6roBJ;;AAzroBA;EACE,aAAA;EACA,2DAAA;EACA,cAAA;EAAA,SAAA;EACA,iBAAA;EACA,6BAAA;EAAA,yCAAA;AA4roBF;;AAzroBA;EACE,qBAAA;EACA,gBAAA;AA4roBF;;AAzroBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;AA4roBF;;AAzroBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,2BAAA;AA4roBF;;AAzroBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AA4roBF;;AAzroBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EAAA,qCAAA;EACA,yBAAA;EAAA,iDAAA;EACA,eAAA;EACA,cAAA;AA4roBF;;AAzroBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,2BAAA;AA4roBF;;AAzroBA;EACE,eAAA;EACA,cAAA;EAAA,2BAAA;EACA,YAAA;AA4roBF;;AAzroBA;EACE,gBAAA;AA4roBF;;AAtroBA;EACE,gBAAA;AAyroBF;AAvroBE;EACE,gCAAA;AAyroBJ;AAtroBE;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EAAA,2CAAA;EACA,yBAAA;EAAA,qCAAA;EACA,kBAAA;AAwroBJ;AArroBE;EACE;IACE,0BAAA;EAuroBJ;AACF;;AAnroBA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAsroBF;;AAnroBA;EACE,eAAA;EACA,cAAA;EAAA,2BAAA;EACA,YAAA;AAsroBF;;AAnroBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;EAAA,sCAAA;EACA,yBAAA;EAAA,iDAAA;AAsroBF;AAproBE;EACE,sBAAA;EACA,WAAA;EACA,oBAAA;AAsroBJ;;AAlroBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAqroBF;;AAlroBA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,2BAAA;AAqroBF;;AAlroBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAqroBF;AAnroBE;EACE,eAAA;AAqroBJ;;AAjroBA;;EAEE,yBAAA;EAAA,kDAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EAAA,2BAAA;AAoroBF;;AAjroBA;EACE,yBAAA;EAAA,+CAAA;EACA,cAAA;EAAA,yBAAA;AAoroBF;;AAjroBA;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AAoroBF;;AAjroBA;EACE,aAAA;EACA,cAAA;EACA,aAAA;EAEA,cAAA;EAAA,SAAA;AAmroBF;;AAhroBA;;;;EAIE,yBAAA;EAAA,yCAAA;EACA,yBAAA;EAAA,oCAAA;EACA,yCAAA;EACA,mBAAA;EACA,4BAAA;AAmroBF;;AAhroBA;;EAEE,aAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAmroBF;AAjroBE;;EACE,aAAA;EACA,qBAAA;EACA,WAAA;AAoroBJ;AAlroBI;;EACE,SAAA;EACA,YAAA;AAqroBN;AAhroBI;;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAmroBN;AAjroBM;;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAAA,yCAAA;EACA,kBAAA;EACA,mBAAA;EAAA,8BAAA;EACA,cAAA;AAoroBR;AAhroBI;;EACE,mBAAA;EACA,cAAA;EACA,kBAAA;AAmroBN;;AA9qoBA;EACE,aAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAiroBF;;AA9qoBA;EACE;IACE,cAAA;IACA,WAAA;IACA,eAAA;EAiroBF;AACF;AA/qoBA;EACE;IACE,cAAA;IACA,WAAA;IACA,eAAA;EAiroBF;AACF;AA9qoBA;EACE,gBAAA;EACA,iBAAA;EACA,6BAAA;EAAA,6CAAA;EACA,WAAA;AAgroBF;AA9qoBE;EACE,eAAA;EACA,eAAA;AAgroBJ;AA7qoBE;EACE,mBAAA;AA+qoBJ;AA5qoBE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EAAA,wCAAA;AA8qoBJ;AA3qoBE;EAEE,mBAAA;AA4qoBJ;AA1qoBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AA4qoBN;AAzqoBI;EACE,SAAA;EACA,kBAAA;EACA,eAAA;AA2qoBN;AAvqoBE;EACE,aAAA;AAyqoBJ;AAtqoBE;EACE,eAAA;EACA,WAAA;EAAA,wCAAA;EACA,gBAAA;EACA,gBAAA;AAwqoBJ;AArqoBE;EACE,gBAAA;EACA,mBAAA;AAuqoBJ;AApqoBE;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAsqoBJ;AApqoBI;;EAEE,iBAAA;EACA,gBAAA;EACA,gCAAA;EAAA,gDAAA;AAsqoBN;AAnqoBI;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AAqqoBN;AAlqoBI;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EAAA,yCAAA;EACA,kBAAA;AAoqoBN;AAhqoBE;EACE,mBAAA;EACA,WAAA;EAAA,wCAAA;EACA,eAAA;AAkqoBJ;AA/poBE;EACE,cAAA;EAAA,kCAAA;EACA,eAAA;EACA,kBAAA;AAiqoBJ;AA9poBE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAgqoBJ;;AA5poBA;EACE,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA+poBF;AA7poBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA+poBJ;;AA3poBA;EACE,yBAAA;EAAA,kDAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AA8poBF;;AA3poBA;EACE,eAAA;EACA,cAAA;EAAA,wBAAA;EACA,gBAAA;EACA,yBAAA;AA8poBF;;AA3poBA;EACE,eAAA;EACA,cAAA;EAAA,2BAAA;EACA,iBAAA;EACA,sBAAA;AA8poBF;;AA3poBA;;;EAGE,aAAA;EACA,sBAAA;EACA,SAAA;AA8poBF;;AA3poBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,+BAAA;AA8poBF;;AA3poBA;EACE,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EAAA,kDAAA;EACA,aAAA;EACA,sBAAA;EACA,yCAAA;AA8poBF;;AA3poBA;EACE,SAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AA8poBF;;AA3poBA;EACE,WAAA;EACA,YAAA;AA8poBF;;AA3poBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AA8poBF;;AA3poBA;EACE,gBAAA;EAAA,2BAAA;EACA,gBAAA;EACA,qBAAA;AA8poBF;AA5poBE;EACE,gCAAA;AA8poBJ;;AA1poBA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EAAA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AA6poBF;AA3poBE;EACE,gCAAA;EACA,0BAAA;AA6poBJ;;AAzpoBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EAAA,kDAAA;EACA,cAAA;EAAA,yBAAA;AA4poBF;;AAzpoBA;EACE,yBAAA;EAAA,+CAAA;EACA,cAAA;EAAA,yBAAA;AA4poBF;;AAzpoBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;UAAA,sBAAA;AA4poBF;;AAzpoBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EAAA,yBAAA;EACA,eAAA;EACA,yBAAA;EAAA,kDAAA;EACA,mBAAA;AA4poBF;;AAzpoBA;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EAAA,SAAA;EACA,2DAAA;AA4poBF;;AAzpoBA;EACE,yBAAA;EAAA,oCAAA;EACA,yBAAA;EAAA,yCAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,0CAAA;AA4poBF;;AAzpoBA;EACE,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EAAA,yBAAA;AA4poBF;;AAzpoBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,2BAAA;AA4poBF;;AAzpoBA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA4poBF;;AAzpoBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,2BAAA;AA4poBF;;AAzpoBA;;EAEE,WAAA;AA4poBF;;AAzpoBA;EACE;IACE,eAAA;IACA,SAAA;EA4poBF;EAzpoBA;IACE,sBAAA;EA2poBF;EAxpoBA;;IAEE,cAAA;IACA,eAAA;EA0poBF;EAvpoBA;IACE,0BAAA;EAypoBF;AACF;AArpoBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;AAupoBF;AArpoBE;EACE,SAAA;AAupoBJ;;AAlpoBA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;AAqpoBF;;AAjpoBA;EACE,kBAAA;AAopoBF;AAlpoBE;EACE,oBAAA;AAopoBJ;;AAhpoBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAmpoBF;AAjpoBE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,WAAA;EACA,eAAA;AAmpoBJ;;AA/ooBA;EACE,kBAAA;AAkpoBF;;AA/ooBA;EACE,kBAAA;AAkpoBF;;AA/ooBA;EACE,kBAAA;AAkpoBF;;AA/ooBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,0BAAA;EACA,gBAAA;AAkpoBF;;AA/ooBA;EACE,WAAA;EACA,YAAA;AAkpoBF;;AA/ooBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;AAkpoBF;AAhpoBE;EACE,SAAA;AAkpoBJ;;AA9ooBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,QAAA;EACA,cAAA;AAipoBF;AA/ooBE;EACE,cAAA;EACA,iBAAA;EACA,SAAA;AAipoBJ;AA9ooBE;EAdF;IAeI,sBAAA;EAipoBF;EA/ooBE;IACE,WAAA;IACA,YAAA;EAipoBJ;AACF;;AA7ooBA;;;gFAAA;AAKA;EACE,kBAAA;EAGA,mBAAA;EACA,0BAAA;AA6ooBF;AA3ooBE;EACE,WAAA;EACA,YAAA;AA6ooBJ;AA1ooBE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,8BAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AA4ooBJ;AA1ooBI;EACE,mBAAA;EAAA,uCAAA;AA4ooBN;AAxooBE;EACE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,eAAA;AA0ooBJ;AAtooBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EAAA,uCAAA;EACA,WAAA;EACA,eAAA;EACA,yCAAA;EACA,eAAA;AAwooBJ;AAtooBI;EACE,wBAAA;AAwooBN;;AAnooBA,0EAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAsooBF;;AAnooBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;AAsooBF;AApooBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,2BAAA;EAAA,+CAAA;EACA,kDAAA;AAsooBJ;;AAlooBA;EACE;IACE,yBAAA;EAqooBF;AACF;AAlooBA,8EAAA;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAmooBF;AAhooBE;EACE,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAkooBJ;AA/noBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAiooBJ;AA9noBE;EACE,gBAAA;EACA,eAAA;EACA,WAAA;AAgooBJ;AA7noBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AA+noBJ;AA7noBI;EACE,mBAAA;AA+noBN;AA3noBE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,UAAA;AA6noBJ;AA1noBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AA4noBJ;AAznoBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;AA2noBJ;AAxnoBE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAAA,8CAAA;EACA,mBAAA;EAAA,wCAAA;EACA,UAAA;EAEA,iFAAA;AAynoBJ;;AArnoBA;EACE;IACE,yCAAA;IACA,YAAA;EAwnoBF;EAtnoBA;IACE,4CAAA;IACA,UAAA;EAwnoBF;AACF;AArnoBA,8EAAA;AAEA;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kBAAA;AAsnoBF;AApnoBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4CAAA;AAsnoBJ;AAnnoBE;EACE,gBAAA;EACA,eAAA;AAqnoBJ;AAlnoBE;EACE,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAonoBJ;AAjnoBE;EACE,gBAAA;EACA,eAAA;EACA,UAAA;AAmnoBJ;;AA/moBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAknoBF;AAhnoBE;EACE,+BAAA;AAknoBJ;AA/moBE;EACE,eAAA;AAinoBJ;AA/moBI;EACE,uBAAA;AAinoBN;AA7moBE;EACE,aAAA;AA+moBJ;AA5moBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA8moBJ;AA3moBE;EACE,cAAA;EACA,eAAA;AA6moBJ;AA1moBE;EACE,cAAA;EACA,eAAA;EACA,cAAA;AA4moBJ;AAzmoBE;EACE,cAAA;EACA,eAAA;AA2moBJ;;AAvmoBA,6EAAA;AAEA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AAymoBF;AAvmoBE;EACE,aAAA;EACA,0BAAA;EAAA,kBAAA;AAymoBJ;AApmoBE;EACE,iCAAA;EACA,iCAAA;EACA,mCAAA;AAsmoBJ;AAnmoBE;EACE,4BAAA;AAqmoBJ;;AAjmoBA;EACE;IACE,wBAAA;EAomoBF;EAlmoBA;IACE,2BAAA;EAomoBF;AACF;AAjmoBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,eAAA;AAmmoBF;AAjmoBE;EACE,4BAAA;EAAA,gDAAA;AAmmoBJ;AAhmoBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAkmoBJ;AA/loBE;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAimoBJ;AA9loBE;EACE,eAAA;EACA,WAAA;AAgmoBJ;;AA5loBA,uEAAA;AACA;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AA+loBF;AA7loBE;EAEE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;AA8loBJ;;AA1loBA,8EAAA;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;AA4loBF;AA1loBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,4CAAA;AA4loBJ;AAzloBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA2loBJ;AAzloBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA2loBN;AAvloBE;EACE,gBAAA;EACA,WAAA;AAyloBJ;AAtloBE;EACE,cAAA;EACA,YAAA;AAwloBJ;AArloBE;EACE,gBAAA;EACA,eAAA;AAuloBJ;AAploBE;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAsloBJ;AAnloBE;EACE,YAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AAqloBJ;AAlloBE;EACE,gBAAA;EACA,eAAA;EACA,UAAA;AAoloBJ;;AAhloBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAmloBF;AAjloBE;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAmloBJ;AAhloBE;EACE,aAAA;EACA,sBAAA;AAkloBJ;AA/koBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAiloBJ;AA9koBE;EACE,eAAA;EACA,WAAA;AAgloBJ;;AA5koBA;;EAEE,qBAAA;EACA,cAAA;AA+koBF;;AA5koBA;EACE,8BAAA;EACA,kBAAA;EACA,mBAAA;AA+koBF;;AA5koBA;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AA+koBF;AA7koBE;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;AA+koBJ;;AA3koBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AA8koBF;;AA3koBA;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AA8koBF;;AA3koBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AA8koBF;;AA3koBA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AA8koBF;;AA3koBA;;EAEE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AA8koBF;;AA3koBA;EACE,mBAAA;AA8koBF;;AA3koBA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA8koBF;;AA3koBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AA8koBF;AA5koBE;EACE,SAAA;AA8koBJ;;AAzkoBE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AA4koBJ;AAzkoBE;EACE,gBAAA;EACA,cAAA;EAAA,yBAAA;EACA,gDAAA;AA2koBJ;AAzkoBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA2koBN;AAxkoBI;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EAAA,2CAAA;EACA,kBAAA;EACA,mBAAA;EAAA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AA0koBN;AAxkoBM;EACE,0BAAA;EAAA,qCAAA;EACA,mBAAA;AA0koBR;AAtkoBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4BAAA;AAwkoBN;AArkoBI;EACE,eAAA;EACA,yBAAA;UAAA,iBAAA;AAukoBN;AApkoBI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EAAA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;AAskoBN;AAnkoBI;EACE,kBAAA;EACA,UAAA;AAqkoBN;AAlkoBI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EAAA,8BAAA;AAokoBN;;AA9joBE;EACE,mBAAA;EACA,YAAA;AAikoBJ;AA9joBE;EACE,kBAAA;AAgkoBJ;AA7joBE;;EAEE,qBAAA;EACA,eAAA;EACA,aAAA;AA+joBJ;AA5joBE;EACE,aAAA;EACA,2DAAA;EACA,cAAA;EAAA,SAAA;EACA,gBAAA;AA8joBJ;AA3joBE;EACE,qBAAA;EACA,sBAAA;EAAA,2CAAA;EACA,kBAAA;AA6joBJ;AA3joBI;EACE,kBAAA;EACA,eAAA;AA6joBN;AA1joBI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AA4joBN;AAzjoBI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,sBAAA;AA2joBN;AAzjoBM;EACE,eAAA;EACA,gBAAA;AA2joBR;AAxjoBM;;EAEE,wBAAA;EACA,sBAAA;EAAA,2CAAA;EACA,kBAAA;EACA,aAAA;AA0joBR;AArjoBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAujoBJ;AApjoBE;EACE,kBAAA;AAsjoBJ;AAnjoBE;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAqjoBJ;AAljoBE;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,sBAAA;EAAA,2CAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AAojoBJ;AAljoBI;EACE,gBAAA;EACA,YAAA;AAojoBN;AAhjoBE;EACE,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EAAA,2CAAA;EACA,kBAAA;EACA,mBAAA;EAAA,oCAAA;EACA,0CAAA;AAkjoBJ;AAhjoBI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AAkjoBN;AAhjoBM;EACE,+BAAA;AAkjoBR;AA/ioBM;EACE,eAAA;AAijoBR;AA9ioBM;;EAEE,eAAA;EACA,aAAA;EACA,kBAAA;AAgjoBR;AA3ioBE;EACE,SAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AA6ioBJ;AA1ioBE;EACE,aAAA;EACA,YAAA;EACA,sBAAA;AA4ioBJ;AAzioBE;EACE,SAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;AA2ioBJ;AAzioBI;EACE,YAAA;EACA,eAAA;EACA,qBAAA;AA2ioBN;AAvioBE;EACE,iBAAA;EACA,cAAA;EACA,sBAAA;EAAA,2CAAA;EACA,kBAAA;AAyioBJ;AAtioBE;EACE,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EAAA,WAAA;EACA,SAAA;EACA,wBAAA;EACA,6BAAA;EAAA,kDAAA;EACA,eAAA;EACA,eAAA;AAwioBJ;AAtioBI;EACE,gBAAA;AAwioBN;AArioBI;EACE,+BAAA;AAuioBN;AApioBI;EACE,SAAA;AAsioBN;AAnioBI;EACE,gBAAA;AAqioBN;AAlioBI;EACE,eAAA;EACA,YAAA;AAoioBN;AAhioBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AAkioBJ;AA/hoBE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AAiioBJ;;AA7hoBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAgioBF;AA9hoBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;AAgioBJ;AA9hoBI;EACE,SAAA;AAgioBN;AA5hoBE;EACE,SAAA;EACA,aAAA;AA8hoBJ;AA3hoBE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;AA6hoBJ;;AAxhoBE;EACE,mBAAA;EACA,qBAAA;AA2hoBJ;AAzhoBI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,yBAAA;AA2hoBN;AAxhoBI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AA0hoBN;AAvhoBI;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAyhoBN;AAthoBI;EACE,eAAA;EACA,gBAAA;AAwhoBN;AArhoBI;EACE,gBAAA;EACA,gBAAA;EAAA,2BAAA;EACA,qBAAA;AAuhoBN;AArhoBM;EACE,0BAAA;AAuhoBR;AAnhoBI;EACE,cAAA;EAAA,yBAAA;EACA,aAAA;AAqhoBN;AAlhoBI;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAohoBN;AAhhoBE;EACE,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EAAA,mCAAA;EACA,4CAAA;AAkhoBJ;AA/goBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAihoBJ;AA9goBE;EACE,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,yBAAA;AAghoBJ;AA9goBI;EACE,gBAAA;AAghoBN;AA5goBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA8goBJ;AA5goBI;EACE,+BAAA;AA8goBN;AA3goBI;EACE,qBAAA;EAAA,4CAAA;EACA,gBAAA;EAAA,2BAAA;EACA,+CAAA;AA6goBN;AA3goBM;EACE,kCAAA;AA6goBR;AA1goBM;EACE,gBAAA;EAAA,2BAAA;EACA,aAAA;AA4goBR;AAxgoBI;EACE,qBAAA;EACA,4CAAA;AA0goBN;AAtgoBE;EACE,cAAA;EACA,+BAAA;AAwgoBJ;AAtgoBI;EACE,yBAAA;AAwgoBN;AApgoBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAsgoBJ;AAngoBE;EACE,eAAA;EACA,gBAAA;AAqgoBJ;AAlgoBE;EACE,cAAA;EACA,eAAA;EACA,aAAA;AAogoBJ;AAjgoBE;EACE,SAAA;EACA,SAAA;EACA,yCAAA;EACA,gBAAA;EACA,uBAAA;AAmgoBJ;AAjgoBI;EACE,sBAAA;AAmgoBN;AA//nBE;EACE,mBAAA;EACA,kBAAA;AAigoBJ;AA9/nBE;EACE,mBAAA;AAggoBJ;;AA5/nBA;EACE,aAAA;EACA,4DAAA;EACA,mBAAA;EAAA,cAAA;EACA,eAAA;AA+/nBF;;AA5/nBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AA+/nBF;AA7/nBE;EACE,SAAA;AA+/nBJ;;AA3/nBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA8/nBF;;AA3/nBA;;EAEE,aAAA;EACA,sBAAA;EACA,YAAA;AA8/nBF;;AA3/nBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA8/nBF;;AA3/nBA;EACE,WAAA;EACA,yBAAA;AA8/nBF;AA5/nBE;;EAEE,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,sBAAA;AA8/nBJ;AA3/nBE;EACE,YAAA;AA6/nBJ;;AAz/nBA;EACE,WAAA;AA4/nBF;;AAz/nBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AA4/nBF;;AAv/nBE;;EACE,gBAAA;AA2/nBJ;;AAt/nBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAy/nBJ;AAv/nBI;EACE,eAAA;AAy/nBN;AAr/nBE;EACE,SAAA;EACA,cAAA;EAAA,8BAAA;EACA,eAAA;AAu/nBJ;AAp/nBE;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EAAA,kCAAA;AAs/nBJ;AAn/nBE;EACE,mBAAA;EACA,cAAA;AAq/nBJ;AAl/nBE;EACE,yBAAA;EAAA,yCAAA;EACA,yBAAA;EAAA,oCAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EAAA,2BAAA;AAo/nBJ;AAl/nBI;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AAo/nBN;AAj/nBI;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;AAm/nBN;AAh/nBI;EACE,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EAAA,yBAAA;EACA,eAAA;EACA,gBAAA;AAk/nBN;AA/+nBI;EACE,cAAA;EAAA,yBAAA;EACA,eAAA;EACA,mBAAA;AAi/nBN;AA9+nBI;EACE,eAAA;AAg/nBN;AA7+nBI;EACE,gBAAA;EACA,gBAAA;AA++nBN;AA5+nBI;EACE,cAAA;EAAA,yBAAA;AA8+nBN;AA3+nBI;EACE,cAAA;EAAA,yBAAA;AA6+nBN;AA1+nBI;EACE,cAAA;AA4+nBN;AAz+nBI;EACE,cAAA;EAAA,yBAAA;AA2+nBN;AAx+nBI;EACE,cAAA;EAAA,yBAAA;AA0+nBN;AAt+nBE;;EAEE,aAAA;AAw+nBJ;AAr+nBE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EAAA,mCAAA;AAu+nBJ;AAr+nBI;EACE,YAAA;EACA,sBAAA;EACA,mBAAA;EAAA,8BAAA;EACA,4BAAA;AAu+nBN;AAp+nBI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EAAA,yBAAA;EACA,eAAA;AAs+nBN;AAp+nBM;EACE,cAAA;EAAA,2BAAA;AAs+nBR;AAj+nBE;EACE,gBAAA;AAm+nBJ;AAj+nBI;EACE,mBAAA;AAm+nBN;AAj+nBM;EACE,eAAA;AAm+nBR;AAh+nBM;EACE,SAAA;EACA,cAAA;EAAA,8BAAA;EACA,eAAA;AAk+nBR;AA99nBI;EACE,aAAA;EACA,4DAAA;EACA,cAAA;EAAA,SAAA;EACA,mBAAA;AAg+nBN;AA99nBM;EACE,yBAAA;EAAA,yCAAA;EACA,mBAAA;EACA,mBAAA;EAAA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAg+nBR;AA99nBQ;EACE,cAAA;EAAA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;AAg+nBV;AA79nBQ;EACE,eAAA;EACA,cAAA;EAAA,2BAAA;EACA,gBAAA;AA+9nBV;;AAv9nBE;EACE,mBAAA;AA09nBJ;AAx9nBI;EACE,eAAA;AA09nBN;AAt9nBE;EACE,SAAA;EACA,cAAA;EAAA,8BAAA;EACA,eAAA;AAw9nBJ;AAr9nBE;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAu9nBJ;;AAl9nBE;EACE,aAAA;EACA,gCAAA;EACA,cAAA;EAAA,SAAA;EACA,gBAAA;AAq9nBJ;AAl9nBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAo9nBJ;AAl9nBI;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAo9nBN;AAh9nBE;EACE,WAAA;EACA,eAAA;AAk9nBJ;AAh9nBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAk9nBN;AAh9nBM;;EAEE,kBAAA;AAk9nBR;AA78nBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EAAA,8BAAA;EACA,kBAAA;AA+8nBJ;AA38nBI;EACE,SAAA;EACA,aAAA;EACA,cAAA;EAAA,SAAA;AA68nBN;AA18nBI;EACE,aAAA;EACA,gCAAA;EACA,aAAA;EAAA,QAAA;AA48nBN;AAz8nBI;EACE,SAAA;EACA,cAAA;EAAA,8BAAA;EACA,eAAA;AA28nBN;AAx8nBI;EACE,SAAA;EACA,eAAA;AA08nBN;AAt8nBE;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAw8nBJ;AAr8nBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAu8nBJ;AAr8nBI;EACE,eAAA;EACA,cAAA;AAu8nBN;AAn8nBE;EACE;IACE,0BAAA;EAq8nBJ;AACF;;AAj8nBA;EACE,uBAAA;AAo8nBF;AAl8nBE;EACE,aAAA;EACA,cAAA;EAAA,SAAA;EACA,gBAAA;AAo8nBJ;AAj8nBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,yCAAA;EACA,yBAAA;EAAA,qCAAA;EACA,cAAA;EAAA,8BAAA;EACA,eAAA;AAm8nBJ;AA/7nBI;EACE,SAAA;EACA,aAAA;EACA,cAAA;EAAA,SAAA;AAi8nBN;AA97nBI;EACE,aAAA;EACA,gCAAA;EACA,aAAA;EAAA,QAAA;AAg8nBN;AA77nBI;EACE,SAAA;EACA,cAAA;EAAA,8BAAA;EACA,eAAA;AA+7nBN;AA57nBI;EACE,SAAA;EACA,eAAA;AA87nBN;AA17nBE;EACE,kBAAA;AA47nBJ;;AAx7nBA;EACE,uBAAA;AA27nBF;AAz7nBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA27nBJ;AAz7nBI;EACE,SAAA;AA27nBN;AAv7nBE;EACE,gBAAA;AAy7nBJ;AAv7nBI;EACE,gBAAA;EACA,eAAA;AAy7nBN;AAt7nBI;EACE,SAAA;EACA,aAAA;EACA,cAAA;EAAA,SAAA;AAw7nBN;AAr7nBI;EACE,aAAA;EACA,gCAAA;EACA,aAAA;EAAA,QAAA;AAu7nBN;AAp7nBI;EACE,SAAA;EACA,cAAA;EAAA,8BAAA;EACA,eAAA;AAs7nBN;AAn7nBI;EACE,SAAA;EACA,eAAA;AAq7nBN;AAj7nBE;EACE,qBAAA;AAm7nBJ;AAh7nBE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EAAA,8BAAA;AAk7nBJ;AA/6nBE;EACE,cAAA;EAAA,yBAAA;AAi7nBJ;AA96nBE;EACE,gBAAA;AAg7nBJ;AA76nBE;EACE,kBAAA;AA+6nBJ;;AA16nBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA66nBJ;AA16nBE;EACE,eAAA;EACA,gBAAA;AA46nBJ;AAz6nBE;EACE,YAAA;EACA,eAAA;AA26nBJ;AAx6nBE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AA06nBJ;AAv6nBE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,sBAAA;EACA,yBAAA;EAAA,yCAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAy6nBJ;AAv6nBI;EACE,qCAAA;AAy6nBN;AAr6nBE;EACE,gBAAA;AAu6nBJ;;AAn6nBA;EACE,uBAAA;AAs6nBF;AAp6nBE;EACE,SAAA;AAs6nBJ;AAn6nBE;EACE,kBAAA;EACA,qBAAA;AAq6nBJ;;AAj6nBA;EACE,gBAAA;AAo6nBF;AAl6nBE;EACE,gBAAA;EACA,eAAA;AAo6nBJ;AAj6nBE;EACE,SAAA;EACA,aAAA;EACA,cAAA;EAAA,SAAA;AAm6nBJ;AAh6nBE;EACE,aAAA;EACA,gCAAA;EACA,aAAA;EAAA,QAAA;AAk6nBJ;AA/5nBE;EACE,SAAA;EACA,cAAA;EAAA,8BAAA;EACA,eAAA;AAi6nBJ;AA95nBE;EACE,SAAA;EACA,eAAA;AAg6nBJ;;AA55nBA;EACE,cAAA;EAAA,8BAAA;EACA,eAAA;AA+5nBF;;AA55nBA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EAAA,QAAA;AA+5nBF;AA75nBE;EACE,aAAA;EACA,qCAAA;EACA,cAAA;EAAA,SAAA;EACA,qBAAA;EACA,iBAAA;EACA,8BAAA;EAAA,8CAAA;EACA,eAAA;AA+5nBJ;AA75nBI;EACE,4BAAA;EAAA,uCAAA;EACA,gBAAA;AA+5nBN;AA35nBE;EAEE,cAAA;EAAA,8BAAA;AA45nBJ;AAz5nBE;EACE;IACE,0BAAA;IACA,QAAA;EA25nBJ;AACF;;AAt5nBE;EACE,gBAAA;EACA,cAAA;EAAA,8BAAA;AAy5nBJ;AAt5nBE;EACE,mBAAA;EACA,eAAA;AAw5nBJ;;AAp5nBA;EACE,aAAA;EACA,4DAAA;EACA,cAAA;EAAA,SAAA;EACA,gBAAA;AAu5nBF;;AAp5nBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EAAA,qCAAA;EACA,mBAAA;AAu5nBF;AAr5nBE;EACE,eAAA;EACA,cAAA;EAAA,8BAAA;AAu5nBJ;AAp5nBE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EAAA,kCAAA;AAs5nBJ;AAn5nBE;EACE,eAAA;EACA,cAAA;EAAA,8BAAA;AAq5nBJ;;AAj5nBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAo5nBF;AAl5nBE;EACE,aAAA;EACA,SAAA;AAo5nBJ;;AAh5nBA;EACE,aAAA;EACA,cAAA;EAAA,SAAA;EACA,gBAAA;AAm5nBF;;AAh5nBA;EACE,kBAAA;EACA,yBAAA;EAAA,qCAAA;EACA,mBAAA;AAm5nBF;AAj5nBE;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AAm5nBJ;AAh5nBE;EACE,gBAAA;AAk5nBJ;AA/4nBE;EACE,eAAA;EACA,cAAA;EAAA,8BAAA;AAi5nBJ;;AA74nBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AAg5nBF;;AA74nBA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AAg5nBF;;AA74nBA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;AAg5nBF;AA94nBE;;EAEE,iBAAA;EACA,iBAAA;EACA,gCAAA;EAAA,gDAAA;EACA,6BAAA;EAAA,kCAAA;AAg5nBJ;AA74nBE;;EAEE,gBAAA;AA+4nBJ;AA54nBE;EACE,gBAAA;EACA,cAAA;EAAA,8BAAA;AA84nBJ;;AA14nBA;EACE,uBAAA;AA64nBF;AA34nBE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;AA64nBJ;AA14nBE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EAAA,yCAAA;AA44nBJ;AAz4nBE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AA24nBJ;AAz4nBI;EACE,SAAA;AA24nBN;AAv4nBE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EAAA,8BAAA;AAy4nBJ;AAt4nBE;EACE,qBAAA;AAw4nBJ;AAr4nBE;EACE,kBAAA;EACA,qBAAA;AAu4nBJ;;AAl4nBA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAq4nBF;;AAl4nBA;EACE,cAAA;EACA,cAAA;AAq4nBF;AAn4nBE;EACE,mCAAA;AAq4nBJ;AAn4nBE;EACE,+BAAA;AAq4nBJ;;AAj4nBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAo4nBF;AAl4nBE;EACE,WAAA;EACA,YAAA;AAo4nBJ;AAj4nBE;EACE,aAAA;AAm4nBJ;;AA/3nBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAk4nBF;AAh4nBE;EACE,mBAAA;EACA,WAAA;AAk4nBJ;AA/3nBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AAi4nBJ;;AA73nBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAg4nBF;;AA73nBA;EACE,sBAAA;AAg4nBF;;AA93nBA;EACE,sBAAA;AAi4nBF;;AA/3nBA;EACE,sBAAA;AAk4nBF;;AA/3nBA;EACE,aAAA;EACA,2CAAA;EACA,cAAA;EAAA,SAAA;EACA,kBAAA;EACA,eAAA;AAk4nBF;AAh4nBE;EAPF;IAQI,qCAAA;EAm4nBF;AACF;;AAh4nBA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAm4nBF;;AAh4nBA;EACE,aAAA;EACA,8DAAA;EACA,mBAAA;EACA,cAAA;EAAA,SAAA;EACA,kBAAA;EACA,yBAAA;EAAA,qCAAA;EACA,8BAAA;EAAA,8DAAA;EACA,kBAAA;EACA,mBAAA;EAAA,mCAAA;AAm4nBF;AAj4nBE;EACE,sBAAA;AAm4nBJ;AAj4nBE;EACE,sBAAA;AAm4nBJ;AAj4nBE;EACE,sBAAA;AAm4nBJ;AAj4nBI;;;EAGE,aAAA;AAm4nBN;AA/3nBE;EACE,0CAAA;AAi4nBJ;AA93nBE;EA/BF;IAgCI,+CAAA;EAi4nBF;EA/3nBE;IACE,aAAA;EAi4nBJ;AACF;AA93nBE;EACE,YAAA;AAg4nBJ;AA73nBE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AA+3nBJ;AA73nBI;EACE,gBAAA;EACA,eAAA;EACA,YAAA;AA+3nBN;AA33nBE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EAAA,kCAAA;EACA,eAAA;EACA,gBAAA;AA63nBJ;AA13nBE;EACE,eAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA43nBJ;AAz3nBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EAAA,qCAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AA23nBJ;AAz3nBI;EACE,mBAAA;EAAA,kCAAA;AA23nBN;;AAt3nBA;EACE,2CAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;AAy3nBF;;AAt3nBA;EACE,eAAA;AAy3nBF;;AAt3nBA;EACE,wBAAA;EAAA,gBAAA;EACA,SAAA;AAy3nBF;AAv3nBE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAy3nBJ;AAt3nBE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,yGACE;AAu3nBN;AAn3nBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;AAq3nBJ;AAl3nBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAo3nBJ;AAl3nBI;EACE,mBAAA;AAo3nBN;AAj3nBI;EACE,aAAA;EACA,mBAAA;AAm3nBN;AA/2nBE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAi3nBJ;AA92nBE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAg3nBJ;AA72nBE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AA+2nBJ;;AA32nBA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA82nBF;AA52nBE;EACE,iBAAA;AA82nBJ;AA32nBE;EACE,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EAAA,qCAAA;AA62nBJ;AA32nBI;EACE,mBAAA;EAAA,kCAAA;AA62nBN;AAz2nBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA22nBJ;AAz2nBI;EACE,eAAA;EACA,YAAA;AA22nBN;AAv2nBE;EACE,eAAA;EACA,YAAA;EACA,iBAAA;AAy2nBJ;AAt2nBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAw2nBJ;AAr2nBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAu2nBJ;AAp2nBE;EACE,eAAA;EACA,gBAAA;AAs2nBJ;AAn2nBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAAA,cAAA;AAq2nBJ;AAn2nBI;EALF;IAMI,0BAAA;EAs2nBJ;AACF;AAn2nBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAq2nBJ;AAn2nBI;EACE,eAAA;AAq2nBN;AAj2nBE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAm2nBJ;AAh2nBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAk2nBJ;AA/1nBE;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAi2nBJ;AA91nBE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AAg2nBJ;AA91nBI;EACE,cAAA;EACA,sBAAA;AAg2nBN;AA51nBE;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,gBAAA;AA81nBJ;AA31nBE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AA61nBJ;AA31nBI;EACE,WAAA;AA61nBN;AAz1nBE;EACE,cAAA;EAAA,yBAAA;EACA,eAAA;AA21nBJ;AAx1nBE;EACE,6BAAA;AA01nBJ;;AAt1nBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,6BAAA;EAAA,yCAAA;EACA,eAAA;AAy1nBF;AAv1nBE;EACE,qBAAA;EAAA,qCAAA;EACA,6BAAA;EAAA,8CAAA;AAy1nBJ;;AAr1nBA;EACE,oBAAA;EACA,sBAAA;EACA,yBAAA;EAAA,qCAAA;EACA,kBAAA;EACA,gBAAA;AAw1nBF;AAt1nBE;EACE,iBAAA;EACA,YAAA;EACA,+BAAA;EAAA,2CAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAw1nBJ;AAt1nBI;EACE,kBAAA;AAw1nBN;AAr1nBI;EACE,8BAAA;EACA,WAAA;EACA,gBAAA;AAu1nBN;;AAl1nBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAq1nBF;;AAl1nBA;EACE,gBAAA;EACA,gBAAA;AAq1nBF;;AAl1nBA;EACE,aAAA;EACA,2DAAA;EACA,aAAA;EAAA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAq1nBF;;AAl1nBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,oBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAq1nBF;AAn1nBE;EACE,mBAAA;EAAA,kCAAA;AAq1nBJ;AAl1nBE;EACE,uBAAA;EAAA,kCAAA;EACA,qBAAA;EAAA,4CAAA;AAo1nBJ;AAj1nBE;EACE,eAAA;EACA,cAAA;AAm1nBJ;AAh1nBE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAk1nBJ;;AA90nBA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EAAA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;AAi1nBF;AA/0nBE;EACE,mBAAA;EACA,cAAA;EACA,UAAA;AAi1nBJ;;AA50nBA;;EAEE,WAAA;EACA,kBAAA;AA+0nBF;AA70nBE;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAg1nBJ;;AA10nBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AA60nBJ;AA10nBE;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,+BAAA;AA40nBJ;AAz0nBE;EACE,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA20nBJ;AAz0nBI;EACE,gBAAA;EACA,yCAAA;AA20nBN;AAt0nBE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAw0nBJ;AAr0nBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAu0nBJ;AAr0nBI;EACE,iBAAA;EACA,YAAA;AAu0nBN;AAn0nBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;AAq0nBJ;AAl0nBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,iCAAA;AAo0nBJ;AAl0nBI;EACE,0CAAA;AAo0nBN;AAj0nBI;EACE,aAAA;EACA,+BAAA;AAm0nBN;AAh0nBI;;EAEE,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;AAk0nBN;AA/znBI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,+BAAA;EACA,0BAAA;EACA,eAAA;AAi0nBN;AA/znBM;EACE,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;AAi0nBR;AA5znBI;EAhDF;IAiDI,eAAA;EA+znBJ;EA7znBI;IACE,WAAA;IACA,kBAAA;EA+znBN;AACF;AA3znBE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA6znBJ;AA1znBE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA4znBJ;AA1znBI;EACE,aAAA;EACA,kBAAA;AA4znBN;AAxznBE;EACE,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AA0znBJ;AAvznBE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;AAyznBJ;AAvznBI;EACE,iBAAA;EACA,YAAA;AAyznBN;AArznBE;EACE,gBAAA;EACA,oBAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;AAuznBJ;AArznBI;EACE,UAAA;AAuznBN;AAnznBE;EACE,iBAAA;EACA,oBAAA;EACA,+BAAA;EACA,eAAA;EACA,yBAAA;AAqznBJ;AAlznBE;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAoznBJ;AAlznBI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0DAAA;AAoznBN;AAlznBM;EACE,+BAAA;AAoznBR;AAjznBM;EACE,qBAAA;EACA,cAAA;EACA,mCAAA;AAmznBR;AAhznBM;EACE,cAAA;EACA,qCAAA;AAkznBR;AAhznBQ;EACE,mCAAA;EACA,qBAAA;AAkznBV;AA9ynBM;EACE,YAAA;EACA,eAAA;AAgznBR;;AA1ynBA;EACE,mBAAA;EACA,cAAA;AA6ynBF;;AA1ynBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AA6ynBF;AA3ynBE;EACE,aAAA;EACA,gCAAA;EACA,kBAAA;EAAA,aAAA;EACA,mBAAA;AA6ynBJ;AA3ynBI;EACE,iBAAA;EACA,kBAAA;EACA,qCAAA;EACA,eAAA;AA6ynBN;AAzynBE;EACE,gBAAA;AA2ynBJ;AAxynBE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA0ynBJ;AAvynBE;EACE,iBAAA;EACA,eAAA;EACA,YAAA;AAyynBJ;AAtynBE;EACE,eAAA;AAwynBJ;AArynBE;EACE,aAAA;EACA,QAAA;AAuynBJ;;AAlynBA;EACE,mBAAA;AAqynBF;;AAlynBA;;EAEE,aAAA;EACA,mBAAA;EACA,SAAA;AAqynBF;AAnynBE;;EACE,WAAA;EACA,YAAA;AAsynBJ;;AAlynBA;EACE,QAAA;AAqynBF;AAnynBE;EACE,WAAA;EACA,YAAA;AAqynBJ;;AAhynBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EAAA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kFAAA;AAmynBF;AAjynBE;EACE,+BAAA;EACA,gCAAA;AAmynBJ;AAhynBE;EACE,aAAA;EACA,eAAA;AAkynBJ;AA/xnBE;EACE,uBAAA;EAAA,kCAAA;EACA,qBAAA;EAAA,gCAAA;EACA,cAAA;EAAA,yBAAA;AAiynBJ;AA/xnBI;EACE,qBAAA;EAAA,gCAAA;EACA,uBAAA;EAAA,kCAAA;EACA,wBAAA;AAiynBN;AA7xnBE;EACE,qCAAA;EACA,cAAA;AA+xnBJ;AA7xnBI;EACE,mCAAA;EACA,qBAAA;AA+xnBN;;AA1xnBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;AA6xnBF;AA3xnBE;EACE,aAAA;AA6xnBJ;;AAzxnBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AA4xnBF;AA1xnBE;EACE,WAAA;EACA,YAAA;AA4xnBJ;;AAxxnBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AA2xnBF;AAzxnBE;EACE,eAAA;EACA,SAAA;AA2xnBJ;AAxxnBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA0xnBJ;AAvxnBE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AAyxnBJ;;AArxnBA;EACE,eAAA;EACA,yBAAA;AAwxnBF;;AArxnBA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAwxnBF;;AArxnBA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AAwxnBF;AAtxnBE;;EAEE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4CAAA;AAwxnBJ;AArxnBE;EACE,gBAAA;EACA,mBAAA;AAuxnBJ;AApxnBE;EACE,gBAAA;EACA,YAAA;AAsxnBJ;AAnxnBE;EACE,WAAA;EACA,eAAA;EACA,mBAAA;AAqxnBJ;;AAjxnBA;;EAEE,cAAA;EACA,eAAA;EACA,eAAA;EACA,0BAAA;AAoxnBF;;AAjxnBA;EACE,cAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EAAA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;AAoxnBF;;AAjxnBA;EACE,WAAA;AAoxnBF;AAlxnBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAoxnBJ;;AAhxnBA;EACE,gBAAA;AAmxnBF;;AAhxnBA;EACE,0BAAA;AAmxnBF;;AAhxnBA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAmxnBF;;AAhxnBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAmxnBF;AAjxnBE;EACE,eAAA;AAmxnBJ;AAhxnBE;EACE,WAAA;EACA,eAAA;AAkxnBJ;;AA9wnBA;EACE,+BAAA;AAixnBF;;AA9wnBA;EACE,aAAA;EACA,2DAAA;EACA,cAAA;EAAA,SAAA;AAixnBF;AA/wnBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAixnBJ;AA9wnBE;;EAEE,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;AAgxnBJ;;AA5wnBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,kBAAA;EACA,0CAAA;AA+wnBF;AA7wnBE;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA+wnBJ;AA7wnBI;EACE,+BAAA;AA+wnBN;AA5wnBI;EACE,cAAA;EACA,eAAA;EACA,0BAAA;AA8wnBN","sourcesContent":["@use 'bootstrap/scss/bootstrap' as *;\n@use 'bootstrap/scss/bootstrap-grid' as *;\n@use 'bootstrap/scss/bootstrap-utilities' as *;\n\n* {\n  box-sizing: border-box;\n}\n// Variables\n:root {\n  --color-primary: #3a5443ff;\n  --color-primary-translucent: #284f4330;\n  --color-secondary: #844c85;\n  --color-error: #aa0000;\n  --color-error-background: #ffeeee;\n  --color-muted: #6c757d;\n  --color-gray: #aaaaaa;\n  --color-light-gray: #cccccc;\n  --color-dark-gray: #999999;\n  --color-white: #ffffff;\n  --color-black: #555555;\n  --color-super-black: #000000;\n  --color-background: #ffffff;\n  --color-highlight: #eaf2ff;\n  --color-disabled-background: #f8f8f8;\n  --color-light-line: #e0e0e0;\n  --color-control: #333333;\n  --color-control-background: #ffffff;\n  --color-control-label: #bbbbbb;\n  --color-button-label: #ffffff;\n  --color-button-background: #284f43;\n  --color-cancel-button-label: #284f43;\n  --color-cancel-button-background: #ffffff;\n  --color-nav-bar-background: #f4f4f4;\n  --color-border: #dee2e6;\n  --color-red: #dd1111;\n  --color-green: #11aa11;\n\n  --width-nav-bar: 200px;\n}\n\n// Dark theme\n[data-theme='dark'] {\n  --color-primary: #5a8a7c;\n  --color-black: #eeeeee;\n  --color-white: #444444;\n  --color-super-black: #ffffff;\n  --color-background: #333333;\n  --color-nav-bar-background: #444444;\n  --color-light-gray: #cccccc;\n  --color-primary-translucent: #268cd333;\n  --color-light-line: #666666;\n  --color-disabled-button: #999999;\n  --color-highlight: #505060;\n  --color-control: #ffffff;\n  --color-control-background: #333333;\n  --color-control-label: #777777;\n  --color-button-label: #ffffff;\n  --color-button-background: #284f43;\n  --color-cancel-button-label: #999999;\n  --color-cancel-button-background: #666666;\n  --color-menu-background: #555555;\n}\n\n// Base styles\n* {\n  font-family:\n    'Inter',\n    -apple-system,\n    BlinkMacSystemFont,\n    'Segoe UI',\n    Roboto,\n    Oxygen,\n    Ubuntu,\n    Cantarell,\n    'Open Sans',\n    'Helvetica Neue',\n    sans-serif;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n*:not(path):not(svg):not(rect) {\n  xcolor: var(--color-black);\n}\n\nhtml,\nbody {\n  height: 100%;\n  background-color: var(--color-background);\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  color: var(--text-color);\n  scroll-behavior: auto;\n}\n\nbody {\n  opacity: 0;\n  animation: fadeIn 200ms ease-in forwards;\n  animation-delay: 200ms;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.loader {\n  width: 50px;\n  aspect-ratio: 1;\n  display: grid;\n  border: 4px solid #0000;\n  border-radius: 50%;\n  border-right-color: #25b09b;\n  animation: l15 1s infinite linear;\n}\n.loader::before,\n.loader::after {\n  content: '';\n  grid-area: 1/1;\n  margin: 2px;\n  border: inherit;\n  border-radius: 50%;\n  animation: l15 2s infinite;\n}\n.loader::after {\n  margin: 8px;\n  animation-duration: 3s;\n}\n@keyframes l15 {\n  100% {\n    transform: rotate(1turn);\n  }\n}\n\n.hidden {\n  display: none;\n}\n\n// Layout\n.container {\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n// Buttons\n\n.styled-button {\n  box-shadow:\n    0 0 16px 0 rgba(0, 0, 0, 0.2),\n    0 0 20px 0 rgba(0, 0, 0, 0.1);\n  border: none;\n  color: var(--color-white);\n  background-color: var(--color-primary);\n  padding: 1.2em 2.8em;\n  text-decoration: none;\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: 700;\n  transition: all 0.2s ease-in;\n  letter-spacing: 1px;\n  cursor: pointer;\n  outline: none;\n  font-size: 16px;\n\n  &:hover {\n    background-color: var(--color-white);\n    color: var(--color-primary);\n  }\n\n  &:disabled {\n    color: var(--color-gray) !important;\n    background-color: var(--color-disabled-button);\n    box-shadow: none !important;\n    cursor: initial;\n  }\n  &.sm {\n    padding: 0.4rem 1.6rem;\n    font-size: 14px;\n  }\n\n  // Destructive actions (e.g. \"Remove Photo\").\n  &.danger {\n    background-color: var(--color-red);\n\n    &:hover {\n      background-color: var(--color-white);\n      color: var(--color-red);\n    }\n  }\n}\n\n// Sits on the left of a modal footer, away from the primary actions.\n.modal-content-wrapper .modal-footer-content .remove-photo-button {\n  margin-right: auto;\n}\n\n.input-container {\n  position: relative;\n  width: 100%;\n  display: block;\n\n  &.column-2 {\n    display: inline-block;\n    width: calc(50% - 6px);\n  }\n\n  &.column-2-last {\n    display: inline-block;\n    width: calc(50% - 6px);\n    margin-left: 12px !important;\n  }\n\n  &:focus-within label {\n    transform: translate(-14px, 2px) scale(0.7);\n    color: var(--color-primary);\n  }\n\n  .filled {\n    transform: translate(-14px, 2px) scale(0.7);\n  }\n\n  label {\n    position: absolute;\n    pointer-events: none;\n    transform: translate(-4px, 18px) scale(1);\n    transform-origin: top left;\n    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    color: var(--color-control-label);\n    font-size: 20px;\n    line-height: 1;\n    left: 16px;\n    padding: 3px;\n    overflow: hidden;\n    height: 25px;\n    max-height: 25px;\n    width: 100%;\n  }\n\n  input,\n  textarea,\n  select,\n  .link-box {\n    height: 64px;\n    border: none;\n    padding: 12px 16px 2px 16px;\n    font-size: 20px;\n    line-height: 1;\n    outline: none;\n    box-shadow: none;\n    transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n    border-bottom: solid 3px #eeeeee;\n    transition: all 200ms ease-in;\n    width: 100%;\n\n    &:read-only {\n      background-color: var(--color-background-color);\n    }\n  }\n\n  select {\n    padding-right: 20px;\n  }\n\n  input:focus,\n  textarea:focus,\n  select:focus {\n    border-bottom: solid 3px var(--color-primary);\n  }\n\n  textarea {\n    min-height: 230px;\n    padding-top: 25px;\n    resize: none;\n    line-height: 23px;\n  }\n\n  &.not-valid {\n    input,\n    textarea,\n    select {\n      border-bottom: solid 3px #aa0000;\n      background-color: #ffeeee;\n    }\n  }\n}\n\n.form-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-bottom: 20px;\n\n  label {\n    font-size: 12px;\n    color: var(--color-gray);\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n\n  p {\n    font-size: 15px;\n    color: var(--color-black);\n    margin: 0;\n    position: relative;\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 0.2rem;\n    align-items: center;\n    height: fit-content;\n    line-height: normal;\n    max-width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 280px;\n  }\n\n  &.nudge-up p {\n    top: -3px;\n  }\n}\n\n.request-password-reset {\n  padding-top: 30px;\n}\n\n.login-form {\n  .request-password-reset {\n    padding-top: 0;\n    margin-bottom: 1rem;\n  }\n\n  .login-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    margin-top: 1.5rem;\n  }\n\n  .login-primary-button,\n  .login-google-button,\n  .login-google-wrap {\n    width: 100%;\n    margin: 0;\n  }\n\n  .login-google-wrap {\n    position: relative;\n  }\n\n  .login-google-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    background-color: var(--color-white);\n    color: var(--color-primary);\n    border: 2px solid var(--color-primary);\n    box-shadow: none;\n\n    &:hover:not(:disabled) {\n      background-color: var(--color-primary);\n      color: var(--color-white);\n    }\n\n    &:disabled {\n      border-color: var(--color-disabled-button);\n    }\n  }\n\n  .login-google-mark {\n    width: 1.15em;\n    height: 1.15em;\n    flex-shrink: 0;\n  }\n\n  .login-google-overlay {\n    position: absolute;\n    inset: 0;\n    opacity: 0.001;\n    overflow: hidden;\n    cursor: pointer;\n\n    > div,\n    iframe {\n      width: 100% !important;\n      height: 100% !important;\n      min-width: 100% !important;\n    }\n  }\n}\n\n// Cards\n.card {\n  background: var(--color-white);\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n// Alerts\n.alert {\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n\n  &-error {\n    background-color: var(--color-error-background);\n    border: 1px solid var(--color-error);\n    color: var(--color-error);\n  }\n}\n\n.no-data {\n  font-size: 15px;\n  opacity: 0;\n  animation: fadeIn 0.2s ease-in-out forwards;\n  animation-delay: 0.5s;\n}\n\n.split-screen-container {\n  position: fixed;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n\n  &.content-left {\n    flex-direction: row-reverse;\n  }\n\n  &.content-right {\n    flex-direction: row;\n  }\n\n  .split-screen-image {\n    width: 50%;\n    height: 100%;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    position: relative;\n\n    @media (max-width: 992px) {\n      display: none;\n    }\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background: linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.1));\n    }\n  }\n\n  .split-screen-content {\n    width: 50%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #eeeeee !important;\n    padding: 40px;\n    overflow-y: auto;\n\n    @media (max-width: 992px) {\n      width: 100%;\n      padding: 20px;\n    }\n\n    .content-wrapper {\n      width: 100%;\n      max-width: 400px;\n      color: var(--color-black);\n\n      @media (max-width: 992px) {\n        max-width: 100%;\n      }\n\n      img.split-screen-logo {\n        width: auto;\n        height: 80px;\n        margin-bottom: 40px;\n        cursor: pointer;\n\n        @media (max-width: 992px) {\n          height: 50px;\n          margin-bottom: 15px;\n        }\n      }\n\n      h3.display-4 {\n        font-weight: 200;\n        font-size: 44px;\n        color: var(--color-black);\n        margin-bottom: 20px;\n\n        @media (max-width: 992px) {\n          font-size: 32px;\n          margin-bottom: 15px;\n        }\n      }\n\n      p.muted {\n        color: var(--color-muted);\n        font-size: 16px;\n        margin-bottom: 30px;\n      }\n\n      .error-message {\n        color: var(--color-error);\n        margin-top: 30px;\n        line-height: 20px;\n      }\n\n      form {\n        margin-top: 50px;\n        margin-bottom: 30px;\n        width: 100%;\n\n        .input-container {\n          margin-bottom: 20px;\n          width: 100%;\n\n          label {\n            position: absolute;\n            pointer-events: none;\n            transform: translate(-4px, 18px) scale(1);\n            transform-origin: top left;\n            transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n            color: var(--color-control-label);\n            font-size: 20px;\n            line-height: 1;\n            left: 16px;\n            padding: 3px;\n            overflow: hidden;\n            height: 25px;\n            max-height: 25px;\n            width: 100%;\n          }\n\n          input,\n          textarea,\n          select {\n            height: 64px;\n            border: none;\n            padding: 12px 16px 2px 16px;\n            font-size: 20px;\n            line-height: 1;\n            outline: none;\n            box-shadow: none;\n            transition: 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n            border-bottom: solid 3px var(--color-light-line);\n            width: 100%;\n            color: var(--color-control);\n            background-color: var(--color-control-background);\n\n            &:focus {\n              border-bottom: solid 3px var(--color-primary);\n            }\n          }\n\n          &:focus-within label {\n            transform: translate(-14px, 2px) scale(0.7);\n            color: var(--color-primary);\n          }\n\n          .filled {\n            transform: translate(-14px, 2px) scale(0.7);\n          }\n        }\n\n        button {\n          margin-top: 40px;\n          margin-bottom: 30px;\n          width: 100%;\n        }\n\n        .login-actions {\n          button {\n            margin-top: 0;\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n.reset-password {\n  margin-top: 30px;\n}\n\n.muted {\n  color: var(--color-muted);\n}\n\n.simple-link {\n  color: var(--color-primary);\n  text-decoration: underline;\n}\n\n// Animations\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeout {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.test-style,\n.home-page-title.test-style {\n  display: none;\n}\n\n.split-screen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  overflow: hidden;\n\n  &.reversed {\n    flex-direction: row-reverse;\n  }\n\n  .image {\n    flex: 1;\n    position: relative;\n    overflow: hidden;\n\n    .bg-image {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      background-size: cover;\n      background-position: center;\n      background-repeat: no-repeat;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4));\n      }\n    }\n  }\n\n  .content-side {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--color-background);\n    padding: 2rem;\n\n    .content {\n      max-width: 400px;\n      width: 100%;\n    }\n  }\n}\n\n.content-wrapper {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px 30px 10px 30px;\n\n  h2 {\n    font-weight: 200;\n    font-size: 44px;\n    color: var(--color-black);\n  }\n}\n\n.map-container {\n  font-size: 15px;\n}\n\n.map-tab-static {\n  width: 100%;\n}\n\n.dashboard {\n  .dashboard-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 20px;\n\n    h2 {\n      margin: 0;\n    }\n  }\n\n  .dashboard-period-selector {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    color: var(--color-light-gray);\n    text-transform: uppercase;\n\n    select {\n      min-width: 150px;\n      padding: 6px 10px;\n      border: solid 1px var(--color-black);\n      border-radius: 4px;\n      background: var(--color-white);\n      text-transform: none;\n      color: var(--color-black);\n    }\n  }\n\n  .dashboard-chart {\n    border: solid 1px var(--color-black);\n    border-radius: 4px;\n    padding-top: 14px;\n    padding-left: 10px;\n    height: 250px;\n    min-height: 2px;\n    pointer-events: none;\n    font-family: Inter, Arial, Helvetica, sans-serif;\n    font-size: 13px;\n    color: var(--color-black);\n    position: relative;\n    margin-bottom: 30px;\n\n    .recharts-responsive-container {\n      position: relative;\n      left: -10px;\n      padding-top: 10px;\n      padding-right: 20px;\n    }\n\n    span.header {\n      padding-left: 6px;\n    }\n  }\n\n  .dashboard-top-users {\n    border: solid 1px var(--color-black);\n    color: var(--color-black);\n    border-radius: 4px;\n    height: 375px;\n    min-height: 375px;\n    overflow: hidden;\n    position: relative;\n    margin-bottom: 30px;\n    padding-top: 14px;\n    padding-bottom: 25px;\n\n    span.header {\n      margin-left: 15px;\n    }\n\n    .frame {\n      margin: 0 30px 30px 25px;\n    }\n  }\n\n  .dashboard-map {\n    border: solid 1px var(--color-black);\n    border-radius: 4px;\n    padding: 10px;\n    height: 375px;\n    min-height: 375px;\n    position: relative;\n    margin-bottom: 30px;\n\n    @media (max-width: 700px) {\n      height: unset;\n      min-height: unset;\n    }\n\n    span.header {\n      margin-left: 10px;\n      position: relative;\n      top: 3px;\n    }\n\n    .us-state-map {\n      padding-top: 10px;\n      padding-bottom: 60px;\n      width: 100%;\n      height: 100%;\n      max-height: 380px;\n\n      @media (max-width: 700px) {\n        padding-bottom: 0;\n      }\n    }\n  }\n\n  span.header {\n    font-weight: 600;\n    color: var(--color-gray);\n    text-transform: uppercase;\n    font-size: 13px;\n  }\n\n  .aggregates {\n    min-height: 130px;\n\n    .aggregate {\n      height: 130px;\n      min-height: 130px;\n      max-height: 130px;\n      margin-bottom: 30px;\n\n      & > div {\n        border: solid 1px var(--color-black);\n        padding: 10px 15px 0 15px;\n        border-radius: 4px;\n        height: 100%;\n        position: relative;\n        overflow: hidden;\n        transition: box-shadow 120ms ease-in;\n      }\n\n      & > div.clickable {\n        cursor: pointer;\n      }\n\n      & > div.clickable:hover {\n        /* Subtle, even gray glow without shifting layout */\n        box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.08);\n      }\n\n      p {\n        margin: 0;\n        overflow: hidden;\n        text-overflow: hidden;\n      }\n\n      p:nth-child(1) {\n        color: var(--color-light-gray);\n        text-transform: uppercase;\n        font-size: 13px;\n        font-weight: 700;\n        position: absolute;\n        top: 16px;\n      }\n\n      p:nth-child(2) {\n        color: var(--color-black);\n        font-size: 36px;\n        font-weight: 600;\n        letter-spacing: 1px;\n        position: absolute;\n        top: 38px;\n      }\n\n      p:nth-child(3) {\n        color: var(--color-gray);\n        font-size: 14px;\n        position: absolute;\n        bottom: 10px;\n        height: 19px;\n        max-height: 19px;\n        overflow: hidden;\n        word-break: break-all;\n      }\n\n      .icon {\n        margin-right: 8px;\n      }\n\n      .icon-ArrowTrendUp,\n      span.trendUp {\n        color: var(--color-green);\n      }\n\n      .icon-ArrowTrendDown,\n      span.trendDown {\n        color: var(--color-red);\n      }\n    }\n  }\n}\n\n// Auth timeout bar\n.auth-timeout-bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: var(--color-light-line);\n  z-index: 1030;\n\n  div {\n    height: 100%;\n    background-color: var(--color-primary);\n    transition: width 0.1s linear;\n  }\n}\n\n.authenticated-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100%;\n\n  .layout-container {\n    display: flex;\n    flex: 1;\n  }\n\n  .nav-bar {\n    display: flex;\n    flex-direction: column;\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: var(--width-nav-bar);\n    height: 100vh;\n    background-color: var(--color-nav-bar-background) !important;\n    color: var(--color-black);\n    transition: width 0.3s ease;\n    z-index: 100;\n    border-right: solid 1px var(--color-light-line);\n    width: var(--width-nav-bar);\n    transition: width 0.3s ease;\n    background-color: var(--color-nav-bar-background);\n    height: 100vh;\n    position: fixed;\n    z-index: 1000;\n\n    @media (max-width: 992px) {\n      width: 48px;\n      max-width: 48px;\n      height: auto;\n      position: relative;\n    }\n\n    .top-bar-nav {\n      width: var(--width-nav-bar);\n    }\n\n    .nav-wrapper {\n      margin-top: 74px;\n      flex: 1 1;\n      overflow-y: auto;\n      overflow-x: hidden;\n      max-height: calc(100vh - 74px);\n    }\n\n    &.mobile {\n      width: 55px;\n      height: auto;\n      position: relative;\n      background-color: var(--color-nav-bar-background);\n      border-bottom: 1px solid var(--color-light-line);\n\n      .top-bar-nav {\n        width: 55px;\n        padding: 10px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .logo {\n          img {\n            height: 100%;\n            width: auto;\n          }\n        }\n      }\n\n      .nav-wrapper {\n        padding: 0;\n      }\n\n      .nav.mobile {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: center;\n        gap: 10px;\n        padding: 10px;\n\n        .nav-item {\n          margin: 0;\n          width: auto;\n\n          .nav-item-link {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            padding: 8px;\n            border-radius: 8px;\n            transition: all 0.2s ease;\n\n            &.active {\n              color: var(--color-primary);\n            }\n\n            .icon {\n              margin: 0 0 4px 0;\n              font-size: 1.2em;\n            }\n\n            .nav-item-label {\n              font-size: 0.8em;\n              text-align: center;\n              white-space: nowrap;\n            }\n          }\n        }\n      }\n    }\n\n    .collapse-button {\n      position: fixed;\n      top: 20px;\n      left: calc(var(--width-nav-bar) - 30px);\n      transition: all 0.3s ease;\n      display: block;\n\n      @media (max-width: 992px) {\n        display: none;\n      }\n    }\n\n    .toggle-button {\n      position: absolute;\n      top: 1rem;\n      right: 16px;\n      background: none;\n      border: none;\n      color: var(--color-black);\n      cursor: pointer;\n      padding: 0.5rem;\n      font-size: 1.1rem;\n      z-index: 101;\n\n      &:hover {\n        opacity: 0.8;\n      }\n    }\n\n    .light-theme-only {\n      display: block;\n    }\n\n    .dark-theme-only {\n      display: none;\n    }\n\n    .logo {\n      height: 60px;\n      width: 100%;\n      padding: 10px 44px 0 20px;\n      transition: opacity 0.2s ease;\n      transition-delay: 0.1s;\n      opacity: 1;\n\n      @media (max-width: 992px) {\n        opacity: 0;\n      }\n\n      .logo-image,\n      .logo-image-white {\n        height: 42px;\n        width: auto;\n      }\n    }\n\n    .position-sticky {\n      z-index: 100;\n    }\n\n    .position-sticky {\n      padding-top: 1px !important;\n    }\n\n    .nav-item {\n      height: 45px;\n      max-height: 45px;\n      position: relative;\n    }\n\n    .nav-item-link {\n      color: var(--color-black);\n      position: relative;\n      display: inline-block;\n\n      &.disabled {\n        opacity: 0.45;\n        cursor: not-allowed;\n        pointer-events: none;\n      }\n      width: 208px;\n      max-width: 208px;\n      min-height: 45px;\n      max-height: 45px;\n      margin-top: 0;\n      margin-left: 10px;\n      margin-bottom: 0;\n      border-width: 0;\n      border-top-right-radius: 8px;\n      border-bottom-right-radius: 8px;\n      border-top-left-radius: 8px;\n      border-bottom-left-radius: 8px;\n      text-decoration: none;\n      padding-left: 32px;\n      padding-top: 9px;\n      border-left: solid 8px transparent;\n      transition: margin-left 0.2s ease;\n\n      @media (max-width: 992px) {\n        margin-left: 5px;\n      }\n\n      .icon {\n        display: inline-block;\n        text-align: left;\n        position: absolute;\n        font-size: 16px;\n        margin-left: 4px;\n        margin-right: 8px;\n        margin-top: 10px;\n        width: 22px;\n        transition: all 0.2s ease;\n        top: 0;\n        left: -1px;\n      }\n\n      .icon-Users {\n        top: 1px;\n        left: -1px;\n        font-size: 14px;\n      }\n\n      .icon-Heart {\n        font-size: 19px;\n        top: -2px;\n        left: -2px;\n      }\n\n      .icon-Comment {\n        font-size: 18px;\n        top: -1px;\n        left: -2px;\n      }\n\n      .icon-LayerGroup {\n        font-size: 16px;\n        top: 0;\n        left: -1px;\n      }\n\n      .icon-DoorOpen {\n        font-size: 16px;\n        top: -1px;\n        left: -1px;\n      }\n\n      .icon-Building {\n        font-size: 16px;\n        top: 0px;\n        left: 1px;\n      }\n\n      .icon-NetworkWired {\n        left: -2px;\n        top: 0px;\n      }\n\n      .icon-FileText {\n        font-size: 20px;\n        left: 1px;\n      }\n\n      .icon-Clipboard {\n        font-size: 19px;\n        top: -2px;\n        left: -1px;\n      }\n\n      .icon-Shop {\n        font-size: 15px;\n        top: 0px;\n        left: -1px;\n      }\n\n      .icon-QuoteRight {\n        left: 1px;\n        font-size: 16px;\n      }\n\n      .icon-ChessKing {\n        font-size: 18px;\n        top: -3px;\n        left: 0px;\n      }\n\n      .icon-FireFlameCurved {\n        font-size: 17px;\n        top: -1px;\n        left: 1px;\n      }\n\n      .icon-SignOutAlt {\n        top: 0px;\n        font-size: 16px;\n      }\n\n      .icon-CloudSun {\n        top: 1px;\n      }\n\n      .icon-University {\n        font-size: 16px;\n        left: -1px;\n        top: -1px;\n      }\n\n      .icon-NetworkWired {\n        font-size: 15px;\n        left: -2px;\n        top: 0px;\n      }\n\n      .icon-PersonDigging {\n        font-size: 16px;\n        left: -1px;\n        top: 0px;\n      }\n\n      .icon-Map {\n        font-size: 15px;\n        left: -2px;\n        top: 0px;\n      }\n\n      span {\n        font-size: 16px;\n        position: relative;\n        color: var(--color-black);\n        font-weight: normal;\n        transition: color 0.2s;\n\n        &.nav-item-label {\n          font-size: 14px;\n          font-weight: 500;\n          transition: opacity 0.2s;\n          opacity: 1;\n\n          @media (max-width: 992px) {\n            opacity: 0;\n          }\n        }\n      }\n\n      &:visited {\n        color: var(--color-black);\n      }\n\n      &:hover span {\n        color: var(--color-primary);\n        cursor: pointer;\n      }\n\n      &.active {\n        color: var(--color-primary);\n        cursor: default;\n      }\n\n      &.active,\n      &.active span {\n        color: var(--color-primary);\n        font-weight: 700;\n        cursor: default;\n      }\n    }\n  }\n\n  .top-bar-nav {\n    position: fixed;\n    z-index: 100;\n    top: 0;\n    left: 0;\n    height: 60px;\n    border-bottom: 1px solid var(--color-light-line);\n\n    @media (max-width: 992px) {\n      display: none;\n    }\n  }\n\n  .account-profile {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-left: auto;\n    justify-content: flex-end;\n\n    &.mobile {\n      .language-chooser {\n        width: 35px;\n        height: 35px;\n      }\n\n      .account-profile-button {\n        width: 35px;\n        height: 35px;\n      }\n\n      .popover-container {\n        width: 100%;\n        max-width: 300px;\n      }\n    }\n\n    .language-chooser {\n      height: 30px;\n      width: auto;\n      position: relative;\n      top: 14px;\n      margin-right: 15px;\n      cursor: pointer;\n    }\n\n    .avatar .initials {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 17px;\n    }\n  }\n\n  &.nav-collapsed {\n    .nav-bar {\n      width: 55px;\n\n      .nav-item-label {\n        opacity: 0 !important;\n      }\n\n      .logo {\n        opacity: 0 !important;\n      }\n\n      .collapse-button {\n        left: 22px;\n        top: 15px;\n        transform: rotate(180deg);\n      }\n    }\n\n    .content-area {\n      margin-left: 55px;\n\n      @media (max-width: 992px) {\n        margin-left: 0;\n      }\n    }\n  }\n\n  .content-area {\n    flex: 1;\n    margin-left: var(--width-nav-bar);\n    transition: margin-left 0.3s ease;\n    overflow-y: auto;\n    height: 100vh;\n\n    @media (max-width: 992px) {\n      margin-left: 0;\n    }\n  }\n\n  .content-container {\n    padding: 0;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .top-bar {\n    background-color: var(--color-background);\n    border-bottom: 1px solid var(--color-light-line);\n    height: 60px;\n    min-height: 60px;\n\n    .top-bar-content {\n      padding: 15px 0 0 35px;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n\n      @media (max-width: 992px) {\n        padding: 15px 0 0 20px;\n      }\n      .global-search {\n        position: relative;\n        width: calc(100% - 180px);\n\n        > input {\n          border: 0;\n          width: 100%;\n          padding: 5px 12px;\n          border: 1px solid var(--color-light-line);\n          border-radius: 6px;\n          background-color: var(--color-background);\n          color: var(--color-black);\n          font-size: 14px;\n          &:focus {\n            outline: none;\n            border-color: var(--color-primary);\n          }\n          &::placeholder {\n            color: var(--color-control-label);\n          }\n        }\n      }\n    }\n  }\n\n  .global-search-panel {\n    position: absolute;\n    top: calc(100% + 6px);\n    left: 0;\n    right: 0;\n    z-index: 1100;\n    max-height: 70vh;\n    overflow-y: auto;\n    background-color: var(--color-background);\n    border: 1px solid var(--color-border);\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    padding: 6px 0;\n\n    .global-search-status {\n      padding: 14px 16px;\n      color: var(--color-muted);\n      font-size: 13px;\n    }\n\n    .global-search-section {\n      &:not(:last-child) {\n        border-bottom: 1px solid var(--color-light-line);\n      }\n    }\n\n    .global-search-section-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 8px 14px 4px;\n\n      .global-search-section-title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 11px;\n        font-weight: 700;\n        letter-spacing: 0.06em;\n        text-transform: uppercase;\n        color: var(--color-muted);\n\n        .icon {\n          color: var(--color-primary);\n        }\n      }\n\n      .global-search-count {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        min-width: 18px;\n        height: 18px;\n        padding: 0 5px;\n        border-radius: 9px;\n        background-color: var(--color-primary-translucent);\n        color: var(--color-primary);\n        font-size: 11px;\n        font-weight: 600;\n        letter-spacing: 0;\n      }\n\n      .global-search-seeall {\n        border: 0;\n        background: none;\n        cursor: pointer;\n        font-size: 12px;\n        font-weight: 600;\n        color: var(--color-primary);\n        padding: 2px 4px;\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n    }\n\n    .global-search-section-items {\n      display: flex;\n      flex-direction: column;\n      padding-bottom: 4px;\n    }\n\n    .global-search-row {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      width: 100%;\n      border: 0;\n      background: none;\n      text-align: left;\n      padding: 7px 14px;\n      cursor: pointer;\n\n      &.active,\n      &:hover {\n        background-color: var(--color-highlight);\n      }\n\n      .global-search-thumb.avatar {\n        width: 34px;\n        height: 34px;\n        flex: 0 0 34px;\n\n        .initials {\n          font-size: 13px;\n          line-height: 1;\n        }\n      }\n\n      .global-search-text {\n        display: flex;\n        flex-direction: column;\n        min-width: 0;\n        flex: 1;\n      }\n\n      .global-search-title {\n        font-size: 14px;\n        color: var(--color-black);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .global-search-subtitle {\n        font-size: 12px;\n        color: var(--color-muted);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      .global-search-badge {\n        flex: 0 0 auto;\n        font-size: 10px;\n        font-weight: 700;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n        padding: 2px 7px;\n        border-radius: 10px;\n\n        &.live {\n          background-color: rgba(17, 170, 17, 0.14);\n          color: var(--color-green);\n        }\n        &.history {\n          background-color: var(--color-disabled-background);\n          color: var(--color-muted);\n        }\n      }\n    }\n  }\n\n  .content-wrapper {\n    flex: 1;\n    overflow-y: auto;\n    background-color: var(--color-background);\n\n    @media (max-width: 992px) {\n      padding: 10px 15px 10px 15px;\n    }\n  }\n}\n\n.avatar {\n  width: 51px;\n  height: 51px;\n  position: relative;\n  // top: 1px;\n  color: var(--color-white);\n\n  &.empty {\n    opacity: 0;\n  }\n\n  &.is-venue .image {\n    border-radius: 0;\n    transform: scale(1.15);\n  }\n\n  .initials {\n    width: 100%;\n    height: 100%;\n    background-color: var(--color-primary);\n    color: var(--color-white);\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 24px;\n    font-weight: 600;\n    position: relative;\n    border-radius: 51px;\n    line-height: 19px;\n  }\n\n  .image {\n    width: 100%;\n    height: 100%;\n    border-radius: 51px;\n    background-position: center center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n    border-radius: 51px;\n    object-fit: cover;\n  }\n\n  &.extra-large {\n    aspect-ratio: 1 / 1;\n    height: 100%;\n    width: 100%;\n    margin-top: 5px;\n\n    .initials {\n      border-radius: 100%;\n    }\n\n    .image {\n      border-radius: 100%;\n    }\n  }\n\n  &.local-avatar {\n    width: 50px;\n    height: 50px;\n    border-radius: 50px;\n    top: 0;\n  }\n\n  &.local-avatar .image {\n    transform: scale(1.1);\n    background-position: center center;\n  }\n\n  &.venue-avatar {\n    border-radius: 0;\n  }\n}\n\n.table {\n  width: 100%;\n  font-size: 13px;\n  position: relative;\n  color: var(--color-background);\n  margin-top: 5px;\n  margin-bottom: 0;\n\n  table {\n    table-layout: fixed;\n\n    tr:not([progress]):hover .options-container {\n      opacity: 1 !important;\n    }\n\n    &:hover td .menu-icon {\n      opacity: 1 !important;\n    }\n\n    &.clickable {\n      tr:not([progress]):hover td {\n        background-color: var(--color-highlight);\n      }\n\n      tbody tr:not([progress]) {\n        cursor: pointer;\n      }\n    }\n\n    width: 100%;\n\n    tr {\n      border-bottom: solid 1px var(--color-light-line);\n      background-color: var(--color-background);\n\n      &:hover td .options-container {\n        opacity: 1 !important;\n      }\n\n      &:hover td .menu-icon {\n        opacity: 1 !important;\n      }\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      &[progress] td {\n        color: var(--color-light-gray) !important;\n\n        img {\n          filter: grayscale(1) brightness(1.8);\n        }\n\n        &:nth-child(2) {\n          max-width: 0;\n          overflow: hidden;\n          text-overflow: clip;\n          white-space: nowrap;\n        }\n\n        &.actions {\n          opacity: 0;\n        }\n\n        div {\n          color: var(--color-light-gray) !important;\n        }\n      }\n    }\n\n    thead tr {\n      height: 34px;\n    }\n\n    td {\n      height: 56px;\n      max-height: 56px;\n      font-size: 13px;\n      padding-right: 8px;\n      padding-top: 0;\n      line-height: 19px;\n      color: var(--color-black);\n      vertical-align: middle;\n\n      &.special-content {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        margin: 0;\n        padding-right: 20px;\n\n        p {\n          overflow: hidden;\n          text-overflow: ellipsis;\n        }\n      }\n\n      p {\n        margin: 0;\n        /* padding-top: 1px; */\n        position: relative;\n        top: -1px;\n      }\n\n      .full-name,\n      .customer-name-and-code,\n      .name-and-address {\n        padding-top: 3px;\n        div:nth-child(1) {\n          font-weight: 600;\n          color: var(--color-black);\n        }\n        div:nth-child(2) {\n          color: var(--color-gray);\n        }\n        div:nth-child(3) {\n          display: none;\n        }\n      }\n\n      .avatar {\n        cursor: pointer;\n      }\n\n      .coordinates-cell {\n        cursor: pointer;\n        color: var(--color-primary);\n      }\n\n      .property-tag {\n        left: -2px;\n      }\n\n      &.actions {\n        div {\n          text-align: center;\n          vertical-align: middle;\n          opacity: 0;\n          transition: opacity 0.2s;\n\n          .icon {\n            font-size: 18px;\n            outline: none;\n            transition: color 0.2s;\n\n            &:hover {\n              color: var(--color-primary);\n            }\n          }\n        }\n      }\n\n      .options-container {\n        opacity: 0;\n        transition: opacity 0.2s ease;\n        display: flex;\n        justify-content: left;\n        padding-left: 3px;\n        align-items: center;\n        height: 40px;\n        width: 100%;\n        position: relative;\n        max-width: 40px;\n\n        .menu-dropdown {\n          position: relative;\n          display: inline-block;\n        }\n\n        .menu-icon {\n          color: var(--color-primary);\n          cursor: pointer;\n          font-size: 22px;\n          display: inline-block !important;\n          width: 35px;\n          height: 35px;\n          padding: 4px;\n          border: solid 1px var(--color-primary);\n          border-radius: 50%;\n          text-align: center;\n          vertical-align: middle;\n          padding-top: 7px;\n        }\n\n        .dropdown-menu {\n          position: absolute;\n          top: 100%;\n          right: 0;\n          margin-top: 4px;\n          background: var(--color-background);\n          border: 1px solid var(--color-light-line);\n          border-radius: 4px;\n          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n          z-index: 1000;\n          min-width: 100px;\n          opacity: 0;\n          visibility: hidden;\n          transform: translateY(-10px);\n          transition: all 0.2s ease;\n          padding-top: 8px;\n          padding-bottom: 8px;\n\n          &.show {\n            opacity: 1;\n            visibility: visible;\n            transform: translateY(0);\n          }\n        }\n\n        .dropdown-item {\n          padding: 8px 12px;\n          cursor: pointer;\n          font-size: 14px;\n          color: var(--color-text);\n          transition: background-color 0.2s ease;\n\n          &:hover {\n            background-color: var(--color-light-line);\n          }\n        }\n      }\n    }\n\n    th {\n      border-bottom: solid 1px var(--color-light-line);\n      font-weight: bold;\n      background-color: var(--color-background);\n\n      &.special-content {\n        width: 50%;\n      }\n\n      div {\n        overflow: hidden;\n        white-space: nowrap;\n      }\n\n      span {\n        position: relative;\n        cursor: pointer;\n        padding: 5px 5px 5px 0px;\n        color: var(--color-black);\n        transition: color 0.2s;\n\n        span {\n          color: var(--color-gray);\n          padding: 0;\n        }\n      }\n\n      span:hover,\n      span:hover span {\n        color: var(--color-primary);\n      }\n\n      span.icon {\n        position: relative;\n        top: 1px;\n      }\n\n      span.icon.icon-CaretDown {\n        top: 1px;\n      }\n\n      div:hover {\n        color: var(--color-primary);\n      }\n\n      &.nameAndAddress-header {\n        width: 30%;\n      }\n\n      &.avatar-header,\n      &.userAvatar-header,\n      &.venueAvatar-header,\n      &.venue-header,\n      &.venueIcon-header {\n        width: 64px;\n      }\n      &.documentType-header {\n        width: 51px;\n      }\n      &.hidden-header {\n        width: 8px;\n      }\n      &.options-header {\n        width: 50px;\n        max-width: 50px;\n      }\n    }\n\n    tbody tr:nth-child(even) {\n      background-color: var(--color-background);\n    }\n\n    tbody tr.api-progress {\n      transition: all 1s;\n      background-image: linear-gradient(to right, var(--color-highlight) 0%, transparent 0%);\n    }\n\n    tbody tr:hover {\n      td.actions div {\n        opacity: 1;\n      }\n    }\n\n    .thumbnail {\n      background-position: center;\n      background-size: cover;\n      width: 100px;\n      height: 100px;\n    }\n\n    .thumbnail-icon {\n      background-position: center;\n      background-size: cover;\n      width: 50px;\n      height: 50px;\n      margin-top: 25px;\n      margin-bottom: 25px;\n      margin-left: 25px;\n    }\n\n    .document-icon {\n      width: 27px;\n      height: 27px;\n      top: 0px;\n      position: relative;\n      max-width: 27px;\n    }\n  }\n}\n\n.venue-icon {\n  width: 51px;\n  height: 51px;\n  border-radius: 51px;\n  background-color: var(--color-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  xbackground-size: 120% 120%;\n  background-position: center center;\n  box-shadow:\n    0 0 1px rgba(128, 128, 128, 0.5),\n    0 0 2px rgba(128, 128, 128, 0.4),\n    0 0 3px rgba(128, 128, 128, 0.3),\n    0 0 4px rgba(128, 128, 128, 0.2),\n    0 0 5px rgba(128, 128, 128, 0.1);\n}\n\n.property-tag {\n  border-radius: 5px;\n  padding: 2px 7px 2px 7px;\n  display: inline-block;\n  position: relative;\n  left: 0;\n  border: solid 1px #cccccc;\n  background-color: #f0f0f0;\n  color: #333333;\n  white-space: nowrap;\n\n  &.Active,\n  &.Resolved,\n  &.NotFraudulent,\n  &.Ready,\n  &.icon-FileExcel,\n  &.NotInterested,\n  &.Trans,\n  &.refund-refunded {\n    background-color: #eaf7ed;\n    border-color: #c4ddca;\n    color: #155724;\n  }\n\n  &.OnProbation,\n  &.Investigating,\n  &.Running,\n  &.Customer,\n  &.icon-FileImage,\n  &.Non-Binary,\n  &.refund-pending {\n    background-color: #fff3cd;\n    border-color: #efdeaa;\n    color: #856404;\n  }\n\n  &.Terminated,\n  &.Tombstoned,\n  &.Fraudulent,\n  &.Error,\n  &.TimedOut,\n  &.Deleted,\n  &.Failed,\n  &.icon-FilePdf,\n  &.Reported,\n  &.refund-failed {\n    background-color: #f8d7da;\n    border-color: #e5b6bb;\n    color: #721c24;\n  }\n\n  &.Orange,\n  &.Support,\n  &.Overdue,\n  &.icon-FileVideo {\n    background-color: #ffe5cc;\n    border-color: #f3bc89;\n    color: #995c00;\n  }\n\n  &.Adjudicated,\n  &.Investigator {\n    background-color: #e5e3f6;\n    border-color: #cabaf2;\n    color: #6b20a2;\n  }\n\n  &.Admin,\n  &.Male,\n  &.icon-FileWord,\n  &.refund-processing {\n    background-color: #ddeafb;\n    border-color: #b3d4f7;\n    color: #0b5394;\n  }\n\n  &.Female,\n  &.icon-FilePowerpoint {\n    background-color: #fdecef;\n    border-color: #f9c6d0;\n    color: #721c24;\n  }\n\n  &.healthy {\n    background-color: #eaf7ed;\n    border-color: #c4ddca;\n    color: #155724;\n  }\n\n  &.degraded {\n    background-color: #fff3cd;\n    border-color: #efdeaa;\n    color: #856404;\n  }\n\n  &.unhealthy {\n    background-color: #f8d7da;\n    border-color: #e5b6bb;\n    color: #721c24;\n  }\n\n  &.not_configured {\n    background-color: var(--color-disabled-background);\n    border-color: #c4c9d1;\n    color: var(--color-muted);\n  }\n}\n\n// 404 Page Styles\n.not-found {\n  &-container {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--color-background);\n    padding: 3rem 1rem;\n  }\n\n  &-content {\n    max-width: 28rem;\n    width: 100%;\n    text-align: center;\n  }\n\n  &-title {\n    font-size: 9rem;\n    font-weight: 800;\n    color: var(--color-primary);\n    line-height: 1;\n    margin: 0;\n  }\n\n  &-subtitle {\n    font-size: 1.875rem;\n    font-weight: 800;\n    color: var(--color-black);\n    margin-top: 1.5rem;\n    margin-bottom: 0;\n  }\n\n  &-description {\n    font-size: 0.875rem;\n    color: var(--color-muted);\n    margin-top: 0.5rem;\n  }\n\n  &-actions {\n    margin-top: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  &-button {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding: 0.5rem 1rem;\n    border-radius: 0.375rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 2px var(--color-primary-translucent);\n    }\n\n    &-primary {\n      background-color: var(--color-button-background);\n      color: var(--color-button-label);\n      border: none;\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n\n      &:hover {\n        opacity: 0.9;\n      }\n    }\n\n    &-secondary {\n      background-color: var(--color-cancel-button-background);\n      color: var(--color-cancel-button-label);\n      border: 1px solid var(--color-border);\n      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n\n      &:hover {\n        background-color: var(--color-disabled-background);\n      }\n    }\n  }\n}\n\n.account-profile {\n  position: absolute;\n  top: 0px;\n  right: 0;\n  z-index: 1000000;\n\n  .popover-container {\n    animation: fadein 0.3s;\n    overflow: visible !important;\n    padding: 15px 20px 15px 20px;\n    z-index: 10000000 !important;\n    background-color: var(--color-white);\n    box-shadow:\n      0 0 16px 0 rgba(0, 0, 0, 0.2),\n      0 0 20px 0 rgba(0, 0, 0, 0.1);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n\n    &.visible {\n      opacity: 1;\n    }\n  }\n\n  .avatar.account-profile-button {\n    display: inline-block;\n    cursor: pointer;\n    position: relative;\n    top: 13px;\n    right: 20px;\n    width: 35px;\n    height: 35px;\n  }\n\n  .icon.button {\n    background-color: transparent;\n    color: var(--color-gray);\n    position: relative;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 20px;\n    margin-right: 19px;\n    top: -11px;\n\n    &:hover {\n      color: var(--color-primary);\n    }\n\n    .icon-badge {\n      position: absolute;\n      right: -5px;\n      top: -2px;\n      width: 13px;\n      height: 13px;\n      border-radius: 13px;\n      background-color: var(--color-red);\n      color: #ffffff;\n      font-size: 8px;\n      font-weight: 600;\n      text-align: center;\n    }\n  }\n}\n\n.top-bar .popover-container {\n  transform: initial !important;\n  animation: fadein 0.3s;\n  min-width: 180px;\n  position: fixed;\n  overflow: visible !important;\n  top: 60px !important;\n  right: 25px !important;\n  left: unset !important;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n\n  &.visible {\n    opacity: 1;\n  }\n\n  &.language {\n    min-width: 144px;\n\n    .popover-content {\n      div {\n        display: flex;\n        align-items: center;\n        padding-left: 4px;\n        cursor: pointer;\n\n        &:hover {\n          background-color: var(--color-highlight);\n        }\n\n        img {\n          width: 24px;\n          height: 24px;\n          margin-right: 8px;\n        }\n\n        span {\n          font-size: 14px;\n          color: var(--color-black);\n        }\n      }\n    }\n  }\n\n  .popover-content {\n    color: var(--color-black);\n    background-color: var(--color-white);\n    position: relative;\n    font-size: 14px;\n\n    .avatar {\n      width: 100%;\n      height: 150px;\n      text-align: center;\n      padding: 5px 5px 0 5px;\n      color: var(--color-black);\n      background-color: var(--color-white);\n\n      .initials {\n        margin: 0 auto;\n        width: 130px;\n        height: 130px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 64px;\n        border-radius: 130px;\n        line-height: 110px;\n        color: var(--color-white);\n      }\n\n      .image {\n        margin: 0 auto;\n        width: 130px;\n        height: 130px;\n        border-radius: 130px;\n        cursor: pointer;\n        background-position: center center;\n        background-size: cover;\n        background-repeat: no-repeat;\n      }\n    }\n\n    .name {\n      text-align: center;\n      display: block;\n      padding-bottom: 4px;\n    }\n\n    .role {\n      text-align: center;\n      display: block;\n    }\n\n    .role-name {\n      display: inline-block;\n      text-align: center;\n    }\n\n    div.item {\n      line-height: 38px;\n      transition: color 0.2s;\n      cursor: pointer;\n\n      .icon {\n        margin-right: 12px;\n        width: 14px;\n        min-width: 14px;\n        display: inline-block;\n\n        &.icon-Moon {\n          position: relative;\n          left: 2px;\n        }\n      }\n\n      &:hover {\n        color: var(--color-primary) !important;\n\n        .icon {\n          color: var(--color-primary) !important;\n        }\n      }\n    }\n\n    hr {\n      margin: 15px 0 10px;\n    }\n  }\n}\n\n.user-detail-overlay,\n.venue-detail-overlay,\n.conversation-detail-overlay,\n.visit-detail-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  outline: none;\n  // Fade transitions via react-modal state classes\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  &.ReactModal__Overlay--after-open {\n    opacity: 1;\n    pointer-events: auto;\n  }\n  &.ReactModal__Overlay--before-close {\n    opacity: 0;\n    pointer-events: none; // allow page interactions during fade-out\n  }\n}\n\n.venue-detail-popup,\n.conversation-detail-popup,\n.visit-detail-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: var(--color-background);\n  border-radius: 8px;\n  box-shadow:\n    0 0 16px 0 rgba(0, 0, 0, 0.2),\n    0 0 20px 0 rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  max-height: 90vh;\n  overflow: auto;\n}\n\n.user-detail-popup,\n.venue-detail-popup,\n.conversation-detail-popup,\n.visit-detail-popup {\n  max-width: 950px;\n  width: 90%;\n  animation: fadein 0.3s;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  &.ReactModal__Content--after-open {\n    opacity: 1;\n  }\n  &.ReactModal__Content--before-close {\n    opacity: 0;\n  }\n  z-index: 1001;\n  outline: none;\n\n  .link {\n    color: var(--color-primary);\n    cursor: pointer;\n    text-decoration: none;\n  }\n\n  .popup-detail-container {\n    max-width: 100%;\n    margin: 0 auto;\n    outline: none;\n\n    .popup-profile-grid {\n      display: grid;\n      grid-template-columns: 270px 1fr;\n      gap: 20px;\n    }\n\n    .popup-image-container {\n      display: flex;\n      align-items: flex-start;\n      height: 320px;\n      width: 260px;\n\n      &.generic-icon {\n        height: 260px;\n        width: 260px;\n        border-radius: 260px;\n        border: solid 3px #999999;\n      }\n\n      .popup-image {\n        width: 100%;\n        height: 100%;\n        border-radius: 8px;\n        margin-right: 10px;\n        background-size: cover;\n        background-position: center;\n        background-repeat: no-repeat;\n      }\n\n      &.generic-icon {\n        .popup-image {\n          margin-right: 0px !important;\n          width: 100%;\n          height: 100%;\n          border-radius: 8px;\n          border-width: 3px;\n          margin-right: 10px;\n          background-size: cover;\n          background-position: center;\n          background-repeat: no-repeat;\n        }\n      }\n    }\n\n    .popup-info {\n      display: flex;\n      flex-direction: column;\n      gap: 15px;\n    }\n\n    .popup-details-grid {\n      display: grid;\n      grid-template-columns: repeat(2, 1fr);\n      gap: 15px;\n    }\n\n    .popup-details-column {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n\n      .clickable p {\n        cursor: pointer;\n        color: var(--color-primary);\n        transition: color 0.2s ease;\n\n        &:hover {\n          color: var(--color-primary-dark);\n        }\n      }\n    }\n\n    h2 {\n      margin: 0;\n      font-size: 44px;\n      font-weight: 200;\n    }\n\n    .popup-visits-section {\n      margin-top: 30px;\n    }\n\n    .popup-map-section {\n      margin-top: 30px;\n      background-color: var(--color-background-light);\n      border-radius: 8px;\n      border: 1px solid var(--color-border);\n\n      h3 {\n        margin: 0 0 15px 0;\n        font-size: 24px;\n        font-weight: 600;\n      }\n\n      p {\n        margin: 0;\n        color: var(--color-text-secondary);\n        font-style: italic;\n      }\n    }\n\n    // Conversation-specific styles\n    .popup-messages-section {\n      margin-top: 20px;\n\n      h3 {\n        margin: 0 0 20px 0;\n        font-size: 24px;\n        font-weight: 600;\n      }\n\n      .messages-container {\n        max-height: 400px;\n        overflow-y: auto;\n        padding: 15px;\n        background-color: var(--color-background-light);\n\n        .message-bubble {\n          margin-bottom: 15px;\n          padding: 15px;\n          border-radius: 8px;\n          background-color: var(--color-background);\n          border: 1px solid var(--color-border);\n          max-width: 75%;\n          min-width: 200px;\n          width: fit-content;\n\n          &.recipient {\n            margin-left: auto;\n          }\n\n          &.sender {\n            margin-right: auto;\n          }\n\n          .message-layout {\n            display: flex;\n            align-items: flex-start;\n            gap: 15px;\n          }\n\n          .message-sender-info {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            flex-shrink: 0;\n\n            .avatar {\n              flex-shrink: 0;\n            }\n\n            .full-name {\n              div:first-child {\n                font-weight: 600;\n                color: var(--color-text-primary);\n                font-size: 14px;\n                line-height: 1.3;\n              }\n            }\n          }\n\n          .message-content-wrapper {\n            flex: 1;\n            min-width: 0; // Allow text to wrap properly\n            margin-left: 25px;\n            margin-top: 5px;\n          }\n\n          .message-content {\n            font-size: 14px;\n            line-height: 1.4;\n            color: var(--color-text-primary);\n            margin-bottom: 6px;\n            word-wrap: break-word;\n          }\n\n          .message-timestamp {\n            font-size: 11px;\n            color: #999999;\n          }\n\n          &.sender {\n            .message-timestamp {\n              text-align: left;\n            }\n          }\n\n          &.recipient {\n            .message-sender-info {\n              .full-name {\n                text-align: right;\n              }\n            }\n          }\n        }\n\n        .recipient .message-content-wrapper {\n          flex: 1;\n          min-width: 0;\n          margin-left: 10px;\n          margin-right: 25px;\n        }\n\n        .no-messages {\n          text-align: center;\n          color: var(--color-text-secondary);\n          font-style: italic;\n          padding: 40px 20px;\n        }\n      }\n    }\n  }\n}\n\n.feedback-thread-popup {\n  // Popup buttons are compact, like the ones in .modal-content-wrapper.\n  .styled-button {\n    margin: 0;\n    padding: 8px 16px;\n    font-size: 13px;\n    box-shadow: none;\n    border: 1px solid var(--color-primary);\n\n    &.secondary {\n      background-color: var(--color-cancel-button-background);\n      color: var(--color-cancel-button-label);\n      border: 1px solid var(--color-border);\n\n      &:hover {\n        background-color: var(--color-primary);\n        color: var(--color-white);\n      }\n    }\n  }\n\n  .feedback-icon-label {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    text-decoration: none;\n\n    .icon {\n      font-size: 12px;\n      line-height: 1;\n    }\n  }\n\n  .feedback-back-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 12px;\n    padding: 0;\n    border: none;\n    background: none;\n    color: var(--color-primary);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n\n    .icon {\n      font-size: 11px;\n    }\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .feedback-thread-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 8px;\n\n    h2 {\n      max-width: 640px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      font-size: 28px;\n    }\n  }\n\n  .feedback-thread-title {\n    min-width: 0;\n  }\n\n  .feedback-thread-meta {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-top: 8px;\n  }\n\n  .feedback-thread-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n\n  .feedback-status {\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n\n    &.is-open {\n      color: #2e7d32;\n    }\n\n    &.is-closed {\n      color: #888888;\n    }\n\n    &.feedback-type-venue-suggestion {\n      color: #1a73e8;\n    }\n\n    &.feedback-type-refund {\n      color: #b26a00;\n    }\n  }\n\n  .feedback-venue-suggestion-card {\n    margin: 12px 0 16px;\n    padding: 16px;\n    border-radius: 8px;\n    background: rgba(26, 115, 232, 0.08);\n    border: 1px solid rgba(26, 115, 232, 0.25);\n  }\n\n  .feedback-venue-suggestion-name {\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  .feedback-venue-suggestion-meta {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-top: 6px;\n    font-size: 13px;\n    color: var(--color-text-secondary);\n\n    a {\n      color: #1a73e8;\n    }\n  }\n\n  .feedback-original-post {\n    margin: 12px 0 16px;\n    padding: 16px;\n    border-radius: 8px;\n    background: var(--color-background-light);\n    border: 1px solid var(--color-border);\n  }\n\n  .feedback-original-label {\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: var(--color-text-secondary);\n    margin-bottom: 8px;\n  }\n\n  .feedback-original-body {\n    white-space: pre-wrap;\n    line-height: 1.45;\n  }\n\n  .feedback-original-time {\n    margin-top: 6px;\n    font-size: 11px;\n    color: var(--color-muted);\n  }\n\n  .feedback-messages {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    max-height: 420px;\n    overflow-y: auto;\n    padding: 16px;\n    border-radius: 8px;\n    border: 1px solid var(--color-border);\n    background-color: var(--color-disabled-background);\n  }\n\n  .feedback-messages-empty {\n    padding: 24px 0;\n    text-align: center;\n    font-size: 13px;\n    color: var(--color-muted);\n  }\n\n  .feedback-message {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    max-width: 75%;\n\n    .avatar {\n      flex-shrink: 0;\n      width: 32px;\n      height: 32px;\n\n      .initials {\n        font-size: 13px;\n      }\n    }\n\n    &.is-admin {\n      flex-direction: row-reverse;\n      align-self: flex-end;\n\n      .feedback-message-meta {\n        flex-direction: row-reverse;\n      }\n\n      .feedback-message-bubble {\n        background-color: var(--color-primary-translucent);\n        border-color: transparent;\n      }\n    }\n  }\n\n  .feedback-message-body {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n  }\n\n  .feedback-message-meta {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    font-size: 11px;\n    color: var(--color-muted);\n  }\n\n  .feedback-message-author {\n    font-size: 13px;\n    font-weight: 600;\n    color: var(--color-control);\n  }\n\n  .feedback-message-bubble {\n    padding: 10px 14px;\n    border-radius: 12px;\n    border: 1px solid var(--color-border);\n    background-color: var(--color-background);\n\n    .feedback-attachments {\n      margin-bottom: 0;\n    }\n  }\n\n  .feedback-message-content {\n    font-size: 14px;\n    line-height: 1.45;\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n    color: var(--color-control);\n  }\n\n  .feedback-attachments {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    margin: 8px 0 6px;\n\n    a {\n      display: block;\n      line-height: 0;\n    }\n\n    img {\n      width: 120px;\n      height: 120px;\n      object-fit: cover;\n      border-radius: 8px;\n      border: 1px solid var(--color-border);\n    }\n  }\n\n  .feedback-attachment-drafts {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 12px 12px 0;\n  }\n\n  .feedback-attachment-draft {\n    position: relative;\n\n    img {\n      width: 72px;\n      height: 72px;\n      object-fit: cover;\n      border-radius: 8px;\n      border: 1px solid var(--color-border);\n    }\n\n    button {\n      position: absolute;\n      top: -6px;\n      right: -6px;\n      width: 22px;\n      height: 22px;\n      padding: 0;\n      border: none;\n      border-radius: 50%;\n      background: rgba(0, 0, 0, 0.7);\n      color: #fff;\n      font-size: 11px;\n      cursor: pointer;\n    }\n  }\n\n  .feedback-attachment-error {\n    margin-top: 8px;\n    font-size: 13px;\n    color: var(--color-error);\n  }\n\n  .feedback-composer {\n    margin-top: 16px;\n    border-radius: 8px;\n    border: 1px solid var(--color-border);\n    background-color: var(--color-control-background);\n    transition: border-color 0.2s;\n\n    &:focus-within {\n      border-color: var(--color-primary);\n    }\n\n    textarea {\n      display: block;\n      width: 100%;\n      min-height: 72px;\n      padding: 12px;\n      border: none;\n      outline: none;\n      background: transparent;\n      color: var(--color-control);\n      font-size: 14px;\n      line-height: 1.45;\n      resize: vertical;\n    }\n  }\n\n  .feedback-composer-footer {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 8px 8px 12px;\n    border-top: 1px solid var(--color-border);\n  }\n\n  .feedback-attach-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border: none;\n    border-radius: 6px;\n    background: none;\n    color: var(--color-muted);\n    font-size: 15px;\n    cursor: pointer;\n\n    &:hover:not(:disabled) {\n      background-color: var(--color-disabled-background);\n      color: var(--color-primary);\n    }\n\n    &:disabled {\n      opacity: 0.4;\n      cursor: default;\n    }\n  }\n\n  .feedback-composer-hint {\n    margin-right: auto;\n    font-size: 11px;\n    color: var(--color-muted);\n  }\n}\n\n@keyframes fadein {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n[data-theme='dark'] {\n  .light-theme-only {\n    display: none !important;\n  }\n\n  .dark-theme-only {\n    display: block !important;\n  }\n\n  .user-detail-overlay,\n  .venue-detail-overlay,\n  .conversation-detail-overlay,\n  .visit-detail-overlay {\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n\n  .property-tag {\n    border: solid 1px #cccccc;\n    background-color: #e0e0e0;\n    color: #333333;\n\n    &.Active,\n    &.Resolved,\n    &.NotFraudulent,\n    &.Customer,\n    &.Ready,\n    &.NotInterested,\n    &.icon-FileExcel {\n      background-color: #a3e4b8;\n      border-color: #7ccf8e;\n      color: #0b3d1b;\n    }\n\n    &.OnProbation,\n    &.Investigating,\n    &.Running,\n    &.icon-FileImage {\n      background-color: #ffdd99;\n      border-color: #ffcc66;\n      color: #664400;\n    }\n\n    &.Terminated,\n    &.Tombstoned,\n    &.Fraudulent,\n    &.Error,\n    &.TimedOut,\n    &.icon-FilePdf,\n    &.Reported {\n      background-color: #d09599;\n      border-color: #f08085;\n      color: #4a0d12;\n    }\n\n    &.Orange,\n    &.Support,\n    &.icon-FileVideo {\n      background-color: #ffb366;\n      border-color: #ff9933;\n      color: #663300;\n    }\n\n    &.Adjudicated,\n    &.Investigator {\n      background-color: #b7b1cc;\n      border-color: #9966ff;\n      color: #330066;\n    }\n\n    &.Administrator,\n    &.icon-FileWord {\n      background-color: #99ccff;\n      border-color: #66b2ff;\n      color: #003366;\n    }\n  }\n}\n\n.idle-warning-toast {\n  position: fixed;\n  top: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--color-primary);\n  color: var(--color-button-label);\n  padding: 1rem;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  animation: slideDown 0.3s ease-out;\n  opacity: 1;\n  transition: opacity 0.3s ease-out;\n  text-align: center;\n  width: 580px;\n  padding-left: 25px;\n\n  &.fading-out {\n    opacity: 0;\n  }\n\n  .toast-content {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    text-align: center;\n\n    .icon {\n      font-size: 1.2rem;\n    }\n\n    span {\n      color: var(--color-white);\n    }\n  }\n}\n\n// Idle countdown pill in top bar\n.idle-countdown {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-right: 100px;\n  padding: 4px 8px;\n  border-radius: 12px;\n  background-color: var(--color-primary);\n  color: var(--color-button-label);\n  font-size: 12px;\n  line-height: 1;\n  transition: opacity 0.3s ease-out;\n\n  &.fading-out {\n    opacity: 0;\n  }\n\n  .icon {\n    font-size: 12px;\n  }\n}\n\n@keyframes slideDown {\n  from {\n    transform: translate(-50%, -100%);\n    opacity: 0;\n  }\n  to {\n    transform: translate(-50%, 0);\n    opacity: 1;\n  }\n}\n\n.location-view-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  outline: none;\n}\n\n.location-view-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: var(--color-white);\n  border-radius: 8px;\n  box-shadow:\n    0 0 16px 0 rgba(0, 0, 0, 0.2),\n    0 0 20px 0 rgba(0, 0, 0, 0.1);\n  outline: none;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1002;\n  outline: none;\n  overflow-y: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1.5rem 0.5rem;\n}\n\n.visit-map-popup {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: var(--color-white);\n  border-radius: 8px;\n  box-shadow:\n    0 0 16px 0 rgba(0, 0, 0, 0.2),\n    0 0 20px 0 rgba(0, 0, 0, 0.1);\n  z-index: 1003;\n  outline: none;\n\n  .visit-map-popup-content {\n    padding: 20px;\n    width: 80vw;\n    height: 80vh;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .visit-map-popup-map-container {\n    flex: 1;\n    border-radius: 8px;\n    overflow: hidden;\n    min-height: 0;\n\n    > div {\n      height: 100% !important;\n      border-radius: 8px;\n    }\n  }\n}\n\n.property-bar {\n  padding: 23px 40px 20px 40px;\n  top: 2px;\n  right: 0;\n  overflow-y: auto;\n  left: unset !important;\n  background-color: var(--color-nav-bar-background) !important;\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.75);\n  clip-path: inset(0px 0px 0px -12px);\n  width: 500px !important;\n  right: -500px;\n  color: var(--color-black);\n  position: fixed;\n  transition: 0.3s all;\n  height: 100%;\n  z-index: 1000000;\n\n  select {\n    background-color: #fff !important;\n  }\n\n  &.opened {\n    right: 0;\n  }\n\n  .collapse-button {\n    position: absolute;\n    top: 27px;\n    right: 40px;\n    cursor: pointer;\n    z-index: 999;\n    transition: 0.3s;\n  }\n\n  &.collapsed {\n    right: -500px;\n    box-shadow: none;\n  }\n\n  .input-container {\n    margin: 0 0 10px 0;\n    overflow: hidden;\n\n    label {\n      font-size: 20px;\n    }\n\n    input,\n    textarea,\n    select {\n      font-size: 19px;\n    }\n\n    &:focus-within label {\n      background-color: unset;\n      xtransform: translate(-8px, 7px) scale(0.7);\n\n      &.filled {\n        xtransform: translate(-8px, 7px) scale(0.7);\n      }\n\n      input,\n      select {\n        height: 48px;\n        padding: 4px 10px 0px 12px;\n        font-size: 16px;\n      }\n    }\n  }\n\n  .caption {\n    padding: 0;\n    font-weight: 300;\n    font-size: 27px;\n    padding-bottom: 20px;\n\n    .icon {\n      font-weight: 400;\n      font-size: 20px;\n      padding-left: 10px;\n      position: relative;\n      top: -2px;\n      transition: all 0.2s;\n      cursor: pointer;\n    }\n\n    a .icon,\n    a:visited .icon {\n      color: var(--color-black);\n    }\n\n    a:hover .icon {\n      color: var(--color-primary);\n    }\n  }\n\n  .property-bar-field-group {\n    margin: 20px 0 8px;\n    padding: 16px 18px 6px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.55);\n\n    &__title {\n      font-size: 18px;\n      font-weight: 600;\n      margin: 0 0 8px;\n      color: var(--color-black);\n    }\n\n    &__description {\n      margin: 0 0 14px;\n      font-size: 14px;\n      line-height: 1.45;\n      color: rgba(0, 0, 0, 0.68);\n    }\n\n    .input-container:last-child {\n      margin-bottom: 0;\n    }\n\n    .admin-central-datetime-field {\n      margin-bottom: 16px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .venue-special-external-link {\n    .styled-button {\n      width: auto;\n      margin-bottom: 12px;\n    }\n  }\n\n  .buttons {\n    margin-top: 30px;\n  }\n\n  .styled-button {\n    color: var(--color-button-label);\n    background-color: var(--color-button-background);\n    padding: 1em 2.4em;\n    width: 100%;\n\n    &:hover {\n      background-color: #ffffff;\n      color: var(--color-primary);\n    }\n\n    &.cancel {\n      background-color: var(--color-cancel-button-background);\n      color: var(--color-cancel-button-label);\n      padding: 1em 2.4em;\n      width: 100%;\n    }\n\n    &.cancel:hover {\n      background-color: var(--color-primary);\n      color: var(--color-white);\n    }\n  }\n}\n\n.ReactModal__Overlay {\n  opacity: 0;\n  transition: opacity 300ms ease-in-out;\n}\n\n.ReactModal__Overlay--after-open {\n  opacity: 1;\n}\n\n.ReactModal__Overlay--before-close {\n  opacity: 0;\n}\n\n.header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.header-row .styled-button {\n  font-size: 13px;\n  padding: 10px 12px;\n}\n\n.modal-popup {\n  position: relative;\n  background: var(--color-background);\n  border-radius: 8px;\n  box-shadow:\n    0 0 16px 0 rgba(0, 0, 0, 0.2),\n    0 0 20px 0 rgba(0, 0, 0, 0.1);\n  z-index: 1200;\n  outline: none;\n  margin: auto;\n}\n\n.modal-content-wrapper {\n  display: flex;\n  position: relative;\n  padding: 24px;\n  border-radius: 8px;\n  flex-direction: column;\n  gap: 1rem;\n  overflow: hidden;\n\n  h2 {\n    margin-top: 0;\n    font-weight: 200;\n    margin-bottom: 0;\n  }\n\n  .modal-body-content {\n    display: flex;\n    flex-grow: 1;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .modal-footer-content {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .styled-button {\n    margin: 0;\n    padding: 8px 16px;\n    font-size: 14px;\n  }\n\n  .loader-wrapper {\n    position: absolute;\n    top: 0;\n    left: 0;\n    background-color: rgba(107, 107, 107, 0.226);\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    backdrop-filter: blur(2px);\n    z-index: 5;\n    .loader {\n      width: 10rem;\n      height: 10rem;\n    }\n  }\n}\n\n.add-venue-popup,\n.blast-popup {\n  width: 100%;\n  max-width: 500px;\n}\n\n.add-venue-popup {\n  max-width: min(1100px, 96vw);\n  max-height: 92vh;\n}\n\n.confirm-popup {\n  width: 100%;\n  max-width: 500px;\n}\n\n.blast-modal-content {\n  .form-group {\n    .date-group {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n      .input-container {\n        input,\n        select {\n          height: 45px;\n        }\n        label {\n          display: none;\n        }\n        .time-date {\n          flex: 0 0 190px !important;\n        }\n      }\n    }\n  }\n}\n\n.venue-add-popup-content,\n.logo-content-wrapper,\n.user-detail-page,\n.notifications-page,\n.modal-content-wrapper,\n.blast-modal-content {\n  display: flex;\n  flex-direction: column;\n\n  .form-group {\n    display: flex;\n    flex-direction: column;\n\n    label {\n      font-weight: 600;\n      margin-bottom: 4px;\n    }\n\n    textarea,\n    input,\n    select {\n      border: 1px solid #ccc;\n      border-radius: 4px;\n      padding: 8px;\n      font-size: 14px;\n      resize: none;\n      &:disabled {\n        opacity: 0.7;\n        background-color: var(--color-light-gray);\n      }\n    }\n\n    select {\n      background-color: var(--color-background);\n      color: var(--color-control);\n    }\n\n    input[type='number'] {\n      -moz-appearance: textfield;\n    }\n\n    input[type='number']::-webkit-outer-spin-button,\n    input[type='number']::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n  }\n\n  .recipient-count {\n    position: relative;\n    top: 5px;\n    font-size: 14px;\n    font-weight: 300;\n    color: var(--color-text-secondary);\n  }\n\n  .back-button {\n    background: none;\n    border: none;\n    color: var(--color-primary);\n    cursor: pointer;\n    font-size: 14px;\n    margin-bottom: 12px;\n    padding: 0;\n  }\n\n  .styled-button:disabled {\n    border: 1px solid var(--color-light-line);\n  }\n}\n\n.toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  user-select: none;\n  width: fit-content;\n  position: relative;\n\n  .toggle-input {\n    position: absolute;\n    opacity: 0;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    height: 100%;\n    z-index: 2;\n    cursor: pointer;\n  }\n\n  .toggle-slider {\n    position: relative;\n    width: 48px;\n    height: 28px;\n    background: var(--color-primary-translucent);\n    border: 1px solid var(--color-light-line);\n    border-radius: 999px;\n    transition: background 0.2s ease;\n    top: 1px;\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: 2px;\n      left: 2px;\n      width: 22px;\n      height: 22px;\n      background: var(--color-white);\n      border: 1px solid var(--color-light-line);\n      border-radius: 50%;\n      transition: transform 0.2s ease;\n    }\n  }\n\n  .toggle-input:checked + .toggle-slider {\n    background: var(--color-primary);\n    border-color: var(--color-primary);\n  }\n\n  .toggle-input:checked + .toggle-slider::after {\n    transform: translateX(20px);\n    border-color: var(--color-primary);\n  }\n\n  .toggle-label {\n    font-weight: 500;\n    color: var(--color-black);\n  }\n}\n.datetime-picker {\n  .picker-content-wrapper {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    .date-picker {\n      position: absolute;\n      opacity: 0;\n      width: 0;\n      height: 0;\n      pointer-events: none;\n      &-icon-wrapper {\n        position: absolute;\n        right: 12px;\n        top: 50%;\n        transform: translateY(-50%);\n      }\n    }\n  }\n}\n\n.admin-central-datetime-field {\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 8px;\n  }\n\n  &__label {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--color-black);\n  }\n\n  &__clear {\n    border: none;\n    background: transparent;\n    color: var(--color-primary);\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    padding: 0;\n  }\n\n  &__controls {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__date {\n    width: 100%;\n    height: 44px;\n    border: 1px solid rgba(0, 0, 0, 0.18);\n    border-radius: 8px;\n    padding: 0 12px;\n    font-size: 16px;\n    background: #fff;\n    color: var(--color-black);\n  }\n\n  &__time {\n    display: grid;\n    grid-template-columns: 1fr auto 1fr 1.1fr;\n    gap: 8px;\n    align-items: center;\n  }\n\n  &__select {\n    width: 100%;\n    height: 44px;\n    border: 1px solid rgba(0, 0, 0, 0.18);\n    border-radius: 8px;\n    padding: 0 10px;\n    font-size: 16px;\n    background: #fff;\n    color: var(--color-black);\n  }\n\n  &__separator {\n    font-size: 18px;\n    font-weight: 600;\n    color: rgba(0, 0, 0, 0.55);\n    text-align: center;\n  }\n\n  &__preview,\n  &__hint {\n    margin: 8px 0 0;\n    font-size: 13px;\n    line-height: 1.4;\n  }\n\n  &__preview {\n    color: rgba(0, 0, 0, 0.78);\n    font-weight: 500;\n  }\n\n  &__hint {\n    color: rgba(0, 0, 0, 0.5);\n  }\n}\n\n.admin-event-date-ranges-field {\n  &__notice {\n    background: var(--color-primary-translucent);\n    border: 1px solid var(--color-primary);\n    border-radius: 8px;\n    padding: 10px 14px;\n    font-size: 13px;\n    color: var(--color-black);\n    margin-bottom: 14px;\n\n    strong {\n      color: var(--color-primary);\n    }\n  }\n\n  &__row {\n    border: 1px solid rgba(0, 0, 0, 0.18);\n    border-radius: 8px;\n    padding: 14px;\n    margin-bottom: 14px;\n  }\n\n  &__row-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 10px;\n  }\n\n  &__row-title {\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    color: var(--color-primary);\n  }\n\n  &__add {\n    margin-top: 4px;\n  }\n\n  &__warning {\n    background: var(--color-error-background);\n    border: 1px solid var(--color-error);\n    border-radius: 8px;\n    padding: 10px 14px;\n    font-size: 13px;\n    color: var(--color-error);\n    margin-top: 10px;\n  }\n}\n\n.admin-date-range-row {\n  min-width: 0;\n  max-width: 100%;\n\n  &__calendar-header {\n    display: flex;\n    justify-content: flex-end;\n    min-height: 18px;\n    margin-bottom: 4px;\n  }\n\n  &__clear-link {\n    border: none;\n    background: transparent;\n    color: var(--color-primary);\n    font-size: 13px;\n    font-weight: 600;\n    text-decoration: underline;\n    cursor: pointer;\n    padding: 0;\n  }\n\n  &__calendar {\n    display: flex;\n    justify-content: center;\n    background: var(--color-background);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    padding: 4px;\n    margin-bottom: 12px;\n    max-width: 100%;\n    overflow-x: auto;\n\n    .rdp-root {\n      --rdp-accent-color: var(--color-primary);\n      --rdp-accent-background-color: var(--color-primary-translucent);\n      --rdp-today-color: var(--color-primary);\n      --rdp-range_middle-background-color: var(--color-primary-translucent);\n      --rdp-range_middle-color: var(--color-black);\n      color: var(--color-black);\n      margin: 0;\n    }\n  }\n\n  &__times {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    min-width: 0;\n  }\n\n  &__time-line {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n  }\n\n  &__time-label {\n    flex: 0 0 90px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--color-black);\n  }\n\n  &__time-select {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) minmax(0, 1.1fr);\n    gap: 8px;\n    align-items: center;\n    flex: 1;\n    min-width: 0;\n  }\n\n  &__preview {\n    margin: 10px 0 0;\n    font-size: 13px;\n    font-weight: 500;\n    color: rgba(0, 0, 0, 0.78);\n  }\n}\n\n.venue-detail-event-rsvps__toolbar {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 12px;\n\n  select {\n    max-width: 360px;\n    height: 36px;\n    padding: 0 10px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n    background: #fff;\n  }\n\n  .styled-button {\n    width: auto;\n    white-space: nowrap;\n  }\n}\n\n.event-rsvp-blast-popup {\n  .event-rsvp-blast-counter {\n    float: right;\n    font-weight: 400;\n    opacity: 0.6;\n  }\n\n  .event-rsvp-blast-preview {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin: 12px 0;\n    padding: 12px 14px;\n    border-radius: 12px;\n    background: rgba(0, 0, 0, 0.05);\n  }\n\n  .event-rsvp-blast-note {\n    font-size: 13px;\n    opacity: 0.7;\n  }\n\n  .event-rsvp-blast-warning {\n    margin-top: 6px;\n    font-size: 13px;\n    color: #b45309;\n  }\n\n  .modal-footer-content {\n    gap: 12px;\n  }\n}\n\n.venue-special-popup {\n  width: 100%;\n  max-width: 680px;\n  max-height: 92vh;\n  box-sizing: border-box;\n  overflow-x: hidden;\n}\n\n.venue-special-popup-content {\n  max-height: 92vh;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n\n  * {\n    min-width: 0;\n  }\n\n  .modal-body-content {\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-right: 4px;\n  }\n\n  h2 {\n    margin-bottom: 4px;\n  }\n\n  .property-bar-field-group {\n    margin: 20px 0 8px;\n    padding: 16px 18px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    background: rgba(0, 0, 0, 0.02);\n\n    &__title {\n      font-size: 18px;\n      font-weight: 600;\n      margin: 0 0 8px;\n      color: var(--color-black);\n    }\n\n    &__description {\n      margin: 0 0 14px;\n      font-size: 14px;\n      line-height: 1.45;\n      color: rgba(0, 0, 0, 0.68);\n    }\n  }\n\n  .venue-special-external-link .styled-button {\n    width: auto;\n  }\n\n  .eventbrite-import-row {\n    display: flex;\n    gap: 10px;\n    align-items: stretch;\n\n    input {\n      flex: 1;\n      height: 40px;\n      padding: 0 12px;\n      font-size: 14px;\n      border: 1px solid rgba(0, 0, 0, 0.2);\n      border-radius: 6px;\n      background: #fff;\n      box-sizing: border-box;\n\n      &:focus {\n        outline: none;\n        border-color: var(--color-button-background);\n      }\n    }\n\n    .styled-button {\n      width: auto;\n      height: 40px;\n      padding: 0 20px;\n      white-space: nowrap;\n    }\n  }\n\n  .eventbrite-event-picker {\n    width: 100%;\n    height: 40px;\n    margin: 4px 0 10px;\n    padding: 0 10px;\n    font-size: 14px;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n    background: #fff;\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n      border-color: var(--color-button-background);\n    }\n  }\n\n  .eventbrite-event-picker__error {\n    margin: -4px 0 10px;\n    font-size: 13px;\n    color: #c0392b;\n  }\n\n  .eventbrite-import-summary {\n    margin-top: 12px;\n    font-size: 14px;\n    line-height: 1.45;\n\n    p {\n      margin: 0 0 4px;\n    }\n\n    .styled-button {\n      width: auto;\n      margin-top: 8px;\n    }\n  }\n}\n\n// Pagination styles\n.pagination-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 0;\n  padding: 0;\n\n  .pagination-info {\n    color: #666;\n    font-size: 14px;\n    white-space: nowrap;\n    margin-right: 10px;\n  }\n\n  .pagination-button {\n    box-shadow:\n      0 0 16px 0 rgba(0, 0, 0, 0.2),\n      0 0 20px 0 rgba(0, 0, 0, 0.1);\n    border: none;\n    padding: 8px 16px;\n    text-decoration: none;\n    text-align: center;\n    font-weight: 600;\n    transition: all 0.2s ease-in;\n    cursor: pointer;\n    outline: none;\n    font-size: 13px;\n    white-space: nowrap;\n    width: 90px;\n    min-width: 90px;\n\n    // Default style (for \"Next\" button)\n    color: var(--color-white);\n    background-color: var(--color-primary);\n\n    &:hover:not(:disabled) {\n      background-color: var(--color-white);\n      color: var(--color-primary);\n    }\n\n    // Inverse style (for \"Previous\" button)\n    &.previous {\n      color: var(--color-primary);\n      background-color: var(--color-white);\n\n      &:hover:not(:disabled) {\n        background-color: var(--color-primary);\n        color: var(--color-white);\n      }\n    }\n\n    &:disabled {\n      color: var(--color-gray) !important;\n      background-color: var(--color-disabled-button);\n      box-shadow: none !important;\n      cursor: not-allowed;\n    }\n  }\n}\n\n// Users header layout\n.users-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 0;\n\n  h2 {\n    margin: 0;\n  }\n}\n\n.venues-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  .venues-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0;\n\n    h2 {\n      margin: 0;\n    }\n  }\n  .venues-actions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.5rem;\n  }\n}\n\n.feature-flags-page {\n  .feature-flag-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n  }\n\n  .feature-flag-row-top {\n    align-items: flex-start;\n  }\n\n  .app-feature-toggle-row {\n    padding: 12px 0;\n    border-top: 1px solid var(--color-border);\n  }\n\n  .feature-flag-save-sticky {\n    position: sticky;\n    top: 16px;\n    align-self: flex-start;\n    flex-shrink: 0;\n    z-index: 2;\n  }\n\n  .feature-flag-grow {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .feature-flag-title {\n    font-weight: 600;\n  }\n\n  .feature-flag-subtitle {\n    opacity: 0.8;\n    font-size: 13px;\n  }\n\n  .feature-flag-subtitle-spaced {\n    margin-bottom: 8px;\n  }\n\n  .feature-flag-actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .feature-flag-card-spaced {\n    margin-top: 12px;\n  }\n\n  .feature-flag-textarea {\n    width: 100%;\n    min-height: 72px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    border: 1px solid var(--color-border);\n    resize: vertical;\n    font-family: inherit;\n    font-size: 14px;\n\n    &:disabled {\n      opacity: 0.6;\n    }\n  }\n\n  .feature-flag-checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    margin-bottom: 8px;\n    cursor: pointer;\n  }\n\n  .map-filters-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n    margin-top: 8px;\n\n    th,\n    td {\n      padding: 8px 6px;\n      text-align: left;\n      vertical-align: middle;\n      border-bottom: 1px solid var(--border-color, #e5e5e5);\n    }\n\n    th {\n      font-weight: 600;\n      opacity: 0.85;\n    }\n  }\n\n  .map-filter-input {\n    width: 100%;\n    min-width: 80px;\n    padding: 6px 8px;\n    font-size: 13px;\n    border: 1px solid var(--border-color, #ccc);\n    border-radius: 4px;\n  }\n\n  .venue-type-emoji-input {\n    min-width: 0;\n    width: 56px;\n    text-align: center;\n    font-size: 16px;\n  }\n\n  .ticker-setting-label {\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  .ticker-setting-field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin: 4px 0 16px;\n    max-width: 360px;\n  }\n\n  .ticker-setting-count-input {\n    width: 120px;\n  }\n\n  .ticker-setting-error {\n    color: var(--error-color, #c00);\n    margin-top: -8px;\n    margin-bottom: 12px;\n  }\n\n  .feature-flag-deprecated-notice {\n    background: #fff8e6;\n    border: 1px solid #f0c96b;\n    border-radius: 6px;\n    padding: 10px 12px;\n    margin-bottom: 12px;\n    font-size: 13px;\n    color: #8a6416;\n  }\n\n  .ticker-setting-block {\n    margin-top: 4px;\n  }\n\n  .ticker-settings-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 12px 24px;\n    margin-bottom: 8px;\n  }\n\n  .spotlight-current-venue-settings {\n    margin-top: 4px;\n  }\n\n  .spotlight-eligibility-editor {\n    margin-top: 4px;\n  }\n\n  .spotlight-eligibility-table {\n    margin-top: 8px;\n\n    input[type='checkbox'] {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .spotlight-eligibility-min-input {\n    width: 88px;\n  }\n\n  .spotlight-eligibility-na {\n    opacity: 0.5;\n  }\n\n  .spotlight-sort-table {\n    margin-top: 8px;\n  }\n\n  .spotlight-ticker-guide {\n    margin: 12px 0 20px;\n    padding: 16px;\n    border: 1px solid var(--border-color, #e5e5e5);\n    border-radius: 8px;\n    background: var(--surface-muted, #fafafa);\n    font-size: 13px;\n\n    p {\n      margin: 0 0 12px;\n      line-height: 1.5;\n    }\n\n    code {\n      font-size: 12px;\n    }\n  }\n\n  .spotlight-ticker-guide__pipeline {\n    margin: 0;\n    padding-left: 20px;\n    line-height: 1.55;\n\n    li + li {\n      margin-top: 6px;\n    }\n  }\n\n  .spotlight-ticker-guide__details {\n    margin-top: 16px;\n\n    summary {\n      cursor: pointer;\n      font-weight: 600;\n      user-select: none;\n    }\n  }\n\n  .spotlight-ticker-guide__glossary {\n    margin: 12px 0 0;\n\n    dt {\n      font-weight: 600;\n      margin-top: 12px;\n\n      &:first-child {\n        margin-top: 0;\n      }\n    }\n\n    dd {\n      margin: 4px 0 0;\n      opacity: 0.85;\n      line-height: 1.5;\n    }\n  }\n\n  .spotlight-ticker-preview {\n    margin-top: 16px;\n    padding-top: 16px;\n    border-top: 1px solid var(--border-color, #e5e5e5);\n  }\n\n  .spotlight-ticker-preview__header {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 8px 16px;\n    margin-bottom: 10px;\n  }\n\n  .spotlight-ticker-preview__label {\n    font-weight: 600;\n  }\n\n  .spotlight-ticker-preview__hint {\n    font-size: 12px;\n    opacity: 0.7;\n  }\n\n  .spotlight-ticker-preview__frame {\n    position: relative;\n    max-width: 420px;\n    border-radius: 20px;\n    overflow: hidden;\n    border: 2px solid #333;\n    background: #e8ece9;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n  }\n\n  .spotlight-ticker-preview__map {\n    height: 120px;\n    background:\n      linear-gradient(180deg, rgba(255, 255, 255, 0.15), transparent),\n      repeating-linear-gradient(\n        45deg,\n        #c5d4c8 0,\n        #c5d4c8 8px,\n        #b8c9bb 8px,\n        #b8c9bb 16px\n      );\n  }\n\n  .spotlight-ticker-preview__cards {\n    display: flex;\n    gap: 10px;\n    padding: 10px 12px 14px;\n    overflow-x: auto;\n    background: rgba(255, 255, 255, 0.55);\n  }\n\n  .spotlight-ticker-preview__card {\n    position: relative;\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 168px;\n    padding: 8px 10px;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);\n    overflow: visible;\n\n    &--pinned {\n      outline: 2px solid var(--color-primary, #3a5443);\n    }\n  }\n\n  .spotlight-ticker-preview__card-body {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    flex: 1;\n  }\n\n  .spotlight-ticker-preview__card-name {\n    font-weight: 700;\n    font-size: 12px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .spotlight-ticker-preview__card-subtitle {\n    font-size: 11px;\n    color: #666;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .spotlight-ticker-preview__pin-badge {\n    position: absolute;\n    top: -6px;\n    right: 6px;\n    padding: 1px 5px;\n    border-radius: 4px;\n    background: var(--color-primary, #3a5443);\n    color: #fff;\n    font-size: 9px;\n    font-weight: 600;\n    white-space: nowrap;\n  }\n\n  .spotlight-ticker-preview__caption {\n    margin: 10px 0 0;\n    font-size: 12px;\n    opacity: 0.8;\n    line-height: 1.45;\n    max-width: 520px;\n  }\n\n  .ticker-checkbox-field {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    margin: 12px 0;\n    font-size: 13px;\n    cursor: pointer;\n\n    input[type='checkbox'] {\n      width: 16px;\n      height: 16px;\n      margin: 2px 0 0;\n      flex-shrink: 0;\n    }\n\n    &__text {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      min-width: 0;\n    }\n\n    &__label {\n      font-weight: 500;\n    }\n\n    &__help {\n      line-height: 1.45;\n    }\n  }\n\n  .map-filter-drag-header {\n    width: 72px;\n  }\n\n  .map-filter-drag-cell {\n    width: 72px;\n    white-space: nowrap;\n  }\n\n  .map-filter-drag-handle {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 6px;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    background: transparent;\n    color: inherit;\n    cursor: grab;\n    touch-action: none;\n\n    &:hover {\n      background: var(--hover-bg, rgba(0, 0, 0, 0.04));\n      border-color: var(--border-color, #e5e5e5);\n    }\n\n    &:active {\n      cursor: grabbing;\n    }\n\n    &:focus-visible {\n      outline: 2px solid var(--focus-color, #2270dd);\n      outline-offset: 1px;\n    }\n  }\n\n  .map-filter-drag-icon {\n    opacity: 0.55;\n    font-size: 14px;\n  }\n\n  .map-filter-position-label {\n    min-width: 14px;\n    font-variant-numeric: tabular-nums;\n    font-weight: 600;\n    opacity: 0.75;\n  }\n\n  .map-filter-row-dragging {\n    opacity: 0.35;\n  }\n\n  .map-filters-table-overlay {\n    width: 100%;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    border-radius: 6px;\n    background: var(--card-bg, #fff);\n    table-layout: fixed;\n  }\n\n  .map-filter-row-overlay {\n    background: var(--card-bg, #fff);\n\n    td {\n      border-bottom: none;\n    }\n  }\n\n  .map-filter-hex {\n    max-width: 88px;\n    margin-left: 6px;\n  }\n\n  .map-filter-payload {\n    min-width: 120px;\n    font-family: monospace;\n  }\n\n  .map-filter-color {\n    width: 36px;\n    height: 32px;\n    padding: 0;\n    border: none;\n    vertical-align: middle;\n    cursor: pointer;\n  }\n\n  .map-filter-select {\n    padding: 6px 8px;\n    font-size: 13px;\n    border: 1px solid var(--border-color, #ccc);\n    border-radius: 4px;\n  }\n}\n\n.user-detail-page,\n.venue-detail-page {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.venue-add-popup-content {\n  .add-venue-header {\n    width: 100%;\n    h2 {\n      margin-bottom: 0.25rem;\n    }\n  }\n\n  .add-venue-subtitle {\n    opacity: 0.75;\n    font-size: 0.9rem;\n    margin: 0 0 0.5rem;\n  }\n\n  .add-venue-layout {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1.15fr 0.85fr;\n    gap: 1rem;\n    align-items: start;\n    max-height: calc(92vh - 120px);\n    overflow: hidden;\n  }\n\n  .add-venue-search-pane,\n  .add-venue-form-pane {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n    min-height: 0;\n  }\n\n  .add-venue-search-pane {\n    overflow: hidden;\n  }\n\n  .add-venue-map {\n    width: 100%;\n    height: 260px;\n    border-radius: 10px;\n    overflow: hidden;\n    background: rgba(255, 255, 255, 0.06);\n  }\n\n  .add-venue-map-fallback {\n    font-size: 0.85rem;\n    opacity: 0.75;\n  }\n\n  .add-venue-search-controls {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .add-venue-search-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .add-venue-hint {\n    margin: 0;\n    font-size: 0.8rem;\n    opacity: 0.7;\n  }\n\n  .add-venue-source-errors,\n  .add-venue-error,\n  .add-venue-empty {\n    font-size: 0.85rem;\n    opacity: 0.85;\n  }\n\n  .add-venue-error {\n    color: #f0a0a0;\n  }\n\n  .add-venue-source-ids {\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n    font-size: 0.75rem;\n    opacity: 0.65;\n    word-break: break-all;\n  }\n\n  .add-venue-form-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n  }\n\n  .form-group {\n    width: 100%;\n\n    select {\n      width: 100%;\n      height: 45px;\n      border-radius: 8px;\n      border: 1px solid rgba(255, 255, 255, 0.12);\n      background: rgba(0, 0, 0, 0.25);\n      color: inherit;\n      padding: 0 0.75rem;\n    }\n  }\n\n  .modal-body-content {\n    flex-grow: 1;\n    gap: 1rem;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    .search-input {\n      width: 100%;\n    }\n    .location-inputs {\n      width: 100%;\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 0.5rem;\n    }\n  }\n\n  .location-inputs {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0.5rem;\n  }\n\n  .external-venues-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n    padding-top: 0.2rem;\n    width: 100%;\n    max-height: 220px;\n    overflow: auto;\n    .external-venue-wrapper {\n      display: flex;\n      border: 1px solid rgba(255, 255, 255, 0.12);\n      align-items: center;\n      justify-content: space-between;\n      border-radius: 10px;\n      gap: 0.2rem;\n      padding: 0.4rem;\n\n      &.selected {\n        border-color: rgba(90, 138, 124, 0.8);\n      }\n\n      &.already-exists {\n        opacity: 0.65;\n      }\n\n      .venue-info {\n        display: flex;\n        align-items: center;\n        gap: 12px;\n        min-width: 0;\n\n        .venue-logo {\n          width: 40px;\n          height: 40px;\n          border-radius: 8px;\n          object-fit: cover;\n          background: rgba(255, 255, 255, 0.06);\n          flex-shrink: 0;\n        }\n\n        .venue-details {\n          min-width: 0;\n\n          .venue-name {\n            font-weight: 600;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n\n          .venue-address {\n            opacity: 0.8;\n            font-size: 12px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n\n          .venue-meta {\n            opacity: 0.7;\n            font-size: 12px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 900px) {\n  .venue-add-popup-content {\n    .add-venue-layout {\n      grid-template-columns: 1fr;\n      max-height: none;\n      overflow: auto;\n    }\n\n    .external-venues-list {\n      max-height: 180px;\n    }\n  }\n}\n\n.venue-logo-popup-content,\n.user-photo-popup-content {\n  .logo-content-wrapper {\n    flex-grow: 1;\n    gap: 1rem;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    .dropzone {\n      flex-grow: 1;\n      width: 100%;\n      position: relative;\n      flex-direction: column;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border-radius: 5px;\n      background-color: rgba(206, 206, 206, 0.103);\n      gap: 1.5rem;\n      transition: gap cubic-bezier(0.165, 0.84, 0.44, 1) 0.3s;\n      label {\n        font-size: 1.4rem;\n        font-weight: 600;\n        opacity: 0.7;\n        transition: opacity cubic-bezier(0.165, 0.84, 0.44, 1) 0.2s;\n        position: relative;\n        pointer-events: none;\n      }\n      svg {\n        pointer-events: none;\n        font-size: 2.5rem;\n        opacity: 0.2;\n        transition: opacity cubic-bezier(0.165, 0.84, 0.44, 1) 0.2s;\n      }\n      &:hover,\n      .active {\n        background-color: rgba(38, 75, 46, 0.103);\n        gap: 0.7rem;\n        label {\n          opacity: 1;\n        }\n        svg {\n          opacity: 0.7;\n        }\n      }\n    }\n    .editor-tools {\n      width: 40%;\n      .form-item {\n        .color-input-row {\n          display: flex;\n          gap: 1rem;\n          justify-content: center;\n          align-items: center;\n          button {\n            flex-grow: 1;\n          }\n        }\n        .input-row {\n          display: flex;\n          gap: 0.5rem;\n          width: 100%;\n          input[type='range'] {\n            flex-grow: 1;\n          }\n        }\n        label {\n          color: #777777;\n          font-size: 1.1rem;\n        }\n      }\n      .buttons-group {\n        display: flex;\n        flex-direction: column;\n      }\n    }\n    .editor-wrapper {\n      display: flex;\n      gap: 2.2rem;\n      position: relative;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      .img-outter-wrapper {\n        display: flex;\n        flex-grow: 1;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        width: 400px;\n        height: 400px;\n        max-width: 400px;\n        flex-shrink: 0;\n        background:\n          linear-gradient(45deg, #e6e6e6 25%, transparent 25%), linear-gradient(-45deg, #e6e6e6 25%, transparent 25%),\n          linear-gradient(45deg, transparent 75%, #e6e6e6 75%), linear-gradient(-45deg, transparent 75%, #e6e6e6 75%);\n        background-size: 20px 20px;\n        background-position:\n          0 0,\n          0 10px,\n          10px -10px,\n          -10px 0px;\n        background-color: #f5f5f5;\n        .img-wrapper {\n          position: relative;\n          overflow: hidden;\n          align-items: center;\n          justify-content: center;\n          width: 100%;\n          height: 100%;\n          canvas {\n            display: block;\n            position: relative;\n            width: 400px !important;\n            height: 400px !important;\n          }\n        }\n        .grid-overlay {\n          position: absolute;\n          inset: 0;\n          pointer-events: none;\n          background-image:\n            linear-gradient(to top, rgba(88, 84, 84, 0.464) 1px, transparent 1px), linear-gradient(to left, rgba(88, 84, 84, 0.464) 1px, transparent 1px),\n            linear-gradient(to right, rgba(88, 84, 84, 0.464) 1px, transparent 1px), linear-gradient(to bottom, rgba(88, 84, 84, 0.464) 1px, transparent 1px);\n          background-size: 33.33% 33.33%;\n        }\n      }\n    }\n  }\n}\n\n.dropzone {\n  border: 2px dashed #ccccccab;\n  border-radius: 12px;\n  padding: 40px;\n  text-align: center;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.dropzone.active {\n  border-color: #4f46e5;\n  background: #eef2ff;\n}\n\n.dropzone.reject {\n  border-color: #dc2626;\n  background: #fee2e2;\n}\n\n.user-detail-header,\n.venue-detail-header {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 5px;\n  align-items: center;\n  justify-content: space-between;\n\n  .left-info-wrapper {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n    width: fit-content;\n    .avatar-wrapper {\n      display: flex;\n      position: relative;\n      justify-content: center;\n      align-items: center;\n      height: 70px;\n      width: 70px;\n      min-width: 70px;\n      border-radius: 50%;\n      .change-avatar {\n        cursor: pointer;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        outline: 0;\n        border-radius: 50%;\n        opacity: 0;\n        background-color: #61af91a4;\n        transition: cubic-bezier(0.165, 0.84, 0.44, 1) opacity 0.2s;\n        border: 0.2rem solid #ffffff;\n        box-shadow: 0px 0px 3px 3px rgba(185, 185, 185, 0.384);\n\n        &:hover {\n          opacity: 0.9;\n          backdrop-filter: blur(10px);\n        }\n        svg {\n          font-size: 1.8rem;\n          color: #ffffff;\n        }\n      }\n      .avatar {\n        height: 70px;\n        width: 70px;\n        background-color: transparent;\n        flex-grow: 1;\n        margin-top: 0;\n        position: relative;\n        display: flex;\n      }\n    }\n    h2 {\n      margin: 0;\n      height: fit-content;\n      font-size: 2.3rem;\n      line-height: 3.1rem;\n    }\n  }\n\n  .hidden {\n    visibility: hidden;\n  }\n}\n\n.tab-bar {\n  display: flex;\n  gap: 24px;\n  padding-right: 10px;\n  margin-bottom: 26px;\n\n  .tab {\n    position: relative;\n    background: none;\n    border: none;\n    padding: 8px 0;\n    color: var(--color-gray);\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: color 0.2s ease-in-out;\n\n    &:hover {\n      color: var(--color-primary);\n    }\n\n    &.active {\n      color: var(--color-primary);\n\n      &::after {\n        content: '';\n        position: absolute;\n        left: 0;\n        right: 0;\n        bottom: 2px;\n        height: 2px;\n        background: var(--color-primary);\n      }\n    }\n\n    &.back-tab {\n      color: var(--color-primary);\n\n      &:hover {\n        color: var(--color-primary-dark);\n      }\n    }\n  }\n}\n\n.account-status-filter {\n  position: relative;\n\n  .account-status-filter-trigger {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    border: 1px solid var(--color-border, #d9d9d9);\n    border-radius: 8px;\n    background: var(--color-surface, #fff);\n    color: var(--color-text, #1f1f1f);\n    font-size: 14px;\n    cursor: pointer;\n  }\n\n  .account-status-filter-menu {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    z-index: 20;\n    min-width: 180px;\n    padding: 8px;\n    border: 1px solid var(--color-border, #d9d9d9);\n    border-radius: 8px;\n    background: var(--color-surface, #fff);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\n  }\n\n  .account-status-filter-option {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px;\n    border-radius: 6px;\n    cursor: pointer;\n\n    &:hover {\n      background: var(--color-surface-muted, #f5f5f5);\n    }\n\n    input {\n      margin: 0;\n    }\n  }\n}\n\n.user-detail-header {\n  .form-group {\n    margin-bottom: 0;\n    min-width: 200px;\n  }\n}\n\n.user-detail-content {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  gap: 32px;\n\n  .user-detail-overview {\n    display: flex;\n    gap: 32px;\n    align-items: flex-start;\n    flex: 1 1;\n    flex-wrap: wrap;\n    .user-detail-info {\n      display: flex;\n      flex-grow: 1;\n      flex-direction: row;\n      padding: 26px;\n      column-gap: 28px;\n      row-gap: 15px;\n\n      &.grid {\n        display: grid;\n        column-gap: 0;\n        row-gap: 15px;\n        grid-template-columns: 1fr 1fr;\n      }\n\n      .form-item {\n        margin-bottom: 0;\n        p {\n          max-width: 100%;\n          position: relative;\n        }\n        label {\n          margin: 0;\n        }\n        .property-tag,\n        select {\n          padding: 0.2rem 0.4rem;\n          font-size: 14px;\n        }\n\n        .moderation-icon-button {\n          width: 24px;\n          height: 24px;\n          margin-left: 4px;\n          flex-shrink: 0;\n\n          .icon {\n            font-size: 12px;\n          }\n        }\n      }\n\n      .user-name-editor {\n        .user-name-editor-row {\n          display: flex;\n          gap: 0.5rem;\n          align-items: center;\n\n          input {\n            flex: 1;\n            min-width: 0;\n            height: 45px;\n            border-radius: 8px;\n            border: 1px solid var(--color-light-line);\n            padding: 0 0.75rem;\n            background: var(--color-white);\n            color: inherit;\n          }\n        }\n\n        .user-name-editor-error {\n          margin: 0.35rem 0 0;\n          color: #c0392b;\n          font-size: 0.85rem;\n        }\n      }\n    }\n  }\n}\n\n.user-detail-tab-table {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.user-detail-tab-table-toolbar {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.user-photo-verification-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n\n  &__label {\n    color: var(--color-light-gray);\n  }\n\n  &__badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 10px;\n    border-radius: 999px;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.4;\n\n    &--verified {\n      background: #d9f5df;\n      color: #14532d;\n    }\n\n    &--unverified {\n      background: #f3f4f6;\n      color: var(--color-muted);\n    }\n  }\n}\n\n.breadcrumb-activity-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.breadcrumb-activity-box {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid var(--color-border);\n\n  &--flagged {\n    border-color: #d97706;\n    box-shadow: inset 0 0 0 1px rgba(217, 119, 6, 0.15);\n  }\n\n  h3 {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--color-control);\n  }\n\n  &--breadcrumb {\n    background-color: var(--color-control-background);\n  }\n\n  &--reply {\n    background-color: var(--color-nav-bar-background);\n  }\n}\n\n.breadcrumb-activity-box-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n\n  h3 {\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n.moderation-icon-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.moderation-icon-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  background-color: var(--color-control-background);\n  color: var(--color-control);\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    background-color: var(--color-nav-bar-background);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  &.is-active {\n    border-color: #d97706;\n    background-color: rgba(217, 119, 6, 0.12);\n    color: #b45309;\n  }\n\n  .icon {\n    display: inline-flex;\n    font-size: 14px;\n  }\n}\n\n.breadcrumb-activity-meta {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--color-border);\n}\n\n.breadcrumb-activity-content {\n  white-space: pre-wrap;\n  line-height: 1.5;\n}\n\n.breadcrumb-activity-reactions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  grid-column: 1 / -1;\n}\n\n.breadcrumb-activity-reactions-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-control);\n}\n\n.breadcrumb-reactions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.breadcrumb-reaction-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 999px;\n  border: 1px solid var(--color-border);\n  background-color: var(--color-control-background);\n  font-size: 16px;\n  line-height: 1;\n}\n\n.breadcrumb-reaction-count {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-control);\n}\n\n.breadcrumb-reactions-empty {\n  font-size: 13px;\n  color: var(--color-control);\n  opacity: 0.7;\n}\n\n.breadcrumb-detail-popup {\n  max-width: 560px;\n}\n\n// Reuses .photo-verification-detail-* layout classes, but that block's own image framing\n// only applies under a .photo-verification-modal ancestor, which this modal never has —\n// so the sticker photo rendered unconstrained. Scoped separately here instead.\n.sticker-detail-popup {\n  max-width: 680px;\n\n  .photo-verification-detail-layout {\n    grid-template-columns: 280px 1fr;\n  }\n\n  .photo-verification-detail-photo img {\n    width: 100%;\n    aspect-ratio: auto;\n    max-height: 420px;\n    object-fit: contain;\n    background: var(--color-nav-bar-background);\n    border: 1px solid var(--color-border);\n    border-radius: 8px;\n  }\n\n  @media (max-width: 700px) {\n    .photo-verification-detail-layout {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.breadcrumb-detail-sections {\n  max-height: 60vh;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n.breadcrumb-detail-loading {\n  padding: 16px 0;\n  color: var(--color-control);\n  opacity: 0.8;\n}\n\n.event-comment-edit-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px dashed var(--color-border);\n  background-color: var(--color-nav-bar-background);\n\n  .styled-button {\n    align-self: flex-start;\n    width: auto;\n    padding: 0.6em 1.4em;\n  }\n}\n\n.breadcrumb-replies-group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.breadcrumb-replies-heading {\n  margin: 4px 0 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--color-control);\n}\n\n.venue-detail-content {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n\n  .form-item p {\n    max-width: 100%;\n  }\n}\n\n.page-loading,\n.page-error {\n  background-color: var(--color-disabled-background);\n  border-radius: 8px;\n  padding: 16px 20px;\n  font-size: 15px;\n  color: var(--color-control);\n}\n\n.page-error {\n  background-color: var(--color-error-background);\n  color: var(--color-error);\n}\n\n.venue-detail-overview {\n  display: flex;\n  gap: 32px;\n  align-items: flex-start;\n}\n\n.venue-detail-media {\n  flex: 0 0 25%;\n  max-width: 25%;\n  display: grid;\n\n  gap: 24px;\n}\n\n.venue-detail-socials,\n.venue-detail-info,\n.user-detail-info,\n.venue-detail-counts {\n  border: solid 1px var(--color-light-line);\n  background-color: var(--color-white);\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  padding: 26px 26px 10px 26px;\n}\n\n.venue-detail-info,\n.venue-detail-socials {\n  flex: 0 0 50%;\n  max-width: 50%;\n  display: grid;\n  display: flex;\n  flex-direction: column;\n  min-height: 70px;\n\n  .venue-address-row {\n    display: flex;\n    align-items: flex-end;\n    gap: 0.5rem;\n\n    .form-item {\n      flex: 1;\n      min-width: 0;\n    }\n  }\n\n  .venue-name-editor {\n    .venue-name-editor-row {\n      display: flex;\n      gap: 0.5rem;\n      align-items: center;\n\n      input {\n        flex: 1;\n        min-width: 0;\n        height: 45px;\n        border-radius: 8px;\n        border: 1px solid var(--color-light-line);\n        padding: 0 0.75rem;\n        background: var(--color-white);\n        color: inherit;\n      }\n    }\n\n    .venue-name-editor-error {\n      margin: 0.35rem 0 0;\n      color: #c0392b;\n      font-size: 0.85rem;\n    }\n  }\n}\n\n.venue-detail-counts {\n  flex: 0 0 20%;\n  max-width: 20%;\n  display: grid;\n  display: flex;\n  flex-direction: column;\n  min-height: 70px;\n}\n\n@media (max-width: 1024px) {\n  .venue-detail-info {\n    flex: 0 0 100%;\n    width: 100%;\n    max-width: 100%;\n  }\n}\n@media (max-width: 1024px) {\n  .venue-detail-counts {\n    flex: 0 0 100%;\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n.venue-opening-hours-editor {\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid var(--color-light-line);\n  width: 100%;\n\n  h3 {\n    margin: 0 0 8px;\n    font-size: 16px;\n  }\n\n  &__header {\n    margin-bottom: 12px;\n  }\n\n  &__meta {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    font-size: 13px;\n    color: var(--color-text-secondary, #666);\n  }\n\n  &__effective,\n  &__google-ref {\n    margin-bottom: 12px;\n\n    label {\n      display: block;\n      font-size: 12px;\n      font-weight: 600;\n      margin-bottom: 4px;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n    }\n\n    ul {\n      margin: 0;\n      padding-left: 20px;\n      font-size: 14px;\n    }\n  }\n\n  &__google-ref {\n    opacity: 0.85;\n  }\n\n  &__hint {\n    font-size: 13px;\n    color: var(--color-text-secondary, #666);\n    margin: 0 0 12px;\n    line-height: 1.4;\n  }\n\n  &__table-wrap {\n    overflow-x: auto;\n    margin-bottom: 12px;\n  }\n\n  &__table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 14px;\n\n    th,\n    td {\n      padding: 8px 10px;\n      text-align: left;\n      border-bottom: 1px solid var(--color-light-line);\n    }\n\n    th {\n      font-weight: 600;\n      font-size: 12px;\n      text-transform: uppercase;\n      letter-spacing: 0.03em;\n    }\n\n    input[type='time'] {\n      font: inherit;\n      padding: 4px 6px;\n      border: 1px solid var(--color-light-line);\n      border-radius: 4px;\n    }\n  }\n\n  &__google-cell {\n    white-space: nowrap;\n    color: var(--color-text-secondary, #666);\n    font-size: 13px;\n  }\n\n  &__error {\n    color: var(--color-error, #c0392b);\n    font-size: 13px;\n    margin-bottom: 8px;\n  }\n\n  &__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    align-items: center;\n  }\n}\n\n.venue-detail-photo {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  position: relative;\n  width: 100%;\n  height: 360px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n}\n\n.detail-item {\n  background-color: var(--color-disabled-background);\n  border-radius: 12px;\n  padding: 16px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-height: 70px;\n}\n\n.detail-label {\n  font-size: 12px;\n  color: var(--color-gray);\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.detail-value {\n  font-size: 15px;\n  color: var(--color-control);\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.venue-detail-visits,\n.venue-detail-blasts,\n.venue-detail-specials {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.venue-detail-map-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  min-height: calc(100vh - 250px);\n}\n\n.map-tab-static {\n  width: 100%;\n  height: calc(100vh - 300px);\n  min-height: 400px;\n  border-radius: 12px;\n  overflow: hidden;\n  background-color: var(--color-disabled-background);\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n}\n\n.venue-detail-map-inline {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.inline-location-map {\n  width: 100%;\n  height: 100%;\n}\n\n.map-tab-actions {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.link-out {\n  color: var(--color-primary);\n  font-weight: 600;\n  text-decoration: none;\n\n  &:hover {\n    color: var(--color-primary-dark);\n  }\n}\n\n.link-button {\n  background: none;\n  border: none;\n  color: var(--color-primary);\n  font-weight: 600;\n  cursor: pointer;\n  margin-left: 12px;\n  padding: 0;\n\n  &:hover {\n    color: var(--color-primary-dark);\n    text-decoration: underline;\n  }\n}\n\n.empty-state {\n  padding: 24px;\n  border-radius: 12px;\n  background-color: var(--color-disabled-background);\n  color: var(--color-muted);\n}\n\n.empty-state.error {\n  background-color: var(--color-error-background);\n  color: var(--color-error);\n}\n\n.venue-detail-map img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  mask-clip: content-box;\n}\n\n.venue-detail-map-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-muted);\n  font-size: 64px;\n  background-color: var(--color-disabled-background);\n  border-radius: 12px;\n}\n\n.venue-detail-stats {\n  margin-top: 32px;\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n}\n\n.stat-card {\n  background-color: var(--color-white);\n  border: 1px solid var(--color-light-line);\n  border-radius: 12px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);\n}\n\n.stat-label {\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--color-muted);\n}\n\n.stat-value {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--color-control);\n}\n\n.venue-detail-table {\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.venue-detail-table h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--color-control);\n}\n\n.venue-detail-tabs,\n.venue-detail-content {\n  width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .venue-detail-tabs {\n    flex-wrap: wrap;\n    gap: 16px;\n  }\n\n  .venue-detail-overview {\n    flex-direction: column;\n  }\n\n  .venue-detail-media,\n  .venue-detail-info {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n\n  .venue-detail-media {\n    grid-template-columns: 1fr;\n  }\n}\n\n// Visits header layout\n.visits-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 0;\n\n  h2 {\n    margin: 0;\n  }\n}\n\n// Loading state\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n  font-size: 16px;\n}\n\n// Table wrapper and loading overlay\n.table-wrapper {\n  position: relative;\n\n  &.loading {\n    pointer-events: none;\n  }\n}\n\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10;\n\n  .loading-spinner {\n    background: white;\n    padding: 20px 40px;\n    border-radius: 8px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    color: #666;\n    font-size: 16px;\n  }\n}\n\n.users-table-container {\n  position: relative;\n}\n\n.venues-table-container {\n  position: relative;\n}\n\n.visits-table-container {\n  position: relative;\n}\n\n.map-container {\n  position: relative;\n  top: -30px;\n  left: -30px;\n  width: calc(100% + 60px);\n  height: calc(100vh - 55px);\n  margin-top: 20px;\n}\n\n.map-container-inner {\n  width: 100%;\n  height: 100%;\n}\n\n.moderation-modal-header {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n\n  h2 {\n    margin: 0;\n  }\n}\n\n.moderation-actions-bar {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: 8px;\n  margin: 16px 0;\n\n  .styled-button {\n    flex: 1 1 auto;\n    min-width: 5.5rem;\n    margin: 0;\n  }\n\n  @media (max-width: 520px) {\n    flex-direction: column;\n\n    .styled-button {\n      width: 100%;\n      min-width: 0;\n    }\n  }\n}\n\n/* ===========================================================================\n   Live Activity map (/admin/live-map)\n   Ported from the mobile map: badge markers, filter card, pulses, bottom cards.\n   =========================================================================== */\n\n.live-map {\n  position: relative;\n  // Full-bleed into the .content-wrapper padding (10px 30px) without widening\n  // past 100% — a calc(100%+60px) box overflows and produces a horizontal scroll.\n  margin: -10px -30px;\n  height: calc(100vh - 55px);\n\n  &__canvas {\n    width: 100%;\n    height: 100%;\n  }\n\n  &__status {\n    position: absolute;\n    top: 16px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: rgba(0, 0, 0, 0.7);\n    color: #fff;\n    padding: 6px 14px;\n    border-radius: 16px;\n    font-size: 13px;\n    z-index: 5;\n\n    &--error {\n      background: var(--color-error, #aa0000);\n    }\n  }\n\n  &__filter-toggle {\n    align-self: flex-start;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    border: none;\n    border-radius: 18px;\n    padding: 8px 14px;\n    background: #fff;\n    color: #1a1a1a;\n    font-size: 13px;\n    font-weight: 600;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);\n    cursor: pointer;\n  }\n\n  // Locate / center-on-coordinates control (top-right), mirrors the mobile button.\n  &__locate {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    z-index: 6;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border: 1px solid #8c1414;\n    border-radius: 12px;\n    background: var(--color-error, #aa0000);\n    color: #fff;\n    font-size: 17px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);\n    cursor: pointer;\n\n    &:hover {\n      filter: brightness(1.08);\n    }\n  }\n}\n\n/* Stacked overlay (filter card / toggle + loading indicator), top-left. */\n.map-overlay-top-left {\n  position: absolute;\n  top: 16px;\n  left: 16px;\n  z-index: 6;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.map-loading-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 14px;\n  border-radius: 18px;\n  background: #fff;\n  color: #1a1a1a;\n  font-size: 13px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);\n\n  &__spinner {\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    border: 2px solid rgba(0, 0, 0, 0.15);\n    border-top-color: var(--color-primary, #3a5443);\n    animation: map-spinner-rotate 0.7s linear infinite;\n  }\n}\n\n@keyframes map-spinner-rotate {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* --- Custom badge marker ------------------------------------------------- */\n\n.live-marker {\n  position: relative;\n  width: 52px;\n  height: 52px;\n  // Centering on the venue point is handled by the OverlayView container.\n\n  &__token {\n    position: absolute;\n    inset: 0;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #ffffff;\n    border: 3px solid #ffffff;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2;\n  }\n\n  &__logo {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__initials {\n    font-weight: 900;\n    font-size: 22px;\n    color: #555;\n  }\n\n  &__badge {\n    position: absolute;\n    top: -6px;\n    right: -6px;\n    min-width: 22px;\n    height: 22px;\n    padding: 0 5px;\n    border-radius: 11px;\n    border: 3.5px solid #ffffff;\n    box-sizing: border-box;\n    color: #ffffff;\n    font-size: 12px;\n    font-weight: 800;\n    line-height: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 3;\n\n    &--pill {\n      border-radius: 13px;\n    }\n  }\n\n  &__dots {\n    position: absolute;\n    left: 50%;\n    bottom: -4px;\n    transform: translateX(-50%);\n    display: flex;\n    gap: 3px;\n    padding: 3px 4px;\n    background: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);\n    z-index: 3;\n  }\n\n  &__dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n  }\n\n  &__ripple {\n    position: absolute;\n    inset: 0;\n    z-index: 1;\n    pointer-events: none;\n  }\n\n  &__ring {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    border: 2px solid var(--ripple-color, #aa0100);\n    background: var(--ripple-color, #aa0100);\n    opacity: 0;\n    // easeOutCubic, 3s cycle, 3 staggered waves (delays set inline).\n    animation: live-marker-ripple 3000ms cubic-bezier(0.215, 0.61, 0.355, 1) infinite;\n  }\n}\n\n@keyframes live-marker-ripple {\n  0% {\n    transform: translate(-50%, -50%) scale(1);\n    opacity: 0.5;\n  }\n  100% {\n    transform: translate(-50%, -50%) scale(1.75);\n    opacity: 0;\n  }\n}\n\n/* --- Filter card --------------------------------------------------------- */\n\n.map-filter-card {\n  width: 220px;\n  background: #ffffff;\n  border-radius: 14px;\n  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);\n  padding: 10px 12px;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-bottom: 8px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  &__title {\n    font-weight: 800;\n    font-size: 15px;\n  }\n\n  &__close {\n    border: none;\n    background: transparent;\n    color: #888;\n    cursor: pointer;\n    font-size: 14px;\n    line-height: 1;\n  }\n\n  &__list {\n    list-style: none;\n    margin: 6px 0 0;\n    padding: 0;\n  }\n}\n\n.map-filter-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 4px;\n  border-radius: 8px;\n  cursor: pointer;\n  user-select: none;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.04);\n  }\n\n  &--locked {\n    cursor: default;\n\n    &:hover {\n      background: transparent;\n    }\n  }\n\n  &--dimmed {\n    opacity: 0.45;\n  }\n\n  &__ring {\n    flex: 0 0 auto;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 2px solid;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n  }\n\n  &__check {\n    color: #ffffff;\n    font-size: 10px;\n  }\n\n  &__label {\n    flex: 1 1 auto;\n    font-size: 14px;\n    color: #1a1a1a;\n  }\n\n  &__lock {\n    color: #b0b0b0;\n    font-size: 12px;\n  }\n}\n\n/* --- Bottom \"recent viewers\" cards -------------------------------------- */\n\n.map-bottom-cards {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 16px;\n  z-index: 5;\n  padding: 0 16px;\n  overflow: hidden; // infinite marquee — the track scrolls, not the container\n\n  &__track {\n    display: flex;\n    width: max-content;\n  }\n\n  // Auto-scrolling only when the cards overflow. Duplicated set + translateX(-50%)\n  // loops seamlessly; pause on hover so cards can be clicked.\n  &__track--scrolling {\n    animation-name: map-ticker-scroll;\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n  }\n\n  &:hover .map-bottom-cards__track--scrolling {\n    animation-play-state: paused;\n  }\n}\n\n@keyframes map-ticker-scroll {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(-50%);\n  }\n}\n\n.map-venue-card {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 220px;\n  margin-right: 12px; // uniform spacing so the duplicated track loops seamlessly\n  text-align: left;\n  border: none;\n  border-radius: 14px;\n  padding: 10px 12px;\n  background: #ffffff;\n  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.18);\n  cursor: pointer;\n\n  &--active {\n    outline: 2px solid var(--color-primary, #3a5443);\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  &__name {\n    font-weight: 700;\n    font-size: 14px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__flame {\n    font-size: 12px;\n    color: #666;\n  }\n}\n\n/* Reused map marker token (logo + count badges) inside ticker cards. */\n.venue-token {\n  flex: 0 0 auto;\n  position: relative;\n  display: inline-block;\n  width: 46px;\n  height: 46px;\n\n  .live-marker {\n    // The shared marker token is 52px; scale to ~46px to fit the card avatar.\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) scale(0.88);\n  }\n}\n\n/* --- Venue detail sheet -------------------------------------------------- */\n\n.venue-detail-sheet {\n  position: absolute;\n  right: 16px;\n  bottom: 16px;\n  z-index: 7;\n  width: 320px;\n  max-width: calc(100% - 32px);\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.25);\n  padding: 16px;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  &__logo {\n    flex: 0 0 auto;\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    overflow: hidden;\n    background: #f0f0f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  &__initials {\n    font-weight: 900;\n    color: #777;\n  }\n\n  &__identity {\n    flex: 1 1 auto;\n    min-width: 0;\n  }\n\n  &__name {\n    font-weight: 800;\n    font-size: 16px;\n  }\n\n  &__address {\n    font-size: 12px;\n    color: #888;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__close {\n    border: none;\n    background: transparent;\n    color: #888;\n    cursor: pointer;\n    font-size: 16px;\n  }\n\n  &__stats {\n    list-style: none;\n    margin: 8px 0 0;\n    padding: 0;\n  }\n}\n\n.venue-stat-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n\n  &__badge {\n    flex: 0 0 auto;\n    min-width: 28px;\n    height: 28px;\n    padding: 0 6px;\n    border-radius: 14px;\n    color: #ffffff;\n    font-weight: 800;\n    font-size: 13px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__label {\n    font-size: 14px;\n    font-weight: 600;\n    color: #1a1a1a;\n  }\n\n  &__subtitle {\n    font-size: 12px;\n    color: #888;\n  }\n}\n\n.moderation-flagged .styled-button,\n.styled-button.moderation-flagged {\n  border-color: #c9a227;\n  color: #8a6914;\n}\n\n.moderation-flagged-content {\n  border-left: 3px solid #c9a227;\n  padding-left: 12px;\n  background: #fffbeb;\n}\n\n.moderation-flag-badge {\n  display: inline-block;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #8a6914;\n  margin-left: 0;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #fff3cd;\n  border: 1px solid #c9a227;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n\n  &--reply {\n    color: #7c4a12;\n    background: #f3f4f6;\n    border-color: #c4c9d1;\n  }\n}\n\n.name-and-address-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.venue-closed-badge {\n  display: inline-block;\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #7f1d1d;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.venue-closed-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  border-radius: 6px;\n  background: #fef2f2;\n  border: 1px solid #fca5a5;\n  color: #7f1d1d;\n}\n\n.venue-status-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n\n.breadcrumb-moderation-flags,\n.moderation-modal-header-flags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n}\n\ntr.moderation-flagged-row td {\n  background: #fffbeb;\n}\n\n.intention-prompt-cell {\n  max-width: 320px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.intention-active-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  cursor: pointer;\n  user-select: none;\n\n  input {\n    margin: 0;\n  }\n}\n\n.dev-telephones-page {\n  .roles-actions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.5rem;\n  }\n\n  .dev-otp-card {\n    max-width: 280px;\n    color: var(--color-black);\n    font-family: Inter, Arial, Helvetica, sans-serif;\n\n    span.header {\n      display: block;\n      font-size: 13px;\n      font-weight: 600;\n      margin-bottom: 10px;\n    }\n\n    .dev-otp-reveal {\n      display: block;\n      width: 100%;\n      min-height: 88px;\n      border: solid 1px var(--border-color, #ccc);\n      border-radius: 4px;\n      background: var(--color-white, #fff);\n      padding: 16px 12px;\n      cursor: pointer;\n      position: relative;\n      text-align: center;\n      box-sizing: border-box;\n\n      &:focus-visible {\n        outline: 2px solid var(--color-black);\n        outline-offset: 2px;\n      }\n    }\n\n    .dev-otp-code {\n      display: block;\n      font-size: 32px;\n      font-weight: 600;\n      letter-spacing: 0.3em;\n      filter: blur(10px);\n      user-select: none;\n      transition: filter 0.2s ease;\n    }\n\n    .dev-otp-reveal.is-revealed .dev-otp-code {\n      filter: blur(0);\n      user-select: text;\n    }\n\n    .dev-otp-hint {\n      display: block;\n      margin-top: 8px;\n      min-height: 14px;\n      font-size: 11px;\n      color: var(--color-gray, #666);\n      visibility: visible;\n      opacity: 1;\n      transition: opacity 0.2s ease;\n    }\n\n    .dev-otp-reveal.is-revealed .dev-otp-hint {\n      visibility: hidden;\n      opacity: 0;\n    }\n\n    .dev-otp-expiry {\n      margin: 10px 0 0;\n      font-size: 11px;\n      color: var(--color-gray, #666);\n    }\n  }\n}\n\n.simulation-page {\n  .simulation-status {\n    margin: 0.75rem 0 0;\n    opacity: 0.9;\n  }\n\n  .simulation-presence-panel {\n    margin-top: 1.5rem;\n  }\n\n  .simulation-presence-meta,\n  .simulation-hint {\n    margin: 0.5rem 0 1rem;\n    font-size: 14px;\n    opacity: 0.85;\n  }\n\n  .simulation-spawn-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 1rem;\n    margin-top: 1rem;\n  }\n\n  .simulation-spawn-card {\n    padding: 1rem 1.25rem;\n    border: 1px solid var(--border-color, #ccc);\n    border-radius: 4px;\n\n    h3 {\n      margin: 0 0 0.5rem;\n      font-size: 16px;\n    }\n\n    p {\n      margin: 0 0 1rem;\n      font-size: 13px;\n      line-height: 1.45;\n      opacity: 0.85;\n    }\n\n    .form-group {\n      display: flex;\n      flex-direction: column;\n      gap: 0.35rem;\n      margin-bottom: 0.75rem;\n\n      span {\n        font-size: 12px;\n        font-weight: 600;\n      }\n\n      input,\n      select {\n        padding: 0.45rem 0.55rem;\n        border: 1px solid var(--border-color, #ccc);\n        border-radius: 4px;\n        font: inherit;\n      }\n    }\n  }\n\n  .simulation-field-note {\n    margin: 0;\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 1.4;\n    opacity: 0.75;\n  }\n\n  .simulation-picker {\n    position: relative;\n  }\n\n  .simulation-chips {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.35rem;\n    margin-bottom: 0.35rem;\n  }\n\n  .simulation-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.35rem;\n    padding: 0.25rem 0.5rem;\n    border: 1px solid var(--border-color, #ccc);\n    border-radius: 4px;\n    background: transparent;\n    font: inherit;\n    font-size: 12px;\n    cursor: pointer;\n\n    span {\n      font-weight: 600;\n      opacity: 0.7;\n    }\n  }\n\n  .simulation-picker-dropdown {\n    position: absolute;\n    z-index: 5;\n    left: 0;\n    right: 0;\n    top: calc(100% - 0.25rem);\n    margin: 0;\n    padding: 0.25rem 0;\n    list-style: none;\n    max-height: 220px;\n    overflow: auto;\n    border: 1px solid var(--border-color, #ccc);\n    border-radius: 4px;\n    background: var(--color-white, #fff);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n\n    li button {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 0.15rem;\n      width: 100%;\n      padding: 0.5rem 0.75rem;\n      border: 0;\n      background: transparent;\n      text-align: left;\n      font: inherit;\n      cursor: pointer;\n\n      &:hover {\n        background: rgba(0, 0, 0, 0.04);\n      }\n\n      strong {\n        font-size: 13px;\n      }\n\n      span,\n      em {\n        font-size: 11px;\n        opacity: 0.75;\n        font-style: normal;\n      }\n    }\n  }\n\n  .simulation-picker-empty {\n    margin: 0;\n    padding: 0.5rem 0.75rem;\n    font-size: 12px;\n    opacity: 0.7;\n  }\n\n  .simulation-person-select-actions {\n    display: flex;\n    gap: 0.75rem;\n    margin-bottom: 0.35rem;\n  }\n\n  .simulation-link-btn {\n    border: 0;\n    padding: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    font-size: 12px;\n    text-decoration: underline;\n    cursor: pointer;\n    opacity: 0.85;\n\n    &:disabled {\n      opacity: 0.4;\n      cursor: default;\n      text-decoration: none;\n    }\n  }\n\n  .simulation-person-list {\n    max-height: 220px;\n    overflow: auto;\n    border: 1px solid var(--border-color, #ccc);\n    border-radius: 4px;\n  }\n\n  .simulation-person-option {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    align-items: center;\n    gap: 0.5rem;\n    margin: 0;\n    padding: 0.45rem 0.65rem;\n    border-bottom: 1px solid var(--border-color, #eee);\n    font-size: 13px;\n    cursor: pointer;\n\n    &:last-child {\n      border-bottom: 0;\n    }\n\n    &.is-selected {\n      background: rgba(0, 0, 0, 0.03);\n    }\n\n    input {\n      margin: 0;\n    }\n\n    &__name {\n      font-weight: 600;\n    }\n\n    &__meta {\n      font-size: 11px;\n      opacity: 0.7;\n    }\n  }\n\n  .users-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 0.75rem;\n  }\n\n  .roles-actions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.5rem;\n  }\n}\n\n.roles-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  .roles-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0;\n\n    h2 {\n      margin: 0;\n    }\n  }\n\n  .roles-page-intro {\n    margin: 0;\n    opacity: 0.85;\n  }\n\n  .roles-actions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 0.5rem;\n  }\n}\n\n.notification-presets-page {\n  .notification-presets-overview {\n    margin-bottom: 1rem;\n    padding: 1rem 1.25rem;\n\n    &__title {\n      margin: 0 0 0.5rem;\n      font-size: 18px;\n      font-weight: 600;\n      color: var(--color-black);\n    }\n\n    &__intro {\n      margin: 0 0 1rem;\n      font-size: 14px;\n      line-height: 1.5;\n      opacity: 0.85;\n    }\n\n    &__list {\n      margin: 0;\n      padding: 0;\n      list-style: none;\n      display: flex;\n      flex-direction: column;\n      gap: 0.85rem;\n    }\n\n    &__item {\n      font-size: 14px;\n      line-height: 1.5;\n    }\n\n    &__link {\n      font-weight: 600;\n      color: var(--color-primary);\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    &__description {\n      color: var(--color-black);\n      opacity: 0.85;\n    }\n\n    &__meta {\n      display: block;\n      margin-top: 0.2rem;\n      font-size: 12px;\n      opacity: 0.65;\n    }\n  }\n\n  .notification-presets-toolbar {\n    position: sticky;\n    top: 0;\n    z-index: 5;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n    margin: 0.75rem 0 1rem;\n    padding: 0.75rem 0;\n    background: var(--color-background);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  .notification-presets-toolbar__secondary {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n  }\n\n  .notification-presets-category {\n    margin-top: 1.5rem;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 10px;\n    background: rgba(255, 255, 255, 0.45);\n    overflow: hidden;\n    scroll-margin-top: 4.5rem;\n\n    &:first-of-type {\n      margin-top: 1rem;\n    }\n  }\n\n  .notification-presets-collapse-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    width: 100%;\n    padding: 1rem 1.1rem;\n    border: 0;\n    background: transparent;\n    text-align: left;\n    cursor: pointer;\n    color: inherit;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.03);\n    }\n\n    &--category {\n      background: var(--color-primary-translucent);\n      color: var(--color-primary);\n      border-bottom: 1px solid rgba(40, 79, 67, 0.12);\n\n      &:hover {\n        background: rgba(40, 79, 67, 0.18);\n      }\n\n      .notification-presets-collapse-count {\n        color: var(--color-primary);\n        opacity: 0.75;\n      }\n    }\n\n    &--trigger {\n      padding: 0.85rem 1rem;\n      border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    }\n  }\n\n  .notification-presets-collapse-icon {\n    flex-shrink: 0;\n    transition: transform 0.2s ease;\n\n    &.is-collapsed {\n      transform: rotate(-90deg);\n    }\n  }\n\n  .notification-presets-collapse-title {\n    flex: 1;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 1.3;\n  }\n\n  .notification-presets-collapse-header--trigger .notification-presets-collapse-title {\n    font-size: 16px;\n    font-weight: 600;\n  }\n\n  .notification-presets-collapse-count {\n    flex-shrink: 0;\n    font-size: 13px;\n    opacity: 0.65;\n  }\n\n  .notification-presets-trigger-group {\n    margin: 0;\n    border: 0;\n    border-top: 1px solid rgba(0, 0, 0, 0.08);\n    border-radius: 0;\n    background: transparent;\n\n    .property-bar-field-group__description {\n      margin: 0 1rem 0.75rem;\n    }\n  }\n\n  .notification-presets-empty {\n    margin: 0 1rem 1rem;\n    font-style: italic;\n  }\n\n  .roles-table-container {\n    margin: 0 1rem 1rem;\n  }\n}\n\n.roles-permissions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 10px 16px;\n  margin-top: 8px;\n}\n\n.roles-permission-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  cursor: pointer;\n\n  input {\n    margin: 0;\n  }\n}\n\n.notification-recipient-picker {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.notification-recipient-search,\n.notification-recipient-selected {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.notification-recipient-search-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n\n.notification-recipient-search-table {\n  width: 100%;\n  border-collapse: collapse;\n\n  th,\n  td {\n    padding: 0.75rem;\n    text-align: left;\n    border-bottom: 1px solid #e5e5e5;\n    vertical-align: middle;\n  }\n\n  tr.is-selected {\n    opacity: 0.7;\n  }\n}\n\n.notification-recipient-checkbox-col {\n  width: 44px;\n}\n\n.notification-recipient-name {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.role-modal,\n.account-access-modal {\n  .modal-content-wrapper {\n    max-width: 720px;\n  }\n}\n\n.system-status-page {\n  .system-status-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 20px;\n\n    h2 {\n      margin: 0 0 6px;\n    }\n  }\n\n  .system-status-subtitle {\n    margin: 0;\n    color: var(--color-light-gray);\n    font-size: 14px;\n  }\n\n  .system-status-error {\n    padding: 16px;\n    border-radius: 8px;\n    background: var(--color-dark-gray);\n  }\n\n  .system-status-error {\n    margin-bottom: 16px;\n    color: #ffb4b4;\n  }\n\n  .system-status-overview-card {\n    border: solid 1px var(--color-light-line);\n    background-color: var(--color-white);\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n    border-radius: 12px;\n    padding: 18px 20px;\n    margin-bottom: 16px;\n    color: var(--color-control);\n\n    &__top {\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      gap: 12px;\n      flex-wrap: wrap;\n      margin-bottom: 8px;\n    }\n\n    &__heading {\n      display: flex;\n      align-items: baseline;\n      gap: 10px;\n      flex-wrap: wrap;\n    }\n\n    &__label {\n      font-weight: 700;\n      text-transform: uppercase;\n      letter-spacing: 0.04em;\n      color: var(--color-muted);\n      font-size: 12px;\n      line-height: 1.2;\n    }\n\n    &__meta {\n      color: var(--color-muted);\n      font-size: 13px;\n      white-space: nowrap;\n    }\n\n    &__description {\n      font-size: 14px;\n    }\n\n    &__status-text {\n      font-weight: 700;\n      line-height: 1.2;\n    }\n\n    &__hint {\n      color: var(--color-muted);\n    }\n\n    &--healthy .system-status-overview-card__status-text {\n      color: var(--color-green);\n    }\n\n    &--degraded .system-status-overview-card__status-text {\n      color: #856404;\n    }\n\n    &--unhealthy .system-status-overview-card__status-text {\n      color: var(--color-error);\n    }\n\n    &--not_configured .system-status-overview-card__status-text {\n      color: var(--color-muted);\n    }\n  }\n\n  th.system-health-priority-col,\n  td.system-health-priority-col {\n    display: none;\n  }\n\n  .tile-migration-progress {\n    height: 10px;\n    overflow: hidden;\n    margin-bottom: 8px;\n    border-radius: 999px;\n    background: var(--color-light-line);\n\n    &__bar {\n      height: 100%;\n      border-radius: inherit;\n      background: var(--color-green);\n      transition: width 200ms ease;\n    }\n\n    &__label {\n      display: flex;\n      justify-content: space-between;\n      gap: 12px;\n      margin-bottom: 16px;\n      color: var(--color-muted);\n      font-size: 13px;\n\n      strong {\n        color: var(--color-control);\n      }\n    }\n  }\n\n  .osm-queue-status {\n    margin-top: 28px;\n\n    &__header {\n      margin-bottom: 14px;\n\n      h3 {\n        margin: 0 0 6px;\n      }\n\n      p {\n        margin: 0;\n        color: var(--color-light-gray);\n        font-size: 14px;\n      }\n    }\n\n    &__stats {\n      display: grid;\n      grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n      gap: 12px;\n      margin-bottom: 16px;\n\n      > div {\n        border: solid 1px var(--color-light-line);\n        border-radius: 10px;\n        background: var(--color-white);\n        padding: 12px 14px;\n        display: flex;\n        flex-direction: column;\n        gap: 6px;\n\n        span {\n          color: var(--color-muted);\n          font-size: 12px;\n          text-transform: uppercase;\n          letter-spacing: 0.03em;\n        }\n\n        strong {\n          font-size: 15px;\n          color: var(--color-control);\n          font-weight: 600;\n        }\n      }\n    }\n  }\n}\n\n.photo-verification-page {\n  .photo-verification-header {\n    margin-bottom: 20px;\n\n    h2 {\n      margin: 0 0 6px;\n    }\n  }\n\n  .photo-verification-subtitle {\n    margin: 0;\n    color: var(--color-light-gray);\n    font-size: 14px;\n  }\n\n  .photo-verification-error {\n    margin-bottom: 16px;\n    padding: 12px 16px;\n    border-radius: 8px;\n    background: #fff1f1;\n    color: #9b1c1c;\n  }\n}\n\n.photo-verification-modal {\n  .photo-verification-detail-layout {\n    display: grid;\n    grid-template-columns: 180px 1fr;\n    gap: 20px;\n    margin-top: 16px;\n  }\n\n  .photo-verification-detail-photo {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n\n    img {\n      width: 100%;\n      border-radius: 8px;\n      object-fit: cover;\n      aspect-ratio: 1;\n    }\n  }\n\n  .photo-verification-detail-photo-avatar {\n    width: 100%;\n    aspect-ratio: 1;\n\n    .avatar {\n      width: 100%;\n      height: 100%;\n      margin-top: 0;\n\n      .initials,\n      .image {\n        border-radius: 8px;\n      }\n    }\n  }\n\n  .photo-verification-detail-photo-caption {\n    margin: 0;\n    font-size: 13px;\n    line-height: 1.4;\n    color: var(--color-light-gray);\n    text-align: center;\n  }\n\n  .photo-verification-detail-stats {\n    dl {\n      margin: 0;\n      display: grid;\n      gap: 10px;\n    }\n\n    div {\n      display: grid;\n      grid-template-columns: 160px 1fr;\n      gap: 8px;\n    }\n\n    dt {\n      margin: 0;\n      color: var(--color-light-gray);\n      font-size: 13px;\n    }\n\n    dd {\n      margin: 0;\n      font-size: 14px;\n    }\n  }\n\n  .photo-verification-error {\n    margin-top: 16px;\n    padding: 12px 16px;\n    border-radius: 8px;\n    background: #fff1f1;\n    color: #9b1c1c;\n  }\n\n  .photo-verification-user-profile-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    margin-right: auto;\n\n    .icon {\n      font-size: 13px;\n      line-height: 1;\n    }\n  }\n\n  @media (max-width: 700px) {\n    .photo-verification-detail-layout {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.venue-suggestion-modal {\n  width: min(640px, 92vw);\n\n  .venue-suggestion-detail-layout {\n    display: grid;\n    gap: 16px;\n    margin-top: 16px;\n  }\n\n  .venue-suggestion-detail-map-fallback {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 120px;\n    border-radius: 8px;\n    background: var(--color-background-light);\n    border: 1px solid var(--color-border);\n    color: var(--color-light-gray);\n    font-size: 13px;\n  }\n\n  .venue-suggestion-detail-stats {\n    dl {\n      margin: 0;\n      display: grid;\n      gap: 10px;\n    }\n\n    div {\n      display: grid;\n      grid-template-columns: 140px 1fr;\n      gap: 8px;\n    }\n\n    dt {\n      margin: 0;\n      color: var(--color-light-gray);\n      font-size: 13px;\n    }\n\n    dd {\n      margin: 0;\n      font-size: 14px;\n    }\n  }\n\n  .venue-suggestion-feedback-link {\n    margin-right: auto;\n  }\n}\n\n.refund-request-modal {\n  width: min(680px, 92vw);\n\n  .refund-request-header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    h3 {\n      margin: 0;\n    }\n  }\n\n  .refund-request-section {\n    margin-top: 20px;\n\n    h4 {\n      margin: 0 0 10px;\n      font-size: 14px;\n    }\n\n    dl {\n      margin: 0;\n      display: grid;\n      gap: 10px;\n    }\n\n    dl > div {\n      display: grid;\n      grid-template-columns: 140px 1fr;\n      gap: 8px;\n    }\n\n    dt {\n      margin: 0;\n      color: var(--color-light-gray);\n      font-size: 13px;\n    }\n\n    dd {\n      margin: 0;\n      font-size: 14px;\n    }\n  }\n\n  .refund-request-reason {\n    white-space: pre-wrap;\n  }\n\n  .refund-request-hint {\n    margin: 0 0 8px;\n    font-size: 13px;\n    color: var(--color-light-gray);\n  }\n\n  .refund-request-failure {\n    color: var(--color-error);\n  }\n\n  .refund-request-action-error {\n    margin-top: 16px;\n  }\n\n  .refund-request-feedback-link {\n    margin-right: auto;\n  }\n}\n\n.partnered-hotspot-modal {\n  &__selected {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__label {\n    font-size: 15px;\n    font-weight: 600;\n  }\n\n  &__muted {\n    opacity: 0.7;\n    font-size: 12px;\n  }\n\n  &__results {\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n    max-height: 220px;\n    overflow: auto;\n  }\n\n  &__result {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n    padding: 0.4rem 0.6rem;\n    border: 1px solid var(--color-light-line);\n    border-radius: 10px;\n    background: transparent;\n    color: inherit;\n    text-align: left;\n    cursor: pointer;\n\n    &.selected {\n      border-color: rgba(90, 138, 124, 0.8);\n    }\n  }\n\n  &__result-name {\n    font-weight: 600;\n  }\n}\n\n.event-journey-modal {\n  width: min(680px, 92vw);\n\n  h3 {\n    margin: 0;\n  }\n\n  &__link {\n    margin-right: auto;\n    text-decoration: none;\n  }\n}\n\n.event-journey-section {\n  margin-top: 20px;\n\n  h4 {\n    margin: 0 0 10px;\n    font-size: 14px;\n  }\n\n  dl {\n    margin: 0;\n    display: grid;\n    gap: 10px;\n  }\n\n  dl > div {\n    display: grid;\n    grid-template-columns: 140px 1fr;\n    gap: 8px;\n  }\n\n  dt {\n    margin: 0;\n    color: var(--color-light-gray);\n    font-size: 13px;\n  }\n\n  dd {\n    margin: 0;\n    font-size: 14px;\n  }\n}\n\n.event-journey-empty {\n  color: var(--color-light-gray);\n  font-size: 13px;\n}\n\n.event-journey-timeline {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 6px;\n\n  li {\n    display: grid;\n    grid-template-columns: 170px 1fr auto;\n    gap: 12px;\n    align-items: baseline;\n    padding: 6px 10px;\n    border-left: 2px solid var(--color-light-gray);\n    font-size: 13px;\n\n    &.is-conversion {\n      border-left-color: var(--color-primary);\n      font-weight: 600;\n    }\n  }\n\n  &__time,\n  &__source {\n    color: var(--color-light-gray);\n  }\n\n  @media (max-width: 640px) {\n    li {\n      grid-template-columns: 1fr;\n      gap: 2px;\n    }\n  }\n}\n\n.event-journey-page {\n  &__venue {\n    font-weight: 400;\n    color: var(--color-light-gray);\n  }\n\n  &__heading {\n    margin: 24px 0 12px;\n    font-size: 16px;\n  }\n}\n\n.event-journey-tiles {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.event-journey-tile {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 14px 16px;\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n\n  &__label {\n    font-size: 13px;\n    color: var(--color-light-gray);\n  }\n\n  &__value {\n    font-size: 24px;\n    font-weight: 600;\n    font-variant-numeric: tabular-nums;\n  }\n\n  &__sub {\n    font-size: 12px;\n    color: var(--color-light-gray);\n  }\n}\n\n.event-journey-users-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n\n  .tab-bar {\n    display: flex;\n    gap: 24px;\n  }\n}\n\n.event-journey-users {\n  display: grid;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.event-journey-user {\n  padding: 12px 16px;\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n\n  &__header {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 6px 16px;\n    margin-bottom: 10px;\n  }\n\n  &__name {\n    font-weight: 600;\n  }\n\n  &__meta {\n    font-size: 13px;\n    color: var(--color-light-gray);\n  }\n}\n\n.event-name-cell {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.event-ticketed-badge {\n  display: inline-block;\n  font-size: 0.65rem;\n  font-weight: 600;\n  line-height: 1.4;\n  color: #14532d;\n  padding: 1px 6px;\n  border-radius: 4px;\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  white-space: nowrap;\n}\n\n.event-journey-sources {\n  width: 100%;\n  margin-top: 16px;\n  border-collapse: collapse;\n  font-size: 13px;\n\n  th,\n  td {\n    padding: 8px 10px;\n    text-align: right;\n    border-bottom: 1px solid var(--color-light-line);\n    font-variant-numeric: tabular-nums;\n  }\n\n  th:first-child,\n  td:first-child {\n    text-align: left;\n  }\n\n  th {\n    font-weight: 600;\n    color: var(--color-light-gray);\n  }\n}\n\n.event-detail-modal {\n  width: min(760px, 94vw);\n\n  &__header {\n    display: flex;\n    gap: 16px;\n    align-items: flex-start;\n  }\n\n  &__flyer {\n    width: 96px;\n    height: 128px;\n    flex-shrink: 0;\n    border-radius: 8px;\n    background-size: cover;\n    background-position: center;\n    background-color: var(--color-light-line);\n  }\n\n  &__title {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n\n    h3 {\n      margin: 0;\n    }\n  }\n\n  &__subtitle {\n    margin: 4px 0 0;\n    font-size: 13px;\n    color: var(--color-light-gray);\n  }\n\n  &__content {\n    white-space: pre-wrap;\n  }\n\n  &__link {\n    margin-right: auto;\n    text-decoration: none;\n  }\n}\n\n// Feature Flags -> Map filters (new-map sidebar). Top-level: the edit modal renders in a portal.\n.feature-flag-unsaved {\n  margin-left: 10px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: #fff3d6;\n  color: #8a6416;\n  font-size: 11px;\n  font-weight: 600;\n  vertical-align: middle;\n}\n\n.map-action-icon {\n  display: block;\n  flex-shrink: 0;\n  // Every opaque pixel takes one color, like the app's srcIn color filter.\n  &--muted {\n    filter: brightness(0) invert(0.773); // #C5C5C5, the app's brandTextMuted\n  }\n  &--white {\n    filter: brightness(0) invert(1);\n  }\n}\n\n.map-action-tile {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: #1c1c1c;\n\n  &--lg {\n    width: 56px;\n    height: 56px;\n  }\n\n  &.is-disabled {\n    opacity: 0.35;\n  }\n}\n\n.map-action-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 14px;\n  border-radius: 999px;\n  background: #1c1c1c;\n  color: #f2f2f2;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: nowrap;\n\n  &--icon {\n    background: #2b2b2b;\n    color: #fff;\n  }\n\n  &__dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    flex-shrink: 0;\n  }\n}\n\n.map-action-marker-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 24px;\n  height: 20px;\n  padding: 0 6px;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.map-action-state--active {\n  --state-color: #11aa11;\n}\n.map-action-state--disabled {\n  --state-color: #c88a00;\n}\n.map-action-state--hidden {\n  --state-color: #888888;\n}\n\n.map-actions-editor {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 220px;\n  gap: 20px;\n  align-items: start;\n  margin-top: 8px;\n\n  @media (max-width: 900px) {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.map-action-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.map-action-row {\n  display: grid;\n  grid-template-columns: auto auto minmax(0, 1fr) auto auto auto;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border);\n  border-left: 4px solid var(--state-color, var(--color-border));\n  border-radius: 8px;\n  background: var(--color-background);\n\n  &--active {\n    --state-color: #11aa11;\n  }\n  &--disabled {\n    --state-color: #c88a00;\n  }\n  &--hidden {\n    --state-color: #888888;\n\n    .map-action-tile,\n    .map-action-row__main,\n    .map-action-row__pill {\n      opacity: 0.45;\n    }\n  }\n\n  &--overlay {\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  }\n\n  @media (max-width: 700px) {\n    grid-template-columns: auto auto minmax(0, 1fr);\n\n    .map-action-row__pill {\n      display: none;\n    }\n  }\n\n  &__main {\n    min-width: 0;\n  }\n\n  &__title {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n    font-weight: 600;\n    font-size: 14px;\n\n    code {\n      font-weight: 400;\n      font-size: 12px;\n      opacity: 0.6;\n    }\n  }\n\n  &__tag {\n    padding: 1px 6px;\n    border-radius: 4px;\n    background: var(--color-highlight);\n    font-size: 11px;\n    font-weight: 500;\n  }\n\n  &__description {\n    margin-top: 2px;\n    font-size: 12px;\n    opacity: 0.7;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__edit {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 10px;\n    border: 1px solid var(--color-border);\n    border-radius: 6px;\n    background: transparent;\n    color: inherit;\n    font-size: 13px;\n    cursor: pointer;\n\n    &:hover:not(:disabled) {\n      background: var(--color-highlight);\n    }\n  }\n}\n\n.map-action-state-select {\n  border-color: var(--state-color) !important;\n  color: var(--state-color);\n  font-weight: 600;\n  background: transparent;\n}\n\n.map-actions-error {\n  margin-top: 8px;\n}\n\n.map-actions-phone {\n  position: sticky;\n  top: 16px;\n\n  &__label {\n    margin-bottom: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    opacity: 0.7;\n  }\n\n  &__screen {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 16px;\n    min-height: 420px;\n    padding: 16px;\n    border: 6px solid #1c1c1c;\n    border-radius: 28px;\n    background:\n      linear-gradient(135deg, rgba(255, 255, 255, 0.5) 25%, transparent 25%) 0 0 / 28px 28px,\n      #e6ece7;\n  }\n\n  &__sidebar {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    width: 64px;\n    padding: 12px;\n    border-radius: 55px;\n    background: #1c1c1c;\n    box-shadow: 0 8px 10px -8px rgba(0, 0, 0, 0.3);\n  }\n\n  &__action {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n    border: none;\n    border-radius: 29px;\n    background: transparent;\n    cursor: pointer;\n\n    &.is-selected {\n      background: #3a3a3a;\n    }\n\n    &.is-disabled {\n      opacity: 0.35;\n      cursor: not-allowed;\n    }\n  }\n\n  &__empty {\n    color: #c5c5c5;\n    font-size: 10px;\n    text-align: center;\n  }\n\n  &__pill-slot {\n    align-self: center;\n    min-height: 32px;\n    display: flex;\n    align-items: center;\n  }\n\n  &__hint {\n    font-size: 11px;\n    color: #555;\n    text-align: center;\n  }\n}\n\n.map-action-modal {\n  width: 100%;\n  max-width: 600px;\n  max-height: 92vh;\n  overflow-y: auto;\n\n  .modal-content-wrapper {\n    overflow: visible;\n  }\n\n  .styled-button.cancel {\n    background: transparent;\n    color: inherit;\n    box-shadow: none;\n    border: 1px solid var(--color-border);\n\n    &:hover {\n      background: var(--color-highlight);\n    }\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n\n    code {\n      font-size: 12px;\n      opacity: 0.6;\n    }\n  }\n\n  &__description {\n    font-size: 13px;\n    opacity: 0.8;\n    line-height: 1.45;\n  }\n\n  &__body {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n  }\n\n  &__section {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  &__section-title {\n    font-size: 13px;\n    font-weight: 600;\n  }\n\n  &__grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px 16px;\n\n    @media (max-width: 560px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n\n    &--spaced {\n      margin-top: 8px;\n    }\n  }\n\n  &__icon-row {\n    display: flex;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  &__icon-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n\n  &__buttons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  &__color-row {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 8px;\n\n    .map-filter-hex {\n      margin-left: 0;\n      font-family: monospace;\n    }\n  }\n\n  &__swatches {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-left: 4px;\n  }\n\n  &__preview {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 10px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    background: #e6ece7;\n\n    .feature-flag-subtitle {\n      color: #333;\n    }\n  }\n\n  &__error {\n    color: var(--color-error);\n    font-size: 12px;\n  }\n\n  &__reset {\n    margin-right: auto !important;\n  }\n}\n\n.map-action-swatch {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  box-shadow: 0 0 0 1px var(--color-border);\n  cursor: pointer;\n\n  &.is-selected {\n    border-color: var(--color-background);\n    box-shadow: 0 0 0 2px var(--color-super-black);\n  }\n}\n\n.map-action-state-segmented {\n  display: inline-flex;\n  align-self: flex-start;\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  overflow: hidden;\n\n  &__option {\n    padding: 7px 16px;\n    border: none;\n    border-right: 1px solid var(--color-border);\n    background: transparent;\n    color: inherit;\n    font-size: 13px;\n    cursor: pointer;\n\n    &:last-child {\n      border-right: none;\n    }\n\n    &.is-selected {\n      background: var(--state-color);\n      color: #fff;\n      font-weight: 600;\n    }\n  }\n}\n\n.map-action-modal__icon-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.map-action-icon-search {\n  max-width: 200px;\n  font-weight: 400;\n}\n\n.map-action-icon-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));\n  gap: 6px;\n  max-height: 228px;\n  overflow-y: auto;\n  padding: 2px;\n}\n\n.map-action-icon-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 4px 6px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n\n  &:hover {\n    background: var(--color-highlight);\n  }\n\n  &.is-selected {\n    border-color: var(--color-primary);\n    background: var(--color-primary-translucent);\n  }\n\n  &--static {\n    cursor: default;\n    flex-shrink: 0;\n  }\n\n  &__label {\n    font-size: 11px;\n    line-height: 1.2;\n    text-align: center;\n  }\n}\n\n.map-ui-status-tag {\n  margin-left: 10px;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: var(--color-highlight);\n  font-size: 11px;\n  font-weight: 600;\n  vertical-align: middle;\n  opacity: 0.85;\n\n  &.is-live {\n    background: #dcf5dc;\n    color: #1f7a1f;\n    opacity: 1;\n  }\n}\n\n// Row checkboxes for bulk actions (Table `onSelectionChange`).\n.table th.select-header,\n.table td.select-cell {\n  width: 36px;\n  text-align: center;\n\n  input[type='checkbox'] {\n    cursor: pointer;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n// Admin Stickers page: Moments / Notes / Reported tabs, bulk actions, reports queue.\n.stickers-admin {\n  .stickers-admin-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 12px;\n    flex-wrap: wrap;\n  }\n\n  .stickers-admin-tabs {\n    display: flex;\n    gap: 4px;\n    padding: 4px;\n    border-radius: 12px;\n    background: rgba(0, 0, 0, 0.06);\n  }\n\n  .stickers-admin-tab {\n    border: none;\n    background: transparent;\n    padding: 6px 16px;\n    border-radius: 8px;\n    cursor: pointer;\n    font-weight: 500;\n\n    &.active {\n      background: #fff;\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);\n    }\n  }\n\n  // Open reports waiting for review.\n  .stickers-admin-tab-count {\n    display: inline-block;\n    min-width: 18px;\n    margin-left: 6px;\n    padding: 0 6px;\n    border-radius: 9px;\n    background: #c92f2f;\n    color: #fff;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 18px;\n    text-align: center;\n  }\n\n  .stickers-admin-bulk {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    span {\n      margin-right: 4px;\n      opacity: 0.7;\n    }\n  }\n\n  .stickers-admin-reports {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    max-width: 1100px;\n  }\n\n  .stickers-admin-report {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    padding: 12px 14px;\n    border-radius: 12px;\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    background: #fff;\n    transition: box-shadow 0.15s ease;\n\n    &:hover {\n      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);\n    }\n\n    &.resolved {\n      opacity: 0.55;\n      background: rgba(0, 0, 0, 0.02);\n    }\n\n    .thumbnail,\n    .stickers-admin-report-kind {\n      flex-shrink: 0;\n      width: 52px;\n      height: 52px;\n      border-radius: 10px;\n      background-size: cover;\n      background-position: center;\n    }\n\n    .stickers-admin-report-kind {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 2px;\n      background: rgba(0, 0, 0, 0.05);\n      color: rgba(0, 0, 0, 0.45);\n      font-size: 18px;\n\n      span {\n        font-size: 9px;\n        font-weight: 600;\n        text-transform: uppercase;\n        letter-spacing: 0.04em;\n      }\n    }\n\n    // Narrow screens: buttons drop under the text instead of squeezing it.\n    @media (max-width: 760px) {\n      flex-wrap: wrap;\n\n      .stickers-admin-report-actions {\n        width: 100%;\n        padding-left: 66px;\n      }\n    }\n  }\n\n  .stickers-admin-report-body {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .stickers-admin-report-text {\n    font-size: 14px;\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    .muted {\n      opacity: 0.55;\n      font-style: italic;\n    }\n  }\n\n  .stickers-admin-report-type {\n    display: inline-block;\n    margin-right: 8px;\n    padding: 1px 7px;\n    border-radius: 6px;\n    background: rgba(0, 0, 0, 0.06);\n    font-size: 11px;\n    font-weight: 600;\n    vertical-align: 1px;\n  }\n\n  .stickers-admin-report-meta {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 6px 14px;\n    font-size: 12px;\n    color: rgba(0, 0, 0, 0.6);\n\n    .icon {\n      margin-right: 3px;\n      opacity: 0.7;\n    }\n  }\n\n  .stickers-admin-report-reason {\n    padding: 2px 8px;\n    border-radius: 999px;\n    background: rgba(201, 47, 47, 0.1);\n    color: #a82626;\n    font-weight: 500;\n\n    .icon {\n      opacity: 1;\n    }\n  }\n\n  .stickers-admin-report-status {\n    padding: 3px 10px;\n    border-radius: 999px;\n    background: rgba(0, 0, 0, 0.06);\n    font-size: 12px;\n    color: rgba(0, 0, 0, 0.6);\n  }\n\n  .stickers-admin-report-actions {\n    display: flex;\n    gap: 6px;\n    flex-shrink: 0;\n\n    .report-action {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      height: 32px;\n      padding: 0 12px;\n      border: 1px solid rgba(0, 0, 0, 0.12);\n      border-radius: 8px;\n      background: #fff;\n      color: #1c1c1c;\n      font-size: 13px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: background 0.15s ease, border-color 0.15s ease;\n\n      &:hover:not(:disabled) {\n        background: rgba(0, 0, 0, 0.04);\n      }\n\n      &.keep:hover:not(:disabled) {\n        border-color: #2e7d4f;\n        color: #2e7d4f;\n        background: rgba(46, 125, 79, 0.06);\n      }\n\n      &.remove {\n        color: #c92f2f;\n        border-color: rgba(201, 47, 47, 0.35);\n\n        &:hover:not(:disabled) {\n          background: rgba(201, 47, 47, 0.08);\n          border-color: #c92f2f;\n        }\n      }\n\n      &:disabled {\n        opacity: 0.5;\n        cursor: default;\n      }\n    }\n  }\n}\n\n.moderation-flag-badge.pinned {\n  background: #43f099;\n  color: #1c1c1c;\n}\n\n.stickers-admin-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-width: 560px;\n\n  .stickers-admin-setting {\n    display: grid;\n    grid-template-columns: 1fr 120px;\n    gap: 4px 16px;\n    align-items: center;\n\n    input {\n      padding: 6px 10px;\n      border-radius: 8px;\n      border: 1px solid rgba(0, 0, 0, 0.15);\n      font-size: 14px;\n    }\n  }\n\n  .stickers-admin-setting-label {\n    font-weight: 600;\n  }\n\n  .stickers-admin-setting input[type='checkbox'] {\n    justify-self: start;\n    width: 18px;\n    height: 18px;\n    padding: 0;\n  }\n\n  .stickers-admin-setting-hint {\n    grid-column: 1 / -1;\n    font-size: 12px;\n    opacity: 0.7;\n  }\n\n  .stickers-admin-setting-message {\n    font-size: 13px;\n  }\n\n  .stickers-admin-setting-actions {\n    display: flex;\n    gap: 8px;\n  }\n}\n\n// Events > Eventbrite tab\n.eventbrite-events-tab {\n  padding: 4px 0 24px;\n}\n\n.eventbrite-page__title,\n.eventbrite-import-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  img {\n    width: 36px;\n    height: 36px;\n  }\n}\n\n.eventbrite-import-title {\n  gap: 8px;\n\n  img {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n// Light, rounded buttons for the Eventbrite list (the uppercase styled-button is too heavy in a table).\n.eb-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 32px;\n  padding: 0 14px;\n  border: 1px solid rgba(0, 0, 0, 0.18);\n  border-radius: 8px;\n  background: var(--color-white);\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &:hover:not(:disabled) {\n    background: rgba(0, 0, 0, 0.04);\n    border-color: rgba(0, 0, 0, 0.3);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: default;\n  }\n\n  &--primary {\n    border-color: var(--color-primary);\n    background: var(--color-primary);\n    color: var(--color-white);\n\n    &:hover:not(:disabled) {\n      background: var(--color-primary);\n      border-color: var(--color-primary);\n      filter: brightness(1.12);\n    }\n  }\n\n  &--danger {\n    border-color: rgba(192, 57, 43, 0.35);\n    color: #c0392b;\n\n    &:hover:not(:disabled) {\n      background: rgba(192, 57, 43, 0.06);\n      border-color: #c0392b;\n    }\n  }\n}\n\n.eventbrite-events-table__no-venue {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n\n  .eventbrite-events-tab__error {\n    margin-top: 0;\n  }\n}\n\n.eventbrite-events-table__eb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n\n  img {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n.eventbrite-events-tab__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n\n  .eventbrite-events-tab__note {\n    flex: 1 1 320px;\n    margin: 0;\n  }\n\n  label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .styled-button {\n    width: auto;\n    padding: 0 18px;\n    white-space: nowrap;\n  }\n}\n\n.eventbrite-events-tab__note {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.6);\n}\n\n.eventbrite-events-tab__error {\n  display: block;\n  margin-top: 4px;\n  font-size: 13px;\n  color: #c0392b;\n}\n\n.eventbrite-events-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n\n  th,\n  td {\n    padding: 10px 12px;\n    text-align: left;\n    vertical-align: top;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n  }\n\n  th {\n    font-weight: 600;\n    white-space: nowrap;\n  }\n\n  select {\n    max-width: 260px;\n    height: 34px;\n  }\n\n  .styled-button {\n    width: auto;\n    padding: 0 16px;\n    white-space: nowrap;\n  }\n}\n\n.eventbrite-events-table__tags,\n.eventbrite-events-table__sub {\n  display: block;\n  margin-top: 2px;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.55);\n}\n\n.eventbrite-events-table__link {\n  display: block;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--color-button-background);\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.eventbrite-events-table__check {\n  width: 32px;\n\n  input[type='checkbox'] {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n  }\n}\n\n.eventbrite-events-table__name {\n  font-weight: 600;\n}\n\n.eventbrite-events-table__row--linked td {\n  color: rgba(0, 0, 0, 0.55);\n}\n\n.eventbrite-events-table__badge {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 1px 8px;\n  border-radius: 10px;\n  background: rgba(46, 125, 50, 0.12);\n  color: #2e7d32;\n  font-size: 12px;\n  font-weight: 600;\n  vertical-align: middle;\n}\n\n.eventbrite-events-table__linked {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n\n  & + & {\n    margin-top: 6px;\n  }\n\n  .styled-button {\n    width: auto;\n    padding: 0 14px;\n  }\n}\n\n.eventbrite-events-table__edit-row td {\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.eventbrite-quick-edit {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n\n  label {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    position: relative;\n  }\n\n  input[type='text'],\n  select {\n    height: 36px;\n    padding: 0 10px;\n    font-size: 14px;\n    font-weight: 400;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n    background: #fff;\n    box-sizing: border-box;\n    max-width: none;\n  }\n}\n\n.eventbrite-quick-edit__results {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 5;\n  margin: 4px 0 0;\n  padding: 4px 0;\n  list-style: none;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 6px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);\n\n  button {\n    display: block;\n    width: 100%;\n    padding: 6px 10px;\n    border: 0;\n    background: none;\n    font-size: 14px;\n    font-weight: 400;\n    text-align: left;\n    cursor: pointer;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.05);\n    }\n\n    span {\n      display: block;\n      font-size: 12px;\n      color: rgba(0, 0, 0, 0.55);\n    }\n  }\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.8 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n\n  // 3. Better affordance and consistent appearance for search cancel button\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n    filter: grayscale(1);\n  }\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
